var libCrypto$1 = (() => {
  var _scriptName = import.meta.url;
  return function (moduleArg = {}) {
    var moduleRtn;
    var Module = moduleArg;
    var readyPromiseResolve, readyPromiseReject;
    var readyPromise = new Promise((resolve, reject) => {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });
    var arguments_ = {};
    arguments_["foo"] = 1;
    var moduleOverrides = Object.assign({}, Module);
    var arguments_ = [];
    var thisProgram = "./this.program";

    var quit_ = (status, toThrow) => {
      throw toThrow;
    };

    var scriptDirectory = "";

    function locateFile(path) {
      if (Module["locateFile"]) {
        return Module["locateFile"](path, scriptDirectory);
      }

      return scriptDirectory + path;
    }

    var readAsync;

    {
      if (typeof document != "undefined" && document.currentScript) {
        scriptDirectory = document.currentScript.src;
      }

      if (_scriptName) {
        scriptDirectory = _scriptName;
      }

      if (scriptDirectory.startsWith("blob:")) {
        scriptDirectory = "";
      } else {
        scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
      }

      {
        readAsync = url => fetch(url, {
          credentials: "same-origin"
        }).then(response => {
          if (response.ok) {
            return response.arrayBuffer();
          }

          return Promise.reject(new Error(response.status + " : " + response.url));
        });
      }
    }

    var out = Module["print"] || console.log.bind(console);
    var err = Module["printErr"] || console.error.bind(console);
    Object.assign(Module, moduleOverrides);
    moduleOverrides = null;
    if (Module["arguments"]) arguments_ = Module["arguments"];
    if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
    var wasmBinary = Module["wasmBinary"];
    var wasmMemory;
    var ABORT = false;
    var EXITSTATUS;

    function assert(condition, text) {
      if (!condition) {
        abort(text);
      }
    }

    var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAP64, HEAPF64;

    function updateMemoryViews() {
      var b = wasmMemory.buffer;
      Module["HEAP8"] = HEAP8 = new Int8Array(b);
      Module["HEAP16"] = HEAP16 = new Int16Array(b);
      Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
      Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
      Module["HEAP32"] = HEAP32 = new Int32Array(b);
      Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
      Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
      Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
      Module["HEAP64"] = HEAP64 = new BigInt64Array(b);
      Module["HEAPU64"] = new BigUint64Array(b);
    }

    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATMAIN__ = [];
    var __ATPOSTRUN__ = [];

    function preRun() {
      if (Module["preRun"]) {
        if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];

        while (Module["preRun"].length) {
          addOnPreRun(Module["preRun"].shift());
        }
      }

      callRuntimeCallbacks(__ATPRERUN__);
    }

    function initRuntime() {
      callRuntimeCallbacks(__ATINIT__);
    }

    function preMain() {
      callRuntimeCallbacks(__ATMAIN__);
    }

    function postRun() {
      if (Module["postRun"]) {
        if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];

        while (Module["postRun"].length) {
          addOnPostRun(Module["postRun"].shift());
        }
      }

      callRuntimeCallbacks(__ATPOSTRUN__);
    }

    function addOnPreRun(cb) {
      __ATPRERUN__.unshift(cb);
    }

    function addOnPostRun(cb) {
      __ATPOSTRUN__.unshift(cb);
    }

    var runDependencies = 0;
    var dependenciesFulfilled = null;

    function addRunDependency(id) {
      runDependencies++;
      Module["monitorRunDependencies"]?.(runDependencies);
    }

    function removeRunDependency(id) {
      runDependencies--;
      Module["monitorRunDependencies"]?.(runDependencies);

      if (runDependencies == 0) {

        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled;
          dependenciesFulfilled = null;
          callback();
        }
      }
    }

    function abort(what) {
      Module["onAbort"]?.(what);
      what = "Aborted(" + what + ")";
      err(what);
      ABORT = true;
      what += ". Build with -sASSERTIONS for more info.";
      var e = new WebAssembly.RuntimeError(what);
      readyPromiseReject(e);
      throw e;
    }

    var dataURIPrefix = "data:application/octet-stream;base64,";

    var isDataURI = filename => filename.startsWith(dataURIPrefix);

    function findWasmBinary() {
      if (Module["locateFile"]) {
        var f = "libcrypto.JSPI.5497e3a.wasm";

        if (!isDataURI(f)) {
          return locateFile(f);
        }

        return f;
      }

      return new URL("libcrypto.JSPI.5497e3a.wasm", import.meta.url).href;
    }

    var wasmBinaryFile;

    function getBinarySync(file) {
      if (file == wasmBinaryFile && wasmBinary) {
        return new Uint8Array(wasmBinary);
      }

      throw "both async and sync fetching of the wasm failed";
    }

    function getBinaryPromise(binaryFile) {
      if (!wasmBinary) {
        return readAsync(binaryFile).then(response => new Uint8Array(response), () => getBinarySync(binaryFile));
      }

      return Promise.resolve().then(() => getBinarySync(binaryFile));
    }

    function instantiateArrayBuffer(binaryFile, imports, receiver) {
      return getBinaryPromise(binaryFile).then(binary => WebAssembly.instantiate(binary, imports)).then(receiver, reason => {
        err(`failed to asynchronously prepare wasm: ${reason}`);
        abort(reason);
      });
    }

    function instantiateAsync(binary, binaryFile, imports, callback) {
      if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") {
        return fetch(binaryFile, {
          credentials: "same-origin"
        }).then(response => {
          var result = WebAssembly.instantiateStreaming(response, imports);
          return result.then(callback, function (reason) {
            err(`wasm streaming compile failed: ${reason}`);
            err("falling back to ArrayBuffer instantiation");
            return instantiateArrayBuffer(binaryFile, imports, callback);
          });
        });
      }

      return instantiateArrayBuffer(binaryFile, imports, callback);
    }

    function getWasmImports() {
      Asyncify.instrumentWasmImports(wasmImports);
      return {
        env: wasmImports,
        wasi_snapshot_preview1: wasmImports
      };
    }

    function createWasm() {
      var info = getWasmImports();

      function receiveInstance(instance, module) {
        wasmExports = instance.exports;
        wasmExports = Asyncify.instrumentWasmExports(wasmExports);
        wasmMemory = wasmExports["memory"];
        updateMemoryViews();
        wasmTable = wasmExports["__indirect_function_table"];
        removeRunDependency();
        return wasmExports;
      }

      addRunDependency();

      function receiveInstantiationResult(result) {
        receiveInstance(result["instance"]);
      }

      if (Module["instantiateWasm"]) {
        try {
          return Module["instantiateWasm"](info, receiveInstance);
        } catch (e) {
          err(`Module.instantiateWasm callback failed with error: ${e}`);
          readyPromiseReject(e);
        }
      }

      if (!wasmBinaryFile) wasmBinaryFile = findWasmBinary();
      instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
      return {};
    }

    function ExitStatus(status) {
      this.name = "ExitStatus";
      this.message = `Program terminated with exit(${status})`;
      this.status = status;
    }

    var callRuntimeCallbacks = callbacks => {
      while (callbacks.length > 0) {
        callbacks.shift()(Module);
      }
    };

    function getValue(ptr, type = "i8") {
      if (type.endsWith("*")) type = "*";

      switch (type) {
        case "i1":
          return HEAP8[ptr];

        case "i8":
          return HEAP8[ptr];

        case "i16":
          return HEAP16[ptr >> 1];

        case "i32":
          return HEAP32[ptr >> 2];

        case "i64":
          return HEAP64[ptr >> 3];

        case "float":
          return HEAPF32[ptr >> 2];

        case "double":
          return HEAPF64[ptr >> 3];

        case "*":
          return HEAPU32[ptr >> 2];

        default:
          abort(`invalid type for getValue: ${type}`);
      }
    }

    var noExitRuntime = Module["noExitRuntime"] || true;

    function setValue(ptr, value, type = "i8") {
      if (type.endsWith("*")) type = "*";

      switch (type) {
        case "i1":
          HEAP8[ptr] = value;
          break;

        case "i8":
          HEAP8[ptr] = value;
          break;

        case "i16":
          HEAP16[ptr >> 1] = value;
          break;

        case "i32":
          HEAP32[ptr >> 2] = value;
          break;

        case "i64":
          HEAP64[ptr >> 3] = BigInt(value);
          break;

        case "float":
          HEAPF32[ptr >> 2] = value;
          break;

        case "double":
          HEAPF64[ptr >> 3] = value;
          break;

        case "*":
          HEAPU32[ptr >> 2] = value;
          break;

        default:
          abort(`invalid type for setValue: ${type}`);
      }
    }

    var stackRestore = val => __emscripten_stack_restore(val);

    var stackSave = () => _emscripten_stack_get_current();

    var inetNtop4 = addr => (addr & 255) + "." + (addr >> 8 & 255) + "." + (addr >> 16 & 255) + "." + (addr >> 24 & 255);

    var inetNtop6 = ints => {
      var str = "";
      var word = 0;
      var longest = 0;
      var lastzero = 0;
      var zstart = 0;
      var len = 0;
      var i = 0;
      var parts = [ints[0] & 65535, ints[0] >> 16, ints[1] & 65535, ints[1] >> 16, ints[2] & 65535, ints[2] >> 16, ints[3] & 65535, ints[3] >> 16];
      var hasipv4 = true;
      var v4part = "";

      for (i = 0; i < 5; i++) {
        if (parts[i] !== 0) {
          hasipv4 = false;
          break;
        }
      }

      if (hasipv4) {
        v4part = inetNtop4(parts[6] | parts[7] << 16);

        if (parts[5] === -1) {
          str = "::ffff:";
          str += v4part;
          return str;
        }

        if (parts[5] === 0) {
          str = "::";
          if (v4part === "0.0.0.0") v4part = "";
          if (v4part === "0.0.0.1") v4part = "1";
          str += v4part;
          return str;
        }
      }

      for (word = 0; word < 8; word++) {
        if (parts[word] === 0) {
          if (word - lastzero > 1) {
            len = 0;
          }

          lastzero = word;
          len++;
        }

        if (len > longest) {
          longest = len;
          zstart = word - longest + 1;
        }
      }

      for (word = 0; word < 8; word++) {
        if (longest > 1) {
          if (parts[word] === 0 && word >= zstart && word < zstart + longest) {
            if (word === zstart) {
              str += ":";
              if (zstart === 0) str += ":";
            }

            continue;
          }
        }

        str += Number(_ntohs(parts[word] & 65535)).toString(16);
        str += word < 7 ? ":" : "";
      }

      return str;
    };

    var readSockaddr = (sa, salen) => {
      var family = HEAP16[sa >> 1];

      var port = _ntohs(HEAPU16[sa + 2 >> 1]);

      var addr;

      switch (family) {
        case 2:
          if (salen !== 16) {
            return {
              errno: 28
            };
          }

          addr = HEAP32[sa + 4 >> 2];
          addr = inetNtop4(addr);
          break;

        case 10:
          if (salen !== 28) {
            return {
              errno: 28
            };
          }

          addr = [HEAP32[sa + 8 >> 2], HEAP32[sa + 12 >> 2], HEAP32[sa + 16 >> 2], HEAP32[sa + 20 >> 2]];
          addr = inetNtop6(addr);
          break;

        default:
          return {
            errno: 5
          };
      }

      return {
        family,
        addr,
        port
      };
    };

    var inetPton4 = str => {
      var b = str.split(".");

      for (var i = 0; i < 4; i++) {
        var tmp = Number(b[i]);
        if (isNaN(tmp)) return null;
        b[i] = tmp;
      }

      return (b[0] | b[1] << 8 | b[2] << 16 | b[3] << 24) >>> 0;
    };

    var jstoi_q = str => parseInt(str);

    var inetPton6 = str => {
      var words;
      var w, offset, z;
      var valid6regx = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i;
      var parts = [];

      if (!valid6regx.test(str)) {
        return null;
      }

      if (str === "::") {
        return [0, 0, 0, 0, 0, 0, 0, 0];
      }

      if (str.startsWith("::")) {
        str = str.replace("::", "Z:");
      } else {
        str = str.replace("::", ":Z:");
      }

      if (str.indexOf(".") > 0) {
        str = str.replace(new RegExp("[.]", "g"), ":");
        words = str.split(":");
        words[words.length - 4] = jstoi_q(words[words.length - 4]) + jstoi_q(words[words.length - 3]) * 256;
        words[words.length - 3] = jstoi_q(words[words.length - 2]) + jstoi_q(words[words.length - 1]) * 256;
        words = words.slice(0, words.length - 2);
      } else {
        words = str.split(":");
      }

      offset = 0;
      z = 0;

      for (w = 0; w < words.length; w++) {
        if (typeof words[w] == "string") {
          if (words[w] === "Z") {
            for (z = 0; z < 8 - words.length + 1; z++) {
              parts[w + z] = 0;
            }

            offset = z - 1;
          } else {
            parts[w + offset] = _htons(parseInt(words[w], 16));
          }
        } else {
          parts[w + offset] = words[w];
        }
      }

      return [parts[1] << 16 | parts[0], parts[3] << 16 | parts[2], parts[5] << 16 | parts[4], parts[7] << 16 | parts[6]];
    };

    var DNS = {
      address_map: {
        id: 1,
        addrs: {},
        names: {}
      },

      lookup_name(name) {
        var res = inetPton4(name);

        if (res !== null) {
          return name;
        }

        res = inetPton6(name);

        if (res !== null) {
          return name;
        }

        var addr;

        if (DNS.address_map.addrs[name]) {
          addr = DNS.address_map.addrs[name];
        } else {
          var id = DNS.address_map.id++;
          assert(id < 65535, "exceeded max address mappings of 65535");
          addr = "172.29." + (id & 255) + "." + (id & 65280);
          DNS.address_map.names[addr] = name;
          DNS.address_map.addrs[name] = addr;
        }

        return addr;
      },

      lookup_addr(addr) {
        if (DNS.address_map.names[addr]) {
          return DNS.address_map.names[addr];
        }

        return null;
      }

    };

    function ___syscall_connect() {
      return 0;
    }

    var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
      if (!(maxBytesToWrite > 0)) return 0;
      var startIdx = outIdx;
      var endIdx = outIdx + maxBytesToWrite - 1;

      for (var i = 0; i < str.length; ++i) {
        var u = str.charCodeAt(i);

        if (u >= 55296 && u <= 57343) {
          var u1 = str.charCodeAt(++i);
          u = 65536 + ((u & 1023) << 10) | u1 & 1023;
        }

        if (u <= 127) {
          if (outIdx >= endIdx) break;
          heap[outIdx++] = u;
        } else if (u <= 2047) {
          if (outIdx + 1 >= endIdx) break;
          heap[outIdx++] = 192 | u >> 6;
          heap[outIdx++] = 128 | u & 63;
        } else if (u <= 65535) {
          if (outIdx + 2 >= endIdx) break;
          heap[outIdx++] = 224 | u >> 12;
          heap[outIdx++] = 128 | u >> 6 & 63;
          heap[outIdx++] = 128 | u & 63;
        } else {
          if (outIdx + 3 >= endIdx) break;
          heap[outIdx++] = 240 | u >> 18;
          heap[outIdx++] = 128 | u >> 12 & 63;
          heap[outIdx++] = 128 | u >> 6 & 63;
          heap[outIdx++] = 128 | u & 63;
        }
      }

      heap[outIdx] = 0;
      return outIdx - startIdx;
    };

    var stringToUTF8 = (str, outPtr, maxBytesToWrite) => stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);

    var ___syscall_getdents64 = (fd, dirp, count) => {};

    function ___syscall_getsockopt(fd, level, optname, optval, optlen, d1) {
      return -50;
    }

    var ___syscall_socket = (domain, type, protocol) => {};

    var _emscripten_get_now;

    _emscripten_get_now = () => performance.now();

    var checkWasiClock = clock_id => clock_id == 0 || clock_id == 1 || clock_id == 2 || clock_id == 3;

    function _clock_time_get(clk_id, ignored_precision, ptime) {

      if (!checkWasiClock(clk_id)) {
        return 28;
      }

      var now;

      if (clk_id === 0) {
        now = Date.now();
      } else {
        now = _emscripten_get_now();
      }

      var nsec = Math.round(now * 1e3 * 1e3);
      HEAP32[ptime >> 2] = nsec >>> 0;
      HEAP32[ptime + 4 >> 2] = nsec / Math.pow(2, 32) >>> 0;
      return 0;
    }

    var _emscripten_notify_memory_growth = memoryIndex => {
      updateMemoryViews();
    };

    var handleException = e => {
      if (e instanceof ExitStatus || e == "unwind") {
        return EXITSTATUS;
      }

      quit_(1, e);
    };

    var runtimeKeepaliveCounter = 0;

    var keepRuntimeAlive = () => noExitRuntime || runtimeKeepaliveCounter > 0;

    var _proc_exit = code => {
      EXITSTATUS = code;

      if (!keepRuntimeAlive()) {
        Module["onExit"]?.(code);
        ABORT = true;
      }

      quit_(code, new ExitStatus(code));
    };

    var exitJS = (status, implicit) => {
      EXITSTATUS = status;

      _proc_exit(status);
    };

    var _exit = exitJS;

    var maybeExit = () => {
      if (!keepRuntimeAlive()) {
        try {
          _exit(EXITSTATUS);
        } catch (e) {
          handleException(e);
        }
      }
    };

    var callUserCallback = func => {
      if (ABORT) {
        return;
      }

      try {
        func();
        maybeExit();
      } catch (e) {
        handleException(e);
      }
    };

    var safeSetTimeout = (func, timeout) => setTimeout(() => {
      callUserCallback(func);
    }, timeout);

    var _emscripten_sleep = ms => Asyncify.handleSleep(wakeUp => safeSetTimeout(wakeUp, ms));

    _emscripten_sleep.isAsync = true;
    var ENV = {};

    var getExecutableName = () => thisProgram || "./this.program";

    var getEnvStrings = () => {
      if (!getEnvStrings.strings) {
        var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
        var env = {
          USER: "web_user",
          LOGNAME: "web_user",
          PATH: "/",
          PWD: "/",
          HOME: "/home/web_user",
          LANG: lang,
          _: getExecutableName()
        };

        for (var x in ENV) {
          if (ENV[x] === undefined) delete env[x];else env[x] = ENV[x];
        }

        var strings = [];

        for (var x in env) {
          strings.push(`${x}=${env[x]}`);
        }

        getEnvStrings.strings = strings;
      }

      return getEnvStrings.strings;
    };

    var stringToAscii = (str, buffer) => {
      for (var i = 0; i < str.length; ++i) {
        HEAP8[buffer++] = str.charCodeAt(i);
      }

      HEAP8[buffer] = 0;
    };

    var _environ_get = (__environ, environ_buf) => {
      var bufSize = 0;
      getEnvStrings().forEach((string, i) => {
        var ptr = environ_buf + bufSize;
        HEAPU32[__environ + i * 4 >> 2] = ptr;
        stringToAscii(string, ptr);
        bufSize += string.length + 1;
      });
      return 0;
    };

    var _environ_sizes_get = (penviron_count, penviron_buf_size) => {
      var strings = getEnvStrings();
      HEAPU32[penviron_count >> 2] = strings.length;
      var bufSize = 0;
      strings.forEach(string => bufSize += string.length + 1);
      HEAPU32[penviron_buf_size >> 2] = bufSize;
      return 0;
    };

    var _fd_close = fd => 52;

    async function _fd_read(fd, iov, iovcnt, pnum) {
      console.log("fd_read: entered");

      if (fd < 10) {
        var stream = SYSCALLS.getStreamFromFD(fd);
        var num = SYSCALLS.doReadv(stream, iov, iovcnt);
        HEAP32[pnum >> 2] = num;
        return 0;
      } else {
        const wasmFD = _zitiContext._wasmFDsById.get(fd);

        if (wasmFD === null) throw new Error("cannot find wasmFD");
        wasmFD.socket.fd_read();
        HEAP32[pnum >> 2] = 0;
        return 0;
      }
    }

    _fd_read.isAsync = true;

    function _fd_seek(fd, offset, whence, newOffset) {
      return 70;
    }

    var printCharBuffers = [null, [], []];
    var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder() : undefined;

    var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead) => {
      var endIdx = idx + maxBytesToRead;
      var endPtr = idx;

      while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr;

      if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
        return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
      }

      var str = "";

      while (idx < endPtr) {
        var u0 = heapOrArray[idx++];

        if (!(u0 & 128)) {
          str += String.fromCharCode(u0);
          continue;
        }

        var u1 = heapOrArray[idx++] & 63;

        if ((u0 & 224) == 192) {
          str += String.fromCharCode((u0 & 31) << 6 | u1);
          continue;
        }

        var u2 = heapOrArray[idx++] & 63;

        if ((u0 & 240) == 224) {
          u0 = (u0 & 15) << 12 | u1 << 6 | u2;
        } else {
          u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
        }

        if (u0 < 65536) {
          str += String.fromCharCode(u0);
        } else {
          var ch = u0 - 65536;
          str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
        }
      }

      return str;
    };

    var printChar = (stream, curr) => {
      var buffer = printCharBuffers[stream];

      if (curr === 0 || curr === 10) {
        (stream === 1 ? out : err)(UTF8ArrayToString(buffer, 0));
        buffer.length = 0;
      } else {
        buffer.push(curr);
      }
    };

    var UTF8ToString = (ptr, maxBytesToRead) => ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";

    var SYSCALLS = {
      varargs: undefined,

      getStr(ptr) {
        var ret = UTF8ToString(ptr);
        return ret;
      }

    };

    function _fd_write(fd, iov, iovcnt, pnum) {
      if (fd < 10) {
        var num = 0;

        for (var i = 0; i < iovcnt; i++) {
          var ptr = HEAP32[iov >> 2];
          var len = HEAP32[iov + 4 >> 2];
          iov += 8;

          for (var j = 0; j < len; j++) {
            printChar(fd, HEAPU8[ptr + j]);
          }

          num += len;
        }

        HEAP32[pnum >> 2] = num;
        return 0;
      } else {
        const wasmFD = _zitiContext._wasmFDsById.get(fd);

        if (wasmFD === null) throw new Error("cannot find wasmFD");
        var num = 0;

        for (var i = 0; i < iovcnt; i++) {
          var ptr = HEAP32[iov >> 2];
          var len = HEAP32[iov + 4 >> 2];
          iov += 8;
          var array = new Uint8Array(Module.HEAPU8.buffer, ptr, len);
          wasmFD.socket.fd_write(array);
          num += len;
        }

        HEAP32[pnum >> 2] = num;
        return 0;
      }
    }

    var zeroMemory = (address, size) => {
      HEAPU8.fill(0, address, address + size);
      return address;
    };

    var writeSockaddr = (sa, family, addr, port, addrlen) => {
      switch (family) {
        case 2:
          addr = inetPton4(addr);
          zeroMemory(sa, 16);

          if (addrlen) {
            HEAP32[addrlen >> 2] = 16;
          }

          HEAP16[sa >> 1] = family;
          HEAP32[sa + 4 >> 2] = addr;
          HEAP16[sa + 2 >> 1] = _htons(port);
          break;

        case 10:
          addr = inetPton6(addr);
          zeroMemory(sa, 28);

          if (addrlen) {
            HEAP32[addrlen >> 2] = 28;
          }

          HEAP32[sa >> 2] = family;
          HEAP32[sa + 8 >> 2] = addr[0];
          HEAP32[sa + 12 >> 2] = addr[1];
          HEAP32[sa + 16 >> 2] = addr[2];
          HEAP32[sa + 20 >> 2] = addr[3];
          HEAP16[sa + 2 >> 1] = _htons(port);
          break;

        default:
          return 5;
      }

      return 0;
    };

    var _getaddrinfo = (node, service, hint, out) => {
      var addr = 0;
      var port = 0;
      var flags = 0;
      var family = 0;
      var type = 0;
      var proto = 0;
      var ai;

      function allocaddrinfo(family, type, proto, canon, addr, port) {
        var sa, salen, ai;
        var errno;
        salen = family === 10 ? 28 : 16;
        addr = family === 10 ? inetNtop6(addr) : inetNtop4(addr);
        sa = _malloc(salen);
        errno = writeSockaddr(sa, family, addr, port);
        assert(!errno);
        ai = _malloc(32);
        HEAP32[ai + 4 >> 2] = family;
        HEAP32[ai + 8 >> 2] = type;
        HEAP32[ai + 12 >> 2] = proto;
        HEAPU32[ai + 24 >> 2] = canon;
        HEAPU32[ai + 20 >> 2] = sa;

        if (family === 10) {
          HEAP32[ai + 16 >> 2] = 28;
        } else {
          HEAP32[ai + 16 >> 2] = 16;
        }

        HEAP32[ai + 28 >> 2] = 0;
        return ai;
      }

      if (hint) {
        flags = HEAP32[hint >> 2];
        family = HEAP32[hint + 4 >> 2];
        type = HEAP32[hint + 8 >> 2];
        proto = HEAP32[hint + 12 >> 2];
      }

      if (type && !proto) {
        proto = type === 2 ? 17 : 6;
      }

      if (!type && proto) {
        type = proto === 17 ? 2 : 1;
      }

      if (proto === 0) {
        proto = 6;
      }

      if (type === 0) {
        type = 1;
      }

      if (!node && !service) {
        return -2;
      }

      if (flags & ~(1 | 2 | 4 | 1024 | 8 | 16 | 32)) {
        return -1;
      }

      if (hint !== 0 && HEAP32[hint >> 2] & 2 && !node) {
        return -1;
      }

      if (flags & 32) {
        return -2;
      }

      if (type !== 0 && type !== 1 && type !== 2) {
        return -7;
      }

      if (family !== 0 && family !== 2 && family !== 10) {
        return -6;
      }

      if (service) {
        service = UTF8ToString(service);
        port = parseInt(service, 10);

        if (isNaN(port)) {
          if (flags & 1024) {
            return -2;
          }

          return -8;
        }
      }

      if (!node) {
        if (family === 0) {
          family = 2;
        }

        if ((flags & 1) === 0) {
          if (family === 2) {
            addr = _htonl(2130706433);
          } else {
            addr = [0, 0, 0, 1];
          }
        }

        ai = allocaddrinfo(family, type, proto, null, addr, port);
        HEAPU32[out >> 2] = ai;
        return 0;
      }

      node = UTF8ToString(node);
      addr = inetPton4(node);

      if (addr !== null) {
        if (family === 0 || family === 2) {
          family = 2;
        } else if (family === 10 && flags & 8) {
          addr = [0, 0, _htonl(65535), addr];
          family = 10;
        } else {
          return -2;
        }
      } else {
        addr = inetPton6(node);

        if (addr !== null) {
          if (family === 0 || family === 10) {
            family = 10;
          } else {
            return -2;
          }
        }
      }

      if (addr != null) {
        ai = allocaddrinfo(family, type, proto, node, addr, port);
        HEAPU32[out >> 2] = ai;
        return 0;
      }

      if (flags & 4) {
        return -2;
      }

      node = DNS.lookup_name(node);
      addr = inetPton4(node);

      if (family === 0) {
        family = 2;
      } else if (family === 10) {
        addr = [0, 0, _htonl(65535), addr];
      }

      ai = allocaddrinfo(family, type, proto, null, addr, port);
      HEAPU32[out >> 2] = ai;
      return 0;
    };

    var _getnameinfo = (sa, salen, node, nodelen, serv, servlen, flags) => {
      var info = readSockaddr(sa, salen);

      if (info.errno) {
        return -6;
      }

      var port = info.port;
      var addr = info.addr;
      var overflowed = false;

      if (node && nodelen) {
        var lookup;

        if (flags & 1 || !(lookup = DNS.lookup_addr(addr))) {
          if (flags & 8) {
            return -2;
          }
        } else {
          addr = lookup;
        }

        var numBytesWrittenExclNull = stringToUTF8(addr, node, nodelen);

        if (numBytesWrittenExclNull + 1 >= nodelen) {
          overflowed = true;
        }
      }

      if (serv && servlen) {
        port = "" + port;
        var numBytesWrittenExclNull = stringToUTF8(port, serv, servlen);

        if (numBytesWrittenExclNull + 1 >= servlen) {
          overflowed = true;
        }
      }

      if (overflowed) {
        return -12;
      }

      return 0;
    };

    function _ziti_getentropy(buf, buflen) {
      let array = new Uint8Array(Module.HEAPU8.buffer, buf, buflen);
      crypto.getRandomValues(array);
    }

    var sigToWasmTypes = sig => {
      var typeNames = {
        i: "i32",
        j: "i64",
        f: "f32",
        d: "f64",
        e: "externref",
        p: "i32"
      };
      var type = {
        parameters: [],
        results: sig[0] == "v" ? [] : [typeNames[sig[0]]]
      };

      for (var i = 1; i < sig.length; ++i) {
        type.parameters.push(typeNames[sig[i]]);
      }

      return type;
    };

    var Asyncify = {
      instrumentWasmImports(imports) {
        var importPattern = /^(invoke_.*|__asyncjs__.*)$/;

        for (let [x, original] of Object.entries(imports)) {
          if (typeof original == "function") {
            let isAsyncifyImport = original.isAsync || importPattern.test(x);

            if (isAsyncifyImport) {
              imports[x] = original = new WebAssembly.Suspending(original);
            }
          }
        }
      },

      instrumentWasmExports(exports) {
        var exportPattern = /^(ssl_do_handshake|tls_read|main|__main_argc_argv)$/;
        Asyncify.asyncExports = new Set();
        var ret = {};

        for (let [x, original] of Object.entries(exports)) {
          if (typeof original == "function") {
            let isAsyncifyExport = exportPattern.test(x);

            if (isAsyncifyExport) {
              Asyncify.asyncExports.add(original);
              original = Asyncify.makeAsyncFunction(original);
            }

            ret[x] = (...args) => original(...args);
          } else {
            ret[x] = original;
          }
        }

        return ret;
      },

      asyncExports: null,

      isAsyncExport(func) {
        return Asyncify.asyncExports?.has(func);
      },

      handleAsync: async startAsync => {
        try {
          return await startAsync();
        } finally {}
      },

      handleSleep(startAsync) {
        return Asyncify.handleAsync(() => new Promise(startAsync));
      },

      makeAsyncFunction(original) {
        return WebAssembly.promising(original);
      }

    };

    var getCFunc = ident => {
      var func = Module["_" + ident];
      return func;
    };

    var writeArrayToMemory = (array, buffer) => {
      HEAP8.set(array, buffer);
    };

    var lengthBytesUTF8 = str => {
      var len = 0;

      for (var i = 0; i < str.length; ++i) {
        var c = str.charCodeAt(i);

        if (c <= 127) {
          len++;
        } else if (c <= 2047) {
          len += 2;
        } else if (c >= 55296 && c <= 57343) {
          len += 4;
          ++i;
        } else {
          len += 3;
        }
      }

      return len;
    };

    var stackAlloc = sz => __emscripten_stack_alloc(sz);

    var stringToUTF8OnStack = str => {
      var size = lengthBytesUTF8(str) + 1;
      var ret = stackAlloc(size);
      stringToUTF8(str, ret, size);
      return ret;
    };

    var ccall = (ident, returnType, argTypes, args, opts) => {
      var toC = {
        string: str => {
          var ret = 0;

          if (str !== null && str !== undefined && str !== 0) {
            ret = stringToUTF8OnStack(str);
          }

          return ret;
        },
        array: arr => {
          var ret = stackAlloc(arr.length);
          writeArrayToMemory(arr, ret);
          return ret;
        }
      };

      function convertReturnValue(ret) {
        if (returnType === "string") {
          return UTF8ToString(ret);
        }

        if (returnType === "boolean") return Boolean(ret);
        return ret;
      }

      var func = getCFunc(ident);
      var cArgs = [];
      var stack = 0;

      if (args) {
        for (var i = 0; i < args.length; i++) {
          var converter = toC[argTypes[i]];

          if (converter) {
            if (stack === 0) stack = stackSave();
            cArgs[i] = converter(args[i]);
          } else {
            cArgs[i] = args[i];
          }
        }
      }

      var ret = func(...cArgs);

      function onDone(ret) {
        if (stack !== 0) stackRestore(stack);
        return convertReturnValue(ret);
      }

      var asyncMode = opts?.async;
      if (asyncMode) return ret.then(onDone);
      ret = onDone(ret);
      return ret;
    };

    var cwrap = (ident, returnType, argTypes, opts) => {
      var numericArgs = !argTypes || argTypes.every(type => type === "number" || type === "boolean");
      var numericRet = returnType !== "string";

      if (numericRet && numericArgs && !opts) {
        return getCFunc(ident);
      }

      return (...args) => ccall(ident, returnType, argTypes, args, opts);
    };

    var uleb128Encode = (n, target) => {
      if (n < 128) {
        target.push(n);
      } else {
        target.push(n % 128 | 128, n >> 7);
      }
    };

    var generateFuncType = (sig, target) => {
      var sigRet = sig.slice(0, 1);
      var sigParam = sig.slice(1);
      var typeCodes = {
        i: 127,
        p: 127,
        j: 126,
        f: 125,
        d: 124,
        e: 111
      };
      target.push(96);
      uleb128Encode(sigParam.length, target);

      for (var i = 0; i < sigParam.length; ++i) {
        target.push(typeCodes[sigParam[i]]);
      }

      if (sigRet == "v") {
        target.push(0);
      } else {
        target.push(1, typeCodes[sigRet]);
      }
    };

    var convertJsFunctionToWasm = (func, sig) => {
      if (typeof WebAssembly.Function == "function") {
        return new WebAssembly.Function(sigToWasmTypes(sig), func);
      }

      var typeSectionBody = [1];
      generateFuncType(sig, typeSectionBody);
      var bytes = [0, 97, 115, 109, 1, 0, 0, 0, 1];
      uleb128Encode(typeSectionBody.length, bytes);
      bytes.push(...typeSectionBody);
      bytes.push(2, 7, 1, 1, 101, 1, 102, 0, 0, 7, 5, 1, 1, 102, 0, 0);
      var module = new WebAssembly.Module(new Uint8Array(bytes));
      var instance = new WebAssembly.Instance(module, {
        e: {
          f: func
        }
      });
      var wrappedFunc = instance.exports["f"];
      return wrappedFunc;
    };

    var wasmTableMirror = [];
    var wasmTable;

    var getWasmTableEntry = funcPtr => {
      var func = wasmTableMirror[funcPtr];

      if (!func) {
        if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
        wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);

        if (Asyncify.isAsyncExport(func)) {
          wasmTableMirror[funcPtr] = func = Asyncify.makeAsyncFunction(func);
        }
      }

      return func;
    };

    var updateTableMap = (offset, count) => {
      if (functionsInTableMap) {
        for (var i = offset; i < offset + count; i++) {
          var item = getWasmTableEntry(i);

          if (item) {
            functionsInTableMap.set(item, i);
          }
        }
      }
    };

    var functionsInTableMap;

    var getFunctionAddress = func => {
      if (!functionsInTableMap) {
        functionsInTableMap = new WeakMap();
        updateTableMap(0, wasmTable.length);
      }

      return functionsInTableMap.get(func) || 0;
    };

    var freeTableIndexes = [];

    var getEmptyTableSlot = () => {
      if (freeTableIndexes.length) {
        return freeTableIndexes.pop();
      }

      try {
        wasmTable.grow(1);
      } catch (err) {
        if (!(err instanceof RangeError)) {
          throw err;
        }

        throw "Unable to grow wasm table. Set ALLOW_TABLE_GROWTH.";
      }

      return wasmTable.length - 1;
    };

    var setWasmTableEntry = (idx, func) => {
      wasmTable.set(idx, func);
      wasmTableMirror[idx] = wasmTable.get(idx);
    };

    var addFunction = (func, sig) => {
      var rtn = getFunctionAddress(func);

      if (rtn) {
        return rtn;
      }

      var ret = getEmptyTableSlot();

      try {
        setWasmTableEntry(ret, func);
      } catch (err) {
        if (!(err instanceof TypeError)) {
          throw err;
        }

        var wrapped = convertJsFunctionToWasm(func, sig);
        setWasmTableEntry(ret, wrapped);
      }

      functionsInTableMap.set(func, ret);
      return ret;
    };

    var wasmImports = {
      __syscall_connect: ___syscall_connect,
      __syscall_getdents64: ___syscall_getdents64,
      __syscall_getsockopt: ___syscall_getsockopt,
      __syscall_socket: ___syscall_socket,
      clock_time_get: _clock_time_get,
      emscripten_notify_memory_growth: _emscripten_notify_memory_growth,
      emscripten_sleep: _emscripten_sleep,
      environ_get: _environ_get,
      environ_sizes_get: _environ_sizes_get,
      fd_close: _fd_close,
      fd_read: _fd_read,
      fd_seek: _fd_seek,
      fd_write: _fd_write,
      getaddrinfo: _getaddrinfo,
      getnameinfo: _getnameinfo,
      ziti_getentropy: _ziti_getentropy
    };
    var wasmExports = createWasm();

    var _malloc = Module["_malloc"] = a0 => (_malloc = Module["_malloc"] = wasmExports["malloc"])(a0);

    Module["_createCertificateSigningRequest"] = (a0, a1, a2, a3, a4, a5, a6, a7) => (Module["_createCertificateSigningRequest"] = wasmExports["createCertificateSigningRequest"])(a0, a1, a2, a3, a4, a5, a6, a7);

    Module["_generateKey"] = a0 => (Module["_generateKey"] = wasmExports["generateKey"])(a0);

    Module["_EVP_PKEY_CTX_new_id"] = (a0, a1) => (Module["_EVP_PKEY_CTX_new_id"] = wasmExports["EVP_PKEY_CTX_new_id"])(a0, a1);

    Module["_EVP_PKEY_keygen_init"] = a0 => (Module["_EVP_PKEY_keygen_init"] = wasmExports["EVP_PKEY_keygen_init"])(a0);

    Module["_EVP_PKEY_keygen"] = (a0, a1) => (Module["_EVP_PKEY_keygen"] = wasmExports["EVP_PKEY_keygen"])(a0, a1);

    Module["_generateECKey"] = () => (Module["_generateECKey"] = wasmExports["generateECKey"])();

    Module["_EVP_PKEY_new"] = () => (Module["_EVP_PKEY_new"] = wasmExports["EVP_PKEY_new"])();

    Module["_getPrivateKeyPEM"] = a0 => (Module["_getPrivateKeyPEM"] = wasmExports["getPrivateKeyPEM"])(a0);

    Module["_getPublicKeyPEM"] = a0 => (Module["_getPublicKeyPEM"] = wasmExports["getPublicKeyPEM"])(a0);

    Module["_cleanup"] = () => (Module["_cleanup"] = wasmExports["cleanup"])();

    Module["_fd_kv_alloc"] = () => (Module["_fd_kv_alloc"] = wasmExports["fd_kv_alloc"])();

    Module["_fd_kv_getItem"] = a0 => (Module["_fd_kv_getItem"] = wasmExports["fd_kv_getItem"])(a0);

    Module["_fd_kv_delItem"] = a0 => (Module["_fd_kv_delItem"] = wasmExports["fd_kv_delItem"])(a0);

    Module["_fd_kv_addItem"] = (a0, a1) => (Module["_fd_kv_addItem"] = wasmExports["fd_kv_addItem"])(a0, a1);

    Module["_constructTLSDataQueue"] = (a0, a1) => (Module["_constructTLSDataQueue"] = wasmExports["constructTLSDataQueue"])(a0, a1);

    Module["_destructTLSDataQueue"] = a0 => (Module["_destructTLSDataQueue"] = wasmExports["destructTLSDataQueue"])(a0);

    Module["_isEmptyTLSData"] = a0 => (Module["_isEmptyTLSData"] = wasmExports["isEmptyTLSData"])(a0);

    Module["_dequeueTLSData"] = a0 => (Module["_dequeueTLSData"] = wasmExports["dequeueTLSData"])(a0);

    Module["_allocateTLSDataBuf"] = a0 => (Module["_allocateTLSDataBuf"] = wasmExports["allocateTLSDataBuf"])(a0);

    Module["_freeTLSDataBuf"] = a0 => (Module["_freeTLSDataBuf"] = wasmExports["freeTLSDataBuf"])(a0);

    Module["_enqueueTLSData"] = (a0, a1, a2) => (Module["_enqueueTLSData"] = wasmExports["enqueueTLSData"])(a0, a1, a2);

    Module["_peekTLSData"] = a0 => (Module["_peekTLSData"] = wasmExports["peekTLSData"])(a0);

    Module["_ssl_CTX_new"] = () => (Module["_ssl_CTX_new"] = wasmExports["ssl_CTX_new"])();

    Module["_ssl_CTX_add_private_key"] = (a0, a1) => (Module["_ssl_CTX_add_private_key"] = wasmExports["ssl_CTX_add_private_key"])(a0, a1);

    Module["_ssl_CTX_add_certificate"] = (a0, a1) => (Module["_ssl_CTX_add_certificate"] = wasmExports["ssl_CTX_add_certificate"])(a0, a1);

    Module["_ssl_CTX_add_extra_chain_cert"] = (a0, a1) => (Module["_ssl_CTX_add_extra_chain_cert"] = wasmExports["ssl_CTX_add_extra_chain_cert"])(a0, a1);

    Module["_ssl_CTX_add1_to_CA_list"] = (a0, a1) => (Module["_ssl_CTX_add1_to_CA_list"] = wasmExports["ssl_CTX_add1_to_CA_list"])(a0, a1);

    Module["_ssl_CTX_verify_certificate_and_key"] = a0 => (Module["_ssl_CTX_verify_certificate_and_key"] = wasmExports["ssl_CTX_verify_certificate_and_key"])(a0);

    Module["_ssl_new"] = a0 => (Module["_ssl_new"] = wasmExports["ssl_new"])(a0);

    Module["_bio_new_ssl_connect"] = a0 => (Module["_bio_new_ssl_connect"] = wasmExports["bio_new_ssl_connect"])(a0);

    Module["_bio_get_ssl"] = a0 => (Module["_bio_get_ssl"] = wasmExports["bio_get_ssl"])(a0);

    Module["_bio_set_conn_hostname"] = (a0, a1) => (Module["_bio_set_conn_hostname"] = wasmExports["bio_set_conn_hostname"])(a0, a1);

    Module["_bio_do_connect"] = a0 => (Module["_bio_do_connect"] = wasmExports["bio_do_connect"])(a0);

    Module["_ssl_do_handshake"] = a0 => (Module["_ssl_do_handshake"] = wasmExports["ssl_do_handshake"])(a0);

    Module["_ssl_get_verify_result"] = a0 => (Module["_ssl_get_verify_result"] = wasmExports["ssl_get_verify_result"])(a0);

    Module["_tls_write"] = (a0, a1, a2) => (Module["_tls_write"] = wasmExports["tls_write"])(a0, a1, a2);

    Module["_SSL_get_fd"] = a0 => (Module["_SSL_get_fd"] = wasmExports["SSL_get_fd"])(a0);

    Module["_tls_read"] = (a0, a1, a2) => (Module["_tls_read"] = wasmExports["tls_read"])(a0, a1, a2);

    Module["_ssl_set_fd"] = (a0, a1) => (Module["_ssl_set_fd"] = wasmExports["ssl_set_fd"])(a0, a1);

    Module["_ssl_connect"] = a0 => (Module["_ssl_connect"] = wasmExports["ssl_connect"])(a0);

    Module["_createBuffer"] = a0 => (Module["_createBuffer"] = wasmExports["createBuffer"])(a0);

    Module["_destroyBuffer"] = a0 => (Module["_destroyBuffer"] = wasmExports["destroyBuffer"])(a0);

    var _ntohs = a0 => (_ntohs = wasmExports["ntohs"])(a0);

    Module["_BIO_new_fp"] = (a0, a1) => (Module["_BIO_new_fp"] = wasmExports["BIO_new_fp"])(a0, a1);

    Module["_DSA_free"] = a0 => (Module["_DSA_free"] = wasmExports["DSA_free"])(a0);

    Module["_EVP_PKEY_CTX_free"] = a0 => (Module["_EVP_PKEY_CTX_free"] = wasmExports["EVP_PKEY_CTX_free"])(a0);

    Module["_EVP_PKEY_free"] = a0 => (Module["_EVP_PKEY_free"] = wasmExports["EVP_PKEY_free"])(a0);

    Module["_EVP_PKEY_get1_DSA"] = a0 => (Module["_EVP_PKEY_get1_DSA"] = wasmExports["EVP_PKEY_get1_DSA"])(a0);

    Module["_EVP_PKEY_paramgen_init"] = a0 => (Module["_EVP_PKEY_paramgen_init"] = wasmExports["EVP_PKEY_paramgen_init"])(a0);

    Module["_EVP_PKEY_paramgen"] = (a0, a1) => (Module["_EVP_PKEY_paramgen"] = wasmExports["EVP_PKEY_paramgen"])(a0, a1);

    Module["_OPENSSL_init"] = () => (Module["_OPENSSL_init"] = wasmExports["OPENSSL_init"])();

    Module["_PEM_write_bio_DSAPrivateKey"] = (a0, a1, a2, a3, a4, a5, a6) => (Module["_PEM_write_bio_DSAPrivateKey"] = wasmExports["PEM_write_bio_DSAPrivateKey"])(a0, a1, a2, a3, a4, a5, a6);

    Module["_RSA_new"] = () => (Module["_RSA_new"] = wasmExports["RSA_new"])();

    Module["_EVP_PKEY_CTX_set_rsa_keygen_bits"] = (a0, a1) => (Module["_EVP_PKEY_CTX_set_rsa_keygen_bits"] = wasmExports["EVP_PKEY_CTX_set_rsa_keygen_bits"])(a0, a1);

    Module["_SSL_is_init_finished"] = a0 => (Module["_SSL_is_init_finished"] = wasmExports["SSL_is_init_finished"])(a0);

    var __initialize = Module["__initialize"] = () => (__initialize = Module["__initialize"] = wasmExports["_initialize"])();

    var _htonl = a0 => (_htonl = wasmExports["htonl"])(a0);

    var _htons = a0 => (_htons = wasmExports["htons"])(a0);

    var __emscripten_stack_restore = a0 => (__emscripten_stack_restore = wasmExports["_emscripten_stack_restore"])(a0);

    var __emscripten_stack_alloc = a0 => (__emscripten_stack_alloc = wasmExports["_emscripten_stack_alloc"])(a0);

    var _emscripten_stack_get_current = () => (_emscripten_stack_get_current = wasmExports["emscripten_stack_get_current"])();

    Module["_whichWASMstring"] = 1024;

    Module["ccall"] = ccall;
    Module["cwrap"] = cwrap;
    Module["addFunction"] = addFunction;
    Module["setValue"] = setValue;
    Module["getValue"] = getValue;
    Module["stringToUTF8"] = stringToUTF8;
    Module["lengthBytesUTF8"] = lengthBytesUTF8;
    var calledRun;

    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run();
      if (!calledRun) dependenciesFulfilled = runCaller;
    };

    function callMain(args = []) {
      var entryFunction = __initialize;

      try {
        entryFunction();
        var ret = 0;
        Promise.resolve(ret).then(result => {
          exitJS(result, true);
        }).catch(e => {
          handleException(e);
        });
        return ret;
      } catch (e) {
        return handleException(e);
      }
    }

    function run(args = arguments_) {
      if (runDependencies > 0) {
        return;
      }

      preRun();

      if (runDependencies > 0) {
        return;
      }

      function doRun() {
        if (calledRun) return;
        calledRun = true;
        Module["calledRun"] = true;
        if (ABORT) return;
        initRuntime();
        preMain();
        readyPromiseResolve(Module);
        Module["onRuntimeInitialized"]?.();
        if (shouldRunNow) callMain(args);
        postRun();
      }

      if (Module["setStatus"]) {
        Module["setStatus"]("Running...");
        setTimeout(() => {
          setTimeout(() => Module["setStatus"](""), 1);
          doRun();
        }, 1);
      } else {
        doRun();
      }
    }

    if (Module["preInit"]) {
      if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];

      while (Module["preInit"].length > 0) {
        Module["preInit"].pop()();
      }
    }

    var shouldRunNow = false;
    if (Module["noInitialRun"]) shouldRunNow = false;
    run();
    moduleRtn = readyPromise;
    return moduleRtn;
  };
})();

var libCrypto = (() => {
  var _scriptName = import.meta.url;
  return function (moduleArg = {}) {
    var moduleRtn;
    var Module = moduleArg;
    var readyPromiseResolve, readyPromiseReject;
    var readyPromise = new Promise((resolve, reject) => {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });
    var arguments_ = {};
    arguments_["foo"] = 1;
    var moduleOverrides = Object.assign({}, Module);
    var arguments_ = [];
    var thisProgram = "./this.program";

    var quit_ = (status, toThrow) => {
      throw toThrow;
    };

    var scriptDirectory = "";

    function locateFile(path) {
      return scriptDirectory + path;
    }

    var readAsync;

    {
      if (typeof document != "undefined" && document.currentScript) {
        scriptDirectory = document.currentScript.src;
      }

      if (_scriptName) {
        scriptDirectory = _scriptName;
      }

      if (scriptDirectory.startsWith("blob:")) {
        scriptDirectory = "";
      } else {
        scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
      }

      {
        readAsync = url => fetch(url, {
          credentials: "same-origin"
        }).then(response => {
          if (response.ok) {
            return response.arrayBuffer();
          }

          return Promise.reject(new Error(response.status + " : " + response.url));
        });
      }
    }

    var out = console.log.bind(console);
    var err = console.error.bind(console);
    Object.assign(Module, moduleOverrides);
    moduleOverrides = null;
    var wasmBinary;
    var wasmMemory;
    var ABORT = false;
    var EXITSTATUS;
    var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAP64, HEAPF64;

    function updateMemoryViews() {
      var b = wasmMemory.buffer;
      HEAP8 = new Int8Array(b);
      HEAP16 = new Int16Array(b);
      HEAPU8 = new Uint8Array(b);
      HEAPU16 = new Uint16Array(b);
      HEAP32 = new Int32Array(b);
      HEAPU32 = new Uint32Array(b);
      HEAPF32 = new Float32Array(b);
      HEAPF64 = new Float64Array(b);
      HEAP64 = new BigInt64Array(b);
      new BigUint64Array(b);
    }

    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATMAIN__ = [];
    var __ATPOSTRUN__ = [];

    function preRun() {
      callRuntimeCallbacks(__ATPRERUN__);
    }

    function initRuntime() {
      callRuntimeCallbacks(__ATINIT__);
    }

    function preMain() {
      callRuntimeCallbacks(__ATMAIN__);
    }

    function postRun() {
      callRuntimeCallbacks(__ATPOSTRUN__);
    }

    var runDependencies = 0;
    var dependenciesFulfilled = null;

    function addRunDependency(id) {
      runDependencies++;
    }

    function removeRunDependency(id) {
      runDependencies--;

      if (runDependencies == 0) {

        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled;
          dependenciesFulfilled = null;
          callback();
        }
      }
    }

    function abort(what) {
      what = "Aborted(" + what + ")";
      err(what);
      ABORT = true;
      what += ". Build with -sASSERTIONS for more info.";
      var e = new WebAssembly.RuntimeError(what);
      readyPromiseReject(e);
      throw e;
    }

    var dataURIPrefix = "data:application/octet-stream;base64,";

    var isDataURI = filename => filename.startsWith(dataURIPrefix);

    function findWasmBinary() {
      if (Module["locateFile"]) {
        var f = "libcrypto.NO-JSPI.5497e3a.wasm";

        if (!isDataURI(f)) {
          return locateFile(f);
        }

        return f;
      }

      return new URL("libcrypto.NO-JSPI.5497e3a.wasm", import.meta.url).href;
    }

    var wasmBinaryFile;

    function getBinarySync(file) {
      if (file == wasmBinaryFile && wasmBinary) {
        return new Uint8Array(wasmBinary);
      }

      throw "both async and sync fetching of the wasm failed";
    }

    function getBinaryPromise(binaryFile) {
      {
        return readAsync(binaryFile).then(response => new Uint8Array(response), () => getBinarySync(binaryFile));
      }
    }

    function instantiateArrayBuffer(binaryFile, imports, receiver) {
      return getBinaryPromise(binaryFile).then(binary => WebAssembly.instantiate(binary, imports)).then(receiver, reason => {
        err(`failed to asynchronously prepare wasm: ${reason}`);
        abort(reason);
      });
    }

    function instantiateAsync(binary, binaryFile, imports, callback) {
      if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") {
        return fetch(binaryFile, {
          credentials: "same-origin"
        }).then(response => {
          var result = WebAssembly.instantiateStreaming(response, imports);
          return result.then(callback, function (reason) {
            err(`wasm streaming compile failed: ${reason}`);
            err("falling back to ArrayBuffer instantiation");
            return instantiateArrayBuffer(binaryFile, imports, callback);
          });
        });
      }

      return instantiateArrayBuffer(binaryFile, imports, callback);
    }

    function getWasmImports() {
      return {
        env: wasmImports,
        wasi_snapshot_preview1: wasmImports
      };
    }

    function createWasm() {
      var info = getWasmImports();

      function receiveInstance(instance, module) {
        wasmExports = instance.exports;
        wasmExports = Asyncify.instrumentWasmExports(wasmExports);
        wasmMemory = wasmExports["memory"];
        updateMemoryViews();
        wasmTable = wasmExports["__indirect_function_table"];
        removeRunDependency();
        return wasmExports;
      }

      addRunDependency();

      function receiveInstantiationResult(result) {
        receiveInstance(result["instance"]);
      }

      if (!wasmBinaryFile) wasmBinaryFile = findWasmBinary();
      instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
      return {};
    }

    function ExitStatus(status) {
      this.name = "ExitStatus";
      this.message = `Program terminated with exit(${status})`;
      this.status = status;
    }

    var callRuntimeCallbacks = callbacks => {
      while (callbacks.length > 0) {
        callbacks.shift()(Module);
      }
    };

    function getValue(ptr, type = "i8") {
      if (type.endsWith("*")) type = "*";

      switch (type) {
        case "i1":
          return HEAP8[ptr];

        case "i8":
          return HEAP8[ptr];

        case "i16":
          return HEAP16[ptr >> 1];

        case "i32":
          return HEAP32[ptr >> 2];

        case "i64":
          return HEAP64[ptr >> 3];

        case "float":
          return HEAPF32[ptr >> 2];

        case "double":
          return HEAPF64[ptr >> 3];

        case "*":
          return HEAPU32[ptr >> 2];

        default:
          abort(`invalid type for getValue: ${type}`);
      }
    }

    function setValue(ptr, value, type = "i8") {
      if (type.endsWith("*")) type = "*";

      switch (type) {
        case "i1":
          HEAP8[ptr] = value;
          break;

        case "i8":
          HEAP8[ptr] = value;
          break;

        case "i16":
          HEAP16[ptr >> 1] = value;
          break;

        case "i32":
          HEAP32[ptr >> 2] = value;
          break;

        case "i64":
          HEAP64[ptr >> 3] = BigInt(value);
          break;

        case "float":
          HEAPF32[ptr >> 2] = value;
          break;

        case "double":
          HEAPF64[ptr >> 3] = value;
          break;

        case "*":
          HEAPU32[ptr >> 2] = value;
          break;

        default:
          abort(`invalid type for setValue: ${type}`);
      }
    }

    var stackRestore = val => __emscripten_stack_restore(val);

    var stackSave = () => _emscripten_stack_get_current();

    var inetNtop4 = addr => (addr & 255) + "." + (addr >> 8 & 255) + "." + (addr >> 16 & 255) + "." + (addr >> 24 & 255);

    var inetNtop6 = ints => {
      var str = "";
      var word = 0;
      var longest = 0;
      var lastzero = 0;
      var zstart = 0;
      var len = 0;
      var i = 0;
      var parts = [ints[0] & 65535, ints[0] >> 16, ints[1] & 65535, ints[1] >> 16, ints[2] & 65535, ints[2] >> 16, ints[3] & 65535, ints[3] >> 16];
      var hasipv4 = true;
      var v4part = "";

      for (i = 0; i < 5; i++) {
        if (parts[i] !== 0) {
          hasipv4 = false;
          break;
        }
      }

      if (hasipv4) {
        v4part = inetNtop4(parts[6] | parts[7] << 16);

        if (parts[5] === -1) {
          str = "::ffff:";
          str += v4part;
          return str;
        }

        if (parts[5] === 0) {
          str = "::";
          if (v4part === "0.0.0.0") v4part = "";
          if (v4part === "0.0.0.1") v4part = "1";
          str += v4part;
          return str;
        }
      }

      for (word = 0; word < 8; word++) {
        if (parts[word] === 0) {
          if (word - lastzero > 1) {
            len = 0;
          }

          lastzero = word;
          len++;
        }

        if (len > longest) {
          longest = len;
          zstart = word - longest + 1;
        }
      }

      for (word = 0; word < 8; word++) {
        if (longest > 1) {
          if (parts[word] === 0 && word >= zstart && word < zstart + longest) {
            if (word === zstart) {
              str += ":";
              if (zstart === 0) str += ":";
            }

            continue;
          }
        }

        str += Number(_ntohs(parts[word] & 65535)).toString(16);
        str += word < 7 ? ":" : "";
      }

      return str;
    };

    var readSockaddr = (sa, salen) => {
      var family = HEAP16[sa >> 1];

      var port = _ntohs(HEAPU16[sa + 2 >> 1]);

      var addr;

      switch (family) {
        case 2:
          if (salen !== 16) {
            return {
              errno: 28
            };
          }

          addr = HEAP32[sa + 4 >> 2];
          addr = inetNtop4(addr);
          break;

        case 10:
          if (salen !== 28) {
            return {
              errno: 28
            };
          }

          addr = [HEAP32[sa + 8 >> 2], HEAP32[sa + 12 >> 2], HEAP32[sa + 16 >> 2], HEAP32[sa + 20 >> 2]];
          addr = inetNtop6(addr);
          break;

        default:
          return {
            errno: 5
          };
      }

      return {
        family,
        addr,
        port
      };
    };

    var inetPton4 = str => {
      var b = str.split(".");

      for (var i = 0; i < 4; i++) {
        var tmp = Number(b[i]);
        if (isNaN(tmp)) return null;
        b[i] = tmp;
      }

      return (b[0] | b[1] << 8 | b[2] << 16 | b[3] << 24) >>> 0;
    };

    var jstoi_q = str => parseInt(str);

    var inetPton6 = str => {
      var words;
      var w, offset, z;
      var valid6regx = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i;
      var parts = [];

      if (!valid6regx.test(str)) {
        return null;
      }

      if (str === "::") {
        return [0, 0, 0, 0, 0, 0, 0, 0];
      }

      if (str.startsWith("::")) {
        str = str.replace("::", "Z:");
      } else {
        str = str.replace("::", ":Z:");
      }

      if (str.indexOf(".") > 0) {
        str = str.replace(new RegExp("[.]", "g"), ":");
        words = str.split(":");
        words[words.length - 4] = jstoi_q(words[words.length - 4]) + jstoi_q(words[words.length - 3]) * 256;
        words[words.length - 3] = jstoi_q(words[words.length - 2]) + jstoi_q(words[words.length - 1]) * 256;
        words = words.slice(0, words.length - 2);
      } else {
        words = str.split(":");
      }

      offset = 0;
      z = 0;

      for (w = 0; w < words.length; w++) {
        if (typeof words[w] == "string") {
          if (words[w] === "Z") {
            for (z = 0; z < 8 - words.length + 1; z++) {
              parts[w + z] = 0;
            }

            offset = z - 1;
          } else {
            parts[w + offset] = _htons(parseInt(words[w], 16));
          }
        } else {
          parts[w + offset] = words[w];
        }
      }

      return [parts[1] << 16 | parts[0], parts[3] << 16 | parts[2], parts[5] << 16 | parts[4], parts[7] << 16 | parts[6]];
    };

    var DNS = {
      address_map: {
        id: 1,
        addrs: {},
        names: {}
      },

      lookup_name(name) {
        var res = inetPton4(name);

        if (res !== null) {
          return name;
        }

        res = inetPton6(name);

        if (res !== null) {
          return name;
        }

        var addr;

        if (DNS.address_map.addrs[name]) {
          addr = DNS.address_map.addrs[name];
        } else {
          var id = DNS.address_map.id++;
          assert(id < 65535, "exceeded max address mappings of 65535");
          addr = "172.29." + (id & 255) + "." + (id & 65280);
          DNS.address_map.names[addr] = name;
          DNS.address_map.addrs[name] = addr;
        }

        return addr;
      },

      lookup_addr(addr) {
        if (DNS.address_map.names[addr]) {
          return DNS.address_map.names[addr];
        }

        return null;
      }

    };

    function ___syscall_connect() {
      return 0;
    }

    var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
      if (!(maxBytesToWrite > 0)) return 0;
      var startIdx = outIdx;
      var endIdx = outIdx + maxBytesToWrite - 1;

      for (var i = 0; i < str.length; ++i) {
        var u = str.charCodeAt(i);

        if (u >= 55296 && u <= 57343) {
          var u1 = str.charCodeAt(++i);
          u = 65536 + ((u & 1023) << 10) | u1 & 1023;
        }

        if (u <= 127) {
          if (outIdx >= endIdx) break;
          heap[outIdx++] = u;
        } else if (u <= 2047) {
          if (outIdx + 1 >= endIdx) break;
          heap[outIdx++] = 192 | u >> 6;
          heap[outIdx++] = 128 | u & 63;
        } else if (u <= 65535) {
          if (outIdx + 2 >= endIdx) break;
          heap[outIdx++] = 224 | u >> 12;
          heap[outIdx++] = 128 | u >> 6 & 63;
          heap[outIdx++] = 128 | u & 63;
        } else {
          if (outIdx + 3 >= endIdx) break;
          heap[outIdx++] = 240 | u >> 18;
          heap[outIdx++] = 128 | u >> 12 & 63;
          heap[outIdx++] = 128 | u >> 6 & 63;
          heap[outIdx++] = 128 | u & 63;
        }
      }

      heap[outIdx] = 0;
      return outIdx - startIdx;
    };

    var stringToUTF8 = (str, outPtr, maxBytesToWrite) => stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);

    var ___syscall_getdents64 = (fd, dirp, count) => {};

    function ___syscall_getegid32() {
      return 0;
    }

    function ___syscall_geteuid32() {
      return 0;
    }

    function ___syscall_getgid32() {
      return 0;
    }

    function ___syscall_getsockopt(fd, level, optname, optval, optlen, d1) {
      return -50;
    }

    function ___syscall_getuid32() {
      return 0;
    }

    function ___syscall_setsockopt(arg1, arg2, arg3, arg4, arg5) {
      console.log("__syscall_setsockopt(): args are: ", arg1, arg2, arg3, arg4, arg5);
      return 0;
    }

    function ___syscall_shutdown(fd, how) {
      return -50;
    }

    var ___syscall_socket = (domain, type, protocol) => {};

    var _emscripten_get_now;

    _emscripten_get_now = () => performance.now();

    var checkWasiClock = clock_id => clock_id == 0 || clock_id == 1 || clock_id == 2 || clock_id == 3;

    function _clock_time_get(clk_id, ignored_precision, ptime) {

      if (!checkWasiClock(clk_id)) {
        return 28;
      }

      var now;

      if (clk_id === 0) {
        now = Date.now();
      } else {
        now = _emscripten_get_now();
      }

      var nsec = Math.round(now * 1e3 * 1e3);
      HEAP32[ptime >> 2] = nsec >>> 0;
      HEAP32[ptime + 4 >> 2] = nsec / Math.pow(2, 32) >>> 0;
      return 0;
    }

    var _emscripten_notify_memory_growth = memoryIndex => {
      updateMemoryViews();
    };

    var handleException = e => {
      if (e instanceof ExitStatus || e == "unwind") {
        return EXITSTATUS;
      }

      quit_(1, e);
    };

    var maybeExit = () => {
    };

    var callUserCallback = func => {
      if (ABORT) {
        return;
      }

      try {
        func();
        maybeExit();
      } catch (e) {
        handleException(e);
      }
    };

    var safeSetTimeout = (func, timeout) => setTimeout(() => {
      callUserCallback(func);
    }, timeout);

    var _emscripten_sleep = ms => Asyncify.handleSleep(wakeUp => safeSetTimeout(wakeUp, ms));

    _emscripten_sleep.isAsync = true;
    var ENV = {};

    var getExecutableName = () => thisProgram ;

    var getEnvStrings = () => {
      if (!getEnvStrings.strings) {
        var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
        var env = {
          USER: "web_user",
          LOGNAME: "web_user",
          PATH: "/",
          PWD: "/",
          HOME: "/home/web_user",
          LANG: lang,
          _: getExecutableName()
        };

        for (var x in ENV) {
          if (ENV[x] === undefined) delete env[x];else env[x] = ENV[x];
        }

        var strings = [];

        for (var x in env) {
          strings.push(`${x}=${env[x]}`);
        }

        getEnvStrings.strings = strings;
      }

      return getEnvStrings.strings;
    };

    var stringToAscii = (str, buffer) => {
      for (var i = 0; i < str.length; ++i) {
        HEAP8[buffer++] = str.charCodeAt(i);
      }

      HEAP8[buffer] = 0;
    };

    var _environ_get = (__environ, environ_buf) => {
      var bufSize = 0;
      getEnvStrings().forEach((string, i) => {
        var ptr = environ_buf + bufSize;
        HEAPU32[__environ + i * 4 >> 2] = ptr;
        stringToAscii(string, ptr);
        bufSize += string.length + 1;
      });
      return 0;
    };

    var _environ_sizes_get = (penviron_count, penviron_buf_size) => {
      var strings = getEnvStrings();
      HEAPU32[penviron_count >> 2] = strings.length;
      var bufSize = 0;
      strings.forEach(string => bufSize += string.length + 1);
      HEAPU32[penviron_buf_size >> 2] = bufSize;
      return 0;
    };

    var _fd_close = fd => 52;

    async function _fd_read(fd, iov, iovcnt, pnum) {
      console.log("fd_read: entered");

      if (fd < 10) {
        var stream = SYSCALLS.getStreamFromFD(fd);
        var num = SYSCALLS.doReadv(stream, iov, iovcnt);
        HEAP32[pnum >> 2] = num;
        return 0;
      } else {
        const wasmFD = _zitiContext._wasmFDsById.get(fd);

        if (wasmFD === null) throw new Error("cannot find wasmFD");
        wasmFD.socket.fd_read();
        HEAP32[pnum >> 2] = 0;
        return 0;
      }
    }

    _fd_read.isAsync = true;

    function _fd_seek(fd, offset, whence, newOffset) {
      return 70;
    }

    var printCharBuffers = [null, [], []];
    var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder() : undefined;

    var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead) => {
      var endIdx = idx + maxBytesToRead;
      var endPtr = idx;

      while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr;

      if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
        return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
      }

      var str = "";

      while (idx < endPtr) {
        var u0 = heapOrArray[idx++];

        if (!(u0 & 128)) {
          str += String.fromCharCode(u0);
          continue;
        }

        var u1 = heapOrArray[idx++] & 63;

        if ((u0 & 224) == 192) {
          str += String.fromCharCode((u0 & 31) << 6 | u1);
          continue;
        }

        var u2 = heapOrArray[idx++] & 63;

        if ((u0 & 240) == 224) {
          u0 = (u0 & 15) << 12 | u1 << 6 | u2;
        } else {
          u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
        }

        if (u0 < 65536) {
          str += String.fromCharCode(u0);
        } else {
          var ch = u0 - 65536;
          str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
        }
      }

      return str;
    };

    var printChar = (stream, curr) => {
      var buffer = printCharBuffers[stream];

      if (curr === 0 || curr === 10) {
        (stream === 1 ? out : err)(UTF8ArrayToString(buffer, 0));
        buffer.length = 0;
      } else {
        buffer.push(curr);
      }
    };

    var UTF8ToString = (ptr, maxBytesToRead) => ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";

    var SYSCALLS = {
      varargs: undefined,

      getStr(ptr) {
        var ret = UTF8ToString(ptr);
        return ret;
      }

    };

    function _fd_write(fd, iov, iovcnt, pnum) {
      if (fd < 10) {
        var num = 0;

        for (var i = 0; i < iovcnt; i++) {
          var ptr = HEAP32[iov >> 2];
          var len = HEAP32[iov + 4 >> 2];
          iov += 8;

          for (var j = 0; j < len; j++) {
            printChar(fd, HEAPU8[ptr + j]);
          }

          num += len;
        }

        HEAP32[pnum >> 2] = num;
        return 0;
      } else {
        const wasmFD = _zitiContext._wasmFDsById.get(fd);

        if (wasmFD === null) throw new Error("cannot find wasmFD");
        var num = 0;

        for (var i = 0; i < iovcnt; i++) {
          var ptr = HEAP32[iov >> 2];
          var len = HEAP32[iov + 4 >> 2];
          iov += 8;
          var array = new Uint8Array(Module.HEAPU8.buffer, ptr, len);
          wasmFD.socket.fd_write(array);
          num += len;
        }

        HEAP32[pnum >> 2] = num;
        return 0;
      }
    }

    var zeroMemory = (address, size) => {
      HEAPU8.fill(0, address, address + size);
      return address;
    };

    var writeSockaddr = (sa, family, addr, port, addrlen) => {
      switch (family) {
        case 2:
          addr = inetPton4(addr);
          zeroMemory(sa, 16);

          if (addrlen) {
            HEAP32[addrlen >> 2] = 16;
          }

          HEAP16[sa >> 1] = family;
          HEAP32[sa + 4 >> 2] = addr;
          HEAP16[sa + 2 >> 1] = _htons(port);
          break;

        case 10:
          addr = inetPton6(addr);
          zeroMemory(sa, 28);

          if (addrlen) {
            HEAP32[addrlen >> 2] = 28;
          }

          HEAP32[sa >> 2] = family;
          HEAP32[sa + 8 >> 2] = addr[0];
          HEAP32[sa + 12 >> 2] = addr[1];
          HEAP32[sa + 16 >> 2] = addr[2];
          HEAP32[sa + 20 >> 2] = addr[3];
          HEAP16[sa + 2 >> 1] = _htons(port);
          break;

        default:
          return 5;
      }

      return 0;
    };

    var _getaddrinfo = (node, service, hint, out) => {
      var addr = 0;
      var port = 0;
      var flags = 0;
      var family = 0;
      var type = 0;
      var proto = 0;
      var ai;

      function allocaddrinfo(family, type, proto, canon, addr, port) {
        var sa, salen, ai;
        var errno;
        salen = family === 10 ? 28 : 16;
        addr = family === 10 ? inetNtop6(addr) : inetNtop4(addr);
        sa = _malloc(salen);
        errno = writeSockaddr(sa, family, addr, port);
        assert(!errno);
        ai = _malloc(32);
        HEAP32[ai + 4 >> 2] = family;
        HEAP32[ai + 8 >> 2] = type;
        HEAP32[ai + 12 >> 2] = proto;
        HEAPU32[ai + 24 >> 2] = canon;
        HEAPU32[ai + 20 >> 2] = sa;

        if (family === 10) {
          HEAP32[ai + 16 >> 2] = 28;
        } else {
          HEAP32[ai + 16 >> 2] = 16;
        }

        HEAP32[ai + 28 >> 2] = 0;
        return ai;
      }

      if (hint) {
        flags = HEAP32[hint >> 2];
        family = HEAP32[hint + 4 >> 2];
        type = HEAP32[hint + 8 >> 2];
        proto = HEAP32[hint + 12 >> 2];
      }

      if (type && !proto) {
        proto = type === 2 ? 17 : 6;
      }

      if (!type && proto) {
        type = proto === 17 ? 2 : 1;
      }

      if (proto === 0) {
        proto = 6;
      }

      if (type === 0) {
        type = 1;
      }

      if (!node && !service) {
        return -2;
      }

      if (flags & ~(1 | 2 | 4 | 1024 | 8 | 16 | 32)) {
        return -1;
      }

      if (hint !== 0 && HEAP32[hint >> 2] & 2 && !node) {
        return -1;
      }

      if (flags & 32) {
        return -2;
      }

      if (type !== 0 && type !== 1 && type !== 2) {
        return -7;
      }

      if (family !== 0 && family !== 2 && family !== 10) {
        return -6;
      }

      if (service) {
        service = UTF8ToString(service);
        port = parseInt(service, 10);

        if (isNaN(port)) {
          if (flags & 1024) {
            return -2;
          }

          return -8;
        }
      }

      if (!node) {
        if (family === 0) {
          family = 2;
        }

        if ((flags & 1) === 0) {
          if (family === 2) {
            addr = _htonl(2130706433);
          } else {
            addr = [0, 0, 0, 1];
          }
        }

        ai = allocaddrinfo(family, type, proto, null, addr, port);
        HEAPU32[out >> 2] = ai;
        return 0;
      }

      node = UTF8ToString(node);
      addr = inetPton4(node);

      if (addr !== null) {
        if (family === 0 || family === 2) {
          family = 2;
        } else if (family === 10 && flags & 8) {
          addr = [0, 0, _htonl(65535), addr];
          family = 10;
        } else {
          return -2;
        }
      } else {
        addr = inetPton6(node);

        if (addr !== null) {
          if (family === 0 || family === 10) {
            family = 10;
          } else {
            return -2;
          }
        }
      }

      if (addr != null) {
        ai = allocaddrinfo(family, type, proto, node, addr, port);
        HEAPU32[out >> 2] = ai;
        return 0;
      }

      if (flags & 4) {
        return -2;
      }

      node = DNS.lookup_name(node);
      addr = inetPton4(node);

      if (family === 0) {
        family = 2;
      } else if (family === 10) {
        addr = [0, 0, _htonl(65535), addr];
      }

      ai = allocaddrinfo(family, type, proto, null, addr, port);
      HEAPU32[out >> 2] = ai;
      return 0;
    };

    var _getnameinfo = (sa, salen, node, nodelen, serv, servlen, flags) => {
      var info = readSockaddr(sa, salen);

      if (info.errno) {
        return -6;
      }

      var port = info.port;
      var addr = info.addr;
      var overflowed = false;

      if (node && nodelen) {
        var lookup;

        if (flags & 1 || !(lookup = DNS.lookup_addr(addr))) {
          if (flags & 8) {
            return -2;
          }
        } else {
          addr = lookup;
        }

        var numBytesWrittenExclNull = stringToUTF8(addr, node, nodelen);

        if (numBytesWrittenExclNull + 1 >= nodelen) {
          overflowed = true;
        }
      }

      if (serv && servlen) {
        port = "" + port;
        var numBytesWrittenExclNull = stringToUTF8(port, serv, servlen);

        if (numBytesWrittenExclNull + 1 >= servlen) {
          overflowed = true;
        }
      }

      if (overflowed) {
        return -12;
      }

      return 0;
    };

    function _ziti_getentropy(buf, buflen) {
      let array = new Uint8Array(Module.HEAPU8.buffer, buf, buflen);
      crypto.getRandomValues(array);
    }

    var runAndAbortIfError = func => {
      try {
        return func();
      } catch (e) {
        abort(e);
      }
    };

    var sigToWasmTypes = sig => {
      var typeNames = {
        i: "i32",
        j: "i64",
        f: "f32",
        d: "f64",
        e: "externref",
        p: "i32"
      };
      var type = {
        parameters: [],
        results: sig[0] == "v" ? [] : [typeNames[sig[0]]]
      };

      for (var i = 1; i < sig.length; ++i) {
        type.parameters.push(typeNames[sig[i]]);
      }

      return type;
    };

    var Asyncify = {
      instrumentWasmImports(imports) {
        var importPattern = /^(invoke_.*|__asyncjs__.*)$/;

        for (let [x, original] of Object.entries(imports)) {
          if (typeof original == "function") {
            original.isAsync || importPattern.test(x);
          }
        }
      },

      instrumentWasmExports(exports) {
        var ret = {};

        for (let [x, original] of Object.entries(exports)) {
          if (typeof original == "function") {
            ret[x] = (...args) => {
              Asyncify.exportCallStack.push(x);

              try {
                return original(...args);
              } finally {
                if (!ABORT) {
                  Asyncify.exportCallStack.pop();
                  Asyncify.maybeStopUnwind();
                }
              }
            };
          } else {
            ret[x] = original;
          }
        }

        return ret;
      },

      State: {
        Normal: 0,
        Unwinding: 1,
        Rewinding: 2,
        Disabled: 3
      },
      state: 0,
      StackSize: 4096,
      currData: null,
      handleSleepReturnValue: 0,
      exportCallStack: [],
      callStackNameToId: {},
      callStackIdToName: {},
      callStackId: 0,
      asyncPromiseHandlers: null,
      sleepCallbacks: [],

      getCallStackId(funcName) {
        var id = Asyncify.callStackNameToId[funcName];

        if (id === undefined) {
          id = Asyncify.callStackId++;
          Asyncify.callStackNameToId[funcName] = id;
          Asyncify.callStackIdToName[id] = funcName;
        }

        return id;
      },

      maybeStopUnwind() {
        if (Asyncify.currData && Asyncify.state === Asyncify.State.Unwinding && Asyncify.exportCallStack.length === 0) {
          Asyncify.state = Asyncify.State.Normal;
          runAndAbortIfError(_asyncify_stop_unwind);

          if (typeof Fibers != "undefined") {
            Fibers.trampoline();
          }
        }
      },

      whenDone() {
        return new Promise((resolve, reject) => {
          Asyncify.asyncPromiseHandlers = {
            resolve,
            reject
          };
        });
      },

      allocateData() {
        var ptr = _malloc(12 + Asyncify.StackSize);

        Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize);
        Asyncify.setDataRewindFunc(ptr);
        return ptr;
      },

      setDataHeader(ptr, stack, stackSize) {
        HEAPU32[ptr >> 2] = stack;
        HEAPU32[ptr + 4 >> 2] = stack + stackSize;
      },

      setDataRewindFunc(ptr) {
        var bottomOfCallStack = Asyncify.exportCallStack[0];
        var rewindId = Asyncify.getCallStackId(bottomOfCallStack);
        HEAP32[ptr + 8 >> 2] = rewindId;
      },

      getDataRewindFuncName(ptr) {
        var id = HEAP32[ptr + 8 >> 2];
        var name = Asyncify.callStackIdToName[id];
        return name;
      },

      getDataRewindFunc(name) {
        var func = wasmExports[name];
        return func;
      },

      doRewind(ptr) {
        var name = Asyncify.getDataRewindFuncName(ptr);
        var func = Asyncify.getDataRewindFunc(name);
        return func();
      },

      handleSleep(startAsync) {
        if (ABORT) return;

        if (Asyncify.state === Asyncify.State.Normal) {
          var reachedCallback = false;
          var reachedAfterCallback = false;
          startAsync((handleSleepReturnValue = 0) => {
            if (ABORT) return;
            Asyncify.handleSleepReturnValue = handleSleepReturnValue;
            reachedCallback = true;

            if (!reachedAfterCallback) {
              return;
            }

            Asyncify.state = Asyncify.State.Rewinding;
            runAndAbortIfError(() => _asyncify_start_rewind(Asyncify.currData));

            if (typeof Browser != "undefined" && Browser.mainLoop.func) {
              Browser.mainLoop.resume();
            }

            var asyncWasmReturnValue,
                isError = false;

            try {
              asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData);
            } catch (err) {
              asyncWasmReturnValue = err;
              isError = true;
            }

            var handled = false;

            if (!Asyncify.currData) {
              var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers;

              if (asyncPromiseHandlers) {
                Asyncify.asyncPromiseHandlers = null;
                (isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(asyncWasmReturnValue);
                handled = true;
              }
            }

            if (isError && !handled) {
              throw asyncWasmReturnValue;
            }
          });
          reachedAfterCallback = true;

          if (!reachedCallback) {
            Asyncify.state = Asyncify.State.Unwinding;
            Asyncify.currData = Asyncify.allocateData();

            if (typeof Browser != "undefined" && Browser.mainLoop.func) {
              Browser.mainLoop.pause();
            }

            runAndAbortIfError(() => _asyncify_start_unwind(Asyncify.currData));
          }
        } else if (Asyncify.state === Asyncify.State.Rewinding) {
          Asyncify.state = Asyncify.State.Normal;
          runAndAbortIfError(_asyncify_stop_rewind);

          _free(Asyncify.currData);

          Asyncify.currData = null;
          Asyncify.sleepCallbacks.forEach(callUserCallback);
        } else {
          abort(`invalid state: ${Asyncify.state}`);
        }

        return Asyncify.handleSleepReturnValue;
      },

      handleAsync(startAsync) {
        return Asyncify.handleSleep(wakeUp => {
          startAsync().then(wakeUp);
        });
      }

    };

    var getCFunc = ident => {
      var func = Module["_" + ident];
      return func;
    };

    var writeArrayToMemory = (array, buffer) => {
      HEAP8.set(array, buffer);
    };

    var lengthBytesUTF8 = str => {
      var len = 0;

      for (var i = 0; i < str.length; ++i) {
        var c = str.charCodeAt(i);

        if (c <= 127) {
          len++;
        } else if (c <= 2047) {
          len += 2;
        } else if (c >= 55296 && c <= 57343) {
          len += 4;
          ++i;
        } else {
          len += 3;
        }
      }

      return len;
    };

    var stackAlloc = sz => __emscripten_stack_alloc(sz);

    var stringToUTF8OnStack = str => {
      var size = lengthBytesUTF8(str) + 1;
      var ret = stackAlloc(size);
      stringToUTF8(str, ret, size);
      return ret;
    };

    var ccall = (ident, returnType, argTypes, args, opts) => {
      var toC = {
        string: str => {
          var ret = 0;

          if (str !== null && str !== undefined && str !== 0) {
            ret = stringToUTF8OnStack(str);
          }

          return ret;
        },
        array: arr => {
          var ret = stackAlloc(arr.length);
          writeArrayToMemory(arr, ret);
          return ret;
        }
      };

      function convertReturnValue(ret) {
        if (returnType === "string") {
          return UTF8ToString(ret);
        }

        if (returnType === "boolean") return Boolean(ret);
        return ret;
      }

      var func = getCFunc(ident);
      var cArgs = [];
      var stack = 0;

      if (args) {
        for (var i = 0; i < args.length; i++) {
          var converter = toC[argTypes[i]];

          if (converter) {
            if (stack === 0) stack = stackSave();
            cArgs[i] = converter(args[i]);
          } else {
            cArgs[i] = args[i];
          }
        }
      }

      var previousAsync = Asyncify.currData;
      var ret = func(...cArgs);

      function onDone(ret) {
        if (stack !== 0) stackRestore(stack);
        return convertReturnValue(ret);
      }

      var asyncMode = opts?.async;

      if (Asyncify.currData != previousAsync) {
        return Asyncify.whenDone().then(onDone);
      }

      ret = onDone(ret);
      if (asyncMode) return Promise.resolve(ret);
      return ret;
    };

    var cwrap = (ident, returnType, argTypes, opts) => {
      var numericArgs = !argTypes || argTypes.every(type => type === "number" || type === "boolean");
      var numericRet = returnType !== "string";

      if (numericRet && numericArgs && !opts) {
        return getCFunc(ident);
      }

      return (...args) => ccall(ident, returnType, argTypes, args, opts);
    };

    var uleb128Encode = (n, target) => {
      if (n < 128) {
        target.push(n);
      } else {
        target.push(n % 128 | 128, n >> 7);
      }
    };

    var generateFuncType = (sig, target) => {
      var sigRet = sig.slice(0, 1);
      var sigParam = sig.slice(1);
      var typeCodes = {
        i: 127,
        p: 127,
        j: 126,
        f: 125,
        d: 124,
        e: 111
      };
      target.push(96);
      uleb128Encode(sigParam.length, target);

      for (var i = 0; i < sigParam.length; ++i) {
        target.push(typeCodes[sigParam[i]]);
      }

      if (sigRet == "v") {
        target.push(0);
      } else {
        target.push(1, typeCodes[sigRet]);
      }
    };

    var convertJsFunctionToWasm = (func, sig) => {
      if (typeof WebAssembly.Function == "function") {
        return new WebAssembly.Function(sigToWasmTypes(sig), func);
      }

      var typeSectionBody = [1];
      generateFuncType(sig, typeSectionBody);
      var bytes = [0, 97, 115, 109, 1, 0, 0, 0, 1];
      uleb128Encode(typeSectionBody.length, bytes);
      bytes.push(...typeSectionBody);
      bytes.push(2, 7, 1, 1, 101, 1, 102, 0, 0, 7, 5, 1, 1, 102, 0, 0);
      var module = new WebAssembly.Module(new Uint8Array(bytes));
      var instance = new WebAssembly.Instance(module, {
        e: {
          f: func
        }
      });
      var wrappedFunc = instance.exports["f"];
      return wrappedFunc;
    };

    var wasmTableMirror = [];
    var wasmTable;

    var getWasmTableEntry = funcPtr => {
      var func = wasmTableMirror[funcPtr];

      if (!func) {
        if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
        wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
      }

      return func;
    };

    var updateTableMap = (offset, count) => {
      if (functionsInTableMap) {
        for (var i = offset; i < offset + count; i++) {
          var item = getWasmTableEntry(i);

          if (item) {
            functionsInTableMap.set(item, i);
          }
        }
      }
    };

    var functionsInTableMap;

    var getFunctionAddress = func => {
      if (!functionsInTableMap) {
        functionsInTableMap = new WeakMap();
        updateTableMap(0, wasmTable.length);
      }

      return functionsInTableMap.get(func) || 0;
    };

    var freeTableIndexes = [];

    var getEmptyTableSlot = () => {
      if (freeTableIndexes.length) {
        return freeTableIndexes.pop();
      }

      try {
        wasmTable.grow(1);
      } catch (err) {
        if (!(err instanceof RangeError)) {
          throw err;
        }

        throw "Unable to grow wasm table. Set ALLOW_TABLE_GROWTH.";
      }

      return wasmTable.length - 1;
    };

    var setWasmTableEntry = (idx, func) => {
      wasmTable.set(idx, func);
      wasmTableMirror[idx] = wasmTable.get(idx);
    };

    var addFunction = (func, sig) => {
      var rtn = getFunctionAddress(func);

      if (rtn) {
        return rtn;
      }

      var ret = getEmptyTableSlot();

      try {
        setWasmTableEntry(ret, func);
      } catch (err) {
        if (!(err instanceof TypeError)) {
          throw err;
        }

        var wrapped = convertJsFunctionToWasm(func, sig);
        setWasmTableEntry(ret, wrapped);
      }

      functionsInTableMap.set(func, ret);
      return ret;
    };

    var wasmImports = {
      __syscall_connect: ___syscall_connect,
      __syscall_getdents64: ___syscall_getdents64,
      __syscall_getegid32: ___syscall_getegid32,
      __syscall_geteuid32: ___syscall_geteuid32,
      __syscall_getgid32: ___syscall_getgid32,
      __syscall_getsockopt: ___syscall_getsockopt,
      __syscall_getuid32: ___syscall_getuid32,
      __syscall_setsockopt: ___syscall_setsockopt,
      __syscall_shutdown: ___syscall_shutdown,
      __syscall_socket: ___syscall_socket,
      clock_time_get: _clock_time_get,
      emscripten_notify_memory_growth: _emscripten_notify_memory_growth,
      emscripten_sleep: _emscripten_sleep,
      environ_get: _environ_get,
      environ_sizes_get: _environ_sizes_get,
      fd_close: _fd_close,
      fd_read: _fd_read,
      fd_seek: _fd_seek,
      fd_write: _fd_write,
      getaddrinfo: _getaddrinfo,
      getnameinfo: _getnameinfo,
      ziti_getentropy: _ziti_getentropy
    };
    var wasmExports = createWasm();

    var _malloc = Module["_malloc"] = a0 => (_malloc = Module["_malloc"] = wasmExports["malloc"])(a0);

    var _free = a0 => (_free = wasmExports["free"])(a0);

    Module["_createCertificateSigningRequest"] = (a0, a1, a2, a3, a4, a5, a6, a7) => (Module["_createCertificateSigningRequest"] = wasmExports["createCertificateSigningRequest"])(a0, a1, a2, a3, a4, a5, a6, a7);

    Module["_generateKey"] = a0 => (Module["_generateKey"] = wasmExports["generateKey"])(a0);

    Module["_EVP_PKEY_CTX_new_id"] = (a0, a1) => (Module["_EVP_PKEY_CTX_new_id"] = wasmExports["EVP_PKEY_CTX_new_id"])(a0, a1);

    Module["_EVP_PKEY_keygen_init"] = a0 => (Module["_EVP_PKEY_keygen_init"] = wasmExports["EVP_PKEY_keygen_init"])(a0);

    Module["_EVP_PKEY_keygen"] = (a0, a1) => (Module["_EVP_PKEY_keygen"] = wasmExports["EVP_PKEY_keygen"])(a0, a1);

    Module["_generateECKey"] = () => (Module["_generateECKey"] = wasmExports["generateECKey"])();

    Module["_EVP_PKEY_new"] = () => (Module["_EVP_PKEY_new"] = wasmExports["EVP_PKEY_new"])();

    Module["_getPrivateKeyPEM"] = a0 => (Module["_getPrivateKeyPEM"] = wasmExports["getPrivateKeyPEM"])(a0);

    Module["_getPublicKeyPEM"] = a0 => (Module["_getPublicKeyPEM"] = wasmExports["getPublicKeyPEM"])(a0);

    Module["_cleanup"] = () => (Module["_cleanup"] = wasmExports["cleanup"])();

    Module["_fd_kv_alloc"] = () => (Module["_fd_kv_alloc"] = wasmExports["fd_kv_alloc"])();

    Module["_fd_kv_getItem"] = a0 => (Module["_fd_kv_getItem"] = wasmExports["fd_kv_getItem"])(a0);

    Module["_fd_kv_delItem"] = a0 => (Module["_fd_kv_delItem"] = wasmExports["fd_kv_delItem"])(a0);

    Module["_fd_kv_addItem"] = (a0, a1) => (Module["_fd_kv_addItem"] = wasmExports["fd_kv_addItem"])(a0, a1);

    Module["_constructTLSDataQueue"] = (a0, a1) => (Module["_constructTLSDataQueue"] = wasmExports["constructTLSDataQueue"])(a0, a1);

    Module["_destructTLSDataQueue"] = a0 => (Module["_destructTLSDataQueue"] = wasmExports["destructTLSDataQueue"])(a0);

    Module["_isEmptyTLSData"] = a0 => (Module["_isEmptyTLSData"] = wasmExports["isEmptyTLSData"])(a0);

    Module["_dequeueTLSData"] = a0 => (Module["_dequeueTLSData"] = wasmExports["dequeueTLSData"])(a0);

    Module["_allocateTLSDataBuf"] = a0 => (Module["_allocateTLSDataBuf"] = wasmExports["allocateTLSDataBuf"])(a0);

    Module["_freeTLSDataBuf"] = a0 => (Module["_freeTLSDataBuf"] = wasmExports["freeTLSDataBuf"])(a0);

    Module["_enqueueTLSData"] = (a0, a1, a2) => (Module["_enqueueTLSData"] = wasmExports["enqueueTLSData"])(a0, a1, a2);

    Module["_peekTLSData"] = a0 => (Module["_peekTLSData"] = wasmExports["peekTLSData"])(a0);

    Module["_ssl_CTX_new"] = () => (Module["_ssl_CTX_new"] = wasmExports["ssl_CTX_new"])();

    Module["_ssl_CTX_add_private_key"] = (a0, a1) => (Module["_ssl_CTX_add_private_key"] = wasmExports["ssl_CTX_add_private_key"])(a0, a1);

    Module["_ssl_CTX_add_certificate"] = (a0, a1) => (Module["_ssl_CTX_add_certificate"] = wasmExports["ssl_CTX_add_certificate"])(a0, a1);

    Module["_ssl_CTX_add_extra_chain_cert"] = (a0, a1) => (Module["_ssl_CTX_add_extra_chain_cert"] = wasmExports["ssl_CTX_add_extra_chain_cert"])(a0, a1);

    Module["_ssl_CTX_add1_to_CA_list"] = (a0, a1) => (Module["_ssl_CTX_add1_to_CA_list"] = wasmExports["ssl_CTX_add1_to_CA_list"])(a0, a1);

    Module["_ssl_CTX_verify_certificate_and_key"] = a0 => (Module["_ssl_CTX_verify_certificate_and_key"] = wasmExports["ssl_CTX_verify_certificate_and_key"])(a0);

    Module["_ssl_new"] = a0 => (Module["_ssl_new"] = wasmExports["ssl_new"])(a0);

    Module["_bio_new_ssl_connect"] = a0 => (Module["_bio_new_ssl_connect"] = wasmExports["bio_new_ssl_connect"])(a0);

    Module["_bio_get_ssl"] = a0 => (Module["_bio_get_ssl"] = wasmExports["bio_get_ssl"])(a0);

    Module["_bio_set_conn_hostname"] = (a0, a1) => (Module["_bio_set_conn_hostname"] = wasmExports["bio_set_conn_hostname"])(a0, a1);

    Module["_bio_do_connect"] = a0 => (Module["_bio_do_connect"] = wasmExports["bio_do_connect"])(a0);

    Module["_ssl_do_handshake"] = a0 => (Module["_ssl_do_handshake"] = wasmExports["ssl_do_handshake"])(a0);

    Module["_ssl_get_verify_result"] = a0 => (Module["_ssl_get_verify_result"] = wasmExports["ssl_get_verify_result"])(a0);

    Module["_tls_write"] = (a0, a1, a2) => (Module["_tls_write"] = wasmExports["tls_write"])(a0, a1, a2);

    Module["_SSL_get_fd"] = a0 => (Module["_SSL_get_fd"] = wasmExports["SSL_get_fd"])(a0);

    Module["_tls_read"] = (a0, a1, a2) => (Module["_tls_read"] = wasmExports["tls_read"])(a0, a1, a2);

    Module["_ssl_set_fd"] = (a0, a1) => (Module["_ssl_set_fd"] = wasmExports["ssl_set_fd"])(a0, a1);

    Module["_ssl_connect"] = a0 => (Module["_ssl_connect"] = wasmExports["ssl_connect"])(a0);

    Module["_createBuffer"] = a0 => (Module["_createBuffer"] = wasmExports["createBuffer"])(a0);

    Module["_destroyBuffer"] = a0 => (Module["_destroyBuffer"] = wasmExports["destroyBuffer"])(a0);

    var _ntohs = a0 => (_ntohs = wasmExports["ntohs"])(a0);

    Module["_BIO_new_fp"] = (a0, a1) => (Module["_BIO_new_fp"] = wasmExports["BIO_new_fp"])(a0, a1);

    Module["_DSA_free"] = a0 => (Module["_DSA_free"] = wasmExports["DSA_free"])(a0);

    Module["_EVP_PKEY_CTX_free"] = a0 => (Module["_EVP_PKEY_CTX_free"] = wasmExports["EVP_PKEY_CTX_free"])(a0);

    Module["_EVP_PKEY_free"] = a0 => (Module["_EVP_PKEY_free"] = wasmExports["EVP_PKEY_free"])(a0);

    Module["_EVP_PKEY_get1_DSA"] = a0 => (Module["_EVP_PKEY_get1_DSA"] = wasmExports["EVP_PKEY_get1_DSA"])(a0);

    Module["_EVP_PKEY_paramgen_init"] = a0 => (Module["_EVP_PKEY_paramgen_init"] = wasmExports["EVP_PKEY_paramgen_init"])(a0);

    Module["_EVP_PKEY_paramgen"] = (a0, a1) => (Module["_EVP_PKEY_paramgen"] = wasmExports["EVP_PKEY_paramgen"])(a0, a1);

    Module["_OPENSSL_init"] = () => (Module["_OPENSSL_init"] = wasmExports["OPENSSL_init"])();

    Module["_PEM_write_bio_DSAPrivateKey"] = (a0, a1, a2, a3, a4, a5, a6) => (Module["_PEM_write_bio_DSAPrivateKey"] = wasmExports["PEM_write_bio_DSAPrivateKey"])(a0, a1, a2, a3, a4, a5, a6);

    Module["_RSA_new"] = () => (Module["_RSA_new"] = wasmExports["RSA_new"])();

    Module["_EVP_PKEY_CTX_set_rsa_keygen_bits"] = (a0, a1) => (Module["_EVP_PKEY_CTX_set_rsa_keygen_bits"] = wasmExports["EVP_PKEY_CTX_set_rsa_keygen_bits"])(a0, a1);

    Module["_SSL_is_init_finished"] = a0 => (Module["_SSL_is_init_finished"] = wasmExports["SSL_is_init_finished"])(a0);

    Module["__initialize"] = () => (Module["__initialize"] = wasmExports["_initialize"])();

    var _htonl = a0 => (_htonl = wasmExports["htonl"])(a0);

    var _htons = a0 => (_htons = wasmExports["htons"])(a0);

    var __emscripten_stack_restore = a0 => (__emscripten_stack_restore = wasmExports["_emscripten_stack_restore"])(a0);

    var __emscripten_stack_alloc = a0 => (__emscripten_stack_alloc = wasmExports["_emscripten_stack_alloc"])(a0);

    var _emscripten_stack_get_current = () => (_emscripten_stack_get_current = wasmExports["emscripten_stack_get_current"])();

    var _asyncify_start_unwind = a0 => (_asyncify_start_unwind = wasmExports["asyncify_start_unwind"])(a0);

    var _asyncify_stop_unwind = () => (_asyncify_stop_unwind = wasmExports["asyncify_stop_unwind"])();

    var _asyncify_start_rewind = a0 => (_asyncify_start_rewind = wasmExports["asyncify_start_rewind"])(a0);

    var _asyncify_stop_rewind = () => (_asyncify_stop_rewind = wasmExports["asyncify_stop_rewind"])();

    Module["_whichWASMstring"] = 1024;

    Module["ccall"] = ccall;
    Module["cwrap"] = cwrap;
    Module["addFunction"] = addFunction;
    Module["setValue"] = setValue;
    Module["getValue"] = getValue;
    Module["stringToUTF8"] = stringToUTF8;
    Module["lengthBytesUTF8"] = lengthBytesUTF8;
    var calledRun;

    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run();
      if (!calledRun) dependenciesFulfilled = runCaller;
    };

    function run(args = arguments_) {
      if (runDependencies > 0) {
        return;
      }

      preRun();

      if (runDependencies > 0) {
        return;
      }

      function doRun() {
        if (calledRun) return;
        calledRun = true;
        Module["calledRun"] = true;
        if (ABORT) return;
        initRuntime();
        preMain();
        readyPromiseResolve(Module);
        postRun();
      }

      {
        doRun();
      }
    }
    run();
    moduleRtn = readyPromise;
    return moduleRtn;
  };
})();

const AES_BLOCK_SIZE = 16,
      ASN1_R_ADDING_OBJECT = 171,
      ASN1_R_ASN1_PARSE_ERROR = 203,
      ASN1_R_ASN1_SIG_PARSE_ERROR = 204,
      ASN1_R_AUX_ERROR = 100,
      ASN1_R_BAD_OBJECT_HEADER = 102,
      ASN1_R_BAD_TEMPLATE = 230,
      ASN1_R_BMPSTRING_IS_WRONG_LENGTH = 214,
      ASN1_R_BN_LIB = 105,
      ASN1_R_BOOLEAN_IS_WRONG_LENGTH = 106,
      ASN1_R_BUFFER_TOO_SMALL = 107,
      ASN1_R_CIPHER_HAS_NO_OBJECT_IDENTIFIER = 108,
      ASN1_R_CONTEXT_NOT_INITIALISED = 217,
      ASN1_R_DATA_IS_WRONG = 109,
      ASN1_R_DECODE_ERROR = 110,
      ASN1_R_DEPTH_EXCEEDED = 174,
      ASN1_R_DIGEST_AND_KEY_TYPE_NOT_SUPPORTED = 198,
      ASN1_R_ENCODE_ERROR = 112,
      ASN1_R_ERROR_GETTING_TIME = 173,
      ASN1_R_ERROR_LOADING_SECTION = 172,
      ASN1_R_ERROR_SETTING_CIPHER_PARAMS = 114,
      ASN1_R_EXPECTING_AN_INTEGER = 115,
      ASN1_R_EXPECTING_AN_OBJECT = 116,
      ASN1_R_EXPLICIT_LENGTH_MISMATCH = 119,
      ASN1_R_EXPLICIT_TAG_NOT_CONSTRUCTED = 120,
      ASN1_R_FIELD_MISSING = 121,
      ASN1_R_FIRST_NUM_TOO_LARGE = 122,
      ASN1_R_HEADER_TOO_LONG = 123,
      ASN1_R_ILLEGAL_BITSTRING_FORMAT = 175,
      ASN1_R_ILLEGAL_BOOLEAN = 176,
      ASN1_R_ILLEGAL_CHARACTERS = 124,
      ASN1_R_ILLEGAL_FORMAT = 177,
      ASN1_R_ILLEGAL_HEX = 178,
      ASN1_R_ILLEGAL_IMPLICIT_TAG = 179,
      ASN1_R_ILLEGAL_INTEGER = 180,
      ASN1_R_ILLEGAL_NEGATIVE_VALUE = 226,
      ASN1_R_ILLEGAL_NESTED_TAGGING = 181,
      ASN1_R_ILLEGAL_NULL = 125,
      ASN1_R_ILLEGAL_NULL_VALUE = 182,
      ASN1_R_ILLEGAL_OBJECT = 183,
      ASN1_R_ILLEGAL_OPTIONAL_ANY = 126,
      ASN1_R_ILLEGAL_OPTIONS_ON_ITEM_TEMPLATE = 170,
      ASN1_R_ILLEGAL_PADDING = 221,
      ASN1_R_ILLEGAL_TAGGED_ANY = 127,
      ASN1_R_ILLEGAL_TIME_VALUE = 184,
      ASN1_R_ILLEGAL_ZERO_CONTENT = 222,
      ASN1_R_INTEGER_NOT_ASCII_FORMAT = 185,
      ASN1_R_INTEGER_TOO_LARGE_FOR_LONG = 128,
      ASN1_R_INVALID_BIT_STRING_BITS_LEFT = 220,
      ASN1_R_INVALID_BMPSTRING_LENGTH = 129,
      ASN1_R_INVALID_DIGIT = 130,
      ASN1_R_INVALID_MIME_TYPE = 205,
      ASN1_R_INVALID_MODIFIER = 186,
      ASN1_R_INVALID_NUMBER = 187,
      ASN1_R_INVALID_OBJECT_ENCODING = 216,
      ASN1_R_INVALID_SCRYPT_PARAMETERS = 227,
      ASN1_R_INVALID_SEPARATOR = 131,
      ASN1_R_INVALID_STRING_TABLE_VALUE = 218,
      ASN1_R_INVALID_UNIVERSALSTRING_LENGTH = 133,
      ASN1_R_INVALID_UTF8STRING = 134,
      ASN1_R_INVALID_VALUE = 219,
      ASN1_R_LENGTH_TOO_LONG = 231,
      ASN1_R_LIST_ERROR = 188,
      ASN1_R_MIME_NO_CONTENT_TYPE = 206,
      ASN1_R_MIME_PARSE_ERROR = 207,
      ASN1_R_MIME_SIG_PARSE_ERROR = 208,
      ASN1_R_MISSING_EOC = 137,
      ASN1_R_MISSING_SECOND_NUMBER = 138,
      ASN1_R_MISSING_VALUE = 189,
      ASN1_R_MSTRING_NOT_UNIVERSAL = 139,
      ASN1_R_MSTRING_WRONG_TAG = 140,
      ASN1_R_NESTED_ASN1_STRING = 197,
      ASN1_R_NESTED_TOO_DEEP = 201,
      ASN1_R_NON_HEX_CHARACTERS = 141,
      ASN1_R_NOT_ASCII_FORMAT = 190,
      ASN1_R_NOT_ENOUGH_DATA = 142,
      ASN1_R_NO_CONTENT_TYPE = 209,
      ASN1_R_NO_MATCHING_CHOICE_TYPE = 143,
      ASN1_R_NO_MULTIPART_BODY_FAILURE = 210,
      ASN1_R_NO_MULTIPART_BOUNDARY = 211,
      ASN1_R_NO_SIG_CONTENT_TYPE = 212,
      ASN1_R_NULL_IS_WRONG_LENGTH = 144,
      ASN1_R_OBJECT_NOT_ASCII_FORMAT = 191,
      ASN1_R_ODD_NUMBER_OF_CHARS = 145,
      ASN1_R_SECOND_NUMBER_TOO_LARGE = 147,
      ASN1_R_SEQUENCE_LENGTH_MISMATCH = 148,
      ASN1_R_SEQUENCE_NOT_CONSTRUCTED = 149,
      ASN1_R_SEQUENCE_OR_SET_NEEDS_CONFIG = 192,
      ASN1_R_SHORT_LINE = 150,
      ASN1_R_SIG_INVALID_MIME_TYPE = 213,
      ASN1_R_STREAMING_NOT_SUPPORTED = 202,
      ASN1_R_STRING_TOO_LONG = 151,
      ASN1_R_STRING_TOO_SHORT = 152,
      ASN1_R_THE_ASN1_OBJECT_IDENTIFIER_IS_NOT_KNOWN_FOR_THIS_MD = 154,
      ASN1_R_TIME_NOT_ASCII_FORMAT = 193,
      ASN1_R_TOO_LARGE = 223,
      ASN1_R_TOO_LONG = 155,
      ASN1_R_TOO_SMALL = 224,
      ASN1_R_TYPE_NOT_CONSTRUCTED = 156,
      ASN1_R_TYPE_NOT_PRIMITIVE = 195,
      ASN1_R_UNEXPECTED_EOC = 159,
      ASN1_R_UNIVERSALSTRING_IS_WRONG_LENGTH = 215,
      ASN1_R_UNKNOWN_DIGEST = 229,
      ASN1_R_UNKNOWN_FORMAT = 160,
      ASN1_R_UNKNOWN_MESSAGE_DIGEST_ALGORITHM = 161,
      ASN1_R_UNKNOWN_OBJECT_TYPE = 162,
      ASN1_R_UNKNOWN_PUBLIC_KEY_TYPE = 163,
      ASN1_R_UNKNOWN_SIGNATURE_ALGORITHM = 199,
      ASN1_R_UNKNOWN_TAG = 194,
      ASN1_R_UNSUPPORTED_ANY_DEFINED_BY_TYPE = 164,
      ASN1_R_UNSUPPORTED_CIPHER = 228,
      ASN1_R_UNSUPPORTED_PUBLIC_KEY_TYPE = 167,
      ASN1_R_UNSUPPORTED_TYPE = 196,
      ASN1_R_WRONG_INTEGER_TYPE = 225,
      ASN1_R_WRONG_PUBLIC_KEY_TYPE = 200,
      ASN1_R_WRONG_TAG = 168,
      OSSL_ASYNC_FD = "HANDLE",
      OSSL_BAD_ASYNC_FD = "INVALID_HANDLE_VALUE",
      ASYNC_ERR = "0",
      ASYNC_NO_JOBS = 1,
      ASYNC_PAUSE = 2,
      ASYNC_FINISH = 3,
      ASYNC_STATUS_UNSUPPORTED = "0",
      ASYNC_STATUS_ERR = 1,
      ASYNC_STATUS_OK = 2,
      ASYNC_STATUS_EAGAIN = 3,
      ASYNC_R_FAILED_TO_SET_POOL = 101,
      ASYNC_R_FAILED_TO_SWAP_CONTEXT = 102,
      ASYNC_R_INIT_FAILED = 105,
      ASYNC_R_INVALID_POOL_SIZE = 103,
      BIO_R_ACCEPT_ERROR = 100,
      BIO_R_ADDRINFO_ADDR_IS_NOT_AF_INET = 141,
      BIO_R_AMBIGUOUS_HOST_OR_SERVICE = 129,
      BIO_R_BAD_FOPEN_MODE = 101,
      BIO_R_BROKEN_PIPE = 124,
      BIO_R_CONNECT_ERROR = 103,
      BIO_R_CONNECT_TIMEOUT = 147,
      BIO_R_GETHOSTBYNAME_ADDR_IS_NOT_AF_INET = 107,
      BIO_R_GETSOCKNAME_ERROR = 132,
      BIO_R_GETSOCKNAME_TRUNCATED_ADDRESS = 133,
      BIO_R_GETTING_SOCKTYPE = 134,
      BIO_R_INVALID_ARGUMENT = 125,
      BIO_R_INVALID_SOCKET = 135,
      BIO_R_IN_USE = 123,
      BIO_R_LENGTH_TOO_LONG = 102,
      BIO_R_LISTEN_V6_ONLY = 136,
      BIO_R_LOOKUP_RETURNED_NOTHING = 142,
      BIO_R_MALFORMED_HOST_OR_SERVICE = 130,
      BIO_R_NBIO_CONNECT_ERROR = 110,
      BIO_R_NO_ACCEPT_ADDR_OR_SERVICE_SPECIFIED = 143,
      BIO_R_NO_HOSTNAME_OR_SERVICE_SPECIFIED = 144,
      BIO_R_NO_PORT_DEFINED = 113,
      BIO_R_NO_SUCH_FILE = 128,
      BIO_R_NULL_PARAMETER = 115,
      BIO_R_TRANSFER_ERROR = 104,
      BIO_R_TRANSFER_TIMEOUT = 105,
      BIO_R_UNABLE_TO_BIND_SOCKET = 117,
      BIO_R_UNABLE_TO_CREATE_SOCKET = 118,
      BIO_R_UNABLE_TO_KEEPALIVE = 137,
      BIO_R_UNABLE_TO_LISTEN_SOCKET = 119,
      BIO_R_UNABLE_TO_NODELAY = 138,
      BIO_R_UNABLE_TO_REUSEADDR = 139,
      BIO_R_UNAVAILABLE_IP_FAMILY = 145,
      BIO_R_UNINITIALIZED = 120,
      BIO_R_UNKNOWN_INFO_TYPE = 140,
      BIO_R_UNSUPPORTED_IP_FAMILY = 146,
      BIO_R_UNSUPPORTED_METHOD = 121,
      BIO_R_UNSUPPORTED_PROTOCOL_FAMILY = 131,
      BIO_R_WRITE_TO_READ_ONLY_BIO = 126,
      BIO_R_WSASTARTUP = 122,
      BF_BLOCK = 8,
      BN_FLG_MALLOCED = "0x01",
      BN_FLG_STATIC_DATA = "0x02",
      BN_FLG_CONSTTIME = "0x04",
      BN_FLG_SECURE = "0x08",
      BN_RAND_TOP_ANY = -1,
      BN_RAND_TOP_ONE = "0",
      BN_RAND_TOP_TWO = 1,
      BN_RAND_BOTTOM_ANY = "0",
      BN_RAND_BOTTOM_ODD = 1,
      BN_BLINDING_NO_UPDATE = "0x00000001",
      BN_BLINDING_NO_RECREATE = "0x00000002",
      BN_R_ARG2_LT_ARG3 = 100,
      BN_R_BAD_RECIPROCAL = 101,
      BN_R_BIGNUM_TOO_LONG = 114,
      BN_R_BITS_TOO_SMALL = 118,
      BN_R_CALLED_WITH_EVEN_MODULUS = 102,
      BN_R_DIV_BY_ZERO = 103,
      BN_R_ENCODING_ERROR = 104,
      BN_R_EXPAND_ON_STATIC_BIGNUM_DATA = 105,
      BN_R_INPUT_NOT_REDUCED = 110,
      BN_R_INVALID_LENGTH = 106,
      BN_R_INVALID_RANGE = 115,
      BN_R_INVALID_SHIFT = 119,
      BN_R_NOT_A_SQUARE = 111,
      BN_R_NOT_INITIALIZED = 107,
      BN_R_NO_INVERSE = 108,
      BN_R_NO_SOLUTION = 116,
      BN_R_NO_SUITABLE_DIGEST = 120,
      BN_R_PRIVATE_KEY_TOO_LARGE = 117,
      BN_R_P_IS_NOT_PRIME = 112,
      BN_R_TOO_MANY_ITERATIONS = 113,
      BN_R_TOO_MANY_TEMPORARY_VARIABLES = 109,
      BUF_MEM_FLAG_SECURE = "0x01",
      CAMELLIA_BLOCK_SIZE = 16,
      CAST_BLOCK = 8,
      CAST_KEY_LENGTH = 16,
      CONF_R_ERROR_LOADING_DSO = 110,
      CONF_R_INVALID_PRAGMA = 122,
      CONF_R_LIST_CANNOT_BE_NULL = 115,
      CONF_R_MANDATORY_BRACES_IN_VARIABLE_EXPANSION = 123,
      CONF_R_MISSING_CLOSE_SQUARE_BRACKET = 100,
      CONF_R_MISSING_EQUAL_SIGN = 101,
      CONF_R_MISSING_INIT_FUNCTION = 112,
      CONF_R_MODULE_INITIALIZATION_ERROR = 109,
      CONF_R_NO_CLOSE_BRACE = 102,
      CONF_R_NO_CONF = 105,
      CONF_R_NO_CONF_OR_ENVIRONMENT_VARIABLE = 106,
      CONF_R_NO_SECTION = 107,
      CONF_R_NO_SUCH_FILE = 114,
      CONF_R_NO_VALUE = 108,
      CONF_R_NUMBER_TOO_LARGE = 121,
      CONF_R_OPENSSL_CONF_REFERENCES_MISSING_SECTION = 124,
      CONF_R_RECURSIVE_DIRECTORY_INCLUDE = 111,
      CONF_R_RELATIVE_PATH = 125,
      CONF_R_SSL_COMMAND_SECTION_EMPTY = 117,
      CONF_R_SSL_COMMAND_SECTION_NOT_FOUND = 118,
      CONF_R_SSL_SECTION_EMPTY = 119,
      CONF_R_SSL_SECTION_NOT_FOUND = 120,
      CONF_R_UNABLE_TO_CREATE_NEW_SECTION = 103,
      CONF_R_UNKNOWN_MODULE_NAME = 113,
      CONF_R_VARIABLE_EXPANSION_TOO_LONG = 116,
      CONF_R_VARIABLE_HAS_NO_VALUE = 104,
      OSSL_PARAM_INTEGER = 1,
      OSSL_PARAM_UNSIGNED_INTEGER = 2,
      OSSL_PARAM_REAL = 3,
      OSSL_PARAM_UTF8_STRING = 4,
      OSSL_PARAM_OCTET_STRING = 5,
      OSSL_PARAM_UTF8_PTR = 6,
      OSSL_PARAM_OCTET_PTR = 7,
      OSSL_FUNC_CORE_GETTABLE_PARAMS = 1,
      OSSL_FUNC_CORE_GET_PARAMS = 2,
      OSSL_FUNC_CORE_THREAD_START = 3,
      OSSL_FUNC_CORE_GET_LIBCTX = 4,
      OSSL_FUNC_CORE_NEW_ERROR = 5,
      OSSL_FUNC_CORE_SET_ERROR_DEBUG = 6,
      OSSL_FUNC_CORE_VSET_ERROR = 7,
      OSSL_FUNC_CORE_SET_ERROR_MARK = 8,
      OSSL_FUNC_CORE_CLEAR_LAST_ERROR_MARK = 9,
      OSSL_FUNC_CORE_POP_ERROR_TO_MARK = 10,
      OSSL_FUNC_CORE_OBJ_ADD_SIGID = 11,
      OSSL_FUNC_CORE_OBJ_CREATE = 12,
      OSSL_FUNC_CRYPTO_MALLOC = 20,
      OSSL_FUNC_CRYPTO_ZALLOC = 21,
      OSSL_FUNC_CRYPTO_FREE = 22,
      OSSL_FUNC_CRYPTO_CLEAR_FREE = 23,
      OSSL_FUNC_CRYPTO_REALLOC = 24,
      OSSL_FUNC_CRYPTO_CLEAR_REALLOC = 25,
      OSSL_FUNC_CRYPTO_SECURE_MALLOC = 26,
      OSSL_FUNC_CRYPTO_SECURE_ZALLOC = 27,
      OSSL_FUNC_CRYPTO_SECURE_FREE = 28,
      OSSL_FUNC_CRYPTO_SECURE_CLEAR_FREE = 29,
      OSSL_FUNC_CRYPTO_SECURE_ALLOCATED = 30,
      OSSL_FUNC_OPENSSL_CLEANSE = 31,
      OSSL_FUNC_BIO_NEW_FILE = 40,
      OSSL_FUNC_BIO_NEW_MEMBUF = 41,
      OSSL_FUNC_BIO_READ_EX = 42,
      OSSL_FUNC_BIO_WRITE_EX = 43,
      OSSL_FUNC_BIO_UP_REF = 44,
      OSSL_FUNC_BIO_FREE = 45,
      OSSL_FUNC_BIO_VPRINTF = 46,
      OSSL_FUNC_BIO_VSNPRINTF = 47,
      OSSL_FUNC_BIO_PUTS = 48,
      OSSL_FUNC_BIO_GETS = 49,
      OSSL_FUNC_BIO_CTRL = 50,
      OSSL_FUNC_SELF_TEST_CB = 100,
      OSSL_FUNC_GET_ENTROPY = 101,
      OSSL_FUNC_CLEANUP_ENTROPY = 102,
      OSSL_FUNC_GET_NONCE = 103,
      OSSL_FUNC_CLEANUP_NONCE = 104,
      OSSL_FUNC_PROVIDER_REGISTER_CHILD_CB = 105,
      OSSL_FUNC_PROVIDER_DEREGISTER_CHILD_CB = 106,
      OSSL_FUNC_PROVIDER_NAME = 107,
      OSSL_FUNC_PROVIDER_GET0_PROVIDER_CTX = 108,
      OSSL_FUNC_PROVIDER_GET0_DISPATCH = 109,
      OSSL_FUNC_PROVIDER_UP_REF = 110,
      OSSL_FUNC_PROVIDER_FREE = 111,
      OSSL_FUNC_PROVIDER_TEARDOWN = 1024,
      OSSL_FUNC_PROVIDER_GETTABLE_PARAMS = 1025,
      OSSL_FUNC_PROVIDER_GET_PARAMS = 1026,
      OSSL_FUNC_PROVIDER_QUERY_OPERATION = 1027,
      OSSL_FUNC_PROVIDER_UNQUERY_OPERATION = 1028,
      OSSL_FUNC_PROVIDER_GET_REASON_STRINGS = 1029,
      OSSL_FUNC_PROVIDER_GET_CAPABILITIES = 1030,
      OSSL_FUNC_PROVIDER_SELF_TEST = 1031,
      OSSL_OP_DIGEST = 1,
      OSSL_OP_CIPHER = 2,
      OSSL_OP_MAC = 3,
      OSSL_OP_KDF = 4,
      OSSL_OP_RAND = 5,
      OSSL_OP_KEYMGMT = 10,
      OSSL_OP_KEYEXCH = 11,
      OSSL_OP_SIGNATURE = 12,
      OSSL_OP_ASYM_CIPHER = 13,
      OSSL_OP_KEM = 14,
      OSSL_OP_ENCODER = 20,
      OSSL_OP_DECODER = 21,
      OSSL_OP_STORE = 22,
      OSSL_OP__HIGHEST = 22,
      OSSL_FUNC_DIGEST_NEWCTX = 1,
      OSSL_FUNC_DIGEST_INIT = 2,
      OSSL_FUNC_DIGEST_UPDATE = 3,
      OSSL_FUNC_DIGEST_FINAL = 4,
      OSSL_FUNC_DIGEST_DIGEST = 5,
      OSSL_FUNC_DIGEST_FREECTX = 6,
      OSSL_FUNC_DIGEST_DUPCTX = 7,
      OSSL_FUNC_DIGEST_GET_PARAMS = 8,
      OSSL_FUNC_DIGEST_SET_CTX_PARAMS = 9,
      OSSL_FUNC_DIGEST_GET_CTX_PARAMS = 10,
      OSSL_FUNC_DIGEST_GETTABLE_PARAMS = 11,
      OSSL_FUNC_DIGEST_SETTABLE_CTX_PARAMS = 12,
      OSSL_FUNC_DIGEST_GETTABLE_CTX_PARAMS = 13,
      OSSL_FUNC_CIPHER_NEWCTX = 1,
      OSSL_FUNC_CIPHER_ENCRYPT_INIT = 2,
      OSSL_FUNC_CIPHER_DECRYPT_INIT = 3,
      OSSL_FUNC_CIPHER_UPDATE = 4,
      OSSL_FUNC_CIPHER_FINAL = 5,
      OSSL_FUNC_CIPHER_CIPHER = 6,
      OSSL_FUNC_CIPHER_FREECTX = 7,
      OSSL_FUNC_CIPHER_DUPCTX = 8,
      OSSL_FUNC_CIPHER_GET_PARAMS = 9,
      OSSL_FUNC_CIPHER_GET_CTX_PARAMS = 10,
      OSSL_FUNC_CIPHER_SET_CTX_PARAMS = 11,
      OSSL_FUNC_CIPHER_GETTABLE_PARAMS = 12,
      OSSL_FUNC_CIPHER_GETTABLE_CTX_PARAMS = 13,
      OSSL_FUNC_CIPHER_SETTABLE_CTX_PARAMS = 14,
      OSSL_FUNC_MAC_NEWCTX = 1,
      OSSL_FUNC_MAC_DUPCTX = 2,
      OSSL_FUNC_MAC_FREECTX = 3,
      OSSL_FUNC_MAC_INIT = 4,
      OSSL_FUNC_MAC_UPDATE = 5,
      OSSL_FUNC_MAC_FINAL = 6,
      OSSL_FUNC_MAC_GET_PARAMS = 7,
      OSSL_FUNC_MAC_GET_CTX_PARAMS = 8,
      OSSL_FUNC_MAC_SET_CTX_PARAMS = 9,
      OSSL_FUNC_MAC_GETTABLE_PARAMS = 10,
      OSSL_FUNC_MAC_GETTABLE_CTX_PARAMS = 11,
      OSSL_FUNC_MAC_SETTABLE_CTX_PARAMS = 12,
      OSSL_FUNC_KDF_NEWCTX = 1,
      OSSL_FUNC_KDF_DUPCTX = 2,
      OSSL_FUNC_KDF_FREECTX = 3,
      OSSL_FUNC_KDF_RESET = 4,
      OSSL_FUNC_KDF_DERIVE = 5,
      OSSL_FUNC_KDF_GETTABLE_PARAMS = 6,
      OSSL_FUNC_KDF_GETTABLE_CTX_PARAMS = 7,
      OSSL_FUNC_KDF_SETTABLE_CTX_PARAMS = 8,
      OSSL_FUNC_KDF_GET_PARAMS = 9,
      OSSL_FUNC_KDF_GET_CTX_PARAMS = 10,
      OSSL_FUNC_KDF_SET_CTX_PARAMS = 11,
      OSSL_FUNC_RAND_NEWCTX = 1,
      OSSL_FUNC_RAND_FREECTX = 2,
      OSSL_FUNC_RAND_INSTANTIATE = 3,
      OSSL_FUNC_RAND_UNINSTANTIATE = 4,
      OSSL_FUNC_RAND_GENERATE = 5,
      OSSL_FUNC_RAND_RESEED = 6,
      OSSL_FUNC_RAND_NONCE = 7,
      OSSL_FUNC_RAND_ENABLE_LOCKING = 8,
      OSSL_FUNC_RAND_LOCK = 9,
      OSSL_FUNC_RAND_UNLOCK = 10,
      OSSL_FUNC_RAND_GETTABLE_PARAMS = 11,
      OSSL_FUNC_RAND_GETTABLE_CTX_PARAMS = 12,
      OSSL_FUNC_RAND_SETTABLE_CTX_PARAMS = 13,
      OSSL_FUNC_RAND_GET_PARAMS = 14,
      OSSL_FUNC_RAND_GET_CTX_PARAMS = 15,
      OSSL_FUNC_RAND_SET_CTX_PARAMS = 16,
      OSSL_FUNC_RAND_VERIFY_ZEROIZATION = 17,
      OSSL_FUNC_RAND_GET_SEED = 18,
      OSSL_FUNC_RAND_CLEAR_SEED = 19,
      OSSL_KEYMGMT_SELECT_PRIVATE_KEY = "0x01",
      OSSL_KEYMGMT_SELECT_PUBLIC_KEY = "0x02",
      OSSL_KEYMGMT_SELECT_DOMAIN_PARAMETERS = "0x04",
      OSSL_KEYMGMT_SELECT_OTHER_PARAMETERS = "0x80",
      OSSL_KEYMGMT_VALIDATE_FULL_CHECK = "0",
      OSSL_KEYMGMT_VALIDATE_QUICK_CHECK = 1,
      OSSL_FUNC_KEYMGMT_NEW = 1,
      OSSL_FUNC_KEYMGMT_GEN_INIT = 2,
      OSSL_FUNC_KEYMGMT_GEN_SET_TEMPLATE = 3,
      OSSL_FUNC_KEYMGMT_GEN_SET_PARAMS = 4,
      OSSL_FUNC_KEYMGMT_GEN_SETTABLE_PARAMS = 5,
      OSSL_FUNC_KEYMGMT_GEN = 6,
      OSSL_FUNC_KEYMGMT_GEN_CLEANUP = 7,
      OSSL_FUNC_KEYMGMT_LOAD = 8,
      OSSL_FUNC_KEYMGMT_FREE = 10,
      OSSL_FUNC_KEYMGMT_GET_PARAMS = 11,
      OSSL_FUNC_KEYMGMT_GETTABLE_PARAMS = 12,
      OSSL_FUNC_KEYMGMT_SET_PARAMS = 13,
      OSSL_FUNC_KEYMGMT_SETTABLE_PARAMS = 14,
      OSSL_FUNC_KEYMGMT_QUERY_OPERATION_NAME = 20,
      OSSL_FUNC_KEYMGMT_HAS = 21,
      OSSL_FUNC_KEYMGMT_VALIDATE = 22,
      OSSL_FUNC_KEYMGMT_MATCH = 23,
      OSSL_FUNC_KEYMGMT_IMPORT = 40,
      OSSL_FUNC_KEYMGMT_IMPORT_TYPES = 41,
      OSSL_FUNC_KEYMGMT_EXPORT = 42,
      OSSL_FUNC_KEYMGMT_EXPORT_TYPES = 43,
      OSSL_FUNC_KEYMGMT_DUP = 44,
      OSSL_FUNC_KEYEXCH_NEWCTX = 1,
      OSSL_FUNC_KEYEXCH_INIT = 2,
      OSSL_FUNC_KEYEXCH_DERIVE = 3,
      OSSL_FUNC_KEYEXCH_SET_PEER = 4,
      OSSL_FUNC_KEYEXCH_FREECTX = 5,
      OSSL_FUNC_KEYEXCH_DUPCTX = 6,
      OSSL_FUNC_KEYEXCH_SET_CTX_PARAMS = 7,
      OSSL_FUNC_KEYEXCH_SETTABLE_CTX_PARAMS = 8,
      OSSL_FUNC_KEYEXCH_GET_CTX_PARAMS = 9,
      OSSL_FUNC_KEYEXCH_GETTABLE_CTX_PARAMS = 10,
      OSSL_FUNC_SIGNATURE_NEWCTX = 1,
      OSSL_FUNC_SIGNATURE_SIGN_INIT = 2,
      OSSL_FUNC_SIGNATURE_SIGN = 3,
      OSSL_FUNC_SIGNATURE_VERIFY_INIT = 4,
      OSSL_FUNC_SIGNATURE_VERIFY = 5,
      OSSL_FUNC_SIGNATURE_VERIFY_RECOVER_INIT = 6,
      OSSL_FUNC_SIGNATURE_VERIFY_RECOVER = 7,
      OSSL_FUNC_SIGNATURE_DIGEST_SIGN_INIT = 8,
      OSSL_FUNC_SIGNATURE_DIGEST_SIGN_UPDATE = 9,
      OSSL_FUNC_SIGNATURE_DIGEST_SIGN_FINAL = 10,
      OSSL_FUNC_SIGNATURE_DIGEST_SIGN = 11,
      OSSL_FUNC_SIGNATURE_DIGEST_VERIFY_INIT = 12,
      OSSL_FUNC_SIGNATURE_DIGEST_VERIFY_UPDATE = 13,
      OSSL_FUNC_SIGNATURE_DIGEST_VERIFY_FINAL = 14,
      OSSL_FUNC_SIGNATURE_DIGEST_VERIFY = 15,
      OSSL_FUNC_SIGNATURE_FREECTX = 16,
      OSSL_FUNC_SIGNATURE_DUPCTX = 17,
      OSSL_FUNC_SIGNATURE_GET_CTX_PARAMS = 18,
      OSSL_FUNC_SIGNATURE_GETTABLE_CTX_PARAMS = 19,
      OSSL_FUNC_SIGNATURE_SET_CTX_PARAMS = 20,
      OSSL_FUNC_SIGNATURE_SETTABLE_CTX_PARAMS = 21,
      OSSL_FUNC_SIGNATURE_GET_CTX_MD_PARAMS = 22,
      OSSL_FUNC_SIGNATURE_GETTABLE_CTX_MD_PARAMS = 23,
      OSSL_FUNC_SIGNATURE_SET_CTX_MD_PARAMS = 24,
      OSSL_FUNC_SIGNATURE_SETTABLE_CTX_MD_PARAMS = 25,
      OSSL_FUNC_ASYM_CIPHER_NEWCTX = 1,
      OSSL_FUNC_ASYM_CIPHER_ENCRYPT_INIT = 2,
      OSSL_FUNC_ASYM_CIPHER_ENCRYPT = 3,
      OSSL_FUNC_ASYM_CIPHER_DECRYPT_INIT = 4,
      OSSL_FUNC_ASYM_CIPHER_DECRYPT = 5,
      OSSL_FUNC_ASYM_CIPHER_FREECTX = 6,
      OSSL_FUNC_ASYM_CIPHER_DUPCTX = 7,
      OSSL_FUNC_ASYM_CIPHER_GET_CTX_PARAMS = 8,
      OSSL_FUNC_ASYM_CIPHER_GETTABLE_CTX_PARAMS = 9,
      OSSL_FUNC_ASYM_CIPHER_SET_CTX_PARAMS = 10,
      OSSL_FUNC_ASYM_CIPHER_SETTABLE_CTX_PARAMS = 11,
      OSSL_FUNC_KEM_NEWCTX = 1,
      OSSL_FUNC_KEM_ENCAPSULATE_INIT = 2,
      OSSL_FUNC_KEM_ENCAPSULATE = 3,
      OSSL_FUNC_KEM_DECAPSULATE_INIT = 4,
      OSSL_FUNC_KEM_DECAPSULATE = 5,
      OSSL_FUNC_KEM_FREECTX = 6,
      OSSL_FUNC_KEM_DUPCTX = 7,
      OSSL_FUNC_KEM_GET_CTX_PARAMS = 8,
      OSSL_FUNC_KEM_GETTABLE_CTX_PARAMS = 9,
      OSSL_FUNC_KEM_SET_CTX_PARAMS = 10,
      OSSL_FUNC_KEM_SETTABLE_CTX_PARAMS = 11,
      OSSL_FUNC_ENCODER_NEWCTX = 1,
      OSSL_FUNC_ENCODER_FREECTX = 2,
      OSSL_FUNC_ENCODER_GET_PARAMS = 3,
      OSSL_FUNC_ENCODER_GETTABLE_PARAMS = 4,
      OSSL_FUNC_ENCODER_SET_CTX_PARAMS = 5,
      OSSL_FUNC_ENCODER_SETTABLE_CTX_PARAMS = 6,
      OSSL_FUNC_ENCODER_DOES_SELECTION = 10,
      OSSL_FUNC_ENCODER_ENCODE = 11,
      OSSL_FUNC_ENCODER_IMPORT_OBJECT = 20,
      OSSL_FUNC_ENCODER_FREE_OBJECT = 21,
      OSSL_FUNC_DECODER_NEWCTX = 1,
      OSSL_FUNC_DECODER_FREECTX = 2,
      OSSL_FUNC_DECODER_GET_PARAMS = 3,
      OSSL_FUNC_DECODER_GETTABLE_PARAMS = 4,
      OSSL_FUNC_DECODER_SET_CTX_PARAMS = 5,
      OSSL_FUNC_DECODER_SETTABLE_CTX_PARAMS = 6,
      OSSL_FUNC_DECODER_DOES_SELECTION = 10,
      OSSL_FUNC_DECODER_DECODE = 11,
      OSSL_FUNC_DECODER_EXPORT_OBJECT = 20,
      OSSL_FUNC_STORE_OPEN = 1,
      OSSL_FUNC_STORE_ATTACH = 2,
      OSSL_FUNC_STORE_SETTABLE_CTX_PARAMS = 3,
      OSSL_FUNC_STORE_SET_CTX_PARAMS = 4,
      OSSL_FUNC_STORE_LOAD = 5,
      OSSL_FUNC_STORE_EOF = 6,
      OSSL_FUNC_STORE_CLOSE = 7,
      OSSL_FUNC_STORE_EXPORT_OBJECT = 8,
      OSSL_PROV_PARAM_CORE_VERSION = "openssl-version",
      OSSL_PROV_PARAM_CORE_PROV_NAME = "provider-name",
      OSSL_PROV_PARAM_CORE_MODULE_FILENAME = "module-filename",
      OSSL_PROV_PARAM_NAME = "name",
      OSSL_PROV_PARAM_VERSION = "version",
      OSSL_PROV_PARAM_BUILDINFO = "buildinfo",
      OSSL_PROV_PARAM_STATUS = "status",
      OSSL_PROV_PARAM_SECURITY_CHECKS = "security-checks",
      OSSL_PROV_PARAM_SELF_TEST_PHASE = "st-phase",
      OSSL_PROV_PARAM_SELF_TEST_TYPE = "st-type",
      OSSL_PROV_PARAM_SELF_TEST_DESC = "st-desc",
      OSSL_OBJECT_PARAM_TYPE = "type",
      OSSL_OBJECT_PARAM_DATA_TYPE = "data-type",
      OSSL_OBJECT_PARAM_DATA_STRUCTURE = "data-structure",
      OSSL_OBJECT_PARAM_REFERENCE = "reference",
      OSSL_OBJECT_PARAM_DATA = "data",
      OSSL_OBJECT_PARAM_DESC = "desc",
      OSSL_ALG_PARAM_DIGEST = "digest",
      OSSL_ALG_PARAM_CIPHER = "cipher",
      OSSL_ALG_PARAM_ENGINE = "engine",
      OSSL_ALG_PARAM_MAC = "mac",
      OSSL_CIPHER_PARAM_PADDING = "padding",
      OSSL_CIPHER_PARAM_USE_BITS = "use-bits",
      OSSL_CIPHER_PARAM_TLS_VERSION = "tls-version",
      OSSL_CIPHER_PARAM_TLS_MAC = "tls-mac",
      OSSL_CIPHER_PARAM_TLS_MAC_SIZE = "tls-mac-size",
      OSSL_CIPHER_PARAM_MODE = "mode",
      OSSL_CIPHER_PARAM_BLOCK_SIZE = "blocksize",
      OSSL_CIPHER_PARAM_AEAD = "aead",
      OSSL_CIPHER_PARAM_CUSTOM_IV = "custom-iv",
      OSSL_CIPHER_PARAM_CTS = "cts",
      OSSL_CIPHER_PARAM_TLS1_MULTIBLOCK = "tls-multi",
      OSSL_CIPHER_PARAM_HAS_RAND_KEY = "has-randkey",
      OSSL_CIPHER_PARAM_KEYLEN = "keylen",
      OSSL_CIPHER_PARAM_IVLEN = "ivlen",
      OSSL_CIPHER_PARAM_IV = "iv",
      OSSL_CIPHER_PARAM_UPDATED_IV = "updated-iv",
      OSSL_CIPHER_PARAM_NUM = "num",
      OSSL_CIPHER_PARAM_ROUNDS = "rounds",
      OSSL_CIPHER_PARAM_AEAD_TAG = "tag",
      OSSL_CIPHER_PARAM_AEAD_TLS1_AAD = "tlsaad",
      OSSL_CIPHER_PARAM_AEAD_TLS1_AAD_PAD = "tlsaadpad",
      OSSL_CIPHER_PARAM_AEAD_TLS1_IV_FIXED = "tlsivfixed",
      OSSL_CIPHER_PARAM_AEAD_TLS1_GET_IV_GEN = "tlsivgen",
      OSSL_CIPHER_PARAM_AEAD_TLS1_SET_IV_INV = "tlsivinv",
      OSSL_CIPHER_PARAM_AEAD_IVLEN = "ivlen",
      OSSL_CIPHER_PARAM_AEAD_TAGLEN = "taglen",
      OSSL_CIPHER_PARAM_AEAD_MAC_KEY = "mackey",
      OSSL_CIPHER_PARAM_RANDOM_KEY = "randkey",
      OSSL_CIPHER_PARAM_RC2_KEYBITS = "keybits",
      OSSL_CIPHER_PARAM_SPEED = "speed",
      OSSL_CIPHER_PARAM_CTS_MODE = "cts_mode",
      OSSL_CIPHER_PARAM_ALGORITHM_ID_PARAMS = "alg_id_param",
      OSSL_CIPHER_CTS_MODE_CS1 = "CS1",
      OSSL_CIPHER_CTS_MODE_CS2 = "CS2",
      OSSL_CIPHER_CTS_MODE_CS3 = "CS3",
      OSSL_DIGEST_PARAM_XOFLEN = "xoflen",
      OSSL_DIGEST_PARAM_SSL3_MS = "ssl3-ms",
      OSSL_DIGEST_PARAM_PAD_TYPE = "pad-type",
      OSSL_DIGEST_PARAM_MICALG = "micalg",
      OSSL_DIGEST_PARAM_BLOCK_SIZE = "blocksize",
      OSSL_DIGEST_PARAM_SIZE = "size",
      OSSL_DIGEST_PARAM_XOF = "xof",
      OSSL_DIGEST_PARAM_ALGID_ABSENT = "algid-absent",
      OSSL_DIGEST_NAME_MD5 = "MD5",
      OSSL_DIGEST_NAME_MD5_SHA1 = "MD5-SHA1",
      OSSL_DIGEST_NAME_SHA1 = "SHA1",
      OSSL_DIGEST_NAME_SHA2_224 = "SHA2-224",
      OSSL_DIGEST_NAME_SHA2_256 = "SHA2-256",
      OSSL_DIGEST_NAME_SHA2_384 = "SHA2-384",
      OSSL_DIGEST_NAME_SHA2_512 = "SHA2-512",
      OSSL_DIGEST_NAME_MD2 = "MD2",
      OSSL_DIGEST_NAME_MD4 = "MD4",
      OSSL_DIGEST_NAME_MDC2 = "MDC2",
      OSSL_DIGEST_NAME_RIPEMD160 = "RIPEMD160",
      OSSL_DIGEST_NAME_SHA3_224 = "SHA3-224",
      OSSL_DIGEST_NAME_SHA3_256 = "SHA3-256",
      OSSL_DIGEST_NAME_SHA3_384 = "SHA3-384",
      OSSL_DIGEST_NAME_SHA3_512 = "SHA3-512",
      OSSL_DIGEST_NAME_KECCAK_KMAC128 = "KECCAK-KMAC-128",
      OSSL_DIGEST_NAME_KECCAK_KMAC256 = "KECCAK-KMAC-256",
      OSSL_DIGEST_NAME_SM3 = "SM3",
      OSSL_MAC_PARAM_KEY = "key",
      OSSL_MAC_PARAM_IV = "iv",
      OSSL_MAC_PARAM_CUSTOM = "custom",
      OSSL_MAC_PARAM_SALT = "salt",
      OSSL_MAC_PARAM_XOF = "xof",
      OSSL_MAC_PARAM_DIGEST_NOINIT = "digest-noinit",
      OSSL_MAC_PARAM_DIGEST_ONESHOT = "digest-oneshot",
      OSSL_MAC_PARAM_C_ROUNDS = "c-rounds",
      OSSL_MAC_PARAM_D_ROUNDS = "d-rounds",
      OSSL_MAC_PARAM_CIPHER = "cipher",
      OSSL_MAC_PARAM_DIGEST = "digest",
      OSSL_MAC_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_MAC_PARAM_SIZE = "size",
      OSSL_MAC_PARAM_BLOCK_SIZE = "block-size",
      OSSL_MAC_PARAM_TLS_DATA_SIZE = "tls-data-size",
      OSSL_MAC_NAME_BLAKE2BMAC = "BLAKE2BMAC",
      OSSL_MAC_NAME_BLAKE2SMAC = "BLAKE2SMAC",
      OSSL_MAC_NAME_CMAC = "CMAC",
      OSSL_MAC_NAME_GMAC = "GMAC",
      OSSL_MAC_NAME_HMAC = "HMAC",
      OSSL_MAC_NAME_KMAC128 = "KMAC128",
      OSSL_MAC_NAME_KMAC256 = "KMAC256",
      OSSL_MAC_NAME_POLY1305 = "POLY1305",
      OSSL_MAC_NAME_SIPHASH = "SIPHASH",
      OSSL_KDF_PARAM_SECRET = "secret",
      OSSL_KDF_PARAM_KEY = "key",
      OSSL_KDF_PARAM_SALT = "salt",
      OSSL_KDF_PARAM_PASSWORD = "pass",
      OSSL_KDF_PARAM_PREFIX = "prefix",
      OSSL_KDF_PARAM_LABEL = "label",
      OSSL_KDF_PARAM_DATA = "data",
      OSSL_KDF_PARAM_DIGEST = "digest",
      OSSL_KDF_PARAM_CIPHER = "cipher",
      OSSL_KDF_PARAM_MAC = "mac",
      OSSL_KDF_PARAM_MAC_SIZE = "maclen",
      OSSL_KDF_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_KDF_PARAM_ITER = "iter",
      OSSL_KDF_PARAM_MODE = "mode",
      OSSL_KDF_PARAM_PKCS5 = "pkcs5",
      OSSL_KDF_PARAM_UKM = "ukm",
      OSSL_KDF_PARAM_CEK_ALG = "cekalg",
      OSSL_KDF_PARAM_SCRYPT_N = "n",
      OSSL_KDF_PARAM_SCRYPT_R = "r",
      OSSL_KDF_PARAM_SCRYPT_P = "p",
      OSSL_KDF_PARAM_SCRYPT_MAXMEM = "maxmem_bytes",
      OSSL_KDF_PARAM_INFO = "info",
      OSSL_KDF_PARAM_SEED = "seed",
      OSSL_KDF_PARAM_SSHKDF_XCGHASH = "xcghash",
      OSSL_KDF_PARAM_SSHKDF_SESSION_ID = "session_id",
      OSSL_KDF_PARAM_SSHKDF_TYPE = "type",
      OSSL_KDF_PARAM_SIZE = "size",
      OSSL_KDF_PARAM_CONSTANT = "constant",
      OSSL_KDF_PARAM_PKCS12_ID = "id",
      OSSL_KDF_PARAM_KBKDF_USE_L = "use-l",
      OSSL_KDF_PARAM_KBKDF_USE_SEPARATOR = "use-separator",
      OSSL_KDF_PARAM_X942_ACVPINFO = "acvp-info",
      OSSL_KDF_PARAM_X942_PARTYUINFO = "partyu-info",
      OSSL_KDF_PARAM_X942_PARTYVINFO = "partyv-info",
      OSSL_KDF_PARAM_X942_SUPP_PUBINFO = "supp-pubinfo",
      OSSL_KDF_PARAM_X942_SUPP_PRIVINFO = "supp-privinfo",
      OSSL_KDF_PARAM_X942_USE_KEYBITS = "use-keybits",
      OSSL_KDF_NAME_HKDF = "HKDF",
      OSSL_KDF_NAME_TLS1_3_KDF = "TLS13-KDF",
      OSSL_KDF_NAME_PBKDF1 = "PBKDF1",
      OSSL_KDF_NAME_PBKDF2 = "PBKDF2",
      OSSL_KDF_NAME_SCRYPT = "SCRYPT",
      OSSL_KDF_NAME_SSHKDF = "SSHKDF",
      OSSL_KDF_NAME_SSKDF = "SSKDF",
      OSSL_KDF_NAME_TLS1_PRF = "TLS1-PRF",
      OSSL_KDF_NAME_X942KDF_ASN1 = "X942KDF-ASN1",
      OSSL_KDF_NAME_X942KDF_CONCAT = "X942KDF-CONCAT",
      OSSL_KDF_NAME_X963KDF = "X963KDF",
      OSSL_KDF_NAME_KBKDF = "KBKDF",
      OSSL_KDF_NAME_KRB5KDF = "KRB5KDF",
      OSSL_RAND_PARAM_STATE = "state",
      OSSL_RAND_PARAM_STRENGTH = "strength",
      OSSL_RAND_PARAM_MAX_REQUEST = "max_request",
      OSSL_RAND_PARAM_TEST_ENTROPY = "test_entropy",
      OSSL_RAND_PARAM_TEST_NONCE = "test_nonce",
      OSSL_DRBG_PARAM_RESEED_REQUESTS = "reseed_requests",
      OSSL_DRBG_PARAM_RESEED_TIME_INTERVAL = "reseed_time_interval",
      OSSL_DRBG_PARAM_MIN_ENTROPYLEN = "min_entropylen",
      OSSL_DRBG_PARAM_MAX_ENTROPYLEN = "max_entropylen",
      OSSL_DRBG_PARAM_MIN_NONCELEN = "min_noncelen",
      OSSL_DRBG_PARAM_MAX_NONCELEN = "max_noncelen",
      OSSL_DRBG_PARAM_MAX_PERSLEN = "max_perslen",
      OSSL_DRBG_PARAM_MAX_ADINLEN = "max_adinlen",
      OSSL_DRBG_PARAM_RESEED_COUNTER = "reseed_counter",
      OSSL_DRBG_PARAM_RESEED_TIME = "reseed_time",
      OSSL_DRBG_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_DRBG_PARAM_DIGEST = "digest",
      OSSL_DRBG_PARAM_CIPHER = "cipher",
      OSSL_DRBG_PARAM_MAC = "mac",
      OSSL_DRBG_PARAM_USE_DF = "use_derivation_function",
      OSSL_DRBG_PARAM_ENTROPY_REQUIRED = "entropy_required",
      OSSL_DRBG_PARAM_PREDICTION_RESISTANCE = "prediction_resistance",
      OSSL_DRBG_PARAM_MIN_LENGTH = "minium_length",
      OSSL_DRBG_PARAM_MAX_LENGTH = "maxium_length",
      OSSL_DRBG_PARAM_RANDOM_DATA = "random_data",
      OSSL_DRBG_PARAM_SIZE = "size",
      OSSL_PKEY_PARAM_BITS = "bits",
      OSSL_PKEY_PARAM_MAX_SIZE = "max-size",
      OSSL_PKEY_PARAM_SECURITY_BITS = "security-bits",
      OSSL_PKEY_PARAM_DIGEST = "digest",
      OSSL_PKEY_PARAM_CIPHER = "cipher",
      OSSL_PKEY_PARAM_ENGINE = "engine",
      OSSL_PKEY_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_PKEY_PARAM_DEFAULT_DIGEST = "default-digest",
      OSSL_PKEY_PARAM_MANDATORY_DIGEST = "mandatory-digest",
      OSSL_PKEY_PARAM_PAD_MODE = "pad-mode",
      OSSL_PKEY_PARAM_DIGEST_SIZE = "digest-size",
      OSSL_PKEY_PARAM_MASKGENFUNC = "mgf",
      OSSL_PKEY_PARAM_MGF1_DIGEST = "mgf1-digest",
      OSSL_PKEY_PARAM_MGF1_PROPERTIES = "mgf1-properties",
      OSSL_PKEY_PARAM_ENCODED_PUBLIC_KEY = "encoded-pub-key",
      OSSL_PKEY_PARAM_GROUP_NAME = "group",
      OSSL_PKEY_PARAM_DIST_ID = "distid",
      OSSL_PKEY_PARAM_PUB_KEY = "pub",
      OSSL_PKEY_PARAM_PRIV_KEY = "priv",
      OSSL_PKEY_PARAM_FFC_P = "p",
      OSSL_PKEY_PARAM_FFC_G = "g",
      OSSL_PKEY_PARAM_FFC_Q = "q",
      OSSL_PKEY_PARAM_FFC_GINDEX = "gindex",
      OSSL_PKEY_PARAM_FFC_PCOUNTER = "pcounter",
      OSSL_PKEY_PARAM_FFC_SEED = "seed",
      OSSL_PKEY_PARAM_FFC_COFACTOR = "j",
      OSSL_PKEY_PARAM_FFC_H = "hindex",
      OSSL_PKEY_PARAM_FFC_VALIDATE_PQ = "validate-pq",
      OSSL_PKEY_PARAM_FFC_VALIDATE_G = "validate-g",
      OSSL_PKEY_PARAM_FFC_VALIDATE_LEGACY = "validate-legacy",
      OSSL_PKEY_PARAM_DH_GENERATOR = "safeprime-generator",
      OSSL_PKEY_PARAM_DH_PRIV_LEN = "priv_len",
      OSSL_PKEY_PARAM_EC_PUB_X = "qx",
      OSSL_PKEY_PARAM_EC_PUB_Y = "qy",
      OSSL_PKEY_PARAM_EC_FIELD_TYPE = "field-type",
      OSSL_PKEY_PARAM_EC_P = "p",
      OSSL_PKEY_PARAM_EC_A = "a",
      OSSL_PKEY_PARAM_EC_B = "b",
      OSSL_PKEY_PARAM_EC_GENERATOR = "generator",
      OSSL_PKEY_PARAM_EC_ORDER = "order",
      OSSL_PKEY_PARAM_EC_COFACTOR = "cofactor",
      OSSL_PKEY_PARAM_EC_SEED = "seed",
      OSSL_PKEY_PARAM_EC_CHAR2_M = "m",
      OSSL_PKEY_PARAM_EC_CHAR2_TYPE = "basis-type",
      OSSL_PKEY_PARAM_EC_CHAR2_TP_BASIS = "tp",
      OSSL_PKEY_PARAM_EC_CHAR2_PP_K1 = "k1",
      OSSL_PKEY_PARAM_EC_CHAR2_PP_K2 = "k2",
      OSSL_PKEY_PARAM_EC_CHAR2_PP_K3 = "k3",
      OSSL_PKEY_PARAM_EC_DECODED_FROM_EXPLICIT_PARAMS = "decoded-from-explicit",
      OSSL_PKEY_PARAM_USE_COFACTOR_FLAG = "use-cofactor-flag",
      OSSL_PKEY_PARAM_RSA_N = "n",
      OSSL_PKEY_PARAM_RSA_E = "e",
      OSSL_PKEY_PARAM_RSA_D = "d",
      OSSL_PKEY_PARAM_RSA_FACTOR = "rsa-factor",
      OSSL_PKEY_PARAM_RSA_EXPONENT = "rsa-exponent",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT = "rsa-coefficient",
      OSSL_PKEY_PARAM_RSA_FACTOR1 = "OSSL_PKEY_PARAM_RSA_FACTOR1",
      OSSL_PKEY_PARAM_RSA_FACTOR2 = "OSSL_PKEY_PARAM_RSA_FACTOR2",
      OSSL_PKEY_PARAM_RSA_FACTOR3 = "OSSL_PKEY_PARAM_RSA_FACTOR3",
      OSSL_PKEY_PARAM_RSA_FACTOR4 = "OSSL_PKEY_PARAM_RSA_FACTOR4",
      OSSL_PKEY_PARAM_RSA_FACTOR5 = "OSSL_PKEY_PARAM_RSA_FACTOR5",
      OSSL_PKEY_PARAM_RSA_FACTOR6 = "OSSL_PKEY_PARAM_RSA_FACTOR6",
      OSSL_PKEY_PARAM_RSA_FACTOR7 = "OSSL_PKEY_PARAM_RSA_FACTOR7",
      OSSL_PKEY_PARAM_RSA_FACTOR8 = "OSSL_PKEY_PARAM_RSA_FACTOR8",
      OSSL_PKEY_PARAM_RSA_FACTOR9 = "OSSL_PKEY_PARAM_RSA_FACTOR9",
      OSSL_PKEY_PARAM_RSA_FACTOR10 = "OSSL_PKEY_PARAM_RSA_FACTOR10",
      OSSL_PKEY_PARAM_RSA_EXPONENT1 = "OSSL_PKEY_PARAM_RSA_EXPONENT1",
      OSSL_PKEY_PARAM_RSA_EXPONENT2 = "OSSL_PKEY_PARAM_RSA_EXPONENT2",
      OSSL_PKEY_PARAM_RSA_EXPONENT3 = "OSSL_PKEY_PARAM_RSA_EXPONENT3",
      OSSL_PKEY_PARAM_RSA_EXPONENT4 = "OSSL_PKEY_PARAM_RSA_EXPONENT4",
      OSSL_PKEY_PARAM_RSA_EXPONENT5 = "OSSL_PKEY_PARAM_RSA_EXPONENT5",
      OSSL_PKEY_PARAM_RSA_EXPONENT6 = "OSSL_PKEY_PARAM_RSA_EXPONENT6",
      OSSL_PKEY_PARAM_RSA_EXPONENT7 = "OSSL_PKEY_PARAM_RSA_EXPONENT7",
      OSSL_PKEY_PARAM_RSA_EXPONENT8 = "OSSL_PKEY_PARAM_RSA_EXPONENT8",
      OSSL_PKEY_PARAM_RSA_EXPONENT9 = "OSSL_PKEY_PARAM_RSA_EXPONENT9",
      OSSL_PKEY_PARAM_RSA_EXPONENT10 = "OSSL_PKEY_PARAM_RSA_EXPONENT10",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT1 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT1",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT2 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT2",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT3 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT3",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT4 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT4",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT5 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT5",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT6 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT6",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT7 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT7",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT8 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT8",
      OSSL_PKEY_PARAM_RSA_COEFFICIENT9 = "OSSL_PKEY_PARAM_RSA_COEFFICIENT9",
      OSSL_PKEY_RSA_PAD_MODE_NONE = "none",
      OSSL_PKEY_RSA_PAD_MODE_PKCSV15 = "pkcs1",
      OSSL_PKEY_RSA_PAD_MODE_OAEP = "oaep",
      OSSL_PKEY_RSA_PAD_MODE_X931 = "x931",
      OSSL_PKEY_RSA_PAD_MODE_PSS = "pss",
      OSSL_PKEY_RSA_PSS_SALT_LEN_DIGEST = "digest",
      OSSL_PKEY_RSA_PSS_SALT_LEN_MAX = "max",
      OSSL_PKEY_RSA_PSS_SALT_LEN_AUTO = "auto",
      OSSL_PKEY_PARAM_RSA_BITS = "bits",
      OSSL_PKEY_PARAM_RSA_PRIMES = "primes",
      OSSL_PKEY_PARAM_RSA_DIGEST = "digest",
      OSSL_PKEY_PARAM_RSA_DIGEST_PROPS = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_PKEY_PARAM_RSA_MASKGENFUNC = "mgf",
      OSSL_PKEY_PARAM_RSA_MGF1_DIGEST = "mgf1-digest",
      OSSL_PKEY_PARAM_RSA_PSS_SALTLEN = "saltlen",
      OSSL_PKEY_PARAM_FFC_TYPE = "type",
      OSSL_PKEY_PARAM_FFC_PBITS = "pbits",
      OSSL_PKEY_PARAM_FFC_QBITS = "qbits",
      OSSL_PKEY_PARAM_FFC_DIGEST = "digest",
      OSSL_PKEY_PARAM_FFC_DIGEST_PROPS = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_PKEY_PARAM_EC_ENCODING = "encoding",
      OSSL_PKEY_PARAM_EC_POINT_CONVERSION_FORMAT = "point-format",
      OSSL_PKEY_PARAM_EC_GROUP_CHECK_TYPE = "group-check",
      OSSL_PKEY_PARAM_EC_INCLUDE_PUBLIC = "include-public",
      OSSL_PKEY_EC_ENCODING_EXPLICIT = "explicit",
      OSSL_PKEY_EC_ENCODING_GROUP = "named_curve",
      OSSL_PKEY_EC_POINT_CONVERSION_FORMAT_UNCOMPRESSED = "uncompressed",
      OSSL_PKEY_EC_POINT_CONVERSION_FORMAT_COMPRESSED = "compressed",
      OSSL_PKEY_EC_POINT_CONVERSION_FORMAT_HYBRID = "hybrid",
      OSSL_PKEY_EC_GROUP_CHECK_DEFAULT = "default",
      OSSL_PKEY_EC_GROUP_CHECK_NAMED = "named",
      OSSL_PKEY_EC_GROUP_CHECK_NAMED_NIST = "named-nist",
      OSSL_EXCHANGE_PARAM_PAD = "pad",
      OSSL_EXCHANGE_PARAM_EC_ECDH_COFACTOR_MODE = "ecdh-cofactor-mode",
      OSSL_EXCHANGE_PARAM_KDF_TYPE = "kdf-type",
      OSSL_EXCHANGE_PARAM_KDF_DIGEST = "kdf-digest",
      OSSL_EXCHANGE_PARAM_KDF_DIGEST_PROPS = "kdf-digest-props",
      OSSL_EXCHANGE_PARAM_KDF_OUTLEN = "kdf-outlen",
      OSSL_EXCHANGE_PARAM_KDF_UKM = "kdf-ukm",
      OSSL_SIGNATURE_PARAM_ALGORITHM_ID = "algorithm-id",
      OSSL_SIGNATURE_PARAM_PAD_MODE = "pad-mode",
      OSSL_SIGNATURE_PARAM_DIGEST = "digest",
      OSSL_SIGNATURE_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_SIGNATURE_PARAM_PSS_SALTLEN = "saltlen",
      OSSL_SIGNATURE_PARAM_MGF1_DIGEST = "mgf1-digest",
      OSSL_SIGNATURE_PARAM_DIGEST_SIZE = "digest-size",
      OSSL_ASYM_CIPHER_PARAM_DIGEST = "digest",
      OSSL_ASYM_CIPHER_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_ASYM_CIPHER_PARAM_ENGINE = "engine",
      OSSL_ASYM_CIPHER_PARAM_PAD_MODE = "pad-mode",
      OSSL_ASYM_CIPHER_PARAM_OAEP_DIGEST = "digest",
      OSSL_ASYM_CIPHER_PARAM_OAEP_DIGEST_PROPS = "digest-props",
      OSSL_ASYM_CIPHER_PARAM_OAEP_LABEL = "oaep-label",
      OSSL_ASYM_CIPHER_PARAM_TLS_CLIENT_VERSION = "tls-client-version",
      OSSL_ASYM_CIPHER_PARAM_TLS_NEGOTIATED_VERSION = "tls-negotiated-version",
      OSSL_ENCODER_PARAM_CIPHER = "cipher",
      OSSL_ENCODER_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_ENCODER_PARAM_ENCRYPT_LEVEL = "encrypt-level",
      OSSL_ENCODER_PARAM_SAVE_PARAMETERS = "save-parameters",
      OSSL_DECODER_PARAM_PROPERTIES = "OSSL_ALG_PARAM_PROPERTIES",
      OSSL_PASSPHRASE_PARAM_INFO = "info",
      OSSL_GEN_PARAM_POTENTIAL = "potential",
      OSSL_GEN_PARAM_ITERATION = "iteration",
      OSSL_PKEY_PARAM_RSA_TEST_XP1 = "xp1",
      OSSL_PKEY_PARAM_RSA_TEST_XP2 = "xp2",
      OSSL_PKEY_PARAM_RSA_TEST_XP = "xp",
      OSSL_PKEY_PARAM_RSA_TEST_XQ1 = "xq1",
      OSSL_PKEY_PARAM_RSA_TEST_XQ2 = "xq2",
      OSSL_PKEY_PARAM_RSA_TEST_XQ = "xq",
      OSSL_PKEY_PARAM_RSA_TEST_P1 = "p1",
      OSSL_PKEY_PARAM_RSA_TEST_P2 = "p2",
      OSSL_PKEY_PARAM_RSA_TEST_Q1 = "q1",
      OSSL_PKEY_PARAM_RSA_TEST_Q2 = "q2",
      OSSL_SIGNATURE_PARAM_KAT = "kat",
      OSSL_KEM_PARAM_OPERATION = "operation",
      OSSL_KEM_PARAM_OPERATION_RSASVE = "RSASVE",
      OSSL_CAPABILITY_TLS_GROUP_NAME = "tls-group-name",
      OSSL_CAPABILITY_TLS_GROUP_NAME_INTERNAL = "tls-group-name-internal",
      OSSL_CAPABILITY_TLS_GROUP_ID = "tls-group-id",
      OSSL_CAPABILITY_TLS_GROUP_ALG = "tls-group-alg",
      OSSL_CAPABILITY_TLS_GROUP_SECURITY_BITS = "tls-group-sec-bits",
      OSSL_CAPABILITY_TLS_GROUP_IS_KEM = "tls-group-is-kem",
      OSSL_CAPABILITY_TLS_GROUP_MIN_TLS = "tls-min-tls",
      OSSL_CAPABILITY_TLS_GROUP_MAX_TLS = "tls-max-tls",
      OSSL_CAPABILITY_TLS_GROUP_MIN_DTLS = "tls-min-dtls",
      OSSL_CAPABILITY_TLS_GROUP_MAX_DTLS = "tls-max-dtls",
      OSSL_STORE_PARAM_EXPECT = "expect",
      OSSL_STORE_PARAM_SUBJECT = "subject",
      OSSL_STORE_PARAM_ISSUER = "name",
      OSSL_STORE_PARAM_SERIAL = "serial",
      OSSL_STORE_PARAM_DIGEST = "digest",
      OSSL_STORE_PARAM_FINGERPRINT = "fingerprint",
      OSSL_STORE_PARAM_ALIAS = "alias",
      OSSL_STORE_PARAM_PROPERTIES = "properties",
      OSSL_STORE_PARAM_INPUT_TYPE = "input-type",
      OSSL_OBJECT_UNKNOWN = "0",
      OSSL_OBJECT_NAME = 1,
      OSSL_OBJECT_PKEY = 2,
      OSSL_OBJECT_CERT = 3,
      OSSL_OBJECT_CRL = 4,
      CRYPTO_R_BAD_ALGORITHM_NAME = 117,
      CRYPTO_R_CONFLICTING_NAMES = 118,
      CRYPTO_R_HEX_STRING_TOO_SHORT = 121,
      CRYPTO_R_ILLEGAL_HEX_DIGIT = 102,
      CRYPTO_R_INSUFFICIENT_DATA_SPACE = 106,
      CRYPTO_R_INSUFFICIENT_PARAM_SIZE = 107,
      CRYPTO_R_INSUFFICIENT_SECURE_DATA_SPACE = 108,
      CRYPTO_R_INVALID_NEGATIVE_VALUE = 122,
      CRYPTO_R_INVALID_NULL_ARGUMENT = 109,
      CRYPTO_R_INVALID_OSSL_PARAM_TYPE = 110,
      CRYPTO_R_ODD_NUMBER_OF_DIGITS = 103,
      CRYPTO_R_PROVIDER_ALREADY_EXISTS = 104,
      CRYPTO_R_PROVIDER_SECTION_ERROR = 105,
      CRYPTO_R_RANDOM_SECTION_ERROR = 119,
      CRYPTO_R_SECURE_MALLOC_FAILURE = 111,
      CRYPTO_R_STRING_TOO_LONG = 112,
      CRYPTO_R_TOO_MANY_BYTES = 113,
      CRYPTO_R_TOO_MANY_RECORDS = 114,
      CRYPTO_R_TOO_SMALL_BUFFER = 116,
      CRYPTO_R_UNKNOWN_NAME_IN_RANDOM_SECTION = 120,
      CRYPTO_R_ZERO_LENGTH_NUMBER = 115,
      EVP_R_OPERATON_NOT_INITIALIZED = 151,
      OSSL_DECODER_R_COULD_NOT_DECODE_OBJECT = 101,
      OSSL_DECODER_R_DECODER_NOT_FOUND = 102,
      OSSL_DECODER_R_MISSING_GET_PARAMS = 100,
      DH_PARAMGEN_TYPE_GENERATOR = "0",
      DH_PARAMGEN_TYPE_FIPS_186_2 = 1,
      DH_PARAMGEN_TYPE_FIPS_186_4 = 2,
      DH_PARAMGEN_TYPE_GROUP = 3,
      EVP_PKEY_DH_KDF_NONE = 1,
      EVP_PKEY_DH_KDF_X9_42 = 2,
      DTLS1_VERSION_MAJOR = "0xFE",
      DTLS_ANY_VERSION = "0x1FFFF",
      DTLS1_COOKIE_LENGTH = 255,
      DTLS1_RT_HEADER_LENGTH = 13,
      DTLS1_HM_HEADER_LENGTH = 12,
      DTLS1_HM_BAD_FRAGMENT = -2,
      DTLS1_HM_FRAGMENT_RETRY = -3,
      DTLS1_CCS_HEADER_LENGTH = 1,
      DTLS1_AL_HEADER_LENGTH = 2,
      DTLS1_TMO_ALERT_COUNT = 12,
      OPENSSL_EXTERN = "OPENSSL_EXPORT",
      os_toascii = "_openssl_os_toascii",
      os_toebcdic = "_openssl_os_toebcdic",
      ebcdic2ascii = "_openssl_ebcdic2ascii",
      ascii2ebcdic = "_openssl_ascii2ebcdic",
      OPENSSL_EC_EXPLICIT_CURVE = "0x000",
      OPENSSL_EC_NAMED_CURVE = "0x001",
      EVP_PKEY_ECDH_KDF_NONE = 1,
      EVP_PKEY_ECDH_KDF_X9_63 = 2,
      EVP_PKEY_ECDH_KDF_X9_62 = 2,
      OSSL_ENCODER_R_ENCODER_NOT_FOUND = 101,
      OSSL_ENCODER_R_INCORRECT_PROPERTY_QUERY = 100,
      OSSL_ENCODER_R_MISSING_GET_PARAMS = 102,
      ENGINE_FLAGS_MALLOCED = "0x0001",
      ESS_R_EMPTY_ESS_CERT_ID_LIST = 107,
      ESS_R_ESS_CERT_DIGEST_ERROR = 103,
      ESS_R_ESS_CERT_ID_NOT_FOUND = 104,
      ESS_R_ESS_CERT_ID_WRONG_ORDER = 105,
      ESS_R_ESS_DIGEST_ALG_UNKNOWN = 106,
      ESS_R_ESS_SIGNING_CERTIFICATE_ERROR = 102,
      ESS_R_ESS_SIGNING_CERT_ADD_ERROR = 100,
      ESS_R_ESS_SIGNING_CERT_V2_ADD_ERROR = 101,
      ESS_R_MISSING_SIGNING_CERTIFICATE_ATTRIBUTE = 108,
      EVP_MAX_KEY_LENGTH = 64,
      EVP_MAX_IV_LENGTH = 16,
      EVP_MAX_BLOCK_LENGTH = 32,
      PKCS5_SALT_LEN = 8,
      PKCS5_DEFAULT_ITER = 2048,
      EVP_PKEY_NONE = "0",
      EVP_PKEY_RSA = 6,
      EVP_PKEY_RSA2 = 19,
      EVP_PKEY_RSA_PSS = 912,
      EVP_PKEY_DSA = 116,
      EVP_PKEY_DSA1 = 67,
      EVP_PKEY_DSA2 = 66,
      EVP_PKEY_DSA3 = 113,
      EVP_PKEY_DSA4 = 70,
      EVP_PKEY_DH = 28,
      EVP_PKEY_DHX = 920,
      EVP_PKEY_EC = 408,
      EVP_PKEY_SM2 = 1172,
      EVP_PKEY_HMAC = 855,
      EVP_PKEY_CMAC = 894,
      EVP_PKEY_SCRYPT = 973,
      EVP_PKEY_TLS1_PRF = 1021,
      EVP_PKEY_HKDF = 1036,
      EVP_PKEY_POLY1305 = 1061,
      EVP_PKEY_SIPHASH = 1062,
      EVP_PKEY_X25519 = 1034,
      EVP_PKEY_ED25519 = 1087,
      EVP_PKEY_X448 = 1035,
      EVP_PKEY_ED448 = 1088,
      EVP_PKEY_KEYMGMT = -1,
      EVP_PKEY_MO_SIGN = "0x0001",
      EVP_PKEY_MO_VERIFY = "0x0002",
      EVP_PKEY_MO_ENCRYPT = "0x0004",
      EVP_PKEY_MO_DECRYPT = "0x0008",
      EVP_MD_CTX_FLAG_FINALISE = "0x0200",
      EVP_PADDING_PKCS7 = 1,
      EVP_PADDING_ISO7816_4 = 2,
      EVP_PADDING_ANSI923 = 3,
      EVP_PADDING_ISO10126 = 4,
      EVP_PADDING_ZERO = 5,
      EVP_GCM_TLS_FIXED_IV_LEN = 4,
      EVP_GCM_TLS_EXPLICIT_IV_LEN = 8,
      EVP_GCM_TLS_TAG_LEN = 16,
      EVP_CCM_TLS_FIXED_IV_LEN = 4,
      EVP_CCM_TLS_EXPLICIT_IV_LEN = 8,
      EVP_CCM_TLS_IV_LEN = 12,
      EVP_CCM_TLS_TAG_LEN = 16,
      EVP_CCM8_TLS_TAG_LEN = 8,
      EVP_CHACHAPOLY_TLS_TAG_LEN = 16,
      EVP_MD_type = "EVP_MD_get_type",
      EVP_MD_nid = "EVP_MD_get_type",
      EVP_MD_name = "EVP_MD_get0_name",
      EVP_MD_pkey_type = "EVP_MD_get_pkey_type",
      EVP_MD_size = "EVP_MD_get_size",
      EVP_MD_block_size = "EVP_MD_get_block_size",
      EVP_MD_flags = "EVP_MD_get_flags",
      EVP_MD_CTX_size = "EVP_MD_CTX_get_size",
      EVP_MD_CTX_block_size = "EVP_MD_CTX_get_block_size",
      EVP_MD_CTX_type = "EVP_MD_CTX_get_type",
      EVP_MD_CTX_pkey_ctx = "EVP_MD_CTX_get_pkey_ctx",
      EVP_MD_CTX_md_data = "EVP_MD_CTX_get0_md_data",
      EVP_CIPHER_nid = "EVP_CIPHER_get_nid",
      EVP_CIPHER_name = "EVP_CIPHER_get0_name",
      EVP_CIPHER_block_size = "EVP_CIPHER_get_block_size",
      EVP_CIPHER_key_length = "EVP_CIPHER_get_key_length",
      EVP_CIPHER_iv_length = "EVP_CIPHER_get_iv_length",
      EVP_CIPHER_flags = "EVP_CIPHER_get_flags",
      EVP_CIPHER_mode = "EVP_CIPHER_get_mode",
      EVP_CIPHER_type = "EVP_CIPHER_get_type",
      EVP_CIPHER_CTX_encrypting = "EVP_CIPHER_CTX_is_encrypting",
      EVP_CIPHER_CTX_nid = "EVP_CIPHER_CTX_get_nid",
      EVP_CIPHER_CTX_block_size = "EVP_CIPHER_CTX_get_block_size",
      EVP_CIPHER_CTX_key_length = "EVP_CIPHER_CTX_get_key_length",
      EVP_CIPHER_CTX_iv_length = "EVP_CIPHER_CTX_get_iv_length",
      EVP_CIPHER_CTX_tag_length = "EVP_CIPHER_CTX_get_tag_length",
      EVP_CIPHER_CTX_num = "EVP_CIPHER_CTX_get_num",
      EVP_CIPHER_CTX_type = "EVP_CIPHER_CTX_get_type",
      EVP_CIPHER_CTX_mode = "EVP_CIPHER_CTX_get_mode",
      EVP_aes_128_cfb = "EVP_aes_128_cfb128",
      EVP_aes_192_cfb = "EVP_aes_192_cfb128",
      EVP_aes_256_cfb = "EVP_aes_256_cfb128",
      EVP_RAND_STATE_UNINITIALISED = "0",
      EVP_RAND_STATE_READY = 1,
      EVP_RAND_STATE_ERROR = 2,
      EVP_PKEY_id = "EVP_PKEY_get_id",
      EVP_PKEY_base_id = "EVP_PKEY_get_base_id",
      EVP_PKEY_bits = "EVP_PKEY_get_bits",
      EVP_PKEY_security_bits = "EVP_PKEY_get_security_bits",
      EVP_PKEY_size = "EVP_PKEY_get_size",
      EVP_PBE_TYPE_OUTER = "0x0",
      EVP_PBE_TYPE_PRF = "0x1",
      EVP_PBE_TYPE_KDF = "0x2",
      ASN1_PKEY_ALIAS = "0x1",
      ASN1_PKEY_DYNAMIC = "0x2",
      ASN1_PKEY_SIGPARAM_NULL = "0x4",
      ASN1_PKEY_CTRL_PKCS7_SIGN = "0x1",
      ASN1_PKEY_CTRL_PKCS7_ENCRYPT = "0x2",
      ASN1_PKEY_CTRL_DEFAULT_MD_NID = "0x3",
      ASN1_PKEY_CTRL_CMS_SIGN = "0x5",
      ASN1_PKEY_CTRL_CMS_ENVELOPE = "0x7",
      ASN1_PKEY_CTRL_CMS_RI_TYPE = "0x8",
      ASN1_PKEY_CTRL_SET1_TLS_ENCPT = "0x9",
      ASN1_PKEY_CTRL_GET1_TLS_ENCPT = "0xa",
      ASN1_PKEY_CTRL_CMS_IS_RI_TYPE_SUPPORTED = "0xb",
      EVP_PKEY_OP_UNDEFINED = "0",
      EVP_PKEY_CTRL_MD = 1,
      EVP_PKEY_CTRL_PEER_KEY = 2,
      EVP_PKEY_CTRL_SET_MAC_KEY = 6,
      EVP_PKEY_CTRL_DIGESTINIT = 7,
      EVP_PKEY_CTRL_SET_IV = 8,
      EVP_PKEY_CTRL_CIPHER = 12,
      EVP_PKEY_CTRL_GET_MD = 13,
      EVP_PKEY_CTRL_SET_DIGEST_SIZE = 14,
      EVP_PKEY_CTRL_SET1_ID = 15,
      EVP_PKEY_CTRL_GET1_ID = 16,
      EVP_PKEY_CTRL_GET1_ID_LEN = 17,
      EVP_PKEY_ALG_CTRL = "0x1000",
      EVP_PKEY_FLAG_AUTOARGLEN = 2,
      EVP_PKEY_FLAG_SIGCTX_CUSTOM = 4,
      EVP_R_AES_KEY_SETUP_FAILED = 143,
      EVP_R_ARIA_KEY_SETUP_FAILED = 176,
      EVP_R_BAD_ALGORITHM_NAME = 200,
      EVP_R_BAD_DECRYPT = 100,
      EVP_R_BAD_KEY_LENGTH = 195,
      EVP_R_BUFFER_TOO_SMALL = 155,
      EVP_R_CACHE_CONSTANTS_FAILED = 225,
      EVP_R_CAMELLIA_KEY_SETUP_FAILED = 157,
      EVP_R_CANNOT_GET_PARAMETERS = 197,
      EVP_R_CANNOT_SET_PARAMETERS = 198,
      EVP_R_CIPHER_NOT_GCM_MODE = 184,
      EVP_R_CIPHER_PARAMETER_ERROR = 122,
      EVP_R_COMMAND_NOT_SUPPORTED = 147,
      EVP_R_CONFLICTING_ALGORITHM_NAME = 201,
      EVP_R_COPY_ERROR = 173,
      EVP_R_CTRL_NOT_IMPLEMENTED = 132,
      EVP_R_CTRL_OPERATION_NOT_IMPLEMENTED = 133,
      EVP_R_DATA_NOT_MULTIPLE_OF_BLOCK_LENGTH = 138,
      EVP_R_DECODE_ERROR = 114,
      EVP_R_DEFAULT_QUERY_PARSE_ERROR = 210,
      EVP_R_DIFFERENT_KEY_TYPES = 101,
      EVP_R_DIFFERENT_PARAMETERS = 153,
      EVP_R_ERROR_LOADING_SECTION = 165,
      EVP_R_EXPECTING_AN_HMAC_KEY = 174,
      EVP_R_EXPECTING_AN_RSA_KEY = 127,
      EVP_R_EXPECTING_A_DH_KEY = 128,
      EVP_R_EXPECTING_A_DSA_KEY = 129,
      EVP_R_EXPECTING_A_ECX_KEY = 219,
      EVP_R_EXPECTING_A_EC_KEY = 142,
      EVP_R_EXPECTING_A_POLY1305_KEY = 164,
      EVP_R_EXPECTING_A_SIPHASH_KEY = 175,
      EVP_R_FINAL_ERROR = 188,
      EVP_R_GENERATE_ERROR = 214,
      EVP_R_GET_RAW_KEY_FAILED = 182,
      EVP_R_ILLEGAL_SCRYPT_PARAMETERS = 171,
      EVP_R_INACCESSIBLE_DOMAIN_PARAMETERS = 204,
      EVP_R_INACCESSIBLE_KEY = 203,
      EVP_R_INITIALIZATION_ERROR = 134,
      EVP_R_INPUT_NOT_INITIALIZED = 111,
      EVP_R_INVALID_CUSTOM_LENGTH = 185,
      EVP_R_INVALID_DIGEST = 152,
      EVP_R_INVALID_IV_LENGTH = 194,
      EVP_R_INVALID_KEY = 163,
      EVP_R_INVALID_KEY_LENGTH = 130,
      EVP_R_INVALID_LENGTH = 221,
      EVP_R_INVALID_NULL_ALGORITHM = 218,
      EVP_R_INVALID_OPERATION = 148,
      EVP_R_INVALID_PROVIDER_FUNCTIONS = 193,
      EVP_R_INVALID_SALT_LENGTH = 186,
      EVP_R_INVALID_SECRET_LENGTH = 223,
      EVP_R_INVALID_SEED_LENGTH = 220,
      EVP_R_INVALID_VALUE = 222,
      EVP_R_KEYMGMT_EXPORT_FAILURE = 205,
      EVP_R_KEY_SETUP_FAILED = 180,
      EVP_R_LOCKING_NOT_SUPPORTED = 213,
      EVP_R_MEMORY_LIMIT_EXCEEDED = 172,
      EVP_R_MESSAGE_DIGEST_IS_NULL = 159,
      EVP_R_METHOD_NOT_SUPPORTED = 144,
      EVP_R_MISSING_PARAMETERS = 103,
      EVP_R_NOT_ABLE_TO_COPY_CTX = 190,
      EVP_R_NOT_XOF_OR_INVALID_LENGTH = 178,
      EVP_R_NO_CIPHER_SET = 131,
      EVP_R_NO_DEFAULT_DIGEST = 158,
      EVP_R_NO_DIGEST_SET = 139,
      EVP_R_NO_IMPORT_FUNCTION = 206,
      EVP_R_NO_KEYMGMT_AVAILABLE = 199,
      EVP_R_NO_KEYMGMT_PRESENT = 196,
      EVP_R_NO_KEY_SET = 154,
      EVP_R_NO_OPERATION_SET = 149,
      EVP_R_NULL_MAC_PKEY_CTX = 208,
      EVP_R_ONLY_ONESHOT_SUPPORTED = 177,
      EVP_R_OPERATION_NOT_INITIALIZED = 151,
      EVP_R_OPERATION_NOT_SUPPORTED_FOR_THIS_KEYTYPE = 150,
      EVP_R_OUTPUT_WOULD_OVERFLOW = 202,
      EVP_R_PARAMETER_TOO_LARGE = 187,
      EVP_R_PARTIALLY_OVERLAPPING = 162,
      EVP_R_PBKDF2_ERROR = 181,
      EVP_R_PKEY_APPLICATION_ASN1_METHOD_ALREADY_REGISTERED = 179,
      EVP_R_PRIVATE_KEY_DECODE_ERROR = 145,
      EVP_R_PRIVATE_KEY_ENCODE_ERROR = 146,
      EVP_R_PUBLIC_KEY_NOT_RSA = 106,
      EVP_R_SETTING_XOF_FAILED = 227,
      EVP_R_SET_DEFAULT_PROPERTY_FAILURE = 209,
      EVP_R_TOO_MANY_RECORDS = 183,
      EVP_R_UNABLE_TO_ENABLE_LOCKING = 212,
      EVP_R_UNABLE_TO_GET_MAXIMUM_REQUEST_SIZE = 215,
      EVP_R_UNABLE_TO_GET_RANDOM_STRENGTH = 216,
      EVP_R_UNABLE_TO_LOCK_CONTEXT = 211,
      EVP_R_UNABLE_TO_SET_CALLBACKS = 217,
      EVP_R_UNKNOWN_CIPHER = 160,
      EVP_R_UNKNOWN_DIGEST = 161,
      EVP_R_UNKNOWN_KEY_TYPE = 207,
      EVP_R_UNKNOWN_OPTION = 169,
      EVP_R_UNKNOWN_PBE_ALGORITHM = 121,
      EVP_R_UNSUPPORTED_ALGORITHM = 156,
      EVP_R_UNSUPPORTED_CIPHER = 107,
      EVP_R_UNSUPPORTED_KEYLENGTH = 123,
      EVP_R_UNSUPPORTED_KEY_DERIVATION_FUNCTION = 124,
      EVP_R_UNSUPPORTED_KEY_SIZE = 108,
      EVP_R_UNSUPPORTED_KEY_TYPE = 224,
      EVP_R_UNSUPPORTED_NUMBER_OF_ROUNDS = 135,
      EVP_R_UNSUPPORTED_PRF = 125,
      EVP_R_UNSUPPORTED_PRIVATE_KEY_ALGORITHM = 118,
      EVP_R_UNSUPPORTED_SALT_TYPE = 126,
      EVP_R_UPDATE_ERROR = 189,
      EVP_R_WRAP_MODE_NOT_ALLOWED = 170,
      EVP_R_WRONG_FINAL_BLOCK_LENGTH = 109,
      EVP_R_XTS_DATA_UNIT_IS_TOO_LARGE = 191,
      EVP_R_XTS_DUPLICATED_KEYS = 192,
      OSSL_PROV_FIPS_PARAM_MODULE_MAC = "module-mac",
      OSSL_PROV_FIPS_PARAM_INSTALL_VERSION = "install-version",
      OSSL_PROV_FIPS_PARAM_INSTALL_MAC = "install-mac",
      OSSL_PROV_FIPS_PARAM_INSTALL_STATUS = "install-status",
      OSSL_PROV_FIPS_PARAM_CONDITIONAL_ERRORS = "conditional-errors",
      OSSL_PROV_FIPS_PARAM_SECURITY_CHECKS = "security-checks",
      OSSL_HTTP_NAME = "http",
      OSSL_HTTPS_NAME = "https",
      OSSL_HTTP_PORT = 80,
      OSSL_HTTPS_PORT = 443,
      OPENSSL_NO_PROXY = "NO_PROXY",
      OPENSSL_HTTP_PROXY = "HTTP_PROXY",
      OPENSSL_HTTPS_PROXY = "HTTPS_PROXY",
      HTTP_R_ASN1_LEN_EXCEEDS_MAX_RESP_LEN = 108,
      HTTP_R_CONNECT_FAILURE = 100,
      HTTP_R_ERROR_PARSING_ASN1_LENGTH = 109,
      HTTP_R_ERROR_PARSING_CONTENT_LENGTH = 119,
      HTTP_R_ERROR_PARSING_URL = 101,
      HTTP_R_ERROR_RECEIVING = 103,
      HTTP_R_ERROR_SENDING = 102,
      HTTP_R_FAILED_READING_DATA = 128,
      HTTP_R_HEADER_PARSE_ERROR = 126,
      HTTP_R_INCONSISTENT_CONTENT_LENGTH = 120,
      HTTP_R_INVALID_PORT_NUMBER = 123,
      HTTP_R_INVALID_URL_PATH = 125,
      HTTP_R_INVALID_URL_SCHEME = 124,
      HTTP_R_MAX_RESP_LEN_EXCEEDED = 117,
      HTTP_R_MISSING_ASN1_ENCODING = 110,
      HTTP_R_MISSING_CONTENT_TYPE = 121,
      HTTP_R_MISSING_REDIRECT_LOCATION = 111,
      HTTP_R_RECEIVED_ERROR = 105,
      HTTP_R_RECEIVED_WRONG_HTTP_VERSION = 106,
      HTTP_R_REDIRECTION_FROM_HTTPS_TO_HTTP = 112,
      HTTP_R_REDIRECTION_NOT_ENABLED = 116,
      HTTP_R_RESPONSE_LINE_TOO_LONG = 113,
      HTTP_R_RESPONSE_PARSE_ERROR = 104,
      HTTP_R_RETRY_TIMEOUT = 129,
      HTTP_R_SERVER_CANCELED_CONNECTION = 127,
      HTTP_R_SOCK_NOT_SUPPORTED = 122,
      HTTP_R_STATUS_CODE_UNSUPPORTED = 114,
      HTTP_R_TLS_NOT_ENABLED = 107,
      HTTP_R_TOO_MANY_REDIRECTIONS = 115,
      HTTP_R_UNEXPECTED_CONTENT_TYPE = 118,
      EVP_KDF_HKDF_MODE_EXTRACT_AND_EXPAND = "0",
      EVP_KDF_HKDF_MODE_EXTRACT_ONLY = 1,
      EVP_KDF_HKDF_MODE_EXPAND_ONLY = 2,
      EVP_KDF_SSHKDF_TYPE_INITIAL_IV_CLI_TO_SRV = 65,
      EVP_KDF_SSHKDF_TYPE_INITIAL_IV_SRV_TO_CLI = 66,
      EVP_KDF_SSHKDF_TYPE_ENCRYPTION_KEY_CLI_TO_SRV = 67,
      EVP_KDF_SSHKDF_TYPE_ENCRYPTION_KEY_SRV_TO_CLI = 68,
      EVP_KDF_SSHKDF_TYPE_INTEGRITY_KEY_CLI_TO_SRV = 69,
      EVP_KDF_SSHKDF_TYPE_INTEGRITY_KEY_SRV_TO_CLI = 70,
      EVP_PKEY_CTX_hkdf_mode = "EVP_PKEY_CTX_set_hkdf_mode",
      NON_EMPTY_TRANSLATION_UNIT = "static",
      SN_undef = "UNDEF",
      LN_undef = "undefined",
      NID_undef = "0",
      OBJ_undef = "0L",
      SN_itu_t = "ITU-T",
      LN_itu_t = "itu-t",
      NID_itu_t = 645,
      OBJ_itu_t = "0L",
      NID_ccitt = 404,
      OBJ_ccitt = "0L",
      SN_iso = "ISO",
      LN_iso = "iso",
      NID_iso = 181,
      OBJ_iso = 1,
      SN_joint_iso_itu_t = "JOINT-ISO-ITU-T",
      LN_joint_iso_itu_t = "joint-iso-itu-t",
      NID_joint_iso_itu_t = 646,
      OBJ_joint_iso_itu_t = 2,
      NID_joint_iso_ccitt = 393,
      OBJ_joint_iso_ccitt = 2,
      SN_member_body = "member-body",
      LN_member_body = "ISO",
      NID_member_body = 182,
      OBJ_member_body = "OBJ_iso,2L",
      SN_identified_organization = "identified-organization",
      NID_identified_organization = 676,
      OBJ_identified_organization = "OBJ_iso,3L",
      SN_gmac = "GMAC",
      LN_gmac = "gmac",
      NID_gmac = 1195,
      OBJ_gmac = "OBJ_iso,0L,9797L,3L,4L",
      SN_hmac_md5 = "HMAC-MD5",
      LN_hmac_md5 = "hmac-md5",
      NID_hmac_md5 = 780,
      OBJ_hmac_md5 = "OBJ_identified_organization,6L,1L,5L,5L,8L,1L,1L",
      SN_hmac_sha1 = "HMAC-SHA1",
      LN_hmac_sha1 = "hmac-sha1",
      NID_hmac_sha1 = 781,
      OBJ_hmac_sha1 = "OBJ_identified_organization,6L,1L,5L,5L,8L,1L,2L",
      SN_x509ExtAdmission = "x509ExtAdmission",
      LN_x509ExtAdmission = "Professional",
      NID_x509ExtAdmission = 1093,
      OBJ_x509ExtAdmission = "OBJ_identified_organization,36L,8L,3L,3L",
      SN_certicom_arc = "certicom-arc",
      NID_certicom_arc = 677,
      OBJ_certicom_arc = "OBJ_identified_organization,132L",
      SN_ieee = "ieee",
      NID_ieee = 1170,
      OBJ_ieee = "OBJ_identified_organization,111L",
      SN_ieee_siswg = "ieee-siswg",
      LN_ieee_siswg = "IEEE",
      NID_ieee_siswg = 1171,
      OBJ_ieee_siswg = "OBJ_ieee,2L,1619L",
      SN_international_organizations = "international-organizations",
      LN_international_organizations = "International",
      NID_international_organizations = 647,
      OBJ_international_organizations = "OBJ_joint_iso_itu_t,23L",
      SN_wap = "wap",
      NID_wap = 678,
      OBJ_wap = "OBJ_international_organizations,43L",
      SN_wap_wsg = "wap-wsg",
      NID_wap_wsg = 679,
      OBJ_wap_wsg = "OBJ_wap,1L",
      SN_selected_attribute_types = "selected-attribute-types",
      LN_selected_attribute_types = "Selected",
      NID_selected_attribute_types = 394,
      OBJ_selected_attribute_types = "OBJ_joint_iso_itu_t,5L,1L,5L",
      SN_clearance = "clearance",
      NID_clearance = 395,
      OBJ_clearance = "OBJ_selected_attribute_types,55L",
      SN_ISO_US = "ISO-US",
      LN_ISO_US = "ISO",
      NID_ISO_US = 183,
      OBJ_ISO_US = "OBJ_member_body,840L",
      SN_X9_57 = "X9-57",
      LN_X9_57 = "X9.57",
      NID_X9_57 = 184,
      OBJ_X9_57 = "OBJ_ISO_US,10040L",
      SN_X9cm = "X9cm",
      LN_X9cm = "X9.57",
      NID_X9cm = 185,
      OBJ_X9cm = "OBJ_X9_57,4L",
      SN_ISO_CN = "ISO-CN",
      LN_ISO_CN = "ISO",
      NID_ISO_CN = 1140,
      OBJ_ISO_CN = "OBJ_member_body,156L",
      SN_oscca = "oscca",
      NID_oscca = 1141,
      OBJ_oscca = "OBJ_ISO_CN,10197L",
      SN_sm_scheme = "sm-scheme",
      NID_sm_scheme = 1142,
      OBJ_sm_scheme = "OBJ_oscca,1L",
      SN_dsa = "DSA",
      LN_dsa = "dsaEncryption",
      NID_dsa = 116,
      OBJ_dsa = "OBJ_X9cm,1L",
      SN_dsaWithSHA1 = "DSA-SHA1",
      LN_dsaWithSHA1 = "dsaWithSHA1",
      NID_dsaWithSHA1 = 113,
      OBJ_dsaWithSHA1 = "OBJ_X9cm,3L",
      SN_ansi_X9_62 = "ansi-X9-62",
      LN_ansi_X9_62 = "ANSI",
      NID_ansi_X9_62 = 405,
      OBJ_ansi_X9_62 = "OBJ_ISO_US,10045L",
      OBJ_X9_62_id_fieldType = "OBJ_ansi_X9_62,1L",
      SN_X9_62_prime_field = "prime-field",
      NID_X9_62_prime_field = 406,
      OBJ_X9_62_prime_field = "OBJ_X9_62_id_fieldType,1L",
      SN_X9_62_characteristic_two_field = "characteristic-two-field",
      NID_X9_62_characteristic_two_field = 407,
      OBJ_X9_62_characteristic_two_field = "OBJ_X9_62_id_fieldType,2L",
      SN_X9_62_id_characteristic_two_basis = "id-characteristic-two-basis",
      NID_X9_62_id_characteristic_two_basis = 680,
      OBJ_X9_62_id_characteristic_two_basis = "OBJ_X9_62_characteristic_two_field,3L",
      SN_X9_62_onBasis = "onBasis",
      NID_X9_62_onBasis = 681,
      OBJ_X9_62_onBasis = "OBJ_X9_62_id_characteristic_two_basis,1L",
      SN_X9_62_tpBasis = "tpBasis",
      NID_X9_62_tpBasis = 682,
      OBJ_X9_62_tpBasis = "OBJ_X9_62_id_characteristic_two_basis,2L",
      SN_X9_62_ppBasis = "ppBasis",
      NID_X9_62_ppBasis = 683,
      OBJ_X9_62_ppBasis = "OBJ_X9_62_id_characteristic_two_basis,3L",
      OBJ_X9_62_id_publicKeyType = "OBJ_ansi_X9_62,2L",
      SN_X9_62_id_ecPublicKey = "id-ecPublicKey",
      NID_X9_62_id_ecPublicKey = 408,
      OBJ_X9_62_id_ecPublicKey = "OBJ_X9_62_id_publicKeyType,1L",
      OBJ_X9_62_ellipticCurve = "OBJ_ansi_X9_62,3L",
      OBJ_X9_62_c_TwoCurve = "OBJ_X9_62_ellipticCurve,0L",
      SN_X9_62_c2pnb163v1 = "c2pnb163v1",
      NID_X9_62_c2pnb163v1 = 684,
      OBJ_X9_62_c2pnb163v1 = "OBJ_X9_62_c_TwoCurve,1L",
      SN_X9_62_c2pnb163v2 = "c2pnb163v2",
      NID_X9_62_c2pnb163v2 = 685,
      OBJ_X9_62_c2pnb163v2 = "OBJ_X9_62_c_TwoCurve,2L",
      SN_X9_62_c2pnb163v3 = "c2pnb163v3",
      NID_X9_62_c2pnb163v3 = 686,
      OBJ_X9_62_c2pnb163v3 = "OBJ_X9_62_c_TwoCurve,3L",
      SN_X9_62_c2pnb176v1 = "c2pnb176v1",
      NID_X9_62_c2pnb176v1 = 687,
      OBJ_X9_62_c2pnb176v1 = "OBJ_X9_62_c_TwoCurve,4L",
      SN_X9_62_c2tnb191v1 = "c2tnb191v1",
      NID_X9_62_c2tnb191v1 = 688,
      OBJ_X9_62_c2tnb191v1 = "OBJ_X9_62_c_TwoCurve,5L",
      SN_X9_62_c2tnb191v2 = "c2tnb191v2",
      NID_X9_62_c2tnb191v2 = 689,
      OBJ_X9_62_c2tnb191v2 = "OBJ_X9_62_c_TwoCurve,6L",
      SN_X9_62_c2tnb191v3 = "c2tnb191v3",
      NID_X9_62_c2tnb191v3 = 690,
      OBJ_X9_62_c2tnb191v3 = "OBJ_X9_62_c_TwoCurve,7L",
      SN_X9_62_c2onb191v4 = "c2onb191v4",
      NID_X9_62_c2onb191v4 = 691,
      OBJ_X9_62_c2onb191v4 = "OBJ_X9_62_c_TwoCurve,8L",
      SN_X9_62_c2onb191v5 = "c2onb191v5",
      NID_X9_62_c2onb191v5 = 692,
      OBJ_X9_62_c2onb191v5 = "OBJ_X9_62_c_TwoCurve,9L",
      SN_X9_62_c2pnb208w1 = "c2pnb208w1",
      NID_X9_62_c2pnb208w1 = 693,
      OBJ_X9_62_c2pnb208w1 = "OBJ_X9_62_c_TwoCurve,10L",
      SN_X9_62_c2tnb239v1 = "c2tnb239v1",
      NID_X9_62_c2tnb239v1 = 694,
      OBJ_X9_62_c2tnb239v1 = "OBJ_X9_62_c_TwoCurve,11L",
      SN_X9_62_c2tnb239v2 = "c2tnb239v2",
      NID_X9_62_c2tnb239v2 = 695,
      OBJ_X9_62_c2tnb239v2 = "OBJ_X9_62_c_TwoCurve,12L",
      SN_X9_62_c2tnb239v3 = "c2tnb239v3",
      NID_X9_62_c2tnb239v3 = 696,
      OBJ_X9_62_c2tnb239v3 = "OBJ_X9_62_c_TwoCurve,13L",
      SN_X9_62_c2onb239v4 = "c2onb239v4",
      NID_X9_62_c2onb239v4 = 697,
      OBJ_X9_62_c2onb239v4 = "OBJ_X9_62_c_TwoCurve,14L",
      SN_X9_62_c2onb239v5 = "c2onb239v5",
      NID_X9_62_c2onb239v5 = 698,
      OBJ_X9_62_c2onb239v5 = "OBJ_X9_62_c_TwoCurve,15L",
      SN_X9_62_c2pnb272w1 = "c2pnb272w1",
      NID_X9_62_c2pnb272w1 = 699,
      OBJ_X9_62_c2pnb272w1 = "OBJ_X9_62_c_TwoCurve,16L",
      SN_X9_62_c2pnb304w1 = "c2pnb304w1",
      NID_X9_62_c2pnb304w1 = 700,
      OBJ_X9_62_c2pnb304w1 = "OBJ_X9_62_c_TwoCurve,17L",
      SN_X9_62_c2tnb359v1 = "c2tnb359v1",
      NID_X9_62_c2tnb359v1 = 701,
      OBJ_X9_62_c2tnb359v1 = "OBJ_X9_62_c_TwoCurve,18L",
      SN_X9_62_c2pnb368w1 = "c2pnb368w1",
      NID_X9_62_c2pnb368w1 = 702,
      OBJ_X9_62_c2pnb368w1 = "OBJ_X9_62_c_TwoCurve,19L",
      SN_X9_62_c2tnb431r1 = "c2tnb431r1",
      NID_X9_62_c2tnb431r1 = 703,
      OBJ_X9_62_c2tnb431r1 = "OBJ_X9_62_c_TwoCurve,20L",
      OBJ_X9_62_primeCurve = "OBJ_X9_62_ellipticCurve,1L",
      SN_X9_62_prime192v1 = "prime192v1",
      NID_X9_62_prime192v1 = 409,
      OBJ_X9_62_prime192v1 = "OBJ_X9_62_primeCurve,1L",
      SN_X9_62_prime192v2 = "prime192v2",
      NID_X9_62_prime192v2 = 410,
      OBJ_X9_62_prime192v2 = "OBJ_X9_62_primeCurve,2L",
      SN_X9_62_prime192v3 = "prime192v3",
      NID_X9_62_prime192v3 = 411,
      OBJ_X9_62_prime192v3 = "OBJ_X9_62_primeCurve,3L",
      SN_X9_62_prime239v1 = "prime239v1",
      NID_X9_62_prime239v1 = 412,
      OBJ_X9_62_prime239v1 = "OBJ_X9_62_primeCurve,4L",
      SN_X9_62_prime239v2 = "prime239v2",
      NID_X9_62_prime239v2 = 413,
      OBJ_X9_62_prime239v2 = "OBJ_X9_62_primeCurve,5L",
      SN_X9_62_prime239v3 = "prime239v3",
      NID_X9_62_prime239v3 = 414,
      OBJ_X9_62_prime239v3 = "OBJ_X9_62_primeCurve,6L",
      SN_X9_62_prime256v1 = "prime256v1",
      NID_X9_62_prime256v1 = 415,
      OBJ_X9_62_prime256v1 = "OBJ_X9_62_primeCurve,7L",
      OBJ_X9_62_id_ecSigType = "OBJ_ansi_X9_62,4L",
      SN_ecdsa_with_SHA1 = "ecdsa-with-SHA1",
      NID_ecdsa_with_SHA1 = 416,
      OBJ_ecdsa_with_SHA1 = "OBJ_X9_62_id_ecSigType,1L",
      SN_ecdsa_with_Recommended = "ecdsa-with-Recommended",
      NID_ecdsa_with_Recommended = 791,
      OBJ_ecdsa_with_Recommended = "OBJ_X9_62_id_ecSigType,2L",
      SN_ecdsa_with_Specified = "ecdsa-with-Specified",
      NID_ecdsa_with_Specified = 792,
      OBJ_ecdsa_with_Specified = "OBJ_X9_62_id_ecSigType,3L",
      SN_ecdsa_with_SHA224 = "ecdsa-with-SHA224",
      NID_ecdsa_with_SHA224 = 793,
      OBJ_ecdsa_with_SHA224 = "OBJ_ecdsa_with_Specified,1L",
      SN_ecdsa_with_SHA256 = "ecdsa-with-SHA256",
      NID_ecdsa_with_SHA256 = 794,
      OBJ_ecdsa_with_SHA256 = "OBJ_ecdsa_with_Specified,2L",
      SN_ecdsa_with_SHA384 = "ecdsa-with-SHA384",
      NID_ecdsa_with_SHA384 = 795,
      OBJ_ecdsa_with_SHA384 = "OBJ_ecdsa_with_Specified,3L",
      SN_ecdsa_with_SHA512 = "ecdsa-with-SHA512",
      NID_ecdsa_with_SHA512 = 796,
      OBJ_ecdsa_with_SHA512 = "OBJ_ecdsa_with_Specified,4L",
      OBJ_secg_ellipticCurve = "OBJ_certicom_arc,0L",
      SN_secp112r1 = "secp112r1",
      NID_secp112r1 = 704,
      OBJ_secp112r1 = "OBJ_secg_ellipticCurve,6L",
      SN_secp112r2 = "secp112r2",
      NID_secp112r2 = 705,
      OBJ_secp112r2 = "OBJ_secg_ellipticCurve,7L",
      SN_secp128r1 = "secp128r1",
      NID_secp128r1 = 706,
      OBJ_secp128r1 = "OBJ_secg_ellipticCurve,28L",
      SN_secp128r2 = "secp128r2",
      NID_secp128r2 = 707,
      OBJ_secp128r2 = "OBJ_secg_ellipticCurve,29L",
      SN_secp160k1 = "secp160k1",
      NID_secp160k1 = 708,
      OBJ_secp160k1 = "OBJ_secg_ellipticCurve,9L",
      SN_secp160r1 = "secp160r1",
      NID_secp160r1 = 709,
      OBJ_secp160r1 = "OBJ_secg_ellipticCurve,8L",
      SN_secp160r2 = "secp160r2",
      NID_secp160r2 = 710,
      OBJ_secp160r2 = "OBJ_secg_ellipticCurve,30L",
      SN_secp192k1 = "secp192k1",
      NID_secp192k1 = 711,
      OBJ_secp192k1 = "OBJ_secg_ellipticCurve,31L",
      SN_secp224k1 = "secp224k1",
      NID_secp224k1 = 712,
      OBJ_secp224k1 = "OBJ_secg_ellipticCurve,32L",
      SN_secp224r1 = "secp224r1",
      NID_secp224r1 = 713,
      OBJ_secp224r1 = "OBJ_secg_ellipticCurve,33L",
      SN_secp256k1 = "secp256k1",
      NID_secp256k1 = 714,
      OBJ_secp256k1 = "OBJ_secg_ellipticCurve,10L",
      SN_secp384r1 = "secp384r1",
      NID_secp384r1 = 715,
      OBJ_secp384r1 = "OBJ_secg_ellipticCurve,34L",
      SN_secp521r1 = "secp521r1",
      NID_secp521r1 = 716,
      OBJ_secp521r1 = "OBJ_secg_ellipticCurve,35L",
      SN_sect113r1 = "sect113r1",
      NID_sect113r1 = 717,
      OBJ_sect113r1 = "OBJ_secg_ellipticCurve,4L",
      SN_sect113r2 = "sect113r2",
      NID_sect113r2 = 718,
      OBJ_sect113r2 = "OBJ_secg_ellipticCurve,5L",
      SN_sect131r1 = "sect131r1",
      NID_sect131r1 = 719,
      OBJ_sect131r1 = "OBJ_secg_ellipticCurve,22L",
      SN_sect131r2 = "sect131r2",
      NID_sect131r2 = 720,
      OBJ_sect131r2 = "OBJ_secg_ellipticCurve,23L",
      SN_sect163k1 = "sect163k1",
      NID_sect163k1 = 721,
      OBJ_sect163k1 = "OBJ_secg_ellipticCurve,1L",
      SN_sect163r1 = "sect163r1",
      NID_sect163r1 = 722,
      OBJ_sect163r1 = "OBJ_secg_ellipticCurve,2L",
      SN_sect163r2 = "sect163r2",
      NID_sect163r2 = 723,
      OBJ_sect163r2 = "OBJ_secg_ellipticCurve,15L",
      SN_sect193r1 = "sect193r1",
      NID_sect193r1 = 724,
      OBJ_sect193r1 = "OBJ_secg_ellipticCurve,24L",
      SN_sect193r2 = "sect193r2",
      NID_sect193r2 = 725,
      OBJ_sect193r2 = "OBJ_secg_ellipticCurve,25L",
      SN_sect233k1 = "sect233k1",
      NID_sect233k1 = 726,
      OBJ_sect233k1 = "OBJ_secg_ellipticCurve,26L",
      SN_sect233r1 = "sect233r1",
      NID_sect233r1 = 727,
      OBJ_sect233r1 = "OBJ_secg_ellipticCurve,27L",
      SN_sect239k1 = "sect239k1",
      NID_sect239k1 = 728,
      OBJ_sect239k1 = "OBJ_secg_ellipticCurve,3L",
      SN_sect283k1 = "sect283k1",
      NID_sect283k1 = 729,
      OBJ_sect283k1 = "OBJ_secg_ellipticCurve,16L",
      SN_sect283r1 = "sect283r1",
      NID_sect283r1 = 730,
      OBJ_sect283r1 = "OBJ_secg_ellipticCurve,17L",
      SN_sect409k1 = "sect409k1",
      NID_sect409k1 = 731,
      OBJ_sect409k1 = "OBJ_secg_ellipticCurve,36L",
      SN_sect409r1 = "sect409r1",
      NID_sect409r1 = 732,
      OBJ_sect409r1 = "OBJ_secg_ellipticCurve,37L",
      SN_sect571k1 = "sect571k1",
      NID_sect571k1 = 733,
      OBJ_sect571k1 = "OBJ_secg_ellipticCurve,38L",
      SN_sect571r1 = "sect571r1",
      NID_sect571r1 = 734,
      OBJ_sect571r1 = "OBJ_secg_ellipticCurve,39L",
      OBJ_wap_wsg_idm_ecid = "OBJ_wap_wsg,4L",
      SN_wap_wsg_idm_ecid_wtls1 = "wap-wsg-idm-ecid-wtls1",
      NID_wap_wsg_idm_ecid_wtls1 = 735,
      OBJ_wap_wsg_idm_ecid_wtls1 = "OBJ_wap_wsg_idm_ecid,1L",
      SN_wap_wsg_idm_ecid_wtls3 = "wap-wsg-idm-ecid-wtls3",
      NID_wap_wsg_idm_ecid_wtls3 = 736,
      OBJ_wap_wsg_idm_ecid_wtls3 = "OBJ_wap_wsg_idm_ecid,3L",
      SN_wap_wsg_idm_ecid_wtls4 = "wap-wsg-idm-ecid-wtls4",
      NID_wap_wsg_idm_ecid_wtls4 = 737,
      OBJ_wap_wsg_idm_ecid_wtls4 = "OBJ_wap_wsg_idm_ecid,4L",
      SN_wap_wsg_idm_ecid_wtls5 = "wap-wsg-idm-ecid-wtls5",
      NID_wap_wsg_idm_ecid_wtls5 = 738,
      OBJ_wap_wsg_idm_ecid_wtls5 = "OBJ_wap_wsg_idm_ecid,5L",
      SN_wap_wsg_idm_ecid_wtls6 = "wap-wsg-idm-ecid-wtls6",
      NID_wap_wsg_idm_ecid_wtls6 = 739,
      OBJ_wap_wsg_idm_ecid_wtls6 = "OBJ_wap_wsg_idm_ecid,6L",
      SN_wap_wsg_idm_ecid_wtls7 = "wap-wsg-idm-ecid-wtls7",
      NID_wap_wsg_idm_ecid_wtls7 = 740,
      OBJ_wap_wsg_idm_ecid_wtls7 = "OBJ_wap_wsg_idm_ecid,7L",
      SN_wap_wsg_idm_ecid_wtls8 = "wap-wsg-idm-ecid-wtls8",
      NID_wap_wsg_idm_ecid_wtls8 = 741,
      OBJ_wap_wsg_idm_ecid_wtls8 = "OBJ_wap_wsg_idm_ecid,8L",
      SN_wap_wsg_idm_ecid_wtls9 = "wap-wsg-idm-ecid-wtls9",
      NID_wap_wsg_idm_ecid_wtls9 = 742,
      OBJ_wap_wsg_idm_ecid_wtls9 = "OBJ_wap_wsg_idm_ecid,9L",
      SN_wap_wsg_idm_ecid_wtls10 = "wap-wsg-idm-ecid-wtls10",
      NID_wap_wsg_idm_ecid_wtls10 = 743,
      OBJ_wap_wsg_idm_ecid_wtls10 = "OBJ_wap_wsg_idm_ecid,10L",
      SN_wap_wsg_idm_ecid_wtls11 = "wap-wsg-idm-ecid-wtls11",
      NID_wap_wsg_idm_ecid_wtls11 = 744,
      OBJ_wap_wsg_idm_ecid_wtls11 = "OBJ_wap_wsg_idm_ecid,11L",
      SN_wap_wsg_idm_ecid_wtls12 = "wap-wsg-idm-ecid-wtls12",
      NID_wap_wsg_idm_ecid_wtls12 = 745,
      OBJ_wap_wsg_idm_ecid_wtls12 = "OBJ_wap_wsg_idm_ecid,12L",
      SN_cast5_cbc = "CAST5-CBC",
      LN_cast5_cbc = "cast5-cbc",
      NID_cast5_cbc = 108,
      OBJ_cast5_cbc = "OBJ_ISO_US,113533L,7L,66L,10L",
      SN_cast5_ecb = "CAST5-ECB",
      LN_cast5_ecb = "cast5-ecb",
      NID_cast5_ecb = 109,
      SN_cast5_cfb64 = "CAST5-CFB",
      LN_cast5_cfb64 = "cast5-cfb",
      NID_cast5_cfb64 = 110,
      SN_cast5_ofb64 = "CAST5-OFB",
      LN_cast5_ofb64 = "cast5-ofb",
      NID_cast5_ofb64 = 111,
      LN_pbeWithMD5AndCast5_CBC = "pbeWithMD5AndCast5CBC",
      NID_pbeWithMD5AndCast5_CBC = 112,
      OBJ_pbeWithMD5AndCast5_CBC = "OBJ_ISO_US,113533L,7L,66L,12L",
      SN_id_PasswordBasedMAC = "id-PasswordBasedMAC",
      LN_id_PasswordBasedMAC = "password",
      NID_id_PasswordBasedMAC = 782,
      OBJ_id_PasswordBasedMAC = "OBJ_ISO_US,113533L,7L,66L,13L",
      SN_id_DHBasedMac = "id-DHBasedMac",
      LN_id_DHBasedMac = "Diffie-Hellman",
      NID_id_DHBasedMac = 783,
      OBJ_id_DHBasedMac = "OBJ_ISO_US,113533L,7L,66L,30L",
      SN_rsadsi = "rsadsi",
      LN_rsadsi = "RSA",
      NID_rsadsi = 1,
      OBJ_rsadsi = "OBJ_ISO_US,113549L",
      SN_pkcs = "pkcs",
      LN_pkcs = "RSA",
      NID_pkcs = 2,
      OBJ_pkcs = "OBJ_rsadsi,1L",
      SN_pkcs1 = "pkcs1",
      NID_pkcs1 = 186,
      OBJ_pkcs1 = "OBJ_pkcs,1L",
      LN_rsaEncryption = "rsaEncryption",
      NID_rsaEncryption = 6,
      OBJ_rsaEncryption = "OBJ_pkcs1,1L",
      SN_md2WithRSAEncryption = "RSA-MD2",
      LN_md2WithRSAEncryption = "md2WithRSAEncryption",
      NID_md2WithRSAEncryption = 7,
      OBJ_md2WithRSAEncryption = "OBJ_pkcs1,2L",
      SN_md4WithRSAEncryption = "RSA-MD4",
      LN_md4WithRSAEncryption = "md4WithRSAEncryption",
      NID_md4WithRSAEncryption = 396,
      OBJ_md4WithRSAEncryption = "OBJ_pkcs1,3L",
      SN_md5WithRSAEncryption = "RSA-MD5",
      LN_md5WithRSAEncryption = "md5WithRSAEncryption",
      NID_md5WithRSAEncryption = 8,
      OBJ_md5WithRSAEncryption = "OBJ_pkcs1,4L",
      SN_sha1WithRSAEncryption = "RSA-SHA1",
      LN_sha1WithRSAEncryption = "sha1WithRSAEncryption",
      NID_sha1WithRSAEncryption = 65,
      OBJ_sha1WithRSAEncryption = "OBJ_pkcs1,5L",
      SN_rsaesOaep = "RSAES-OAEP",
      LN_rsaesOaep = "rsaesOaep",
      NID_rsaesOaep = 919,
      OBJ_rsaesOaep = "OBJ_pkcs1,7L",
      SN_mgf1 = "MGF1",
      LN_mgf1 = "mgf1",
      NID_mgf1 = 911,
      OBJ_mgf1 = "OBJ_pkcs1,8L",
      SN_pSpecified = "PSPECIFIED",
      LN_pSpecified = "pSpecified",
      NID_pSpecified = 935,
      OBJ_pSpecified = "OBJ_pkcs1,9L",
      SN_rsassaPss = "RSASSA-PSS",
      LN_rsassaPss = "rsassaPss",
      NID_rsassaPss = 912,
      OBJ_rsassaPss = "OBJ_pkcs1,10L",
      SN_sha256WithRSAEncryption = "RSA-SHA256",
      LN_sha256WithRSAEncryption = "sha256WithRSAEncryption",
      NID_sha256WithRSAEncryption = 668,
      OBJ_sha256WithRSAEncryption = "OBJ_pkcs1,11L",
      SN_sha384WithRSAEncryption = "RSA-SHA384",
      LN_sha384WithRSAEncryption = "sha384WithRSAEncryption",
      NID_sha384WithRSAEncryption = 669,
      OBJ_sha384WithRSAEncryption = "OBJ_pkcs1,12L",
      SN_sha512WithRSAEncryption = "RSA-SHA512",
      LN_sha512WithRSAEncryption = "sha512WithRSAEncryption",
      NID_sha512WithRSAEncryption = 670,
      OBJ_sha512WithRSAEncryption = "OBJ_pkcs1,13L",
      SN_sha224WithRSAEncryption = "RSA-SHA224",
      LN_sha224WithRSAEncryption = "sha224WithRSAEncryption",
      NID_sha224WithRSAEncryption = 671,
      OBJ_sha224WithRSAEncryption = "OBJ_pkcs1,14L",
      LN_sha512_224WithRSAEncryption = "sha512-224WithRSAEncryption",
      NID_sha512_224WithRSAEncryption = 1145,
      OBJ_sha512_224WithRSAEncryption = "OBJ_pkcs1,15L",
      LN_sha512_256WithRSAEncryption = "sha512-256WithRSAEncryption",
      NID_sha512_256WithRSAEncryption = 1146,
      OBJ_sha512_256WithRSAEncryption = "OBJ_pkcs1,16L",
      SN_pkcs3 = "pkcs3",
      NID_pkcs3 = 27,
      OBJ_pkcs3 = "OBJ_pkcs,3L",
      LN_dhKeyAgreement = "dhKeyAgreement",
      NID_dhKeyAgreement = 28,
      OBJ_dhKeyAgreement = "OBJ_pkcs3,1L",
      SN_pkcs5 = "pkcs5",
      NID_pkcs5 = 187,
      OBJ_pkcs5 = "OBJ_pkcs,5L",
      SN_pbeWithMD2AndDES_CBC = "PBE-MD2-DES",
      LN_pbeWithMD2AndDES_CBC = "pbeWithMD2AndDES-CBC",
      NID_pbeWithMD2AndDES_CBC = 9,
      OBJ_pbeWithMD2AndDES_CBC = "OBJ_pkcs5,1L",
      SN_pbeWithMD5AndDES_CBC = "PBE-MD5-DES",
      LN_pbeWithMD5AndDES_CBC = "pbeWithMD5AndDES-CBC",
      NID_pbeWithMD5AndDES_CBC = 10,
      OBJ_pbeWithMD5AndDES_CBC = "OBJ_pkcs5,3L",
      SN_pbeWithMD2AndRC2_CBC = "PBE-MD2-RC2-64",
      LN_pbeWithMD2AndRC2_CBC = "pbeWithMD2AndRC2-CBC",
      NID_pbeWithMD2AndRC2_CBC = 168,
      OBJ_pbeWithMD2AndRC2_CBC = "OBJ_pkcs5,4L",
      SN_pbeWithMD5AndRC2_CBC = "PBE-MD5-RC2-64",
      LN_pbeWithMD5AndRC2_CBC = "pbeWithMD5AndRC2-CBC",
      NID_pbeWithMD5AndRC2_CBC = 169,
      OBJ_pbeWithMD5AndRC2_CBC = "OBJ_pkcs5,6L",
      SN_pbeWithSHA1AndDES_CBC = "PBE-SHA1-DES",
      LN_pbeWithSHA1AndDES_CBC = "pbeWithSHA1AndDES-CBC",
      NID_pbeWithSHA1AndDES_CBC = 170,
      OBJ_pbeWithSHA1AndDES_CBC = "OBJ_pkcs5,10L",
      SN_pbeWithSHA1AndRC2_CBC = "PBE-SHA1-RC2-64",
      LN_pbeWithSHA1AndRC2_CBC = "pbeWithSHA1AndRC2-CBC",
      NID_pbeWithSHA1AndRC2_CBC = 68,
      OBJ_pbeWithSHA1AndRC2_CBC = "OBJ_pkcs5,11L",
      LN_id_pbkdf2 = "PBKDF2",
      NID_id_pbkdf2 = 69,
      OBJ_id_pbkdf2 = "OBJ_pkcs5,12L",
      LN_pbes2 = "PBES2",
      NID_pbes2 = 161,
      OBJ_pbes2 = "OBJ_pkcs5,13L",
      LN_pbmac1 = "PBMAC1",
      NID_pbmac1 = 162,
      OBJ_pbmac1 = "OBJ_pkcs5,14L",
      SN_pkcs7 = "pkcs7",
      NID_pkcs7 = 20,
      OBJ_pkcs7 = "OBJ_pkcs,7L",
      LN_pkcs7_data = "pkcs7-data",
      NID_pkcs7_data = 21,
      OBJ_pkcs7_data = "OBJ_pkcs7,1L",
      LN_pkcs7_signed = "pkcs7-signedData",
      NID_pkcs7_signed = 22,
      OBJ_pkcs7_signed = "OBJ_pkcs7,2L",
      LN_pkcs7_enveloped = "pkcs7-envelopedData",
      NID_pkcs7_enveloped = 23,
      OBJ_pkcs7_enveloped = "OBJ_pkcs7,3L",
      LN_pkcs7_signedAndEnveloped = "pkcs7-signedAndEnvelopedData",
      NID_pkcs7_signedAndEnveloped = 24,
      OBJ_pkcs7_signedAndEnveloped = "OBJ_pkcs7,4L",
      LN_pkcs7_digest = "pkcs7-digestData",
      NID_pkcs7_digest = 25,
      OBJ_pkcs7_digest = "OBJ_pkcs7,5L",
      LN_pkcs7_encrypted = "pkcs7-encryptedData",
      NID_pkcs7_encrypted = 26,
      OBJ_pkcs7_encrypted = "OBJ_pkcs7,6L",
      SN_pkcs9 = "pkcs9",
      NID_pkcs9 = 47,
      OBJ_pkcs9 = "OBJ_pkcs,9L",
      LN_pkcs9_emailAddress = "emailAddress",
      NID_pkcs9_emailAddress = 48,
      OBJ_pkcs9_emailAddress = "OBJ_pkcs9,1L",
      LN_pkcs9_unstructuredName = "unstructuredName",
      NID_pkcs9_unstructuredName = 49,
      OBJ_pkcs9_unstructuredName = "OBJ_pkcs9,2L",
      LN_pkcs9_contentType = "contentType",
      NID_pkcs9_contentType = 50,
      OBJ_pkcs9_contentType = "OBJ_pkcs9,3L",
      LN_pkcs9_messageDigest = "messageDigest",
      NID_pkcs9_messageDigest = 51,
      OBJ_pkcs9_messageDigest = "OBJ_pkcs9,4L",
      LN_pkcs9_signingTime = "signingTime",
      NID_pkcs9_signingTime = 52,
      OBJ_pkcs9_signingTime = "OBJ_pkcs9,5L",
      LN_pkcs9_countersignature = "countersignature",
      NID_pkcs9_countersignature = 53,
      OBJ_pkcs9_countersignature = "OBJ_pkcs9,6L",
      LN_pkcs9_challengePassword = "challengePassword",
      NID_pkcs9_challengePassword = 54,
      OBJ_pkcs9_challengePassword = "OBJ_pkcs9,7L",
      LN_pkcs9_unstructuredAddress = "unstructuredAddress",
      NID_pkcs9_unstructuredAddress = 55,
      OBJ_pkcs9_unstructuredAddress = "OBJ_pkcs9,8L",
      LN_pkcs9_extCertAttributes = "extendedCertificateAttributes",
      NID_pkcs9_extCertAttributes = 56,
      OBJ_pkcs9_extCertAttributes = "OBJ_pkcs9,9L",
      SN_ext_req = "extReq",
      LN_ext_req = "Extension",
      NID_ext_req = 172,
      OBJ_ext_req = "OBJ_pkcs9,14L",
      SN_SMIMECapabilities = "SMIME-CAPS",
      NID_SMIMECapabilities = 167,
      OBJ_SMIMECapabilities = "OBJ_pkcs9,15L",
      SN_SMIME = "SMIME",
      NID_SMIME = 188,
      OBJ_SMIME = "OBJ_pkcs9,16L",
      SN_id_smime_mod = "id-smime-mod",
      NID_id_smime_mod = 189,
      OBJ_id_smime_mod = "OBJ_SMIME,0L",
      SN_id_smime_ct = "id-smime-ct",
      NID_id_smime_ct = 190,
      OBJ_id_smime_ct = "OBJ_SMIME,1L",
      SN_id_smime_aa = "id-smime-aa",
      NID_id_smime_aa = 191,
      OBJ_id_smime_aa = "OBJ_SMIME,2L",
      SN_id_smime_alg = "id-smime-alg",
      NID_id_smime_alg = 192,
      OBJ_id_smime_alg = "OBJ_SMIME,3L",
      SN_id_smime_cd = "id-smime-cd",
      NID_id_smime_cd = 193,
      OBJ_id_smime_cd = "OBJ_SMIME,4L",
      SN_id_smime_spq = "id-smime-spq",
      NID_id_smime_spq = 194,
      OBJ_id_smime_spq = "OBJ_SMIME,5L",
      SN_id_smime_cti = "id-smime-cti",
      NID_id_smime_cti = 195,
      OBJ_id_smime_cti = "OBJ_SMIME,6L",
      SN_id_smime_mod_cms = "id-smime-mod-cms",
      NID_id_smime_mod_cms = 196,
      OBJ_id_smime_mod_cms = "OBJ_id_smime_mod,1L",
      SN_id_smime_mod_ess = "id-smime-mod-ess",
      NID_id_smime_mod_ess = 197,
      OBJ_id_smime_mod_ess = "OBJ_id_smime_mod,2L",
      SN_id_smime_mod_oid = "id-smime-mod-oid",
      NID_id_smime_mod_oid = 198,
      OBJ_id_smime_mod_oid = "OBJ_id_smime_mod,3L",
      SN_id_smime_mod_msg_v3 = "id-smime-mod-msg-v3",
      NID_id_smime_mod_msg_v3 = 199,
      OBJ_id_smime_mod_msg_v3 = "OBJ_id_smime_mod,4L",
      SN_id_smime_mod_ets_eSignature_88 = "id-smime-mod-ets-eSignature-88",
      NID_id_smime_mod_ets_eSignature_88 = 200,
      OBJ_id_smime_mod_ets_eSignature_88 = "OBJ_id_smime_mod,5L",
      SN_id_smime_mod_ets_eSignature_97 = "id-smime-mod-ets-eSignature-97",
      NID_id_smime_mod_ets_eSignature_97 = 201,
      OBJ_id_smime_mod_ets_eSignature_97 = "OBJ_id_smime_mod,6L",
      SN_id_smime_mod_ets_eSigPolicy_88 = "id-smime-mod-ets-eSigPolicy-88",
      NID_id_smime_mod_ets_eSigPolicy_88 = 202,
      OBJ_id_smime_mod_ets_eSigPolicy_88 = "OBJ_id_smime_mod,7L",
      SN_id_smime_mod_ets_eSigPolicy_97 = "id-smime-mod-ets-eSigPolicy-97",
      NID_id_smime_mod_ets_eSigPolicy_97 = 203,
      OBJ_id_smime_mod_ets_eSigPolicy_97 = "OBJ_id_smime_mod,8L",
      SN_id_smime_ct_receipt = "id-smime-ct-receipt",
      NID_id_smime_ct_receipt = 204,
      OBJ_id_smime_ct_receipt = "OBJ_id_smime_ct,1L",
      SN_id_smime_ct_authData = "id-smime-ct-authData",
      NID_id_smime_ct_authData = 205,
      OBJ_id_smime_ct_authData = "OBJ_id_smime_ct,2L",
      SN_id_smime_ct_publishCert = "id-smime-ct-publishCert",
      NID_id_smime_ct_publishCert = 206,
      OBJ_id_smime_ct_publishCert = "OBJ_id_smime_ct,3L",
      SN_id_smime_ct_TSTInfo = "id-smime-ct-TSTInfo",
      NID_id_smime_ct_TSTInfo = 207,
      OBJ_id_smime_ct_TSTInfo = "OBJ_id_smime_ct,4L",
      SN_id_smime_ct_TDTInfo = "id-smime-ct-TDTInfo",
      NID_id_smime_ct_TDTInfo = 208,
      OBJ_id_smime_ct_TDTInfo = "OBJ_id_smime_ct,5L",
      SN_id_smime_ct_contentInfo = "id-smime-ct-contentInfo",
      NID_id_smime_ct_contentInfo = 209,
      OBJ_id_smime_ct_contentInfo = "OBJ_id_smime_ct,6L",
      SN_id_smime_ct_DVCSRequestData = "id-smime-ct-DVCSRequestData",
      NID_id_smime_ct_DVCSRequestData = 210,
      OBJ_id_smime_ct_DVCSRequestData = "OBJ_id_smime_ct,7L",
      SN_id_smime_ct_DVCSResponseData = "id-smime-ct-DVCSResponseData",
      NID_id_smime_ct_DVCSResponseData = 211,
      OBJ_id_smime_ct_DVCSResponseData = "OBJ_id_smime_ct,8L",
      SN_id_smime_ct_compressedData = "id-smime-ct-compressedData",
      NID_id_smime_ct_compressedData = 786,
      OBJ_id_smime_ct_compressedData = "OBJ_id_smime_ct,9L",
      SN_id_smime_ct_contentCollection = "id-smime-ct-contentCollection",
      NID_id_smime_ct_contentCollection = 1058,
      OBJ_id_smime_ct_contentCollection = "OBJ_id_smime_ct,19L",
      SN_id_smime_ct_authEnvelopedData = "id-smime-ct-authEnvelopedData",
      NID_id_smime_ct_authEnvelopedData = 1059,
      OBJ_id_smime_ct_authEnvelopedData = "OBJ_id_smime_ct,23L",
      SN_id_ct_routeOriginAuthz = "id-ct-routeOriginAuthz",
      NID_id_ct_routeOriginAuthz = 1234,
      OBJ_id_ct_routeOriginAuthz = "OBJ_id_smime_ct,24L",
      SN_id_ct_rpkiManifest = "id-ct-rpkiManifest",
      NID_id_ct_rpkiManifest = 1235,
      OBJ_id_ct_rpkiManifest = "OBJ_id_smime_ct,26L",
      SN_id_ct_asciiTextWithCRLF = "id-ct-asciiTextWithCRLF",
      NID_id_ct_asciiTextWithCRLF = 787,
      OBJ_id_ct_asciiTextWithCRLF = "OBJ_id_smime_ct,27L",
      SN_id_ct_xml = "id-ct-xml",
      NID_id_ct_xml = 1060,
      OBJ_id_ct_xml = "OBJ_id_smime_ct,28L",
      SN_id_ct_rpkiGhostbusters = "id-ct-rpkiGhostbusters",
      NID_id_ct_rpkiGhostbusters = 1236,
      OBJ_id_ct_rpkiGhostbusters = "OBJ_id_smime_ct,35L",
      SN_id_ct_resourceTaggedAttest = "id-ct-resourceTaggedAttest",
      NID_id_ct_resourceTaggedAttest = 1237,
      OBJ_id_ct_resourceTaggedAttest = "OBJ_id_smime_ct,36L",
      SN_id_ct_geofeedCSVwithCRLF = "id-ct-geofeedCSVwithCRLF",
      NID_id_ct_geofeedCSVwithCRLF = 1246,
      OBJ_id_ct_geofeedCSVwithCRLF = "OBJ_id_smime_ct,47L",
      SN_id_ct_signedChecklist = "id-ct-signedChecklist",
      NID_id_ct_signedChecklist = 1247,
      OBJ_id_ct_signedChecklist = "OBJ_id_smime_ct,48L",
      SN_id_smime_aa_receiptRequest = "id-smime-aa-receiptRequest",
      NID_id_smime_aa_receiptRequest = 212,
      OBJ_id_smime_aa_receiptRequest = "OBJ_id_smime_aa,1L",
      SN_id_smime_aa_securityLabel = "id-smime-aa-securityLabel",
      NID_id_smime_aa_securityLabel = 213,
      OBJ_id_smime_aa_securityLabel = "OBJ_id_smime_aa,2L",
      SN_id_smime_aa_mlExpandHistory = "id-smime-aa-mlExpandHistory",
      NID_id_smime_aa_mlExpandHistory = 214,
      OBJ_id_smime_aa_mlExpandHistory = "OBJ_id_smime_aa,3L",
      SN_id_smime_aa_contentHint = "id-smime-aa-contentHint",
      NID_id_smime_aa_contentHint = 215,
      OBJ_id_smime_aa_contentHint = "OBJ_id_smime_aa,4L",
      SN_id_smime_aa_msgSigDigest = "id-smime-aa-msgSigDigest",
      NID_id_smime_aa_msgSigDigest = 216,
      OBJ_id_smime_aa_msgSigDigest = "OBJ_id_smime_aa,5L",
      SN_id_smime_aa_encapContentType = "id-smime-aa-encapContentType",
      NID_id_smime_aa_encapContentType = 217,
      OBJ_id_smime_aa_encapContentType = "OBJ_id_smime_aa,6L",
      SN_id_smime_aa_contentIdentifier = "id-smime-aa-contentIdentifier",
      NID_id_smime_aa_contentIdentifier = 218,
      OBJ_id_smime_aa_contentIdentifier = "OBJ_id_smime_aa,7L",
      SN_id_smime_aa_macValue = "id-smime-aa-macValue",
      NID_id_smime_aa_macValue = 219,
      OBJ_id_smime_aa_macValue = "OBJ_id_smime_aa,8L",
      SN_id_smime_aa_equivalentLabels = "id-smime-aa-equivalentLabels",
      NID_id_smime_aa_equivalentLabels = 220,
      OBJ_id_smime_aa_equivalentLabels = "OBJ_id_smime_aa,9L",
      SN_id_smime_aa_contentReference = "id-smime-aa-contentReference",
      NID_id_smime_aa_contentReference = 221,
      OBJ_id_smime_aa_contentReference = "OBJ_id_smime_aa,10L",
      SN_id_smime_aa_encrypKeyPref = "id-smime-aa-encrypKeyPref",
      NID_id_smime_aa_encrypKeyPref = 222,
      OBJ_id_smime_aa_encrypKeyPref = "OBJ_id_smime_aa,11L",
      SN_id_smime_aa_signingCertificate = "id-smime-aa-signingCertificate",
      NID_id_smime_aa_signingCertificate = 223,
      OBJ_id_smime_aa_signingCertificate = "OBJ_id_smime_aa,12L",
      SN_id_smime_aa_smimeEncryptCerts = "id-smime-aa-smimeEncryptCerts",
      NID_id_smime_aa_smimeEncryptCerts = 224,
      OBJ_id_smime_aa_smimeEncryptCerts = "OBJ_id_smime_aa,13L",
      SN_id_smime_aa_timeStampToken = "id-smime-aa-timeStampToken",
      NID_id_smime_aa_timeStampToken = 225,
      OBJ_id_smime_aa_timeStampToken = "OBJ_id_smime_aa,14L",
      SN_id_smime_aa_ets_sigPolicyId = "id-smime-aa-ets-sigPolicyId",
      NID_id_smime_aa_ets_sigPolicyId = 226,
      OBJ_id_smime_aa_ets_sigPolicyId = "OBJ_id_smime_aa,15L",
      SN_id_smime_aa_ets_commitmentType = "id-smime-aa-ets-commitmentType",
      NID_id_smime_aa_ets_commitmentType = 227,
      OBJ_id_smime_aa_ets_commitmentType = "OBJ_id_smime_aa,16L",
      SN_id_smime_aa_ets_signerLocation = "id-smime-aa-ets-signerLocation",
      NID_id_smime_aa_ets_signerLocation = 228,
      OBJ_id_smime_aa_ets_signerLocation = "OBJ_id_smime_aa,17L",
      SN_id_smime_aa_ets_signerAttr = "id-smime-aa-ets-signerAttr",
      NID_id_smime_aa_ets_signerAttr = 229,
      OBJ_id_smime_aa_ets_signerAttr = "OBJ_id_smime_aa,18L",
      SN_id_smime_aa_ets_otherSigCert = "id-smime-aa-ets-otherSigCert",
      NID_id_smime_aa_ets_otherSigCert = 230,
      OBJ_id_smime_aa_ets_otherSigCert = "OBJ_id_smime_aa,19L",
      SN_id_smime_aa_ets_contentTimestamp = "id-smime-aa-ets-contentTimestamp",
      NID_id_smime_aa_ets_contentTimestamp = 231,
      OBJ_id_smime_aa_ets_contentTimestamp = "OBJ_id_smime_aa,20L",
      SN_id_smime_aa_ets_CertificateRefs = "id-smime-aa-ets-CertificateRefs",
      NID_id_smime_aa_ets_CertificateRefs = 232,
      OBJ_id_smime_aa_ets_CertificateRefs = "OBJ_id_smime_aa,21L",
      SN_id_smime_aa_ets_RevocationRefs = "id-smime-aa-ets-RevocationRefs",
      NID_id_smime_aa_ets_RevocationRefs = 233,
      OBJ_id_smime_aa_ets_RevocationRefs = "OBJ_id_smime_aa,22L",
      SN_id_smime_aa_ets_certValues = "id-smime-aa-ets-certValues",
      NID_id_smime_aa_ets_certValues = 234,
      OBJ_id_smime_aa_ets_certValues = "OBJ_id_smime_aa,23L",
      SN_id_smime_aa_ets_revocationValues = "id-smime-aa-ets-revocationValues",
      NID_id_smime_aa_ets_revocationValues = 235,
      OBJ_id_smime_aa_ets_revocationValues = "OBJ_id_smime_aa,24L",
      SN_id_smime_aa_ets_escTimeStamp = "id-smime-aa-ets-escTimeStamp",
      NID_id_smime_aa_ets_escTimeStamp = 236,
      OBJ_id_smime_aa_ets_escTimeStamp = "OBJ_id_smime_aa,25L",
      SN_id_smime_aa_ets_certCRLTimestamp = "id-smime-aa-ets-certCRLTimestamp",
      NID_id_smime_aa_ets_certCRLTimestamp = 237,
      OBJ_id_smime_aa_ets_certCRLTimestamp = "OBJ_id_smime_aa,26L",
      SN_id_smime_aa_ets_archiveTimeStamp = "id-smime-aa-ets-archiveTimeStamp",
      NID_id_smime_aa_ets_archiveTimeStamp = 238,
      OBJ_id_smime_aa_ets_archiveTimeStamp = "OBJ_id_smime_aa,27L",
      SN_id_smime_aa_signatureType = "id-smime-aa-signatureType",
      NID_id_smime_aa_signatureType = 239,
      OBJ_id_smime_aa_signatureType = "OBJ_id_smime_aa,28L",
      SN_id_smime_aa_dvcs_dvc = "id-smime-aa-dvcs-dvc",
      NID_id_smime_aa_dvcs_dvc = 240,
      OBJ_id_smime_aa_dvcs_dvc = "OBJ_id_smime_aa,29L",
      SN_id_smime_aa_signingCertificateV2 = "id-smime-aa-signingCertificateV2",
      NID_id_smime_aa_signingCertificateV2 = 1086,
      OBJ_id_smime_aa_signingCertificateV2 = "OBJ_id_smime_aa,47L",
      SN_id_smime_alg_ESDHwith3DES = "id-smime-alg-ESDHwith3DES",
      NID_id_smime_alg_ESDHwith3DES = 241,
      OBJ_id_smime_alg_ESDHwith3DES = "OBJ_id_smime_alg,1L",
      SN_id_smime_alg_ESDHwithRC2 = "id-smime-alg-ESDHwithRC2",
      NID_id_smime_alg_ESDHwithRC2 = 242,
      OBJ_id_smime_alg_ESDHwithRC2 = "OBJ_id_smime_alg,2L",
      SN_id_smime_alg_3DESwrap = "id-smime-alg-3DESwrap",
      NID_id_smime_alg_3DESwrap = 243,
      OBJ_id_smime_alg_3DESwrap = "OBJ_id_smime_alg,3L",
      SN_id_smime_alg_RC2wrap = "id-smime-alg-RC2wrap",
      NID_id_smime_alg_RC2wrap = 244,
      OBJ_id_smime_alg_RC2wrap = "OBJ_id_smime_alg,4L",
      SN_id_smime_alg_ESDH = "id-smime-alg-ESDH",
      NID_id_smime_alg_ESDH = 245,
      OBJ_id_smime_alg_ESDH = "OBJ_id_smime_alg,5L",
      SN_id_smime_alg_CMS3DESwrap = "id-smime-alg-CMS3DESwrap",
      NID_id_smime_alg_CMS3DESwrap = 246,
      OBJ_id_smime_alg_CMS3DESwrap = "OBJ_id_smime_alg,6L",
      SN_id_smime_alg_CMSRC2wrap = "id-smime-alg-CMSRC2wrap",
      NID_id_smime_alg_CMSRC2wrap = 247,
      OBJ_id_smime_alg_CMSRC2wrap = "OBJ_id_smime_alg,7L",
      SN_id_alg_PWRI_KEK = "id-alg-PWRI-KEK",
      NID_id_alg_PWRI_KEK = 893,
      OBJ_id_alg_PWRI_KEK = "OBJ_id_smime_alg,9L",
      SN_id_smime_cd_ldap = "id-smime-cd-ldap",
      NID_id_smime_cd_ldap = 248,
      OBJ_id_smime_cd_ldap = "OBJ_id_smime_cd,1L",
      SN_id_smime_spq_ets_sqt_uri = "id-smime-spq-ets-sqt-uri",
      NID_id_smime_spq_ets_sqt_uri = 249,
      OBJ_id_smime_spq_ets_sqt_uri = "OBJ_id_smime_spq,1L",
      SN_id_smime_spq_ets_sqt_unotice = "id-smime-spq-ets-sqt-unotice",
      NID_id_smime_spq_ets_sqt_unotice = 250,
      OBJ_id_smime_spq_ets_sqt_unotice = "OBJ_id_smime_spq,2L",
      SN_id_smime_cti_ets_proofOfOrigin = "id-smime-cti-ets-proofOfOrigin",
      NID_id_smime_cti_ets_proofOfOrigin = 251,
      OBJ_id_smime_cti_ets_proofOfOrigin = "OBJ_id_smime_cti,1L",
      SN_id_smime_cti_ets_proofOfReceipt = "id-smime-cti-ets-proofOfReceipt",
      NID_id_smime_cti_ets_proofOfReceipt = 252,
      OBJ_id_smime_cti_ets_proofOfReceipt = "OBJ_id_smime_cti,2L",
      SN_id_smime_cti_ets_proofOfDelivery = "id-smime-cti-ets-proofOfDelivery",
      NID_id_smime_cti_ets_proofOfDelivery = 253,
      OBJ_id_smime_cti_ets_proofOfDelivery = "OBJ_id_smime_cti,3L",
      SN_id_smime_cti_ets_proofOfSender = "id-smime-cti-ets-proofOfSender",
      NID_id_smime_cti_ets_proofOfSender = 254,
      OBJ_id_smime_cti_ets_proofOfSender = "OBJ_id_smime_cti,4L",
      SN_id_smime_cti_ets_proofOfApproval = "id-smime-cti-ets-proofOfApproval",
      NID_id_smime_cti_ets_proofOfApproval = 255,
      OBJ_id_smime_cti_ets_proofOfApproval = "OBJ_id_smime_cti,5L",
      SN_id_smime_cti_ets_proofOfCreation = "id-smime-cti-ets-proofOfCreation",
      NID_id_smime_cti_ets_proofOfCreation = 256,
      OBJ_id_smime_cti_ets_proofOfCreation = "OBJ_id_smime_cti,6L",
      LN_friendlyName = "friendlyName",
      NID_friendlyName = 156,
      OBJ_friendlyName = "OBJ_pkcs9,20L",
      LN_localKeyID = "localKeyID",
      NID_localKeyID = 157,
      OBJ_localKeyID = "OBJ_pkcs9,21L",
      SN_ms_csp_name = "CSPName",
      LN_ms_csp_name = "Microsoft",
      NID_ms_csp_name = 417,
      OBJ_ms_csp_name = 1,
      SN_LocalKeySet = "LocalKeySet",
      LN_LocalKeySet = "Microsoft",
      NID_LocalKeySet = 856,
      OBJ_LocalKeySet = 1,
      OBJ_certTypes = "OBJ_pkcs9,22L",
      LN_x509Certificate = "x509Certificate",
      NID_x509Certificate = 158,
      OBJ_x509Certificate = "OBJ_certTypes,1L",
      LN_sdsiCertificate = "sdsiCertificate",
      NID_sdsiCertificate = 159,
      OBJ_sdsiCertificate = "OBJ_certTypes,2L",
      OBJ_crlTypes = "OBJ_pkcs9,23L",
      LN_x509Crl = "x509Crl",
      NID_x509Crl = 160,
      OBJ_x509Crl = "OBJ_crlTypes,1L",
      OBJ_pkcs12 = "OBJ_pkcs,12L",
      OBJ_pkcs12_pbeids = "OBJ_pkcs12,1L",
      SN_pbe_WithSHA1And128BitRC4 = "PBE-SHA1-RC4-128",
      LN_pbe_WithSHA1And128BitRC4 = "pbeWithSHA1And128BitRC4",
      NID_pbe_WithSHA1And128BitRC4 = 144,
      OBJ_pbe_WithSHA1And128BitRC4 = "OBJ_pkcs12_pbeids,1L",
      SN_pbe_WithSHA1And40BitRC4 = "PBE-SHA1-RC4-40",
      LN_pbe_WithSHA1And40BitRC4 = "pbeWithSHA1And40BitRC4",
      NID_pbe_WithSHA1And40BitRC4 = 145,
      OBJ_pbe_WithSHA1And40BitRC4 = "OBJ_pkcs12_pbeids,2L",
      SN_pbe_WithSHA1And3_Key_TripleDES_CBC = "PBE-SHA1-3DES",
      LN_pbe_WithSHA1And3_Key_TripleDES_CBC = "pbeWithSHA1And3-KeyTripleDES-CBC",
      NID_pbe_WithSHA1And3_Key_TripleDES_CBC = 146,
      OBJ_pbe_WithSHA1And3_Key_TripleDES_CBC = "OBJ_pkcs12_pbeids,3L",
      SN_pbe_WithSHA1And2_Key_TripleDES_CBC = "PBE-SHA1-2DES",
      LN_pbe_WithSHA1And2_Key_TripleDES_CBC = "pbeWithSHA1And2-KeyTripleDES-CBC",
      NID_pbe_WithSHA1And2_Key_TripleDES_CBC = 147,
      OBJ_pbe_WithSHA1And2_Key_TripleDES_CBC = "OBJ_pkcs12_pbeids,4L",
      SN_pbe_WithSHA1And128BitRC2_CBC = "PBE-SHA1-RC2-128",
      LN_pbe_WithSHA1And128BitRC2_CBC = "pbeWithSHA1And128BitRC2-CBC",
      NID_pbe_WithSHA1And128BitRC2_CBC = 148,
      OBJ_pbe_WithSHA1And128BitRC2_CBC = "OBJ_pkcs12_pbeids,5L",
      SN_pbe_WithSHA1And40BitRC2_CBC = "PBE-SHA1-RC2-40",
      LN_pbe_WithSHA1And40BitRC2_CBC = "pbeWithSHA1And40BitRC2-CBC",
      NID_pbe_WithSHA1And40BitRC2_CBC = 149,
      OBJ_pbe_WithSHA1And40BitRC2_CBC = "OBJ_pkcs12_pbeids,6L",
      OBJ_pkcs12_Version1 = "OBJ_pkcs12,10L",
      OBJ_pkcs12_BagIds = "OBJ_pkcs12_Version1,1L",
      LN_keyBag = "keyBag",
      NID_keyBag = 150,
      OBJ_keyBag = "OBJ_pkcs12_BagIds,1L",
      LN_pkcs8ShroudedKeyBag = "pkcs8ShroudedKeyBag",
      NID_pkcs8ShroudedKeyBag = 151,
      OBJ_pkcs8ShroudedKeyBag = "OBJ_pkcs12_BagIds,2L",
      LN_certBag = "certBag",
      NID_certBag = 152,
      OBJ_certBag = "OBJ_pkcs12_BagIds,3L",
      LN_crlBag = "crlBag",
      NID_crlBag = 153,
      OBJ_crlBag = "OBJ_pkcs12_BagIds,4L",
      LN_secretBag = "secretBag",
      NID_secretBag = 154,
      OBJ_secretBag = "OBJ_pkcs12_BagIds,5L",
      LN_safeContentsBag = "safeContentsBag",
      NID_safeContentsBag = 155,
      OBJ_safeContentsBag = "OBJ_pkcs12_BagIds,6L",
      SN_md2 = "MD2",
      LN_md2 = "md2",
      NID_md2 = 3,
      OBJ_md2 = "OBJ_rsadsi,2L,2L",
      SN_md4 = "MD4",
      LN_md4 = "md4",
      NID_md4 = 257,
      OBJ_md4 = "OBJ_rsadsi,2L,4L",
      SN_md5 = "MD5",
      LN_md5 = "md5",
      NID_md5 = 4,
      OBJ_md5 = "OBJ_rsadsi,2L,5L",
      SN_md5_sha1 = "MD5-SHA1",
      LN_md5_sha1 = "md5-sha1",
      NID_md5_sha1 = 114,
      LN_hmacWithMD5 = "hmacWithMD5",
      NID_hmacWithMD5 = 797,
      OBJ_hmacWithMD5 = "OBJ_rsadsi,2L,6L",
      LN_hmacWithSHA1 = "hmacWithSHA1",
      NID_hmacWithSHA1 = 163,
      OBJ_hmacWithSHA1 = "OBJ_rsadsi,2L,7L",
      SN_sm2 = "SM2",
      LN_sm2 = "sm2",
      NID_sm2 = 1172,
      OBJ_sm2 = "OBJ_sm_scheme,301L",
      SN_sm3 = "SM3",
      LN_sm3 = "sm3",
      NID_sm3 = 1143,
      OBJ_sm3 = "OBJ_sm_scheme,401L",
      SN_sm3WithRSAEncryption = "RSA-SM3",
      LN_sm3WithRSAEncryption = "sm3WithRSAEncryption",
      NID_sm3WithRSAEncryption = 1144,
      OBJ_sm3WithRSAEncryption = "OBJ_sm_scheme,504L",
      SN_SM2_with_SM3 = "SM2-SM3",
      LN_SM2_with_SM3 = "SM2-with-SM3",
      NID_SM2_with_SM3 = 1204,
      OBJ_SM2_with_SM3 = "OBJ_sm_scheme,501L",
      LN_hmacWithSHA224 = "hmacWithSHA224",
      NID_hmacWithSHA224 = 798,
      OBJ_hmacWithSHA224 = "OBJ_rsadsi,2L,8L",
      LN_hmacWithSHA256 = "hmacWithSHA256",
      NID_hmacWithSHA256 = 799,
      OBJ_hmacWithSHA256 = "OBJ_rsadsi,2L,9L",
      LN_hmacWithSHA384 = "hmacWithSHA384",
      NID_hmacWithSHA384 = 800,
      OBJ_hmacWithSHA384 = "OBJ_rsadsi,2L,10L",
      LN_hmacWithSHA512 = "hmacWithSHA512",
      NID_hmacWithSHA512 = 801,
      OBJ_hmacWithSHA512 = "OBJ_rsadsi,2L,11L",
      LN_hmacWithSHA512_224 = "hmacWithSHA512-224",
      NID_hmacWithSHA512_224 = 1193,
      OBJ_hmacWithSHA512_224 = "OBJ_rsadsi,2L,12L",
      LN_hmacWithSHA512_256 = "hmacWithSHA512-256",
      NID_hmacWithSHA512_256 = 1194,
      OBJ_hmacWithSHA512_256 = "OBJ_rsadsi,2L,13L",
      SN_rc2_cbc = "RC2-CBC",
      LN_rc2_cbc = "rc2-cbc",
      NID_rc2_cbc = 37,
      OBJ_rc2_cbc = "OBJ_rsadsi,3L,2L",
      SN_rc2_ecb = "RC2-ECB",
      LN_rc2_ecb = "rc2-ecb",
      NID_rc2_ecb = 38,
      SN_rc2_cfb64 = "RC2-CFB",
      LN_rc2_cfb64 = "rc2-cfb",
      NID_rc2_cfb64 = 39,
      SN_rc2_ofb64 = "RC2-OFB",
      LN_rc2_ofb64 = "rc2-ofb",
      NID_rc2_ofb64 = 40,
      SN_rc2_40_cbc = "RC2-40-CBC",
      LN_rc2_40_cbc = "rc2-40-cbc",
      NID_rc2_40_cbc = 98,
      SN_rc2_64_cbc = "RC2-64-CBC",
      LN_rc2_64_cbc = "rc2-64-cbc",
      NID_rc2_64_cbc = 166,
      SN_rc4 = "RC4",
      LN_rc4 = "rc4",
      NID_rc4 = 5,
      OBJ_rc4 = "OBJ_rsadsi,3L,4L",
      SN_rc4_40 = "RC4-40",
      LN_rc4_40 = "rc4-40",
      NID_rc4_40 = 97,
      SN_des_ede3_cbc = "DES-EDE3-CBC",
      LN_des_ede3_cbc = "des-ede3-cbc",
      NID_des_ede3_cbc = 44,
      OBJ_des_ede3_cbc = "OBJ_rsadsi,3L,7L",
      SN_rc5_cbc = "RC5-CBC",
      LN_rc5_cbc = "rc5-cbc",
      NID_rc5_cbc = 120,
      OBJ_rc5_cbc = "OBJ_rsadsi,3L,8L",
      SN_rc5_ecb = "RC5-ECB",
      LN_rc5_ecb = "rc5-ecb",
      NID_rc5_ecb = 121,
      SN_rc5_cfb64 = "RC5-CFB",
      LN_rc5_cfb64 = "rc5-cfb",
      NID_rc5_cfb64 = 122,
      SN_rc5_ofb64 = "RC5-OFB",
      LN_rc5_ofb64 = "rc5-ofb",
      NID_rc5_ofb64 = 123,
      SN_ms_ext_req = "msExtReq",
      LN_ms_ext_req = "Microsoft",
      NID_ms_ext_req = 171,
      OBJ_ms_ext_req = 1,
      SN_ms_code_ind = "msCodeInd",
      LN_ms_code_ind = "Microsoft",
      NID_ms_code_ind = 134,
      OBJ_ms_code_ind = 1,
      SN_ms_code_com = "msCodeCom",
      LN_ms_code_com = "Microsoft",
      NID_ms_code_com = 135,
      OBJ_ms_code_com = 1,
      SN_ms_ctl_sign = "msCTLSign",
      LN_ms_ctl_sign = "Microsoft",
      NID_ms_ctl_sign = 136,
      OBJ_ms_ctl_sign = 1,
      SN_ms_sgc = "msSGC",
      LN_ms_sgc = "Microsoft",
      NID_ms_sgc = 137,
      OBJ_ms_sgc = 1,
      SN_ms_efs = "msEFS",
      LN_ms_efs = "Microsoft",
      NID_ms_efs = 138,
      OBJ_ms_efs = 1,
      SN_ms_smartcard_login = "msSmartcardLogin",
      LN_ms_smartcard_login = "Microsoft",
      NID_ms_smartcard_login = 648,
      OBJ_ms_smartcard_login = 1,
      SN_ms_upn = "msUPN",
      LN_ms_upn = "Microsoft",
      NID_ms_upn = 649,
      OBJ_ms_upn = 1,
      SN_idea_cbc = "IDEA-CBC",
      LN_idea_cbc = "idea-cbc",
      NID_idea_cbc = 34,
      OBJ_idea_cbc = 1,
      SN_idea_ecb = "IDEA-ECB",
      LN_idea_ecb = "idea-ecb",
      NID_idea_ecb = 36,
      SN_idea_cfb64 = "IDEA-CFB",
      LN_idea_cfb64 = "idea-cfb",
      NID_idea_cfb64 = 35,
      SN_idea_ofb64 = "IDEA-OFB",
      LN_idea_ofb64 = "idea-ofb",
      NID_idea_ofb64 = 46,
      SN_bf_cbc = "BF-CBC",
      LN_bf_cbc = "bf-cbc",
      NID_bf_cbc = 91,
      OBJ_bf_cbc = 1,
      SN_bf_ecb = "BF-ECB",
      LN_bf_ecb = "bf-ecb",
      NID_bf_ecb = 92,
      SN_bf_cfb64 = "BF-CFB",
      LN_bf_cfb64 = "bf-cfb",
      NID_bf_cfb64 = 93,
      SN_bf_ofb64 = "BF-OFB",
      LN_bf_ofb64 = "bf-ofb",
      NID_bf_ofb64 = 94,
      SN_id_pkix = "PKIX",
      NID_id_pkix = 127,
      OBJ_id_pkix = 1,
      SN_id_pkix_mod = "id-pkix-mod",
      NID_id_pkix_mod = 258,
      OBJ_id_pkix_mod = "OBJ_id_pkix,0L",
      SN_id_pe = "id-pe",
      NID_id_pe = 175,
      OBJ_id_pe = "OBJ_id_pkix,1L",
      SN_id_qt = "id-qt",
      NID_id_qt = 259,
      OBJ_id_qt = "OBJ_id_pkix,2L",
      SN_id_kp = "id-kp",
      NID_id_kp = 128,
      OBJ_id_kp = "OBJ_id_pkix,3L",
      SN_id_it = "id-it",
      NID_id_it = 260,
      OBJ_id_it = "OBJ_id_pkix,4L",
      SN_id_pkip = "id-pkip",
      NID_id_pkip = 261,
      OBJ_id_pkip = "OBJ_id_pkix,5L",
      SN_id_alg = "id-alg",
      NID_id_alg = 262,
      OBJ_id_alg = "OBJ_id_pkix,6L",
      SN_id_cmc = "id-cmc",
      NID_id_cmc = 263,
      OBJ_id_cmc = "OBJ_id_pkix,7L",
      SN_id_on = "id-on",
      NID_id_on = 264,
      OBJ_id_on = "OBJ_id_pkix,8L",
      SN_id_pda = "id-pda",
      NID_id_pda = 265,
      OBJ_id_pda = "OBJ_id_pkix,9L",
      SN_id_aca = "id-aca",
      NID_id_aca = 266,
      OBJ_id_aca = "OBJ_id_pkix,10L",
      SN_id_qcs = "id-qcs",
      NID_id_qcs = 267,
      OBJ_id_qcs = "OBJ_id_pkix,11L",
      SN_id_cp = "id-cp",
      NID_id_cp = 1238,
      OBJ_id_cp = "OBJ_id_pkix,14L",
      SN_id_cct = "id-cct",
      NID_id_cct = 268,
      OBJ_id_cct = "OBJ_id_pkix,12L",
      SN_id_ppl = "id-ppl",
      NID_id_ppl = 662,
      OBJ_id_ppl = "OBJ_id_pkix,21L",
      SN_id_ad = "id-ad",
      NID_id_ad = 176,
      OBJ_id_ad = "OBJ_id_pkix,48L",
      SN_id_pkix1_explicit_88 = "id-pkix1-explicit-88",
      NID_id_pkix1_explicit_88 = 269,
      OBJ_id_pkix1_explicit_88 = "OBJ_id_pkix_mod,1L",
      SN_id_pkix1_implicit_88 = "id-pkix1-implicit-88",
      NID_id_pkix1_implicit_88 = 270,
      OBJ_id_pkix1_implicit_88 = "OBJ_id_pkix_mod,2L",
      SN_id_pkix1_explicit_93 = "id-pkix1-explicit-93",
      NID_id_pkix1_explicit_93 = 271,
      OBJ_id_pkix1_explicit_93 = "OBJ_id_pkix_mod,3L",
      SN_id_pkix1_implicit_93 = "id-pkix1-implicit-93",
      NID_id_pkix1_implicit_93 = 272,
      OBJ_id_pkix1_implicit_93 = "OBJ_id_pkix_mod,4L",
      SN_id_mod_crmf = "id-mod-crmf",
      NID_id_mod_crmf = 273,
      OBJ_id_mod_crmf = "OBJ_id_pkix_mod,5L",
      SN_id_mod_cmc = "id-mod-cmc",
      NID_id_mod_cmc = 274,
      OBJ_id_mod_cmc = "OBJ_id_pkix_mod,6L",
      SN_id_mod_kea_profile_88 = "id-mod-kea-profile-88",
      NID_id_mod_kea_profile_88 = 275,
      OBJ_id_mod_kea_profile_88 = "OBJ_id_pkix_mod,7L",
      SN_id_mod_kea_profile_93 = "id-mod-kea-profile-93",
      NID_id_mod_kea_profile_93 = 276,
      OBJ_id_mod_kea_profile_93 = "OBJ_id_pkix_mod,8L",
      SN_id_mod_cmp = "id-mod-cmp",
      NID_id_mod_cmp = 277,
      OBJ_id_mod_cmp = "OBJ_id_pkix_mod,9L",
      SN_id_mod_qualified_cert_88 = "id-mod-qualified-cert-88",
      NID_id_mod_qualified_cert_88 = 278,
      OBJ_id_mod_qualified_cert_88 = "OBJ_id_pkix_mod,10L",
      SN_id_mod_qualified_cert_93 = "id-mod-qualified-cert-93",
      NID_id_mod_qualified_cert_93 = 279,
      OBJ_id_mod_qualified_cert_93 = "OBJ_id_pkix_mod,11L",
      SN_id_mod_attribute_cert = "id-mod-attribute-cert",
      NID_id_mod_attribute_cert = 280,
      OBJ_id_mod_attribute_cert = "OBJ_id_pkix_mod,12L",
      SN_id_mod_timestamp_protocol = "id-mod-timestamp-protocol",
      NID_id_mod_timestamp_protocol = 281,
      OBJ_id_mod_timestamp_protocol = "OBJ_id_pkix_mod,13L",
      SN_id_mod_ocsp = "id-mod-ocsp",
      NID_id_mod_ocsp = 282,
      OBJ_id_mod_ocsp = "OBJ_id_pkix_mod,14L",
      SN_id_mod_dvcs = "id-mod-dvcs",
      NID_id_mod_dvcs = 283,
      OBJ_id_mod_dvcs = "OBJ_id_pkix_mod,15L",
      SN_id_mod_cmp2000 = "id-mod-cmp2000",
      NID_id_mod_cmp2000 = 284,
      OBJ_id_mod_cmp2000 = "OBJ_id_pkix_mod,16L",
      SN_info_access = "authorityInfoAccess",
      LN_info_access = "Authority",
      NID_info_access = 177,
      OBJ_info_access = "OBJ_id_pe,1L",
      SN_biometricInfo = "biometricInfo",
      LN_biometricInfo = "Biometric",
      NID_biometricInfo = 285,
      OBJ_biometricInfo = "OBJ_id_pe,2L",
      SN_qcStatements = "qcStatements",
      NID_qcStatements = 286,
      OBJ_qcStatements = "OBJ_id_pe,3L",
      SN_ac_auditEntity = "ac-auditEntity",
      NID_ac_auditEntity = 287,
      OBJ_ac_auditEntity = "OBJ_id_pe,4L",
      SN_ac_targeting = "ac-targeting",
      NID_ac_targeting = 288,
      OBJ_ac_targeting = "OBJ_id_pe,5L",
      SN_aaControls = "aaControls",
      NID_aaControls = 289,
      OBJ_aaControls = "OBJ_id_pe,6L",
      SN_sbgp_ipAddrBlock = "sbgp-ipAddrBlock",
      NID_sbgp_ipAddrBlock = 290,
      OBJ_sbgp_ipAddrBlock = "OBJ_id_pe,7L",
      SN_sbgp_autonomousSysNum = "sbgp-autonomousSysNum",
      NID_sbgp_autonomousSysNum = 291,
      OBJ_sbgp_autonomousSysNum = "OBJ_id_pe,8L",
      SN_sbgp_routerIdentifier = "sbgp-routerIdentifier",
      NID_sbgp_routerIdentifier = 292,
      OBJ_sbgp_routerIdentifier = "OBJ_id_pe,9L",
      SN_ac_proxying = "ac-proxying",
      NID_ac_proxying = 397,
      OBJ_ac_proxying = "OBJ_id_pe,10L",
      SN_sinfo_access = "subjectInfoAccess",
      LN_sinfo_access = "Subject",
      NID_sinfo_access = 398,
      OBJ_sinfo_access = "OBJ_id_pe,11L",
      SN_proxyCertInfo = "proxyCertInfo",
      LN_proxyCertInfo = "Proxy",
      NID_proxyCertInfo = 663,
      OBJ_proxyCertInfo = "OBJ_id_pe,14L",
      SN_tlsfeature = "tlsfeature",
      LN_tlsfeature = "TLS",
      NID_tlsfeature = 1020,
      OBJ_tlsfeature = "OBJ_id_pe,24L",
      SN_sbgp_ipAddrBlockv2 = "sbgp-ipAddrBlockv2",
      NID_sbgp_ipAddrBlockv2 = 1239,
      OBJ_sbgp_ipAddrBlockv2 = "OBJ_id_pe,28L",
      SN_sbgp_autonomousSysNumv2 = "sbgp-autonomousSysNumv2",
      NID_sbgp_autonomousSysNumv2 = 1240,
      OBJ_sbgp_autonomousSysNumv2 = "OBJ_id_pe,29L",
      SN_id_qt_cps = "id-qt-cps",
      LN_id_qt_cps = "Policy",
      NID_id_qt_cps = 164,
      OBJ_id_qt_cps = "OBJ_id_qt,1L",
      SN_id_qt_unotice = "id-qt-unotice",
      LN_id_qt_unotice = "Policy",
      NID_id_qt_unotice = 165,
      OBJ_id_qt_unotice = "OBJ_id_qt,2L",
      SN_textNotice = "textNotice",
      NID_textNotice = 293,
      OBJ_textNotice = "OBJ_id_qt,3L",
      SN_server_auth = "serverAuth",
      LN_server_auth = "TLS",
      NID_server_auth = 129,
      OBJ_server_auth = "OBJ_id_kp,1L",
      SN_client_auth = "clientAuth",
      LN_client_auth = "TLS",
      NID_client_auth = 130,
      OBJ_client_auth = "OBJ_id_kp,2L",
      SN_code_sign = "codeSigning",
      LN_code_sign = "Code",
      NID_code_sign = 131,
      OBJ_code_sign = "OBJ_id_kp,3L",
      SN_email_protect = "emailProtection",
      LN_email_protect = "E-mail",
      NID_email_protect = 132,
      OBJ_email_protect = "OBJ_id_kp,4L",
      SN_ipsecEndSystem = "ipsecEndSystem",
      LN_ipsecEndSystem = "IPSec",
      NID_ipsecEndSystem = 294,
      OBJ_ipsecEndSystem = "OBJ_id_kp,5L",
      SN_ipsecTunnel = "ipsecTunnel",
      LN_ipsecTunnel = "IPSec",
      NID_ipsecTunnel = 295,
      OBJ_ipsecTunnel = "OBJ_id_kp,6L",
      SN_ipsecUser = "ipsecUser",
      LN_ipsecUser = "IPSec",
      NID_ipsecUser = 296,
      OBJ_ipsecUser = "OBJ_id_kp,7L",
      SN_time_stamp = "timeStamping",
      LN_time_stamp = "Time",
      NID_time_stamp = 133,
      OBJ_time_stamp = "OBJ_id_kp,8L",
      SN_OCSP_sign = "OCSPSigning",
      LN_OCSP_sign = "OCSP",
      NID_OCSP_sign = 180,
      OBJ_OCSP_sign = "OBJ_id_kp,9L",
      SN_dvcs = "DVCS",
      LN_dvcs = "dvcs",
      NID_dvcs = 297,
      OBJ_dvcs = "OBJ_id_kp,10L",
      SN_ipsec_IKE = "ipsecIKE",
      LN_ipsec_IKE = "ipsec",
      NID_ipsec_IKE = 1022,
      OBJ_ipsec_IKE = "OBJ_id_kp,17L",
      SN_capwapAC = "capwapAC",
      NID_capwapAC = 1023,
      OBJ_capwapAC = "OBJ_id_kp,18L",
      SN_capwapWTP = "capwapWTP",
      NID_capwapWTP = 1024,
      OBJ_capwapWTP = "OBJ_id_kp,19L",
      SN_sshClient = "secureShellClient",
      LN_sshClient = "SSH",
      NID_sshClient = 1025,
      OBJ_sshClient = "OBJ_id_kp,21L",
      SN_sshServer = "secureShellServer",
      LN_sshServer = "SSH",
      NID_sshServer = 1026,
      OBJ_sshServer = "OBJ_id_kp,22L",
      SN_sendRouter = "sendRouter",
      LN_sendRouter = "Send",
      NID_sendRouter = 1027,
      OBJ_sendRouter = "OBJ_id_kp,23L",
      SN_sendProxiedRouter = "sendProxiedRouter",
      LN_sendProxiedRouter = "Send",
      NID_sendProxiedRouter = 1028,
      OBJ_sendProxiedRouter = "OBJ_id_kp,24L",
      SN_sendOwner = "sendOwner",
      LN_sendOwner = "Send",
      NID_sendOwner = 1029,
      OBJ_sendOwner = "OBJ_id_kp,25L",
      SN_sendProxiedOwner = "sendProxiedOwner",
      LN_sendProxiedOwner = "Send",
      NID_sendProxiedOwner = 1030,
      OBJ_sendProxiedOwner = "OBJ_id_kp,26L",
      SN_cmcCA = "cmcCA",
      LN_cmcCA = "CMC",
      NID_cmcCA = 1131,
      OBJ_cmcCA = "OBJ_id_kp,27L",
      SN_cmcRA = "cmcRA",
      LN_cmcRA = "CMC",
      NID_cmcRA = 1132,
      OBJ_cmcRA = "OBJ_id_kp,28L",
      SN_cmcArchive = "cmcArchive",
      LN_cmcArchive = "CMC",
      NID_cmcArchive = 1219,
      OBJ_cmcArchive = "OBJ_id_kp,29L",
      SN_id_kp_bgpsec_router = "id-kp-bgpsec-router",
      LN_id_kp_bgpsec_router = "BGPsec",
      NID_id_kp_bgpsec_router = 1220,
      OBJ_id_kp_bgpsec_router = "OBJ_id_kp,30L",
      SN_id_kp_BrandIndicatorforMessageIdentification = "id-kp-BrandIndicatorforMessageIdentification",
      LN_id_kp_BrandIndicatorforMessageIdentification = "Brand",
      NID_id_kp_BrandIndicatorforMessageIdentification = 1221,
      OBJ_id_kp_BrandIndicatorforMessageIdentification = "OBJ_id_kp,31L",
      SN_cmKGA = "cmKGA",
      LN_cmKGA = "Certificate",
      NID_cmKGA = 1222,
      OBJ_cmKGA = "OBJ_id_kp,32L",
      SN_id_it_caProtEncCert = "id-it-caProtEncCert",
      NID_id_it_caProtEncCert = 298,
      OBJ_id_it_caProtEncCert = "OBJ_id_it,1L",
      SN_id_it_signKeyPairTypes = "id-it-signKeyPairTypes",
      NID_id_it_signKeyPairTypes = 299,
      OBJ_id_it_signKeyPairTypes = "OBJ_id_it,2L",
      SN_id_it_encKeyPairTypes = "id-it-encKeyPairTypes",
      NID_id_it_encKeyPairTypes = 300,
      OBJ_id_it_encKeyPairTypes = "OBJ_id_it,3L",
      SN_id_it_preferredSymmAlg = "id-it-preferredSymmAlg",
      NID_id_it_preferredSymmAlg = 301,
      OBJ_id_it_preferredSymmAlg = "OBJ_id_it,4L",
      SN_id_it_caKeyUpdateInfo = "id-it-caKeyUpdateInfo",
      NID_id_it_caKeyUpdateInfo = 302,
      OBJ_id_it_caKeyUpdateInfo = "OBJ_id_it,5L",
      SN_id_it_currentCRL = "id-it-currentCRL",
      NID_id_it_currentCRL = 303,
      OBJ_id_it_currentCRL = "OBJ_id_it,6L",
      SN_id_it_unsupportedOIDs = "id-it-unsupportedOIDs",
      NID_id_it_unsupportedOIDs = 304,
      OBJ_id_it_unsupportedOIDs = "OBJ_id_it,7L",
      SN_id_it_subscriptionRequest = "id-it-subscriptionRequest",
      NID_id_it_subscriptionRequest = 305,
      OBJ_id_it_subscriptionRequest = "OBJ_id_it,8L",
      SN_id_it_subscriptionResponse = "id-it-subscriptionResponse",
      NID_id_it_subscriptionResponse = 306,
      OBJ_id_it_subscriptionResponse = "OBJ_id_it,9L",
      SN_id_it_keyPairParamReq = "id-it-keyPairParamReq",
      NID_id_it_keyPairParamReq = 307,
      OBJ_id_it_keyPairParamReq = "OBJ_id_it,10L",
      SN_id_it_keyPairParamRep = "id-it-keyPairParamRep",
      NID_id_it_keyPairParamRep = 308,
      OBJ_id_it_keyPairParamRep = "OBJ_id_it,11L",
      SN_id_it_revPassphrase = "id-it-revPassphrase",
      NID_id_it_revPassphrase = 309,
      OBJ_id_it_revPassphrase = "OBJ_id_it,12L",
      SN_id_it_implicitConfirm = "id-it-implicitConfirm",
      NID_id_it_implicitConfirm = 310,
      OBJ_id_it_implicitConfirm = "OBJ_id_it,13L",
      SN_id_it_confirmWaitTime = "id-it-confirmWaitTime",
      NID_id_it_confirmWaitTime = 311,
      OBJ_id_it_confirmWaitTime = "OBJ_id_it,14L",
      SN_id_it_origPKIMessage = "id-it-origPKIMessage",
      NID_id_it_origPKIMessage = 312,
      OBJ_id_it_origPKIMessage = "OBJ_id_it,15L",
      SN_id_it_suppLangTags = "id-it-suppLangTags",
      NID_id_it_suppLangTags = 784,
      OBJ_id_it_suppLangTags = "OBJ_id_it,16L",
      SN_id_it_caCerts = "id-it-caCerts",
      NID_id_it_caCerts = 1223,
      OBJ_id_it_caCerts = "OBJ_id_it,17L",
      SN_id_it_rootCaKeyUpdate = "id-it-rootCaKeyUpdate",
      NID_id_it_rootCaKeyUpdate = 1224,
      OBJ_id_it_rootCaKeyUpdate = "OBJ_id_it,18L",
      SN_id_it_certReqTemplate = "id-it-certReqTemplate",
      NID_id_it_certReqTemplate = 1225,
      OBJ_id_it_certReqTemplate = "OBJ_id_it,19L",
      SN_id_regCtrl = "id-regCtrl",
      NID_id_regCtrl = 313,
      OBJ_id_regCtrl = "OBJ_id_pkip,1L",
      SN_id_regInfo = "id-regInfo",
      NID_id_regInfo = 314,
      OBJ_id_regInfo = "OBJ_id_pkip,2L",
      SN_id_regCtrl_regToken = "id-regCtrl-regToken",
      NID_id_regCtrl_regToken = 315,
      OBJ_id_regCtrl_regToken = "OBJ_id_regCtrl,1L",
      SN_id_regCtrl_authenticator = "id-regCtrl-authenticator",
      NID_id_regCtrl_authenticator = 316,
      OBJ_id_regCtrl_authenticator = "OBJ_id_regCtrl,2L",
      SN_id_regCtrl_pkiPublicationInfo = "id-regCtrl-pkiPublicationInfo",
      NID_id_regCtrl_pkiPublicationInfo = 317,
      OBJ_id_regCtrl_pkiPublicationInfo = "OBJ_id_regCtrl,3L",
      SN_id_regCtrl_pkiArchiveOptions = "id-regCtrl-pkiArchiveOptions",
      NID_id_regCtrl_pkiArchiveOptions = 318,
      OBJ_id_regCtrl_pkiArchiveOptions = "OBJ_id_regCtrl,4L",
      SN_id_regCtrl_oldCertID = "id-regCtrl-oldCertID",
      NID_id_regCtrl_oldCertID = 319,
      OBJ_id_regCtrl_oldCertID = "OBJ_id_regCtrl,5L",
      SN_id_regCtrl_protocolEncrKey = "id-regCtrl-protocolEncrKey",
      NID_id_regCtrl_protocolEncrKey = 320,
      OBJ_id_regCtrl_protocolEncrKey = "OBJ_id_regCtrl,6L",
      SN_id_regInfo_utf8Pairs = "id-regInfo-utf8Pairs",
      NID_id_regInfo_utf8Pairs = 321,
      OBJ_id_regInfo_utf8Pairs = "OBJ_id_regInfo,1L",
      SN_id_regInfo_certReq = "id-regInfo-certReq",
      NID_id_regInfo_certReq = 322,
      OBJ_id_regInfo_certReq = "OBJ_id_regInfo,2L",
      SN_id_alg_des40 = "id-alg-des40",
      NID_id_alg_des40 = 323,
      OBJ_id_alg_des40 = "OBJ_id_alg,1L",
      SN_id_alg_noSignature = "id-alg-noSignature",
      NID_id_alg_noSignature = 324,
      OBJ_id_alg_noSignature = "OBJ_id_alg,2L",
      SN_id_alg_dh_sig_hmac_sha1 = "id-alg-dh-sig-hmac-sha1",
      NID_id_alg_dh_sig_hmac_sha1 = 325,
      OBJ_id_alg_dh_sig_hmac_sha1 = "OBJ_id_alg,3L",
      SN_id_alg_dh_pop = "id-alg-dh-pop",
      NID_id_alg_dh_pop = 326,
      OBJ_id_alg_dh_pop = "OBJ_id_alg,4L",
      SN_id_cmc_statusInfo = "id-cmc-statusInfo",
      NID_id_cmc_statusInfo = 327,
      OBJ_id_cmc_statusInfo = "OBJ_id_cmc,1L",
      SN_id_cmc_identification = "id-cmc-identification",
      NID_id_cmc_identification = 328,
      OBJ_id_cmc_identification = "OBJ_id_cmc,2L",
      SN_id_cmc_identityProof = "id-cmc-identityProof",
      NID_id_cmc_identityProof = 329,
      OBJ_id_cmc_identityProof = "OBJ_id_cmc,3L",
      SN_id_cmc_dataReturn = "id-cmc-dataReturn",
      NID_id_cmc_dataReturn = 330,
      OBJ_id_cmc_dataReturn = "OBJ_id_cmc,4L",
      SN_id_cmc_transactionId = "id-cmc-transactionId",
      NID_id_cmc_transactionId = 331,
      OBJ_id_cmc_transactionId = "OBJ_id_cmc,5L",
      SN_id_cmc_senderNonce = "id-cmc-senderNonce",
      NID_id_cmc_senderNonce = 332,
      OBJ_id_cmc_senderNonce = "OBJ_id_cmc,6L",
      SN_id_cmc_recipientNonce = "id-cmc-recipientNonce",
      NID_id_cmc_recipientNonce = 333,
      OBJ_id_cmc_recipientNonce = "OBJ_id_cmc,7L",
      SN_id_cmc_addExtensions = "id-cmc-addExtensions",
      NID_id_cmc_addExtensions = 334,
      OBJ_id_cmc_addExtensions = "OBJ_id_cmc,8L",
      SN_id_cmc_encryptedPOP = "id-cmc-encryptedPOP",
      NID_id_cmc_encryptedPOP = 335,
      OBJ_id_cmc_encryptedPOP = "OBJ_id_cmc,9L",
      SN_id_cmc_decryptedPOP = "id-cmc-decryptedPOP",
      NID_id_cmc_decryptedPOP = 336,
      OBJ_id_cmc_decryptedPOP = "OBJ_id_cmc,10L",
      SN_id_cmc_lraPOPWitness = "id-cmc-lraPOPWitness",
      NID_id_cmc_lraPOPWitness = 337,
      OBJ_id_cmc_lraPOPWitness = "OBJ_id_cmc,11L",
      SN_id_cmc_getCert = "id-cmc-getCert",
      NID_id_cmc_getCert = 338,
      OBJ_id_cmc_getCert = "OBJ_id_cmc,15L",
      SN_id_cmc_getCRL = "id-cmc-getCRL",
      NID_id_cmc_getCRL = 339,
      OBJ_id_cmc_getCRL = "OBJ_id_cmc,16L",
      SN_id_cmc_revokeRequest = "id-cmc-revokeRequest",
      NID_id_cmc_revokeRequest = 340,
      OBJ_id_cmc_revokeRequest = "OBJ_id_cmc,17L",
      SN_id_cmc_regInfo = "id-cmc-regInfo",
      NID_id_cmc_regInfo = 341,
      OBJ_id_cmc_regInfo = "OBJ_id_cmc,18L",
      SN_id_cmc_responseInfo = "id-cmc-responseInfo",
      NID_id_cmc_responseInfo = 342,
      OBJ_id_cmc_responseInfo = "OBJ_id_cmc,19L",
      SN_id_cmc_queryPending = "id-cmc-queryPending",
      NID_id_cmc_queryPending = 343,
      OBJ_id_cmc_queryPending = "OBJ_id_cmc,21L",
      SN_id_cmc_popLinkRandom = "id-cmc-popLinkRandom",
      NID_id_cmc_popLinkRandom = 344,
      OBJ_id_cmc_popLinkRandom = "OBJ_id_cmc,22L",
      SN_id_cmc_popLinkWitness = "id-cmc-popLinkWitness",
      NID_id_cmc_popLinkWitness = 345,
      OBJ_id_cmc_popLinkWitness = "OBJ_id_cmc,23L",
      SN_id_cmc_confirmCertAcceptance = "id-cmc-confirmCertAcceptance",
      NID_id_cmc_confirmCertAcceptance = 346,
      OBJ_id_cmc_confirmCertAcceptance = "OBJ_id_cmc,24L",
      SN_id_on_personalData = "id-on-personalData",
      NID_id_on_personalData = 347,
      OBJ_id_on_personalData = "OBJ_id_on,1L",
      SN_id_on_permanentIdentifier = "id-on-permanentIdentifier",
      LN_id_on_permanentIdentifier = "Permanent",
      NID_id_on_permanentIdentifier = 858,
      OBJ_id_on_permanentIdentifier = "OBJ_id_on,3L",
      SN_XmppAddr = "id-on-xmppAddr",
      LN_XmppAddr = "XmppAddr",
      NID_XmppAddr = 1209,
      OBJ_XmppAddr = "OBJ_id_on,5L",
      SN_SRVName = "id-on-dnsSRV",
      LN_SRVName = "SRVName",
      NID_SRVName = 1210,
      OBJ_SRVName = "OBJ_id_on,7L",
      SN_NAIRealm = "id-on-NAIRealm",
      LN_NAIRealm = "NAIRealm",
      NID_NAIRealm = 1211,
      OBJ_NAIRealm = "OBJ_id_on,8L",
      SN_id_on_SmtpUTF8Mailbox = "id-on-SmtpUTF8Mailbox",
      LN_id_on_SmtpUTF8Mailbox = "Smtp",
      NID_id_on_SmtpUTF8Mailbox = 1208,
      OBJ_id_on_SmtpUTF8Mailbox = "OBJ_id_on,9L",
      SN_id_pda_dateOfBirth = "id-pda-dateOfBirth",
      NID_id_pda_dateOfBirth = 348,
      OBJ_id_pda_dateOfBirth = "OBJ_id_pda,1L",
      SN_id_pda_placeOfBirth = "id-pda-placeOfBirth",
      NID_id_pda_placeOfBirth = 349,
      OBJ_id_pda_placeOfBirth = "OBJ_id_pda,2L",
      SN_id_pda_gender = "id-pda-gender",
      NID_id_pda_gender = 351,
      OBJ_id_pda_gender = "OBJ_id_pda,3L",
      SN_id_pda_countryOfCitizenship = "id-pda-countryOfCitizenship",
      NID_id_pda_countryOfCitizenship = 352,
      OBJ_id_pda_countryOfCitizenship = "OBJ_id_pda,4L",
      SN_id_pda_countryOfResidence = "id-pda-countryOfResidence",
      NID_id_pda_countryOfResidence = 353,
      OBJ_id_pda_countryOfResidence = "OBJ_id_pda,5L",
      SN_id_aca_authenticationInfo = "id-aca-authenticationInfo",
      NID_id_aca_authenticationInfo = 354,
      OBJ_id_aca_authenticationInfo = "OBJ_id_aca,1L",
      SN_id_aca_accessIdentity = "id-aca-accessIdentity",
      NID_id_aca_accessIdentity = 355,
      OBJ_id_aca_accessIdentity = "OBJ_id_aca,2L",
      SN_id_aca_chargingIdentity = "id-aca-chargingIdentity",
      NID_id_aca_chargingIdentity = 356,
      OBJ_id_aca_chargingIdentity = "OBJ_id_aca,3L",
      SN_id_aca_group = "id-aca-group",
      NID_id_aca_group = 357,
      OBJ_id_aca_group = "OBJ_id_aca,4L",
      SN_id_aca_role = "id-aca-role",
      NID_id_aca_role = 358,
      OBJ_id_aca_role = "OBJ_id_aca,5L",
      SN_id_aca_encAttrs = "id-aca-encAttrs",
      NID_id_aca_encAttrs = 399,
      OBJ_id_aca_encAttrs = "OBJ_id_aca,6L",
      SN_id_qcs_pkixQCSyntax_v1 = "id-qcs-pkixQCSyntax-v1",
      NID_id_qcs_pkixQCSyntax_v1 = 359,
      OBJ_id_qcs_pkixQCSyntax_v1 = "OBJ_id_qcs,1L",
      SN_ipAddr_asNumber = "ipAddr-asNumber",
      NID_ipAddr_asNumber = 1241,
      OBJ_ipAddr_asNumber = "OBJ_id_cp,2L",
      SN_ipAddr_asNumberv2 = "ipAddr-asNumberv2",
      NID_ipAddr_asNumberv2 = 1242,
      OBJ_ipAddr_asNumberv2 = "OBJ_id_cp,3L",
      SN_id_cct_crs = "id-cct-crs",
      NID_id_cct_crs = 360,
      OBJ_id_cct_crs = "OBJ_id_cct,1L",
      SN_id_cct_PKIData = "id-cct-PKIData",
      NID_id_cct_PKIData = 361,
      OBJ_id_cct_PKIData = "OBJ_id_cct,2L",
      SN_id_cct_PKIResponse = "id-cct-PKIResponse",
      NID_id_cct_PKIResponse = 362,
      OBJ_id_cct_PKIResponse = "OBJ_id_cct,3L",
      SN_id_ppl_anyLanguage = "id-ppl-anyLanguage",
      LN_id_ppl_anyLanguage = "Any",
      NID_id_ppl_anyLanguage = 664,
      OBJ_id_ppl_anyLanguage = "OBJ_id_ppl,0L",
      SN_id_ppl_inheritAll = "id-ppl-inheritAll",
      LN_id_ppl_inheritAll = "Inherit",
      NID_id_ppl_inheritAll = 665,
      OBJ_id_ppl_inheritAll = "OBJ_id_ppl,1L",
      SN_Independent = "id-ppl-independent",
      LN_Independent = "Independent",
      NID_Independent = 667,
      OBJ_Independent = "OBJ_id_ppl,2L",
      SN_ad_OCSP = "OCSP",
      LN_ad_OCSP = "OCSP",
      NID_ad_OCSP = 178,
      OBJ_ad_OCSP = "OBJ_id_ad,1L",
      SN_ad_ca_issuers = "caIssuers",
      LN_ad_ca_issuers = "CA",
      NID_ad_ca_issuers = 179,
      OBJ_ad_ca_issuers = "OBJ_id_ad,2L",
      SN_ad_timeStamping = "ad_timestamping",
      LN_ad_timeStamping = "AD",
      NID_ad_timeStamping = 363,
      OBJ_ad_timeStamping = "OBJ_id_ad,3L",
      SN_ad_dvcs = "AD_DVCS",
      LN_ad_dvcs = "ad",
      NID_ad_dvcs = 364,
      OBJ_ad_dvcs = "OBJ_id_ad,4L",
      SN_caRepository = "caRepository",
      LN_caRepository = "CA",
      NID_caRepository = 785,
      OBJ_caRepository = "OBJ_id_ad,5L",
      SN_rpkiManifest = "rpkiManifest",
      LN_rpkiManifest = "RPKI",
      NID_rpkiManifest = 1243,
      OBJ_rpkiManifest = "OBJ_id_ad,10L",
      SN_signedObject = "signedObject",
      LN_signedObject = "Signed",
      NID_signedObject = 1244,
      OBJ_signedObject = "OBJ_id_ad,11L",
      SN_rpkiNotify = "rpkiNotify",
      LN_rpkiNotify = "RPKI",
      NID_rpkiNotify = 1245,
      OBJ_rpkiNotify = "OBJ_id_ad,13L",
      OBJ_id_pkix_OCSP = "OBJ_id_ad,1L",
      SN_id_pkix_OCSP_basic = "basicOCSPResponse",
      LN_id_pkix_OCSP_basic = "Basic",
      NID_id_pkix_OCSP_basic = 365,
      OBJ_id_pkix_OCSP_basic = "OBJ_id_pkix_OCSP,1L",
      SN_id_pkix_OCSP_Nonce = "Nonce",
      LN_id_pkix_OCSP_Nonce = "OCSP",
      NID_id_pkix_OCSP_Nonce = 366,
      OBJ_id_pkix_OCSP_Nonce = "OBJ_id_pkix_OCSP,2L",
      SN_id_pkix_OCSP_CrlID = "CrlID",
      LN_id_pkix_OCSP_CrlID = "OCSP",
      NID_id_pkix_OCSP_CrlID = 367,
      OBJ_id_pkix_OCSP_CrlID = "OBJ_id_pkix_OCSP,3L",
      SN_id_pkix_OCSP_acceptableResponses = "acceptableResponses",
      LN_id_pkix_OCSP_acceptableResponses = "Acceptable",
      NID_id_pkix_OCSP_acceptableResponses = 368,
      OBJ_id_pkix_OCSP_acceptableResponses = "OBJ_id_pkix_OCSP,4L",
      SN_id_pkix_OCSP_noCheck = "noCheck",
      LN_id_pkix_OCSP_noCheck = "OCSP",
      NID_id_pkix_OCSP_noCheck = 369,
      OBJ_id_pkix_OCSP_noCheck = "OBJ_id_pkix_OCSP,5L",
      SN_id_pkix_OCSP_archiveCutoff = "archiveCutoff",
      LN_id_pkix_OCSP_archiveCutoff = "OCSP",
      NID_id_pkix_OCSP_archiveCutoff = 370,
      OBJ_id_pkix_OCSP_archiveCutoff = "OBJ_id_pkix_OCSP,6L",
      SN_id_pkix_OCSP_serviceLocator = "serviceLocator",
      LN_id_pkix_OCSP_serviceLocator = "OCSP",
      NID_id_pkix_OCSP_serviceLocator = 371,
      OBJ_id_pkix_OCSP_serviceLocator = "OBJ_id_pkix_OCSP,7L",
      SN_id_pkix_OCSP_extendedStatus = "extendedStatus",
      LN_id_pkix_OCSP_extendedStatus = "Extended",
      NID_id_pkix_OCSP_extendedStatus = 372,
      OBJ_id_pkix_OCSP_extendedStatus = "OBJ_id_pkix_OCSP,8L",
      SN_id_pkix_OCSP_valid = "valid",
      NID_id_pkix_OCSP_valid = 373,
      OBJ_id_pkix_OCSP_valid = "OBJ_id_pkix_OCSP,9L",
      SN_id_pkix_OCSP_path = "path",
      NID_id_pkix_OCSP_path = 374,
      OBJ_id_pkix_OCSP_path = "OBJ_id_pkix_OCSP,10L",
      SN_id_pkix_OCSP_trustRoot = "trustRoot",
      LN_id_pkix_OCSP_trustRoot = "Trust",
      NID_id_pkix_OCSP_trustRoot = 375,
      OBJ_id_pkix_OCSP_trustRoot = "OBJ_id_pkix_OCSP,11L",
      SN_algorithm = "algorithm",
      LN_algorithm = "algorithm",
      NID_algorithm = 376,
      OBJ_algorithm = 1,
      SN_md5WithRSA = "RSA-NP-MD5",
      LN_md5WithRSA = "md5WithRSA",
      NID_md5WithRSA = 104,
      OBJ_md5WithRSA = "OBJ_algorithm,3L",
      SN_des_ecb = "DES-ECB",
      LN_des_ecb = "des-ecb",
      NID_des_ecb = 29,
      OBJ_des_ecb = "OBJ_algorithm,6L",
      SN_des_cbc = "DES-CBC",
      LN_des_cbc = "des-cbc",
      NID_des_cbc = 31,
      OBJ_des_cbc = "OBJ_algorithm,7L",
      SN_des_ofb64 = "DES-OFB",
      LN_des_ofb64 = "des-ofb",
      NID_des_ofb64 = 45,
      OBJ_des_ofb64 = "OBJ_algorithm,8L",
      SN_des_cfb64 = "DES-CFB",
      LN_des_cfb64 = "des-cfb",
      NID_des_cfb64 = 30,
      OBJ_des_cfb64 = "OBJ_algorithm,9L",
      SN_rsaSignature = "rsaSignature",
      NID_rsaSignature = 377,
      OBJ_rsaSignature = "OBJ_algorithm,11L",
      SN_dsa_2 = "DSA-old",
      LN_dsa_2 = "dsaEncryption-old",
      NID_dsa_2 = 67,
      OBJ_dsa_2 = "OBJ_algorithm,12L",
      SN_dsaWithSHA = "DSA-SHA",
      LN_dsaWithSHA = "dsaWithSHA",
      NID_dsaWithSHA = 66,
      OBJ_dsaWithSHA = "OBJ_algorithm,13L",
      SN_shaWithRSAEncryption = "RSA-SHA",
      LN_shaWithRSAEncryption = "shaWithRSAEncryption",
      NID_shaWithRSAEncryption = 42,
      OBJ_shaWithRSAEncryption = "OBJ_algorithm,15L",
      SN_des_ede_ecb = "DES-EDE",
      LN_des_ede_ecb = "des-ede",
      NID_des_ede_ecb = 32,
      OBJ_des_ede_ecb = "OBJ_algorithm,17L",
      SN_des_ede3_ecb = "DES-EDE3",
      LN_des_ede3_ecb = "des-ede3",
      NID_des_ede3_ecb = 33,
      SN_des_ede_cbc = "DES-EDE-CBC",
      LN_des_ede_cbc = "des-ede-cbc",
      NID_des_ede_cbc = 43,
      SN_des_ede_cfb64 = "DES-EDE-CFB",
      LN_des_ede_cfb64 = "des-ede-cfb",
      NID_des_ede_cfb64 = 60,
      SN_des_ede3_cfb64 = "DES-EDE3-CFB",
      LN_des_ede3_cfb64 = "des-ede3-cfb",
      NID_des_ede3_cfb64 = 61,
      SN_des_ede_ofb64 = "DES-EDE-OFB",
      LN_des_ede_ofb64 = "des-ede-ofb",
      NID_des_ede_ofb64 = 62,
      SN_des_ede3_ofb64 = "DES-EDE3-OFB",
      LN_des_ede3_ofb64 = "des-ede3-ofb",
      NID_des_ede3_ofb64 = 63,
      SN_desx_cbc = "DESX-CBC",
      LN_desx_cbc = "desx-cbc",
      NID_desx_cbc = 80,
      SN_sha = "SHA",
      LN_sha = "sha",
      NID_sha = 41,
      OBJ_sha = "OBJ_algorithm,18L",
      SN_sha1 = "SHA1",
      LN_sha1 = "sha1",
      NID_sha1 = 64,
      OBJ_sha1 = "OBJ_algorithm,26L",
      SN_dsaWithSHA1_2 = "DSA-SHA1-old",
      LN_dsaWithSHA1_2 = "dsaWithSHA1-old",
      NID_dsaWithSHA1_2 = 70,
      OBJ_dsaWithSHA1_2 = "OBJ_algorithm,27L",
      SN_sha1WithRSA = "RSA-SHA1-2",
      LN_sha1WithRSA = "sha1WithRSA",
      NID_sha1WithRSA = 115,
      OBJ_sha1WithRSA = "OBJ_algorithm,29L",
      SN_ripemd160 = "RIPEMD160",
      LN_ripemd160 = "ripemd160",
      NID_ripemd160 = 117,
      OBJ_ripemd160 = 1,
      SN_ripemd160WithRSA = "RSA-RIPEMD160",
      LN_ripemd160WithRSA = "ripemd160WithRSA",
      NID_ripemd160WithRSA = 119,
      OBJ_ripemd160WithRSA = 1,
      SN_blake2bmac = "BLAKE2BMAC",
      LN_blake2bmac = "blake2bmac",
      NID_blake2bmac = 1201,
      OBJ_blake2bmac = 1,
      SN_blake2smac = "BLAKE2SMAC",
      LN_blake2smac = "blake2smac",
      NID_blake2smac = 1202,
      OBJ_blake2smac = 1,
      SN_blake2b512 = "BLAKE2b512",
      LN_blake2b512 = "blake2b512",
      NID_blake2b512 = 1056,
      OBJ_blake2b512 = "OBJ_blake2bmac,16L",
      SN_blake2s256 = "BLAKE2s256",
      LN_blake2s256 = "blake2s256",
      NID_blake2s256 = 1057,
      OBJ_blake2s256 = "OBJ_blake2smac,8L",
      SN_sxnet = "SXNetID",
      LN_sxnet = "Strong",
      NID_sxnet = 143,
      OBJ_sxnet = 1,
      SN_X500 = "X500",
      LN_X500 = "directory",
      NID_X500 = 11,
      OBJ_X500 = 2,
      SN_X509 = "X509",
      NID_X509 = 12,
      OBJ_X509 = "OBJ_X500,4L",
      SN_commonName = "CN",
      LN_commonName = "commonName",
      NID_commonName = 13,
      OBJ_commonName = "OBJ_X509,3L",
      SN_surname = "SN",
      LN_surname = "surname",
      NID_surname = 100,
      OBJ_surname = "OBJ_X509,4L",
      LN_serialNumber = "serialNumber",
      NID_serialNumber = 105,
      OBJ_serialNumber = "OBJ_X509,5L",
      SN_countryName = "C",
      LN_countryName = "countryName",
      NID_countryName = 14,
      OBJ_countryName = "OBJ_X509,6L",
      SN_localityName = "L",
      LN_localityName = "localityName",
      NID_localityName = 15,
      OBJ_localityName = "OBJ_X509,7L",
      SN_stateOrProvinceName = "ST",
      LN_stateOrProvinceName = "stateOrProvinceName",
      NID_stateOrProvinceName = 16,
      OBJ_stateOrProvinceName = "OBJ_X509,8L",
      SN_streetAddress = "street",
      LN_streetAddress = "streetAddress",
      NID_streetAddress = 660,
      OBJ_streetAddress = "OBJ_X509,9L",
      SN_organizationName = "O",
      LN_organizationName = "organizationName",
      NID_organizationName = 17,
      OBJ_organizationName = "OBJ_X509,10L",
      SN_organizationalUnitName = "OU",
      LN_organizationalUnitName = "organizationalUnitName",
      NID_organizationalUnitName = 18,
      OBJ_organizationalUnitName = "OBJ_X509,11L",
      SN_title = "title",
      LN_title = "title",
      NID_title = 106,
      OBJ_title = "OBJ_X509,12L",
      LN_description = "description",
      NID_description = 107,
      OBJ_description = "OBJ_X509,13L",
      LN_searchGuide = "searchGuide",
      NID_searchGuide = 859,
      OBJ_searchGuide = "OBJ_X509,14L",
      LN_businessCategory = "businessCategory",
      NID_businessCategory = 860,
      OBJ_businessCategory = "OBJ_X509,15L",
      LN_postalAddress = "postalAddress",
      NID_postalAddress = 861,
      OBJ_postalAddress = "OBJ_X509,16L",
      LN_postalCode = "postalCode",
      NID_postalCode = 661,
      OBJ_postalCode = "OBJ_X509,17L",
      LN_postOfficeBox = "postOfficeBox",
      NID_postOfficeBox = 862,
      OBJ_postOfficeBox = "OBJ_X509,18L",
      LN_physicalDeliveryOfficeName = "physicalDeliveryOfficeName",
      NID_physicalDeliveryOfficeName = 863,
      OBJ_physicalDeliveryOfficeName = "OBJ_X509,19L",
      LN_telephoneNumber = "telephoneNumber",
      NID_telephoneNumber = 864,
      OBJ_telephoneNumber = "OBJ_X509,20L",
      LN_telexNumber = "telexNumber",
      NID_telexNumber = 865,
      OBJ_telexNumber = "OBJ_X509,21L",
      LN_teletexTerminalIdentifier = "teletexTerminalIdentifier",
      NID_teletexTerminalIdentifier = 866,
      OBJ_teletexTerminalIdentifier = "OBJ_X509,22L",
      LN_facsimileTelephoneNumber = "facsimileTelephoneNumber",
      NID_facsimileTelephoneNumber = 867,
      OBJ_facsimileTelephoneNumber = "OBJ_X509,23L",
      LN_x121Address = "x121Address",
      NID_x121Address = 868,
      OBJ_x121Address = "OBJ_X509,24L",
      LN_internationaliSDNNumber = "internationaliSDNNumber",
      NID_internationaliSDNNumber = 869,
      OBJ_internationaliSDNNumber = "OBJ_X509,25L",
      LN_registeredAddress = "registeredAddress",
      NID_registeredAddress = 870,
      OBJ_registeredAddress = "OBJ_X509,26L",
      LN_destinationIndicator = "destinationIndicator",
      NID_destinationIndicator = 871,
      OBJ_destinationIndicator = "OBJ_X509,27L",
      LN_preferredDeliveryMethod = "preferredDeliveryMethod",
      NID_preferredDeliveryMethod = 872,
      OBJ_preferredDeliveryMethod = "OBJ_X509,28L",
      LN_presentationAddress = "presentationAddress",
      NID_presentationAddress = 873,
      OBJ_presentationAddress = "OBJ_X509,29L",
      LN_supportedApplicationContext = "supportedApplicationContext",
      NID_supportedApplicationContext = 874,
      OBJ_supportedApplicationContext = "OBJ_X509,30L",
      SN_member = "member",
      NID_member = 875,
      OBJ_member = "OBJ_X509,31L",
      SN_owner = "owner",
      NID_owner = 876,
      OBJ_owner = "OBJ_X509,32L",
      LN_roleOccupant = "roleOccupant",
      NID_roleOccupant = 877,
      OBJ_roleOccupant = "OBJ_X509,33L",
      SN_seeAlso = "seeAlso",
      NID_seeAlso = 878,
      OBJ_seeAlso = "OBJ_X509,34L",
      LN_userPassword = "userPassword",
      NID_userPassword = 879,
      OBJ_userPassword = "OBJ_X509,35L",
      LN_userCertificate = "userCertificate",
      NID_userCertificate = 880,
      OBJ_userCertificate = "OBJ_X509,36L",
      LN_cACertificate = "cACertificate",
      NID_cACertificate = 881,
      OBJ_cACertificate = "OBJ_X509,37L",
      LN_authorityRevocationList = "authorityRevocationList",
      NID_authorityRevocationList = 882,
      OBJ_authorityRevocationList = "OBJ_X509,38L",
      LN_certificateRevocationList = "certificateRevocationList",
      NID_certificateRevocationList = 883,
      OBJ_certificateRevocationList = "OBJ_X509,39L",
      LN_crossCertificatePair = "crossCertificatePair",
      NID_crossCertificatePair = 884,
      OBJ_crossCertificatePair = "OBJ_X509,40L",
      SN_name = "name",
      LN_name = "name",
      NID_name = 173,
      OBJ_name = "OBJ_X509,41L",
      SN_givenName = "GN",
      LN_givenName = "givenName",
      NID_givenName = 99,
      OBJ_givenName = "OBJ_X509,42L",
      SN_initials = "initials",
      LN_initials = "initials",
      NID_initials = 101,
      OBJ_initials = "OBJ_X509,43L",
      LN_generationQualifier = "generationQualifier",
      NID_generationQualifier = 509,
      OBJ_generationQualifier = "OBJ_X509,44L",
      LN_x500UniqueIdentifier = "x500UniqueIdentifier",
      NID_x500UniqueIdentifier = 503,
      OBJ_x500UniqueIdentifier = "OBJ_X509,45L",
      SN_dnQualifier = "dnQualifier",
      LN_dnQualifier = "dnQualifier",
      NID_dnQualifier = 174,
      OBJ_dnQualifier = "OBJ_X509,46L",
      LN_enhancedSearchGuide = "enhancedSearchGuide",
      NID_enhancedSearchGuide = 885,
      OBJ_enhancedSearchGuide = "OBJ_X509,47L",
      LN_protocolInformation = "protocolInformation",
      NID_protocolInformation = 886,
      OBJ_protocolInformation = "OBJ_X509,48L",
      LN_distinguishedName = "distinguishedName",
      NID_distinguishedName = 887,
      OBJ_distinguishedName = "OBJ_X509,49L",
      LN_uniqueMember = "uniqueMember",
      NID_uniqueMember = 888,
      OBJ_uniqueMember = "OBJ_X509,50L",
      LN_houseIdentifier = "houseIdentifier",
      NID_houseIdentifier = 889,
      OBJ_houseIdentifier = "OBJ_X509,51L",
      LN_supportedAlgorithms = "supportedAlgorithms",
      NID_supportedAlgorithms = 890,
      OBJ_supportedAlgorithms = "OBJ_X509,52L",
      LN_deltaRevocationList = "deltaRevocationList",
      NID_deltaRevocationList = 891,
      OBJ_deltaRevocationList = "OBJ_X509,53L",
      SN_dmdName = "dmdName",
      NID_dmdName = 892,
      OBJ_dmdName = "OBJ_X509,54L",
      LN_pseudonym = "pseudonym",
      NID_pseudonym = 510,
      OBJ_pseudonym = "OBJ_X509,65L",
      SN_role = "role",
      LN_role = "role",
      NID_role = 400,
      OBJ_role = "OBJ_X509,72L",
      LN_organizationIdentifier = "organizationIdentifier",
      NID_organizationIdentifier = 1089,
      OBJ_organizationIdentifier = "OBJ_X509,97L",
      SN_countryCode3c = "c3",
      LN_countryCode3c = "countryCode3c",
      NID_countryCode3c = 1090,
      OBJ_countryCode3c = "OBJ_X509,98L",
      SN_countryCode3n = "n3",
      LN_countryCode3n = "countryCode3n",
      NID_countryCode3n = 1091,
      OBJ_countryCode3n = "OBJ_X509,99L",
      LN_dnsName = "dnsName",
      NID_dnsName = 1092,
      OBJ_dnsName = "OBJ_X509,100L",
      SN_X500algorithms = "X500algorithms",
      LN_X500algorithms = "directory",
      NID_X500algorithms = 378,
      OBJ_X500algorithms = "OBJ_X500,8L",
      SN_rsa = "RSA",
      LN_rsa = "rsa",
      NID_rsa = 19,
      OBJ_rsa = "OBJ_X500algorithms,1L,1L",
      SN_mdc2WithRSA = "RSA-MDC2",
      LN_mdc2WithRSA = "mdc2WithRSA",
      NID_mdc2WithRSA = 96,
      OBJ_mdc2WithRSA = "OBJ_X500algorithms,3L,100L",
      SN_mdc2 = "MDC2",
      LN_mdc2 = "mdc2",
      NID_mdc2 = 95,
      OBJ_mdc2 = "OBJ_X500algorithms,3L,101L",
      SN_id_ce = "id-ce",
      NID_id_ce = 81,
      OBJ_id_ce = "OBJ_X500,29L",
      SN_subject_directory_attributes = "subjectDirectoryAttributes",
      LN_subject_directory_attributes = "X509v3",
      NID_subject_directory_attributes = 769,
      OBJ_subject_directory_attributes = "OBJ_id_ce,9L",
      SN_subject_key_identifier = "subjectKeyIdentifier",
      LN_subject_key_identifier = "X509v3",
      NID_subject_key_identifier = 82,
      OBJ_subject_key_identifier = "OBJ_id_ce,14L",
      SN_key_usage = "keyUsage",
      LN_key_usage = "X509v3",
      NID_key_usage = 83,
      OBJ_key_usage = "OBJ_id_ce,15L",
      SN_private_key_usage_period = "privateKeyUsagePeriod",
      LN_private_key_usage_period = "X509v3",
      NID_private_key_usage_period = 84,
      OBJ_private_key_usage_period = "OBJ_id_ce,16L",
      SN_subject_alt_name = "subjectAltName",
      LN_subject_alt_name = "X509v3",
      NID_subject_alt_name = 85,
      OBJ_subject_alt_name = "OBJ_id_ce,17L",
      SN_issuer_alt_name = "issuerAltName",
      LN_issuer_alt_name = "X509v3",
      NID_issuer_alt_name = 86,
      OBJ_issuer_alt_name = "OBJ_id_ce,18L",
      SN_basic_constraints = "basicConstraints",
      LN_basic_constraints = "X509v3",
      NID_basic_constraints = 87,
      OBJ_basic_constraints = "OBJ_id_ce,19L",
      SN_crl_number = "crlNumber",
      LN_crl_number = "X509v3",
      NID_crl_number = 88,
      OBJ_crl_number = "OBJ_id_ce,20L",
      SN_crl_reason = "CRLReason",
      LN_crl_reason = "X509v3",
      NID_crl_reason = 141,
      OBJ_crl_reason = "OBJ_id_ce,21L",
      SN_invalidity_date = "invalidityDate",
      LN_invalidity_date = "Invalidity",
      NID_invalidity_date = 142,
      OBJ_invalidity_date = "OBJ_id_ce,24L",
      SN_delta_crl = "deltaCRL",
      LN_delta_crl = "X509v3",
      NID_delta_crl = 140,
      OBJ_delta_crl = "OBJ_id_ce,27L",
      SN_issuing_distribution_point = "issuingDistributionPoint",
      LN_issuing_distribution_point = "X509v3",
      NID_issuing_distribution_point = 770,
      OBJ_issuing_distribution_point = "OBJ_id_ce,28L",
      SN_certificate_issuer = "certificateIssuer",
      LN_certificate_issuer = "X509v3",
      NID_certificate_issuer = 771,
      OBJ_certificate_issuer = "OBJ_id_ce,29L",
      SN_name_constraints = "nameConstraints",
      LN_name_constraints = "X509v3",
      NID_name_constraints = 666,
      OBJ_name_constraints = "OBJ_id_ce,30L",
      SN_crl_distribution_points = "crlDistributionPoints",
      LN_crl_distribution_points = "X509v3",
      NID_crl_distribution_points = 103,
      OBJ_crl_distribution_points = "OBJ_id_ce,31L",
      SN_certificate_policies = "certificatePolicies",
      LN_certificate_policies = "X509v3",
      NID_certificate_policies = 89,
      OBJ_certificate_policies = "OBJ_id_ce,32L",
      SN_any_policy = "anyPolicy",
      LN_any_policy = "X509v3",
      NID_any_policy = 746,
      OBJ_any_policy = "OBJ_certificate_policies,0L",
      SN_policy_mappings = "policyMappings",
      LN_policy_mappings = "X509v3",
      NID_policy_mappings = 747,
      OBJ_policy_mappings = "OBJ_id_ce,33L",
      SN_authority_key_identifier = "authorityKeyIdentifier",
      LN_authority_key_identifier = "X509v3",
      NID_authority_key_identifier = 90,
      OBJ_authority_key_identifier = "OBJ_id_ce,35L",
      SN_policy_constraints = "policyConstraints",
      LN_policy_constraints = "X509v3",
      NID_policy_constraints = 401,
      OBJ_policy_constraints = "OBJ_id_ce,36L",
      SN_ext_key_usage = "extendedKeyUsage",
      LN_ext_key_usage = "X509v3",
      NID_ext_key_usage = 126,
      OBJ_ext_key_usage = "OBJ_id_ce,37L",
      SN_freshest_crl = "freshestCRL",
      LN_freshest_crl = "X509v3",
      NID_freshest_crl = 857,
      OBJ_freshest_crl = "OBJ_id_ce,46L",
      SN_inhibit_any_policy = "inhibitAnyPolicy",
      LN_inhibit_any_policy = "X509v3",
      NID_inhibit_any_policy = 748,
      OBJ_inhibit_any_policy = "OBJ_id_ce,54L",
      SN_target_information = "targetInformation",
      LN_target_information = "X509v3",
      NID_target_information = 402,
      OBJ_target_information = "OBJ_id_ce,55L",
      SN_no_rev_avail = "noRevAvail",
      LN_no_rev_avail = "X509v3",
      NID_no_rev_avail = 403,
      OBJ_no_rev_avail = "OBJ_id_ce,56L",
      SN_anyExtendedKeyUsage = "anyExtendedKeyUsage",
      LN_anyExtendedKeyUsage = "Any",
      NID_anyExtendedKeyUsage = 910,
      OBJ_anyExtendedKeyUsage = "OBJ_ext_key_usage,0L",
      SN_netscape = "Netscape",
      LN_netscape = "Netscape",
      NID_netscape = 57,
      OBJ_netscape = 2,
      SN_netscape_cert_extension = "nsCertExt",
      LN_netscape_cert_extension = "Netscape",
      NID_netscape_cert_extension = 58,
      OBJ_netscape_cert_extension = "OBJ_netscape,1L",
      SN_netscape_data_type = "nsDataType",
      LN_netscape_data_type = "Netscape",
      NID_netscape_data_type = 59,
      OBJ_netscape_data_type = "OBJ_netscape,2L",
      SN_netscape_cert_type = "nsCertType",
      LN_netscape_cert_type = "Netscape",
      NID_netscape_cert_type = 71,
      OBJ_netscape_cert_type = "OBJ_netscape_cert_extension,1L",
      SN_netscape_base_url = "nsBaseUrl",
      LN_netscape_base_url = "Netscape",
      NID_netscape_base_url = 72,
      OBJ_netscape_base_url = "OBJ_netscape_cert_extension,2L",
      SN_netscape_revocation_url = "nsRevocationUrl",
      LN_netscape_revocation_url = "Netscape",
      NID_netscape_revocation_url = 73,
      OBJ_netscape_revocation_url = "OBJ_netscape_cert_extension,3L",
      SN_netscape_ca_revocation_url = "nsCaRevocationUrl",
      LN_netscape_ca_revocation_url = "Netscape",
      NID_netscape_ca_revocation_url = 74,
      OBJ_netscape_ca_revocation_url = "OBJ_netscape_cert_extension,4L",
      SN_netscape_renewal_url = "nsRenewalUrl",
      LN_netscape_renewal_url = "Netscape",
      NID_netscape_renewal_url = 75,
      OBJ_netscape_renewal_url = "OBJ_netscape_cert_extension,7L",
      SN_netscape_ca_policy_url = "nsCaPolicyUrl",
      LN_netscape_ca_policy_url = "Netscape",
      NID_netscape_ca_policy_url = 76,
      OBJ_netscape_ca_policy_url = "OBJ_netscape_cert_extension,8L",
      SN_netscape_ssl_server_name = "nsSslServerName",
      LN_netscape_ssl_server_name = "Netscape",
      NID_netscape_ssl_server_name = 77,
      OBJ_netscape_ssl_server_name = "OBJ_netscape_cert_extension,12L",
      SN_netscape_comment = "nsComment",
      LN_netscape_comment = "Netscape",
      NID_netscape_comment = 78,
      OBJ_netscape_comment = "OBJ_netscape_cert_extension,13L",
      SN_netscape_cert_sequence = "nsCertSequence",
      LN_netscape_cert_sequence = "Netscape",
      NID_netscape_cert_sequence = 79,
      OBJ_netscape_cert_sequence = "OBJ_netscape_data_type,5L",
      SN_ns_sgc = "nsSGC",
      LN_ns_sgc = "Netscape",
      NID_ns_sgc = 139,
      OBJ_ns_sgc = "OBJ_netscape,4L,1L",
      SN_org = "ORG",
      LN_org = "org",
      NID_org = 379,
      OBJ_org = "OBJ_iso,3L",
      SN_dod = "DOD",
      LN_dod = "dod",
      NID_dod = 380,
      OBJ_dod = "OBJ_org,6L",
      SN_iana = "IANA",
      LN_iana = "iana",
      NID_iana = 381,
      OBJ_iana = "OBJ_dod,1L",
      OBJ_internet = "OBJ_dod,1L",
      SN_Directory = "directory",
      LN_Directory = "Directory",
      NID_Directory = 382,
      OBJ_Directory = "OBJ_internet,1L",
      SN_Management = "mgmt",
      LN_Management = "Management",
      NID_Management = 383,
      OBJ_Management = "OBJ_internet,2L",
      SN_Experimental = "experimental",
      LN_Experimental = "Experimental",
      NID_Experimental = 384,
      OBJ_Experimental = "OBJ_internet,3L",
      SN_Private = "private",
      LN_Private = "Private",
      NID_Private = 385,
      OBJ_Private = "OBJ_internet,4L",
      SN_Security = "security",
      LN_Security = "Security",
      NID_Security = 386,
      OBJ_Security = "OBJ_internet,5L",
      SN_SNMPv2 = "snmpv2",
      LN_SNMPv2 = "SNMPv2",
      NID_SNMPv2 = 387,
      OBJ_SNMPv2 = "OBJ_internet,6L",
      LN_Mail = "Mail",
      NID_Mail = 388,
      OBJ_Mail = "OBJ_internet,7L",
      SN_Enterprises = "enterprises",
      LN_Enterprises = "Enterprises",
      NID_Enterprises = 389,
      OBJ_Enterprises = "OBJ_Private,1L",
      SN_dcObject = "dcobject",
      LN_dcObject = "dcObject",
      NID_dcObject = 390,
      OBJ_dcObject = "OBJ_Enterprises,1466L,344L",
      SN_mime_mhs = "mime-mhs",
      LN_mime_mhs = "MIME",
      NID_mime_mhs = 504,
      OBJ_mime_mhs = "OBJ_Mail,1L",
      SN_mime_mhs_headings = "mime-mhs-headings",
      LN_mime_mhs_headings = "mime-mhs-headings",
      NID_mime_mhs_headings = 505,
      OBJ_mime_mhs_headings = "OBJ_mime_mhs,1L",
      SN_mime_mhs_bodies = "mime-mhs-bodies",
      LN_mime_mhs_bodies = "mime-mhs-bodies",
      NID_mime_mhs_bodies = 506,
      OBJ_mime_mhs_bodies = "OBJ_mime_mhs,2L",
      SN_id_hex_partial_message = "id-hex-partial-message",
      LN_id_hex_partial_message = "id-hex-partial-message",
      NID_id_hex_partial_message = 507,
      OBJ_id_hex_partial_message = "OBJ_mime_mhs_headings,1L",
      SN_id_hex_multipart_message = "id-hex-multipart-message",
      LN_id_hex_multipart_message = "id-hex-multipart-message",
      NID_id_hex_multipart_message = 508,
      OBJ_id_hex_multipart_message = "OBJ_mime_mhs_headings,2L",
      SN_zlib_compression = "ZLIB",
      LN_zlib_compression = "zlib",
      NID_zlib_compression = 125,
      OBJ_zlib_compression = "OBJ_id_smime_alg,8L",
      OBJ_csor = 2,
      OBJ_nistAlgorithms = "OBJ_csor,4L",
      OBJ_aes = "OBJ_nistAlgorithms,1L",
      SN_aes_128_ecb = "AES-128-ECB",
      LN_aes_128_ecb = "aes-128-ecb",
      NID_aes_128_ecb = 418,
      OBJ_aes_128_ecb = "OBJ_aes,1L",
      SN_aes_128_cbc = "AES-128-CBC",
      LN_aes_128_cbc = "aes-128-cbc",
      NID_aes_128_cbc = 419,
      OBJ_aes_128_cbc = "OBJ_aes,2L",
      SN_aes_128_ofb128 = "AES-128-OFB",
      LN_aes_128_ofb128 = "aes-128-ofb",
      NID_aes_128_ofb128 = 420,
      OBJ_aes_128_ofb128 = "OBJ_aes,3L",
      SN_aes_128_cfb128 = "AES-128-CFB",
      LN_aes_128_cfb128 = "aes-128-cfb",
      NID_aes_128_cfb128 = 421,
      OBJ_aes_128_cfb128 = "OBJ_aes,4L",
      SN_id_aes128_wrap = "id-aes128-wrap",
      NID_id_aes128_wrap = 788,
      OBJ_id_aes128_wrap = "OBJ_aes,5L",
      SN_aes_128_gcm = "id-aes128-GCM",
      LN_aes_128_gcm = "aes-128-gcm",
      NID_aes_128_gcm = 895,
      OBJ_aes_128_gcm = "OBJ_aes,6L",
      SN_aes_128_ccm = "id-aes128-CCM",
      LN_aes_128_ccm = "aes-128-ccm",
      NID_aes_128_ccm = 896,
      OBJ_aes_128_ccm = "OBJ_aes,7L",
      SN_id_aes128_wrap_pad = "id-aes128-wrap-pad",
      NID_id_aes128_wrap_pad = 897,
      OBJ_id_aes128_wrap_pad = "OBJ_aes,8L",
      SN_aes_192_ecb = "AES-192-ECB",
      LN_aes_192_ecb = "aes-192-ecb",
      NID_aes_192_ecb = 422,
      OBJ_aes_192_ecb = "OBJ_aes,21L",
      SN_aes_192_cbc = "AES-192-CBC",
      LN_aes_192_cbc = "aes-192-cbc",
      NID_aes_192_cbc = 423,
      OBJ_aes_192_cbc = "OBJ_aes,22L",
      SN_aes_192_ofb128 = "AES-192-OFB",
      LN_aes_192_ofb128 = "aes-192-ofb",
      NID_aes_192_ofb128 = 424,
      OBJ_aes_192_ofb128 = "OBJ_aes,23L",
      SN_aes_192_cfb128 = "AES-192-CFB",
      LN_aes_192_cfb128 = "aes-192-cfb",
      NID_aes_192_cfb128 = 425,
      OBJ_aes_192_cfb128 = "OBJ_aes,24L",
      SN_id_aes192_wrap = "id-aes192-wrap",
      NID_id_aes192_wrap = 789,
      OBJ_id_aes192_wrap = "OBJ_aes,25L",
      SN_aes_192_gcm = "id-aes192-GCM",
      LN_aes_192_gcm = "aes-192-gcm",
      NID_aes_192_gcm = 898,
      OBJ_aes_192_gcm = "OBJ_aes,26L",
      SN_aes_192_ccm = "id-aes192-CCM",
      LN_aes_192_ccm = "aes-192-ccm",
      NID_aes_192_ccm = 899,
      OBJ_aes_192_ccm = "OBJ_aes,27L",
      SN_id_aes192_wrap_pad = "id-aes192-wrap-pad",
      NID_id_aes192_wrap_pad = 900,
      OBJ_id_aes192_wrap_pad = "OBJ_aes,28L",
      SN_aes_256_ecb = "AES-256-ECB",
      LN_aes_256_ecb = "aes-256-ecb",
      NID_aes_256_ecb = 426,
      OBJ_aes_256_ecb = "OBJ_aes,41L",
      SN_aes_256_cbc = "AES-256-CBC",
      LN_aes_256_cbc = "aes-256-cbc",
      NID_aes_256_cbc = 427,
      OBJ_aes_256_cbc = "OBJ_aes,42L",
      SN_aes_256_ofb128 = "AES-256-OFB",
      LN_aes_256_ofb128 = "aes-256-ofb",
      NID_aes_256_ofb128 = 428,
      OBJ_aes_256_ofb128 = "OBJ_aes,43L",
      SN_aes_256_cfb128 = "AES-256-CFB",
      LN_aes_256_cfb128 = "aes-256-cfb",
      NID_aes_256_cfb128 = 429,
      OBJ_aes_256_cfb128 = "OBJ_aes,44L",
      SN_id_aes256_wrap = "id-aes256-wrap",
      NID_id_aes256_wrap = 790,
      OBJ_id_aes256_wrap = "OBJ_aes,45L",
      SN_aes_256_gcm = "id-aes256-GCM",
      LN_aes_256_gcm = "aes-256-gcm",
      NID_aes_256_gcm = 901,
      OBJ_aes_256_gcm = "OBJ_aes,46L",
      SN_aes_256_ccm = "id-aes256-CCM",
      LN_aes_256_ccm = "aes-256-ccm",
      NID_aes_256_ccm = 902,
      OBJ_aes_256_ccm = "OBJ_aes,47L",
      SN_id_aes256_wrap_pad = "id-aes256-wrap-pad",
      NID_id_aes256_wrap_pad = 903,
      OBJ_id_aes256_wrap_pad = "OBJ_aes,48L",
      SN_aes_128_xts = "AES-128-XTS",
      LN_aes_128_xts = "aes-128-xts",
      NID_aes_128_xts = 913,
      OBJ_aes_128_xts = "OBJ_ieee_siswg,0L,1L,1L",
      SN_aes_256_xts = "AES-256-XTS",
      LN_aes_256_xts = "aes-256-xts",
      NID_aes_256_xts = 914,
      OBJ_aes_256_xts = "OBJ_ieee_siswg,0L,1L,2L",
      SN_aes_128_cfb1 = "AES-128-CFB1",
      LN_aes_128_cfb1 = "aes-128-cfb1",
      NID_aes_128_cfb1 = 650,
      SN_aes_192_cfb1 = "AES-192-CFB1",
      LN_aes_192_cfb1 = "aes-192-cfb1",
      NID_aes_192_cfb1 = 651,
      SN_aes_256_cfb1 = "AES-256-CFB1",
      LN_aes_256_cfb1 = "aes-256-cfb1",
      NID_aes_256_cfb1 = 652,
      SN_aes_128_cfb8 = "AES-128-CFB8",
      LN_aes_128_cfb8 = "aes-128-cfb8",
      NID_aes_128_cfb8 = 653,
      SN_aes_192_cfb8 = "AES-192-CFB8",
      LN_aes_192_cfb8 = "aes-192-cfb8",
      NID_aes_192_cfb8 = 654,
      SN_aes_256_cfb8 = "AES-256-CFB8",
      LN_aes_256_cfb8 = "aes-256-cfb8",
      NID_aes_256_cfb8 = 655,
      SN_aes_128_ctr = "AES-128-CTR",
      LN_aes_128_ctr = "aes-128-ctr",
      NID_aes_128_ctr = 904,
      SN_aes_192_ctr = "AES-192-CTR",
      LN_aes_192_ctr = "aes-192-ctr",
      NID_aes_192_ctr = 905,
      SN_aes_256_ctr = "AES-256-CTR",
      LN_aes_256_ctr = "aes-256-ctr",
      NID_aes_256_ctr = 906,
      SN_aes_128_ocb = "AES-128-OCB",
      LN_aes_128_ocb = "aes-128-ocb",
      NID_aes_128_ocb = 958,
      SN_aes_192_ocb = "AES-192-OCB",
      LN_aes_192_ocb = "aes-192-ocb",
      NID_aes_192_ocb = 959,
      SN_aes_256_ocb = "AES-256-OCB",
      LN_aes_256_ocb = "aes-256-ocb",
      NID_aes_256_ocb = 960,
      SN_des_cfb1 = "DES-CFB1",
      LN_des_cfb1 = "des-cfb1",
      NID_des_cfb1 = 656,
      SN_des_cfb8 = "DES-CFB8",
      LN_des_cfb8 = "des-cfb8",
      NID_des_cfb8 = 657,
      SN_des_ede3_cfb1 = "DES-EDE3-CFB1",
      LN_des_ede3_cfb1 = "des-ede3-cfb1",
      NID_des_ede3_cfb1 = 658,
      SN_des_ede3_cfb8 = "DES-EDE3-CFB8",
      LN_des_ede3_cfb8 = "des-ede3-cfb8",
      NID_des_ede3_cfb8 = 659,
      OBJ_nist_hashalgs = "OBJ_nistAlgorithms,2L",
      SN_sha256 = "SHA256",
      LN_sha256 = "sha256",
      NID_sha256 = 672,
      OBJ_sha256 = "OBJ_nist_hashalgs,1L",
      SN_sha384 = "SHA384",
      LN_sha384 = "sha384",
      NID_sha384 = 673,
      OBJ_sha384 = "OBJ_nist_hashalgs,2L",
      SN_sha512 = "SHA512",
      LN_sha512 = "sha512",
      NID_sha512 = 674,
      OBJ_sha512 = "OBJ_nist_hashalgs,3L",
      SN_sha224 = "SHA224",
      LN_sha224 = "sha224",
      NID_sha224 = 675,
      OBJ_sha224 = "OBJ_nist_hashalgs,4L",
      SN_sha512_224 = "SHA512-224",
      LN_sha512_224 = "sha512-224",
      NID_sha512_224 = 1094,
      OBJ_sha512_224 = "OBJ_nist_hashalgs,5L",
      SN_sha512_256 = "SHA512-256",
      LN_sha512_256 = "sha512-256",
      NID_sha512_256 = 1095,
      OBJ_sha512_256 = "OBJ_nist_hashalgs,6L",
      SN_sha3_224 = "SHA3-224",
      LN_sha3_224 = "sha3-224",
      NID_sha3_224 = 1096,
      OBJ_sha3_224 = "OBJ_nist_hashalgs,7L",
      SN_sha3_256 = "SHA3-256",
      LN_sha3_256 = "sha3-256",
      NID_sha3_256 = 1097,
      OBJ_sha3_256 = "OBJ_nist_hashalgs,8L",
      SN_sha3_384 = "SHA3-384",
      LN_sha3_384 = "sha3-384",
      NID_sha3_384 = 1098,
      OBJ_sha3_384 = "OBJ_nist_hashalgs,9L",
      SN_sha3_512 = "SHA3-512",
      LN_sha3_512 = "sha3-512",
      NID_sha3_512 = 1099,
      OBJ_sha3_512 = "OBJ_nist_hashalgs,10L",
      SN_shake128 = "SHAKE128",
      LN_shake128 = "shake128",
      NID_shake128 = 1100,
      OBJ_shake128 = "OBJ_nist_hashalgs,11L",
      SN_shake256 = "SHAKE256",
      LN_shake256 = "shake256",
      NID_shake256 = 1101,
      OBJ_shake256 = "OBJ_nist_hashalgs,12L",
      SN_hmac_sha3_224 = "id-hmacWithSHA3-224",
      LN_hmac_sha3_224 = "hmac-sha3-224",
      NID_hmac_sha3_224 = 1102,
      OBJ_hmac_sha3_224 = "OBJ_nist_hashalgs,13L",
      SN_hmac_sha3_256 = "id-hmacWithSHA3-256",
      LN_hmac_sha3_256 = "hmac-sha3-256",
      NID_hmac_sha3_256 = 1103,
      OBJ_hmac_sha3_256 = "OBJ_nist_hashalgs,14L",
      SN_hmac_sha3_384 = "id-hmacWithSHA3-384",
      LN_hmac_sha3_384 = "hmac-sha3-384",
      NID_hmac_sha3_384 = 1104,
      OBJ_hmac_sha3_384 = "OBJ_nist_hashalgs,15L",
      SN_hmac_sha3_512 = "id-hmacWithSHA3-512",
      LN_hmac_sha3_512 = "hmac-sha3-512",
      NID_hmac_sha3_512 = 1105,
      OBJ_hmac_sha3_512 = "OBJ_nist_hashalgs,16L",
      SN_kmac128 = "KMAC128",
      LN_kmac128 = "kmac128",
      NID_kmac128 = 1196,
      OBJ_kmac128 = "OBJ_nist_hashalgs,19L",
      SN_kmac256 = "KMAC256",
      LN_kmac256 = "kmac256",
      NID_kmac256 = 1197,
      OBJ_kmac256 = "OBJ_nist_hashalgs,20L",
      OBJ_dsa_with_sha2 = "OBJ_nistAlgorithms,3L",
      SN_dsa_with_SHA224 = "dsa_with_SHA224",
      NID_dsa_with_SHA224 = 802,
      OBJ_dsa_with_SHA224 = "OBJ_dsa_with_sha2,1L",
      SN_dsa_with_SHA256 = "dsa_with_SHA256",
      NID_dsa_with_SHA256 = 803,
      OBJ_dsa_with_SHA256 = "OBJ_dsa_with_sha2,2L",
      OBJ_sigAlgs = "OBJ_nistAlgorithms,3L",
      SN_dsa_with_SHA384 = "id-dsa-with-sha384",
      LN_dsa_with_SHA384 = "dsa_with_SHA384",
      NID_dsa_with_SHA384 = 1106,
      OBJ_dsa_with_SHA384 = "OBJ_sigAlgs,3L",
      SN_dsa_with_SHA512 = "id-dsa-with-sha512",
      LN_dsa_with_SHA512 = "dsa_with_SHA512",
      NID_dsa_with_SHA512 = 1107,
      OBJ_dsa_with_SHA512 = "OBJ_sigAlgs,4L",
      SN_dsa_with_SHA3_224 = "id-dsa-with-sha3-224",
      LN_dsa_with_SHA3_224 = "dsa_with_SHA3-224",
      NID_dsa_with_SHA3_224 = 1108,
      OBJ_dsa_with_SHA3_224 = "OBJ_sigAlgs,5L",
      SN_dsa_with_SHA3_256 = "id-dsa-with-sha3-256",
      LN_dsa_with_SHA3_256 = "dsa_with_SHA3-256",
      NID_dsa_with_SHA3_256 = 1109,
      OBJ_dsa_with_SHA3_256 = "OBJ_sigAlgs,6L",
      SN_dsa_with_SHA3_384 = "id-dsa-with-sha3-384",
      LN_dsa_with_SHA3_384 = "dsa_with_SHA3-384",
      NID_dsa_with_SHA3_384 = 1110,
      OBJ_dsa_with_SHA3_384 = "OBJ_sigAlgs,7L",
      SN_dsa_with_SHA3_512 = "id-dsa-with-sha3-512",
      LN_dsa_with_SHA3_512 = "dsa_with_SHA3-512",
      NID_dsa_with_SHA3_512 = 1111,
      OBJ_dsa_with_SHA3_512 = "OBJ_sigAlgs,8L",
      SN_ecdsa_with_SHA3_224 = "id-ecdsa-with-sha3-224",
      LN_ecdsa_with_SHA3_224 = "ecdsa_with_SHA3-224",
      NID_ecdsa_with_SHA3_224 = 1112,
      OBJ_ecdsa_with_SHA3_224 = "OBJ_sigAlgs,9L",
      SN_ecdsa_with_SHA3_256 = "id-ecdsa-with-sha3-256",
      LN_ecdsa_with_SHA3_256 = "ecdsa_with_SHA3-256",
      NID_ecdsa_with_SHA3_256 = 1113,
      OBJ_ecdsa_with_SHA3_256 = "OBJ_sigAlgs,10L",
      SN_ecdsa_with_SHA3_384 = "id-ecdsa-with-sha3-384",
      LN_ecdsa_with_SHA3_384 = "ecdsa_with_SHA3-384",
      NID_ecdsa_with_SHA3_384 = 1114,
      OBJ_ecdsa_with_SHA3_384 = "OBJ_sigAlgs,11L",
      SN_ecdsa_with_SHA3_512 = "id-ecdsa-with-sha3-512",
      LN_ecdsa_with_SHA3_512 = "ecdsa_with_SHA3-512",
      NID_ecdsa_with_SHA3_512 = 1115,
      OBJ_ecdsa_with_SHA3_512 = "OBJ_sigAlgs,12L",
      SN_RSA_SHA3_224 = "id-rsassa-pkcs1-v1_5-with-sha3-224",
      LN_RSA_SHA3_224 = "RSA-SHA3-224",
      NID_RSA_SHA3_224 = 1116,
      OBJ_RSA_SHA3_224 = "OBJ_sigAlgs,13L",
      SN_RSA_SHA3_256 = "id-rsassa-pkcs1-v1_5-with-sha3-256",
      LN_RSA_SHA3_256 = "RSA-SHA3-256",
      NID_RSA_SHA3_256 = 1117,
      OBJ_RSA_SHA3_256 = "OBJ_sigAlgs,14L",
      SN_RSA_SHA3_384 = "id-rsassa-pkcs1-v1_5-with-sha3-384",
      LN_RSA_SHA3_384 = "RSA-SHA3-384",
      NID_RSA_SHA3_384 = 1118,
      OBJ_RSA_SHA3_384 = "OBJ_sigAlgs,15L",
      SN_RSA_SHA3_512 = "id-rsassa-pkcs1-v1_5-with-sha3-512",
      LN_RSA_SHA3_512 = "RSA-SHA3-512",
      NID_RSA_SHA3_512 = 1119,
      OBJ_RSA_SHA3_512 = "OBJ_sigAlgs,16L",
      SN_hold_instruction_code = "holdInstructionCode",
      LN_hold_instruction_code = "Hold",
      NID_hold_instruction_code = 430,
      OBJ_hold_instruction_code = "OBJ_id_ce,23L",
      OBJ_holdInstruction = "OBJ_X9_57,2L",
      SN_hold_instruction_none = "holdInstructionNone",
      LN_hold_instruction_none = "Hold",
      NID_hold_instruction_none = 431,
      OBJ_hold_instruction_none = "OBJ_holdInstruction,1L",
      SN_hold_instruction_call_issuer = "holdInstructionCallIssuer",
      LN_hold_instruction_call_issuer = "Hold",
      NID_hold_instruction_call_issuer = 432,
      OBJ_hold_instruction_call_issuer = "OBJ_holdInstruction,2L",
      SN_hold_instruction_reject = "holdInstructionReject",
      LN_hold_instruction_reject = "Hold",
      NID_hold_instruction_reject = 433,
      OBJ_hold_instruction_reject = "OBJ_holdInstruction,3L",
      SN_data = "data",
      NID_data = 434,
      OBJ_data = "OBJ_itu_t,9L",
      SN_pss = "pss",
      NID_pss = 435,
      OBJ_pss = "OBJ_data,2342L",
      SN_ucl = "ucl",
      NID_ucl = 436,
      OBJ_ucl = "OBJ_pss,19200300L",
      SN_pilot = "pilot",
      NID_pilot = 437,
      OBJ_pilot = "OBJ_ucl,100L",
      LN_pilotAttributeType = "pilotAttributeType",
      NID_pilotAttributeType = 438,
      OBJ_pilotAttributeType = "OBJ_pilot,1L",
      LN_pilotAttributeSyntax = "pilotAttributeSyntax",
      NID_pilotAttributeSyntax = 439,
      OBJ_pilotAttributeSyntax = "OBJ_pilot,3L",
      LN_pilotObjectClass = "pilotObjectClass",
      NID_pilotObjectClass = 440,
      OBJ_pilotObjectClass = "OBJ_pilot,4L",
      LN_pilotGroups = "pilotGroups",
      NID_pilotGroups = 441,
      OBJ_pilotGroups = "OBJ_pilot,10L",
      LN_iA5StringSyntax = "iA5StringSyntax",
      NID_iA5StringSyntax = 442,
      OBJ_iA5StringSyntax = "OBJ_pilotAttributeSyntax,4L",
      LN_caseIgnoreIA5StringSyntax = "caseIgnoreIA5StringSyntax",
      NID_caseIgnoreIA5StringSyntax = 443,
      OBJ_caseIgnoreIA5StringSyntax = "OBJ_pilotAttributeSyntax,5L",
      LN_pilotObject = "pilotObject",
      NID_pilotObject = 444,
      OBJ_pilotObject = "OBJ_pilotObjectClass,3L",
      LN_pilotPerson = "pilotPerson",
      NID_pilotPerson = 445,
      OBJ_pilotPerson = "OBJ_pilotObjectClass,4L",
      SN_account = "account",
      NID_account = 446,
      OBJ_account = "OBJ_pilotObjectClass,5L",
      SN_document = "document",
      NID_document = 447,
      OBJ_document = "OBJ_pilotObjectClass,6L",
      SN_room = "room",
      NID_room = 448,
      OBJ_room = "OBJ_pilotObjectClass,7L",
      LN_documentSeries = "documentSeries",
      NID_documentSeries = 449,
      OBJ_documentSeries = "OBJ_pilotObjectClass,9L",
      SN_Domain = "domain",
      LN_Domain = "Domain",
      NID_Domain = 392,
      OBJ_Domain = "OBJ_pilotObjectClass,13L",
      LN_rFC822localPart = "rFC822localPart",
      NID_rFC822localPart = 450,
      OBJ_rFC822localPart = "OBJ_pilotObjectClass,14L",
      LN_dNSDomain = "dNSDomain",
      NID_dNSDomain = 451,
      OBJ_dNSDomain = "OBJ_pilotObjectClass,15L",
      LN_domainRelatedObject = "domainRelatedObject",
      NID_domainRelatedObject = 452,
      OBJ_domainRelatedObject = "OBJ_pilotObjectClass,17L",
      LN_friendlyCountry = "friendlyCountry",
      NID_friendlyCountry = 453,
      OBJ_friendlyCountry = "OBJ_pilotObjectClass,18L",
      LN_simpleSecurityObject = "simpleSecurityObject",
      NID_simpleSecurityObject = 454,
      OBJ_simpleSecurityObject = "OBJ_pilotObjectClass,19L",
      LN_pilotOrganization = "pilotOrganization",
      NID_pilotOrganization = 455,
      OBJ_pilotOrganization = "OBJ_pilotObjectClass,20L",
      LN_pilotDSA = "pilotDSA",
      NID_pilotDSA = 456,
      OBJ_pilotDSA = "OBJ_pilotObjectClass,21L",
      LN_qualityLabelledData = "qualityLabelledData",
      NID_qualityLabelledData = 457,
      OBJ_qualityLabelledData = "OBJ_pilotObjectClass,22L",
      SN_userId = "UID",
      LN_userId = "userId",
      NID_userId = 458,
      OBJ_userId = "OBJ_pilotAttributeType,1L",
      LN_textEncodedORAddress = "textEncodedORAddress",
      NID_textEncodedORAddress = 459,
      OBJ_textEncodedORAddress = "OBJ_pilotAttributeType,2L",
      SN_rfc822Mailbox = "mail",
      LN_rfc822Mailbox = "rfc822Mailbox",
      NID_rfc822Mailbox = 460,
      OBJ_rfc822Mailbox = "OBJ_pilotAttributeType,3L",
      SN_info = "info",
      NID_info = 461,
      OBJ_info = "OBJ_pilotAttributeType,4L",
      LN_favouriteDrink = "favouriteDrink",
      NID_favouriteDrink = 462,
      OBJ_favouriteDrink = "OBJ_pilotAttributeType,5L",
      LN_roomNumber = "roomNumber",
      NID_roomNumber = 463,
      OBJ_roomNumber = "OBJ_pilotAttributeType,6L",
      SN_photo = "photo",
      NID_photo = 464,
      OBJ_photo = "OBJ_pilotAttributeType,7L",
      LN_userClass = "userClass",
      NID_userClass = 465,
      OBJ_userClass = "OBJ_pilotAttributeType,8L",
      SN_host = "host",
      NID_host = 466,
      OBJ_host = "OBJ_pilotAttributeType,9L",
      SN_manager = "manager",
      NID_manager = 467,
      OBJ_manager = "OBJ_pilotAttributeType,10L",
      LN_documentIdentifier = "documentIdentifier",
      NID_documentIdentifier = 468,
      OBJ_documentIdentifier = "OBJ_pilotAttributeType,11L",
      LN_documentTitle = "documentTitle",
      NID_documentTitle = 469,
      OBJ_documentTitle = "OBJ_pilotAttributeType,12L",
      LN_documentVersion = "documentVersion",
      NID_documentVersion = 470,
      OBJ_documentVersion = "OBJ_pilotAttributeType,13L",
      LN_documentAuthor = "documentAuthor",
      NID_documentAuthor = 471,
      OBJ_documentAuthor = "OBJ_pilotAttributeType,14L",
      LN_documentLocation = "documentLocation",
      NID_documentLocation = 472,
      OBJ_documentLocation = "OBJ_pilotAttributeType,15L",
      LN_homeTelephoneNumber = "homeTelephoneNumber",
      NID_homeTelephoneNumber = 473,
      OBJ_homeTelephoneNumber = "OBJ_pilotAttributeType,20L",
      SN_secretary = "secretary",
      NID_secretary = 474,
      OBJ_secretary = "OBJ_pilotAttributeType,21L",
      LN_otherMailbox = "otherMailbox",
      NID_otherMailbox = 475,
      OBJ_otherMailbox = "OBJ_pilotAttributeType,22L",
      LN_lastModifiedTime = "lastModifiedTime",
      NID_lastModifiedTime = 476,
      OBJ_lastModifiedTime = "OBJ_pilotAttributeType,23L",
      LN_lastModifiedBy = "lastModifiedBy",
      NID_lastModifiedBy = 477,
      OBJ_lastModifiedBy = "OBJ_pilotAttributeType,24L",
      SN_domainComponent = "DC",
      LN_domainComponent = "domainComponent",
      NID_domainComponent = 391,
      OBJ_domainComponent = "OBJ_pilotAttributeType,25L",
      LN_aRecord = "aRecord",
      NID_aRecord = 478,
      OBJ_aRecord = "OBJ_pilotAttributeType,26L",
      LN_pilotAttributeType27 = "pilotAttributeType27",
      NID_pilotAttributeType27 = 479,
      OBJ_pilotAttributeType27 = "OBJ_pilotAttributeType,27L",
      LN_mXRecord = "mXRecord",
      NID_mXRecord = 480,
      OBJ_mXRecord = "OBJ_pilotAttributeType,28L",
      LN_nSRecord = "nSRecord",
      NID_nSRecord = 481,
      OBJ_nSRecord = "OBJ_pilotAttributeType,29L",
      LN_sOARecord = "sOARecord",
      NID_sOARecord = 482,
      OBJ_sOARecord = "OBJ_pilotAttributeType,30L",
      LN_cNAMERecord = "cNAMERecord",
      NID_cNAMERecord = 483,
      OBJ_cNAMERecord = "OBJ_pilotAttributeType,31L",
      LN_associatedDomain = "associatedDomain",
      NID_associatedDomain = 484,
      OBJ_associatedDomain = "OBJ_pilotAttributeType,37L",
      LN_associatedName = "associatedName",
      NID_associatedName = 485,
      OBJ_associatedName = "OBJ_pilotAttributeType,38L",
      LN_homePostalAddress = "homePostalAddress",
      NID_homePostalAddress = 486,
      OBJ_homePostalAddress = "OBJ_pilotAttributeType,39L",
      LN_personalTitle = "personalTitle",
      NID_personalTitle = 487,
      OBJ_personalTitle = "OBJ_pilotAttributeType,40L",
      LN_mobileTelephoneNumber = "mobileTelephoneNumber",
      NID_mobileTelephoneNumber = 488,
      OBJ_mobileTelephoneNumber = "OBJ_pilotAttributeType,41L",
      LN_pagerTelephoneNumber = "pagerTelephoneNumber",
      NID_pagerTelephoneNumber = 489,
      OBJ_pagerTelephoneNumber = "OBJ_pilotAttributeType,42L",
      LN_friendlyCountryName = "friendlyCountryName",
      NID_friendlyCountryName = 490,
      OBJ_friendlyCountryName = "OBJ_pilotAttributeType,43L",
      SN_uniqueIdentifier = "uid",
      LN_uniqueIdentifier = "uniqueIdentifier",
      NID_uniqueIdentifier = 102,
      OBJ_uniqueIdentifier = "OBJ_pilotAttributeType,44L",
      LN_organizationalStatus = "organizationalStatus",
      NID_organizationalStatus = 491,
      OBJ_organizationalStatus = "OBJ_pilotAttributeType,45L",
      LN_janetMailbox = "janetMailbox",
      NID_janetMailbox = 492,
      OBJ_janetMailbox = "OBJ_pilotAttributeType,46L",
      LN_mailPreferenceOption = "mailPreferenceOption",
      NID_mailPreferenceOption = 493,
      OBJ_mailPreferenceOption = "OBJ_pilotAttributeType,47L",
      LN_buildingName = "buildingName",
      NID_buildingName = 494,
      OBJ_buildingName = "OBJ_pilotAttributeType,48L",
      LN_dSAQuality = "dSAQuality",
      NID_dSAQuality = 495,
      OBJ_dSAQuality = "OBJ_pilotAttributeType,49L",
      LN_singleLevelQuality = "singleLevelQuality",
      NID_singleLevelQuality = 496,
      OBJ_singleLevelQuality = "OBJ_pilotAttributeType,50L",
      LN_subtreeMinimumQuality = "subtreeMinimumQuality",
      NID_subtreeMinimumQuality = 497,
      OBJ_subtreeMinimumQuality = "OBJ_pilotAttributeType,51L",
      LN_subtreeMaximumQuality = "subtreeMaximumQuality",
      NID_subtreeMaximumQuality = 498,
      OBJ_subtreeMaximumQuality = "OBJ_pilotAttributeType,52L",
      LN_personalSignature = "personalSignature",
      NID_personalSignature = 499,
      OBJ_personalSignature = "OBJ_pilotAttributeType,53L",
      LN_dITRedirect = "dITRedirect",
      NID_dITRedirect = 500,
      OBJ_dITRedirect = "OBJ_pilotAttributeType,54L",
      SN_audio = "audio",
      NID_audio = 501,
      OBJ_audio = "OBJ_pilotAttributeType,55L",
      LN_documentPublisher = "documentPublisher",
      NID_documentPublisher = 502,
      OBJ_documentPublisher = "OBJ_pilotAttributeType,56L",
      SN_id_set = "id-set",
      LN_id_set = "Secure",
      NID_id_set = 512,
      OBJ_id_set = "OBJ_international_organizations,42L",
      SN_set_ctype = "set-ctype",
      LN_set_ctype = "content",
      NID_set_ctype = 513,
      OBJ_set_ctype = "OBJ_id_set,0L",
      SN_set_msgExt = "set-msgExt",
      LN_set_msgExt = "message",
      NID_set_msgExt = 514,
      OBJ_set_msgExt = "OBJ_id_set,1L",
      SN_set_attr = "set-attr",
      NID_set_attr = 515,
      OBJ_set_attr = "OBJ_id_set,3L",
      SN_set_policy = "set-policy",
      NID_set_policy = 516,
      OBJ_set_policy = "OBJ_id_set,5L",
      SN_set_certExt = "set-certExt",
      LN_set_certExt = "certificate",
      NID_set_certExt = 517,
      OBJ_set_certExt = "OBJ_id_set,7L",
      SN_set_brand = "set-brand",
      NID_set_brand = 518,
      OBJ_set_brand = "OBJ_id_set,8L",
      SN_setct_PANData = "setct-PANData",
      NID_setct_PANData = 519,
      OBJ_setct_PANData = "OBJ_set_ctype,0L",
      SN_setct_PANToken = "setct-PANToken",
      NID_setct_PANToken = 520,
      OBJ_setct_PANToken = "OBJ_set_ctype,1L",
      SN_setct_PANOnly = "setct-PANOnly",
      NID_setct_PANOnly = 521,
      OBJ_setct_PANOnly = "OBJ_set_ctype,2L",
      SN_setct_OIData = "setct-OIData",
      NID_setct_OIData = 522,
      OBJ_setct_OIData = "OBJ_set_ctype,3L",
      SN_setct_PI = "setct-PI",
      NID_setct_PI = 523,
      OBJ_setct_PI = "OBJ_set_ctype,4L",
      SN_setct_PIData = "setct-PIData",
      NID_setct_PIData = 524,
      OBJ_setct_PIData = "OBJ_set_ctype,5L",
      SN_setct_PIDataUnsigned = "setct-PIDataUnsigned",
      NID_setct_PIDataUnsigned = 525,
      OBJ_setct_PIDataUnsigned = "OBJ_set_ctype,6L",
      SN_setct_HODInput = "setct-HODInput",
      NID_setct_HODInput = 526,
      OBJ_setct_HODInput = "OBJ_set_ctype,7L",
      SN_setct_AuthResBaggage = "setct-AuthResBaggage",
      NID_setct_AuthResBaggage = 527,
      OBJ_setct_AuthResBaggage = "OBJ_set_ctype,8L",
      SN_setct_AuthRevReqBaggage = "setct-AuthRevReqBaggage",
      NID_setct_AuthRevReqBaggage = 528,
      OBJ_setct_AuthRevReqBaggage = "OBJ_set_ctype,9L",
      SN_setct_AuthRevResBaggage = "setct-AuthRevResBaggage",
      NID_setct_AuthRevResBaggage = 529,
      OBJ_setct_AuthRevResBaggage = "OBJ_set_ctype,10L",
      SN_setct_CapTokenSeq = "setct-CapTokenSeq",
      NID_setct_CapTokenSeq = 530,
      OBJ_setct_CapTokenSeq = "OBJ_set_ctype,11L",
      SN_setct_PInitResData = "setct-PInitResData",
      NID_setct_PInitResData = 531,
      OBJ_setct_PInitResData = "OBJ_set_ctype,12L",
      SN_setct_PI_TBS = "setct-PI-TBS",
      NID_setct_PI_TBS = 532,
      OBJ_setct_PI_TBS = "OBJ_set_ctype,13L",
      SN_setct_PResData = "setct-PResData",
      NID_setct_PResData = 533,
      OBJ_setct_PResData = "OBJ_set_ctype,14L",
      SN_setct_AuthReqTBS = "setct-AuthReqTBS",
      NID_setct_AuthReqTBS = 534,
      OBJ_setct_AuthReqTBS = "OBJ_set_ctype,16L",
      SN_setct_AuthResTBS = "setct-AuthResTBS",
      NID_setct_AuthResTBS = 535,
      OBJ_setct_AuthResTBS = "OBJ_set_ctype,17L",
      SN_setct_AuthResTBSX = "setct-AuthResTBSX",
      NID_setct_AuthResTBSX = 536,
      OBJ_setct_AuthResTBSX = "OBJ_set_ctype,18L",
      SN_setct_AuthTokenTBS = "setct-AuthTokenTBS",
      NID_setct_AuthTokenTBS = 537,
      OBJ_setct_AuthTokenTBS = "OBJ_set_ctype,19L",
      SN_setct_CapTokenData = "setct-CapTokenData",
      NID_setct_CapTokenData = 538,
      OBJ_setct_CapTokenData = "OBJ_set_ctype,20L",
      SN_setct_CapTokenTBS = "setct-CapTokenTBS",
      NID_setct_CapTokenTBS = 539,
      OBJ_setct_CapTokenTBS = "OBJ_set_ctype,21L",
      SN_setct_AcqCardCodeMsg = "setct-AcqCardCodeMsg",
      NID_setct_AcqCardCodeMsg = 540,
      OBJ_setct_AcqCardCodeMsg = "OBJ_set_ctype,22L",
      SN_setct_AuthRevReqTBS = "setct-AuthRevReqTBS",
      NID_setct_AuthRevReqTBS = 541,
      OBJ_setct_AuthRevReqTBS = "OBJ_set_ctype,23L",
      SN_setct_AuthRevResData = "setct-AuthRevResData",
      NID_setct_AuthRevResData = 542,
      OBJ_setct_AuthRevResData = "OBJ_set_ctype,24L",
      SN_setct_AuthRevResTBS = "setct-AuthRevResTBS",
      NID_setct_AuthRevResTBS = 543,
      OBJ_setct_AuthRevResTBS = "OBJ_set_ctype,25L",
      SN_setct_CapReqTBS = "setct-CapReqTBS",
      NID_setct_CapReqTBS = 544,
      OBJ_setct_CapReqTBS = "OBJ_set_ctype,26L",
      SN_setct_CapReqTBSX = "setct-CapReqTBSX",
      NID_setct_CapReqTBSX = 545,
      OBJ_setct_CapReqTBSX = "OBJ_set_ctype,27L",
      SN_setct_CapResData = "setct-CapResData",
      NID_setct_CapResData = 546,
      OBJ_setct_CapResData = "OBJ_set_ctype,28L",
      SN_setct_CapRevReqTBS = "setct-CapRevReqTBS",
      NID_setct_CapRevReqTBS = 547,
      OBJ_setct_CapRevReqTBS = "OBJ_set_ctype,29L",
      SN_setct_CapRevReqTBSX = "setct-CapRevReqTBSX",
      NID_setct_CapRevReqTBSX = 548,
      OBJ_setct_CapRevReqTBSX = "OBJ_set_ctype,30L",
      SN_setct_CapRevResData = "setct-CapRevResData",
      NID_setct_CapRevResData = 549,
      OBJ_setct_CapRevResData = "OBJ_set_ctype,31L",
      SN_setct_CredReqTBS = "setct-CredReqTBS",
      NID_setct_CredReqTBS = 550,
      OBJ_setct_CredReqTBS = "OBJ_set_ctype,32L",
      SN_setct_CredReqTBSX = "setct-CredReqTBSX",
      NID_setct_CredReqTBSX = 551,
      OBJ_setct_CredReqTBSX = "OBJ_set_ctype,33L",
      SN_setct_CredResData = "setct-CredResData",
      NID_setct_CredResData = 552,
      OBJ_setct_CredResData = "OBJ_set_ctype,34L",
      SN_setct_CredRevReqTBS = "setct-CredRevReqTBS",
      NID_setct_CredRevReqTBS = 553,
      OBJ_setct_CredRevReqTBS = "OBJ_set_ctype,35L",
      SN_setct_CredRevReqTBSX = "setct-CredRevReqTBSX",
      NID_setct_CredRevReqTBSX = 554,
      OBJ_setct_CredRevReqTBSX = "OBJ_set_ctype,36L",
      SN_setct_CredRevResData = "setct-CredRevResData",
      NID_setct_CredRevResData = 555,
      OBJ_setct_CredRevResData = "OBJ_set_ctype,37L",
      SN_setct_PCertReqData = "setct-PCertReqData",
      NID_setct_PCertReqData = 556,
      OBJ_setct_PCertReqData = "OBJ_set_ctype,38L",
      SN_setct_PCertResTBS = "setct-PCertResTBS",
      NID_setct_PCertResTBS = 557,
      OBJ_setct_PCertResTBS = "OBJ_set_ctype,39L",
      SN_setct_BatchAdminReqData = "setct-BatchAdminReqData",
      NID_setct_BatchAdminReqData = 558,
      OBJ_setct_BatchAdminReqData = "OBJ_set_ctype,40L",
      SN_setct_BatchAdminResData = "setct-BatchAdminResData",
      NID_setct_BatchAdminResData = 559,
      OBJ_setct_BatchAdminResData = "OBJ_set_ctype,41L",
      SN_setct_CardCInitResTBS = "setct-CardCInitResTBS",
      NID_setct_CardCInitResTBS = 560,
      OBJ_setct_CardCInitResTBS = "OBJ_set_ctype,42L",
      SN_setct_MeAqCInitResTBS = "setct-MeAqCInitResTBS",
      NID_setct_MeAqCInitResTBS = 561,
      OBJ_setct_MeAqCInitResTBS = "OBJ_set_ctype,43L",
      SN_setct_RegFormResTBS = "setct-RegFormResTBS",
      NID_setct_RegFormResTBS = 562,
      OBJ_setct_RegFormResTBS = "OBJ_set_ctype,44L",
      SN_setct_CertReqData = "setct-CertReqData",
      NID_setct_CertReqData = 563,
      OBJ_setct_CertReqData = "OBJ_set_ctype,45L",
      SN_setct_CertReqTBS = "setct-CertReqTBS",
      NID_setct_CertReqTBS = 564,
      OBJ_setct_CertReqTBS = "OBJ_set_ctype,46L",
      SN_setct_CertResData = "setct-CertResData",
      NID_setct_CertResData = 565,
      OBJ_setct_CertResData = "OBJ_set_ctype,47L",
      SN_setct_CertInqReqTBS = "setct-CertInqReqTBS",
      NID_setct_CertInqReqTBS = 566,
      OBJ_setct_CertInqReqTBS = "OBJ_set_ctype,48L",
      SN_setct_ErrorTBS = "setct-ErrorTBS",
      NID_setct_ErrorTBS = 567,
      OBJ_setct_ErrorTBS = "OBJ_set_ctype,49L",
      SN_setct_PIDualSignedTBE = "setct-PIDualSignedTBE",
      NID_setct_PIDualSignedTBE = 568,
      OBJ_setct_PIDualSignedTBE = "OBJ_set_ctype,50L",
      SN_setct_PIUnsignedTBE = "setct-PIUnsignedTBE",
      NID_setct_PIUnsignedTBE = 569,
      OBJ_setct_PIUnsignedTBE = "OBJ_set_ctype,51L",
      SN_setct_AuthReqTBE = "setct-AuthReqTBE",
      NID_setct_AuthReqTBE = 570,
      OBJ_setct_AuthReqTBE = "OBJ_set_ctype,52L",
      SN_setct_AuthResTBE = "setct-AuthResTBE",
      NID_setct_AuthResTBE = 571,
      OBJ_setct_AuthResTBE = "OBJ_set_ctype,53L",
      SN_setct_AuthResTBEX = "setct-AuthResTBEX",
      NID_setct_AuthResTBEX = 572,
      OBJ_setct_AuthResTBEX = "OBJ_set_ctype,54L",
      SN_setct_AuthTokenTBE = "setct-AuthTokenTBE",
      NID_setct_AuthTokenTBE = 573,
      OBJ_setct_AuthTokenTBE = "OBJ_set_ctype,55L",
      SN_setct_CapTokenTBE = "setct-CapTokenTBE",
      NID_setct_CapTokenTBE = 574,
      OBJ_setct_CapTokenTBE = "OBJ_set_ctype,56L",
      SN_setct_CapTokenTBEX = "setct-CapTokenTBEX",
      NID_setct_CapTokenTBEX = 575,
      OBJ_setct_CapTokenTBEX = "OBJ_set_ctype,57L",
      SN_setct_AcqCardCodeMsgTBE = "setct-AcqCardCodeMsgTBE",
      NID_setct_AcqCardCodeMsgTBE = 576,
      OBJ_setct_AcqCardCodeMsgTBE = "OBJ_set_ctype,58L",
      SN_setct_AuthRevReqTBE = "setct-AuthRevReqTBE",
      NID_setct_AuthRevReqTBE = 577,
      OBJ_setct_AuthRevReqTBE = "OBJ_set_ctype,59L",
      SN_setct_AuthRevResTBE = "setct-AuthRevResTBE",
      NID_setct_AuthRevResTBE = 578,
      OBJ_setct_AuthRevResTBE = "OBJ_set_ctype,60L",
      SN_setct_AuthRevResTBEB = "setct-AuthRevResTBEB",
      NID_setct_AuthRevResTBEB = 579,
      OBJ_setct_AuthRevResTBEB = "OBJ_set_ctype,61L",
      SN_setct_CapReqTBE = "setct-CapReqTBE",
      NID_setct_CapReqTBE = 580,
      OBJ_setct_CapReqTBE = "OBJ_set_ctype,62L",
      SN_setct_CapReqTBEX = "setct-CapReqTBEX",
      NID_setct_CapReqTBEX = 581,
      OBJ_setct_CapReqTBEX = "OBJ_set_ctype,63L",
      SN_setct_CapResTBE = "setct-CapResTBE",
      NID_setct_CapResTBE = 582,
      OBJ_setct_CapResTBE = "OBJ_set_ctype,64L",
      SN_setct_CapRevReqTBE = "setct-CapRevReqTBE",
      NID_setct_CapRevReqTBE = 583,
      OBJ_setct_CapRevReqTBE = "OBJ_set_ctype,65L",
      SN_setct_CapRevReqTBEX = "setct-CapRevReqTBEX",
      NID_setct_CapRevReqTBEX = 584,
      OBJ_setct_CapRevReqTBEX = "OBJ_set_ctype,66L",
      SN_setct_CapRevResTBE = "setct-CapRevResTBE",
      NID_setct_CapRevResTBE = 585,
      OBJ_setct_CapRevResTBE = "OBJ_set_ctype,67L",
      SN_setct_CredReqTBE = "setct-CredReqTBE",
      NID_setct_CredReqTBE = 586,
      OBJ_setct_CredReqTBE = "OBJ_set_ctype,68L",
      SN_setct_CredReqTBEX = "setct-CredReqTBEX",
      NID_setct_CredReqTBEX = 587,
      OBJ_setct_CredReqTBEX = "OBJ_set_ctype,69L",
      SN_setct_CredResTBE = "setct-CredResTBE",
      NID_setct_CredResTBE = 588,
      OBJ_setct_CredResTBE = "OBJ_set_ctype,70L",
      SN_setct_CredRevReqTBE = "setct-CredRevReqTBE",
      NID_setct_CredRevReqTBE = 589,
      OBJ_setct_CredRevReqTBE = "OBJ_set_ctype,71L",
      SN_setct_CredRevReqTBEX = "setct-CredRevReqTBEX",
      NID_setct_CredRevReqTBEX = 590,
      OBJ_setct_CredRevReqTBEX = "OBJ_set_ctype,72L",
      SN_setct_CredRevResTBE = "setct-CredRevResTBE",
      NID_setct_CredRevResTBE = 591,
      OBJ_setct_CredRevResTBE = "OBJ_set_ctype,73L",
      SN_setct_BatchAdminReqTBE = "setct-BatchAdminReqTBE",
      NID_setct_BatchAdminReqTBE = 592,
      OBJ_setct_BatchAdminReqTBE = "OBJ_set_ctype,74L",
      SN_setct_BatchAdminResTBE = "setct-BatchAdminResTBE",
      NID_setct_BatchAdminResTBE = 593,
      OBJ_setct_BatchAdminResTBE = "OBJ_set_ctype,75L",
      SN_setct_RegFormReqTBE = "setct-RegFormReqTBE",
      NID_setct_RegFormReqTBE = 594,
      OBJ_setct_RegFormReqTBE = "OBJ_set_ctype,76L",
      SN_setct_CertReqTBE = "setct-CertReqTBE",
      NID_setct_CertReqTBE = 595,
      OBJ_setct_CertReqTBE = "OBJ_set_ctype,77L",
      SN_setct_CertReqTBEX = "setct-CertReqTBEX",
      NID_setct_CertReqTBEX = 596,
      OBJ_setct_CertReqTBEX = "OBJ_set_ctype,78L",
      SN_setct_CertResTBE = "setct-CertResTBE",
      NID_setct_CertResTBE = 597,
      OBJ_setct_CertResTBE = "OBJ_set_ctype,79L",
      SN_setct_CRLNotificationTBS = "setct-CRLNotificationTBS",
      NID_setct_CRLNotificationTBS = 598,
      OBJ_setct_CRLNotificationTBS = "OBJ_set_ctype,80L",
      SN_setct_CRLNotificationResTBS = "setct-CRLNotificationResTBS",
      NID_setct_CRLNotificationResTBS = 599,
      OBJ_setct_CRLNotificationResTBS = "OBJ_set_ctype,81L",
      SN_setct_BCIDistributionTBS = "setct-BCIDistributionTBS",
      NID_setct_BCIDistributionTBS = 600,
      OBJ_setct_BCIDistributionTBS = "OBJ_set_ctype,82L",
      SN_setext_genCrypt = "setext-genCrypt",
      LN_setext_genCrypt = "generic",
      NID_setext_genCrypt = 601,
      OBJ_setext_genCrypt = "OBJ_set_msgExt,1L",
      SN_setext_miAuth = "setext-miAuth",
      LN_setext_miAuth = "merchant",
      NID_setext_miAuth = 602,
      OBJ_setext_miAuth = "OBJ_set_msgExt,3L",
      SN_setext_pinSecure = "setext-pinSecure",
      NID_setext_pinSecure = 603,
      OBJ_setext_pinSecure = "OBJ_set_msgExt,4L",
      SN_setext_pinAny = "setext-pinAny",
      NID_setext_pinAny = 604,
      OBJ_setext_pinAny = "OBJ_set_msgExt,5L",
      SN_setext_track2 = "setext-track2",
      NID_setext_track2 = 605,
      OBJ_setext_track2 = "OBJ_set_msgExt,7L",
      SN_setext_cv = "setext-cv",
      LN_setext_cv = "additional",
      NID_setext_cv = 606,
      OBJ_setext_cv = "OBJ_set_msgExt,8L",
      SN_set_policy_root = "set-policy-root",
      NID_set_policy_root = 607,
      OBJ_set_policy_root = "OBJ_set_policy,0L",
      SN_setCext_hashedRoot = "setCext-hashedRoot",
      NID_setCext_hashedRoot = 608,
      OBJ_setCext_hashedRoot = "OBJ_set_certExt,0L",
      SN_setCext_certType = "setCext-certType",
      NID_setCext_certType = 609,
      OBJ_setCext_certType = "OBJ_set_certExt,1L",
      SN_setCext_merchData = "setCext-merchData",
      NID_setCext_merchData = 610,
      OBJ_setCext_merchData = "OBJ_set_certExt,2L",
      SN_setCext_cCertRequired = "setCext-cCertRequired",
      NID_setCext_cCertRequired = 611,
      OBJ_setCext_cCertRequired = "OBJ_set_certExt,3L",
      SN_setCext_tunneling = "setCext-tunneling",
      NID_setCext_tunneling = 612,
      OBJ_setCext_tunneling = "OBJ_set_certExt,4L",
      SN_setCext_setExt = "setCext-setExt",
      NID_setCext_setExt = 613,
      OBJ_setCext_setExt = "OBJ_set_certExt,5L",
      SN_setCext_setQualf = "setCext-setQualf",
      NID_setCext_setQualf = 614,
      OBJ_setCext_setQualf = "OBJ_set_certExt,6L",
      SN_setCext_PGWYcapabilities = "setCext-PGWYcapabilities",
      NID_setCext_PGWYcapabilities = 615,
      OBJ_setCext_PGWYcapabilities = "OBJ_set_certExt,7L",
      SN_setCext_TokenIdentifier = "setCext-TokenIdentifier",
      NID_setCext_TokenIdentifier = 616,
      OBJ_setCext_TokenIdentifier = "OBJ_set_certExt,8L",
      SN_setCext_Track2Data = "setCext-Track2Data",
      NID_setCext_Track2Data = 617,
      OBJ_setCext_Track2Data = "OBJ_set_certExt,9L",
      SN_setCext_TokenType = "setCext-TokenType",
      NID_setCext_TokenType = 618,
      OBJ_setCext_TokenType = "OBJ_set_certExt,10L",
      SN_setCext_IssuerCapabilities = "setCext-IssuerCapabilities",
      NID_setCext_IssuerCapabilities = 619,
      OBJ_setCext_IssuerCapabilities = "OBJ_set_certExt,11L",
      SN_setAttr_Cert = "setAttr-Cert",
      NID_setAttr_Cert = 620,
      OBJ_setAttr_Cert = "OBJ_set_attr,0L",
      SN_setAttr_PGWYcap = "setAttr-PGWYcap",
      LN_setAttr_PGWYcap = "payment",
      NID_setAttr_PGWYcap = 621,
      OBJ_setAttr_PGWYcap = "OBJ_set_attr,1L",
      SN_setAttr_TokenType = "setAttr-TokenType",
      NID_setAttr_TokenType = 622,
      OBJ_setAttr_TokenType = "OBJ_set_attr,2L",
      SN_setAttr_IssCap = "setAttr-IssCap",
      LN_setAttr_IssCap = "issuer",
      NID_setAttr_IssCap = 623,
      OBJ_setAttr_IssCap = "OBJ_set_attr,3L",
      SN_set_rootKeyThumb = "set-rootKeyThumb",
      NID_set_rootKeyThumb = 624,
      OBJ_set_rootKeyThumb = "OBJ_setAttr_Cert,0L",
      SN_set_addPolicy = "set-addPolicy",
      NID_set_addPolicy = 625,
      OBJ_set_addPolicy = "OBJ_setAttr_Cert,1L",
      SN_setAttr_Token_EMV = "setAttr-Token-EMV",
      NID_setAttr_Token_EMV = 626,
      OBJ_setAttr_Token_EMV = "OBJ_setAttr_TokenType,1L",
      SN_setAttr_Token_B0Prime = "setAttr-Token-B0Prime",
      NID_setAttr_Token_B0Prime = 627,
      OBJ_setAttr_Token_B0Prime = "OBJ_setAttr_TokenType,2L",
      SN_setAttr_IssCap_CVM = "setAttr-IssCap-CVM",
      NID_setAttr_IssCap_CVM = 628,
      OBJ_setAttr_IssCap_CVM = "OBJ_setAttr_IssCap,3L",
      SN_setAttr_IssCap_T2 = "setAttr-IssCap-T2",
      NID_setAttr_IssCap_T2 = 629,
      OBJ_setAttr_IssCap_T2 = "OBJ_setAttr_IssCap,4L",
      SN_setAttr_IssCap_Sig = "setAttr-IssCap-Sig",
      NID_setAttr_IssCap_Sig = 630,
      OBJ_setAttr_IssCap_Sig = "OBJ_setAttr_IssCap,5L",
      SN_setAttr_GenCryptgrm = "setAttr-GenCryptgrm",
      LN_setAttr_GenCryptgrm = "generate",
      NID_setAttr_GenCryptgrm = 631,
      OBJ_setAttr_GenCryptgrm = "OBJ_setAttr_IssCap_CVM,1L",
      SN_setAttr_T2Enc = "setAttr-T2Enc",
      LN_setAttr_T2Enc = "encrypted",
      NID_setAttr_T2Enc = 632,
      OBJ_setAttr_T2Enc = "OBJ_setAttr_IssCap_T2,1L",
      SN_setAttr_T2cleartxt = "setAttr-T2cleartxt",
      LN_setAttr_T2cleartxt = "cleartext",
      NID_setAttr_T2cleartxt = 633,
      OBJ_setAttr_T2cleartxt = "OBJ_setAttr_IssCap_T2,2L",
      SN_setAttr_TokICCsig = "setAttr-TokICCsig",
      LN_setAttr_TokICCsig = "ICC",
      NID_setAttr_TokICCsig = 634,
      OBJ_setAttr_TokICCsig = "OBJ_setAttr_IssCap_Sig,1L",
      SN_setAttr_SecDevSig = "setAttr-SecDevSig",
      LN_setAttr_SecDevSig = "secure",
      NID_setAttr_SecDevSig = 635,
      OBJ_setAttr_SecDevSig = "OBJ_setAttr_IssCap_Sig,2L",
      SN_set_brand_IATA_ATA = "set-brand-IATA-ATA",
      NID_set_brand_IATA_ATA = 636,
      OBJ_set_brand_IATA_ATA = "OBJ_set_brand,1L",
      SN_set_brand_Diners = "set-brand-Diners",
      NID_set_brand_Diners = 637,
      OBJ_set_brand_Diners = "OBJ_set_brand,30L",
      SN_set_brand_AmericanExpress = "set-brand-AmericanExpress",
      NID_set_brand_AmericanExpress = 638,
      OBJ_set_brand_AmericanExpress = "OBJ_set_brand,34L",
      SN_set_brand_JCB = "set-brand-JCB",
      NID_set_brand_JCB = 639,
      OBJ_set_brand_JCB = "OBJ_set_brand,35L",
      SN_set_brand_Visa = "set-brand-Visa",
      NID_set_brand_Visa = 640,
      OBJ_set_brand_Visa = "OBJ_set_brand,4L",
      SN_set_brand_MasterCard = "set-brand-MasterCard",
      NID_set_brand_MasterCard = 641,
      OBJ_set_brand_MasterCard = "OBJ_set_brand,5L",
      SN_set_brand_Novus = "set-brand-Novus",
      NID_set_brand_Novus = 642,
      OBJ_set_brand_Novus = "OBJ_set_brand,6011L",
      SN_des_cdmf = "DES-CDMF",
      LN_des_cdmf = "des-cdmf",
      NID_des_cdmf = 643,
      OBJ_des_cdmf = "OBJ_rsadsi,3L,10L",
      SN_rsaOAEPEncryptionSET = "rsaOAEPEncryptionSET",
      NID_rsaOAEPEncryptionSET = 644,
      OBJ_rsaOAEPEncryptionSET = "OBJ_rsadsi,1L,1L,6L",
      SN_ipsec3 = "Oakley-EC2N-3",
      LN_ipsec3 = "ipsec3",
      NID_ipsec3 = 749,
      SN_ipsec4 = "Oakley-EC2N-4",
      LN_ipsec4 = "ipsec4",
      NID_ipsec4 = 750,
      SN_whirlpool = "whirlpool",
      NID_whirlpool = 804,
      OBJ_whirlpool = "OBJ_iso,0L,10118L,3L,0L,55L",
      SN_cryptopro = "cryptopro",
      NID_cryptopro = 805,
      OBJ_cryptopro = "OBJ_member_body,643L,2L,2L",
      SN_cryptocom = "cryptocom",
      NID_cryptocom = 806,
      OBJ_cryptocom = "OBJ_member_body,643L,2L,9L",
      SN_id_tc26 = "id-tc26",
      NID_id_tc26 = 974,
      OBJ_id_tc26 = "OBJ_member_body,643L,7L,1L",
      SN_id_GostR3411_94_with_GostR3410_2001 = "id-GostR3411-94-with-GostR3410-2001",
      LN_id_GostR3411_94_with_GostR3410_2001 = "GOST",
      NID_id_GostR3411_94_with_GostR3410_2001 = 807,
      OBJ_id_GostR3411_94_with_GostR3410_2001 = "OBJ_cryptopro,3L",
      SN_id_GostR3411_94_with_GostR3410_94 = "id-GostR3411-94-with-GostR3410-94",
      LN_id_GostR3411_94_with_GostR3410_94 = "GOST",
      NID_id_GostR3411_94_with_GostR3410_94 = 808,
      OBJ_id_GostR3411_94_with_GostR3410_94 = "OBJ_cryptopro,4L",
      SN_id_GostR3411_94 = "md_gost94",
      LN_id_GostR3411_94 = "GOST",
      NID_id_GostR3411_94 = 809,
      OBJ_id_GostR3411_94 = "OBJ_cryptopro,9L",
      SN_id_HMACGostR3411_94 = "id-HMACGostR3411-94",
      LN_id_HMACGostR3411_94 = "HMAC",
      NID_id_HMACGostR3411_94 = 810,
      OBJ_id_HMACGostR3411_94 = "OBJ_cryptopro,10L",
      SN_id_GostR3410_2001 = "gost2001",
      LN_id_GostR3410_2001 = "GOST",
      NID_id_GostR3410_2001 = 811,
      OBJ_id_GostR3410_2001 = "OBJ_cryptopro,19L",
      SN_id_GostR3410_94 = "gost94",
      LN_id_GostR3410_94 = "GOST",
      NID_id_GostR3410_94 = 812,
      OBJ_id_GostR3410_94 = "OBJ_cryptopro,20L",
      SN_id_Gost28147_89 = "gost89",
      LN_id_Gost28147_89 = "GOST",
      NID_id_Gost28147_89 = 813,
      OBJ_id_Gost28147_89 = "OBJ_cryptopro,21L",
      SN_gost89_cnt = "gost89-cnt",
      NID_gost89_cnt = 814,
      SN_gost89_cnt_12 = "gost89-cnt-12",
      NID_gost89_cnt_12 = 975,
      SN_gost89_cbc = "gost89-cbc",
      NID_gost89_cbc = 1009,
      SN_gost89_ecb = "gost89-ecb",
      NID_gost89_ecb = 1010,
      SN_gost89_ctr = "gost89-ctr",
      NID_gost89_ctr = 1011,
      SN_id_Gost28147_89_MAC = "gost-mac",
      LN_id_Gost28147_89_MAC = "GOST",
      NID_id_Gost28147_89_MAC = 815,
      OBJ_id_Gost28147_89_MAC = "OBJ_cryptopro,22L",
      SN_gost_mac_12 = "gost-mac-12",
      NID_gost_mac_12 = 976,
      SN_id_GostR3411_94_prf = "prf-gostr3411-94",
      LN_id_GostR3411_94_prf = "GOST",
      NID_id_GostR3411_94_prf = 816,
      OBJ_id_GostR3411_94_prf = "OBJ_cryptopro,23L",
      SN_id_GostR3410_2001DH = "id-GostR3410-2001DH",
      LN_id_GostR3410_2001DH = "GOST",
      NID_id_GostR3410_2001DH = 817,
      OBJ_id_GostR3410_2001DH = "OBJ_cryptopro,98L",
      SN_id_GostR3410_94DH = "id-GostR3410-94DH",
      LN_id_GostR3410_94DH = "GOST",
      NID_id_GostR3410_94DH = 818,
      OBJ_id_GostR3410_94DH = "OBJ_cryptopro,99L",
      SN_id_Gost28147_89_CryptoPro_KeyMeshing = "id-Gost28147-89-CryptoPro-KeyMeshing",
      NID_id_Gost28147_89_CryptoPro_KeyMeshing = 819,
      OBJ_id_Gost28147_89_CryptoPro_KeyMeshing = "OBJ_cryptopro,14L,1L",
      SN_id_Gost28147_89_None_KeyMeshing = "id-Gost28147-89-None-KeyMeshing",
      NID_id_Gost28147_89_None_KeyMeshing = 820,
      OBJ_id_Gost28147_89_None_KeyMeshing = "OBJ_cryptopro,14L,0L",
      SN_id_GostR3411_94_TestParamSet = "id-GostR3411-94-TestParamSet",
      NID_id_GostR3411_94_TestParamSet = 821,
      OBJ_id_GostR3411_94_TestParamSet = "OBJ_cryptopro,30L,0L",
      SN_id_GostR3411_94_CryptoProParamSet = "id-GostR3411-94-CryptoProParamSet",
      NID_id_GostR3411_94_CryptoProParamSet = 822,
      OBJ_id_GostR3411_94_CryptoProParamSet = "OBJ_cryptopro,30L,1L",
      SN_id_Gost28147_89_TestParamSet = "id-Gost28147-89-TestParamSet",
      NID_id_Gost28147_89_TestParamSet = 823,
      OBJ_id_Gost28147_89_TestParamSet = "OBJ_cryptopro,31L,0L",
      SN_id_Gost28147_89_CryptoPro_A_ParamSet = "id-Gost28147-89-CryptoPro-A-ParamSet",
      NID_id_Gost28147_89_CryptoPro_A_ParamSet = 824,
      OBJ_id_Gost28147_89_CryptoPro_A_ParamSet = "OBJ_cryptopro,31L,1L",
      SN_id_Gost28147_89_CryptoPro_B_ParamSet = "id-Gost28147-89-CryptoPro-B-ParamSet",
      NID_id_Gost28147_89_CryptoPro_B_ParamSet = 825,
      OBJ_id_Gost28147_89_CryptoPro_B_ParamSet = "OBJ_cryptopro,31L,2L",
      SN_id_Gost28147_89_CryptoPro_C_ParamSet = "id-Gost28147-89-CryptoPro-C-ParamSet",
      NID_id_Gost28147_89_CryptoPro_C_ParamSet = 826,
      OBJ_id_Gost28147_89_CryptoPro_C_ParamSet = "OBJ_cryptopro,31L,3L",
      SN_id_Gost28147_89_CryptoPro_D_ParamSet = "id-Gost28147-89-CryptoPro-D-ParamSet",
      NID_id_Gost28147_89_CryptoPro_D_ParamSet = 827,
      OBJ_id_Gost28147_89_CryptoPro_D_ParamSet = "OBJ_cryptopro,31L,4L",
      SN_id_Gost28147_89_CryptoPro_Oscar_1_1_ParamSet = "id-Gost28147-89-CryptoPro-Oscar-1-1-ParamSet",
      NID_id_Gost28147_89_CryptoPro_Oscar_1_1_ParamSet = 828,
      OBJ_id_Gost28147_89_CryptoPro_Oscar_1_1_ParamSet = "OBJ_cryptopro,31L,5L",
      SN_id_Gost28147_89_CryptoPro_Oscar_1_0_ParamSet = "id-Gost28147-89-CryptoPro-Oscar-1-0-ParamSet",
      NID_id_Gost28147_89_CryptoPro_Oscar_1_0_ParamSet = 829,
      OBJ_id_Gost28147_89_CryptoPro_Oscar_1_0_ParamSet = "OBJ_cryptopro,31L,6L",
      SN_id_Gost28147_89_CryptoPro_RIC_1_ParamSet = "id-Gost28147-89-CryptoPro-RIC-1-ParamSet",
      NID_id_Gost28147_89_CryptoPro_RIC_1_ParamSet = 830,
      OBJ_id_Gost28147_89_CryptoPro_RIC_1_ParamSet = "OBJ_cryptopro,31L,7L",
      SN_id_GostR3410_94_TestParamSet = "id-GostR3410-94-TestParamSet",
      NID_id_GostR3410_94_TestParamSet = 831,
      OBJ_id_GostR3410_94_TestParamSet = "OBJ_cryptopro,32L,0L",
      SN_id_GostR3410_94_CryptoPro_A_ParamSet = "id-GostR3410-94-CryptoPro-A-ParamSet",
      NID_id_GostR3410_94_CryptoPro_A_ParamSet = 832,
      OBJ_id_GostR3410_94_CryptoPro_A_ParamSet = "OBJ_cryptopro,32L,2L",
      SN_id_GostR3410_94_CryptoPro_B_ParamSet = "id-GostR3410-94-CryptoPro-B-ParamSet",
      NID_id_GostR3410_94_CryptoPro_B_ParamSet = 833,
      OBJ_id_GostR3410_94_CryptoPro_B_ParamSet = "OBJ_cryptopro,32L,3L",
      SN_id_GostR3410_94_CryptoPro_C_ParamSet = "id-GostR3410-94-CryptoPro-C-ParamSet",
      NID_id_GostR3410_94_CryptoPro_C_ParamSet = 834,
      OBJ_id_GostR3410_94_CryptoPro_C_ParamSet = "OBJ_cryptopro,32L,4L",
      SN_id_GostR3410_94_CryptoPro_D_ParamSet = "id-GostR3410-94-CryptoPro-D-ParamSet",
      NID_id_GostR3410_94_CryptoPro_D_ParamSet = 835,
      OBJ_id_GostR3410_94_CryptoPro_D_ParamSet = "OBJ_cryptopro,32L,5L",
      SN_id_GostR3410_94_CryptoPro_XchA_ParamSet = "id-GostR3410-94-CryptoPro-XchA-ParamSet",
      NID_id_GostR3410_94_CryptoPro_XchA_ParamSet = 836,
      OBJ_id_GostR3410_94_CryptoPro_XchA_ParamSet = "OBJ_cryptopro,33L,1L",
      SN_id_GostR3410_94_CryptoPro_XchB_ParamSet = "id-GostR3410-94-CryptoPro-XchB-ParamSet",
      NID_id_GostR3410_94_CryptoPro_XchB_ParamSet = 837,
      OBJ_id_GostR3410_94_CryptoPro_XchB_ParamSet = "OBJ_cryptopro,33L,2L",
      SN_id_GostR3410_94_CryptoPro_XchC_ParamSet = "id-GostR3410-94-CryptoPro-XchC-ParamSet",
      NID_id_GostR3410_94_CryptoPro_XchC_ParamSet = 838,
      OBJ_id_GostR3410_94_CryptoPro_XchC_ParamSet = "OBJ_cryptopro,33L,3L",
      SN_id_GostR3410_2001_TestParamSet = "id-GostR3410-2001-TestParamSet",
      NID_id_GostR3410_2001_TestParamSet = 839,
      OBJ_id_GostR3410_2001_TestParamSet = "OBJ_cryptopro,35L,0L",
      SN_id_GostR3410_2001_CryptoPro_A_ParamSet = "id-GostR3410-2001-CryptoPro-A-ParamSet",
      NID_id_GostR3410_2001_CryptoPro_A_ParamSet = 840,
      OBJ_id_GostR3410_2001_CryptoPro_A_ParamSet = "OBJ_cryptopro,35L,1L",
      SN_id_GostR3410_2001_CryptoPro_B_ParamSet = "id-GostR3410-2001-CryptoPro-B-ParamSet",
      NID_id_GostR3410_2001_CryptoPro_B_ParamSet = 841,
      OBJ_id_GostR3410_2001_CryptoPro_B_ParamSet = "OBJ_cryptopro,35L,2L",
      SN_id_GostR3410_2001_CryptoPro_C_ParamSet = "id-GostR3410-2001-CryptoPro-C-ParamSet",
      NID_id_GostR3410_2001_CryptoPro_C_ParamSet = 842,
      OBJ_id_GostR3410_2001_CryptoPro_C_ParamSet = "OBJ_cryptopro,35L,3L",
      SN_id_GostR3410_2001_CryptoPro_XchA_ParamSet = "id-GostR3410-2001-CryptoPro-XchA-ParamSet",
      NID_id_GostR3410_2001_CryptoPro_XchA_ParamSet = 843,
      OBJ_id_GostR3410_2001_CryptoPro_XchA_ParamSet = "OBJ_cryptopro,36L,0L",
      SN_id_GostR3410_2001_CryptoPro_XchB_ParamSet = "id-GostR3410-2001-CryptoPro-XchB-ParamSet",
      NID_id_GostR3410_2001_CryptoPro_XchB_ParamSet = 844,
      OBJ_id_GostR3410_2001_CryptoPro_XchB_ParamSet = "OBJ_cryptopro,36L,1L",
      SN_id_GostR3410_94_a = "id-GostR3410-94-a",
      NID_id_GostR3410_94_a = 845,
      OBJ_id_GostR3410_94_a = "OBJ_id_GostR3410_94,1L",
      SN_id_GostR3410_94_aBis = "id-GostR3410-94-aBis",
      NID_id_GostR3410_94_aBis = 846,
      OBJ_id_GostR3410_94_aBis = "OBJ_id_GostR3410_94,2L",
      SN_id_GostR3410_94_b = "id-GostR3410-94-b",
      NID_id_GostR3410_94_b = 847,
      OBJ_id_GostR3410_94_b = "OBJ_id_GostR3410_94,3L",
      SN_id_GostR3410_94_bBis = "id-GostR3410-94-bBis",
      NID_id_GostR3410_94_bBis = 848,
      OBJ_id_GostR3410_94_bBis = "OBJ_id_GostR3410_94,4L",
      SN_id_Gost28147_89_cc = "id-Gost28147-89-cc",
      LN_id_Gost28147_89_cc = "GOST",
      NID_id_Gost28147_89_cc = 849,
      OBJ_id_Gost28147_89_cc = "OBJ_cryptocom,1L,6L,1L",
      SN_id_GostR3410_94_cc = "gost94cc",
      LN_id_GostR3410_94_cc = "GOST",
      NID_id_GostR3410_94_cc = 850,
      OBJ_id_GostR3410_94_cc = "OBJ_cryptocom,1L,5L,3L",
      SN_id_GostR3410_2001_cc = "gost2001cc",
      LN_id_GostR3410_2001_cc = "GOST",
      NID_id_GostR3410_2001_cc = 851,
      OBJ_id_GostR3410_2001_cc = "OBJ_cryptocom,1L,5L,4L",
      SN_id_GostR3411_94_with_GostR3410_94_cc = "id-GostR3411-94-with-GostR3410-94-cc",
      LN_id_GostR3411_94_with_GostR3410_94_cc = "GOST",
      NID_id_GostR3411_94_with_GostR3410_94_cc = 852,
      OBJ_id_GostR3411_94_with_GostR3410_94_cc = "OBJ_cryptocom,1L,3L,3L",
      SN_id_GostR3411_94_with_GostR3410_2001_cc = "id-GostR3411-94-with-GostR3410-2001-cc",
      LN_id_GostR3411_94_with_GostR3410_2001_cc = "GOST",
      NID_id_GostR3411_94_with_GostR3410_2001_cc = 853,
      OBJ_id_GostR3411_94_with_GostR3410_2001_cc = "OBJ_cryptocom,1L,3L,4L",
      SN_id_GostR3410_2001_ParamSet_cc = "id-GostR3410-2001-ParamSet-cc",
      LN_id_GostR3410_2001_ParamSet_cc = "GOST",
      NID_id_GostR3410_2001_ParamSet_cc = 854,
      OBJ_id_GostR3410_2001_ParamSet_cc = "OBJ_cryptocom,1L,8L,1L",
      SN_id_tc26_algorithms = "id-tc26-algorithms",
      NID_id_tc26_algorithms = 977,
      OBJ_id_tc26_algorithms = "OBJ_id_tc26,1L",
      SN_id_tc26_sign = "id-tc26-sign",
      NID_id_tc26_sign = 978,
      OBJ_id_tc26_sign = "OBJ_id_tc26_algorithms,1L",
      SN_id_GostR3410_2012_256 = "gost2012_256",
      LN_id_GostR3410_2012_256 = "GOST",
      NID_id_GostR3410_2012_256 = 979,
      OBJ_id_GostR3410_2012_256 = "OBJ_id_tc26_sign,1L",
      SN_id_GostR3410_2012_512 = "gost2012_512",
      LN_id_GostR3410_2012_512 = "GOST",
      NID_id_GostR3410_2012_512 = 980,
      OBJ_id_GostR3410_2012_512 = "OBJ_id_tc26_sign,2L",
      SN_id_tc26_digest = "id-tc26-digest",
      NID_id_tc26_digest = 981,
      OBJ_id_tc26_digest = "OBJ_id_tc26_algorithms,2L",
      SN_id_GostR3411_2012_256 = "md_gost12_256",
      LN_id_GostR3411_2012_256 = "GOST",
      NID_id_GostR3411_2012_256 = 982,
      OBJ_id_GostR3411_2012_256 = "OBJ_id_tc26_digest,2L",
      SN_id_GostR3411_2012_512 = "md_gost12_512",
      LN_id_GostR3411_2012_512 = "GOST",
      NID_id_GostR3411_2012_512 = 983,
      OBJ_id_GostR3411_2012_512 = "OBJ_id_tc26_digest,3L",
      SN_id_tc26_signwithdigest = "id-tc26-signwithdigest",
      NID_id_tc26_signwithdigest = 984,
      OBJ_id_tc26_signwithdigest = "OBJ_id_tc26_algorithms,3L",
      SN_id_tc26_signwithdigest_gost3410_2012_256 = "id-tc26-signwithdigest-gost3410-2012-256",
      LN_id_tc26_signwithdigest_gost3410_2012_256 = "GOST",
      NID_id_tc26_signwithdigest_gost3410_2012_256 = 985,
      OBJ_id_tc26_signwithdigest_gost3410_2012_256 = "OBJ_id_tc26_signwithdigest,2L",
      SN_id_tc26_signwithdigest_gost3410_2012_512 = "id-tc26-signwithdigest-gost3410-2012-512",
      LN_id_tc26_signwithdigest_gost3410_2012_512 = "GOST",
      NID_id_tc26_signwithdigest_gost3410_2012_512 = 986,
      OBJ_id_tc26_signwithdigest_gost3410_2012_512 = "OBJ_id_tc26_signwithdigest,3L",
      SN_id_tc26_mac = "id-tc26-mac",
      NID_id_tc26_mac = 987,
      OBJ_id_tc26_mac = "OBJ_id_tc26_algorithms,4L",
      SN_id_tc26_hmac_gost_3411_2012_256 = "id-tc26-hmac-gost-3411-2012-256",
      LN_id_tc26_hmac_gost_3411_2012_256 = "HMAC",
      NID_id_tc26_hmac_gost_3411_2012_256 = 988,
      OBJ_id_tc26_hmac_gost_3411_2012_256 = "OBJ_id_tc26_mac,1L",
      SN_id_tc26_hmac_gost_3411_2012_512 = "id-tc26-hmac-gost-3411-2012-512",
      LN_id_tc26_hmac_gost_3411_2012_512 = "HMAC",
      NID_id_tc26_hmac_gost_3411_2012_512 = 989,
      OBJ_id_tc26_hmac_gost_3411_2012_512 = "OBJ_id_tc26_mac,2L",
      SN_id_tc26_cipher = "id-tc26-cipher",
      NID_id_tc26_cipher = 990,
      OBJ_id_tc26_cipher = "OBJ_id_tc26_algorithms,5L",
      SN_id_tc26_cipher_gostr3412_2015_magma = "id-tc26-cipher-gostr3412-2015-magma",
      NID_id_tc26_cipher_gostr3412_2015_magma = 1173,
      OBJ_id_tc26_cipher_gostr3412_2015_magma = "OBJ_id_tc26_cipher,1L",
      SN_magma_ctr_acpkm = "magma-ctr-acpkm",
      NID_magma_ctr_acpkm = 1174,
      OBJ_magma_ctr_acpkm = "OBJ_id_tc26_cipher_gostr3412_2015_magma,1L",
      SN_magma_ctr_acpkm_omac = "magma-ctr-acpkm-omac",
      NID_magma_ctr_acpkm_omac = 1175,
      OBJ_magma_ctr_acpkm_omac = "OBJ_id_tc26_cipher_gostr3412_2015_magma,2L",
      SN_id_tc26_cipher_gostr3412_2015_kuznyechik = "id-tc26-cipher-gostr3412-2015-kuznyechik",
      NID_id_tc26_cipher_gostr3412_2015_kuznyechik = 1176,
      OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik = "OBJ_id_tc26_cipher,2L",
      SN_kuznyechik_ctr_acpkm = "kuznyechik-ctr-acpkm",
      NID_kuznyechik_ctr_acpkm = 1177,
      OBJ_kuznyechik_ctr_acpkm = "OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik,1L",
      SN_kuznyechik_ctr_acpkm_omac = "kuznyechik-ctr-acpkm-omac",
      NID_kuznyechik_ctr_acpkm_omac = 1178,
      OBJ_kuznyechik_ctr_acpkm_omac = "OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik,2L",
      SN_id_tc26_agreement = "id-tc26-agreement",
      NID_id_tc26_agreement = 991,
      OBJ_id_tc26_agreement = "OBJ_id_tc26_algorithms,6L",
      SN_id_tc26_agreement_gost_3410_2012_256 = "id-tc26-agreement-gost-3410-2012-256",
      NID_id_tc26_agreement_gost_3410_2012_256 = 992,
      OBJ_id_tc26_agreement_gost_3410_2012_256 = "OBJ_id_tc26_agreement,1L",
      SN_id_tc26_agreement_gost_3410_2012_512 = "id-tc26-agreement-gost-3410-2012-512",
      NID_id_tc26_agreement_gost_3410_2012_512 = 993,
      OBJ_id_tc26_agreement_gost_3410_2012_512 = "OBJ_id_tc26_agreement,2L",
      SN_id_tc26_wrap = "id-tc26-wrap",
      NID_id_tc26_wrap = 1179,
      OBJ_id_tc26_wrap = "OBJ_id_tc26_algorithms,7L",
      SN_id_tc26_wrap_gostr3412_2015_magma = "id-tc26-wrap-gostr3412-2015-magma",
      NID_id_tc26_wrap_gostr3412_2015_magma = 1180,
      OBJ_id_tc26_wrap_gostr3412_2015_magma = "OBJ_id_tc26_wrap,1L",
      SN_magma_kexp15 = "magma-kexp15",
      NID_magma_kexp15 = 1181,
      OBJ_magma_kexp15 = "OBJ_id_tc26_wrap_gostr3412_2015_magma,1L",
      SN_id_tc26_wrap_gostr3412_2015_kuznyechik = "id-tc26-wrap-gostr3412-2015-kuznyechik",
      NID_id_tc26_wrap_gostr3412_2015_kuznyechik = 1182,
      OBJ_id_tc26_wrap_gostr3412_2015_kuznyechik = "OBJ_id_tc26_wrap,2L",
      SN_kuznyechik_kexp15 = "kuznyechik-kexp15",
      NID_kuznyechik_kexp15 = 1183,
      OBJ_kuznyechik_kexp15 = "OBJ_id_tc26_wrap_gostr3412_2015_kuznyechik,1L",
      SN_id_tc26_constants = "id-tc26-constants",
      NID_id_tc26_constants = 994,
      OBJ_id_tc26_constants = "OBJ_id_tc26,2L",
      SN_id_tc26_sign_constants = "id-tc26-sign-constants",
      NID_id_tc26_sign_constants = 995,
      OBJ_id_tc26_sign_constants = "OBJ_id_tc26_constants,1L",
      SN_id_tc26_gost_3410_2012_256_constants = "id-tc26-gost-3410-2012-256-constants",
      NID_id_tc26_gost_3410_2012_256_constants = 1147,
      OBJ_id_tc26_gost_3410_2012_256_constants = "OBJ_id_tc26_sign_constants,1L",
      SN_id_tc26_gost_3410_2012_256_paramSetA = "id-tc26-gost-3410-2012-256-paramSetA",
      LN_id_tc26_gost_3410_2012_256_paramSetA = "GOST",
      NID_id_tc26_gost_3410_2012_256_paramSetA = 1148,
      OBJ_id_tc26_gost_3410_2012_256_paramSetA = "OBJ_id_tc26_gost_3410_2012_256_constants,1L",
      SN_id_tc26_gost_3410_2012_256_paramSetB = "id-tc26-gost-3410-2012-256-paramSetB",
      LN_id_tc26_gost_3410_2012_256_paramSetB = "GOST",
      NID_id_tc26_gost_3410_2012_256_paramSetB = 1184,
      OBJ_id_tc26_gost_3410_2012_256_paramSetB = "OBJ_id_tc26_gost_3410_2012_256_constants,2L",
      SN_id_tc26_gost_3410_2012_256_paramSetC = "id-tc26-gost-3410-2012-256-paramSetC",
      LN_id_tc26_gost_3410_2012_256_paramSetC = "GOST",
      NID_id_tc26_gost_3410_2012_256_paramSetC = 1185,
      OBJ_id_tc26_gost_3410_2012_256_paramSetC = "OBJ_id_tc26_gost_3410_2012_256_constants,3L",
      SN_id_tc26_gost_3410_2012_256_paramSetD = "id-tc26-gost-3410-2012-256-paramSetD",
      LN_id_tc26_gost_3410_2012_256_paramSetD = "GOST",
      NID_id_tc26_gost_3410_2012_256_paramSetD = 1186,
      OBJ_id_tc26_gost_3410_2012_256_paramSetD = "OBJ_id_tc26_gost_3410_2012_256_constants,4L",
      SN_id_tc26_gost_3410_2012_512_constants = "id-tc26-gost-3410-2012-512-constants",
      NID_id_tc26_gost_3410_2012_512_constants = 996,
      OBJ_id_tc26_gost_3410_2012_512_constants = "OBJ_id_tc26_sign_constants,2L",
      SN_id_tc26_gost_3410_2012_512_paramSetTest = "id-tc26-gost-3410-2012-512-paramSetTest",
      LN_id_tc26_gost_3410_2012_512_paramSetTest = "GOST",
      NID_id_tc26_gost_3410_2012_512_paramSetTest = 997,
      OBJ_id_tc26_gost_3410_2012_512_paramSetTest = "OBJ_id_tc26_gost_3410_2012_512_constants,0L",
      SN_id_tc26_gost_3410_2012_512_paramSetA = "id-tc26-gost-3410-2012-512-paramSetA",
      LN_id_tc26_gost_3410_2012_512_paramSetA = "GOST",
      NID_id_tc26_gost_3410_2012_512_paramSetA = 998,
      OBJ_id_tc26_gost_3410_2012_512_paramSetA = "OBJ_id_tc26_gost_3410_2012_512_constants,1L",
      SN_id_tc26_gost_3410_2012_512_paramSetB = "id-tc26-gost-3410-2012-512-paramSetB",
      LN_id_tc26_gost_3410_2012_512_paramSetB = "GOST",
      NID_id_tc26_gost_3410_2012_512_paramSetB = 999,
      OBJ_id_tc26_gost_3410_2012_512_paramSetB = "OBJ_id_tc26_gost_3410_2012_512_constants,2L",
      SN_id_tc26_gost_3410_2012_512_paramSetC = "id-tc26-gost-3410-2012-512-paramSetC",
      LN_id_tc26_gost_3410_2012_512_paramSetC = "GOST",
      NID_id_tc26_gost_3410_2012_512_paramSetC = 1149,
      OBJ_id_tc26_gost_3410_2012_512_paramSetC = "OBJ_id_tc26_gost_3410_2012_512_constants,3L",
      SN_id_tc26_digest_constants = "id-tc26-digest-constants",
      NID_id_tc26_digest_constants = 1000,
      OBJ_id_tc26_digest_constants = "OBJ_id_tc26_constants,2L",
      SN_id_tc26_cipher_constants = "id-tc26-cipher-constants",
      NID_id_tc26_cipher_constants = 1001,
      OBJ_id_tc26_cipher_constants = "OBJ_id_tc26_constants,5L",
      SN_id_tc26_gost_28147_constants = "id-tc26-gost-28147-constants",
      NID_id_tc26_gost_28147_constants = 1002,
      OBJ_id_tc26_gost_28147_constants = "OBJ_id_tc26_cipher_constants,1L",
      SN_id_tc26_gost_28147_param_Z = "id-tc26-gost-28147-param-Z",
      LN_id_tc26_gost_28147_param_Z = "GOST",
      NID_id_tc26_gost_28147_param_Z = 1003,
      OBJ_id_tc26_gost_28147_param_Z = "OBJ_id_tc26_gost_28147_constants,1L",
      SN_INN = "INN",
      LN_INN = "INN",
      NID_INN = 1004,
      OBJ_INN = "OBJ_member_body,643L,3L,131L,1L,1L",
      SN_OGRN = "OGRN",
      LN_OGRN = "OGRN",
      NID_OGRN = 1005,
      OBJ_OGRN = "OBJ_member_body,643L,100L,1L",
      SN_SNILS = "SNILS",
      LN_SNILS = "SNILS",
      NID_SNILS = 1006,
      OBJ_SNILS = "OBJ_member_body,643L,100L,3L",
      SN_OGRNIP = "OGRNIP",
      LN_OGRNIP = "OGRNIP",
      NID_OGRNIP = 1226,
      OBJ_OGRNIP = "OBJ_member_body,643L,100L,5L",
      SN_subjectSignTool = "subjectSignTool",
      LN_subjectSignTool = "Signing",
      NID_subjectSignTool = 1007,
      OBJ_subjectSignTool = "OBJ_member_body,643L,100L,111L",
      SN_issuerSignTool = "issuerSignTool",
      LN_issuerSignTool = "Signing",
      NID_issuerSignTool = 1008,
      OBJ_issuerSignTool = "OBJ_member_body,643L,100L,112L",
      SN_classSignTool = "classSignTool",
      LN_classSignTool = "Class",
      NID_classSignTool = 1227,
      OBJ_classSignTool = "OBJ_member_body,643L,100L,113L",
      SN_classSignToolKC1 = "classSignToolKC1",
      LN_classSignToolKC1 = "Class",
      NID_classSignToolKC1 = 1228,
      OBJ_classSignToolKC1 = "OBJ_member_body,643L,100L,113L,1L",
      SN_classSignToolKC2 = "classSignToolKC2",
      LN_classSignToolKC2 = "Class",
      NID_classSignToolKC2 = 1229,
      OBJ_classSignToolKC2 = "OBJ_member_body,643L,100L,113L,2L",
      SN_classSignToolKC3 = "classSignToolKC3",
      LN_classSignToolKC3 = "Class",
      NID_classSignToolKC3 = 1230,
      OBJ_classSignToolKC3 = "OBJ_member_body,643L,100L,113L,3L",
      SN_classSignToolKB1 = "classSignToolKB1",
      LN_classSignToolKB1 = "Class",
      NID_classSignToolKB1 = 1231,
      OBJ_classSignToolKB1 = "OBJ_member_body,643L,100L,113L,4L",
      SN_classSignToolKB2 = "classSignToolKB2",
      LN_classSignToolKB2 = "Class",
      NID_classSignToolKB2 = 1232,
      OBJ_classSignToolKB2 = "OBJ_member_body,643L,100L,113L,5L",
      SN_classSignToolKA1 = "classSignToolKA1",
      LN_classSignToolKA1 = "Class",
      NID_classSignToolKA1 = 1233,
      OBJ_classSignToolKA1 = "OBJ_member_body,643L,100L,113L,6L",
      SN_kuznyechik_ecb = "kuznyechik-ecb",
      NID_kuznyechik_ecb = 1012,
      SN_kuznyechik_ctr = "kuznyechik-ctr",
      NID_kuznyechik_ctr = 1013,
      SN_kuznyechik_ofb = "kuznyechik-ofb",
      NID_kuznyechik_ofb = 1014,
      SN_kuznyechik_cbc = "kuznyechik-cbc",
      NID_kuznyechik_cbc = 1015,
      SN_kuznyechik_cfb = "kuznyechik-cfb",
      NID_kuznyechik_cfb = 1016,
      SN_kuznyechik_mac = "kuznyechik-mac",
      NID_kuznyechik_mac = 1017,
      SN_magma_ecb = "magma-ecb",
      NID_magma_ecb = 1187,
      SN_magma_ctr = "magma-ctr",
      NID_magma_ctr = 1188,
      SN_magma_ofb = "magma-ofb",
      NID_magma_ofb = 1189,
      SN_magma_cbc = "magma-cbc",
      NID_magma_cbc = 1190,
      SN_magma_cfb = "magma-cfb",
      NID_magma_cfb = 1191,
      SN_magma_mac = "magma-mac",
      NID_magma_mac = 1192,
      SN_camellia_128_cbc = "CAMELLIA-128-CBC",
      LN_camellia_128_cbc = "camellia-128-cbc",
      NID_camellia_128_cbc = 751,
      OBJ_camellia_128_cbc = 1,
      SN_camellia_192_cbc = "CAMELLIA-192-CBC",
      LN_camellia_192_cbc = "camellia-192-cbc",
      NID_camellia_192_cbc = 752,
      OBJ_camellia_192_cbc = 1,
      SN_camellia_256_cbc = "CAMELLIA-256-CBC",
      LN_camellia_256_cbc = "camellia-256-cbc",
      NID_camellia_256_cbc = 753,
      OBJ_camellia_256_cbc = 1,
      SN_id_camellia128_wrap = "id-camellia128-wrap",
      NID_id_camellia128_wrap = 907,
      OBJ_id_camellia128_wrap = 1,
      SN_id_camellia192_wrap = "id-camellia192-wrap",
      NID_id_camellia192_wrap = 908,
      OBJ_id_camellia192_wrap = 1,
      SN_id_camellia256_wrap = "id-camellia256-wrap",
      NID_id_camellia256_wrap = 909,
      OBJ_id_camellia256_wrap = 1,
      OBJ_ntt_ds = "0L,3L,4401L,5L",
      OBJ_camellia = "OBJ_ntt_ds,3L,1L,9L",
      SN_camellia_128_ecb = "CAMELLIA-128-ECB",
      LN_camellia_128_ecb = "camellia-128-ecb",
      NID_camellia_128_ecb = 754,
      OBJ_camellia_128_ecb = "OBJ_camellia,1L",
      SN_camellia_128_ofb128 = "CAMELLIA-128-OFB",
      LN_camellia_128_ofb128 = "camellia-128-ofb",
      NID_camellia_128_ofb128 = 766,
      OBJ_camellia_128_ofb128 = "OBJ_camellia,3L",
      SN_camellia_128_cfb128 = "CAMELLIA-128-CFB",
      LN_camellia_128_cfb128 = "camellia-128-cfb",
      NID_camellia_128_cfb128 = 757,
      OBJ_camellia_128_cfb128 = "OBJ_camellia,4L",
      SN_camellia_128_gcm = "CAMELLIA-128-GCM",
      LN_camellia_128_gcm = "camellia-128-gcm",
      NID_camellia_128_gcm = 961,
      OBJ_camellia_128_gcm = "OBJ_camellia,6L",
      SN_camellia_128_ccm = "CAMELLIA-128-CCM",
      LN_camellia_128_ccm = "camellia-128-ccm",
      NID_camellia_128_ccm = 962,
      OBJ_camellia_128_ccm = "OBJ_camellia,7L",
      SN_camellia_128_ctr = "CAMELLIA-128-CTR",
      LN_camellia_128_ctr = "camellia-128-ctr",
      NID_camellia_128_ctr = 963,
      OBJ_camellia_128_ctr = "OBJ_camellia,9L",
      SN_camellia_128_cmac = "CAMELLIA-128-CMAC",
      LN_camellia_128_cmac = "camellia-128-cmac",
      NID_camellia_128_cmac = 964,
      OBJ_camellia_128_cmac = "OBJ_camellia,10L",
      SN_camellia_192_ecb = "CAMELLIA-192-ECB",
      LN_camellia_192_ecb = "camellia-192-ecb",
      NID_camellia_192_ecb = 755,
      OBJ_camellia_192_ecb = "OBJ_camellia,21L",
      SN_camellia_192_ofb128 = "CAMELLIA-192-OFB",
      LN_camellia_192_ofb128 = "camellia-192-ofb",
      NID_camellia_192_ofb128 = 767,
      OBJ_camellia_192_ofb128 = "OBJ_camellia,23L",
      SN_camellia_192_cfb128 = "CAMELLIA-192-CFB",
      LN_camellia_192_cfb128 = "camellia-192-cfb",
      NID_camellia_192_cfb128 = 758,
      OBJ_camellia_192_cfb128 = "OBJ_camellia,24L",
      SN_camellia_192_gcm = "CAMELLIA-192-GCM",
      LN_camellia_192_gcm = "camellia-192-gcm",
      NID_camellia_192_gcm = 965,
      OBJ_camellia_192_gcm = "OBJ_camellia,26L",
      SN_camellia_192_ccm = "CAMELLIA-192-CCM",
      LN_camellia_192_ccm = "camellia-192-ccm",
      NID_camellia_192_ccm = 966,
      OBJ_camellia_192_ccm = "OBJ_camellia,27L",
      SN_camellia_192_ctr = "CAMELLIA-192-CTR",
      LN_camellia_192_ctr = "camellia-192-ctr",
      NID_camellia_192_ctr = 967,
      OBJ_camellia_192_ctr = "OBJ_camellia,29L",
      SN_camellia_192_cmac = "CAMELLIA-192-CMAC",
      LN_camellia_192_cmac = "camellia-192-cmac",
      NID_camellia_192_cmac = 968,
      OBJ_camellia_192_cmac = "OBJ_camellia,30L",
      SN_camellia_256_ecb = "CAMELLIA-256-ECB",
      LN_camellia_256_ecb = "camellia-256-ecb",
      NID_camellia_256_ecb = 756,
      OBJ_camellia_256_ecb = "OBJ_camellia,41L",
      SN_camellia_256_ofb128 = "CAMELLIA-256-OFB",
      LN_camellia_256_ofb128 = "camellia-256-ofb",
      NID_camellia_256_ofb128 = 768,
      OBJ_camellia_256_ofb128 = "OBJ_camellia,43L",
      SN_camellia_256_cfb128 = "CAMELLIA-256-CFB",
      LN_camellia_256_cfb128 = "camellia-256-cfb",
      NID_camellia_256_cfb128 = 759,
      OBJ_camellia_256_cfb128 = "OBJ_camellia,44L",
      SN_camellia_256_gcm = "CAMELLIA-256-GCM",
      LN_camellia_256_gcm = "camellia-256-gcm",
      NID_camellia_256_gcm = 969,
      OBJ_camellia_256_gcm = "OBJ_camellia,46L",
      SN_camellia_256_ccm = "CAMELLIA-256-CCM",
      LN_camellia_256_ccm = "camellia-256-ccm",
      NID_camellia_256_ccm = 970,
      OBJ_camellia_256_ccm = "OBJ_camellia,47L",
      SN_camellia_256_ctr = "CAMELLIA-256-CTR",
      LN_camellia_256_ctr = "camellia-256-ctr",
      NID_camellia_256_ctr = 971,
      OBJ_camellia_256_ctr = "OBJ_camellia,49L",
      SN_camellia_256_cmac = "CAMELLIA-256-CMAC",
      LN_camellia_256_cmac = "camellia-256-cmac",
      NID_camellia_256_cmac = 972,
      OBJ_camellia_256_cmac = "OBJ_camellia,50L",
      SN_camellia_128_cfb1 = "CAMELLIA-128-CFB1",
      LN_camellia_128_cfb1 = "camellia-128-cfb1",
      NID_camellia_128_cfb1 = 760,
      SN_camellia_192_cfb1 = "CAMELLIA-192-CFB1",
      LN_camellia_192_cfb1 = "camellia-192-cfb1",
      NID_camellia_192_cfb1 = 761,
      SN_camellia_256_cfb1 = "CAMELLIA-256-CFB1",
      LN_camellia_256_cfb1 = "camellia-256-cfb1",
      NID_camellia_256_cfb1 = 762,
      SN_camellia_128_cfb8 = "CAMELLIA-128-CFB8",
      LN_camellia_128_cfb8 = "camellia-128-cfb8",
      NID_camellia_128_cfb8 = 763,
      SN_camellia_192_cfb8 = "CAMELLIA-192-CFB8",
      LN_camellia_192_cfb8 = "camellia-192-cfb8",
      NID_camellia_192_cfb8 = 764,
      SN_camellia_256_cfb8 = "CAMELLIA-256-CFB8",
      LN_camellia_256_cfb8 = "camellia-256-cfb8",
      NID_camellia_256_cfb8 = 765,
      OBJ_aria = 1,
      SN_aria_128_ecb = "ARIA-128-ECB",
      LN_aria_128_ecb = "aria-128-ecb",
      NID_aria_128_ecb = 1065,
      OBJ_aria_128_ecb = "OBJ_aria,1L",
      SN_aria_128_cbc = "ARIA-128-CBC",
      LN_aria_128_cbc = "aria-128-cbc",
      NID_aria_128_cbc = 1066,
      OBJ_aria_128_cbc = "OBJ_aria,2L",
      SN_aria_128_cfb128 = "ARIA-128-CFB",
      LN_aria_128_cfb128 = "aria-128-cfb",
      NID_aria_128_cfb128 = 1067,
      OBJ_aria_128_cfb128 = "OBJ_aria,3L",
      SN_aria_128_ofb128 = "ARIA-128-OFB",
      LN_aria_128_ofb128 = "aria-128-ofb",
      NID_aria_128_ofb128 = 1068,
      OBJ_aria_128_ofb128 = "OBJ_aria,4L",
      SN_aria_128_ctr = "ARIA-128-CTR",
      LN_aria_128_ctr = "aria-128-ctr",
      NID_aria_128_ctr = 1069,
      OBJ_aria_128_ctr = "OBJ_aria,5L",
      SN_aria_192_ecb = "ARIA-192-ECB",
      LN_aria_192_ecb = "aria-192-ecb",
      NID_aria_192_ecb = 1070,
      OBJ_aria_192_ecb = "OBJ_aria,6L",
      SN_aria_192_cbc = "ARIA-192-CBC",
      LN_aria_192_cbc = "aria-192-cbc",
      NID_aria_192_cbc = 1071,
      OBJ_aria_192_cbc = "OBJ_aria,7L",
      SN_aria_192_cfb128 = "ARIA-192-CFB",
      LN_aria_192_cfb128 = "aria-192-cfb",
      NID_aria_192_cfb128 = 1072,
      OBJ_aria_192_cfb128 = "OBJ_aria,8L",
      SN_aria_192_ofb128 = "ARIA-192-OFB",
      LN_aria_192_ofb128 = "aria-192-ofb",
      NID_aria_192_ofb128 = 1073,
      OBJ_aria_192_ofb128 = "OBJ_aria,9L",
      SN_aria_192_ctr = "ARIA-192-CTR",
      LN_aria_192_ctr = "aria-192-ctr",
      NID_aria_192_ctr = 1074,
      OBJ_aria_192_ctr = "OBJ_aria,10L",
      SN_aria_256_ecb = "ARIA-256-ECB",
      LN_aria_256_ecb = "aria-256-ecb",
      NID_aria_256_ecb = 1075,
      OBJ_aria_256_ecb = "OBJ_aria,11L",
      SN_aria_256_cbc = "ARIA-256-CBC",
      LN_aria_256_cbc = "aria-256-cbc",
      NID_aria_256_cbc = 1076,
      OBJ_aria_256_cbc = "OBJ_aria,12L",
      SN_aria_256_cfb128 = "ARIA-256-CFB",
      LN_aria_256_cfb128 = "aria-256-cfb",
      NID_aria_256_cfb128 = 1077,
      OBJ_aria_256_cfb128 = "OBJ_aria,13L",
      SN_aria_256_ofb128 = "ARIA-256-OFB",
      LN_aria_256_ofb128 = "aria-256-ofb",
      NID_aria_256_ofb128 = 1078,
      OBJ_aria_256_ofb128 = "OBJ_aria,14L",
      SN_aria_256_ctr = "ARIA-256-CTR",
      LN_aria_256_ctr = "aria-256-ctr",
      NID_aria_256_ctr = 1079,
      OBJ_aria_256_ctr = "OBJ_aria,15L",
      SN_aria_128_cfb1 = "ARIA-128-CFB1",
      LN_aria_128_cfb1 = "aria-128-cfb1",
      NID_aria_128_cfb1 = 1080,
      SN_aria_192_cfb1 = "ARIA-192-CFB1",
      LN_aria_192_cfb1 = "aria-192-cfb1",
      NID_aria_192_cfb1 = 1081,
      SN_aria_256_cfb1 = "ARIA-256-CFB1",
      LN_aria_256_cfb1 = "aria-256-cfb1",
      NID_aria_256_cfb1 = 1082,
      SN_aria_128_cfb8 = "ARIA-128-CFB8",
      LN_aria_128_cfb8 = "aria-128-cfb8",
      NID_aria_128_cfb8 = 1083,
      SN_aria_192_cfb8 = "ARIA-192-CFB8",
      LN_aria_192_cfb8 = "aria-192-cfb8",
      NID_aria_192_cfb8 = 1084,
      SN_aria_256_cfb8 = "ARIA-256-CFB8",
      LN_aria_256_cfb8 = "aria-256-cfb8",
      NID_aria_256_cfb8 = 1085,
      SN_aria_128_ccm = "ARIA-128-CCM",
      LN_aria_128_ccm = "aria-128-ccm",
      NID_aria_128_ccm = 1120,
      OBJ_aria_128_ccm = "OBJ_aria,37L",
      SN_aria_192_ccm = "ARIA-192-CCM",
      LN_aria_192_ccm = "aria-192-ccm",
      NID_aria_192_ccm = 1121,
      OBJ_aria_192_ccm = "OBJ_aria,38L",
      SN_aria_256_ccm = "ARIA-256-CCM",
      LN_aria_256_ccm = "aria-256-ccm",
      NID_aria_256_ccm = 1122,
      OBJ_aria_256_ccm = "OBJ_aria,39L",
      SN_aria_128_gcm = "ARIA-128-GCM",
      LN_aria_128_gcm = "aria-128-gcm",
      NID_aria_128_gcm = 1123,
      OBJ_aria_128_gcm = "OBJ_aria,34L",
      SN_aria_192_gcm = "ARIA-192-GCM",
      LN_aria_192_gcm = "aria-192-gcm",
      NID_aria_192_gcm = 1124,
      OBJ_aria_192_gcm = "OBJ_aria,35L",
      SN_aria_256_gcm = "ARIA-256-GCM",
      LN_aria_256_gcm = "aria-256-gcm",
      NID_aria_256_gcm = 1125,
      OBJ_aria_256_gcm = "OBJ_aria,36L",
      SN_kisa = "KISA",
      LN_kisa = "kisa",
      NID_kisa = 773,
      OBJ_kisa = "OBJ_member_body,410L,200004L",
      SN_seed_ecb = "SEED-ECB",
      LN_seed_ecb = "seed-ecb",
      NID_seed_ecb = 776,
      OBJ_seed_ecb = "OBJ_kisa,1L,3L",
      SN_seed_cbc = "SEED-CBC",
      LN_seed_cbc = "seed-cbc",
      NID_seed_cbc = 777,
      OBJ_seed_cbc = "OBJ_kisa,1L,4L",
      SN_seed_cfb128 = "SEED-CFB",
      LN_seed_cfb128 = "seed-cfb",
      NID_seed_cfb128 = 779,
      OBJ_seed_cfb128 = "OBJ_kisa,1L,5L",
      SN_seed_ofb128 = "SEED-OFB",
      LN_seed_ofb128 = "seed-ofb",
      NID_seed_ofb128 = 778,
      OBJ_seed_ofb128 = "OBJ_kisa,1L,6L",
      SN_sm4_ecb = "SM4-ECB",
      LN_sm4_ecb = "sm4-ecb",
      NID_sm4_ecb = 1133,
      OBJ_sm4_ecb = "OBJ_sm_scheme,104L,1L",
      SN_sm4_cbc = "SM4-CBC",
      LN_sm4_cbc = "sm4-cbc",
      NID_sm4_cbc = 1134,
      OBJ_sm4_cbc = "OBJ_sm_scheme,104L,2L",
      SN_sm4_ofb128 = "SM4-OFB",
      LN_sm4_ofb128 = "sm4-ofb",
      NID_sm4_ofb128 = 1135,
      OBJ_sm4_ofb128 = "OBJ_sm_scheme,104L,3L",
      SN_sm4_cfb128 = "SM4-CFB",
      LN_sm4_cfb128 = "sm4-cfb",
      NID_sm4_cfb128 = 1137,
      OBJ_sm4_cfb128 = "OBJ_sm_scheme,104L,4L",
      SN_sm4_cfb1 = "SM4-CFB1",
      LN_sm4_cfb1 = "sm4-cfb1",
      NID_sm4_cfb1 = 1136,
      OBJ_sm4_cfb1 = "OBJ_sm_scheme,104L,5L",
      SN_sm4_cfb8 = "SM4-CFB8",
      LN_sm4_cfb8 = "sm4-cfb8",
      NID_sm4_cfb8 = 1138,
      OBJ_sm4_cfb8 = "OBJ_sm_scheme,104L,6L",
      SN_sm4_ctr = "SM4-CTR",
      LN_sm4_ctr = "sm4-ctr",
      NID_sm4_ctr = 1139,
      OBJ_sm4_ctr = "OBJ_sm_scheme,104L,7L",
      SN_hmac = "HMAC",
      LN_hmac = "hmac",
      NID_hmac = 855,
      SN_cmac = "CMAC",
      LN_cmac = "cmac",
      NID_cmac = 894,
      SN_rc4_hmac_md5 = "RC4-HMAC-MD5",
      LN_rc4_hmac_md5 = "rc4-hmac-md5",
      NID_rc4_hmac_md5 = 915,
      SN_aes_128_cbc_hmac_sha1 = "AES-128-CBC-HMAC-SHA1",
      LN_aes_128_cbc_hmac_sha1 = "aes-128-cbc-hmac-sha1",
      NID_aes_128_cbc_hmac_sha1 = 916,
      SN_aes_192_cbc_hmac_sha1 = "AES-192-CBC-HMAC-SHA1",
      LN_aes_192_cbc_hmac_sha1 = "aes-192-cbc-hmac-sha1",
      NID_aes_192_cbc_hmac_sha1 = 917,
      SN_aes_256_cbc_hmac_sha1 = "AES-256-CBC-HMAC-SHA1",
      LN_aes_256_cbc_hmac_sha1 = "aes-256-cbc-hmac-sha1",
      NID_aes_256_cbc_hmac_sha1 = 918,
      SN_aes_128_cbc_hmac_sha256 = "AES-128-CBC-HMAC-SHA256",
      LN_aes_128_cbc_hmac_sha256 = "aes-128-cbc-hmac-sha256",
      NID_aes_128_cbc_hmac_sha256 = 948,
      SN_aes_192_cbc_hmac_sha256 = "AES-192-CBC-HMAC-SHA256",
      LN_aes_192_cbc_hmac_sha256 = "aes-192-cbc-hmac-sha256",
      NID_aes_192_cbc_hmac_sha256 = 949,
      SN_aes_256_cbc_hmac_sha256 = "AES-256-CBC-HMAC-SHA256",
      LN_aes_256_cbc_hmac_sha256 = "aes-256-cbc-hmac-sha256",
      NID_aes_256_cbc_hmac_sha256 = 950,
      SN_chacha20_poly1305 = "ChaCha20-Poly1305",
      LN_chacha20_poly1305 = "chacha20-poly1305",
      NID_chacha20_poly1305 = 1018,
      SN_chacha20 = "ChaCha20",
      LN_chacha20 = "chacha20",
      NID_chacha20 = 1019,
      SN_dhpublicnumber = "dhpublicnumber",
      LN_dhpublicnumber = "X9.42",
      NID_dhpublicnumber = 920,
      OBJ_dhpublicnumber = "OBJ_ISO_US,10046L,2L,1L",
      SN_brainpoolP160r1 = "brainpoolP160r1",
      NID_brainpoolP160r1 = 921,
      OBJ_brainpoolP160r1 = 1,
      SN_brainpoolP160t1 = "brainpoolP160t1",
      NID_brainpoolP160t1 = 922,
      OBJ_brainpoolP160t1 = 1,
      SN_brainpoolP192r1 = "brainpoolP192r1",
      NID_brainpoolP192r1 = 923,
      OBJ_brainpoolP192r1 = 1,
      SN_brainpoolP192t1 = "brainpoolP192t1",
      NID_brainpoolP192t1 = 924,
      OBJ_brainpoolP192t1 = 1,
      SN_brainpoolP224r1 = "brainpoolP224r1",
      NID_brainpoolP224r1 = 925,
      OBJ_brainpoolP224r1 = 1,
      SN_brainpoolP224t1 = "brainpoolP224t1",
      NID_brainpoolP224t1 = 926,
      OBJ_brainpoolP224t1 = 1,
      SN_brainpoolP256r1 = "brainpoolP256r1",
      NID_brainpoolP256r1 = 927,
      OBJ_brainpoolP256r1 = 1,
      SN_brainpoolP256t1 = "brainpoolP256t1",
      NID_brainpoolP256t1 = 928,
      OBJ_brainpoolP256t1 = 1,
      SN_brainpoolP320r1 = "brainpoolP320r1",
      NID_brainpoolP320r1 = 929,
      OBJ_brainpoolP320r1 = 1,
      SN_brainpoolP320t1 = "brainpoolP320t1",
      NID_brainpoolP320t1 = 930,
      OBJ_brainpoolP320t1 = 1,
      SN_brainpoolP384r1 = "brainpoolP384r1",
      NID_brainpoolP384r1 = 931,
      OBJ_brainpoolP384r1 = 1,
      SN_brainpoolP384t1 = "brainpoolP384t1",
      NID_brainpoolP384t1 = 932,
      OBJ_brainpoolP384t1 = 1,
      SN_brainpoolP512r1 = "brainpoolP512r1",
      NID_brainpoolP512r1 = 933,
      OBJ_brainpoolP512r1 = 1,
      SN_brainpoolP512t1 = "brainpoolP512t1",
      NID_brainpoolP512t1 = 934,
      OBJ_brainpoolP512t1 = 1,
      OBJ_x9_63_scheme = 1,
      OBJ_secg_scheme = "OBJ_certicom_arc,1L",
      SN_dhSinglePass_stdDH_sha1kdf_scheme = "dhSinglePass-stdDH-sha1kdf-scheme",
      NID_dhSinglePass_stdDH_sha1kdf_scheme = 936,
      OBJ_dhSinglePass_stdDH_sha1kdf_scheme = "OBJ_x9_63_scheme,2L",
      SN_dhSinglePass_stdDH_sha224kdf_scheme = "dhSinglePass-stdDH-sha224kdf-scheme",
      NID_dhSinglePass_stdDH_sha224kdf_scheme = 937,
      OBJ_dhSinglePass_stdDH_sha224kdf_scheme = "OBJ_secg_scheme,11L,0L",
      SN_dhSinglePass_stdDH_sha256kdf_scheme = "dhSinglePass-stdDH-sha256kdf-scheme",
      NID_dhSinglePass_stdDH_sha256kdf_scheme = 938,
      OBJ_dhSinglePass_stdDH_sha256kdf_scheme = "OBJ_secg_scheme,11L,1L",
      SN_dhSinglePass_stdDH_sha384kdf_scheme = "dhSinglePass-stdDH-sha384kdf-scheme",
      NID_dhSinglePass_stdDH_sha384kdf_scheme = 939,
      OBJ_dhSinglePass_stdDH_sha384kdf_scheme = "OBJ_secg_scheme,11L,2L",
      SN_dhSinglePass_stdDH_sha512kdf_scheme = "dhSinglePass-stdDH-sha512kdf-scheme",
      NID_dhSinglePass_stdDH_sha512kdf_scheme = 940,
      OBJ_dhSinglePass_stdDH_sha512kdf_scheme = "OBJ_secg_scheme,11L,3L",
      SN_dhSinglePass_cofactorDH_sha1kdf_scheme = "dhSinglePass-cofactorDH-sha1kdf-scheme",
      NID_dhSinglePass_cofactorDH_sha1kdf_scheme = 941,
      OBJ_dhSinglePass_cofactorDH_sha1kdf_scheme = "OBJ_x9_63_scheme,3L",
      SN_dhSinglePass_cofactorDH_sha224kdf_scheme = "dhSinglePass-cofactorDH-sha224kdf-scheme",
      NID_dhSinglePass_cofactorDH_sha224kdf_scheme = 942,
      OBJ_dhSinglePass_cofactorDH_sha224kdf_scheme = "OBJ_secg_scheme,14L,0L",
      SN_dhSinglePass_cofactorDH_sha256kdf_scheme = "dhSinglePass-cofactorDH-sha256kdf-scheme",
      NID_dhSinglePass_cofactorDH_sha256kdf_scheme = 943,
      OBJ_dhSinglePass_cofactorDH_sha256kdf_scheme = "OBJ_secg_scheme,14L,1L",
      SN_dhSinglePass_cofactorDH_sha384kdf_scheme = "dhSinglePass-cofactorDH-sha384kdf-scheme",
      NID_dhSinglePass_cofactorDH_sha384kdf_scheme = 944,
      OBJ_dhSinglePass_cofactorDH_sha384kdf_scheme = "OBJ_secg_scheme,14L,2L",
      SN_dhSinglePass_cofactorDH_sha512kdf_scheme = "dhSinglePass-cofactorDH-sha512kdf-scheme",
      NID_dhSinglePass_cofactorDH_sha512kdf_scheme = 945,
      OBJ_dhSinglePass_cofactorDH_sha512kdf_scheme = "OBJ_secg_scheme,14L,3L",
      SN_dh_std_kdf = "dh-std-kdf",
      NID_dh_std_kdf = 946,
      SN_dh_cofactor_kdf = "dh-cofactor-kdf",
      NID_dh_cofactor_kdf = 947,
      SN_ct_precert_scts = "ct_precert_scts",
      LN_ct_precert_scts = "CT",
      NID_ct_precert_scts = 951,
      OBJ_ct_precert_scts = 1,
      SN_ct_precert_poison = "ct_precert_poison",
      LN_ct_precert_poison = "CT",
      NID_ct_precert_poison = 952,
      OBJ_ct_precert_poison = 1,
      SN_ct_precert_signer = "ct_precert_signer",
      LN_ct_precert_signer = "CT",
      NID_ct_precert_signer = 953,
      OBJ_ct_precert_signer = 1,
      SN_ct_cert_scts = "ct_cert_scts",
      LN_ct_cert_scts = "CT",
      NID_ct_cert_scts = 954,
      OBJ_ct_cert_scts = 1,
      SN_jurisdictionLocalityName = "jurisdictionL",
      LN_jurisdictionLocalityName = "jurisdictionLocalityName",
      NID_jurisdictionLocalityName = 955,
      OBJ_jurisdictionLocalityName = 1,
      SN_jurisdictionStateOrProvinceName = "jurisdictionST",
      LN_jurisdictionStateOrProvinceName = "jurisdictionStateOrProvinceName",
      NID_jurisdictionStateOrProvinceName = 956,
      OBJ_jurisdictionStateOrProvinceName = 1,
      SN_jurisdictionCountryName = "jurisdictionC",
      LN_jurisdictionCountryName = "jurisdictionCountryName",
      NID_jurisdictionCountryName = 957,
      OBJ_jurisdictionCountryName = 1,
      SN_id_scrypt = "id-scrypt",
      LN_id_scrypt = "scrypt",
      NID_id_scrypt = 973,
      OBJ_id_scrypt = 1,
      SN_tls1_prf = "TLS1-PRF",
      LN_tls1_prf = "tls1-prf",
      NID_tls1_prf = 1021,
      SN_hkdf = "HKDF",
      LN_hkdf = "hkdf",
      NID_hkdf = 1036,
      SN_sshkdf = "SSHKDF",
      LN_sshkdf = "sshkdf",
      NID_sshkdf = 1203,
      SN_sskdf = "SSKDF",
      LN_sskdf = "sskdf",
      NID_sskdf = 1205,
      SN_x942kdf = "X942KDF",
      LN_x942kdf = "x942kdf",
      NID_x942kdf = 1207,
      SN_x963kdf = "X963KDF",
      LN_x963kdf = "x963kdf",
      NID_x963kdf = 1206,
      SN_id_pkinit = "id-pkinit",
      NID_id_pkinit = 1031,
      OBJ_id_pkinit = 1,
      SN_pkInitClientAuth = "pkInitClientAuth",
      LN_pkInitClientAuth = "PKINIT",
      NID_pkInitClientAuth = 1032,
      OBJ_pkInitClientAuth = "OBJ_id_pkinit,4L",
      SN_pkInitKDC = "pkInitKDC",
      LN_pkInitKDC = "Signing",
      NID_pkInitKDC = 1033,
      OBJ_pkInitKDC = "OBJ_id_pkinit,5L",
      SN_X25519 = "X25519",
      NID_X25519 = 1034,
      OBJ_X25519 = 1,
      SN_X448 = "X448",
      NID_X448 = 1035,
      OBJ_X448 = 1,
      SN_ED25519 = "ED25519",
      NID_ED25519 = 1087,
      OBJ_ED25519 = 1,
      SN_ED448 = "ED448",
      NID_ED448 = 1088,
      OBJ_ED448 = 1,
      SN_kx_rsa = "KxRSA",
      LN_kx_rsa = "kx-rsa",
      NID_kx_rsa = 1037,
      SN_kx_ecdhe = "KxECDHE",
      LN_kx_ecdhe = "kx-ecdhe",
      NID_kx_ecdhe = 1038,
      SN_kx_dhe = "KxDHE",
      LN_kx_dhe = "kx-dhe",
      NID_kx_dhe = 1039,
      SN_kx_ecdhe_psk = "KxECDHE-PSK",
      LN_kx_ecdhe_psk = "kx-ecdhe-psk",
      NID_kx_ecdhe_psk = 1040,
      SN_kx_dhe_psk = "KxDHE-PSK",
      LN_kx_dhe_psk = "kx-dhe-psk",
      NID_kx_dhe_psk = 1041,
      SN_kx_rsa_psk = "KxRSA_PSK",
      LN_kx_rsa_psk = "kx-rsa-psk",
      NID_kx_rsa_psk = 1042,
      SN_kx_psk = "KxPSK",
      LN_kx_psk = "kx-psk",
      NID_kx_psk = 1043,
      SN_kx_srp = "KxSRP",
      LN_kx_srp = "kx-srp",
      NID_kx_srp = 1044,
      SN_kx_gost = "KxGOST",
      LN_kx_gost = "kx-gost",
      NID_kx_gost = 1045,
      SN_kx_gost18 = "KxGOST18",
      LN_kx_gost18 = "kx-gost18",
      NID_kx_gost18 = 1218,
      SN_kx_any = "KxANY",
      LN_kx_any = "kx-any",
      NID_kx_any = 1063,
      SN_auth_rsa = "AuthRSA",
      LN_auth_rsa = "auth-rsa",
      NID_auth_rsa = 1046,
      SN_auth_ecdsa = "AuthECDSA",
      LN_auth_ecdsa = "auth-ecdsa",
      NID_auth_ecdsa = 1047,
      SN_auth_psk = "AuthPSK",
      LN_auth_psk = "auth-psk",
      NID_auth_psk = 1048,
      SN_auth_dss = "AuthDSS",
      LN_auth_dss = "auth-dss",
      NID_auth_dss = 1049,
      SN_auth_gost01 = "AuthGOST01",
      LN_auth_gost01 = "auth-gost01",
      NID_auth_gost01 = 1050,
      SN_auth_gost12 = "AuthGOST12",
      LN_auth_gost12 = "auth-gost12",
      NID_auth_gost12 = 1051,
      SN_auth_srp = "AuthSRP",
      LN_auth_srp = "auth-srp",
      NID_auth_srp = 1052,
      SN_auth_null = "AuthNULL",
      LN_auth_null = "auth-null",
      NID_auth_null = 1053,
      SN_auth_any = "AuthANY",
      LN_auth_any = "auth-any",
      NID_auth_any = 1064,
      SN_poly1305 = "Poly1305",
      LN_poly1305 = "poly1305",
      NID_poly1305 = 1061,
      SN_siphash = "SipHash",
      LN_siphash = "siphash",
      NID_siphash = 1062,
      SN_ffdhe2048 = "ffdhe2048",
      NID_ffdhe2048 = 1126,
      SN_ffdhe3072 = "ffdhe3072",
      NID_ffdhe3072 = 1127,
      SN_ffdhe4096 = "ffdhe4096",
      NID_ffdhe4096 = 1128,
      SN_ffdhe6144 = "ffdhe6144",
      NID_ffdhe6144 = 1129,
      SN_ffdhe8192 = "ffdhe8192",
      NID_ffdhe8192 = 1130,
      SN_modp_1536 = "modp_1536",
      NID_modp_1536 = 1212,
      SN_modp_2048 = "modp_2048",
      NID_modp_2048 = 1213,
      SN_modp_3072 = "modp_3072",
      NID_modp_3072 = 1214,
      SN_modp_4096 = "modp_4096",
      NID_modp_4096 = 1215,
      SN_modp_6144 = "modp_6144",
      NID_modp_6144 = 1216,
      SN_modp_8192 = "modp_8192",
      NID_modp_8192 = 1217,
      SN_ISO_UA = "ISO-UA",
      NID_ISO_UA = 1150,
      OBJ_ISO_UA = "OBJ_member_body,804L",
      SN_ua_pki = "ua-pki",
      NID_ua_pki = 1151,
      OBJ_ua_pki = "OBJ_ISO_UA,2L,1L,1L,1L",
      SN_dstu28147 = "dstu28147",
      LN_dstu28147 = "DSTU",
      NID_dstu28147 = 1152,
      OBJ_dstu28147 = "OBJ_ua_pki,1L,1L,1L",
      SN_dstu28147_ofb = "dstu28147-ofb",
      LN_dstu28147_ofb = "DSTU",
      NID_dstu28147_ofb = 1153,
      OBJ_dstu28147_ofb = "OBJ_dstu28147,2L",
      SN_dstu28147_cfb = "dstu28147-cfb",
      LN_dstu28147_cfb = "DSTU",
      NID_dstu28147_cfb = 1154,
      OBJ_dstu28147_cfb = "OBJ_dstu28147,3L",
      SN_dstu28147_wrap = "dstu28147-wrap",
      LN_dstu28147_wrap = "DSTU",
      NID_dstu28147_wrap = 1155,
      OBJ_dstu28147_wrap = "OBJ_dstu28147,5L",
      SN_hmacWithDstu34311 = "hmacWithDstu34311",
      LN_hmacWithDstu34311 = "HMAC",
      NID_hmacWithDstu34311 = 1156,
      OBJ_hmacWithDstu34311 = "OBJ_ua_pki,1L,1L,2L",
      SN_dstu34311 = "dstu34311",
      LN_dstu34311 = "DSTU",
      NID_dstu34311 = 1157,
      OBJ_dstu34311 = "OBJ_ua_pki,1L,2L,1L",
      SN_dstu4145le = "dstu4145le",
      LN_dstu4145le = "DSTU",
      NID_dstu4145le = 1158,
      OBJ_dstu4145le = "OBJ_ua_pki,1L,3L,1L,1L",
      SN_dstu4145be = "dstu4145be",
      LN_dstu4145be = "DSTU",
      NID_dstu4145be = 1159,
      OBJ_dstu4145be = "OBJ_dstu4145le,1L,1L",
      SN_uacurve0 = "uacurve0",
      LN_uacurve0 = "DSTU",
      NID_uacurve0 = 1160,
      OBJ_uacurve0 = "OBJ_dstu4145le,2L,0L",
      SN_uacurve1 = "uacurve1",
      LN_uacurve1 = "DSTU",
      NID_uacurve1 = 1161,
      OBJ_uacurve1 = "OBJ_dstu4145le,2L,1L",
      SN_uacurve2 = "uacurve2",
      LN_uacurve2 = "DSTU",
      NID_uacurve2 = 1162,
      OBJ_uacurve2 = "OBJ_dstu4145le,2L,2L",
      SN_uacurve3 = "uacurve3",
      LN_uacurve3 = "DSTU",
      NID_uacurve3 = 1163,
      OBJ_uacurve3 = "OBJ_dstu4145le,2L,3L",
      SN_uacurve4 = "uacurve4",
      LN_uacurve4 = "DSTU",
      NID_uacurve4 = 1164,
      OBJ_uacurve4 = "OBJ_dstu4145le,2L,4L",
      SN_uacurve5 = "uacurve5",
      LN_uacurve5 = "DSTU",
      NID_uacurve5 = 1165,
      OBJ_uacurve5 = "OBJ_dstu4145le,2L,5L",
      SN_uacurve6 = "uacurve6",
      LN_uacurve6 = "DSTU",
      NID_uacurve6 = 1166,
      OBJ_uacurve6 = "OBJ_dstu4145le,2L,6L",
      SN_uacurve7 = "uacurve7",
      LN_uacurve7 = "DSTU",
      NID_uacurve7 = 1167,
      OBJ_uacurve7 = "OBJ_dstu4145le,2L,7L",
      SN_uacurve8 = "uacurve8",
      LN_uacurve8 = "DSTU",
      NID_uacurve8 = 1168,
      OBJ_uacurve8 = "OBJ_dstu4145le,2L,8L",
      SN_uacurve9 = "uacurve9",
      LN_uacurve9 = "DSTU",
      NID_uacurve9 = 1169,
      OBJ_uacurve9 = "OBJ_dstu4145le,2L,9L",
      SN_aes_128_siv = "AES-128-SIV",
      LN_aes_128_siv = "aes-128-siv",
      NID_aes_128_siv = 1198,
      SN_aes_192_siv = "AES-192-SIV",
      LN_aes_192_siv = "aes-192-siv",
      NID_aes_192_siv = 1199,
      SN_aes_256_siv = "AES-256-SIV",
      LN_aes_256_siv = "aes-256-siv",
      NID_aes_256_siv = 1200,
      SN_id_tc26_cipher_gostr3412_2015_magma_ctracpkm = "magma-ctr-acpkm",
      NID_id_tc26_cipher_gostr3412_2015_magma_ctracpkm = 1174,
      OBJ_id_tc26_cipher_gostr3412_2015_magma_ctracpkm = "OBJ_id_tc26_cipher_gostr3412_2015_magma,1L",
      SN_id_tc26_cipher_gostr3412_2015_magma_ctracpkm_omac = "magma-ctr-acpkm-omac",
      NID_id_tc26_cipher_gostr3412_2015_magma_ctracpkm_omac = 1175,
      OBJ_id_tc26_cipher_gostr3412_2015_magma_ctracpkm_omac = "OBJ_id_tc26_cipher_gostr3412_2015_magma,2L",
      SN_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm = "kuznyechik-ctr-acpkm",
      NID_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm = 1177,
      OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm = "OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik,1L",
      SN_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm_omac = "kuznyechik-ctr-acpkm-omac",
      NID_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm_omac = 1178,
      OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm_omac = "OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik,2L",
      SN_id_tc26_wrap_gostr3412_2015_magma_kexp15 = "magma-kexp15",
      NID_id_tc26_wrap_gostr3412_2015_magma_kexp15 = 1181,
      OBJ_id_tc26_wrap_gostr3412_2015_magma_kexp15 = "OBJ_id_tc26_wrap_gostr3412_2015_magma,1L",
      SN_id_tc26_wrap_gostr3412_2015_kuznyechik_kexp15 = "kuznyechik-kexp15",
      NID_id_tc26_wrap_gostr3412_2015_kuznyechik_kexp15 = 1183,
      OBJ_id_tc26_wrap_gostr3412_2015_kuznyechik_kexp15 = "OBJ_id_tc26_wrap_gostr3412_2015_kuznyechik,1L",
      SN_grasshopper_ecb = "kuznyechik-ecb",
      NID_grasshopper_ecb = 1012,
      SN_grasshopper_ctr = "kuznyechik-ctr",
      NID_grasshopper_ctr = 1013,
      SN_grasshopper_ofb = "kuznyechik-ofb",
      NID_grasshopper_ofb = 1014,
      SN_grasshopper_cbc = "kuznyechik-cbc",
      NID_grasshopper_cbc = 1015,
      SN_grasshopper_cfb = "kuznyechik-cfb",
      NID_grasshopper_cfb = 1016,
      SN_grasshopper_mac = "kuznyechik-mac",
      NID_grasshopper_mac = 1017,
      OBJ_NAME_TYPE_UNDEF = "0x00",
      OBJ_NAME_TYPE_MD_METH = "0x01",
      OBJ_NAME_TYPE_CIPHER_METH = "0x02",
      OBJ_NAME_TYPE_PKEY_METH = "0x03",
      OBJ_NAME_TYPE_COMP_METH = "0x04",
      OBJ_NAME_TYPE_MAC_METH = "0x05",
      OBJ_NAME_TYPE_KDF_METH = "0x06",
      OBJ_NAME_TYPE_NUM = "0x07",
      OBJ_NAME_ALIAS = "0x8000",
      OBJ_BSEARCH_VALUE_ON_NOMATCH = "0x01",
      OBJ_BSEARCH_FIRST_VALUE_ON_MATCH = "0x02",
      OBJ_R_OID_EXISTS = 102,
      OBJ_R_UNKNOWN_NID = 101,
      OBJ_R_UNKNOWN_OBJECT_NAME = 103,
      PEM_BUFSIZE = 1024,
      PEM_STRING_X509_OLD = "X509",
      PEM_STRING_X509 = "CERTIFICATE",
      PEM_STRING_X509_TRUSTED = "TRUSTED",
      PEM_STRING_X509_REQ_OLD = "NEW",
      PEM_STRING_X509_REQ = "CERTIFICATE",
      PEM_STRING_X509_CRL = "X509",
      PEM_STRING_EVP_PKEY = "ANY",
      PEM_STRING_PUBLIC = "PUBLIC",
      PEM_STRING_RSA = "RSA",
      PEM_STRING_RSA_PUBLIC = "RSA",
      PEM_STRING_DSA = "DSA",
      PEM_STRING_DSA_PUBLIC = "DSA",
      PEM_STRING_PKCS7 = "PKCS7",
      PEM_STRING_PKCS7_SIGNED = "PKCS",
      PEM_STRING_PKCS8 = "ENCRYPTED",
      PEM_STRING_PKCS8INF = "PRIVATE",
      PEM_STRING_DHPARAMS = "DH",
      PEM_STRING_DHXPARAMS = "X9.42",
      PEM_STRING_SSL_SESSION = "SSL",
      PEM_STRING_DSAPARAMS = "DSA",
      PEM_STRING_ECDSA_PUBLIC = "ECDSA",
      PEM_STRING_ECPARAMETERS = "EC",
      PEM_STRING_ECPRIVATEKEY = "EC",
      PEM_STRING_PARAMETERS = "PARAMETERS",
      PEM_STRING_CMS = "CMS",
      PEM_TYPE_ENCRYPTED = 10,
      PEM_TYPE_MIC_ONLY = 20,
      PEM_TYPE_MIC_CLEAR = 30,
      PEM_TYPE_CLEAR = 40,
      PEM_R_BAD_BASE64_DECODE = 100,
      PEM_R_BAD_DECRYPT = 101,
      PEM_R_BAD_END_LINE = 102,
      PEM_R_BAD_IV_CHARS = 103,
      PEM_R_BAD_MAGIC_NUMBER = 116,
      PEM_R_BAD_PASSWORD_READ = 104,
      PEM_R_BAD_VERSION_NUMBER = 117,
      PEM_R_BIO_WRITE_FAILURE = 118,
      PEM_R_CIPHER_IS_NULL = 127,
      PEM_R_ERROR_CONVERTING_PRIVATE_KEY = 115,
      PEM_R_EXPECTING_DSS_KEY_BLOB = 131,
      PEM_R_EXPECTING_PRIVATE_KEY_BLOB = 119,
      PEM_R_EXPECTING_PUBLIC_KEY_BLOB = 120,
      PEM_R_EXPECTING_RSA_KEY_BLOB = 132,
      PEM_R_HEADER_TOO_LONG = 128,
      PEM_R_INCONSISTENT_HEADER = 121,
      PEM_R_KEYBLOB_HEADER_PARSE_ERROR = 122,
      PEM_R_KEYBLOB_TOO_SHORT = 123,
      PEM_R_MISSING_DEK_IV = 129,
      PEM_R_NOT_DEK_INFO = 105,
      PEM_R_NOT_ENCRYPTED = 106,
      PEM_R_NOT_PROC_TYPE = 107,
      PEM_R_NO_START_LINE = 108,
      PEM_R_PROBLEMS_GETTING_PASSWORD = 109,
      PEM_R_PVK_DATA_TOO_SHORT = 124,
      PEM_R_PVK_TOO_SHORT = 125,
      PEM_R_READ_KEY = 111,
      PEM_R_SHORT_HEADER = 112,
      PEM_R_UNEXPECTED_DEK_IV = 130,
      PEM_R_UNSUPPORTED_CIPHER = 113,
      PEM_R_UNSUPPORTED_ENCRYPTION = 114,
      PEM_R_UNSUPPORTED_KEY_COMPONENTS = 126,
      PEM_R_UNSUPPORTED_PUBLIC_KEY_TYPE = 110,
      PKCS12_R_CANT_PACK_STRUCTURE = 100,
      PKCS12_R_CONTENT_TYPE_NOT_DATA = 121,
      PKCS12_R_DECODE_ERROR = 101,
      PKCS12_R_ENCODE_ERROR = 102,
      PKCS12_R_ENCRYPT_ERROR = 103,
      PKCS12_R_ERROR_SETTING_ENCRYPTED_DATA_TYPE = 120,
      PKCS12_R_INVALID_NULL_ARGUMENT = 104,
      PKCS12_R_INVALID_NULL_PKCS12_POINTER = 105,
      PKCS12_R_INVALID_TYPE = 112,
      PKCS12_R_IV_GEN_ERROR = 106,
      PKCS12_R_KEY_GEN_ERROR = 107,
      PKCS12_R_MAC_ABSENT = 108,
      PKCS12_R_MAC_GENERATION_ERROR = 109,
      PKCS12_R_MAC_SETUP_ERROR = 110,
      PKCS12_R_MAC_STRING_SET_ERROR = 111,
      PKCS12_R_MAC_VERIFY_FAILURE = 113,
      PKCS12_R_PARSE_ERROR = 114,
      PKCS12_R_PKCS12_CIPHERFINAL_ERROR = 116,
      PKCS12_R_UNKNOWN_DIGEST_ALGORITHM = 118,
      PKCS12_R_UNSUPPORTED_PKCS12_MODE = 119,
      PKCS7_R_CERTIFICATE_VERIFY_ERROR = 117,
      PKCS7_R_CIPHER_HAS_NO_OBJECT_IDENTIFIER = 144,
      PKCS7_R_CIPHER_NOT_INITIALIZED = 116,
      PKCS7_R_CONTENT_AND_DATA_PRESENT = 118,
      PKCS7_R_CTRL_ERROR = 152,
      PKCS7_R_DECRYPT_ERROR = 119,
      PKCS7_R_DIGEST_FAILURE = 101,
      PKCS7_R_ENCRYPTION_CTRL_FAILURE = 149,
      PKCS7_R_ENCRYPTION_NOT_SUPPORTED_FOR_THIS_KEY_TYPE = 150,
      PKCS7_R_ERROR_ADDING_RECIPIENT = 120,
      PKCS7_R_ERROR_SETTING_CIPHER = 121,
      PKCS7_R_INVALID_NULL_POINTER = 143,
      PKCS7_R_INVALID_SIGNED_DATA_TYPE = 155,
      PKCS7_R_NO_CONTENT = 122,
      PKCS7_R_NO_DEFAULT_DIGEST = 151,
      PKCS7_R_NO_MATCHING_DIGEST_TYPE_FOUND = 154,
      PKCS7_R_NO_RECIPIENT_MATCHES_CERTIFICATE = 115,
      PKCS7_R_NO_SIGNATURES_ON_DATA = 123,
      PKCS7_R_NO_SIGNERS = 142,
      PKCS7_R_OPERATION_NOT_SUPPORTED_ON_THIS_TYPE = 104,
      PKCS7_R_PKCS7_ADD_SIGNATURE_ERROR = 124,
      PKCS7_R_PKCS7_ADD_SIGNER_ERROR = 153,
      PKCS7_R_PKCS7_DATASIGN = 145,
      PKCS7_R_PRIVATE_KEY_DOES_NOT_MATCH_CERTIFICATE = 127,
      PKCS7_R_SIGNATURE_FAILURE = 105,
      PKCS7_R_SIGNER_CERTIFICATE_NOT_FOUND = 128,
      PKCS7_R_SIGNING_CTRL_FAILURE = 147,
      PKCS7_R_SIGNING_NOT_SUPPORTED_FOR_THIS_KEY_TYPE = 148,
      PKCS7_R_SMIME_TEXT_ERROR = 129,
      PKCS7_R_UNABLE_TO_FIND_CERTIFICATE = 106,
      PKCS7_R_UNABLE_TO_FIND_MEM_BIO = 107,
      PKCS7_R_UNABLE_TO_FIND_MESSAGE_DIGEST = 108,
      PKCS7_R_UNKNOWN_DIGEST_TYPE = 109,
      PKCS7_R_UNKNOWN_OPERATION = 110,
      PKCS7_R_UNSUPPORTED_CIPHER_TYPE = 111,
      PKCS7_R_UNSUPPORTED_CONTENT_TYPE = 112,
      PKCS7_R_WRONG_CONTENT_TYPE = 113,
      PKCS7_R_WRONG_PKCS7_TYPE = 114,
      SSL_MAX_MASTER_KEY_LENGTH = 48,
      SSL3_VERSION = "0x0300",
      TLS1_VERSION = "0x0301",
      TLS1_1_VERSION = "0x0302",
      TLS1_2_VERSION = "0x0303",
      TLS1_3_VERSION = "0x0304",
      DTLS1_VERSION = "0xFEFF",
      DTLS1_2_VERSION = "0xFEFD",
      DTLS1_BAD_VER = "0x0100",
      PROV_R_ADDITIONAL_INPUT_TOO_LONG = 184,
      PROV_R_ALGORITHM_MISMATCH = 173,
      PROV_R_ALREADY_INSTANTIATED = 185,
      PROV_R_BAD_DECRYPT = 100,
      PROV_R_BAD_ENCODING = 141,
      PROV_R_BAD_LENGTH = 142,
      PROV_R_BAD_TLS_CLIENT_VERSION = 161,
      PROV_R_BN_ERROR = 160,
      PROV_R_CIPHER_OPERATION_FAILED = 102,
      PROV_R_DERIVATION_FUNCTION_INIT_FAILED = 205,
      PROV_R_DIGEST_NOT_ALLOWED = 174,
      PROV_R_ENTROPY_SOURCE_STRENGTH_TOO_WEAK = 186,
      PROV_R_ERROR_INSTANTIATING_DRBG = 188,
      PROV_R_ERROR_RETRIEVING_ENTROPY = 189,
      PROV_R_ERROR_RETRIEVING_NONCE = 190,
      PROV_R_FAILED_DURING_DERIVATION = 164,
      PROV_R_FAILED_TO_CREATE_LOCK = 180,
      PROV_R_FAILED_TO_DECRYPT = 162,
      PROV_R_FAILED_TO_GENERATE_KEY = 121,
      PROV_R_FAILED_TO_GET_PARAMETER = 103,
      PROV_R_FAILED_TO_SET_PARAMETER = 104,
      PROV_R_FAILED_TO_SIGN = 175,
      PROV_R_FIPS_MODULE_CONDITIONAL_ERROR = 227,
      PROV_R_FIPS_MODULE_ENTERING_ERROR_STATE = 224,
      PROV_R_FIPS_MODULE_IN_ERROR_STATE = 225,
      PROV_R_GENERATE_ERROR = 191,
      PROV_R_ILLEGAL_OR_UNSUPPORTED_PADDING_MODE = 165,
      PROV_R_INDICATOR_INTEGRITY_FAILURE = 210,
      PROV_R_INSUFFICIENT_DRBG_STRENGTH = 181,
      PROV_R_INVALID_AAD = 108,
      PROV_R_INVALID_CONFIG_DATA = 211,
      PROV_R_INVALID_CONSTANT_LENGTH = 157,
      PROV_R_INVALID_CURVE = 176,
      PROV_R_INVALID_CUSTOM_LENGTH = 111,
      PROV_R_INVALID_DATA = 115,
      PROV_R_INVALID_DIGEST = 122,
      PROV_R_INVALID_DIGEST_LENGTH = 166,
      PROV_R_INVALID_DIGEST_SIZE = 218,
      PROV_R_INVALID_INPUT_LENGTH = 230,
      PROV_R_INVALID_ITERATION_COUNT = 123,
      PROV_R_INVALID_IV_LENGTH = 109,
      PROV_R_INVALID_KEY = 158,
      PROV_R_INVALID_KEY_LENGTH = 105,
      PROV_R_INVALID_MAC = 151,
      PROV_R_INVALID_MGF1_MD = 167,
      PROV_R_INVALID_MODE = 125,
      PROV_R_INVALID_OUTPUT_LENGTH = 217,
      PROV_R_INVALID_PADDING_MODE = 168,
      PROV_R_INVALID_PUBINFO = 198,
      PROV_R_INVALID_SALT_LENGTH = 112,
      PROV_R_INVALID_SEED_LENGTH = 154,
      PROV_R_INVALID_SIGNATURE_SIZE = 179,
      PROV_R_INVALID_STATE = 212,
      PROV_R_INVALID_TAG = 110,
      PROV_R_INVALID_TAG_LENGTH = 118,
      PROV_R_INVALID_UKM_LENGTH = 200,
      PROV_R_INVALID_X931_DIGEST = 170,
      PROV_R_IN_ERROR_STATE = 192,
      PROV_R_KEY_SETUP_FAILED = 101,
      PROV_R_KEY_SIZE_TOO_SMALL = 171,
      PROV_R_LENGTH_TOO_LARGE = 202,
      PROV_R_MISMATCHING_DOMAIN_PARAMETERS = 203,
      PROV_R_MISSING_CEK_ALG = 144,
      PROV_R_MISSING_CIPHER = 155,
      PROV_R_MISSING_CONFIG_DATA = 213,
      PROV_R_MISSING_CONSTANT = 156,
      PROV_R_MISSING_KEY = 128,
      PROV_R_MISSING_MAC = 150,
      PROV_R_MISSING_MESSAGE_DIGEST = 129,
      PROV_R_MISSING_OID = 209,
      PROV_R_MISSING_PASS = 130,
      PROV_R_MISSING_SALT = 131,
      PROV_R_MISSING_SECRET = 132,
      PROV_R_MISSING_SEED = 140,
      PROV_R_MISSING_SESSION_ID = 133,
      PROV_R_MISSING_TYPE = 134,
      PROV_R_MISSING_XCGHASH = 135,
      PROV_R_MODULE_INTEGRITY_FAILURE = 214,
      PROV_R_NOT_A_PRIVATE_KEY = 221,
      PROV_R_NOT_A_PUBLIC_KEY = 220,
      PROV_R_NOT_INSTANTIATED = 193,
      PROV_R_NOT_PARAMETERS = 226,
      PROV_R_NOT_SUPPORTED = 136,
      PROV_R_NOT_XOF_OR_INVALID_LENGTH = 113,
      PROV_R_NO_KEY_SET = 114,
      PROV_R_NO_PARAMETERS_SET = 177,
      PROV_R_OPERATION_NOT_SUPPORTED_FOR_THIS_KEYTYPE = 178,
      PROV_R_OUTPUT_BUFFER_TOO_SMALL = 106,
      PROV_R_PARENT_CANNOT_GENERATE_RANDOM_NUMBERS = 228,
      PROV_R_PARENT_CANNOT_SUPPLY_ENTROPY_SEED = 187,
      PROV_R_PARENT_LOCKING_NOT_ENABLED = 182,
      PROV_R_PARENT_STRENGTH_TOO_WEAK = 194,
      PROV_R_PATH_MUST_BE_ABSOLUTE = 219,
      PROV_R_PERSONALISATION_STRING_TOO_LONG = 195,
      PROV_R_PSS_SALTLEN_TOO_SMALL = 172,
      PROV_R_REQUEST_TOO_LARGE_FOR_DRBG = 196,
      PROV_R_REQUIRE_CTR_MODE_CIPHER = 206,
      PROV_R_RESEED_ERROR = 197,
      PROV_R_SEARCH_ONLY_SUPPORTED_FOR_DIRECTORIES = 222,
      PROV_R_SEED_SOURCES_MUST_NOT_HAVE_A_PARENT = 229,
      PROV_R_SELF_TEST_KAT_FAILURE = 215,
      PROV_R_SELF_TEST_POST_FAILURE = 216,
      PROV_R_TAG_NOT_NEEDED = 120,
      PROV_R_TAG_NOT_SET = 119,
      PROV_R_TOO_MANY_RECORDS = 126,
      PROV_R_UNABLE_TO_FIND_CIPHERS = 207,
      PROV_R_UNABLE_TO_GET_PARENT_STRENGTH = 199,
      PROV_R_UNABLE_TO_GET_PASSPHRASE = 159,
      PROV_R_UNABLE_TO_INITIALISE_CIPHERS = 208,
      PROV_R_UNABLE_TO_LOAD_SHA256 = 147,
      PROV_R_UNABLE_TO_LOCK_PARENT = 201,
      PROV_R_UNABLE_TO_RESEED = 204,
      PROV_R_UNSUPPORTED_CEK_ALG = 145,
      PROV_R_UNSUPPORTED_KEY_SIZE = 153,
      PROV_R_UNSUPPORTED_MAC_TYPE = 137,
      PROV_R_UNSUPPORTED_NUMBER_OF_ROUNDS = 152,
      PROV_R_URI_AUTHORITY_UNSUPPORTED = 223,
      PROV_R_VALUE_ERROR = 138,
      PROV_R_WRONG_FINAL_BLOCK_LENGTH = 107,
      PROV_R_WRONG_OUTPUT_BUFFER_SIZE = 139,
      PROV_R_XOF_DIGESTS_NOT_ALLOWED = 183,
      PROV_R_XTS_DATA_UNIT_IS_TOO_LARGE = 148,
      PROV_R_XTS_DUPLICATED_KEYS = 149,
      RAND_DRBG_STRENGTH = 256,
      RAND_R_ADDITIONAL_INPUT_TOO_LONG = 102,
      RAND_R_ALREADY_INSTANTIATED = 103,
      RAND_R_ARGUMENT_OUT_OF_RANGE = 105,
      RAND_R_CANNOT_OPEN_FILE = 121,
      RAND_R_DRBG_ALREADY_INITIALIZED = 129,
      RAND_R_DRBG_NOT_INITIALISED = 104,
      RAND_R_ENTROPY_INPUT_TOO_LONG = 106,
      RAND_R_ENTROPY_OUT_OF_RANGE = 124,
      RAND_R_ERROR_ENTROPY_POOL_WAS_IGNORED = 127,
      RAND_R_ERROR_INITIALISING_DRBG = 107,
      RAND_R_ERROR_INSTANTIATING_DRBG = 108,
      RAND_R_ERROR_RETRIEVING_ADDITIONAL_INPUT = 109,
      RAND_R_ERROR_RETRIEVING_ENTROPY = 110,
      RAND_R_ERROR_RETRIEVING_NONCE = 111,
      RAND_R_FAILED_TO_CREATE_LOCK = 126,
      RAND_R_FUNC_NOT_IMPLEMENTED = 101,
      RAND_R_FWRITE_ERROR = 123,
      RAND_R_GENERATE_ERROR = 112,
      RAND_R_INSUFFICIENT_DRBG_STRENGTH = 139,
      RAND_R_INTERNAL_ERROR = 113,
      RAND_R_IN_ERROR_STATE = 114,
      RAND_R_NOT_A_REGULAR_FILE = 122,
      RAND_R_NOT_INSTANTIATED = 115,
      RAND_R_NO_DRBG_IMPLEMENTATION_SELECTED = 128,
      RAND_R_PARENT_LOCKING_NOT_ENABLED = 130,
      RAND_R_PARENT_STRENGTH_TOO_WEAK = 131,
      RAND_R_PERSONALISATION_STRING_TOO_LONG = 116,
      RAND_R_PREDICTION_RESISTANCE_NOT_SUPPORTED = 133,
      RAND_R_PRNG_NOT_SEEDED = 100,
      RAND_R_RANDOM_POOL_OVERFLOW = 125,
      RAND_R_RANDOM_POOL_UNDERFLOW = 134,
      RAND_R_REQUEST_TOO_LARGE_FOR_DRBG = 117,
      RAND_R_RESEED_ERROR = 118,
      RAND_R_SELFTEST_FAILURE = 119,
      RAND_R_TOO_LITTLE_NONCE_REQUESTED = 135,
      RAND_R_TOO_MUCH_NONCE_REQUESTED = 136,
      RAND_R_UNABLE_TO_CREATE_DRBG = 143,
      RAND_R_UNABLE_TO_FETCH_DRBG = 144,
      RAND_R_UNABLE_TO_GET_PARENT_RESEED_PROP_COUNTER = 141,
      RAND_R_UNABLE_TO_GET_PARENT_STRENGTH = 138,
      RAND_R_UNABLE_TO_LOCK_PARENT = 140,
      RAND_R_UNSUPPORTED_DRBG_FLAGS = 132,
      RAND_R_UNSUPPORTED_DRBG_TYPE = 120,
      RSA_3 = "0x3L",
      RSA_F4 = "0x10001L",
      RSA_FLAG_TYPE_MASK = "0xF000",
      RSA_FLAG_TYPE_RSA = "0x0000",
      RSA_FLAG_TYPE_RSASSAPSS = "0x1000",
      RSA_FLAG_TYPE_RSAESOAEP = "0x2000",
      RSA_PSS_SALTLEN_DIGEST = -1,
      RSA_PSS_SALTLEN_AUTO = -2,
      RSA_PSS_SALTLEN_MAX = -3,
      RSA_PSS_SALTLEN_MAX_SIGN = -2,
      RSA_PKCS1_PADDING = 1,
      RSA_NO_PADDING = 3,
      RSA_PKCS1_OAEP_PADDING = 4,
      RSA_X931_PADDING = 5,
      RSA_PKCS1_PSS_PADDING = 6,
      RSA_PKCS1_WITH_TLS_PADDING = 7,
      RSA_PKCS1_PADDING_SIZE = 11,
      RSA_R_ALGORITHM_MISMATCH = 100,
      RSA_R_BAD_E_VALUE = 101,
      RSA_R_BAD_FIXED_HEADER_DECRYPT = 102,
      RSA_R_BAD_PAD_BYTE_COUNT = 103,
      RSA_R_BAD_SIGNATURE = 104,
      RSA_R_BLOCK_TYPE_IS_NOT_01 = 106,
      RSA_R_BLOCK_TYPE_IS_NOT_02 = 107,
      RSA_R_DATA_GREATER_THAN_MOD_LEN = 108,
      RSA_R_DATA_TOO_LARGE = 109,
      RSA_R_DATA_TOO_LARGE_FOR_KEY_SIZE = 110,
      RSA_R_DATA_TOO_LARGE_FOR_MODULUS = 132,
      RSA_R_DATA_TOO_SMALL = 111,
      RSA_R_DATA_TOO_SMALL_FOR_KEY_SIZE = 122,
      RSA_R_DIGEST_DOES_NOT_MATCH = 158,
      RSA_R_DIGEST_NOT_ALLOWED = 145,
      RSA_R_DIGEST_TOO_BIG_FOR_RSA_KEY = 112,
      RSA_R_DMP1_NOT_CONGRUENT_TO_D = 124,
      RSA_R_DMQ1_NOT_CONGRUENT_TO_D = 125,
      RSA_R_D_E_NOT_CONGRUENT_TO_1 = 123,
      RSA_R_FIRST_OCTET_INVALID = 133,
      RSA_R_ILLEGAL_OR_UNSUPPORTED_PADDING_MODE = 144,
      RSA_R_INVALID_DIGEST = 157,
      RSA_R_INVALID_DIGEST_LENGTH = 143,
      RSA_R_INVALID_HEADER = 137,
      RSA_R_INVALID_KEYPAIR = 171,
      RSA_R_INVALID_KEY_LENGTH = 173,
      RSA_R_INVALID_LABEL = 160,
      RSA_R_INVALID_LENGTH = 181,
      RSA_R_INVALID_MESSAGE_LENGTH = 131,
      RSA_R_INVALID_MGF1_MD = 156,
      RSA_R_INVALID_MODULUS = 174,
      RSA_R_INVALID_MULTI_PRIME_KEY = 167,
      RSA_R_INVALID_OAEP_PARAMETERS = 161,
      RSA_R_INVALID_PADDING = 138,
      RSA_R_INVALID_PADDING_MODE = 141,
      RSA_R_INVALID_PSS_PARAMETERS = 149,
      RSA_R_INVALID_PSS_SALTLEN = 146,
      RSA_R_INVALID_REQUEST = 175,
      RSA_R_INVALID_SALT_LENGTH = 150,
      RSA_R_INVALID_STRENGTH = 176,
      RSA_R_INVALID_TRAILER = 139,
      RSA_R_INVALID_X931_DIGEST = 142,
      RSA_R_IQMP_NOT_INVERSE_OF_Q = 126,
      RSA_R_KEY_PRIME_NUM_INVALID = 165,
      RSA_R_KEY_SIZE_TOO_SMALL = 120,
      RSA_R_LAST_OCTET_INVALID = 134,
      RSA_R_MGF1_DIGEST_NOT_ALLOWED = 152,
      RSA_R_MISSING_PRIVATE_KEY = 179,
      RSA_R_MODULUS_TOO_LARGE = 105,
      RSA_R_MP_COEFFICIENT_NOT_INVERSE_OF_R = 168,
      RSA_R_MP_EXPONENT_NOT_CONGRUENT_TO_D = 169,
      RSA_R_MP_R_NOT_PRIME = 170,
      RSA_R_NO_PUBLIC_EXPONENT = 140,
      RSA_R_NULL_BEFORE_BLOCK_MISSING = 113,
      RSA_R_N_DOES_NOT_EQUAL_PRODUCT_OF_PRIMES = 172,
      RSA_R_N_DOES_NOT_EQUAL_P_Q = 127,
      RSA_R_OAEP_DECODING_ERROR = 121,
      RSA_R_OPERATION_NOT_SUPPORTED_FOR_THIS_KEYTYPE = 148,
      RSA_R_PADDING_CHECK_FAILED = 114,
      RSA_R_PAIRWISE_TEST_FAILURE = 177,
      RSA_R_PKCS_DECODING_ERROR = 159,
      RSA_R_PSS_SALTLEN_TOO_SMALL = 164,
      RSA_R_PUB_EXPONENT_OUT_OF_RANGE = 178,
      RSA_R_P_NOT_PRIME = 128,
      RSA_R_Q_NOT_PRIME = 129,
      RSA_R_RANDOMNESS_SOURCE_STRENGTH_INSUFFICIENT = 180,
      RSA_R_RSA_OPERATIONS_NOT_SUPPORTED = 130,
      RSA_R_SLEN_CHECK_FAILED = 136,
      RSA_R_SLEN_RECOVERY_FAILED = 135,
      RSA_R_SSLV3_ROLLBACK_ATTACK = 115,
      RSA_R_THE_ASN1_OBJECT_IDENTIFIER_IS_NOT_KNOWN_FOR_THIS_MD = 116,
      RSA_R_UNKNOWN_ALGORITHM_TYPE = 117,
      RSA_R_UNKNOWN_DIGEST = 166,
      RSA_R_UNKNOWN_MASK_DIGEST = 151,
      RSA_R_UNKNOWN_PADDING_TYPE = 118,
      RSA_R_UNSUPPORTED_ENCRYPTION_TYPE = 162,
      RSA_R_UNSUPPORTED_LABEL_SOURCE = 163,
      RSA_R_UNSUPPORTED_MASK_ALGORITHM = 153,
      RSA_R_UNSUPPORTED_MASK_PARAMETER = 154,
      RSA_R_UNSUPPORTED_SIGNATURE_TYPE = 155,
      RSA_R_VALUE_MISSING = 147,
      RSA_R_WRONG_SIGNATURE_LENGTH = 119,
      OSSL_SELF_TEST_PHASE_NONE = "None",
      OSSL_SELF_TEST_PHASE_START = "Start",
      OSSL_SELF_TEST_PHASE_CORRUPT = "Corrupt",
      OSSL_SELF_TEST_PHASE_PASS = "Pass",
      OSSL_SELF_TEST_PHASE_FAIL = "Fail",
      OSSL_SELF_TEST_TYPE_NONE = "None",
      OSSL_SELF_TEST_TYPE_MODULE_INTEGRITY = "Module_Integrity",
      OSSL_SELF_TEST_TYPE_INSTALL_INTEGRITY = "Install_Integrity",
      OSSL_SELF_TEST_TYPE_CRNG = "Continuous_RNG_Test",
      OSSL_SELF_TEST_TYPE_PCT = "Conditional_PCT",
      OSSL_SELF_TEST_TYPE_KAT_CIPHER = "KAT_Cipher",
      OSSL_SELF_TEST_TYPE_KAT_ASYM_CIPHER = "KAT_AsymmetricCipher",
      OSSL_SELF_TEST_TYPE_KAT_DIGEST = "KAT_Digest",
      OSSL_SELF_TEST_TYPE_KAT_SIGNATURE = "KAT_Signature",
      OSSL_SELF_TEST_TYPE_PCT_SIGNATURE = "PCT_Signature",
      OSSL_SELF_TEST_TYPE_KAT_KDF = "KAT_KDF",
      OSSL_SELF_TEST_TYPE_KAT_KA = "KAT_KA",
      OSSL_SELF_TEST_TYPE_DRBG = "DRBG",
      OSSL_SELF_TEST_DESC_NONE = "None",
      OSSL_SELF_TEST_DESC_INTEGRITY_HMAC = "HMAC",
      OSSL_SELF_TEST_DESC_PCT_RSA_PKCS1 = "RSA",
      OSSL_SELF_TEST_DESC_PCT_ECDSA = "ECDSA",
      OSSL_SELF_TEST_DESC_PCT_DSA = "DSA",
      OSSL_SELF_TEST_DESC_CIPHER_AES_GCM = "AES_GCM",
      OSSL_SELF_TEST_DESC_CIPHER_AES_ECB = "AES_ECB_Decrypt",
      OSSL_SELF_TEST_DESC_CIPHER_TDES = "TDES",
      OSSL_SELF_TEST_DESC_ASYM_RSA_ENC = "RSA_Encrypt",
      OSSL_SELF_TEST_DESC_ASYM_RSA_DEC = "RSA_Decrypt",
      OSSL_SELF_TEST_DESC_MD_SHA1 = "SHA1",
      OSSL_SELF_TEST_DESC_MD_SHA2 = "SHA2",
      OSSL_SELF_TEST_DESC_MD_SHA3 = "SHA3",
      OSSL_SELF_TEST_DESC_SIGN_DSA = "DSA",
      OSSL_SELF_TEST_DESC_SIGN_RSA = "RSA",
      OSSL_SELF_TEST_DESC_SIGN_ECDSA = "ECDSA",
      OSSL_SELF_TEST_DESC_DRBG_CTR = "CTR",
      OSSL_SELF_TEST_DESC_DRBG_HASH = "HASH",
      OSSL_SELF_TEST_DESC_DRBG_HMAC = "HMAC",
      OSSL_SELF_TEST_DESC_KA_DH = "DH",
      OSSL_SELF_TEST_DESC_KA_ECDH = "ECDH",
      OSSL_SELF_TEST_DESC_KDF_HKDF = "HKDF",
      OSSL_SELF_TEST_DESC_KDF_SSKDF = "SSKDF",
      OSSL_SELF_TEST_DESC_KDF_X963KDF = "X963KDF",
      OSSL_SELF_TEST_DESC_KDF_X942KDF = "X942KDF",
      OSSL_SELF_TEST_DESC_KDF_PBKDF2 = "PBKDF2",
      OSSL_SELF_TEST_DESC_KDF_SSHKDF = "SSHKDF",
      OSSL_SELF_TEST_DESC_KDF_TLS12_PRF = "TLS12_PRF",
      OSSL_SELF_TEST_DESC_KDF_KBKDF = "KBKDF",
      OSSL_SELF_TEST_DESC_KDF_TLS13_EXTRACT = "TLS13_KDF_EXTRACT",
      OSSL_SELF_TEST_DESC_KDF_TLS13_EXPAND = "TLS13_KDF_EXPAND",
      OSSL_SELF_TEST_DESC_RNG = "RNG",
      SHA_DIGEST_LENGTH = 20,
      SHA224_DIGEST_LENGTH = 28,
      SHA256_DIGEST_LENGTH = 32,
      SHA384_DIGEST_LENGTH = 48,
      SHA512_DIGEST_LENGTH = 64,
      SRTP_AES128_CM_SHA1_80 = "0x0001",
      SRTP_AES128_CM_SHA1_32 = "0x0002",
      SRTP_AES128_F8_SHA1_80 = "0x0003",
      SRTP_AES128_F8_SHA1_32 = "0x0004",
      SRTP_NULL_SHA1_80 = "0x0005",
      SRTP_NULL_SHA1_32 = "0x0006",
      SRTP_AEAD_AES_128_GCM = "0x0007",
      SRTP_AEAD_AES_256_GCM = "0x0008",
      SSL2_VERSION = "0x0002",
      SSL2_MT_CLIENT_HELLO = 1,
      SSL3_CK_SCSV = "0x030000FF",
      SSL3_CK_FALLBACK_SCSV = "0x03005600",
      SSL3_CK_RSA_NULL_MD5 = "0x03000001",
      SSL3_CK_RSA_NULL_SHA = "0x03000002",
      SSL3_CK_RSA_RC4_40_MD5 = "0x03000003",
      SSL3_CK_RSA_RC4_128_MD5 = "0x03000004",
      SSL3_CK_RSA_RC4_128_SHA = "0x03000005",
      SSL3_CK_RSA_RC2_40_MD5 = "0x03000006",
      SSL3_CK_RSA_IDEA_128_SHA = "0x03000007",
      SSL3_CK_RSA_DES_40_CBC_SHA = "0x03000008",
      SSL3_CK_RSA_DES_64_CBC_SHA = "0x03000009",
      SSL3_CK_RSA_DES_192_CBC3_SHA = "0x0300000A",
      SSL3_CK_DH_DSS_DES_40_CBC_SHA = "0x0300000B",
      SSL3_CK_DH_DSS_DES_64_CBC_SHA = "0x0300000C",
      SSL3_CK_DH_DSS_DES_192_CBC3_SHA = "0x0300000D",
      SSL3_CK_DH_RSA_DES_40_CBC_SHA = "0x0300000E",
      SSL3_CK_DH_RSA_DES_64_CBC_SHA = "0x0300000F",
      SSL3_CK_DH_RSA_DES_192_CBC3_SHA = "0x03000010",
      SSL3_CK_DHE_DSS_DES_40_CBC_SHA = "0x03000011",
      SSL3_CK_EDH_DSS_DES_40_CBC_SHA = "0x03000011",
      SSL3_CK_DHE_DSS_DES_64_CBC_SHA = "0x03000012",
      SSL3_CK_EDH_DSS_DES_64_CBC_SHA = "0x03000012",
      SSL3_CK_DHE_DSS_DES_192_CBC3_SHA = "0x03000013",
      SSL3_CK_EDH_DSS_DES_192_CBC3_SHA = "0x03000013",
      SSL3_CK_DHE_RSA_DES_40_CBC_SHA = "0x03000014",
      SSL3_CK_EDH_RSA_DES_40_CBC_SHA = "0x03000014",
      SSL3_CK_DHE_RSA_DES_64_CBC_SHA = "0x03000015",
      SSL3_CK_EDH_RSA_DES_64_CBC_SHA = "0x03000015",
      SSL3_CK_DHE_RSA_DES_192_CBC3_SHA = "0x03000016",
      SSL3_CK_EDH_RSA_DES_192_CBC3_SHA = "0x03000016",
      SSL3_CK_ADH_RC4_40_MD5 = "0x03000017",
      SSL3_CK_ADH_RC4_128_MD5 = "0x03000018",
      SSL3_CK_ADH_DES_40_CBC_SHA = "0x03000019",
      SSL3_CK_ADH_DES_64_CBC_SHA = "0x0300001A",
      SSL3_CK_ADH_DES_192_CBC_SHA = "0x0300001B",
      SSL3_RFC_RSA_NULL_MD5 = "TLS_RSA_WITH_NULL_MD5",
      SSL3_RFC_RSA_NULL_SHA = "TLS_RSA_WITH_NULL_SHA",
      SSL3_RFC_RSA_DES_192_CBC3_SHA = "TLS_RSA_WITH_3DES_EDE_CBC_SHA",
      SSL3_RFC_DHE_DSS_DES_192_CBC3_SHA = "TLS_DHE_DSS_WITH_3DES_EDE_CBC_SHA",
      SSL3_RFC_DHE_RSA_DES_192_CBC3_SHA = "TLS_DHE_RSA_WITH_3DES_EDE_CBC_SHA",
      SSL3_RFC_ADH_DES_192_CBC_SHA = "TLS_DH_anon_WITH_3DES_EDE_CBC_SHA",
      SSL3_RFC_RSA_IDEA_128_SHA = "TLS_RSA_WITH_IDEA_CBC_SHA",
      SSL3_RFC_RSA_RC4_128_MD5 = "TLS_RSA_WITH_RC4_128_MD5",
      SSL3_RFC_RSA_RC4_128_SHA = "TLS_RSA_WITH_RC4_128_SHA",
      SSL3_RFC_ADH_RC4_128_MD5 = "TLS_DH_anon_WITH_RC4_128_MD5",
      SSL3_TXT_RSA_NULL_MD5 = "NULL-MD5",
      SSL3_TXT_RSA_NULL_SHA = "NULL-SHA",
      SSL3_TXT_RSA_RC4_40_MD5 = "EXP-RC4-MD5",
      SSL3_TXT_RSA_RC4_128_MD5 = "RC4-MD5",
      SSL3_TXT_RSA_RC4_128_SHA = "RC4-SHA",
      SSL3_TXT_RSA_RC2_40_MD5 = "EXP-RC2-CBC-MD5",
      SSL3_TXT_RSA_IDEA_128_SHA = "IDEA-CBC-SHA",
      SSL3_TXT_RSA_DES_40_CBC_SHA = "EXP-DES-CBC-SHA",
      SSL3_TXT_RSA_DES_64_CBC_SHA = "DES-CBC-SHA",
      SSL3_TXT_RSA_DES_192_CBC3_SHA = "DES-CBC3-SHA",
      SSL3_TXT_DH_DSS_DES_40_CBC_SHA = "EXP-DH-DSS-DES-CBC-SHA",
      SSL3_TXT_DH_DSS_DES_64_CBC_SHA = "DH-DSS-DES-CBC-SHA",
      SSL3_TXT_DH_DSS_DES_192_CBC3_SHA = "DH-DSS-DES-CBC3-SHA",
      SSL3_TXT_DH_RSA_DES_40_CBC_SHA = "EXP-DH-RSA-DES-CBC-SHA",
      SSL3_TXT_DH_RSA_DES_64_CBC_SHA = "DH-RSA-DES-CBC-SHA",
      SSL3_TXT_DH_RSA_DES_192_CBC3_SHA = "DH-RSA-DES-CBC3-SHA",
      SSL3_TXT_DHE_DSS_DES_40_CBC_SHA = "EXP-DHE-DSS-DES-CBC-SHA",
      SSL3_TXT_DHE_DSS_DES_64_CBC_SHA = "DHE-DSS-DES-CBC-SHA",
      SSL3_TXT_DHE_DSS_DES_192_CBC3_SHA = "DHE-DSS-DES-CBC3-SHA",
      SSL3_TXT_DHE_RSA_DES_40_CBC_SHA = "EXP-DHE-RSA-DES-CBC-SHA",
      SSL3_TXT_DHE_RSA_DES_64_CBC_SHA = "DHE-RSA-DES-CBC-SHA",
      SSL3_TXT_DHE_RSA_DES_192_CBC3_SHA = "DHE-RSA-DES-CBC3-SHA",
      SSL3_TXT_EDH_DSS_DES_40_CBC_SHA = "EXP-EDH-DSS-DES-CBC-SHA",
      SSL3_TXT_EDH_DSS_DES_64_CBC_SHA = "EDH-DSS-DES-CBC-SHA",
      SSL3_TXT_EDH_DSS_DES_192_CBC3_SHA = "EDH-DSS-DES-CBC3-SHA",
      SSL3_TXT_EDH_RSA_DES_40_CBC_SHA = "EXP-EDH-RSA-DES-CBC-SHA",
      SSL3_TXT_EDH_RSA_DES_64_CBC_SHA = "EDH-RSA-DES-CBC-SHA",
      SSL3_TXT_EDH_RSA_DES_192_CBC3_SHA = "EDH-RSA-DES-CBC3-SHA",
      SSL3_TXT_ADH_RC4_40_MD5 = "EXP-ADH-RC4-MD5",
      SSL3_TXT_ADH_RC4_128_MD5 = "ADH-RC4-MD5",
      SSL3_TXT_ADH_DES_40_CBC_SHA = "EXP-ADH-DES-CBC-SHA",
      SSL3_TXT_ADH_DES_64_CBC_SHA = "ADH-DES-CBC-SHA",
      SSL3_TXT_ADH_DES_192_CBC_SHA = "ADH-DES-CBC3-SHA",
      SSL3_SSL_SESSION_ID_LENGTH = 32,
      SSL3_MAX_SSL_SESSION_ID_LENGTH = 32,
      SSL3_MASTER_SECRET_SIZE = 48,
      SSL3_RANDOM_SIZE = 32,
      SSL3_SESSION_ID_SIZE = 32,
      SSL3_RT_HEADER_LENGTH = 5,
      SSL3_HM_HEADER_LENGTH = 4,
      SSL3_RT_MAX_MD_SIZE = 64,
      SSL_RT_MAX_CIPHER_BLOCK_SIZE = 16,
      SSL3_RT_MAX_PLAIN_LENGTH = 16384,
      SSL3_RT_MAX_COMPRESSED_OVERHEAD = 1024,
      SSL3_RT_MAX_TLS13_ENCRYPTED_OVERHEAD = 256,
      SSL3_VERSION_MAJOR = "0x03",
      SSL3_VERSION_MINOR = "0x00",
      SSL3_RT_CHANGE_CIPHER_SPEC = 20,
      SSL3_RT_ALERT = 21,
      SSL3_RT_HANDSHAKE = 22,
      SSL3_RT_APPLICATION_DATA = 23,
      TLS1_RT_CRYPTO = "0x1000",
      TLS1_RT_CRYPTO_READ = "0x0000",
      TLS1_RT_CRYPTO_WRITE = "0x0100",
      SSL3_RT_HEADER = "0x100",
      SSL3_RT_INNER_CONTENT_TYPE = "0x101",
      SSL3_AL_WARNING = 1,
      SSL3_AL_FATAL = 2,
      SSL3_AD_CLOSE_NOTIFY = "0",
      SSL3_AD_NO_CERTIFICATE = 41,
      SSL3_AD_BAD_CERTIFICATE = 42,
      SSL3_AD_UNSUPPORTED_CERTIFICATE = 43,
      SSL3_AD_CERTIFICATE_REVOKED = 44,
      SSL3_AD_CERTIFICATE_EXPIRED = 45,
      SSL3_AD_CERTIFICATE_UNKNOWN = 46,
      TLS1_HB_REQUEST = 1,
      TLS1_HB_RESPONSE = 2,
      SSL3_CT_RSA_SIGN = 1,
      SSL3_CT_DSS_SIGN = 2,
      SSL3_CT_RSA_FIXED_DH = 3,
      SSL3_CT_DSS_FIXED_DH = 4,
      SSL3_CT_RSA_EPHEMERAL_DH = 5,
      SSL3_CT_DSS_EPHEMERAL_DH = 6,
      SSL3_CT_FORTEZZA_DMS = 20,
      SSL3_CT_NUMBER = 12,
      SSL3_FLAGS_NO_RENEGOTIATE_CIPHERS = "0x0001",
      TLS1_FLAGS_TLS_PADDING_BUG = "0x0",
      TLS1_FLAGS_SKIP_CERT_VERIFY = "0x0010",
      TLS1_FLAGS_ENCRYPT_THEN_MAC_READ = "0x0100",
      TLS1_FLAGS_ENCRYPT_THEN_MAC = "0x0100",
      TLS1_FLAGS_RECEIVED_EXTMS = "0x0200",
      TLS1_FLAGS_ENCRYPT_THEN_MAC_WRITE = "0x0400",
      TLS1_FLAGS_STATELESS = "0x0800",
      TLS1_FLAGS_REQUIRED_EXTMS = "0x1000",
      SSL3_MT_HELLO_REQUEST = "0",
      SSL3_MT_CLIENT_HELLO = 1,
      SSL3_MT_SERVER_HELLO = 2,
      SSL3_MT_NEWSESSION_TICKET = 4,
      SSL3_MT_END_OF_EARLY_DATA = 5,
      SSL3_MT_ENCRYPTED_EXTENSIONS = 8,
      SSL3_MT_CERTIFICATE = 11,
      SSL3_MT_SERVER_KEY_EXCHANGE = 12,
      SSL3_MT_CERTIFICATE_REQUEST = 13,
      SSL3_MT_SERVER_DONE = 14,
      SSL3_MT_CERTIFICATE_VERIFY = 15,
      SSL3_MT_CLIENT_KEY_EXCHANGE = 16,
      SSL3_MT_FINISHED = 20,
      SSL3_MT_CERTIFICATE_URL = 21,
      SSL3_MT_CERTIFICATE_STATUS = 22,
      SSL3_MT_SUPPLEMENTAL_DATA = 23,
      SSL3_MT_KEY_UPDATE = 24,
      SSL3_MT_MESSAGE_HASH = 254,
      DTLS1_MT_HELLO_VERIFY_REQUEST = 3,
      SSL3_MT_CHANGE_CIPHER_SPEC = "0x0101",
      SSL3_MT_CCS = 1,
      SSL3_CC_READ = "0x001",
      SSL3_CC_WRITE = "0x002",
      SSL3_CC_CLIENT = "0x010",
      SSL3_CC_SERVER = "0x020",
      SSL3_CC_EARLY = "0x040",
      SSL3_CC_HANDSHAKE = "0x080",
      SSL3_CC_APPLICATION = "0x100",
      SSL_R_APPLICATION_DATA_AFTER_CLOSE_NOTIFY = 291,
      SSL_R_APP_DATA_IN_HANDSHAKE = 100,
      SSL_R_ATTEMPT_TO_REUSE_SESSION_IN_DIFFERENT_CONTEXT = 272,
      SSL_R_AT_LEAST_TLS_1_2_NEEDED_IN_SUITEB_MODE = 158,
      SSL_R_BAD_CHANGE_CIPHER_SPEC = 103,
      SSL_R_BAD_CIPHER = 186,
      SSL_R_BAD_DATA = 390,
      SSL_R_BAD_DATA_RETURNED_BY_CALLBACK = 106,
      SSL_R_BAD_DECOMPRESSION = 107,
      SSL_R_BAD_DH_VALUE = 102,
      SSL_R_BAD_DIGEST_LENGTH = 111,
      SSL_R_BAD_EARLY_DATA = 233,
      SSL_R_BAD_ECC_CERT = 304,
      SSL_R_BAD_ECPOINT = 306,
      SSL_R_BAD_EXTENSION = 110,
      SSL_R_BAD_HANDSHAKE_LENGTH = 332,
      SSL_R_BAD_HANDSHAKE_STATE = 236,
      SSL_R_BAD_HELLO_REQUEST = 105,
      SSL_R_BAD_HRR_VERSION = 263,
      SSL_R_BAD_KEY_SHARE = 108,
      SSL_R_BAD_KEY_UPDATE = 122,
      SSL_R_BAD_LEGACY_VERSION = 292,
      SSL_R_BAD_LENGTH = 271,
      SSL_R_BAD_PACKET = 240,
      SSL_R_BAD_PACKET_LENGTH = 115,
      SSL_R_BAD_PROTOCOL_VERSION_NUMBER = 116,
      SSL_R_BAD_PSK = 219,
      SSL_R_BAD_PSK_IDENTITY = 114,
      SSL_R_BAD_RECORD_TYPE = 443,
      SSL_R_BAD_RSA_ENCRYPT = 119,
      SSL_R_BAD_SIGNATURE = 123,
      SSL_R_BAD_SRP_A_LENGTH = 347,
      SSL_R_BAD_SRP_PARAMETERS = 371,
      SSL_R_BAD_SRTP_MKI_VALUE = 352,
      SSL_R_BAD_SRTP_PROTECTION_PROFILE_LIST = 353,
      SSL_R_BAD_SSL_FILETYPE = 124,
      SSL_R_BAD_VALUE = 384,
      SSL_R_BAD_WRITE_RETRY = 127,
      SSL_R_BINDER_DOES_NOT_VERIFY = 253,
      SSL_R_BIO_NOT_SET = 128,
      SSL_R_BLOCK_CIPHER_PAD_IS_WRONG = 129,
      SSL_R_BN_LIB = 130,
      SSL_R_CALLBACK_FAILED = 234,
      SSL_R_CANNOT_CHANGE_CIPHER = 109,
      SSL_R_CANNOT_GET_GROUP_NAME = 299,
      SSL_R_CA_DN_LENGTH_MISMATCH = 131,
      SSL_R_CA_KEY_TOO_SMALL = 397,
      SSL_R_CA_MD_TOO_WEAK = 398,
      SSL_R_CCS_RECEIVED_EARLY = 133,
      SSL_R_CERTIFICATE_VERIFY_FAILED = 134,
      SSL_R_CERT_CB_ERROR = 377,
      SSL_R_CERT_LENGTH_MISMATCH = 135,
      SSL_R_CIPHERSUITE_DIGEST_HAS_CHANGED = 218,
      SSL_R_CIPHER_CODE_WRONG_LENGTH = 137,
      SSL_R_CLIENTHELLO_TLSEXT = 226,
      SSL_R_COMPRESSED_LENGTH_TOO_LONG = 140,
      SSL_R_COMPRESSION_DISABLED = 343,
      SSL_R_COMPRESSION_FAILURE = 141,
      SSL_R_COMPRESSION_ID_NOT_WITHIN_PRIVATE_RANGE = 307,
      SSL_R_COMPRESSION_LIBRARY_ERROR = 142,
      SSL_R_CONNECTION_TYPE_NOT_SET = 144,
      SSL_R_CONTEXT_NOT_DANE_ENABLED = 167,
      SSL_R_COOKIE_GEN_CALLBACK_FAILURE = 400,
      SSL_R_COOKIE_MISMATCH = 308,
      SSL_R_COPY_PARAMETERS_FAILED = 296,
      SSL_R_CUSTOM_EXT_HANDLER_ALREADY_INSTALLED = 206,
      SSL_R_DANE_ALREADY_ENABLED = 172,
      SSL_R_DANE_CANNOT_OVERRIDE_MTYPE_FULL = 173,
      SSL_R_DANE_NOT_ENABLED = 175,
      SSL_R_DANE_TLSA_BAD_CERTIFICATE = 180,
      SSL_R_DANE_TLSA_BAD_CERTIFICATE_USAGE = 184,
      SSL_R_DANE_TLSA_BAD_DATA_LENGTH = 189,
      SSL_R_DANE_TLSA_BAD_DIGEST_LENGTH = 192,
      SSL_R_DANE_TLSA_BAD_MATCHING_TYPE = 200,
      SSL_R_DANE_TLSA_BAD_PUBLIC_KEY = 201,
      SSL_R_DANE_TLSA_BAD_SELECTOR = 202,
      SSL_R_DANE_TLSA_NULL_DATA = 203,
      SSL_R_DATA_BETWEEN_CCS_AND_FINISHED = 145,
      SSL_R_DATA_LENGTH_TOO_LONG = 146,
      SSL_R_DECRYPTION_FAILED = 147,
      SSL_R_DECRYPTION_FAILED_OR_BAD_RECORD_MAC = 281,
      SSL_R_DH_KEY_TOO_SMALL = 394,
      SSL_R_DH_PUBLIC_VALUE_LENGTH_IS_WRONG = 148,
      SSL_R_DIGEST_CHECK_FAILED = 149,
      SSL_R_DTLS_MESSAGE_TOO_BIG = 334,
      SSL_R_DUPLICATE_COMPRESSION_ID = 309,
      SSL_R_ECC_CERT_NOT_FOR_SIGNING = 318,
      SSL_R_ECDH_REQUIRED_FOR_SUITEB_MODE = 374,
      SSL_R_EE_KEY_TOO_SMALL = 399,
      SSL_R_EMPTY_SRTP_PROTECTION_PROFILE_LIST = 354,
      SSL_R_ENCRYPTED_LENGTH_TOO_LONG = 150,
      SSL_R_ERROR_IN_RECEIVED_CIPHER_LIST = 151,
      SSL_R_ERROR_SETTING_TLSA_BASE_DOMAIN = 204,
      SSL_R_EXCEEDS_MAX_FRAGMENT_SIZE = 194,
      SSL_R_EXCESSIVE_MESSAGE_SIZE = 152,
      SSL_R_EXTENSION_NOT_RECEIVED = 279,
      SSL_R_EXTRA_DATA_IN_MESSAGE = 153,
      SSL_R_EXT_LENGTH_MISMATCH = 163,
      SSL_R_FAILED_TO_INIT_ASYNC = 405,
      SSL_R_FRAGMENTED_CLIENT_HELLO = 401,
      SSL_R_GOT_A_FIN_BEFORE_A_CCS = 154,
      SSL_R_HTTPS_PROXY_REQUEST = 155,
      SSL_R_HTTP_REQUEST = 156,
      SSL_R_ILLEGAL_POINT_COMPRESSION = 162,
      SSL_R_ILLEGAL_SUITEB_DIGEST = 380,
      SSL_R_INAPPROPRIATE_FALLBACK = 373,
      SSL_R_INCONSISTENT_COMPRESSION = 340,
      SSL_R_INCONSISTENT_EARLY_DATA_ALPN = 222,
      SSL_R_INCONSISTENT_EARLY_DATA_SNI = 231,
      SSL_R_INCONSISTENT_EXTMS = 104,
      SSL_R_INSUFFICIENT_SECURITY = 241,
      SSL_R_INVALID_ALERT = 205,
      SSL_R_INVALID_CCS_MESSAGE = 260,
      SSL_R_INVALID_CERTIFICATE_OR_ALG = 238,
      SSL_R_INVALID_COMMAND = 280,
      SSL_R_INVALID_COMPRESSION_ALGORITHM = 341,
      SSL_R_INVALID_CONFIG = 283,
      SSL_R_INVALID_CONFIGURATION_NAME = 113,
      SSL_R_INVALID_CONTEXT = 282,
      SSL_R_INVALID_CT_VALIDATION_TYPE = 212,
      SSL_R_INVALID_KEY_UPDATE_TYPE = 120,
      SSL_R_INVALID_MAX_EARLY_DATA = 174,
      SSL_R_INVALID_NULL_CMD_NAME = 385,
      SSL_R_INVALID_SEQUENCE_NUMBER = 402,
      SSL_R_INVALID_SERVERINFO_DATA = 388,
      SSL_R_INVALID_SESSION_ID = 999,
      SSL_R_INVALID_SRP_USERNAME = 357,
      SSL_R_INVALID_STATUS_RESPONSE = 328,
      SSL_R_INVALID_TICKET_KEYS_LENGTH = 325,
      SSL_R_LENGTH_MISMATCH = 159,
      SSL_R_LENGTH_TOO_LONG = 404,
      SSL_R_LENGTH_TOO_SHORT = 160,
      SSL_R_LIBRARY_BUG = 274,
      SSL_R_LIBRARY_HAS_NO_CIPHERS = 161,
      SSL_R_MISSING_DSA_SIGNING_CERT = 165,
      SSL_R_MISSING_ECDSA_SIGNING_CERT = 381,
      SSL_R_MISSING_FATAL = 256,
      SSL_R_MISSING_PARAMETERS = 290,
      SSL_R_MISSING_PSK_KEX_MODES_EXTENSION = 310,
      SSL_R_MISSING_RSA_CERTIFICATE = 168,
      SSL_R_MISSING_RSA_ENCRYPTING_CERT = 169,
      SSL_R_MISSING_RSA_SIGNING_CERT = 170,
      SSL_R_MISSING_SIGALGS_EXTENSION = 112,
      SSL_R_MISSING_SIGNING_CERT = 221,
      SSL_R_MISSING_SRP_PARAM = 358,
      SSL_R_MISSING_SUPPORTED_GROUPS_EXTENSION = 209,
      SSL_R_MISSING_TMP_DH_KEY = 171,
      SSL_R_MISSING_TMP_ECDH_KEY = 311,
      SSL_R_MIXED_HANDSHAKE_AND_NON_HANDSHAKE_DATA = 293,
      SSL_R_NOT_ON_RECORD_BOUNDARY = 182,
      SSL_R_NOT_REPLACING_CERTIFICATE = 289,
      SSL_R_NOT_SERVER = 284,
      SSL_R_NO_APPLICATION_PROTOCOL = 235,
      SSL_R_NO_CERTIFICATES_RETURNED = 176,
      SSL_R_NO_CERTIFICATE_ASSIGNED = 177,
      SSL_R_NO_CERTIFICATE_SET = 179,
      SSL_R_NO_CHANGE_FOLLOWING_HRR = 214,
      SSL_R_NO_CIPHERS_AVAILABLE = 181,
      SSL_R_NO_CIPHERS_SPECIFIED = 183,
      SSL_R_NO_CIPHER_MATCH = 185,
      SSL_R_NO_CLIENT_CERT_METHOD = 331,
      SSL_R_NO_COMPRESSION_SPECIFIED = 187,
      SSL_R_NO_COOKIE_CALLBACK_SET = 287,
      SSL_R_NO_GOST_CERTIFICATE_SENT_BY_PEER = 330,
      SSL_R_NO_METHOD_SPECIFIED = 188,
      SSL_R_NO_PEM_EXTENSIONS = 389,
      SSL_R_NO_PRIVATE_KEY_ASSIGNED = 190,
      SSL_R_NO_PROTOCOLS_AVAILABLE = 191,
      SSL_R_NO_RENEGOTIATION = 339,
      SSL_R_NO_REQUIRED_DIGEST = 324,
      SSL_R_NO_SHARED_CIPHER = 193,
      SSL_R_NO_SHARED_GROUPS = 410,
      SSL_R_NO_SHARED_SIGNATURE_ALGORITHMS = 376,
      SSL_R_NO_SRTP_PROFILES = 359,
      SSL_R_NO_SUITABLE_DIGEST_ALGORITHM = 297,
      SSL_R_NO_SUITABLE_GROUPS = 295,
      SSL_R_NO_SUITABLE_KEY_SHARE = 101,
      SSL_R_NO_SUITABLE_SIGNATURE_ALGORITHM = 118,
      SSL_R_NO_VALID_SCTS = 216,
      SSL_R_NO_VERIFY_COOKIE_CALLBACK = 403,
      SSL_R_NULL_SSL_CTX = 195,
      SSL_R_NULL_SSL_METHOD_PASSED = 196,
      SSL_R_OCSP_CALLBACK_FAILURE = 305,
      SSL_R_OLD_SESSION_CIPHER_NOT_RETURNED = 197,
      SSL_R_OLD_SESSION_COMPRESSION_ALGORITHM_NOT_RETURNED = 344,
      SSL_R_OVERFLOW_ERROR = 237,
      SSL_R_PACKET_LENGTH_TOO_LONG = 198,
      SSL_R_PARSE_TLSEXT = 227,
      SSL_R_PATH_TOO_LONG = 270,
      SSL_R_PEER_DID_NOT_RETURN_A_CERTIFICATE = 199,
      SSL_R_PEM_NAME_BAD_PREFIX = 391,
      SSL_R_PEM_NAME_TOO_SHORT = 392,
      SSL_R_PIPELINE_FAILURE = 406,
      SSL_R_POST_HANDSHAKE_AUTH_ENCODING_ERR = 278,
      SSL_R_PRIVATE_KEY_MISMATCH = 288,
      SSL_R_PROTOCOL_IS_SHUTDOWN = 207,
      SSL_R_PSK_IDENTITY_NOT_FOUND = 223,
      SSL_R_PSK_NO_CLIENT_CB = 224,
      SSL_R_PSK_NO_SERVER_CB = 225,
      SSL_R_READ_BIO_NOT_SET = 211,
      SSL_R_READ_TIMEOUT_EXPIRED = 312,
      SSL_R_RECORD_LENGTH_MISMATCH = 213,
      SSL_R_RECORD_TOO_SMALL = 298,
      SSL_R_RENEGOTIATE_EXT_TOO_LONG = 335,
      SSL_R_RENEGOTIATION_ENCODING_ERR = 336,
      SSL_R_RENEGOTIATION_MISMATCH = 337,
      SSL_R_REQUEST_PENDING = 285,
      SSL_R_REQUEST_SENT = 286,
      SSL_R_REQUIRED_CIPHER_MISSING = 215,
      SSL_R_REQUIRED_COMPRESSION_ALGORITHM_MISSING = 342,
      SSL_R_SCSV_RECEIVED_WHEN_RENEGOTIATING = 345,
      SSL_R_SCT_VERIFICATION_FAILED = 208,
      SSL_R_SERVERHELLO_TLSEXT = 275,
      SSL_R_SESSION_ID_CONTEXT_UNINITIALIZED = 277,
      SSL_R_SHUTDOWN_WHILE_IN_INIT = 407,
      SSL_R_SIGNATURE_ALGORITHMS_ERROR = 360,
      SSL_R_SIGNATURE_FOR_NON_SIGNING_CERTIFICATE = 220,
      SSL_R_SRP_A_CALC = 361,
      SSL_R_SRTP_COULD_NOT_ALLOCATE_PROFILES = 362,
      SSL_R_SRTP_PROTECTION_PROFILE_LIST_TOO_LONG = 363,
      SSL_R_SRTP_UNKNOWN_PROTECTION_PROFILE = 364,
      SSL_R_SSL3_EXT_INVALID_MAX_FRAGMENT_LENGTH = 232,
      SSL_R_SSL3_EXT_INVALID_SERVERNAME = 319,
      SSL_R_SSL3_EXT_INVALID_SERVERNAME_TYPE = 320,
      SSL_R_SSL3_SESSION_ID_TOO_LONG = 300,
      SSL_R_SSLV3_ALERT_BAD_CERTIFICATE = 1042,
      SSL_R_SSLV3_ALERT_BAD_RECORD_MAC = 1020,
      SSL_R_SSLV3_ALERT_CERTIFICATE_EXPIRED = 1045,
      SSL_R_SSLV3_ALERT_CERTIFICATE_REVOKED = 1044,
      SSL_R_SSLV3_ALERT_CERTIFICATE_UNKNOWN = 1046,
      SSL_R_SSLV3_ALERT_DECOMPRESSION_FAILURE = 1030,
      SSL_R_SSLV3_ALERT_HANDSHAKE_FAILURE = 1040,
      SSL_R_SSLV3_ALERT_ILLEGAL_PARAMETER = 1047,
      SSL_R_SSLV3_ALERT_NO_CERTIFICATE = 1041,
      SSL_R_SSLV3_ALERT_UNEXPECTED_MESSAGE = 1010,
      SSL_R_SSLV3_ALERT_UNSUPPORTED_CERTIFICATE = 1043,
      SSL_R_SSL_COMMAND_SECTION_EMPTY = 117,
      SSL_R_SSL_COMMAND_SECTION_NOT_FOUND = 125,
      SSL_R_SSL_CTX_HAS_NO_DEFAULT_SSL_VERSION = 228,
      SSL_R_SSL_HANDSHAKE_FAILURE = 229,
      SSL_R_SSL_LIBRARY_HAS_NO_CIPHERS = 230,
      SSL_R_SSL_NEGATIVE_LENGTH = 372,
      SSL_R_SSL_SECTION_EMPTY = 126,
      SSL_R_SSL_SECTION_NOT_FOUND = 136,
      SSL_R_SSL_SESSION_ID_CALLBACK_FAILED = 301,
      SSL_R_SSL_SESSION_ID_CONFLICT = 302,
      SSL_R_SSL_SESSION_ID_CONTEXT_TOO_LONG = 273,
      SSL_R_SSL_SESSION_ID_HAS_BAD_LENGTH = 303,
      SSL_R_SSL_SESSION_ID_TOO_LONG = 408,
      SSL_R_SSL_SESSION_VERSION_MISMATCH = 210,
      SSL_R_STILL_IN_INIT = 121,
      SSL_R_TLSV13_ALERT_CERTIFICATE_REQUIRED = 1116,
      SSL_R_TLSV13_ALERT_MISSING_EXTENSION = 1109,
      SSL_R_TLSV1_ALERT_ACCESS_DENIED = 1049,
      SSL_R_TLSV1_ALERT_DECODE_ERROR = 1050,
      SSL_R_TLSV1_ALERT_DECRYPTION_FAILED = 1021,
      SSL_R_TLSV1_ALERT_DECRYPT_ERROR = 1051,
      SSL_R_TLSV1_ALERT_EXPORT_RESTRICTION = 1060,
      SSL_R_TLSV1_ALERT_INAPPROPRIATE_FALLBACK = 1086,
      SSL_R_TLSV1_ALERT_INSUFFICIENT_SECURITY = 1071,
      SSL_R_TLSV1_ALERT_INTERNAL_ERROR = 1080,
      SSL_R_TLSV1_ALERT_NO_RENEGOTIATION = 1100,
      SSL_R_TLSV1_ALERT_PROTOCOL_VERSION = 1070,
      SSL_R_TLSV1_ALERT_RECORD_OVERFLOW = 1022,
      SSL_R_TLSV1_ALERT_UNKNOWN_CA = 1048,
      SSL_R_TLSV1_ALERT_USER_CANCELLED = 1090,
      SSL_R_TLSV1_BAD_CERTIFICATE_HASH_VALUE = 1114,
      SSL_R_TLSV1_BAD_CERTIFICATE_STATUS_RESPONSE = 1113,
      SSL_R_TLSV1_CERTIFICATE_UNOBTAINABLE = 1111,
      SSL_R_TLSV1_UNRECOGNIZED_NAME = 1112,
      SSL_R_TLSV1_UNSUPPORTED_EXTENSION = 1110,
      SSL_R_TLS_ILLEGAL_EXPORTER_LABEL = 367,
      SSL_R_TLS_INVALID_ECPOINTFORMAT_LIST = 157,
      SSL_R_TOO_MANY_KEY_UPDATES = 132,
      SSL_R_TOO_MANY_WARN_ALERTS = 409,
      SSL_R_TOO_MUCH_EARLY_DATA = 164,
      SSL_R_UNABLE_TO_FIND_ECDH_PARAMETERS = 314,
      SSL_R_UNABLE_TO_FIND_PUBLIC_KEY_PARAMETERS = 239,
      SSL_R_UNABLE_TO_LOAD_SSL3_MD5_ROUTINES = 242,
      SSL_R_UNABLE_TO_LOAD_SSL3_SHA1_ROUTINES = 243,
      SSL_R_UNEXPECTED_CCS_MESSAGE = 262,
      SSL_R_UNEXPECTED_END_OF_EARLY_DATA = 178,
      SSL_R_UNEXPECTED_EOF_WHILE_READING = 294,
      SSL_R_UNEXPECTED_MESSAGE = 244,
      SSL_R_UNEXPECTED_RECORD = 245,
      SSL_R_UNINITIALIZED = 276,
      SSL_R_UNKNOWN_ALERT_TYPE = 246,
      SSL_R_UNKNOWN_CERTIFICATE_TYPE = 247,
      SSL_R_UNKNOWN_CIPHER_RETURNED = 248,
      SSL_R_UNKNOWN_CIPHER_TYPE = 249,
      SSL_R_UNKNOWN_CMD_NAME = 386,
      SSL_R_UNKNOWN_COMMAND = 139,
      SSL_R_UNKNOWN_DIGEST = 368,
      SSL_R_UNKNOWN_KEY_EXCHANGE_TYPE = 250,
      SSL_R_UNKNOWN_PKEY_TYPE = 251,
      SSL_R_UNKNOWN_PROTOCOL = 252,
      SSL_R_UNKNOWN_SSL_VERSION = 254,
      SSL_R_UNKNOWN_STATE = 255,
      SSL_R_UNSAFE_LEGACY_RENEGOTIATION_DISABLED = 338,
      SSL_R_UNSOLICITED_EXTENSION = 217,
      SSL_R_UNSUPPORTED_COMPRESSION_ALGORITHM = 257,
      SSL_R_UNSUPPORTED_ELLIPTIC_CURVE = 315,
      SSL_R_UNSUPPORTED_PROTOCOL = 258,
      SSL_R_UNSUPPORTED_SSL_VERSION = 259,
      SSL_R_UNSUPPORTED_STATUS_TYPE = 329,
      SSL_R_USE_SRTP_NOT_NEGOTIATED = 369,
      SSL_R_VERSION_TOO_HIGH = 166,
      SSL_R_VERSION_TOO_LOW = 396,
      SSL_R_WRONG_CERTIFICATE_TYPE = 383,
      SSL_R_WRONG_CIPHER_RETURNED = 261,
      SSL_R_WRONG_CURVE = 378,
      SSL_R_WRONG_SIGNATURE_LENGTH = 264,
      SSL_R_WRONG_SIGNATURE_SIZE = 265,
      SSL_R_WRONG_SIGNATURE_TYPE = 370,
      SSL_R_WRONG_SSL_VERSION = 266,
      SSL_R_WRONG_VERSION_NUMBER = 267,
      SSL_R_X509_LIB = 268,
      SSL_R_X509_VERIFICATION_SETUP_PROBLEMS = 269,
      OSSL_STORE_C_USE_SECMEM = 1,
      OSSL_STORE_C_CUSTOM_START = 100,
      OSSL_STORE_INFO_NAME = 1,
      OSSL_STORE_INFO_PARAMS = 2,
      OSSL_STORE_INFO_PUBKEY = 3,
      OSSL_STORE_INFO_PKEY = 4,
      OSSL_STORE_INFO_CERT = 5,
      OSSL_STORE_INFO_CRL = 6,
      OSSL_STORE_SEARCH_BY_NAME = 1,
      OSSL_STORE_SEARCH_BY_ISSUER_SERIAL = 2,
      OSSL_STORE_SEARCH_BY_KEY_FINGERPRINT = 3,
      OSSL_STORE_SEARCH_BY_ALIAS = 4,
      OSSL_STORE_R_AMBIGUOUS_CONTENT_TYPE = 107,
      OSSL_STORE_R_BAD_PASSWORD_READ = 115,
      OSSL_STORE_R_ERROR_VERIFYING_PKCS12_MAC = 113,
      OSSL_STORE_R_FINGERPRINT_SIZE_DOES_NOT_MATCH_DIGEST = 121,
      OSSL_STORE_R_INVALID_SCHEME = 106,
      OSSL_STORE_R_IS_NOT_A = 112,
      OSSL_STORE_R_LOADER_INCOMPLETE = 116,
      OSSL_STORE_R_LOADING_STARTED = 117,
      OSSL_STORE_R_NOT_A_CERTIFICATE = 100,
      OSSL_STORE_R_NOT_A_CRL = 101,
      OSSL_STORE_R_NOT_A_NAME = 103,
      OSSL_STORE_R_NOT_A_PRIVATE_KEY = 102,
      OSSL_STORE_R_NOT_A_PUBLIC_KEY = 122,
      OSSL_STORE_R_NOT_PARAMETERS = 104,
      OSSL_STORE_R_NO_LOADERS_FOUND = 123,
      OSSL_STORE_R_PASSPHRASE_CALLBACK_ERROR = 114,
      OSSL_STORE_R_PATH_MUST_BE_ABSOLUTE = 108,
      OSSL_STORE_R_SEARCH_ONLY_SUPPORTED_FOR_DIRECTORIES = 119,
      OSSL_STORE_R_UI_PROCESS_INTERRUPTED_OR_CANCELLED = 109,
      OSSL_STORE_R_UNREGISTERED_SCHEME = 105,
      OSSL_STORE_R_UNSUPPORTED_CONTENT_TYPE = 110,
      OSSL_STORE_R_UNSUPPORTED_OPERATION = 118,
      OSSL_STORE_R_UNSUPPORTED_SEARCH_TYPE = 120,
      OSSL_STORE_R_URI_AUTHORITY_UNSUPPORTED = 111,
      TLS_ANY_VERSION = "0x10000",
      TLS1_VERSION_MAJOR = "0x03",
      TLS1_VERSION_MINOR = "0x01",
      TLS1_1_VERSION_MAJOR = "0x03",
      TLS1_1_VERSION_MINOR = "0x02",
      TLS1_2_VERSION_MAJOR = "0x03",
      TLS1_2_VERSION_MINOR = "0x03",
      TLS1_AD_DECRYPTION_FAILED = 21,
      TLS1_AD_RECORD_OVERFLOW = 22,
      TLS1_AD_DECRYPT_ERROR = 51,
      TLS1_AD_USER_CANCELLED = 90,
      TLS1_AD_NO_RENEGOTIATION = 100,
      TLS13_AD_MISSING_EXTENSION = 109,
      TLS13_AD_CERTIFICATE_REQUIRED = 116,
      TLS1_AD_UNSUPPORTED_EXTENSION = 110,
      TLS1_AD_CERTIFICATE_UNOBTAINABLE = 111,
      TLS1_AD_UNRECOGNIZED_NAME = 112,
      TLS1_AD_BAD_CERTIFICATE_STATUS_RESPONSE = 113,
      TLS1_AD_BAD_CERTIFICATE_HASH_VALUE = 114,
      TLS1_AD_NO_APPLICATION_PROTOCOL = 120,
      TLSEXT_TYPE_server_name = "0",
      TLSEXT_TYPE_max_fragment_length = 1,
      TLSEXT_TYPE_client_certificate_url = 2,
      TLSEXT_TYPE_trusted_ca_keys = 3,
      TLSEXT_TYPE_truncated_hmac = 4,
      TLSEXT_TYPE_status_request = 5,
      TLSEXT_TYPE_user_mapping = 6,
      TLSEXT_TYPE_client_authz = 7,
      TLSEXT_TYPE_server_authz = 8,
      TLSEXT_TYPE_cert_type = 9,
      TLSEXT_TYPE_supported_groups = 10,
      TLSEXT_TYPE_elliptic_curves = 10,
      TLSEXT_TYPE_ec_point_formats = 11,
      TLSEXT_TYPE_srp = 12,
      TLSEXT_TYPE_signature_algorithms = 13,
      TLSEXT_TYPE_use_srtp = 14,
      TLSEXT_TYPE_application_layer_protocol_negotiation = 16,
      TLSEXT_TYPE_signed_certificate_timestamp = 18,
      TLSEXT_TYPE_padding = 21,
      TLSEXT_TYPE_encrypt_then_mac = 22,
      TLSEXT_TYPE_extended_master_secret = 23,
      TLSEXT_TYPE_session_ticket = 35,
      TLSEXT_TYPE_psk = 41,
      TLSEXT_TYPE_early_data = 42,
      TLSEXT_TYPE_supported_versions = 43,
      TLSEXT_TYPE_cookie = 44,
      TLSEXT_TYPE_psk_kex_modes = 45,
      TLSEXT_TYPE_certificate_authorities = 47,
      TLSEXT_TYPE_post_handshake_auth = 49,
      TLSEXT_TYPE_signature_algorithms_cert = 50,
      TLSEXT_TYPE_key_share = 51,
      TLSEXT_TYPE_renegotiate = "0xff01",
      TLSEXT_NAMETYPE_host_name = "0",
      TLSEXT_STATUSTYPE_ocsp = 1,
      TLSEXT_ECPOINTFORMAT_first = "0",
      TLSEXT_ECPOINTFORMAT_uncompressed = "0",
      TLSEXT_ECPOINTFORMAT_ansiX962_compressed_prime = 1,
      TLSEXT_ECPOINTFORMAT_ansiX962_compressed_char2 = 2,
      TLSEXT_ECPOINTFORMAT_last = 2,
      TLSEXT_signature_anonymous = "0",
      TLSEXT_signature_rsa = 1,
      TLSEXT_signature_dsa = 2,
      TLSEXT_signature_ecdsa = 3,
      TLSEXT_signature_gostr34102001 = 237,
      TLSEXT_signature_gostr34102012_256 = 238,
      TLSEXT_signature_gostr34102012_512 = 239,
      TLSEXT_signature_num = 7,
      TLSEXT_hash_none = "0",
      TLSEXT_hash_md5 = 1,
      TLSEXT_hash_sha1 = 2,
      TLSEXT_hash_sha224 = 3,
      TLSEXT_hash_sha256 = 4,
      TLSEXT_hash_sha384 = 5,
      TLSEXT_hash_sha512 = 6,
      TLSEXT_hash_gostr3411 = 237,
      TLSEXT_hash_gostr34112012_256 = 238,
      TLSEXT_hash_gostr34112012_512 = 239,
      TLSEXT_hash_num = 10,
      TLSEXT_nid_unknown = "0x1000000",
      TLSEXT_curve_P_256 = 23,
      TLSEXT_curve_P_384 = 24,
      TLSEXT_max_fragment_length_DISABLED = "0",
      TLSEXT_max_fragment_length_512 = 1,
      TLSEXT_max_fragment_length_1024 = 2,
      TLSEXT_max_fragment_length_2048 = 3,
      TLSEXT_max_fragment_length_4096 = 4,
      TLSEXT_MAXLEN_host_name = 255,
      SSL_TLSEXT_ERR_OK = "0",
      SSL_TLSEXT_ERR_ALERT_WARNING = 1,
      SSL_TLSEXT_ERR_ALERT_FATAL = 2,
      SSL_TLSEXT_ERR_NOACK = 3,
      TLS1_CK_PSK_WITH_RC4_128_SHA = "0x0300008A",
      TLS1_CK_PSK_WITH_3DES_EDE_CBC_SHA = "0x0300008B",
      TLS1_CK_PSK_WITH_AES_128_CBC_SHA = "0x0300008C",
      TLS1_CK_PSK_WITH_AES_256_CBC_SHA = "0x0300008D",
      TLS1_CK_DHE_PSK_WITH_RC4_128_SHA = "0x0300008E",
      TLS1_CK_DHE_PSK_WITH_3DES_EDE_CBC_SHA = "0x0300008F",
      TLS1_CK_DHE_PSK_WITH_AES_128_CBC_SHA = "0x03000090",
      TLS1_CK_DHE_PSK_WITH_AES_256_CBC_SHA = "0x03000091",
      TLS1_CK_RSA_PSK_WITH_RC4_128_SHA = "0x03000092",
      TLS1_CK_RSA_PSK_WITH_3DES_EDE_CBC_SHA = "0x03000093",
      TLS1_CK_RSA_PSK_WITH_AES_128_CBC_SHA = "0x03000094",
      TLS1_CK_RSA_PSK_WITH_AES_256_CBC_SHA = "0x03000095",
      TLS1_CK_PSK_WITH_AES_128_GCM_SHA256 = "0x030000A8",
      TLS1_CK_PSK_WITH_AES_256_GCM_SHA384 = "0x030000A9",
      TLS1_CK_DHE_PSK_WITH_AES_128_GCM_SHA256 = "0x030000AA",
      TLS1_CK_DHE_PSK_WITH_AES_256_GCM_SHA384 = "0x030000AB",
      TLS1_CK_RSA_PSK_WITH_AES_128_GCM_SHA256 = "0x030000AC",
      TLS1_CK_RSA_PSK_WITH_AES_256_GCM_SHA384 = "0x030000AD",
      TLS1_CK_PSK_WITH_AES_128_CBC_SHA256 = "0x030000AE",
      TLS1_CK_PSK_WITH_AES_256_CBC_SHA384 = "0x030000AF",
      TLS1_CK_PSK_WITH_NULL_SHA256 = "0x030000B0",
      TLS1_CK_PSK_WITH_NULL_SHA384 = "0x030000B1",
      TLS1_CK_DHE_PSK_WITH_AES_128_CBC_SHA256 = "0x030000B2",
      TLS1_CK_DHE_PSK_WITH_AES_256_CBC_SHA384 = "0x030000B3",
      TLS1_CK_DHE_PSK_WITH_NULL_SHA256 = "0x030000B4",
      TLS1_CK_DHE_PSK_WITH_NULL_SHA384 = "0x030000B5",
      TLS1_CK_RSA_PSK_WITH_AES_128_CBC_SHA256 = "0x030000B6",
      TLS1_CK_RSA_PSK_WITH_AES_256_CBC_SHA384 = "0x030000B7",
      TLS1_CK_RSA_PSK_WITH_NULL_SHA256 = "0x030000B8",
      TLS1_CK_RSA_PSK_WITH_NULL_SHA384 = "0x030000B9",
      TLS1_CK_PSK_WITH_NULL_SHA = "0x0300002C",
      TLS1_CK_DHE_PSK_WITH_NULL_SHA = "0x0300002D",
      TLS1_CK_RSA_PSK_WITH_NULL_SHA = "0x0300002E",
      TLS1_CK_RSA_WITH_AES_128_SHA = "0x0300002F",
      TLS1_CK_DH_DSS_WITH_AES_128_SHA = "0x03000030",
      TLS1_CK_DH_RSA_WITH_AES_128_SHA = "0x03000031",
      TLS1_CK_DHE_DSS_WITH_AES_128_SHA = "0x03000032",
      TLS1_CK_DHE_RSA_WITH_AES_128_SHA = "0x03000033",
      TLS1_CK_ADH_WITH_AES_128_SHA = "0x03000034",
      TLS1_CK_RSA_WITH_AES_256_SHA = "0x03000035",
      TLS1_CK_DH_DSS_WITH_AES_256_SHA = "0x03000036",
      TLS1_CK_DH_RSA_WITH_AES_256_SHA = "0x03000037",
      TLS1_CK_DHE_DSS_WITH_AES_256_SHA = "0x03000038",
      TLS1_CK_DHE_RSA_WITH_AES_256_SHA = "0x03000039",
      TLS1_CK_ADH_WITH_AES_256_SHA = "0x0300003A",
      TLS1_CK_RSA_WITH_NULL_SHA256 = "0x0300003B",
      TLS1_CK_RSA_WITH_AES_128_SHA256 = "0x0300003C",
      TLS1_CK_RSA_WITH_AES_256_SHA256 = "0x0300003D",
      TLS1_CK_DH_DSS_WITH_AES_128_SHA256 = "0x0300003E",
      TLS1_CK_DH_RSA_WITH_AES_128_SHA256 = "0x0300003F",
      TLS1_CK_DHE_DSS_WITH_AES_128_SHA256 = "0x03000040",
      TLS1_CK_RSA_WITH_CAMELLIA_128_CBC_SHA = "0x03000041",
      TLS1_CK_DH_DSS_WITH_CAMELLIA_128_CBC_SHA = "0x03000042",
      TLS1_CK_DH_RSA_WITH_CAMELLIA_128_CBC_SHA = "0x03000043",
      TLS1_CK_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA = "0x03000044",
      TLS1_CK_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA = "0x03000045",
      TLS1_CK_ADH_WITH_CAMELLIA_128_CBC_SHA = "0x03000046",
      TLS1_CK_DHE_RSA_WITH_AES_128_SHA256 = "0x03000067",
      TLS1_CK_DH_DSS_WITH_AES_256_SHA256 = "0x03000068",
      TLS1_CK_DH_RSA_WITH_AES_256_SHA256 = "0x03000069",
      TLS1_CK_DHE_DSS_WITH_AES_256_SHA256 = "0x0300006A",
      TLS1_CK_DHE_RSA_WITH_AES_256_SHA256 = "0x0300006B",
      TLS1_CK_ADH_WITH_AES_128_SHA256 = "0x0300006C",
      TLS1_CK_ADH_WITH_AES_256_SHA256 = "0x0300006D",
      TLS1_CK_RSA_WITH_CAMELLIA_256_CBC_SHA = "0x03000084",
      TLS1_CK_DH_DSS_WITH_CAMELLIA_256_CBC_SHA = "0x03000085",
      TLS1_CK_DH_RSA_WITH_CAMELLIA_256_CBC_SHA = "0x03000086",
      TLS1_CK_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA = "0x03000087",
      TLS1_CK_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA = "0x03000088",
      TLS1_CK_ADH_WITH_CAMELLIA_256_CBC_SHA = "0x03000089",
      TLS1_CK_RSA_WITH_SEED_SHA = "0x03000096",
      TLS1_CK_DH_DSS_WITH_SEED_SHA = "0x03000097",
      TLS1_CK_DH_RSA_WITH_SEED_SHA = "0x03000098",
      TLS1_CK_DHE_DSS_WITH_SEED_SHA = "0x03000099",
      TLS1_CK_DHE_RSA_WITH_SEED_SHA = "0x0300009A",
      TLS1_CK_ADH_WITH_SEED_SHA = "0x0300009B",
      TLS1_CK_RSA_WITH_AES_128_GCM_SHA256 = "0x0300009C",
      TLS1_CK_RSA_WITH_AES_256_GCM_SHA384 = "0x0300009D",
      TLS1_CK_DHE_RSA_WITH_AES_128_GCM_SHA256 = "0x0300009E",
      TLS1_CK_DHE_RSA_WITH_AES_256_GCM_SHA384 = "0x0300009F",
      TLS1_CK_DH_RSA_WITH_AES_128_GCM_SHA256 = "0x030000A0",
      TLS1_CK_DH_RSA_WITH_AES_256_GCM_SHA384 = "0x030000A1",
      TLS1_CK_DHE_DSS_WITH_AES_128_GCM_SHA256 = "0x030000A2",
      TLS1_CK_DHE_DSS_WITH_AES_256_GCM_SHA384 = "0x030000A3",
      TLS1_CK_DH_DSS_WITH_AES_128_GCM_SHA256 = "0x030000A4",
      TLS1_CK_DH_DSS_WITH_AES_256_GCM_SHA384 = "0x030000A5",
      TLS1_CK_ADH_WITH_AES_128_GCM_SHA256 = "0x030000A6",
      TLS1_CK_ADH_WITH_AES_256_GCM_SHA384 = "0x030000A7",
      TLS1_CK_RSA_WITH_AES_128_CCM = "0x0300C09C",
      TLS1_CK_RSA_WITH_AES_256_CCM = "0x0300C09D",
      TLS1_CK_DHE_RSA_WITH_AES_128_CCM = "0x0300C09E",
      TLS1_CK_DHE_RSA_WITH_AES_256_CCM = "0x0300C09F",
      TLS1_CK_RSA_WITH_AES_128_CCM_8 = "0x0300C0A0",
      TLS1_CK_RSA_WITH_AES_256_CCM_8 = "0x0300C0A1",
      TLS1_CK_DHE_RSA_WITH_AES_128_CCM_8 = "0x0300C0A2",
      TLS1_CK_DHE_RSA_WITH_AES_256_CCM_8 = "0x0300C0A3",
      TLS1_CK_PSK_WITH_AES_128_CCM = "0x0300C0A4",
      TLS1_CK_PSK_WITH_AES_256_CCM = "0x0300C0A5",
      TLS1_CK_DHE_PSK_WITH_AES_128_CCM = "0x0300C0A6",
      TLS1_CK_DHE_PSK_WITH_AES_256_CCM = "0x0300C0A7",
      TLS1_CK_PSK_WITH_AES_128_CCM_8 = "0x0300C0A8",
      TLS1_CK_PSK_WITH_AES_256_CCM_8 = "0x0300C0A9",
      TLS1_CK_DHE_PSK_WITH_AES_128_CCM_8 = "0x0300C0AA",
      TLS1_CK_DHE_PSK_WITH_AES_256_CCM_8 = "0x0300C0AB",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_128_CCM = "0x0300C0AC",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_256_CCM = "0x0300C0AD",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_128_CCM_8 = "0x0300C0AE",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_256_CCM_8 = "0x0300C0AF",
      TLS1_CK_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "0x030000BA",
      TLS1_CK_DH_DSS_WITH_CAMELLIA_128_CBC_SHA256 = "0x030000BB",
      TLS1_CK_DH_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "0x030000BC",
      TLS1_CK_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA256 = "0x030000BD",
      TLS1_CK_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "0x030000BE",
      TLS1_CK_ADH_WITH_CAMELLIA_128_CBC_SHA256 = "0x030000BF",
      TLS1_CK_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "0x030000C0",
      TLS1_CK_DH_DSS_WITH_CAMELLIA_256_CBC_SHA256 = "0x030000C1",
      TLS1_CK_DH_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "0x030000C2",
      TLS1_CK_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA256 = "0x030000C3",
      TLS1_CK_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "0x030000C4",
      TLS1_CK_ADH_WITH_CAMELLIA_256_CBC_SHA256 = "0x030000C5",
      TLS1_CK_ECDH_ECDSA_WITH_NULL_SHA = "0x0300C001",
      TLS1_CK_ECDH_ECDSA_WITH_RC4_128_SHA = "0x0300C002",
      TLS1_CK_ECDH_ECDSA_WITH_DES_192_CBC3_SHA = "0x0300C003",
      TLS1_CK_ECDH_ECDSA_WITH_AES_128_CBC_SHA = "0x0300C004",
      TLS1_CK_ECDH_ECDSA_WITH_AES_256_CBC_SHA = "0x0300C005",
      TLS1_CK_ECDHE_ECDSA_WITH_NULL_SHA = "0x0300C006",
      TLS1_CK_ECDHE_ECDSA_WITH_RC4_128_SHA = "0x0300C007",
      TLS1_CK_ECDHE_ECDSA_WITH_DES_192_CBC3_SHA = "0x0300C008",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_128_CBC_SHA = "0x0300C009",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_256_CBC_SHA = "0x0300C00A",
      TLS1_CK_ECDH_RSA_WITH_NULL_SHA = "0x0300C00B",
      TLS1_CK_ECDH_RSA_WITH_RC4_128_SHA = "0x0300C00C",
      TLS1_CK_ECDH_RSA_WITH_DES_192_CBC3_SHA = "0x0300C00D",
      TLS1_CK_ECDH_RSA_WITH_AES_128_CBC_SHA = "0x0300C00E",
      TLS1_CK_ECDH_RSA_WITH_AES_256_CBC_SHA = "0x0300C00F",
      TLS1_CK_ECDHE_RSA_WITH_NULL_SHA = "0x0300C010",
      TLS1_CK_ECDHE_RSA_WITH_RC4_128_SHA = "0x0300C011",
      TLS1_CK_ECDHE_RSA_WITH_DES_192_CBC3_SHA = "0x0300C012",
      TLS1_CK_ECDHE_RSA_WITH_AES_128_CBC_SHA = "0x0300C013",
      TLS1_CK_ECDHE_RSA_WITH_AES_256_CBC_SHA = "0x0300C014",
      TLS1_CK_ECDH_anon_WITH_NULL_SHA = "0x0300C015",
      TLS1_CK_ECDH_anon_WITH_RC4_128_SHA = "0x0300C016",
      TLS1_CK_ECDH_anon_WITH_DES_192_CBC3_SHA = "0x0300C017",
      TLS1_CK_ECDH_anon_WITH_AES_128_CBC_SHA = "0x0300C018",
      TLS1_CK_ECDH_anon_WITH_AES_256_CBC_SHA = "0x0300C019",
      TLS1_CK_SRP_SHA_WITH_3DES_EDE_CBC_SHA = "0x0300C01A",
      TLS1_CK_SRP_SHA_RSA_WITH_3DES_EDE_CBC_SHA = "0x0300C01B",
      TLS1_CK_SRP_SHA_DSS_WITH_3DES_EDE_CBC_SHA = "0x0300C01C",
      TLS1_CK_SRP_SHA_WITH_AES_128_CBC_SHA = "0x0300C01D",
      TLS1_CK_SRP_SHA_RSA_WITH_AES_128_CBC_SHA = "0x0300C01E",
      TLS1_CK_SRP_SHA_DSS_WITH_AES_128_CBC_SHA = "0x0300C01F",
      TLS1_CK_SRP_SHA_WITH_AES_256_CBC_SHA = "0x0300C020",
      TLS1_CK_SRP_SHA_RSA_WITH_AES_256_CBC_SHA = "0x0300C021",
      TLS1_CK_SRP_SHA_DSS_WITH_AES_256_CBC_SHA = "0x0300C022",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_128_SHA256 = "0x0300C023",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_256_SHA384 = "0x0300C024",
      TLS1_CK_ECDH_ECDSA_WITH_AES_128_SHA256 = "0x0300C025",
      TLS1_CK_ECDH_ECDSA_WITH_AES_256_SHA384 = "0x0300C026",
      TLS1_CK_ECDHE_RSA_WITH_AES_128_SHA256 = "0x0300C027",
      TLS1_CK_ECDHE_RSA_WITH_AES_256_SHA384 = "0x0300C028",
      TLS1_CK_ECDH_RSA_WITH_AES_128_SHA256 = "0x0300C029",
      TLS1_CK_ECDH_RSA_WITH_AES_256_SHA384 = "0x0300C02A",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256 = "0x0300C02B",
      TLS1_CK_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384 = "0x0300C02C",
      TLS1_CK_ECDH_ECDSA_WITH_AES_128_GCM_SHA256 = "0x0300C02D",
      TLS1_CK_ECDH_ECDSA_WITH_AES_256_GCM_SHA384 = "0x0300C02E",
      TLS1_CK_ECDHE_RSA_WITH_AES_128_GCM_SHA256 = "0x0300C02F",
      TLS1_CK_ECDHE_RSA_WITH_AES_256_GCM_SHA384 = "0x0300C030",
      TLS1_CK_ECDH_RSA_WITH_AES_128_GCM_SHA256 = "0x0300C031",
      TLS1_CK_ECDH_RSA_WITH_AES_256_GCM_SHA384 = "0x0300C032",
      TLS1_CK_ECDHE_PSK_WITH_RC4_128_SHA = "0x0300C033",
      TLS1_CK_ECDHE_PSK_WITH_3DES_EDE_CBC_SHA = "0x0300C034",
      TLS1_CK_ECDHE_PSK_WITH_AES_128_CBC_SHA = "0x0300C035",
      TLS1_CK_ECDHE_PSK_WITH_AES_256_CBC_SHA = "0x0300C036",
      TLS1_CK_ECDHE_PSK_WITH_AES_128_CBC_SHA256 = "0x0300C037",
      TLS1_CK_ECDHE_PSK_WITH_AES_256_CBC_SHA384 = "0x0300C038",
      TLS1_CK_ECDHE_PSK_WITH_NULL_SHA = "0x0300C039",
      TLS1_CK_ECDHE_PSK_WITH_NULL_SHA256 = "0x0300C03A",
      TLS1_CK_ECDHE_PSK_WITH_NULL_SHA384 = "0x0300C03B",
      TLS1_CK_ECDHE_ECDSA_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C072",
      TLS1_CK_ECDHE_ECDSA_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C073",
      TLS1_CK_ECDH_ECDSA_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C074",
      TLS1_CK_ECDH_ECDSA_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C075",
      TLS1_CK_ECDHE_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C076",
      TLS1_CK_ECDHE_RSA_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C077",
      TLS1_CK_ECDH_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C078",
      TLS1_CK_ECDH_RSA_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C079",
      TLS1_CK_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C094",
      TLS1_CK_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C095",
      TLS1_CK_DHE_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C096",
      TLS1_CK_DHE_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C097",
      TLS1_CK_RSA_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C098",
      TLS1_CK_RSA_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C099",
      TLS1_CK_ECDHE_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "0x0300C09A",
      TLS1_CK_ECDHE_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "0x0300C09B",
      TLS1_CK_ECDHE_RSA_WITH_CHACHA20_POLY1305 = "0x0300CCA8",
      TLS1_CK_ECDHE_ECDSA_WITH_CHACHA20_POLY1305 = "0x0300CCA9",
      TLS1_CK_DHE_RSA_WITH_CHACHA20_POLY1305 = "0x0300CCAA",
      TLS1_CK_PSK_WITH_CHACHA20_POLY1305 = "0x0300CCAB",
      TLS1_CK_ECDHE_PSK_WITH_CHACHA20_POLY1305 = "0x0300CCAC",
      TLS1_CK_DHE_PSK_WITH_CHACHA20_POLY1305 = "0x0300CCAD",
      TLS1_CK_RSA_PSK_WITH_CHACHA20_POLY1305 = "0x0300CCAE",
      TLS1_3_CK_AES_128_GCM_SHA256 = "0x03001301",
      TLS1_3_CK_AES_256_GCM_SHA384 = "0x03001302",
      TLS1_3_CK_CHACHA20_POLY1305_SHA256 = "0x03001303",
      TLS1_3_CK_AES_128_CCM_SHA256 = "0x03001304",
      TLS1_3_CK_AES_128_CCM_8_SHA256 = "0x03001305",
      TLS1_CK_RSA_WITH_ARIA_128_GCM_SHA256 = "0x0300C050",
      TLS1_CK_RSA_WITH_ARIA_256_GCM_SHA384 = "0x0300C051",
      TLS1_CK_DHE_RSA_WITH_ARIA_128_GCM_SHA256 = "0x0300C052",
      TLS1_CK_DHE_RSA_WITH_ARIA_256_GCM_SHA384 = "0x0300C053",
      TLS1_CK_DH_RSA_WITH_ARIA_128_GCM_SHA256 = "0x0300C054",
      TLS1_CK_DH_RSA_WITH_ARIA_256_GCM_SHA384 = "0x0300C055",
      TLS1_CK_DHE_DSS_WITH_ARIA_128_GCM_SHA256 = "0x0300C056",
      TLS1_CK_DHE_DSS_WITH_ARIA_256_GCM_SHA384 = "0x0300C057",
      TLS1_CK_DH_DSS_WITH_ARIA_128_GCM_SHA256 = "0x0300C058",
      TLS1_CK_DH_DSS_WITH_ARIA_256_GCM_SHA384 = "0x0300C059",
      TLS1_CK_DH_anon_WITH_ARIA_128_GCM_SHA256 = "0x0300C05A",
      TLS1_CK_DH_anon_WITH_ARIA_256_GCM_SHA384 = "0x0300C05B",
      TLS1_CK_ECDHE_ECDSA_WITH_ARIA_128_GCM_SHA256 = "0x0300C05C",
      TLS1_CK_ECDHE_ECDSA_WITH_ARIA_256_GCM_SHA384 = "0x0300C05D",
      TLS1_CK_ECDH_ECDSA_WITH_ARIA_128_GCM_SHA256 = "0x0300C05E",
      TLS1_CK_ECDH_ECDSA_WITH_ARIA_256_GCM_SHA384 = "0x0300C05F",
      TLS1_CK_ECDHE_RSA_WITH_ARIA_128_GCM_SHA256 = "0x0300C060",
      TLS1_CK_ECDHE_RSA_WITH_ARIA_256_GCM_SHA384 = "0x0300C061",
      TLS1_CK_ECDH_RSA_WITH_ARIA_128_GCM_SHA256 = "0x0300C062",
      TLS1_CK_ECDH_RSA_WITH_ARIA_256_GCM_SHA384 = "0x0300C063",
      TLS1_CK_PSK_WITH_ARIA_128_GCM_SHA256 = "0x0300C06A",
      TLS1_CK_PSK_WITH_ARIA_256_GCM_SHA384 = "0x0300C06B",
      TLS1_CK_DHE_PSK_WITH_ARIA_128_GCM_SHA256 = "0x0300C06C",
      TLS1_CK_DHE_PSK_WITH_ARIA_256_GCM_SHA384 = "0x0300C06D",
      TLS1_CK_RSA_PSK_WITH_ARIA_128_GCM_SHA256 = "0x0300C06E",
      TLS1_CK_RSA_PSK_WITH_ARIA_256_GCM_SHA384 = "0x0300C06F",
      TLS1_RFC_RSA_WITH_AES_128_SHA = "TLS_RSA_WITH_AES_128_CBC_SHA",
      TLS1_RFC_DHE_DSS_WITH_AES_128_SHA = "TLS_DHE_DSS_WITH_AES_128_CBC_SHA",
      TLS1_RFC_DHE_RSA_WITH_AES_128_SHA = "TLS_DHE_RSA_WITH_AES_128_CBC_SHA",
      TLS1_RFC_ADH_WITH_AES_128_SHA = "TLS_DH_anon_WITH_AES_128_CBC_SHA",
      TLS1_RFC_RSA_WITH_AES_256_SHA = "TLS_RSA_WITH_AES_256_CBC_SHA",
      TLS1_RFC_DHE_DSS_WITH_AES_256_SHA = "TLS_DHE_DSS_WITH_AES_256_CBC_SHA",
      TLS1_RFC_DHE_RSA_WITH_AES_256_SHA = "TLS_DHE_RSA_WITH_AES_256_CBC_SHA",
      TLS1_RFC_ADH_WITH_AES_256_SHA = "TLS_DH_anon_WITH_AES_256_CBC_SHA",
      TLS1_RFC_RSA_WITH_NULL_SHA256 = "TLS_RSA_WITH_NULL_SHA256",
      TLS1_RFC_RSA_WITH_AES_128_SHA256 = "TLS_RSA_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_RSA_WITH_AES_256_SHA256 = "TLS_RSA_WITH_AES_256_CBC_SHA256",
      TLS1_RFC_DHE_DSS_WITH_AES_128_SHA256 = "TLS_DHE_DSS_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_DHE_RSA_WITH_AES_128_SHA256 = "TLS_DHE_RSA_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_DHE_DSS_WITH_AES_256_SHA256 = "TLS_DHE_DSS_WITH_AES_256_CBC_SHA256",
      TLS1_RFC_DHE_RSA_WITH_AES_256_SHA256 = "TLS_DHE_RSA_WITH_AES_256_CBC_SHA256",
      TLS1_RFC_ADH_WITH_AES_128_SHA256 = "TLS_DH_anon_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_ADH_WITH_AES_256_SHA256 = "TLS_DH_anon_WITH_AES_256_CBC_SHA256",
      TLS1_RFC_RSA_WITH_AES_128_GCM_SHA256 = "TLS_RSA_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_RSA_WITH_AES_256_GCM_SHA384 = "TLS_RSA_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_DHE_RSA_WITH_AES_128_GCM_SHA256 = "TLS_DHE_RSA_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_DHE_RSA_WITH_AES_256_GCM_SHA384 = "TLS_DHE_RSA_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_DHE_DSS_WITH_AES_128_GCM_SHA256 = "TLS_DHE_DSS_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_DHE_DSS_WITH_AES_256_GCM_SHA384 = "TLS_DHE_DSS_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_ADH_WITH_AES_128_GCM_SHA256 = "TLS_DH_anon_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_ADH_WITH_AES_256_GCM_SHA384 = "TLS_DH_anon_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_RSA_WITH_AES_128_CCM = "TLS_RSA_WITH_AES_128_CCM",
      TLS1_RFC_RSA_WITH_AES_256_CCM = "TLS_RSA_WITH_AES_256_CCM",
      TLS1_RFC_DHE_RSA_WITH_AES_128_CCM = "TLS_DHE_RSA_WITH_AES_128_CCM",
      TLS1_RFC_DHE_RSA_WITH_AES_256_CCM = "TLS_DHE_RSA_WITH_AES_256_CCM",
      TLS1_RFC_RSA_WITH_AES_128_CCM_8 = "TLS_RSA_WITH_AES_128_CCM_8",
      TLS1_RFC_RSA_WITH_AES_256_CCM_8 = "TLS_RSA_WITH_AES_256_CCM_8",
      TLS1_RFC_DHE_RSA_WITH_AES_128_CCM_8 = "TLS_DHE_RSA_WITH_AES_128_CCM_8",
      TLS1_RFC_DHE_RSA_WITH_AES_256_CCM_8 = "TLS_DHE_RSA_WITH_AES_256_CCM_8",
      TLS1_RFC_PSK_WITH_AES_128_CCM = "TLS_PSK_WITH_AES_128_CCM",
      TLS1_RFC_PSK_WITH_AES_256_CCM = "TLS_PSK_WITH_AES_256_CCM",
      TLS1_RFC_DHE_PSK_WITH_AES_128_CCM = "TLS_DHE_PSK_WITH_AES_128_CCM",
      TLS1_RFC_DHE_PSK_WITH_AES_256_CCM = "TLS_DHE_PSK_WITH_AES_256_CCM",
      TLS1_RFC_PSK_WITH_AES_128_CCM_8 = "TLS_PSK_WITH_AES_128_CCM_8",
      TLS1_RFC_PSK_WITH_AES_256_CCM_8 = "TLS_PSK_WITH_AES_256_CCM_8",
      TLS1_RFC_DHE_PSK_WITH_AES_128_CCM_8 = "TLS_PSK_DHE_WITH_AES_128_CCM_8",
      TLS1_RFC_DHE_PSK_WITH_AES_256_CCM_8 = "TLS_PSK_DHE_WITH_AES_256_CCM_8",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_CCM = "TLS_ECDHE_ECDSA_WITH_AES_128_CCM",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_CCM = "TLS_ECDHE_ECDSA_WITH_AES_256_CCM",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_CCM_8 = "TLS_ECDHE_ECDSA_WITH_AES_128_CCM_8",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_CCM_8 = "TLS_ECDHE_ECDSA_WITH_AES_256_CCM_8",
      TLS1_3_RFC_AES_128_GCM_SHA256 = "TLS_AES_128_GCM_SHA256",
      TLS1_3_RFC_AES_256_GCM_SHA384 = "TLS_AES_256_GCM_SHA384",
      TLS1_3_RFC_CHACHA20_POLY1305_SHA256 = "TLS_CHACHA20_POLY1305_SHA256",
      TLS1_3_RFC_AES_128_CCM_SHA256 = "TLS_AES_128_CCM_SHA256",
      TLS1_3_RFC_AES_128_CCM_8_SHA256 = "TLS_AES_128_CCM_8_SHA256",
      TLS1_RFC_ECDHE_ECDSA_WITH_NULL_SHA = "TLS_ECDHE_ECDSA_WITH_NULL_SHA",
      TLS1_RFC_ECDHE_ECDSA_WITH_DES_192_CBC3_SHA = "TLS_ECDHE_ECDSA_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_CBC_SHA = "TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_CBC_SHA = "TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA",
      TLS1_RFC_ECDHE_RSA_WITH_NULL_SHA = "TLS_ECDHE_RSA_WITH_NULL_SHA",
      TLS1_RFC_ECDHE_RSA_WITH_DES_192_CBC3_SHA = "TLS_ECDHE_RSA_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_ECDHE_RSA_WITH_AES_128_CBC_SHA = "TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA",
      TLS1_RFC_ECDHE_RSA_WITH_AES_256_CBC_SHA = "TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA",
      TLS1_RFC_ECDH_anon_WITH_NULL_SHA = "TLS_ECDH_anon_WITH_NULL_SHA",
      TLS1_RFC_ECDH_anon_WITH_DES_192_CBC3_SHA = "TLS_ECDH_anon_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_ECDH_anon_WITH_AES_128_CBC_SHA = "TLS_ECDH_anon_WITH_AES_128_CBC_SHA",
      TLS1_RFC_ECDH_anon_WITH_AES_256_CBC_SHA = "TLS_ECDH_anon_WITH_AES_256_CBC_SHA",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_SHA256 = "TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_SHA384 = "TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA384",
      TLS1_RFC_ECDHE_RSA_WITH_AES_128_SHA256 = "TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_ECDHE_RSA_WITH_AES_256_SHA384 = "TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA384",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256 = "TLS_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384 = "TLS_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_ECDHE_RSA_WITH_AES_128_GCM_SHA256 = "TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_ECDHE_RSA_WITH_AES_256_GCM_SHA384 = "TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_PSK_WITH_NULL_SHA = "TLS_PSK_WITH_NULL_SHA",
      TLS1_RFC_DHE_PSK_WITH_NULL_SHA = "TLS_DHE_PSK_WITH_NULL_SHA",
      TLS1_RFC_RSA_PSK_WITH_NULL_SHA = "TLS_RSA_PSK_WITH_NULL_SHA",
      TLS1_RFC_PSK_WITH_3DES_EDE_CBC_SHA = "TLS_PSK_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_PSK_WITH_AES_128_CBC_SHA = "TLS_PSK_WITH_AES_128_CBC_SHA",
      TLS1_RFC_PSK_WITH_AES_256_CBC_SHA = "TLS_PSK_WITH_AES_256_CBC_SHA",
      TLS1_RFC_DHE_PSK_WITH_3DES_EDE_CBC_SHA = "TLS_DHE_PSK_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_DHE_PSK_WITH_AES_128_CBC_SHA = "TLS_DHE_PSK_WITH_AES_128_CBC_SHA",
      TLS1_RFC_DHE_PSK_WITH_AES_256_CBC_SHA = "TLS_DHE_PSK_WITH_AES_256_CBC_SHA",
      TLS1_RFC_RSA_PSK_WITH_3DES_EDE_CBC_SHA = "TLS_RSA_PSK_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_RSA_PSK_WITH_AES_128_CBC_SHA = "TLS_RSA_PSK_WITH_AES_128_CBC_SHA",
      TLS1_RFC_RSA_PSK_WITH_AES_256_CBC_SHA = "TLS_RSA_PSK_WITH_AES_256_CBC_SHA",
      TLS1_RFC_PSK_WITH_AES_128_GCM_SHA256 = "TLS_PSK_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_PSK_WITH_AES_256_GCM_SHA384 = "TLS_PSK_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_DHE_PSK_WITH_AES_128_GCM_SHA256 = "TLS_DHE_PSK_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_DHE_PSK_WITH_AES_256_GCM_SHA384 = "TLS_DHE_PSK_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_RSA_PSK_WITH_AES_128_GCM_SHA256 = "TLS_RSA_PSK_WITH_AES_128_GCM_SHA256",
      TLS1_RFC_RSA_PSK_WITH_AES_256_GCM_SHA384 = "TLS_RSA_PSK_WITH_AES_256_GCM_SHA384",
      TLS1_RFC_PSK_WITH_AES_128_CBC_SHA256 = "TLS_PSK_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_PSK_WITH_AES_256_CBC_SHA384 = "TLS_PSK_WITH_AES_256_CBC_SHA384",
      TLS1_RFC_PSK_WITH_NULL_SHA256 = "TLS_PSK_WITH_NULL_SHA256",
      TLS1_RFC_PSK_WITH_NULL_SHA384 = "TLS_PSK_WITH_NULL_SHA384",
      TLS1_RFC_DHE_PSK_WITH_AES_128_CBC_SHA256 = "TLS_DHE_PSK_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_DHE_PSK_WITH_AES_256_CBC_SHA384 = "TLS_DHE_PSK_WITH_AES_256_CBC_SHA384",
      TLS1_RFC_DHE_PSK_WITH_NULL_SHA256 = "TLS_DHE_PSK_WITH_NULL_SHA256",
      TLS1_RFC_DHE_PSK_WITH_NULL_SHA384 = "TLS_DHE_PSK_WITH_NULL_SHA384",
      TLS1_RFC_RSA_PSK_WITH_AES_128_CBC_SHA256 = "TLS_RSA_PSK_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_RSA_PSK_WITH_AES_256_CBC_SHA384 = "TLS_RSA_PSK_WITH_AES_256_CBC_SHA384",
      TLS1_RFC_RSA_PSK_WITH_NULL_SHA256 = "TLS_RSA_PSK_WITH_NULL_SHA256",
      TLS1_RFC_RSA_PSK_WITH_NULL_SHA384 = "TLS_RSA_PSK_WITH_NULL_SHA384",
      TLS1_RFC_ECDHE_PSK_WITH_3DES_EDE_CBC_SHA = "TLS_ECDHE_PSK_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_ECDHE_PSK_WITH_AES_128_CBC_SHA = "TLS_ECDHE_PSK_WITH_AES_128_CBC_SHA",
      TLS1_RFC_ECDHE_PSK_WITH_AES_256_CBC_SHA = "TLS_ECDHE_PSK_WITH_AES_256_CBC_SHA",
      TLS1_RFC_ECDHE_PSK_WITH_AES_128_CBC_SHA256 = "TLS_ECDHE_PSK_WITH_AES_128_CBC_SHA256",
      TLS1_RFC_ECDHE_PSK_WITH_AES_256_CBC_SHA384 = "TLS_ECDHE_PSK_WITH_AES_256_CBC_SHA384",
      TLS1_RFC_ECDHE_PSK_WITH_NULL_SHA = "TLS_ECDHE_PSK_WITH_NULL_SHA",
      TLS1_RFC_ECDHE_PSK_WITH_NULL_SHA256 = "TLS_ECDHE_PSK_WITH_NULL_SHA256",
      TLS1_RFC_ECDHE_PSK_WITH_NULL_SHA384 = "TLS_ECDHE_PSK_WITH_NULL_SHA384",
      TLS1_RFC_SRP_SHA_WITH_3DES_EDE_CBC_SHA = "TLS_SRP_SHA_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_SRP_SHA_RSA_WITH_3DES_EDE_CBC_SHA = "TLS_SRP_SHA_RSA_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_SRP_SHA_DSS_WITH_3DES_EDE_CBC_SHA = "TLS_SRP_SHA_DSS_WITH_3DES_EDE_CBC_SHA",
      TLS1_RFC_SRP_SHA_WITH_AES_128_CBC_SHA = "TLS_SRP_SHA_WITH_AES_128_CBC_SHA",
      TLS1_RFC_SRP_SHA_RSA_WITH_AES_128_CBC_SHA = "TLS_SRP_SHA_RSA_WITH_AES_128_CBC_SHA",
      TLS1_RFC_SRP_SHA_DSS_WITH_AES_128_CBC_SHA = "TLS_SRP_SHA_DSS_WITH_AES_128_CBC_SHA",
      TLS1_RFC_SRP_SHA_WITH_AES_256_CBC_SHA = "TLS_SRP_SHA_WITH_AES_256_CBC_SHA",
      TLS1_RFC_SRP_SHA_RSA_WITH_AES_256_CBC_SHA = "TLS_SRP_SHA_RSA_WITH_AES_256_CBC_SHA",
      TLS1_RFC_SRP_SHA_DSS_WITH_AES_256_CBC_SHA = "TLS_SRP_SHA_DSS_WITH_AES_256_CBC_SHA",
      TLS1_RFC_DHE_RSA_WITH_CHACHA20_POLY1305 = "TLS_DHE_RSA_WITH_CHACHA20_POLY1305_SHA256",
      TLS1_RFC_ECDHE_RSA_WITH_CHACHA20_POLY1305 = "TLS_ECDHE_RSA_WITH_CHACHA20_POLY1305_SHA256",
      TLS1_RFC_ECDHE_ECDSA_WITH_CHACHA20_POLY1305 = "TLS_ECDHE_ECDSA_WITH_CHACHA20_POLY1305_SHA256",
      TLS1_RFC_PSK_WITH_CHACHA20_POLY1305 = "TLS_PSK_WITH_CHACHA20_POLY1305_SHA256",
      TLS1_RFC_ECDHE_PSK_WITH_CHACHA20_POLY1305 = "TLS_ECDHE_PSK_WITH_CHACHA20_POLY1305_SHA256",
      TLS1_RFC_DHE_PSK_WITH_CHACHA20_POLY1305 = "TLS_DHE_PSK_WITH_CHACHA20_POLY1305_SHA256",
      TLS1_RFC_RSA_PSK_WITH_CHACHA20_POLY1305 = "TLS_RSA_PSK_WITH_CHACHA20_POLY1305_SHA256",
      TLS1_RFC_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_RSA_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_ADH_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_DH_anon_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "TLS_RSA_WITH_CAMELLIA_256_CBC_SHA256",
      TLS1_RFC_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA256 = "TLS_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA256",
      TLS1_RFC_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "TLS_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA256",
      TLS1_RFC_ADH_WITH_CAMELLIA_256_CBC_SHA256 = "TLS_DH_anon_WITH_CAMELLIA_256_CBC_SHA256",
      TLS1_RFC_RSA_WITH_CAMELLIA_256_CBC_SHA = "TLS_RSA_WITH_CAMELLIA_256_CBC_SHA",
      TLS1_RFC_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA = "TLS_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA",
      TLS1_RFC_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA = "TLS_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA",
      TLS1_RFC_ADH_WITH_CAMELLIA_256_CBC_SHA = "TLS_DH_anon_WITH_CAMELLIA_256_CBC_SHA",
      TLS1_RFC_RSA_WITH_CAMELLIA_128_CBC_SHA = "TLS_RSA_WITH_CAMELLIA_128_CBC_SHA",
      TLS1_RFC_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA = "TLS_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA",
      TLS1_RFC_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA = "TLS_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA",
      TLS1_RFC_ADH_WITH_CAMELLIA_128_CBC_SHA = "TLS_DH_anon_WITH_CAMELLIA_128_CBC_SHA",
      TLS1_RFC_ECDHE_ECDSA_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_ECDHE_ECDSA_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_ECDHE_ECDSA_WITH_CAMELLIA_256_CBC_SHA384 = "TLS_ECDHE_ECDSA_WITH_CAMELLIA_256_CBC_SHA384",
      TLS1_RFC_ECDHE_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_ECDHE_RSA_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_ECDHE_RSA_WITH_CAMELLIA_256_CBC_SHA384 = "TLS_ECDHE_RSA_WITH_CAMELLIA_256_CBC_SHA384",
      TLS1_RFC_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_PSK_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "TLS_PSK_WITH_CAMELLIA_256_CBC_SHA384",
      TLS1_RFC_DHE_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_DHE_PSK_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_DHE_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "TLS_DHE_PSK_WITH_CAMELLIA_256_CBC_SHA384",
      TLS1_RFC_RSA_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_RSA_PSK_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_RSA_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "TLS_RSA_PSK_WITH_CAMELLIA_256_CBC_SHA384",
      TLS1_RFC_ECDHE_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "TLS_ECDHE_PSK_WITH_CAMELLIA_128_CBC_SHA256",
      TLS1_RFC_ECDHE_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "TLS_ECDHE_PSK_WITH_CAMELLIA_256_CBC_SHA384",
      TLS1_RFC_RSA_WITH_SEED_SHA = "TLS_RSA_WITH_SEED_CBC_SHA",
      TLS1_RFC_DHE_DSS_WITH_SEED_SHA = "TLS_DHE_DSS_WITH_SEED_CBC_SHA",
      TLS1_RFC_DHE_RSA_WITH_SEED_SHA = "TLS_DHE_RSA_WITH_SEED_CBC_SHA",
      TLS1_RFC_ADH_WITH_SEED_SHA = "TLS_DH_anon_WITH_SEED_CBC_SHA",
      TLS1_RFC_ECDHE_PSK_WITH_RC4_128_SHA = "TLS_ECDHE_PSK_WITH_RC4_128_SHA",
      TLS1_RFC_ECDH_anon_WITH_RC4_128_SHA = "TLS_ECDH_anon_WITH_RC4_128_SHA",
      TLS1_RFC_ECDHE_ECDSA_WITH_RC4_128_SHA = "TLS_ECDHE_ECDSA_WITH_RC4_128_SHA",
      TLS1_RFC_ECDHE_RSA_WITH_RC4_128_SHA = "TLS_ECDHE_RSA_WITH_RC4_128_SHA",
      TLS1_RFC_PSK_WITH_RC4_128_SHA = "TLS_PSK_WITH_RC4_128_SHA",
      TLS1_RFC_RSA_PSK_WITH_RC4_128_SHA = "TLS_RSA_PSK_WITH_RC4_128_SHA",
      TLS1_RFC_DHE_PSK_WITH_RC4_128_SHA = "TLS_DHE_PSK_WITH_RC4_128_SHA",
      TLS1_RFC_RSA_WITH_ARIA_128_GCM_SHA256 = "TLS_RSA_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_RSA_WITH_ARIA_256_GCM_SHA384 = "TLS_RSA_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_DHE_RSA_WITH_ARIA_128_GCM_SHA256 = "TLS_DHE_RSA_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_DHE_RSA_WITH_ARIA_256_GCM_SHA384 = "TLS_DHE_RSA_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_DH_RSA_WITH_ARIA_128_GCM_SHA256 = "TLS_DH_RSA_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_DH_RSA_WITH_ARIA_256_GCM_SHA384 = "TLS_DH_RSA_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_DHE_DSS_WITH_ARIA_128_GCM_SHA256 = "TLS_DHE_DSS_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_DHE_DSS_WITH_ARIA_256_GCM_SHA384 = "TLS_DHE_DSS_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_DH_DSS_WITH_ARIA_128_GCM_SHA256 = "TLS_DH_DSS_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_DH_DSS_WITH_ARIA_256_GCM_SHA384 = "TLS_DH_DSS_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_DH_anon_WITH_ARIA_128_GCM_SHA256 = "TLS_DH_anon_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_DH_anon_WITH_ARIA_256_GCM_SHA384 = "TLS_DH_anon_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_ECDHE_ECDSA_WITH_ARIA_128_GCM_SHA256 = "TLS_ECDHE_ECDSA_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_ECDHE_ECDSA_WITH_ARIA_256_GCM_SHA384 = "TLS_ECDHE_ECDSA_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_ECDH_ECDSA_WITH_ARIA_128_GCM_SHA256 = "TLS_ECDH_ECDSA_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_ECDH_ECDSA_WITH_ARIA_256_GCM_SHA384 = "TLS_ECDH_ECDSA_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_ECDHE_RSA_WITH_ARIA_128_GCM_SHA256 = "TLS_ECDHE_RSA_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_ECDHE_RSA_WITH_ARIA_256_GCM_SHA384 = "TLS_ECDHE_RSA_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_ECDH_RSA_WITH_ARIA_128_GCM_SHA256 = "TLS_ECDH_RSA_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_ECDH_RSA_WITH_ARIA_256_GCM_SHA384 = "TLS_ECDH_RSA_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_PSK_WITH_ARIA_128_GCM_SHA256 = "TLS_PSK_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_PSK_WITH_ARIA_256_GCM_SHA384 = "TLS_PSK_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_DHE_PSK_WITH_ARIA_128_GCM_SHA256 = "TLS_DHE_PSK_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_DHE_PSK_WITH_ARIA_256_GCM_SHA384 = "TLS_DHE_PSK_WITH_ARIA_256_GCM_SHA384",
      TLS1_RFC_RSA_PSK_WITH_ARIA_128_GCM_SHA256 = "TLS_RSA_PSK_WITH_ARIA_128_GCM_SHA256",
      TLS1_RFC_RSA_PSK_WITH_ARIA_256_GCM_SHA384 = "TLS_RSA_PSK_WITH_ARIA_256_GCM_SHA384",
      TLS1_TXT_DHE_DSS_WITH_RC4_128_SHA = "DHE-DSS-RC4-SHA",
      TLS1_TXT_PSK_WITH_NULL_SHA = "PSK-NULL-SHA",
      TLS1_TXT_DHE_PSK_WITH_NULL_SHA = "DHE-PSK-NULL-SHA",
      TLS1_TXT_RSA_PSK_WITH_NULL_SHA = "RSA-PSK-NULL-SHA",
      TLS1_TXT_RSA_WITH_AES_128_SHA = "AES128-SHA",
      TLS1_TXT_DH_DSS_WITH_AES_128_SHA = "DH-DSS-AES128-SHA",
      TLS1_TXT_DH_RSA_WITH_AES_128_SHA = "DH-RSA-AES128-SHA",
      TLS1_TXT_DHE_DSS_WITH_AES_128_SHA = "DHE-DSS-AES128-SHA",
      TLS1_TXT_DHE_RSA_WITH_AES_128_SHA = "DHE-RSA-AES128-SHA",
      TLS1_TXT_ADH_WITH_AES_128_SHA = "ADH-AES128-SHA",
      TLS1_TXT_RSA_WITH_AES_256_SHA = "AES256-SHA",
      TLS1_TXT_DH_DSS_WITH_AES_256_SHA = "DH-DSS-AES256-SHA",
      TLS1_TXT_DH_RSA_WITH_AES_256_SHA = "DH-RSA-AES256-SHA",
      TLS1_TXT_DHE_DSS_WITH_AES_256_SHA = "DHE-DSS-AES256-SHA",
      TLS1_TXT_DHE_RSA_WITH_AES_256_SHA = "DHE-RSA-AES256-SHA",
      TLS1_TXT_ADH_WITH_AES_256_SHA = "ADH-AES256-SHA",
      TLS1_TXT_ECDH_ECDSA_WITH_NULL_SHA = "ECDH-ECDSA-NULL-SHA",
      TLS1_TXT_ECDH_ECDSA_WITH_RC4_128_SHA = "ECDH-ECDSA-RC4-SHA",
      TLS1_TXT_ECDH_ECDSA_WITH_DES_192_CBC3_SHA = "ECDH-ECDSA-DES-CBC3-SHA",
      TLS1_TXT_ECDH_ECDSA_WITH_AES_128_CBC_SHA = "ECDH-ECDSA-AES128-SHA",
      TLS1_TXT_ECDH_ECDSA_WITH_AES_256_CBC_SHA = "ECDH-ECDSA-AES256-SHA",
      TLS1_TXT_ECDHE_ECDSA_WITH_NULL_SHA = "ECDHE-ECDSA-NULL-SHA",
      TLS1_TXT_ECDHE_ECDSA_WITH_RC4_128_SHA = "ECDHE-ECDSA-RC4-SHA",
      TLS1_TXT_ECDHE_ECDSA_WITH_DES_192_CBC3_SHA = "ECDHE-ECDSA-DES-CBC3-SHA",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_CBC_SHA = "ECDHE-ECDSA-AES128-SHA",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_CBC_SHA = "ECDHE-ECDSA-AES256-SHA",
      TLS1_TXT_ECDH_RSA_WITH_NULL_SHA = "ECDH-RSA-NULL-SHA",
      TLS1_TXT_ECDH_RSA_WITH_RC4_128_SHA = "ECDH-RSA-RC4-SHA",
      TLS1_TXT_ECDH_RSA_WITH_DES_192_CBC3_SHA = "ECDH-RSA-DES-CBC3-SHA",
      TLS1_TXT_ECDH_RSA_WITH_AES_128_CBC_SHA = "ECDH-RSA-AES128-SHA",
      TLS1_TXT_ECDH_RSA_WITH_AES_256_CBC_SHA = "ECDH-RSA-AES256-SHA",
      TLS1_TXT_ECDHE_RSA_WITH_NULL_SHA = "ECDHE-RSA-NULL-SHA",
      TLS1_TXT_ECDHE_RSA_WITH_RC4_128_SHA = "ECDHE-RSA-RC4-SHA",
      TLS1_TXT_ECDHE_RSA_WITH_DES_192_CBC3_SHA = "ECDHE-RSA-DES-CBC3-SHA",
      TLS1_TXT_ECDHE_RSA_WITH_AES_128_CBC_SHA = "ECDHE-RSA-AES128-SHA",
      TLS1_TXT_ECDHE_RSA_WITH_AES_256_CBC_SHA = "ECDHE-RSA-AES256-SHA",
      TLS1_TXT_ECDH_anon_WITH_NULL_SHA = "AECDH-NULL-SHA",
      TLS1_TXT_ECDH_anon_WITH_RC4_128_SHA = "AECDH-RC4-SHA",
      TLS1_TXT_ECDH_anon_WITH_DES_192_CBC3_SHA = "AECDH-DES-CBC3-SHA",
      TLS1_TXT_ECDH_anon_WITH_AES_128_CBC_SHA = "AECDH-AES128-SHA",
      TLS1_TXT_ECDH_anon_WITH_AES_256_CBC_SHA = "AECDH-AES256-SHA",
      TLS1_TXT_PSK_WITH_RC4_128_SHA = "PSK-RC4-SHA",
      TLS1_TXT_PSK_WITH_3DES_EDE_CBC_SHA = "PSK-3DES-EDE-CBC-SHA",
      TLS1_TXT_PSK_WITH_AES_128_CBC_SHA = "PSK-AES128-CBC-SHA",
      TLS1_TXT_PSK_WITH_AES_256_CBC_SHA = "PSK-AES256-CBC-SHA",
      TLS1_TXT_DHE_PSK_WITH_RC4_128_SHA = "DHE-PSK-RC4-SHA",
      TLS1_TXT_DHE_PSK_WITH_3DES_EDE_CBC_SHA = "DHE-PSK-3DES-EDE-CBC-SHA",
      TLS1_TXT_DHE_PSK_WITH_AES_128_CBC_SHA = "DHE-PSK-AES128-CBC-SHA",
      TLS1_TXT_DHE_PSK_WITH_AES_256_CBC_SHA = "DHE-PSK-AES256-CBC-SHA",
      TLS1_TXT_RSA_PSK_WITH_RC4_128_SHA = "RSA-PSK-RC4-SHA",
      TLS1_TXT_RSA_PSK_WITH_3DES_EDE_CBC_SHA = "RSA-PSK-3DES-EDE-CBC-SHA",
      TLS1_TXT_RSA_PSK_WITH_AES_128_CBC_SHA = "RSA-PSK-AES128-CBC-SHA",
      TLS1_TXT_RSA_PSK_WITH_AES_256_CBC_SHA = "RSA-PSK-AES256-CBC-SHA",
      TLS1_TXT_PSK_WITH_AES_128_GCM_SHA256 = "PSK-AES128-GCM-SHA256",
      TLS1_TXT_PSK_WITH_AES_256_GCM_SHA384 = "PSK-AES256-GCM-SHA384",
      TLS1_TXT_DHE_PSK_WITH_AES_128_GCM_SHA256 = "DHE-PSK-AES128-GCM-SHA256",
      TLS1_TXT_DHE_PSK_WITH_AES_256_GCM_SHA384 = "DHE-PSK-AES256-GCM-SHA384",
      TLS1_TXT_RSA_PSK_WITH_AES_128_GCM_SHA256 = "RSA-PSK-AES128-GCM-SHA256",
      TLS1_TXT_RSA_PSK_WITH_AES_256_GCM_SHA384 = "RSA-PSK-AES256-GCM-SHA384",
      TLS1_TXT_PSK_WITH_AES_128_CBC_SHA256 = "PSK-AES128-CBC-SHA256",
      TLS1_TXT_PSK_WITH_AES_256_CBC_SHA384 = "PSK-AES256-CBC-SHA384",
      TLS1_TXT_PSK_WITH_NULL_SHA256 = "PSK-NULL-SHA256",
      TLS1_TXT_PSK_WITH_NULL_SHA384 = "PSK-NULL-SHA384",
      TLS1_TXT_DHE_PSK_WITH_AES_128_CBC_SHA256 = "DHE-PSK-AES128-CBC-SHA256",
      TLS1_TXT_DHE_PSK_WITH_AES_256_CBC_SHA384 = "DHE-PSK-AES256-CBC-SHA384",
      TLS1_TXT_DHE_PSK_WITH_NULL_SHA256 = "DHE-PSK-NULL-SHA256",
      TLS1_TXT_DHE_PSK_WITH_NULL_SHA384 = "DHE-PSK-NULL-SHA384",
      TLS1_TXT_RSA_PSK_WITH_AES_128_CBC_SHA256 = "RSA-PSK-AES128-CBC-SHA256",
      TLS1_TXT_RSA_PSK_WITH_AES_256_CBC_SHA384 = "RSA-PSK-AES256-CBC-SHA384",
      TLS1_TXT_RSA_PSK_WITH_NULL_SHA256 = "RSA-PSK-NULL-SHA256",
      TLS1_TXT_RSA_PSK_WITH_NULL_SHA384 = "RSA-PSK-NULL-SHA384",
      TLS1_TXT_SRP_SHA_WITH_3DES_EDE_CBC_SHA = "SRP-3DES-EDE-CBC-SHA",
      TLS1_TXT_SRP_SHA_RSA_WITH_3DES_EDE_CBC_SHA = "SRP-RSA-3DES-EDE-CBC-SHA",
      TLS1_TXT_SRP_SHA_DSS_WITH_3DES_EDE_CBC_SHA = "SRP-DSS-3DES-EDE-CBC-SHA",
      TLS1_TXT_SRP_SHA_WITH_AES_128_CBC_SHA = "SRP-AES-128-CBC-SHA",
      TLS1_TXT_SRP_SHA_RSA_WITH_AES_128_CBC_SHA = "SRP-RSA-AES-128-CBC-SHA",
      TLS1_TXT_SRP_SHA_DSS_WITH_AES_128_CBC_SHA = "SRP-DSS-AES-128-CBC-SHA",
      TLS1_TXT_SRP_SHA_WITH_AES_256_CBC_SHA = "SRP-AES-256-CBC-SHA",
      TLS1_TXT_SRP_SHA_RSA_WITH_AES_256_CBC_SHA = "SRP-RSA-AES-256-CBC-SHA",
      TLS1_TXT_SRP_SHA_DSS_WITH_AES_256_CBC_SHA = "SRP-DSS-AES-256-CBC-SHA",
      TLS1_TXT_RSA_WITH_CAMELLIA_128_CBC_SHA = "CAMELLIA128-SHA",
      TLS1_TXT_DH_DSS_WITH_CAMELLIA_128_CBC_SHA = "DH-DSS-CAMELLIA128-SHA",
      TLS1_TXT_DH_RSA_WITH_CAMELLIA_128_CBC_SHA = "DH-RSA-CAMELLIA128-SHA",
      TLS1_TXT_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA = "DHE-DSS-CAMELLIA128-SHA",
      TLS1_TXT_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA = "DHE-RSA-CAMELLIA128-SHA",
      TLS1_TXT_ADH_WITH_CAMELLIA_128_CBC_SHA = "ADH-CAMELLIA128-SHA",
      TLS1_TXT_RSA_WITH_CAMELLIA_256_CBC_SHA = "CAMELLIA256-SHA",
      TLS1_TXT_DH_DSS_WITH_CAMELLIA_256_CBC_SHA = "DH-DSS-CAMELLIA256-SHA",
      TLS1_TXT_DH_RSA_WITH_CAMELLIA_256_CBC_SHA = "DH-RSA-CAMELLIA256-SHA",
      TLS1_TXT_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA = "DHE-DSS-CAMELLIA256-SHA",
      TLS1_TXT_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA = "DHE-RSA-CAMELLIA256-SHA",
      TLS1_TXT_ADH_WITH_CAMELLIA_256_CBC_SHA = "ADH-CAMELLIA256-SHA",
      TLS1_TXT_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "CAMELLIA128-SHA256",
      TLS1_TXT_DH_DSS_WITH_CAMELLIA_128_CBC_SHA256 = "DH-DSS-CAMELLIA128-SHA256",
      TLS1_TXT_DH_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "DH-RSA-CAMELLIA128-SHA256",
      TLS1_TXT_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA256 = "DHE-DSS-CAMELLIA128-SHA256",
      TLS1_TXT_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "DHE-RSA-CAMELLIA128-SHA256",
      TLS1_TXT_ADH_WITH_CAMELLIA_128_CBC_SHA256 = "ADH-CAMELLIA128-SHA256",
      TLS1_TXT_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "CAMELLIA256-SHA256",
      TLS1_TXT_DH_DSS_WITH_CAMELLIA_256_CBC_SHA256 = "DH-DSS-CAMELLIA256-SHA256",
      TLS1_TXT_DH_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "DH-RSA-CAMELLIA256-SHA256",
      TLS1_TXT_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA256 = "DHE-DSS-CAMELLIA256-SHA256",
      TLS1_TXT_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA256 = "DHE-RSA-CAMELLIA256-SHA256",
      TLS1_TXT_ADH_WITH_CAMELLIA_256_CBC_SHA256 = "ADH-CAMELLIA256-SHA256",
      TLS1_TXT_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "PSK-CAMELLIA128-SHA256",
      TLS1_TXT_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "PSK-CAMELLIA256-SHA384",
      TLS1_TXT_DHE_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "DHE-PSK-CAMELLIA128-SHA256",
      TLS1_TXT_DHE_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "DHE-PSK-CAMELLIA256-SHA384",
      TLS1_TXT_RSA_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "RSA-PSK-CAMELLIA128-SHA256",
      TLS1_TXT_RSA_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "RSA-PSK-CAMELLIA256-SHA384",
      TLS1_TXT_ECDHE_PSK_WITH_CAMELLIA_128_CBC_SHA256 = "ECDHE-PSK-CAMELLIA128-SHA256",
      TLS1_TXT_ECDHE_PSK_WITH_CAMELLIA_256_CBC_SHA384 = "ECDHE-PSK-CAMELLIA256-SHA384",
      TLS1_TXT_RSA_WITH_SEED_SHA = "SEED-SHA",
      TLS1_TXT_DH_DSS_WITH_SEED_SHA = "DH-DSS-SEED-SHA",
      TLS1_TXT_DH_RSA_WITH_SEED_SHA = "DH-RSA-SEED-SHA",
      TLS1_TXT_DHE_DSS_WITH_SEED_SHA = "DHE-DSS-SEED-SHA",
      TLS1_TXT_DHE_RSA_WITH_SEED_SHA = "DHE-RSA-SEED-SHA",
      TLS1_TXT_ADH_WITH_SEED_SHA = "ADH-SEED-SHA",
      TLS1_TXT_RSA_WITH_NULL_SHA256 = "NULL-SHA256",
      TLS1_TXT_RSA_WITH_AES_128_SHA256 = "AES128-SHA256",
      TLS1_TXT_RSA_WITH_AES_256_SHA256 = "AES256-SHA256",
      TLS1_TXT_DH_DSS_WITH_AES_128_SHA256 = "DH-DSS-AES128-SHA256",
      TLS1_TXT_DH_RSA_WITH_AES_128_SHA256 = "DH-RSA-AES128-SHA256",
      TLS1_TXT_DHE_DSS_WITH_AES_128_SHA256 = "DHE-DSS-AES128-SHA256",
      TLS1_TXT_DHE_RSA_WITH_AES_128_SHA256 = "DHE-RSA-AES128-SHA256",
      TLS1_TXT_DH_DSS_WITH_AES_256_SHA256 = "DH-DSS-AES256-SHA256",
      TLS1_TXT_DH_RSA_WITH_AES_256_SHA256 = "DH-RSA-AES256-SHA256",
      TLS1_TXT_DHE_DSS_WITH_AES_256_SHA256 = "DHE-DSS-AES256-SHA256",
      TLS1_TXT_DHE_RSA_WITH_AES_256_SHA256 = "DHE-RSA-AES256-SHA256",
      TLS1_TXT_ADH_WITH_AES_128_SHA256 = "ADH-AES128-SHA256",
      TLS1_TXT_ADH_WITH_AES_256_SHA256 = "ADH-AES256-SHA256",
      TLS1_TXT_RSA_WITH_AES_128_GCM_SHA256 = "AES128-GCM-SHA256",
      TLS1_TXT_RSA_WITH_AES_256_GCM_SHA384 = "AES256-GCM-SHA384",
      TLS1_TXT_DHE_RSA_WITH_AES_128_GCM_SHA256 = "DHE-RSA-AES128-GCM-SHA256",
      TLS1_TXT_DHE_RSA_WITH_AES_256_GCM_SHA384 = "DHE-RSA-AES256-GCM-SHA384",
      TLS1_TXT_DH_RSA_WITH_AES_128_GCM_SHA256 = "DH-RSA-AES128-GCM-SHA256",
      TLS1_TXT_DH_RSA_WITH_AES_256_GCM_SHA384 = "DH-RSA-AES256-GCM-SHA384",
      TLS1_TXT_DHE_DSS_WITH_AES_128_GCM_SHA256 = "DHE-DSS-AES128-GCM-SHA256",
      TLS1_TXT_DHE_DSS_WITH_AES_256_GCM_SHA384 = "DHE-DSS-AES256-GCM-SHA384",
      TLS1_TXT_DH_DSS_WITH_AES_128_GCM_SHA256 = "DH-DSS-AES128-GCM-SHA256",
      TLS1_TXT_DH_DSS_WITH_AES_256_GCM_SHA384 = "DH-DSS-AES256-GCM-SHA384",
      TLS1_TXT_ADH_WITH_AES_128_GCM_SHA256 = "ADH-AES128-GCM-SHA256",
      TLS1_TXT_ADH_WITH_AES_256_GCM_SHA384 = "ADH-AES256-GCM-SHA384",
      TLS1_TXT_RSA_WITH_AES_128_CCM = "AES128-CCM",
      TLS1_TXT_RSA_WITH_AES_256_CCM = "AES256-CCM",
      TLS1_TXT_DHE_RSA_WITH_AES_128_CCM = "DHE-RSA-AES128-CCM",
      TLS1_TXT_DHE_RSA_WITH_AES_256_CCM = "DHE-RSA-AES256-CCM",
      TLS1_TXT_RSA_WITH_AES_128_CCM_8 = "AES128-CCM8",
      TLS1_TXT_RSA_WITH_AES_256_CCM_8 = "AES256-CCM8",
      TLS1_TXT_DHE_RSA_WITH_AES_128_CCM_8 = "DHE-RSA-AES128-CCM8",
      TLS1_TXT_DHE_RSA_WITH_AES_256_CCM_8 = "DHE-RSA-AES256-CCM8",
      TLS1_TXT_PSK_WITH_AES_128_CCM = "PSK-AES128-CCM",
      TLS1_TXT_PSK_WITH_AES_256_CCM = "PSK-AES256-CCM",
      TLS1_TXT_DHE_PSK_WITH_AES_128_CCM = "DHE-PSK-AES128-CCM",
      TLS1_TXT_DHE_PSK_WITH_AES_256_CCM = "DHE-PSK-AES256-CCM",
      TLS1_TXT_PSK_WITH_AES_128_CCM_8 = "PSK-AES128-CCM8",
      TLS1_TXT_PSK_WITH_AES_256_CCM_8 = "PSK-AES256-CCM8",
      TLS1_TXT_DHE_PSK_WITH_AES_128_CCM_8 = "DHE-PSK-AES128-CCM8",
      TLS1_TXT_DHE_PSK_WITH_AES_256_CCM_8 = "DHE-PSK-AES256-CCM8",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_CCM = "ECDHE-ECDSA-AES128-CCM",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_CCM = "ECDHE-ECDSA-AES256-CCM",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_CCM_8 = "ECDHE-ECDSA-AES128-CCM8",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_CCM_8 = "ECDHE-ECDSA-AES256-CCM8",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_SHA256 = "ECDHE-ECDSA-AES128-SHA256",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_SHA384 = "ECDHE-ECDSA-AES256-SHA384",
      TLS1_TXT_ECDH_ECDSA_WITH_AES_128_SHA256 = "ECDH-ECDSA-AES128-SHA256",
      TLS1_TXT_ECDH_ECDSA_WITH_AES_256_SHA384 = "ECDH-ECDSA-AES256-SHA384",
      TLS1_TXT_ECDHE_RSA_WITH_AES_128_SHA256 = "ECDHE-RSA-AES128-SHA256",
      TLS1_TXT_ECDHE_RSA_WITH_AES_256_SHA384 = "ECDHE-RSA-AES256-SHA384",
      TLS1_TXT_ECDH_RSA_WITH_AES_128_SHA256 = "ECDH-RSA-AES128-SHA256",
      TLS1_TXT_ECDH_RSA_WITH_AES_256_SHA384 = "ECDH-RSA-AES256-SHA384",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256 = "ECDHE-ECDSA-AES128-GCM-SHA256",
      TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384 = "ECDHE-ECDSA-AES256-GCM-SHA384",
      TLS1_TXT_ECDH_ECDSA_WITH_AES_128_GCM_SHA256 = "ECDH-ECDSA-AES128-GCM-SHA256",
      TLS1_TXT_ECDH_ECDSA_WITH_AES_256_GCM_SHA384 = "ECDH-ECDSA-AES256-GCM-SHA384",
      TLS1_TXT_ECDHE_RSA_WITH_AES_128_GCM_SHA256 = "ECDHE-RSA-AES128-GCM-SHA256",
      TLS1_TXT_ECDHE_RSA_WITH_AES_256_GCM_SHA384 = "ECDHE-RSA-AES256-GCM-SHA384",
      TLS1_TXT_ECDH_RSA_WITH_AES_128_GCM_SHA256 = "ECDH-RSA-AES128-GCM-SHA256",
      TLS1_TXT_ECDH_RSA_WITH_AES_256_GCM_SHA384 = "ECDH-RSA-AES256-GCM-SHA384",
      TLS1_TXT_ECDHE_PSK_WITH_RC4_128_SHA = "ECDHE-PSK-RC4-SHA",
      TLS1_TXT_ECDHE_PSK_WITH_3DES_EDE_CBC_SHA = "ECDHE-PSK-3DES-EDE-CBC-SHA",
      TLS1_TXT_ECDHE_PSK_WITH_AES_128_CBC_SHA = "ECDHE-PSK-AES128-CBC-SHA",
      TLS1_TXT_ECDHE_PSK_WITH_AES_256_CBC_SHA = "ECDHE-PSK-AES256-CBC-SHA",
      TLS1_TXT_ECDHE_PSK_WITH_AES_128_CBC_SHA256 = "ECDHE-PSK-AES128-CBC-SHA256",
      TLS1_TXT_ECDHE_PSK_WITH_AES_256_CBC_SHA384 = "ECDHE-PSK-AES256-CBC-SHA384",
      TLS1_TXT_ECDHE_PSK_WITH_NULL_SHA = "ECDHE-PSK-NULL-SHA",
      TLS1_TXT_ECDHE_PSK_WITH_NULL_SHA256 = "ECDHE-PSK-NULL-SHA256",
      TLS1_TXT_ECDHE_PSK_WITH_NULL_SHA384 = "ECDHE-PSK-NULL-SHA384",
      TLS1_TXT_ECDHE_ECDSA_WITH_CAMELLIA_128_CBC_SHA256 = "ECDHE-ECDSA-CAMELLIA128-SHA256",
      TLS1_TXT_ECDHE_ECDSA_WITH_CAMELLIA_256_CBC_SHA384 = "ECDHE-ECDSA-CAMELLIA256-SHA384",
      TLS1_TXT_ECDH_ECDSA_WITH_CAMELLIA_128_CBC_SHA256 = "ECDH-ECDSA-CAMELLIA128-SHA256",
      TLS1_TXT_ECDH_ECDSA_WITH_CAMELLIA_256_CBC_SHA384 = "ECDH-ECDSA-CAMELLIA256-SHA384",
      TLS1_TXT_ECDHE_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "ECDHE-RSA-CAMELLIA128-SHA256",
      TLS1_TXT_ECDHE_RSA_WITH_CAMELLIA_256_CBC_SHA384 = "ECDHE-RSA-CAMELLIA256-SHA384",
      TLS1_TXT_ECDH_RSA_WITH_CAMELLIA_128_CBC_SHA256 = "ECDH-RSA-CAMELLIA128-SHA256",
      TLS1_TXT_ECDH_RSA_WITH_CAMELLIA_256_CBC_SHA384 = "ECDH-RSA-CAMELLIA256-SHA384",
      TLS1_TXT_ECDHE_RSA_WITH_CHACHA20_POLY1305 = "ECDHE-RSA-CHACHA20-POLY1305",
      TLS1_TXT_ECDHE_ECDSA_WITH_CHACHA20_POLY1305 = "ECDHE-ECDSA-CHACHA20-POLY1305",
      TLS1_TXT_DHE_RSA_WITH_CHACHA20_POLY1305 = "DHE-RSA-CHACHA20-POLY1305",
      TLS1_TXT_PSK_WITH_CHACHA20_POLY1305 = "PSK-CHACHA20-POLY1305",
      TLS1_TXT_ECDHE_PSK_WITH_CHACHA20_POLY1305 = "ECDHE-PSK-CHACHA20-POLY1305",
      TLS1_TXT_DHE_PSK_WITH_CHACHA20_POLY1305 = "DHE-PSK-CHACHA20-POLY1305",
      TLS1_TXT_RSA_PSK_WITH_CHACHA20_POLY1305 = "RSA-PSK-CHACHA20-POLY1305",
      TLS1_TXT_RSA_WITH_ARIA_128_GCM_SHA256 = "ARIA128-GCM-SHA256",
      TLS1_TXT_RSA_WITH_ARIA_256_GCM_SHA384 = "ARIA256-GCM-SHA384",
      TLS1_TXT_DHE_RSA_WITH_ARIA_128_GCM_SHA256 = "DHE-RSA-ARIA128-GCM-SHA256",
      TLS1_TXT_DHE_RSA_WITH_ARIA_256_GCM_SHA384 = "DHE-RSA-ARIA256-GCM-SHA384",
      TLS1_TXT_DH_RSA_WITH_ARIA_128_GCM_SHA256 = "DH-RSA-ARIA128-GCM-SHA256",
      TLS1_TXT_DH_RSA_WITH_ARIA_256_GCM_SHA384 = "DH-RSA-ARIA256-GCM-SHA384",
      TLS1_TXT_DHE_DSS_WITH_ARIA_128_GCM_SHA256 = "DHE-DSS-ARIA128-GCM-SHA256",
      TLS1_TXT_DHE_DSS_WITH_ARIA_256_GCM_SHA384 = "DHE-DSS-ARIA256-GCM-SHA384",
      TLS1_TXT_DH_DSS_WITH_ARIA_128_GCM_SHA256 = "DH-DSS-ARIA128-GCM-SHA256",
      TLS1_TXT_DH_DSS_WITH_ARIA_256_GCM_SHA384 = "DH-DSS-ARIA256-GCM-SHA384",
      TLS1_TXT_DH_anon_WITH_ARIA_128_GCM_SHA256 = "ADH-ARIA128-GCM-SHA256",
      TLS1_TXT_DH_anon_WITH_ARIA_256_GCM_SHA384 = "ADH-ARIA256-GCM-SHA384",
      TLS1_TXT_ECDHE_ECDSA_WITH_ARIA_128_GCM_SHA256 = "ECDHE-ECDSA-ARIA128-GCM-SHA256",
      TLS1_TXT_ECDHE_ECDSA_WITH_ARIA_256_GCM_SHA384 = "ECDHE-ECDSA-ARIA256-GCM-SHA384",
      TLS1_TXT_ECDH_ECDSA_WITH_ARIA_128_GCM_SHA256 = "ECDH-ECDSA-ARIA128-GCM-SHA256",
      TLS1_TXT_ECDH_ECDSA_WITH_ARIA_256_GCM_SHA384 = "ECDH-ECDSA-ARIA256-GCM-SHA384",
      TLS1_TXT_ECDHE_RSA_WITH_ARIA_128_GCM_SHA256 = "ECDHE-ARIA128-GCM-SHA256",
      TLS1_TXT_ECDHE_RSA_WITH_ARIA_256_GCM_SHA384 = "ECDHE-ARIA256-GCM-SHA384",
      TLS1_TXT_ECDH_RSA_WITH_ARIA_128_GCM_SHA256 = "ECDH-ARIA128-GCM-SHA256",
      TLS1_TXT_ECDH_RSA_WITH_ARIA_256_GCM_SHA384 = "ECDH-ARIA256-GCM-SHA384",
      TLS1_TXT_PSK_WITH_ARIA_128_GCM_SHA256 = "PSK-ARIA128-GCM-SHA256",
      TLS1_TXT_PSK_WITH_ARIA_256_GCM_SHA384 = "PSK-ARIA256-GCM-SHA384",
      TLS1_TXT_DHE_PSK_WITH_ARIA_128_GCM_SHA256 = "DHE-PSK-ARIA128-GCM-SHA256",
      TLS1_TXT_DHE_PSK_WITH_ARIA_256_GCM_SHA384 = "DHE-PSK-ARIA256-GCM-SHA384",
      TLS1_TXT_RSA_PSK_WITH_ARIA_128_GCM_SHA256 = "RSA-PSK-ARIA128-GCM-SHA256",
      TLS1_TXT_RSA_PSK_WITH_ARIA_256_GCM_SHA384 = "RSA-PSK-ARIA256-GCM-SHA384",
      TLS_CT_RSA_SIGN = 1,
      TLS_CT_DSS_SIGN = 2,
      TLS_CT_RSA_FIXED_DH = 3,
      TLS_CT_DSS_FIXED_DH = 4,
      TLS_CT_ECDSA_SIGN = 64,
      TLS_CT_RSA_FIXED_ECDH = 65,
      TLS_CT_ECDSA_FIXED_ECDH = 66,
      TLS_CT_GOST01_SIGN = 22,
      TLS_CT_GOST12_IANA_SIGN = 67,
      TLS_CT_GOST12_IANA_512_SIGN = 68,
      TLS_CT_GOST12_LEGACY_SIGN = 238,
      TLS_CT_GOST12_LEGACY_512_SIGN = 239,
      TLS_CT_NUMBER = 12,
      TLS1_FINISH_MAC_LENGTH = 12,
      TLS_MD_MAX_CONST_SIZE = 22,
      TLS_MD_CLIENT_FINISH_CONST = "client",
      TLS_MD_CLIENT_FINISH_CONST_SIZE = 15,
      TLS_MD_SERVER_FINISH_CONST = "server",
      TLS_MD_SERVER_FINISH_CONST_SIZE = 15,
      TLS_MD_KEY_EXPANSION_CONST = "key",
      TLS_MD_KEY_EXPANSION_CONST_SIZE = 13,
      TLS_MD_CLIENT_WRITE_KEY_CONST = "client",
      TLS_MD_CLIENT_WRITE_KEY_CONST_SIZE = 16,
      TLS_MD_SERVER_WRITE_KEY_CONST = "server",
      TLS_MD_SERVER_WRITE_KEY_CONST_SIZE = 16,
      TLS_MD_IV_BLOCK_CONST = "IV",
      TLS_MD_IV_BLOCK_CONST_SIZE = 8,
      TLS_MD_MASTER_SECRET_CONST = "master",
      TLS_MD_MASTER_SECRET_CONST_SIZE = 13,
      TLS_MD_EXTENDED_MASTER_SECRET_CONST = "extended",
      TLS_MD_EXTENDED_MASTER_SECRET_CONST_SIZE = 22,
      OSSL_TRACE_CATEGORY_ALL = "0",
      OSSL_TRACE_CATEGORY_TRACE = 1,
      OSSL_TRACE_CATEGORY_INIT = 2,
      OSSL_TRACE_CATEGORY_TLS = 3,
      OSSL_TRACE_CATEGORY_TLS_CIPHER = 4,
      OSSL_TRACE_CATEGORY_CONF = 5,
      OSSL_TRACE_CATEGORY_PKCS5V2 = 8,
      OSSL_TRACE_CATEGORY_PKCS12_KEYGEN = 9,
      OSSL_TRACE_CATEGORY_PKCS12_DECRYPT = 10,
      OSSL_TRACE_CATEGORY_X509V3_POLICY = 11,
      OSSL_TRACE_CATEGORY_BN_CTX = 12,
      OSSL_TRACE_CATEGORY_CMP = 13,
      OSSL_TRACE_CATEGORY_STORE = 14,
      OSSL_TRACE_CATEGORY_DECODER = 15,
      OSSL_TRACE_CATEGORY_ENCODER = 16,
      OSSL_TRACE_CATEGORY_REF_COUNT = 17,
      OSSL_TRACE_CATEGORY_NUM = 18,
      OSSL_TRACE_CTRL_BEGIN = "0",
      OSSL_TRACE_CTRL_WRITE = 1,
      OSSL_TRACE_CTRL_END = 2,
      TS_STATUS_GRANTED = "0",
      TS_STATUS_GRANTED_WITH_MODS = 1,
      TS_STATUS_REJECTION = 2,
      TS_STATUS_WAITING = 3,
      TS_STATUS_REVOCATION_WARNING = 4,
      TS_STATUS_REVOCATION_NOTIFICATION = 5,
      TS_INFO_BAD_ALG = "0",
      TS_INFO_BAD_REQUEST = 2,
      TS_INFO_BAD_DATA_FORMAT = 5,
      TS_INFO_TIME_NOT_AVAILABLE = 14,
      TS_INFO_UNACCEPTED_POLICY = 15,
      TS_INFO_UNACCEPTED_EXTENSION = 16,
      TS_INFO_ADD_INFO_NOT_AVAILABLE = 17,
      TS_INFO_SYSTEM_FAILURE = 25,
      TS_TSA_NAME = "0x01",
      TS_ORDERING = "0x02",
      TS_ESS_CERT_ID_CHAIN = "0x04",
      TS_MAX_CLOCK_PRECISION_DIGITS = 6,
      DB_ERROR_OK = "0",
      DB_ERROR_MALLOC = 1,
      DB_ERROR_INDEX_CLASH = 2,
      DB_ERROR_INDEX_OUT_OF_RANGE = 3,
      DB_ERROR_NO_INDEX = 4,
      DB_ERROR_INSERT_INDEX_CLASH = 5,
      DB_ERROR_WRONG_NUM_FIELDS = 6,
      UI_R_COMMON_OK_AND_CANCEL_CHARACTERS = 104,
      UI_R_INDEX_TOO_LARGE = 102,
      UI_R_INDEX_TOO_SMALL = 103,
      UI_R_NO_RESULT_BUFFER = 105,
      UI_R_PROCESSING_ERROR = 107,
      UI_R_RESULT_TOO_LARGE = 100,
      UI_R_RESULT_TOO_SMALL = 101,
      UI_R_SYSASSIGN_ERROR = 109,
      UI_R_SYSDASSGN_ERROR = 110,
      UI_R_SYSQIOW_ERROR = 111,
      UI_R_UNKNOWN_CONTROL_COMMAND = 106,
      UI_R_UNKNOWN_TTYGET_ERRNO_VALUE = 108,
      UI_R_USER_DATA_DUPLICATION_UNSUPPORTED = 112,
      X509_R_AKID_MISMATCH = 110,
      X509_R_BAD_SELECTOR = 133,
      X509_R_BAD_X509_FILETYPE = 100,
      X509_R_BASE64_DECODE_ERROR = 118,
      X509_R_CANT_CHECK_DH_KEY = 114,
      X509_R_CERTIFICATE_VERIFICATION_FAILED = 139,
      X509_R_CERT_ALREADY_IN_HASH_TABLE = 101,
      X509_R_CRL_ALREADY_DELTA = 127,
      X509_R_CRL_VERIFY_FAILURE = 131,
      X509_R_ERROR_GETTING_MD_BY_NID = 141,
      X509_R_ERROR_USING_SIGINF_SET = 142,
      X509_R_IDP_MISMATCH = 128,
      X509_R_INVALID_ATTRIBUTES = 138,
      X509_R_INVALID_DIRECTORY = 113,
      X509_R_INVALID_DISTPOINT = 143,
      X509_R_INVALID_FIELD_NAME = 119,
      X509_R_INVALID_TRUST = 123,
      X509_R_ISSUER_MISMATCH = 129,
      X509_R_KEY_TYPE_MISMATCH = 115,
      X509_R_KEY_VALUES_MISMATCH = 116,
      X509_R_LOADING_CERT_DIR = 103,
      X509_R_LOADING_DEFAULTS = 104,
      X509_R_METHOD_NOT_SUPPORTED = 124,
      X509_R_NAME_TOO_LONG = 134,
      X509_R_NEWER_CRL_NOT_NEWER = 132,
      X509_R_NO_CERTIFICATE_FOUND = 135,
      X509_R_NO_CERTIFICATE_OR_CRL_FOUND = 136,
      X509_R_NO_CERT_SET_FOR_US_TO_VERIFY = 105,
      X509_R_NO_CRL_FOUND = 137,
      X509_R_NO_CRL_NUMBER = 130,
      X509_R_PUBLIC_KEY_DECODE_ERROR = 125,
      X509_R_PUBLIC_KEY_ENCODE_ERROR = 126,
      X509_R_SHOULD_RETRY = 106,
      X509_R_UNABLE_TO_FIND_PARAMETERS_IN_CHAIN = 107,
      X509_R_UNABLE_TO_GET_CERTS_PUBLIC_KEY = 108,
      X509_R_UNKNOWN_KEY_TYPE = 117,
      X509_R_UNKNOWN_NID = 109,
      X509_R_UNKNOWN_PURPOSE_ID = 121,
      X509_R_UNKNOWN_SIGID_ALGS = 144,
      X509_R_UNKNOWN_TRUST_ID = 120,
      X509_R_UNSUPPORTED_ALGORITHM = 111,
      X509_R_WRONG_LOOKUP_TYPE = 112,
      X509_R_WRONG_TYPE = 122,
      X509V3_R_BAD_IP_ADDRESS = 118,
      X509V3_R_BAD_OBJECT = 119,
      X509V3_R_BN_DEC2BN_ERROR = 100,
      X509V3_R_BN_TO_ASN1_INTEGER_ERROR = 101,
      X509V3_R_DIRNAME_ERROR = 149,
      X509V3_R_DISTPOINT_ALREADY_SET = 160,
      X509V3_R_DUPLICATE_ZONE_ID = 133,
      X509V3_R_EMPTY_KEY_USAGE = 169,
      X509V3_R_ERROR_CONVERTING_ZONE = 131,
      X509V3_R_ERROR_CREATING_EXTENSION = 144,
      X509V3_R_ERROR_IN_EXTENSION = 128,
      X509V3_R_EXPECTED_A_SECTION_NAME = 137,
      X509V3_R_EXTENSION_EXISTS = 145,
      X509V3_R_EXTENSION_NAME_ERROR = 115,
      X509V3_R_EXTENSION_NOT_FOUND = 102,
      X509V3_R_EXTENSION_SETTING_NOT_SUPPORTED = 103,
      X509V3_R_EXTENSION_VALUE_ERROR = 116,
      X509V3_R_ILLEGAL_EMPTY_EXTENSION = 151,
      X509V3_R_INCORRECT_POLICY_SYNTAX_TAG = 152,
      X509V3_R_INVALID_ASNUMBER = 162,
      X509V3_R_INVALID_ASRANGE = 163,
      X509V3_R_INVALID_BOOLEAN_STRING = 104,
      X509V3_R_INVALID_CERTIFICATE = 158,
      X509V3_R_INVALID_EMPTY_NAME = 108,
      X509V3_R_INVALID_EXTENSION_STRING = 105,
      X509V3_R_INVALID_INHERITANCE = 165,
      X509V3_R_INVALID_IPADDRESS = 166,
      X509V3_R_INVALID_MULTIPLE_RDNS = 161,
      X509V3_R_INVALID_NAME = 106,
      X509V3_R_INVALID_NULL_ARGUMENT = 107,
      X509V3_R_INVALID_NULL_VALUE = 109,
      X509V3_R_INVALID_NUMBER = 140,
      X509V3_R_INVALID_NUMBERS = 141,
      X509V3_R_INVALID_OBJECT_IDENTIFIER = 110,
      X509V3_R_INVALID_OPTION = 138,
      X509V3_R_INVALID_POLICY_IDENTIFIER = 134,
      X509V3_R_INVALID_PROXY_POLICY_SETTING = 153,
      X509V3_R_INVALID_PURPOSE = 146,
      X509V3_R_INVALID_SAFI = 164,
      X509V3_R_INVALID_SECTION = 135,
      X509V3_R_INVALID_SYNTAX = 143,
      X509V3_R_ISSUER_DECODE_ERROR = 126,
      X509V3_R_MISSING_VALUE = 124,
      X509V3_R_NEED_ORGANIZATION_AND_NUMBERS = 142,
      X509V3_R_NEGATIVE_PATHLEN = 168,
      X509V3_R_NO_CONFIG_DATABASE = 136,
      X509V3_R_NO_ISSUER_CERTIFICATE = 121,
      X509V3_R_NO_ISSUER_DETAILS = 127,
      X509V3_R_NO_POLICY_IDENTIFIER = 139,
      X509V3_R_NO_PROXY_CERT_POLICY_LANGUAGE_DEFINED = 154,
      X509V3_R_NO_PUBLIC_KEY = 114,
      X509V3_R_NO_SUBJECT_DETAILS = 125,
      X509V3_R_OPERATION_NOT_DEFINED = 148,
      X509V3_R_OTHERNAME_ERROR = 147,
      X509V3_R_POLICY_LANGUAGE_ALREADY_DEFINED = 155,
      X509V3_R_POLICY_PATH_LENGTH = 156,
      X509V3_R_POLICY_PATH_LENGTH_ALREADY_DEFINED = 157,
      X509V3_R_POLICY_WHEN_PROXY_LANGUAGE_REQUIRES_NO_POLICY = 159,
      X509V3_R_SECTION_NOT_FOUND = 150,
      X509V3_R_UNABLE_TO_GET_ISSUER_DETAILS = 122,
      X509V3_R_UNABLE_TO_GET_ISSUER_KEYID = 123,
      X509V3_R_UNKNOWN_BIT_STRING_ARGUMENT = 111,
      X509V3_R_UNKNOWN_EXTENSION = 129,
      X509V3_R_UNKNOWN_EXTENSION_NAME = 130,
      X509V3_R_UNKNOWN_OPTION = 120,
      X509V3_R_UNSUPPORTED_OPTION = 117,
      X509V3_R_UNSUPPORTED_TYPE = 167,
      X509V3_R_USER_TOO_LONG = 132,
      POINT_CONVERSION_COMPRESSED = 2,
      POINT_CONVERSION_UNCOMPRESSED = 4,
      POINT_CONVERSION_HYBRID = 6;
/**
 *
 * Class representing a LibCrypto instance.
 *
 */

class LibCrypto {
  /**
   *  LibCrypto ctor
   */
  constructor() {
    this.mallocBufferAddresses = [];
    this.wasi = null;
    this.wasiBytes = null;
    this.instance = null;
    this.init = false;
    this.key = null;
    this.maxRead = 1024 * 64;
    /**
     * The key usage extension defines the purpose (e.g., encipherment,
     * signature, certificate signing) of the key contained in the
     * certificate.
     *
     * {@link https://tools.ietf.org/html/rfc5280#section-4.2.1.3}
     * @namespace
     * @property {Boolean} digitalSignature - Subject Public Key (SPK) is used for verifying digital signatures
     * @property {Boolean} nonRepudiation - SPK used to verify digital signatures
     * @property {Boolean} keyEncipherment - SPK used for enciphering private or secret keys
     * @property {Boolean} dataEncipherment - SPK used for enciphering raw user data w/o an intermediate symmetric cipher
     * @property {Boolean} keyAgreement - SPK used for key agreement, used with encipherOnly / decipherOnly
     * @property {Boolean} keyCertSign - SPK used for verifying signatures on public key certificates
     * @property {Boolean} cRLSign - SPK used for verifying signatures on certificate revocation lists
     * @property {Boolean} encipherOnly - If keyAgreement set, enciphering data while performing key agreement
     * @property {Boolean} decipherOnly - If keyAgreement set, deciphering data while performing key agreement
     */

    this.keyUsage = {
      digitalSignature: false,
      nonRepudiation: false,
      keyEncipherment: false,
      dataEncipherment: false,
      keyAgreement: false,
      keyCertSign: false,
      cRLSign: false,
      encipherOnly: false,
      decipherOnly: false
    };
    /**
     * This extension indicates one or more purposes for which the certified
     * public key may be used, in addition to or in place of the basic
     * purposes indicated in the key usage extension
     *
     * {@link https://tools.ietf.org/html/rfc5280#section-4.2.1.12}
     * {@link https://tools.ietf.org/html/rfc6071#section-2.4}
     *
     * @namespace
     * @property {Boolean} serverAuth - TLS WWW server authentication
     * @property {Boolean} clientAuth - TLS WWW server authentication
     * @property {Boolean} codeSigning - Signing of downloadable executable code
     * @property {Boolean} emailProtection - Email protection
     * @property {Boolean} timeStamping - Binding the hash of an object to a time
     * @property {Boolean} OCSPSigning - Signing OCSP responses
     * @property {Boolean} ipsecIKE - Used for IP Security (IPsec) and Internet Key Exchange (IKE)
     * @property {Boolean} msCodeInd - Microsoft Individual Code Signing (authenticode)
     * @property {Boolean} msCodeCom - Microsoft Commercial Code Signing (authenticode)
     * @property {Boolean} msCTLSign - Microsoft Trust List Signing
     * @property {Boolean} msEFS - Microsoft Encrypting File System
     */

    this.extKeyUsage = {
      serverAuth: false,
      clientAuth: false,
      codeSigning: false,
      emailProtection: false,
      timeStamping: false,
      OCSPSigning: false,
      ipsecIKE: false,
      msCodeInd: false,
      msCodeCom: false,
      msCTLSign: false,
      msEFS: false
    };
    /**
     * The subject alternative name extension allows identities to be bound
     * to the subject of the certificate.
     *
     * {@link https://tools.ietf.org/html/rfc5280#section-4.2.1.6}
     */

    this.subjectAlternativeName = {
      URI: [],
      DNS: [],
      IP: [],
      email: []
    };
  }
  /**
   * Initialize the LibCrypto instance.
   * Compiles the core WebAssembly System Interface (WASI) compliant WebAssembly binary.
   *
   * @async
   * @function initialize
   * @return {undefined}
   */


  async initialize_JSPI() {
    if (!this.init) {
      this.instance = await libCrypto$1({
        memory: new WebAssembly.Memory({
          initial: 512,
          //  32MB (i.e. 512 64k pages)
          maximum: 65536 //   4GB (i.e. 64k 64k pages)

        }),
        table: new WebAssembly.Table({
          initial: 0,
          element: 'anyfunc'
        }),
        thisProgram: 'OpenZiti browZer',
        locateFile: function (path, scriptDirectory) {
          return path;
        }
      });
      this.init = true;
      this.readString(this.instance, this.instance._whichWASMstring); // console.log('initialize_JSPI() whichWASMstring is: ', pstring);
      // Alloc data structures related to TLS data handling

      this.instance._fd_kv_alloc(this.instance);
    }
  }

  async initialize_NO_JSPI() {
    if (!this.init) {
      this.instance = await libCrypto({
        memory: new WebAssembly.Memory({
          initial: 512,
          //  32MB (i.e. 512 64k pages)
          maximum: 65536 //   4GB (i.e. 64k 64k pages)

        }),
        table: new WebAssembly.Table({
          initial: 0,
          element: 'anyfunc'
        }),
        thisProgram: 'OpenZiti browZer',
        locateFile: function (path, scriptDirectory) {
          return path;
        }
      });
      this.init = true;
      this.readString(this.instance, this.instance._whichWASMstring); // console.log('initialize_NO_JSPI() whichWASMstring is: ', pstring);
      // Alloc data structures related to Inner-TLS data handling

      this.instance._fd_kv_alloc(this.instance);
    }
  }
  /**
   * Return WASM instance
   *
   * @function getWASMInstance
   */


  async getWASMInstance() {
    if (!this.init) throw Error("Not initialized; call .initialize_*() on LibCrypto");
    return this.instance;
  }

  validateWASMInstance(wasmInstance) {
    if (wasmInstance === this.instance) {
      return;
    }

    throw Error("invalid WASM instance specified");
  }
  /**
   * Creates the Key Usage comma-separated string from an object of NID parameters.
   *
   * @function calcKeyUsage
   * @param {object} KU - Object with NID as parameters.
   * @return {string} The comma-separated list of NIDs
   */


  calcKeyUsage = KU => Object.entries(KU).filter(kU => kU[1]).map(kU => kU[0]).join(",");
  /**
   * Memory management for buffers
   *
   * @function cleanupReferences
   * @return {undefined}
   */

  cleanupReferences(wasmInstance) {
    this.validateWASMInstance(wasmInstance);
    let {
      _destroyBuffer,
      _cleanup
    } = wasmInstance;

    while (this.mallocBufferAddresses.length) {
      _destroyBuffer(this.mallocBufferAddresses.pop());
    }

    _cleanup();
  }
  /**
   * Read UTF8 string from WASM memory location
   *
   * @function writeString
   * @param {number} memloc - Memory offset pointer
   * @return {string} UTF8 string
   */


  readString(wasmInstance, memloc) {
    let {
      maxRead
    } = this,
        _pstr = [],
        _char;

    let pview = new Uint8Array(wasmInstance.HEAPU8.buffer, memloc, maxRead);

    while ((_char = pview[_pstr.length]) && _pstr.length < maxRead) _pstr.push(_char);

    let result = new TextDecoder().decode(new Uint8Array(_pstr));

    if (result.match(/[0-9a-fA-F]{2}:/) && result.match(/:/g).length > result.length / 4) {
      result = result.replace(/:/g, "");
    }

    return result;
  }
  /**
   * Write UTF8 string to WASM memory location
   *
   * @function writeString
   * @param {string} str - String to write to memory location
   * @return {number} Memory offset pointer
   */


  writeString(wasmInstance, str) {
    if (!str) return 0;
    let {
      _createBuffer
    } = wasmInstance; // if (typeof str !== "string") {
    //   str = str.toString(str instanceof Buffer ? "hex" : 16);
    // }

    const strBuf = new TextEncoder().encode(str + "\0");

    let offset = _createBuffer(strBuf.length);

    this.mallocBufferAddresses.push(offset);
    const outBuf = new Uint8Array(wasmInstance.HEAPU8.buffer, offset, strBuf.length);

    for (let i = 0; i < strBuf.length; i++) {
      outBuf[i] = strBuf[i];
    }

    return offset;
  }
  /**
   * Write an array of 32-bit unsigned integers to WASM memory location
   *
   * @function writeUint32Array
   * @param {Uint32Array} uint32Array - array of 32-bit unsigned integers to write to wasm memory
   * @return {number} Memory offset pointer
   */


  writeUint32Array(wasmInstance, uint32Array) {
    this.validateWASMInstance(wasmInstance);
    uint32Array.push(0);
    let {
      _createBuffer
    } = wasmInstance;

    let offset = _createBuffer(4 * uint32Array.length);

    this.mallocBufferAddresses.push(offset);
    new Uint32Array(wasmInstance.HEAPU8.buffer, offset, uint32Array.length).set(Uint32Array.from(uint32Array));
    return offset;
  }
  /**
   * Load key from Buffer
   *
   * @function loadKey
   * @param {Buffer|ArrayBuffer|string|string[]|Object} [key=buffer] - Buffer to load
   * @return {number} Memory offset pointer
   */


  loadKey(key = Buffer.from([])) {
    if (!(key instanceof Buffer)) {
      key = Buffer.from(key);
    }

    this.key = key;
  }
  /**
   * The keyHex property is the current key in hexidecimal
   *
   * @type {string}
   * @return {string} Current key in hexidecimal
   */


  get keyHex() {
    return this.key ? this.key.toString("hex") : null;
  }
  /**
   * Convert key to serialization format
   *
   * @function convertKey
   * @param {Object} settings - The configuration object to tell OpenSSL how to format the key
   * @param {Buffer|ArrayBuffer|string|string[]|Object} [settings.key=null] - Key, default is current instance key. If not null, replaces key.
   * @param {number} [settings.curve=NID_secp521r1] - Numerical ID (NID) for the Elliptic Curve (EC) to use
   * @param {number} [settings.outputtype=NID_X9_62_id_ecPublicKey] - NID for OpenSSL output type
   * @param {number} [settings.outformat=V_ASN1_BIT_STRING] - NID for OpenSSL output format
   * @param {number} [settings.compressed=POINT_CONVERSION_UNCOMPRESSED] - Which X9.62 (ECDSA) form, for encoding an EC point
   * @param {string} [settings.password=null] - Password to use
   * @return {string} String representation of formatted key
   */
  // convertKey({
  //   key = null,
  //   curve = NID_secp521r1,
  //   outputtype = NID_X9_62_id_ecPublicKey,
  //   outformat = V_ASN1_BIT_STRING,
  //   compressed = POINT_CONVERSION_UNCOMPRESSED,
  //   password = null,
  // }) {
  //   if (key) {
  //     this.key = key;
  //   }
  //   if (!this.init) throw Error("Not initialized; call .initialize() on instance.");
  //   let { keyHex } = this;
  //   let writeoffset = this.writeString(keyHex);
  //   let memorylocation = this.instance.convertKey(curve, writeoffset, outputtype, outformat, compressed, this.writeString(password));
  //   let pstring = this.readString(memorylocation);
  //   this.cleanupReferences(undefined);
  //   return pstring;
  // }

  /**
   * Generate an RSA key
   *
   * @function generateKey
   * @return {string} String representation of formatted key
   */


  generateKey(wasmInstance) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._generateKey(EVP_PKEY_RSA);

    return memorylocation;
  }
  /**
   * Generate an EC key
   *
   * @function generateECKey
   * @return {string} String representation of formatted key
   */


  generateECKey(wasmInstance) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._generateECKey();

    return memorylocation;
  }
  /**
   * Get private key from an EC key
   *
   * @function getPrivateKeyPEM
   * @return {string} PEM representation of private key from specified EVP_PKEY
   */


  getPrivateKeyPEM(wasmInstance, pkey) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._getPrivateKeyPEM(pkey);

    let pstring = this.readString(wasmInstance, memorylocation);
    this.cleanupReferences(wasmInstance);
    return pstring;
  }
  /**
   * Get public key from an EC key
   *
   * @function getPublicKeyPEM
   * @return {string} PEM representation of public key from specified EVP_PKEY
   */


  getPublicKeyPEM(wasmInstance, pkey) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._getPublicKeyPEM(pkey);

    let pstring = this.readString(wasmInstance, memorylocation);
    this.cleanupReferences(wasmInstance);
    return pstring;
  }
  /**
   * Free an EC key
   *
   * @function freeECKey
   */
  // freeECKey(pkey) {
  //   if (!this.init) throw Error("Not initialized; call .initialize() on instance.");
  //   this.instance.freeECKey(pkey);
  // }

  /**
   * Create a certificate
   *
   * @function createCertificate
   * @param {Object} settings - The configuration object to tell OpenSSL how to format the key
   * @param {Buffer|ArrayBuffer|string|string[]|Object} [settings.key=null] - Key, default is current instance key. If not null, replaces key.
   * @param {number} [settings.curve=NID_secp521r1] - Numerical ID (NID) for the Elliptic Curve (EC) to use
   * @param {number} [settings.compressed=POINT_CONVERSION_UNCOMPRESSED] - Which X9.62 (ECDSA) form, for encoding an EC point
   * @param {string} [settings.password=null] - Password to use
   * @param {number} [settings.notBefore=0] - Certificate validity start in seconds from current system time
   * @param {number} [settings.notAfter=31536000] - Certificate validity stop in seconds from current system time
   * @param {number} [settings.version=3] - Certificate version
   * @param {string} [settings.issuer=C=US, ST=VA, L=DZM, O=MyOrg, OU=dev, CN=ISSUER] - Certificate issuer csv Distinguished Name (DN) string
   * @param {string} [settings.name=C=US, ST=VA, L=DZM, O=MyOrg, OU=dev, CN=NAME] - Certificate name csv Distinguished Name (DN) string
   * @param {number} [settings.id=0] - Certificate ID number
   * @param {Object} settings.basicConstraints - Basic constraints on this certificate
   * @param {Boolean} settings.basicConstraints.CA - The subject of the cert is a CA
   * @param {number} settings.basicConstraints.pathlen -  The max depth of valid cert paths that include cert
   * @param {Object|string} [settings.keyUsage=this.keyUsage] - Key usage extensions.
   * @param {Object|string} [settings.extKeyUsage=this.extKeyUsage] - Extended Key usage extensions.
   * @param {Object} [settings.subjectAlternativeName] - Object with properties enumerating SAN (additional host names) for certificate
   * @param {string} [settings.subjectKeyIdentifier=hash"] - Either hash per {@link https://tools.ietf.org/html/rfc3280#section-4.2.1.2} or a hex string (strongly discouraged).
   * @param {string} [settings.authorityKeyIdentifier=keyid:always] - {@link https://www.openssl.org/docs/man1.0.2/man5/x509v3_config.html} Can be either 'keyid', 'issuer', or both, each with optional value 'always'
   * @param {string} [settings.friendlyName=null] - Friendly Name for Microsoft .p12
   * @param {string} [settings.certificateSigningRequest=null] - CSR as a string
   * @param {number} [settings.outformat=NID_x509Certificate] - NID for the output format
   * @param {number} [settings.caPEM=null] - PEM of Certificate Authority for signing
   * @param {number} [settings.caCertificate=null] - CA Certificate
   * @return {string} String representation of certificate
   */
  // createCertificate({
  //   key = null,
  //   curve = null,
  //   compressed = POINT_CONVERSION_UNCOMPRESSED,
  //   password = null,
  //   notBefore = 0,
  //   notAfter = 31536000,
  //   version = 3,
  //   issuer = "C=US, ST=VA, L=DZM, O=MyOrg, OU=dev, CN=ISSUER",
  //   name = "C=US, ST=VA, L=DZM, O=MyOrg, OU=dev, CN=NAME",
  //   id = 0,
  //   basicConstraints = { CA: false, pathlen: 0, critical: true },
  //   keyUsage = this.keyUsage,
  //   extKeyUsage = this.extKeyUsage,
  //   subjectAlternativeName = this.subjectAlternativeName,
  //   subjectKeyIdentifier = "hash",
  //   authorityKeyIdentifier = "keyid:always",
  //   friendlyName = null,
  //   certificateSigningRequest = null,
  //   outformat = NID_x509Certificate,
  //   caPEM = null,
  //   caCertificate = null,
  // }) {
  //   this.key = key;
  //   id = parseInt(id).toString();
  //   let { keyHex, calcKeyUsage } = this;
  //   let _san = [];
  //   for (let ext in subjectAlternativeName) {
  //     let sE = subjectAlternativeName[ext];
  //     if (sE instanceof Array && sE.length) {
  //       sE.forEach((a) => {
  //         _san.push(`${ext}:${a}`);
  //       });
  //     }
  //   }
  //   let _critical = certificateSigningRequest ? "" : "critical,";
  //   let extensions = new Map([
  //     [NID_subject_key_identifier, subjectKeyIdentifier],
  //     [NID_authority_key_identifier, authorityKeyIdentifier],
  //     [NID_basic_constraints, `${certificateSigningRequest || basicConstraints.critical ? "critical," : ""}${basicConstraints.CA ? "CA:TRUE" : "CA:FALSE"}${basicConstraints.CA ? `,pathlen:${basicConstraints.pathlen}` : ""}`],
  //     [NID_key_usage, _critical + (typeof keyUsage === "string" ? keyUsage : calcKeyUsage(keyUsage))],
  //     [NID_ext_key_usage, typeof extKeyUsage === "string" ? extKeyUsage : calcKeyUsage(extKeyUsage)],
  //     [NID_subject_alt_name, _san.join(",")],
  //   ]);
  //   let memLocCert = this.instance.createCertificate(
  //     curve,
  //     compressed,
  //     this.writeString(password),
  //     notBefore,
  //     notAfter,
  //     version - 1,
  //     ...[keyHex, name, issuer, id, friendlyName, certificateSigningRequest].map((a) => this.writeString(a)),
  //     this.writeUint32Array(
  //       [...extensions.entries()]
  //         .filter((a) => a[1].length)
  //         .map((a) => [a[0], this.writeString(a[1])])
  //         .flat()
  //     ),
  //     outformat,
  //     ...[caPEM, caCertificate].map((a) => this.writeString(a))
  //   );
  //   let certString = this.readString(memLocCert);
  //   this.cleanupReferences(undefined);
  //   return certString;
  // }

  /**
   * Create a certificate signing request
   *
   * @function createCertificateSigningRequest
   * @param {Object} settings - The configuration object to tell OpenSSL how to format the key
   * @param {Buffer|ArrayBuffer|string|string[]|Object} [settings.key=null] - Key, default is current instance key. If not null, replaces key.
   * @param {number} [settings.curve=NID_secp521r1] - Numerical ID (NID) for the Elliptic Curve (EC) to use
   * @param {number} [settings.compressed=POINT_CONVERSION_UNCOMPRESSED] - Which X9.62 (ECDSA) form, for encoding an EC point
   * @param {string} [settings.password=null] - Password to use
   * @param {number} [settings.version=3] - Certificate version
   * @param {string} [settings.name=C=US, ST=VA, L=DZM, O=MyOrg, OU=dev, CN=NAME] - Certificate name csv Distinguished Name (DN) string
   * @param {number} [settings.id=0] - Certificate ID number
   * @param {Object} settings.basicConstraints - Basic constraints on this certificate
   * @param {Object|string} [settings.keyUsage=this.keyUsage] - Key usage extensions.
   * @param {Object|string} [settings.extKeyUsage=this.extKeyUsage] - Extended Key usage extensions.
   * @param {Object} [settings.subjectAlternativeName] - Object with properties enumerating SAN (additional host names) for certificate
   * @param {string} [settings.subjectKeyIdentifier=hash] - Either hash per {@link https://tools.ietf.org/html/rfc3280#section-4.2.1.2} or a hex string (strongly discouraged).
   * @return {string} String representation of certificate
   */


  createCertificateSigningRequest(wasmInstance, {
    key = null,
    curve = NID_secp521r1,
    compressed = POINT_CONVERSION_UNCOMPRESSED,
    password = null,
    version = 1,
    name = "C=US, ST=NC, L=DZM, O=OpenZiti, OU=browZer, CN=OTF",
    id = "0",
    basicConstraints = null,
    keyUsage = this.keyUsage,
    extKeyUsage = this.extKeyUsage,
    subjectAlternativeName = this.subjectAlternativeName,
    subjectKeyIdentifier = null
  }) {
    this.validateWASMInstance(wasmInstance);

    if (key) {
      this.key = key;
    }

    for (let ext in subjectAlternativeName) {
      let sE = subjectAlternativeName[ext];

      if (sE instanceof Array && sE.length) {
        sE.forEach(a => {
        });
      }
    }

    let extensions = new Map([]); //TODO requested extensions

    let memLocCSR = wasmInstance._createCertificateSigningRequest(curve, compressed, this.writeString(password), version - 1, key, this.writeString(name), this.writeString(id), this.writeUint32Array(wasmInstance, [...extensions.entries()].filter(a => a[1].length).map(a => [a[0], this.writeString(a[1])]).flat()));

    let certRequest = this.readString(wasmInstance, memLocCSR);
    this.cleanupReferences(wasmInstance);
    return certRequest;
  }
  /**
   * Range Check Private Key
   *
   * @function validPrivateKey
   * @static
   * @param {Buffer|ArrayBuffer|string|string[]|Object} privateKey - Private Key to compare
   * @param {string} [min=0] - Minimum value as a hex string
   * @param {string} [max=FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364140] - Maximum value as a hex string
   * @return {Boolean}
   */


  static validPrivateKey(privateKey, min = "0", max = "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364140") {
    if (!(privateKey instanceof Buffer)) {
      privateKey = Buffer.from(privateKey);
    }

    max = Buffer.from(max, "hex");
    min = Buffer.from(min, "hex");
    return Buffer.compare(max, privateKey) === 1 && Buffer.compare(privateKey, min) === 1;
  }
  /**
   * Create a new SSL_CTX object, which holds various configuration and data relevant to SSL/TLS or DTLS session establishment
   *
   * @function ssl_CTX_new
   */


  ssl_CTX_new(wasmInstance) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._ssl_CTX_new();

    return memorylocation;
  }
  /**
   * 
   * @param {*} ctx 
   * @param {*} pkey 
   * @returns 
   */


  ssl_CTX_add_private_key(wasmInstance, ctx, pkey) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._ssl_CTX_add_private_key(ctx, pkey);

    return memorylocation;
  }
  /**
   * 
   * @param {*} ctx 
   * @param {*} certPem 
   * @returns 
   */


  ssl_CTX_add_certificate(wasmInstance, ctx, certPem) {
    this.validateWASMInstance(wasmInstance);
    let certPemPointer = this.writeString(wasmInstance, certPem);
    if (certPemPointer == 0) return null;

    let memorylocation = wasmInstance._ssl_CTX_add_certificate(ctx, certPemPointer);

    return memorylocation;
  }
  /**
   * 
   * @param {*} ctx 
   * @param {*} casPem 
   * @returns 
   */


  ssl_CTX_add1_to_CA_list(wasmInstance, ctx, casPem) {
    this.validateWASMInstance(wasmInstance);
    let casPemPointer = this.writeString(wasmInstance, casPem);
    if (casPemPointer == 0) return null;

    let memorylocation = wasmInstance._ssl_CTX_add1_to_CA_list(ctx, casPemPointer);

    return memorylocation;
  }
  /**
   * 
   * @param {*} ctx 
   * @param {*} casPem 
   * @returns 
   */


  ssl_CTX_add_extra_chain_cert(wasmInstance, ctx, certPem) {
    this.validateWASMInstance(wasmInstance);
    let certPemPointer = this.writeString(wasmInstance, certPem);
    if (certPemPointer == 0) return null;

    let memorylocation = wasmInstance._ssl_CTX_add_extra_chain_cert(ctx, certPemPointer);

    return memorylocation;
  }

  ssl_CTX_verify_certificate_and_key(wasmInstance, ctx) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._ssl_CTX_verify_certificate_and_key(ctx);

    return memorylocation;
  }

  bio_new_ssl_connect(wasmInstance, ctx) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._bio_new_ssl_connect(ctx);

    return memorylocation;
  }

  bio_do_connect(wasmInstance, bio) {
    this.validateWASMInstance(wasmInstance);

    let result = wasmInstance._bio_do_connect(bio);

    return result;
  }

  ssl_new(wasmInstance, ctx) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._ssl_new(ctx);

    return memorylocation;
  } // bio_new_ssl_connect(ctx) {
  //   if (!this.init) throw Error("Not initialized; call .initialize() on instance.");
  //   let memorylocation = this.instance.bio_new_ssl_connect(ctx);
  //   return memorylocation;
  // }


  bio_get_ssl(wasmInstance, sbio) {
    this.validateWASMInstance(wasmInstance);

    let memorylocation = wasmInstance._bio_get_ssl(sbio);

    return memorylocation;
  }

  bio_set_conn_hostname(wasmInstance, sbio, conn_str) {
    this.validateWASMInstance(wasmInstance);
    let hostnamePointer = this.writeString(wasmInstance, conn_str);

    let result = wasmInstance._bio_set_conn_hostname(sbio, hostnamePointer);

    return result;
  }

  async ssl_do_handshake(wasmInstance, ssl) {
    this.validateWASMInstance(wasmInstance); // console.log('index.js calling wasmInstance.ssl_do_handshake() ssl is: ', ssl);

    let result = await wasmInstance._ssl_do_handshake(ssl); // console.log('index.js returned from wasmInstance.ssl_do_handshake() result is: ', result);

    return result;
  }

  ssl_is_init_finished(wasmInstance, ssl) {
    this.validateWASMInstance(wasmInstance);

    let result = wasmInstance._SSL_is_init_finished(ssl);

    return result;
  }

  ssl_get_verify_result(wasmInstance, ssl) {
    this.validateWASMInstance(wasmInstance);

    let result = wasmInstance._ssl_get_verify_result(ssl);

    return result;
  }

  fd_kv_alloc(wasmInstance) {
    this.validateWASMInstance(wasmInstance);

    wasmInstance._fd_kv_alloc();
  }
  /**
   *  
   */


  tls_enqueue(wasmInstance, fd, jsArrayBuffer) {
    this.validateWASMInstance(wasmInstance); // console.log(`tls_enqueue() entered: fd[${fd}]`);

    let tlsDataQueue = wasmInstance._fd_kv_getItem(fd); // if there isn't a TLSDataQueue for the specified FD...then allocate one


    if (!tlsDataQueue) {
      tlsDataQueue = wasmInstance._constructTLSDataQueue(fd, 64);

      wasmInstance._fd_kv_addItem(fd, tlsDataQueue);
    } // Copy the incoming chunk of encrypted data from JS memory into WASM memory


    let wasmArrayPtr = wasmInstance._allocateTLSDataBuf(jsArrayBuffer.byteLength);

    let wasmArray = new Uint8Array(wasmInstance.HEAPU8.buffer, wasmArrayPtr, jsArrayBuffer.byteLength);
    let dataArray = new Uint8Array(jsArrayBuffer);
    wasmArray.set(dataArray); // Add the chunk of encrypted data to the queue of data awaiting decryption for this FD

    wasmInstance._enqueueTLSData(tlsDataQueue, wasmArrayPtr, jsArrayBuffer.byteLength); // console.log('tls_enqueue() wasmInstance.enqueueTLSData returned: ', result);

  }
  /**
   *  
   */


  peekTLSData(wasmInstance, fd) {
    this.validateWASMInstance(wasmInstance);

    let tlsDataQueue = wasmInstance._fd_kv_getItem(fd);

    if (!tlsDataQueue) {
      return null;
    }

    return wasmInstance._peekTLSData(tlsDataQueue);
  }

  tls_write(wasmInstance, ssl, jsArrayBuffer) {
    this.validateWASMInstance(wasmInstance); // let { memory } = wasmInstance;
    // console.log('tls_write() ssl is: ', ssl);
    // console.log('tls_write() jsArrayBuffer is: ', jsArrayBuffer);
    // console.log('tls_write() jsArrayBuffer.byteLength is: ', jsArrayBuffer.byteLength);

    let wasmArrayPtr = wasmInstance._allocateTLSDataBuf(jsArrayBuffer.byteLength); // console.log('tls_write() memory.buffer is: ', wasmInstance.HEAPU8.buffer);
    // console.log('tls_write() wasmArrayPtr is: ', wasmArrayPtr);


    let wasmArray = new Uint8Array(wasmInstance.HEAPU8.buffer, wasmArrayPtr, jsArrayBuffer.byteLength);
    let dataArray = new Uint8Array(jsArrayBuffer);
    wasmArray.set(dataArray); // console.log('tls_write() wasmArray is: ', wasmArray);

    let result = wasmInstance._tls_write(ssl, wasmArrayPtr, jsArrayBuffer.byteLength); // console.log('tls_write() result is: ', result);


    return result;
  }

  async tls_read(wasmInstance, ssl) {
    this.validateWASMInstance(wasmInstance); // console.log('tls_read() ssl is: ', ssl);
    // let { memory } = wasmInstance;

    let len = 64 * 1024;

    let wasmArrayPtr = wasmInstance._allocateTLSDataBuf(len);

    let read_len = await wasmInstance._tls_read(ssl, wasmArrayPtr, len);

    if (read_len < 0) {
      let fd = await wasmInstance._SSL_get_fd(ssl);
      console.log('tls_read() wasmInstance._tls_read failed, returned [%d] for fd[%d] ', read_len, fd);
    } // Copy WASM memory to JavaScript memory


    let jsArray = new Uint8Array(read_len); // alloc new JS array

    let wasmArray = new Uint8Array(wasmInstance.HEAPU8.buffer, wasmArrayPtr, read_len); // Get a view of the wasm array

    jsArray.set(wasmArray); // copy wasm -> js

    wasmInstance._freeTLSDataBuf(wasmArrayPtr);

    return jsArray;
  }

  ssl_set_fd(wasmInstance, ssl, socket) {
    this.validateWASMInstance(wasmInstance);

    let result = wasmInstance._ssl_set_fd(ssl, socket);

    return result;
  }

  ssl_connect(wasmInstance, ssl) {
    this.validateWASMInstance(wasmInstance);

    let result = wasmInstance._ssl_connect(ssl);

    return result;
  }

}

export { AES_BLOCK_SIZE, ASN1_PKEY_ALIAS, ASN1_PKEY_CTRL_CMS_ENVELOPE, ASN1_PKEY_CTRL_CMS_IS_RI_TYPE_SUPPORTED, ASN1_PKEY_CTRL_CMS_RI_TYPE, ASN1_PKEY_CTRL_CMS_SIGN, ASN1_PKEY_CTRL_DEFAULT_MD_NID, ASN1_PKEY_CTRL_GET1_TLS_ENCPT, ASN1_PKEY_CTRL_PKCS7_ENCRYPT, ASN1_PKEY_CTRL_PKCS7_SIGN, ASN1_PKEY_CTRL_SET1_TLS_ENCPT, ASN1_PKEY_DYNAMIC, ASN1_PKEY_SIGPARAM_NULL, ASN1_R_ADDING_OBJECT, ASN1_R_ASN1_PARSE_ERROR, ASN1_R_ASN1_SIG_PARSE_ERROR, ASN1_R_AUX_ERROR, ASN1_R_BAD_OBJECT_HEADER, ASN1_R_BAD_TEMPLATE, ASN1_R_BMPSTRING_IS_WRONG_LENGTH, ASN1_R_BN_LIB, ASN1_R_BOOLEAN_IS_WRONG_LENGTH, ASN1_R_BUFFER_TOO_SMALL, ASN1_R_CIPHER_HAS_NO_OBJECT_IDENTIFIER, ASN1_R_CONTEXT_NOT_INITIALISED, ASN1_R_DATA_IS_WRONG, ASN1_R_DECODE_ERROR, ASN1_R_DEPTH_EXCEEDED, ASN1_R_DIGEST_AND_KEY_TYPE_NOT_SUPPORTED, ASN1_R_ENCODE_ERROR, ASN1_R_ERROR_GETTING_TIME, ASN1_R_ERROR_LOADING_SECTION, ASN1_R_ERROR_SETTING_CIPHER_PARAMS, ASN1_R_EXPECTING_AN_INTEGER, ASN1_R_EXPECTING_AN_OBJECT, ASN1_R_EXPLICIT_LENGTH_MISMATCH, ASN1_R_EXPLICIT_TAG_NOT_CONSTRUCTED, ASN1_R_FIELD_MISSING, ASN1_R_FIRST_NUM_TOO_LARGE, ASN1_R_HEADER_TOO_LONG, ASN1_R_ILLEGAL_BITSTRING_FORMAT, ASN1_R_ILLEGAL_BOOLEAN, ASN1_R_ILLEGAL_CHARACTERS, ASN1_R_ILLEGAL_FORMAT, ASN1_R_ILLEGAL_HEX, ASN1_R_ILLEGAL_IMPLICIT_TAG, ASN1_R_ILLEGAL_INTEGER, ASN1_R_ILLEGAL_NEGATIVE_VALUE, ASN1_R_ILLEGAL_NESTED_TAGGING, ASN1_R_ILLEGAL_NULL, ASN1_R_ILLEGAL_NULL_VALUE, ASN1_R_ILLEGAL_OBJECT, ASN1_R_ILLEGAL_OPTIONAL_ANY, ASN1_R_ILLEGAL_OPTIONS_ON_ITEM_TEMPLATE, ASN1_R_ILLEGAL_PADDING, ASN1_R_ILLEGAL_TAGGED_ANY, ASN1_R_ILLEGAL_TIME_VALUE, ASN1_R_ILLEGAL_ZERO_CONTENT, ASN1_R_INTEGER_NOT_ASCII_FORMAT, ASN1_R_INTEGER_TOO_LARGE_FOR_LONG, ASN1_R_INVALID_BIT_STRING_BITS_LEFT, ASN1_R_INVALID_BMPSTRING_LENGTH, ASN1_R_INVALID_DIGIT, ASN1_R_INVALID_MIME_TYPE, ASN1_R_INVALID_MODIFIER, ASN1_R_INVALID_NUMBER, ASN1_R_INVALID_OBJECT_ENCODING, ASN1_R_INVALID_SCRYPT_PARAMETERS, ASN1_R_INVALID_SEPARATOR, ASN1_R_INVALID_STRING_TABLE_VALUE, ASN1_R_INVALID_UNIVERSALSTRING_LENGTH, ASN1_R_INVALID_UTF8STRING, ASN1_R_INVALID_VALUE, ASN1_R_LENGTH_TOO_LONG, ASN1_R_LIST_ERROR, ASN1_R_MIME_NO_CONTENT_TYPE, ASN1_R_MIME_PARSE_ERROR, ASN1_R_MIME_SIG_PARSE_ERROR, ASN1_R_MISSING_EOC, ASN1_R_MISSING_SECOND_NUMBER, ASN1_R_MISSING_VALUE, ASN1_R_MSTRING_NOT_UNIVERSAL, ASN1_R_MSTRING_WRONG_TAG, ASN1_R_NESTED_ASN1_STRING, ASN1_R_NESTED_TOO_DEEP, ASN1_R_NON_HEX_CHARACTERS, ASN1_R_NOT_ASCII_FORMAT, ASN1_R_NOT_ENOUGH_DATA, ASN1_R_NO_CONTENT_TYPE, ASN1_R_NO_MATCHING_CHOICE_TYPE, ASN1_R_NO_MULTIPART_BODY_FAILURE, ASN1_R_NO_MULTIPART_BOUNDARY, ASN1_R_NO_SIG_CONTENT_TYPE, ASN1_R_NULL_IS_WRONG_LENGTH, ASN1_R_OBJECT_NOT_ASCII_FORMAT, ASN1_R_ODD_NUMBER_OF_CHARS, ASN1_R_SECOND_NUMBER_TOO_LARGE, ASN1_R_SEQUENCE_LENGTH_MISMATCH, ASN1_R_SEQUENCE_NOT_CONSTRUCTED, ASN1_R_SEQUENCE_OR_SET_NEEDS_CONFIG, ASN1_R_SHORT_LINE, ASN1_R_SIG_INVALID_MIME_TYPE, ASN1_R_STREAMING_NOT_SUPPORTED, ASN1_R_STRING_TOO_LONG, ASN1_R_STRING_TOO_SHORT, ASN1_R_THE_ASN1_OBJECT_IDENTIFIER_IS_NOT_KNOWN_FOR_THIS_MD, ASN1_R_TIME_NOT_ASCII_FORMAT, ASN1_R_TOO_LARGE, ASN1_R_TOO_LONG, ASN1_R_TOO_SMALL, ASN1_R_TYPE_NOT_CONSTRUCTED, ASN1_R_TYPE_NOT_PRIMITIVE, ASN1_R_UNEXPECTED_EOC, ASN1_R_UNIVERSALSTRING_IS_WRONG_LENGTH, ASN1_R_UNKNOWN_DIGEST, ASN1_R_UNKNOWN_FORMAT, ASN1_R_UNKNOWN_MESSAGE_DIGEST_ALGORITHM, ASN1_R_UNKNOWN_OBJECT_TYPE, ASN1_R_UNKNOWN_PUBLIC_KEY_TYPE, ASN1_R_UNKNOWN_SIGNATURE_ALGORITHM, ASN1_R_UNKNOWN_TAG, ASN1_R_UNSUPPORTED_ANY_DEFINED_BY_TYPE, ASN1_R_UNSUPPORTED_CIPHER, ASN1_R_UNSUPPORTED_PUBLIC_KEY_TYPE, ASN1_R_UNSUPPORTED_TYPE, ASN1_R_WRONG_INTEGER_TYPE, ASN1_R_WRONG_PUBLIC_KEY_TYPE, ASN1_R_WRONG_TAG, ASYNC_ERR, ASYNC_FINISH, ASYNC_NO_JOBS, ASYNC_PAUSE, ASYNC_R_FAILED_TO_SET_POOL, ASYNC_R_FAILED_TO_SWAP_CONTEXT, ASYNC_R_INIT_FAILED, ASYNC_R_INVALID_POOL_SIZE, ASYNC_STATUS_EAGAIN, ASYNC_STATUS_ERR, ASYNC_STATUS_OK, ASYNC_STATUS_UNSUPPORTED, BF_BLOCK, BIO_R_ACCEPT_ERROR, BIO_R_ADDRINFO_ADDR_IS_NOT_AF_INET, BIO_R_AMBIGUOUS_HOST_OR_SERVICE, BIO_R_BAD_FOPEN_MODE, BIO_R_BROKEN_PIPE, BIO_R_CONNECT_ERROR, BIO_R_CONNECT_TIMEOUT, BIO_R_GETHOSTBYNAME_ADDR_IS_NOT_AF_INET, BIO_R_GETSOCKNAME_ERROR, BIO_R_GETSOCKNAME_TRUNCATED_ADDRESS, BIO_R_GETTING_SOCKTYPE, BIO_R_INVALID_ARGUMENT, BIO_R_INVALID_SOCKET, BIO_R_IN_USE, BIO_R_LENGTH_TOO_LONG, BIO_R_LISTEN_V6_ONLY, BIO_R_LOOKUP_RETURNED_NOTHING, BIO_R_MALFORMED_HOST_OR_SERVICE, BIO_R_NBIO_CONNECT_ERROR, BIO_R_NO_ACCEPT_ADDR_OR_SERVICE_SPECIFIED, BIO_R_NO_HOSTNAME_OR_SERVICE_SPECIFIED, BIO_R_NO_PORT_DEFINED, BIO_R_NO_SUCH_FILE, BIO_R_NULL_PARAMETER, BIO_R_TRANSFER_ERROR, BIO_R_TRANSFER_TIMEOUT, BIO_R_UNABLE_TO_BIND_SOCKET, BIO_R_UNABLE_TO_CREATE_SOCKET, BIO_R_UNABLE_TO_KEEPALIVE, BIO_R_UNABLE_TO_LISTEN_SOCKET, BIO_R_UNABLE_TO_NODELAY, BIO_R_UNABLE_TO_REUSEADDR, BIO_R_UNAVAILABLE_IP_FAMILY, BIO_R_UNINITIALIZED, BIO_R_UNKNOWN_INFO_TYPE, BIO_R_UNSUPPORTED_IP_FAMILY, BIO_R_UNSUPPORTED_METHOD, BIO_R_UNSUPPORTED_PROTOCOL_FAMILY, BIO_R_WRITE_TO_READ_ONLY_BIO, BIO_R_WSASTARTUP, BN_BLINDING_NO_RECREATE, BN_BLINDING_NO_UPDATE, BN_FLG_CONSTTIME, BN_FLG_MALLOCED, BN_FLG_SECURE, BN_FLG_STATIC_DATA, BN_RAND_BOTTOM_ANY, BN_RAND_BOTTOM_ODD, BN_RAND_TOP_ANY, BN_RAND_TOP_ONE, BN_RAND_TOP_TWO, BN_R_ARG2_LT_ARG3, BN_R_BAD_RECIPROCAL, BN_R_BIGNUM_TOO_LONG, BN_R_BITS_TOO_SMALL, BN_R_CALLED_WITH_EVEN_MODULUS, BN_R_DIV_BY_ZERO, BN_R_ENCODING_ERROR, BN_R_EXPAND_ON_STATIC_BIGNUM_DATA, BN_R_INPUT_NOT_REDUCED, BN_R_INVALID_LENGTH, BN_R_INVALID_RANGE, BN_R_INVALID_SHIFT, BN_R_NOT_A_SQUARE, BN_R_NOT_INITIALIZED, BN_R_NO_INVERSE, BN_R_NO_SOLUTION, BN_R_NO_SUITABLE_DIGEST, BN_R_PRIVATE_KEY_TOO_LARGE, BN_R_P_IS_NOT_PRIME, BN_R_TOO_MANY_ITERATIONS, BN_R_TOO_MANY_TEMPORARY_VARIABLES, BUF_MEM_FLAG_SECURE, CAMELLIA_BLOCK_SIZE, CAST_BLOCK, CAST_KEY_LENGTH, CONF_R_ERROR_LOADING_DSO, CONF_R_INVALID_PRAGMA, CONF_R_LIST_CANNOT_BE_NULL, CONF_R_MANDATORY_BRACES_IN_VARIABLE_EXPANSION, CONF_R_MISSING_CLOSE_SQUARE_BRACKET, CONF_R_MISSING_EQUAL_SIGN, CONF_R_MISSING_INIT_FUNCTION, CONF_R_MODULE_INITIALIZATION_ERROR, CONF_R_NO_CLOSE_BRACE, CONF_R_NO_CONF, CONF_R_NO_CONF_OR_ENVIRONMENT_VARIABLE, CONF_R_NO_SECTION, CONF_R_NO_SUCH_FILE, CONF_R_NO_VALUE, CONF_R_NUMBER_TOO_LARGE, CONF_R_OPENSSL_CONF_REFERENCES_MISSING_SECTION, CONF_R_RECURSIVE_DIRECTORY_INCLUDE, CONF_R_RELATIVE_PATH, CONF_R_SSL_COMMAND_SECTION_EMPTY, CONF_R_SSL_COMMAND_SECTION_NOT_FOUND, CONF_R_SSL_SECTION_EMPTY, CONF_R_SSL_SECTION_NOT_FOUND, CONF_R_UNABLE_TO_CREATE_NEW_SECTION, CONF_R_UNKNOWN_MODULE_NAME, CONF_R_VARIABLE_EXPANSION_TOO_LONG, CONF_R_VARIABLE_HAS_NO_VALUE, CRYPTO_R_BAD_ALGORITHM_NAME, CRYPTO_R_CONFLICTING_NAMES, CRYPTO_R_HEX_STRING_TOO_SHORT, CRYPTO_R_ILLEGAL_HEX_DIGIT, CRYPTO_R_INSUFFICIENT_DATA_SPACE, CRYPTO_R_INSUFFICIENT_PARAM_SIZE, CRYPTO_R_INSUFFICIENT_SECURE_DATA_SPACE, CRYPTO_R_INVALID_NEGATIVE_VALUE, CRYPTO_R_INVALID_NULL_ARGUMENT, CRYPTO_R_INVALID_OSSL_PARAM_TYPE, CRYPTO_R_ODD_NUMBER_OF_DIGITS, CRYPTO_R_PROVIDER_ALREADY_EXISTS, CRYPTO_R_PROVIDER_SECTION_ERROR, CRYPTO_R_RANDOM_SECTION_ERROR, CRYPTO_R_SECURE_MALLOC_FAILURE, CRYPTO_R_STRING_TOO_LONG, CRYPTO_R_TOO_MANY_BYTES, CRYPTO_R_TOO_MANY_RECORDS, CRYPTO_R_TOO_SMALL_BUFFER, CRYPTO_R_UNKNOWN_NAME_IN_RANDOM_SECTION, CRYPTO_R_ZERO_LENGTH_NUMBER, DB_ERROR_INDEX_CLASH, DB_ERROR_INDEX_OUT_OF_RANGE, DB_ERROR_INSERT_INDEX_CLASH, DB_ERROR_MALLOC, DB_ERROR_NO_INDEX, DB_ERROR_OK, DB_ERROR_WRONG_NUM_FIELDS, DH_PARAMGEN_TYPE_FIPS_186_2, DH_PARAMGEN_TYPE_FIPS_186_4, DH_PARAMGEN_TYPE_GENERATOR, DH_PARAMGEN_TYPE_GROUP, DTLS1_2_VERSION, DTLS1_AL_HEADER_LENGTH, DTLS1_BAD_VER, DTLS1_CCS_HEADER_LENGTH, DTLS1_COOKIE_LENGTH, DTLS1_HM_BAD_FRAGMENT, DTLS1_HM_FRAGMENT_RETRY, DTLS1_HM_HEADER_LENGTH, DTLS1_MT_HELLO_VERIFY_REQUEST, DTLS1_RT_HEADER_LENGTH, DTLS1_TMO_ALERT_COUNT, DTLS1_VERSION, DTLS1_VERSION_MAJOR, DTLS_ANY_VERSION, ENGINE_FLAGS_MALLOCED, ESS_R_EMPTY_ESS_CERT_ID_LIST, ESS_R_ESS_CERT_DIGEST_ERROR, ESS_R_ESS_CERT_ID_NOT_FOUND, ESS_R_ESS_CERT_ID_WRONG_ORDER, ESS_R_ESS_DIGEST_ALG_UNKNOWN, ESS_R_ESS_SIGNING_CERTIFICATE_ERROR, ESS_R_ESS_SIGNING_CERT_ADD_ERROR, ESS_R_ESS_SIGNING_CERT_V2_ADD_ERROR, ESS_R_MISSING_SIGNING_CERTIFICATE_ATTRIBUTE, EVP_CCM8_TLS_TAG_LEN, EVP_CCM_TLS_EXPLICIT_IV_LEN, EVP_CCM_TLS_FIXED_IV_LEN, EVP_CCM_TLS_IV_LEN, EVP_CCM_TLS_TAG_LEN, EVP_CHACHAPOLY_TLS_TAG_LEN, EVP_CIPHER_CTX_block_size, EVP_CIPHER_CTX_encrypting, EVP_CIPHER_CTX_iv_length, EVP_CIPHER_CTX_key_length, EVP_CIPHER_CTX_mode, EVP_CIPHER_CTX_nid, EVP_CIPHER_CTX_num, EVP_CIPHER_CTX_tag_length, EVP_CIPHER_CTX_type, EVP_CIPHER_block_size, EVP_CIPHER_flags, EVP_CIPHER_iv_length, EVP_CIPHER_key_length, EVP_CIPHER_mode, EVP_CIPHER_name, EVP_CIPHER_nid, EVP_CIPHER_type, EVP_GCM_TLS_EXPLICIT_IV_LEN, EVP_GCM_TLS_FIXED_IV_LEN, EVP_GCM_TLS_TAG_LEN, EVP_KDF_HKDF_MODE_EXPAND_ONLY, EVP_KDF_HKDF_MODE_EXTRACT_AND_EXPAND, EVP_KDF_HKDF_MODE_EXTRACT_ONLY, EVP_KDF_SSHKDF_TYPE_ENCRYPTION_KEY_CLI_TO_SRV, EVP_KDF_SSHKDF_TYPE_ENCRYPTION_KEY_SRV_TO_CLI, EVP_KDF_SSHKDF_TYPE_INITIAL_IV_CLI_TO_SRV, EVP_KDF_SSHKDF_TYPE_INITIAL_IV_SRV_TO_CLI, EVP_KDF_SSHKDF_TYPE_INTEGRITY_KEY_CLI_TO_SRV, EVP_KDF_SSHKDF_TYPE_INTEGRITY_KEY_SRV_TO_CLI, EVP_MAX_BLOCK_LENGTH, EVP_MAX_IV_LENGTH, EVP_MAX_KEY_LENGTH, EVP_MD_CTX_FLAG_FINALISE, EVP_MD_CTX_block_size, EVP_MD_CTX_md_data, EVP_MD_CTX_pkey_ctx, EVP_MD_CTX_size, EVP_MD_CTX_type, EVP_MD_block_size, EVP_MD_flags, EVP_MD_name, EVP_MD_nid, EVP_MD_pkey_type, EVP_MD_size, EVP_MD_type, EVP_PADDING_ANSI923, EVP_PADDING_ISO10126, EVP_PADDING_ISO7816_4, EVP_PADDING_PKCS7, EVP_PADDING_ZERO, EVP_PBE_TYPE_KDF, EVP_PBE_TYPE_OUTER, EVP_PBE_TYPE_PRF, EVP_PKEY_ALG_CTRL, EVP_PKEY_CMAC, EVP_PKEY_CTRL_CIPHER, EVP_PKEY_CTRL_DIGESTINIT, EVP_PKEY_CTRL_GET1_ID, EVP_PKEY_CTRL_GET1_ID_LEN, EVP_PKEY_CTRL_GET_MD, EVP_PKEY_CTRL_MD, EVP_PKEY_CTRL_PEER_KEY, EVP_PKEY_CTRL_SET1_ID, EVP_PKEY_CTRL_SET_DIGEST_SIZE, EVP_PKEY_CTRL_SET_IV, EVP_PKEY_CTRL_SET_MAC_KEY, EVP_PKEY_CTX_hkdf_mode, EVP_PKEY_DH, EVP_PKEY_DHX, EVP_PKEY_DH_KDF_NONE, EVP_PKEY_DH_KDF_X9_42, EVP_PKEY_DSA, EVP_PKEY_DSA1, EVP_PKEY_DSA2, EVP_PKEY_DSA3, EVP_PKEY_DSA4, EVP_PKEY_EC, EVP_PKEY_ECDH_KDF_NONE, EVP_PKEY_ECDH_KDF_X9_62, EVP_PKEY_ECDH_KDF_X9_63, EVP_PKEY_ED25519, EVP_PKEY_ED448, EVP_PKEY_FLAG_AUTOARGLEN, EVP_PKEY_FLAG_SIGCTX_CUSTOM, EVP_PKEY_HKDF, EVP_PKEY_HMAC, EVP_PKEY_KEYMGMT, EVP_PKEY_MO_DECRYPT, EVP_PKEY_MO_ENCRYPT, EVP_PKEY_MO_SIGN, EVP_PKEY_MO_VERIFY, EVP_PKEY_NONE, EVP_PKEY_OP_UNDEFINED, EVP_PKEY_POLY1305, EVP_PKEY_RSA, EVP_PKEY_RSA2, EVP_PKEY_RSA_PSS, EVP_PKEY_SCRYPT, EVP_PKEY_SIPHASH, EVP_PKEY_SM2, EVP_PKEY_TLS1_PRF, EVP_PKEY_X25519, EVP_PKEY_X448, EVP_PKEY_base_id, EVP_PKEY_bits, EVP_PKEY_id, EVP_PKEY_security_bits, EVP_PKEY_size, EVP_RAND_STATE_ERROR, EVP_RAND_STATE_READY, EVP_RAND_STATE_UNINITIALISED, EVP_R_AES_KEY_SETUP_FAILED, EVP_R_ARIA_KEY_SETUP_FAILED, EVP_R_BAD_ALGORITHM_NAME, EVP_R_BAD_DECRYPT, EVP_R_BAD_KEY_LENGTH, EVP_R_BUFFER_TOO_SMALL, EVP_R_CACHE_CONSTANTS_FAILED, EVP_R_CAMELLIA_KEY_SETUP_FAILED, EVP_R_CANNOT_GET_PARAMETERS, EVP_R_CANNOT_SET_PARAMETERS, EVP_R_CIPHER_NOT_GCM_MODE, EVP_R_CIPHER_PARAMETER_ERROR, EVP_R_COMMAND_NOT_SUPPORTED, EVP_R_CONFLICTING_ALGORITHM_NAME, EVP_R_COPY_ERROR, EVP_R_CTRL_NOT_IMPLEMENTED, EVP_R_CTRL_OPERATION_NOT_IMPLEMENTED, EVP_R_DATA_NOT_MULTIPLE_OF_BLOCK_LENGTH, EVP_R_DECODE_ERROR, EVP_R_DEFAULT_QUERY_PARSE_ERROR, EVP_R_DIFFERENT_KEY_TYPES, EVP_R_DIFFERENT_PARAMETERS, EVP_R_ERROR_LOADING_SECTION, EVP_R_EXPECTING_AN_HMAC_KEY, EVP_R_EXPECTING_AN_RSA_KEY, EVP_R_EXPECTING_A_DH_KEY, EVP_R_EXPECTING_A_DSA_KEY, EVP_R_EXPECTING_A_ECX_KEY, EVP_R_EXPECTING_A_EC_KEY, EVP_R_EXPECTING_A_POLY1305_KEY, EVP_R_EXPECTING_A_SIPHASH_KEY, EVP_R_FINAL_ERROR, EVP_R_GENERATE_ERROR, EVP_R_GET_RAW_KEY_FAILED, EVP_R_ILLEGAL_SCRYPT_PARAMETERS, EVP_R_INACCESSIBLE_DOMAIN_PARAMETERS, EVP_R_INACCESSIBLE_KEY, EVP_R_INITIALIZATION_ERROR, EVP_R_INPUT_NOT_INITIALIZED, EVP_R_INVALID_CUSTOM_LENGTH, EVP_R_INVALID_DIGEST, EVP_R_INVALID_IV_LENGTH, EVP_R_INVALID_KEY, EVP_R_INVALID_KEY_LENGTH, EVP_R_INVALID_LENGTH, EVP_R_INVALID_NULL_ALGORITHM, EVP_R_INVALID_OPERATION, EVP_R_INVALID_PROVIDER_FUNCTIONS, EVP_R_INVALID_SALT_LENGTH, EVP_R_INVALID_SECRET_LENGTH, EVP_R_INVALID_SEED_LENGTH, EVP_R_INVALID_VALUE, EVP_R_KEYMGMT_EXPORT_FAILURE, EVP_R_KEY_SETUP_FAILED, EVP_R_LOCKING_NOT_SUPPORTED, EVP_R_MEMORY_LIMIT_EXCEEDED, EVP_R_MESSAGE_DIGEST_IS_NULL, EVP_R_METHOD_NOT_SUPPORTED, EVP_R_MISSING_PARAMETERS, EVP_R_NOT_ABLE_TO_COPY_CTX, EVP_R_NOT_XOF_OR_INVALID_LENGTH, EVP_R_NO_CIPHER_SET, EVP_R_NO_DEFAULT_DIGEST, EVP_R_NO_DIGEST_SET, EVP_R_NO_IMPORT_FUNCTION, EVP_R_NO_KEYMGMT_AVAILABLE, EVP_R_NO_KEYMGMT_PRESENT, EVP_R_NO_KEY_SET, EVP_R_NO_OPERATION_SET, EVP_R_NULL_MAC_PKEY_CTX, EVP_R_ONLY_ONESHOT_SUPPORTED, EVP_R_OPERATION_NOT_INITIALIZED, EVP_R_OPERATION_NOT_SUPPORTED_FOR_THIS_KEYTYPE, EVP_R_OPERATON_NOT_INITIALIZED, EVP_R_OUTPUT_WOULD_OVERFLOW, EVP_R_PARAMETER_TOO_LARGE, EVP_R_PARTIALLY_OVERLAPPING, EVP_R_PBKDF2_ERROR, EVP_R_PKEY_APPLICATION_ASN1_METHOD_ALREADY_REGISTERED, EVP_R_PRIVATE_KEY_DECODE_ERROR, EVP_R_PRIVATE_KEY_ENCODE_ERROR, EVP_R_PUBLIC_KEY_NOT_RSA, EVP_R_SETTING_XOF_FAILED, EVP_R_SET_DEFAULT_PROPERTY_FAILURE, EVP_R_TOO_MANY_RECORDS, EVP_R_UNABLE_TO_ENABLE_LOCKING, EVP_R_UNABLE_TO_GET_MAXIMUM_REQUEST_SIZE, EVP_R_UNABLE_TO_GET_RANDOM_STRENGTH, EVP_R_UNABLE_TO_LOCK_CONTEXT, EVP_R_UNABLE_TO_SET_CALLBACKS, EVP_R_UNKNOWN_CIPHER, EVP_R_UNKNOWN_DIGEST, EVP_R_UNKNOWN_KEY_TYPE, EVP_R_UNKNOWN_OPTION, EVP_R_UNKNOWN_PBE_ALGORITHM, EVP_R_UNSUPPORTED_ALGORITHM, EVP_R_UNSUPPORTED_CIPHER, EVP_R_UNSUPPORTED_KEYLENGTH, EVP_R_UNSUPPORTED_KEY_DERIVATION_FUNCTION, EVP_R_UNSUPPORTED_KEY_SIZE, EVP_R_UNSUPPORTED_KEY_TYPE, EVP_R_UNSUPPORTED_NUMBER_OF_ROUNDS, EVP_R_UNSUPPORTED_PRF, EVP_R_UNSUPPORTED_PRIVATE_KEY_ALGORITHM, EVP_R_UNSUPPORTED_SALT_TYPE, EVP_R_UPDATE_ERROR, EVP_R_WRAP_MODE_NOT_ALLOWED, EVP_R_WRONG_FINAL_BLOCK_LENGTH, EVP_R_XTS_DATA_UNIT_IS_TOO_LARGE, EVP_R_XTS_DUPLICATED_KEYS, EVP_aes_128_cfb, EVP_aes_192_cfb, EVP_aes_256_cfb, HTTP_R_ASN1_LEN_EXCEEDS_MAX_RESP_LEN, HTTP_R_CONNECT_FAILURE, HTTP_R_ERROR_PARSING_ASN1_LENGTH, HTTP_R_ERROR_PARSING_CONTENT_LENGTH, HTTP_R_ERROR_PARSING_URL, HTTP_R_ERROR_RECEIVING, HTTP_R_ERROR_SENDING, HTTP_R_FAILED_READING_DATA, HTTP_R_HEADER_PARSE_ERROR, HTTP_R_INCONSISTENT_CONTENT_LENGTH, HTTP_R_INVALID_PORT_NUMBER, HTTP_R_INVALID_URL_PATH, HTTP_R_INVALID_URL_SCHEME, HTTP_R_MAX_RESP_LEN_EXCEEDED, HTTP_R_MISSING_ASN1_ENCODING, HTTP_R_MISSING_CONTENT_TYPE, HTTP_R_MISSING_REDIRECT_LOCATION, HTTP_R_RECEIVED_ERROR, HTTP_R_RECEIVED_WRONG_HTTP_VERSION, HTTP_R_REDIRECTION_FROM_HTTPS_TO_HTTP, HTTP_R_REDIRECTION_NOT_ENABLED, HTTP_R_RESPONSE_LINE_TOO_LONG, HTTP_R_RESPONSE_PARSE_ERROR, HTTP_R_RETRY_TIMEOUT, HTTP_R_SERVER_CANCELED_CONNECTION, HTTP_R_SOCK_NOT_SUPPORTED, HTTP_R_STATUS_CODE_UNSUPPORTED, HTTP_R_TLS_NOT_ENABLED, HTTP_R_TOO_MANY_REDIRECTIONS, HTTP_R_UNEXPECTED_CONTENT_TYPE, LN_Directory, LN_Domain, LN_Enterprises, LN_Experimental, LN_INN, LN_ISO_CN, LN_ISO_US, LN_Independent, LN_LocalKeySet, LN_Mail, LN_Management, LN_NAIRealm, LN_OCSP_sign, LN_OGRN, LN_OGRNIP, LN_Private, LN_RSA_SHA3_224, LN_RSA_SHA3_256, LN_RSA_SHA3_384, LN_RSA_SHA3_512, LN_SM2_with_SM3, LN_SNILS, LN_SNMPv2, LN_SRVName, LN_Security, LN_X500, LN_X500algorithms, LN_X9_57, LN_X9cm, LN_XmppAddr, LN_aRecord, LN_ad_OCSP, LN_ad_ca_issuers, LN_ad_dvcs, LN_ad_timeStamping, LN_aes_128_cbc, LN_aes_128_cbc_hmac_sha1, LN_aes_128_cbc_hmac_sha256, LN_aes_128_ccm, LN_aes_128_cfb1, LN_aes_128_cfb128, LN_aes_128_cfb8, LN_aes_128_ctr, LN_aes_128_ecb, LN_aes_128_gcm, LN_aes_128_ocb, LN_aes_128_ofb128, LN_aes_128_siv, LN_aes_128_xts, LN_aes_192_cbc, LN_aes_192_cbc_hmac_sha1, LN_aes_192_cbc_hmac_sha256, LN_aes_192_ccm, LN_aes_192_cfb1, LN_aes_192_cfb128, LN_aes_192_cfb8, LN_aes_192_ctr, LN_aes_192_ecb, LN_aes_192_gcm, LN_aes_192_ocb, LN_aes_192_ofb128, LN_aes_192_siv, LN_aes_256_cbc, LN_aes_256_cbc_hmac_sha1, LN_aes_256_cbc_hmac_sha256, LN_aes_256_ccm, LN_aes_256_cfb1, LN_aes_256_cfb128, LN_aes_256_cfb8, LN_aes_256_ctr, LN_aes_256_ecb, LN_aes_256_gcm, LN_aes_256_ocb, LN_aes_256_ofb128, LN_aes_256_siv, LN_aes_256_xts, LN_algorithm, LN_ansi_X9_62, LN_anyExtendedKeyUsage, LN_any_policy, LN_aria_128_cbc, LN_aria_128_ccm, LN_aria_128_cfb1, LN_aria_128_cfb128, LN_aria_128_cfb8, LN_aria_128_ctr, LN_aria_128_ecb, LN_aria_128_gcm, LN_aria_128_ofb128, LN_aria_192_cbc, LN_aria_192_ccm, LN_aria_192_cfb1, LN_aria_192_cfb128, LN_aria_192_cfb8, LN_aria_192_ctr, LN_aria_192_ecb, LN_aria_192_gcm, LN_aria_192_ofb128, LN_aria_256_cbc, LN_aria_256_ccm, LN_aria_256_cfb1, LN_aria_256_cfb128, LN_aria_256_cfb8, LN_aria_256_ctr, LN_aria_256_ecb, LN_aria_256_gcm, LN_aria_256_ofb128, LN_associatedDomain, LN_associatedName, LN_auth_any, LN_auth_dss, LN_auth_ecdsa, LN_auth_gost01, LN_auth_gost12, LN_auth_null, LN_auth_psk, LN_auth_rsa, LN_auth_srp, LN_authorityRevocationList, LN_authority_key_identifier, LN_basic_constraints, LN_bf_cbc, LN_bf_cfb64, LN_bf_ecb, LN_bf_ofb64, LN_biometricInfo, LN_blake2b512, LN_blake2bmac, LN_blake2s256, LN_blake2smac, LN_buildingName, LN_businessCategory, LN_cACertificate, LN_cNAMERecord, LN_caRepository, LN_camellia_128_cbc, LN_camellia_128_ccm, LN_camellia_128_cfb1, LN_camellia_128_cfb128, LN_camellia_128_cfb8, LN_camellia_128_cmac, LN_camellia_128_ctr, LN_camellia_128_ecb, LN_camellia_128_gcm, LN_camellia_128_ofb128, LN_camellia_192_cbc, LN_camellia_192_ccm, LN_camellia_192_cfb1, LN_camellia_192_cfb128, LN_camellia_192_cfb8, LN_camellia_192_cmac, LN_camellia_192_ctr, LN_camellia_192_ecb, LN_camellia_192_gcm, LN_camellia_192_ofb128, LN_camellia_256_cbc, LN_camellia_256_ccm, LN_camellia_256_cfb1, LN_camellia_256_cfb128, LN_camellia_256_cfb8, LN_camellia_256_cmac, LN_camellia_256_ctr, LN_camellia_256_ecb, LN_camellia_256_gcm, LN_camellia_256_ofb128, LN_caseIgnoreIA5StringSyntax, LN_cast5_cbc, LN_cast5_cfb64, LN_cast5_ecb, LN_cast5_ofb64, LN_certBag, LN_certificateRevocationList, LN_certificate_issuer, LN_certificate_policies, LN_chacha20, LN_chacha20_poly1305, LN_classSignTool, LN_classSignToolKA1, LN_classSignToolKB1, LN_classSignToolKB2, LN_classSignToolKC1, LN_classSignToolKC2, LN_classSignToolKC3, LN_client_auth, LN_cmKGA, LN_cmac, LN_cmcArchive, LN_cmcCA, LN_cmcRA, LN_code_sign, LN_commonName, LN_countryCode3c, LN_countryCode3n, LN_countryName, LN_crlBag, LN_crl_distribution_points, LN_crl_number, LN_crl_reason, LN_crossCertificatePair, LN_ct_cert_scts, LN_ct_precert_poison, LN_ct_precert_scts, LN_ct_precert_signer, LN_dITRedirect, LN_dNSDomain, LN_dSAQuality, LN_dcObject, LN_deltaRevocationList, LN_delta_crl, LN_des_cbc, LN_des_cdmf, LN_des_cfb1, LN_des_cfb64, LN_des_cfb8, LN_des_ecb, LN_des_ede3_cbc, LN_des_ede3_cfb1, LN_des_ede3_cfb64, LN_des_ede3_cfb8, LN_des_ede3_ecb, LN_des_ede3_ofb64, LN_des_ede_cbc, LN_des_ede_cfb64, LN_des_ede_ecb, LN_des_ede_ofb64, LN_des_ofb64, LN_description, LN_destinationIndicator, LN_desx_cbc, LN_dhKeyAgreement, LN_dhpublicnumber, LN_distinguishedName, LN_dnQualifier, LN_dnsName, LN_documentAuthor, LN_documentIdentifier, LN_documentLocation, LN_documentPublisher, LN_documentSeries, LN_documentTitle, LN_documentVersion, LN_dod, LN_domainComponent, LN_domainRelatedObject, LN_dsa, LN_dsaWithSHA, LN_dsaWithSHA1, LN_dsaWithSHA1_2, LN_dsa_2, LN_dsa_with_SHA384, LN_dsa_with_SHA3_224, LN_dsa_with_SHA3_256, LN_dsa_with_SHA3_384, LN_dsa_with_SHA3_512, LN_dsa_with_SHA512, LN_dstu28147, LN_dstu28147_cfb, LN_dstu28147_ofb, LN_dstu28147_wrap, LN_dstu34311, LN_dstu4145be, LN_dstu4145le, LN_dvcs, LN_ecdsa_with_SHA3_224, LN_ecdsa_with_SHA3_256, LN_ecdsa_with_SHA3_384, LN_ecdsa_with_SHA3_512, LN_email_protect, LN_enhancedSearchGuide, LN_ext_key_usage, LN_ext_req, LN_facsimileTelephoneNumber, LN_favouriteDrink, LN_freshest_crl, LN_friendlyCountry, LN_friendlyCountryName, LN_friendlyName, LN_generationQualifier, LN_givenName, LN_gmac, LN_hkdf, LN_hmac, LN_hmacWithDstu34311, LN_hmacWithMD5, LN_hmacWithSHA1, LN_hmacWithSHA224, LN_hmacWithSHA256, LN_hmacWithSHA384, LN_hmacWithSHA512, LN_hmacWithSHA512_224, LN_hmacWithSHA512_256, LN_hmac_md5, LN_hmac_sha1, LN_hmac_sha3_224, LN_hmac_sha3_256, LN_hmac_sha3_384, LN_hmac_sha3_512, LN_hold_instruction_call_issuer, LN_hold_instruction_code, LN_hold_instruction_none, LN_hold_instruction_reject, LN_homePostalAddress, LN_homeTelephoneNumber, LN_houseIdentifier, LN_iA5StringSyntax, LN_iana, LN_id_DHBasedMac, LN_id_Gost28147_89, LN_id_Gost28147_89_MAC, LN_id_Gost28147_89_cc, LN_id_GostR3410_2001, LN_id_GostR3410_2001DH, LN_id_GostR3410_2001_ParamSet_cc, LN_id_GostR3410_2001_cc, LN_id_GostR3410_2012_256, LN_id_GostR3410_2012_512, LN_id_GostR3410_94, LN_id_GostR3410_94DH, LN_id_GostR3410_94_cc, LN_id_GostR3411_2012_256, LN_id_GostR3411_2012_512, LN_id_GostR3411_94, LN_id_GostR3411_94_prf, LN_id_GostR3411_94_with_GostR3410_2001, LN_id_GostR3411_94_with_GostR3410_2001_cc, LN_id_GostR3411_94_with_GostR3410_94, LN_id_GostR3411_94_with_GostR3410_94_cc, LN_id_HMACGostR3411_94, LN_id_PasswordBasedMAC, LN_id_hex_multipart_message, LN_id_hex_partial_message, LN_id_kp_BrandIndicatorforMessageIdentification, LN_id_kp_bgpsec_router, LN_id_on_SmtpUTF8Mailbox, LN_id_on_permanentIdentifier, LN_id_pbkdf2, LN_id_pkix_OCSP_CrlID, LN_id_pkix_OCSP_Nonce, LN_id_pkix_OCSP_acceptableResponses, LN_id_pkix_OCSP_archiveCutoff, LN_id_pkix_OCSP_basic, LN_id_pkix_OCSP_extendedStatus, LN_id_pkix_OCSP_noCheck, LN_id_pkix_OCSP_serviceLocator, LN_id_pkix_OCSP_trustRoot, LN_id_ppl_anyLanguage, LN_id_ppl_inheritAll, LN_id_qt_cps, LN_id_qt_unotice, LN_id_scrypt, LN_id_set, LN_id_tc26_gost_28147_param_Z, LN_id_tc26_gost_3410_2012_256_paramSetA, LN_id_tc26_gost_3410_2012_256_paramSetB, LN_id_tc26_gost_3410_2012_256_paramSetC, LN_id_tc26_gost_3410_2012_256_paramSetD, LN_id_tc26_gost_3410_2012_512_paramSetA, LN_id_tc26_gost_3410_2012_512_paramSetB, LN_id_tc26_gost_3410_2012_512_paramSetC, LN_id_tc26_gost_3410_2012_512_paramSetTest, LN_id_tc26_hmac_gost_3411_2012_256, LN_id_tc26_hmac_gost_3411_2012_512, LN_id_tc26_signwithdigest_gost3410_2012_256, LN_id_tc26_signwithdigest_gost3410_2012_512, LN_idea_cbc, LN_idea_cfb64, LN_idea_ecb, LN_idea_ofb64, LN_ieee_siswg, LN_info_access, LN_inhibit_any_policy, LN_initials, LN_international_organizations, LN_internationaliSDNNumber, LN_invalidity_date, LN_ipsec3, LN_ipsec4, LN_ipsecEndSystem, LN_ipsecTunnel, LN_ipsecUser, LN_ipsec_IKE, LN_iso, LN_issuerSignTool, LN_issuer_alt_name, LN_issuing_distribution_point, LN_itu_t, LN_janetMailbox, LN_joint_iso_itu_t, LN_jurisdictionCountryName, LN_jurisdictionLocalityName, LN_jurisdictionStateOrProvinceName, LN_keyBag, LN_key_usage, LN_kisa, LN_kmac128, LN_kmac256, LN_kx_any, LN_kx_dhe, LN_kx_dhe_psk, LN_kx_ecdhe, LN_kx_ecdhe_psk, LN_kx_gost, LN_kx_gost18, LN_kx_psk, LN_kx_rsa, LN_kx_rsa_psk, LN_kx_srp, LN_lastModifiedBy, LN_lastModifiedTime, LN_localKeyID, LN_localityName, LN_mXRecord, LN_mailPreferenceOption, LN_md2, LN_md2WithRSAEncryption, LN_md4, LN_md4WithRSAEncryption, LN_md5, LN_md5WithRSA, LN_md5WithRSAEncryption, LN_md5_sha1, LN_mdc2, LN_mdc2WithRSA, LN_member_body, LN_mgf1, LN_mime_mhs, LN_mime_mhs_bodies, LN_mime_mhs_headings, LN_mobileTelephoneNumber, LN_ms_code_com, LN_ms_code_ind, LN_ms_csp_name, LN_ms_ctl_sign, LN_ms_efs, LN_ms_ext_req, LN_ms_sgc, LN_ms_smartcard_login, LN_ms_upn, LN_nSRecord, LN_name, LN_name_constraints, LN_netscape, LN_netscape_base_url, LN_netscape_ca_policy_url, LN_netscape_ca_revocation_url, LN_netscape_cert_extension, LN_netscape_cert_sequence, LN_netscape_cert_type, LN_netscape_comment, LN_netscape_data_type, LN_netscape_renewal_url, LN_netscape_revocation_url, LN_netscape_ssl_server_name, LN_no_rev_avail, LN_ns_sgc, LN_org, LN_organizationIdentifier, LN_organizationName, LN_organizationalStatus, LN_organizationalUnitName, LN_otherMailbox, LN_pSpecified, LN_pagerTelephoneNumber, LN_pbeWithMD2AndDES_CBC, LN_pbeWithMD2AndRC2_CBC, LN_pbeWithMD5AndCast5_CBC, LN_pbeWithMD5AndDES_CBC, LN_pbeWithMD5AndRC2_CBC, LN_pbeWithSHA1AndDES_CBC, LN_pbeWithSHA1AndRC2_CBC, LN_pbe_WithSHA1And128BitRC2_CBC, LN_pbe_WithSHA1And128BitRC4, LN_pbe_WithSHA1And2_Key_TripleDES_CBC, LN_pbe_WithSHA1And3_Key_TripleDES_CBC, LN_pbe_WithSHA1And40BitRC2_CBC, LN_pbe_WithSHA1And40BitRC4, LN_pbes2, LN_pbmac1, LN_personalSignature, LN_personalTitle, LN_physicalDeliveryOfficeName, LN_pilotAttributeSyntax, LN_pilotAttributeType, LN_pilotAttributeType27, LN_pilotDSA, LN_pilotGroups, LN_pilotObject, LN_pilotObjectClass, LN_pilotOrganization, LN_pilotPerson, LN_pkInitClientAuth, LN_pkInitKDC, LN_pkcs, LN_pkcs7_data, LN_pkcs7_digest, LN_pkcs7_encrypted, LN_pkcs7_enveloped, LN_pkcs7_signed, LN_pkcs7_signedAndEnveloped, LN_pkcs8ShroudedKeyBag, LN_pkcs9_challengePassword, LN_pkcs9_contentType, LN_pkcs9_countersignature, LN_pkcs9_emailAddress, LN_pkcs9_extCertAttributes, LN_pkcs9_messageDigest, LN_pkcs9_signingTime, LN_pkcs9_unstructuredAddress, LN_pkcs9_unstructuredName, LN_policy_constraints, LN_policy_mappings, LN_poly1305, LN_postOfficeBox, LN_postalAddress, LN_postalCode, LN_preferredDeliveryMethod, LN_presentationAddress, LN_private_key_usage_period, LN_protocolInformation, LN_proxyCertInfo, LN_pseudonym, LN_qualityLabelledData, LN_rFC822localPart, LN_rc2_40_cbc, LN_rc2_64_cbc, LN_rc2_cbc, LN_rc2_cfb64, LN_rc2_ecb, LN_rc2_ofb64, LN_rc4, LN_rc4_40, LN_rc4_hmac_md5, LN_rc5_cbc, LN_rc5_cfb64, LN_rc5_ecb, LN_rc5_ofb64, LN_registeredAddress, LN_rfc822Mailbox, LN_ripemd160, LN_ripemd160WithRSA, LN_role, LN_roleOccupant, LN_roomNumber, LN_rpkiManifest, LN_rpkiNotify, LN_rsa, LN_rsaEncryption, LN_rsadsi, LN_rsaesOaep, LN_rsassaPss, LN_sOARecord, LN_safeContentsBag, LN_sdsiCertificate, LN_searchGuide, LN_secretBag, LN_seed_cbc, LN_seed_cfb128, LN_seed_ecb, LN_seed_ofb128, LN_selected_attribute_types, LN_sendOwner, LN_sendProxiedOwner, LN_sendProxiedRouter, LN_sendRouter, LN_serialNumber, LN_server_auth, LN_setAttr_GenCryptgrm, LN_setAttr_IssCap, LN_setAttr_PGWYcap, LN_setAttr_SecDevSig, LN_setAttr_T2Enc, LN_setAttr_T2cleartxt, LN_setAttr_TokICCsig, LN_set_certExt, LN_set_ctype, LN_set_msgExt, LN_setext_cv, LN_setext_genCrypt, LN_setext_miAuth, LN_sha, LN_sha1, LN_sha1WithRSA, LN_sha1WithRSAEncryption, LN_sha224, LN_sha224WithRSAEncryption, LN_sha256, LN_sha256WithRSAEncryption, LN_sha384, LN_sha384WithRSAEncryption, LN_sha3_224, LN_sha3_256, LN_sha3_384, LN_sha3_512, LN_sha512, LN_sha512WithRSAEncryption, LN_sha512_224, LN_sha512_224WithRSAEncryption, LN_sha512_256, LN_sha512_256WithRSAEncryption, LN_shaWithRSAEncryption, LN_shake128, LN_shake256, LN_signedObject, LN_simpleSecurityObject, LN_sinfo_access, LN_singleLevelQuality, LN_siphash, LN_sm2, LN_sm3, LN_sm3WithRSAEncryption, LN_sm4_cbc, LN_sm4_cfb1, LN_sm4_cfb128, LN_sm4_cfb8, LN_sm4_ctr, LN_sm4_ecb, LN_sm4_ofb128, LN_sshClient, LN_sshServer, LN_sshkdf, LN_sskdf, LN_stateOrProvinceName, LN_streetAddress, LN_subjectSignTool, LN_subject_alt_name, LN_subject_directory_attributes, LN_subject_key_identifier, LN_subtreeMaximumQuality, LN_subtreeMinimumQuality, LN_supportedAlgorithms, LN_supportedApplicationContext, LN_surname, LN_sxnet, LN_target_information, LN_telephoneNumber, LN_teletexTerminalIdentifier, LN_telexNumber, LN_textEncodedORAddress, LN_time_stamp, LN_title, LN_tls1_prf, LN_tlsfeature, LN_uacurve0, LN_uacurve1, LN_uacurve2, LN_uacurve3, LN_uacurve4, LN_uacurve5, LN_uacurve6, LN_uacurve7, LN_uacurve8, LN_uacurve9, LN_undef, LN_uniqueIdentifier, LN_uniqueMember, LN_userCertificate, LN_userClass, LN_userId, LN_userPassword, LN_x121Address, LN_x500UniqueIdentifier, LN_x509Certificate, LN_x509Crl, LN_x509ExtAdmission, LN_x942kdf, LN_x963kdf, LN_zlib_compression, LibCrypto, NID_Directory, NID_Domain, NID_ED25519, NID_ED448, NID_Enterprises, NID_Experimental, NID_INN, NID_ISO_CN, NID_ISO_UA, NID_ISO_US, NID_Independent, NID_LocalKeySet, NID_Mail, NID_Management, NID_NAIRealm, NID_OCSP_sign, NID_OGRN, NID_OGRNIP, NID_Private, NID_RSA_SHA3_224, NID_RSA_SHA3_256, NID_RSA_SHA3_384, NID_RSA_SHA3_512, NID_SM2_with_SM3, NID_SMIME, NID_SMIMECapabilities, NID_SNILS, NID_SNMPv2, NID_SRVName, NID_Security, NID_X25519, NID_X448, NID_X500, NID_X500algorithms, NID_X509, NID_X9_57, NID_X9_62_c2onb191v4, NID_X9_62_c2onb191v5, NID_X9_62_c2onb239v4, NID_X9_62_c2onb239v5, NID_X9_62_c2pnb163v1, NID_X9_62_c2pnb163v2, NID_X9_62_c2pnb163v3, NID_X9_62_c2pnb176v1, NID_X9_62_c2pnb208w1, NID_X9_62_c2pnb272w1, NID_X9_62_c2pnb304w1, NID_X9_62_c2pnb368w1, NID_X9_62_c2tnb191v1, NID_X9_62_c2tnb191v2, NID_X9_62_c2tnb191v3, NID_X9_62_c2tnb239v1, NID_X9_62_c2tnb239v2, NID_X9_62_c2tnb239v3, NID_X9_62_c2tnb359v1, NID_X9_62_c2tnb431r1, NID_X9_62_characteristic_two_field, NID_X9_62_id_characteristic_two_basis, NID_X9_62_id_ecPublicKey, NID_X9_62_onBasis, NID_X9_62_ppBasis, NID_X9_62_prime192v1, NID_X9_62_prime192v2, NID_X9_62_prime192v3, NID_X9_62_prime239v1, NID_X9_62_prime239v2, NID_X9_62_prime239v3, NID_X9_62_prime256v1, NID_X9_62_prime_field, NID_X9_62_tpBasis, NID_X9cm, NID_XmppAddr, NID_aRecord, NID_aaControls, NID_ac_auditEntity, NID_ac_proxying, NID_ac_targeting, NID_account, NID_ad_OCSP, NID_ad_ca_issuers, NID_ad_dvcs, NID_ad_timeStamping, NID_aes_128_cbc, NID_aes_128_cbc_hmac_sha1, NID_aes_128_cbc_hmac_sha256, NID_aes_128_ccm, NID_aes_128_cfb1, NID_aes_128_cfb128, NID_aes_128_cfb8, NID_aes_128_ctr, NID_aes_128_ecb, NID_aes_128_gcm, NID_aes_128_ocb, NID_aes_128_ofb128, NID_aes_128_siv, NID_aes_128_xts, NID_aes_192_cbc, NID_aes_192_cbc_hmac_sha1, NID_aes_192_cbc_hmac_sha256, NID_aes_192_ccm, NID_aes_192_cfb1, NID_aes_192_cfb128, NID_aes_192_cfb8, NID_aes_192_ctr, NID_aes_192_ecb, NID_aes_192_gcm, NID_aes_192_ocb, NID_aes_192_ofb128, NID_aes_192_siv, NID_aes_256_cbc, NID_aes_256_cbc_hmac_sha1, NID_aes_256_cbc_hmac_sha256, NID_aes_256_ccm, NID_aes_256_cfb1, NID_aes_256_cfb128, NID_aes_256_cfb8, NID_aes_256_ctr, NID_aes_256_ecb, NID_aes_256_gcm, NID_aes_256_ocb, NID_aes_256_ofb128, NID_aes_256_siv, NID_aes_256_xts, NID_algorithm, NID_ansi_X9_62, NID_anyExtendedKeyUsage, NID_any_policy, NID_aria_128_cbc, NID_aria_128_ccm, NID_aria_128_cfb1, NID_aria_128_cfb128, NID_aria_128_cfb8, NID_aria_128_ctr, NID_aria_128_ecb, NID_aria_128_gcm, NID_aria_128_ofb128, NID_aria_192_cbc, NID_aria_192_ccm, NID_aria_192_cfb1, NID_aria_192_cfb128, NID_aria_192_cfb8, NID_aria_192_ctr, NID_aria_192_ecb, NID_aria_192_gcm, NID_aria_192_ofb128, NID_aria_256_cbc, NID_aria_256_ccm, NID_aria_256_cfb1, NID_aria_256_cfb128, NID_aria_256_cfb8, NID_aria_256_ctr, NID_aria_256_ecb, NID_aria_256_gcm, NID_aria_256_ofb128, NID_associatedDomain, NID_associatedName, NID_audio, NID_auth_any, NID_auth_dss, NID_auth_ecdsa, NID_auth_gost01, NID_auth_gost12, NID_auth_null, NID_auth_psk, NID_auth_rsa, NID_auth_srp, NID_authorityRevocationList, NID_authority_key_identifier, NID_basic_constraints, NID_bf_cbc, NID_bf_cfb64, NID_bf_ecb, NID_bf_ofb64, NID_biometricInfo, NID_blake2b512, NID_blake2bmac, NID_blake2s256, NID_blake2smac, NID_brainpoolP160r1, NID_brainpoolP160t1, NID_brainpoolP192r1, NID_brainpoolP192t1, NID_brainpoolP224r1, NID_brainpoolP224t1, NID_brainpoolP256r1, NID_brainpoolP256t1, NID_brainpoolP320r1, NID_brainpoolP320t1, NID_brainpoolP384r1, NID_brainpoolP384t1, NID_brainpoolP512r1, NID_brainpoolP512t1, NID_buildingName, NID_businessCategory, NID_cACertificate, NID_cNAMERecord, NID_caRepository, NID_camellia_128_cbc, NID_camellia_128_ccm, NID_camellia_128_cfb1, NID_camellia_128_cfb128, NID_camellia_128_cfb8, NID_camellia_128_cmac, NID_camellia_128_ctr, NID_camellia_128_ecb, NID_camellia_128_gcm, NID_camellia_128_ofb128, NID_camellia_192_cbc, NID_camellia_192_ccm, NID_camellia_192_cfb1, NID_camellia_192_cfb128, NID_camellia_192_cfb8, NID_camellia_192_cmac, NID_camellia_192_ctr, NID_camellia_192_ecb, NID_camellia_192_gcm, NID_camellia_192_ofb128, NID_camellia_256_cbc, NID_camellia_256_ccm, NID_camellia_256_cfb1, NID_camellia_256_cfb128, NID_camellia_256_cfb8, NID_camellia_256_cmac, NID_camellia_256_ctr, NID_camellia_256_ecb, NID_camellia_256_gcm, NID_camellia_256_ofb128, NID_capwapAC, NID_capwapWTP, NID_caseIgnoreIA5StringSyntax, NID_cast5_cbc, NID_cast5_cfb64, NID_cast5_ecb, NID_cast5_ofb64, NID_ccitt, NID_certBag, NID_certicom_arc, NID_certificateRevocationList, NID_certificate_issuer, NID_certificate_policies, NID_chacha20, NID_chacha20_poly1305, NID_classSignTool, NID_classSignToolKA1, NID_classSignToolKB1, NID_classSignToolKB2, NID_classSignToolKC1, NID_classSignToolKC2, NID_classSignToolKC3, NID_clearance, NID_client_auth, NID_cmKGA, NID_cmac, NID_cmcArchive, NID_cmcCA, NID_cmcRA, NID_code_sign, NID_commonName, NID_countryCode3c, NID_countryCode3n, NID_countryName, NID_crlBag, NID_crl_distribution_points, NID_crl_number, NID_crl_reason, NID_crossCertificatePair, NID_cryptocom, NID_cryptopro, NID_ct_cert_scts, NID_ct_precert_poison, NID_ct_precert_scts, NID_ct_precert_signer, NID_dITRedirect, NID_dNSDomain, NID_dSAQuality, NID_data, NID_dcObject, NID_deltaRevocationList, NID_delta_crl, NID_des_cbc, NID_des_cdmf, NID_des_cfb1, NID_des_cfb64, NID_des_cfb8, NID_des_ecb, NID_des_ede3_cbc, NID_des_ede3_cfb1, NID_des_ede3_cfb64, NID_des_ede3_cfb8, NID_des_ede3_ecb, NID_des_ede3_ofb64, NID_des_ede_cbc, NID_des_ede_cfb64, NID_des_ede_ecb, NID_des_ede_ofb64, NID_des_ofb64, NID_description, NID_destinationIndicator, NID_desx_cbc, NID_dhKeyAgreement, NID_dhSinglePass_cofactorDH_sha1kdf_scheme, NID_dhSinglePass_cofactorDH_sha224kdf_scheme, NID_dhSinglePass_cofactorDH_sha256kdf_scheme, NID_dhSinglePass_cofactorDH_sha384kdf_scheme, NID_dhSinglePass_cofactorDH_sha512kdf_scheme, NID_dhSinglePass_stdDH_sha1kdf_scheme, NID_dhSinglePass_stdDH_sha224kdf_scheme, NID_dhSinglePass_stdDH_sha256kdf_scheme, NID_dhSinglePass_stdDH_sha384kdf_scheme, NID_dhSinglePass_stdDH_sha512kdf_scheme, NID_dh_cofactor_kdf, NID_dh_std_kdf, NID_dhpublicnumber, NID_distinguishedName, NID_dmdName, NID_dnQualifier, NID_dnsName, NID_document, NID_documentAuthor, NID_documentIdentifier, NID_documentLocation, NID_documentPublisher, NID_documentSeries, NID_documentTitle, NID_documentVersion, NID_dod, NID_domainComponent, NID_domainRelatedObject, NID_dsa, NID_dsaWithSHA, NID_dsaWithSHA1, NID_dsaWithSHA1_2, NID_dsa_2, NID_dsa_with_SHA224, NID_dsa_with_SHA256, NID_dsa_with_SHA384, NID_dsa_with_SHA3_224, NID_dsa_with_SHA3_256, NID_dsa_with_SHA3_384, NID_dsa_with_SHA3_512, NID_dsa_with_SHA512, NID_dstu28147, NID_dstu28147_cfb, NID_dstu28147_ofb, NID_dstu28147_wrap, NID_dstu34311, NID_dstu4145be, NID_dstu4145le, NID_dvcs, NID_ecdsa_with_Recommended, NID_ecdsa_with_SHA1, NID_ecdsa_with_SHA224, NID_ecdsa_with_SHA256, NID_ecdsa_with_SHA384, NID_ecdsa_with_SHA3_224, NID_ecdsa_with_SHA3_256, NID_ecdsa_with_SHA3_384, NID_ecdsa_with_SHA3_512, NID_ecdsa_with_SHA512, NID_ecdsa_with_Specified, NID_email_protect, NID_enhancedSearchGuide, NID_ext_key_usage, NID_ext_req, NID_facsimileTelephoneNumber, NID_favouriteDrink, NID_ffdhe2048, NID_ffdhe3072, NID_ffdhe4096, NID_ffdhe6144, NID_ffdhe8192, NID_freshest_crl, NID_friendlyCountry, NID_friendlyCountryName, NID_friendlyName, NID_generationQualifier, NID_givenName, NID_gmac, NID_gost89_cbc, NID_gost89_cnt, NID_gost89_cnt_12, NID_gost89_ctr, NID_gost89_ecb, NID_gost_mac_12, NID_grasshopper_cbc, NID_grasshopper_cfb, NID_grasshopper_ctr, NID_grasshopper_ecb, NID_grasshopper_mac, NID_grasshopper_ofb, NID_hkdf, NID_hmac, NID_hmacWithDstu34311, NID_hmacWithMD5, NID_hmacWithSHA1, NID_hmacWithSHA224, NID_hmacWithSHA256, NID_hmacWithSHA384, NID_hmacWithSHA512, NID_hmacWithSHA512_224, NID_hmacWithSHA512_256, NID_hmac_md5, NID_hmac_sha1, NID_hmac_sha3_224, NID_hmac_sha3_256, NID_hmac_sha3_384, NID_hmac_sha3_512, NID_hold_instruction_call_issuer, NID_hold_instruction_code, NID_hold_instruction_none, NID_hold_instruction_reject, NID_homePostalAddress, NID_homeTelephoneNumber, NID_host, NID_houseIdentifier, NID_iA5StringSyntax, NID_iana, NID_id_DHBasedMac, NID_id_Gost28147_89, NID_id_Gost28147_89_CryptoPro_A_ParamSet, NID_id_Gost28147_89_CryptoPro_B_ParamSet, NID_id_Gost28147_89_CryptoPro_C_ParamSet, NID_id_Gost28147_89_CryptoPro_D_ParamSet, NID_id_Gost28147_89_CryptoPro_KeyMeshing, NID_id_Gost28147_89_CryptoPro_Oscar_1_0_ParamSet, NID_id_Gost28147_89_CryptoPro_Oscar_1_1_ParamSet, NID_id_Gost28147_89_CryptoPro_RIC_1_ParamSet, NID_id_Gost28147_89_MAC, NID_id_Gost28147_89_None_KeyMeshing, NID_id_Gost28147_89_TestParamSet, NID_id_Gost28147_89_cc, NID_id_GostR3410_2001, NID_id_GostR3410_2001DH, NID_id_GostR3410_2001_CryptoPro_A_ParamSet, NID_id_GostR3410_2001_CryptoPro_B_ParamSet, NID_id_GostR3410_2001_CryptoPro_C_ParamSet, NID_id_GostR3410_2001_CryptoPro_XchA_ParamSet, NID_id_GostR3410_2001_CryptoPro_XchB_ParamSet, NID_id_GostR3410_2001_ParamSet_cc, NID_id_GostR3410_2001_TestParamSet, NID_id_GostR3410_2001_cc, NID_id_GostR3410_2012_256, NID_id_GostR3410_2012_512, NID_id_GostR3410_94, NID_id_GostR3410_94DH, NID_id_GostR3410_94_CryptoPro_A_ParamSet, NID_id_GostR3410_94_CryptoPro_B_ParamSet, NID_id_GostR3410_94_CryptoPro_C_ParamSet, NID_id_GostR3410_94_CryptoPro_D_ParamSet, NID_id_GostR3410_94_CryptoPro_XchA_ParamSet, NID_id_GostR3410_94_CryptoPro_XchB_ParamSet, NID_id_GostR3410_94_CryptoPro_XchC_ParamSet, NID_id_GostR3410_94_TestParamSet, NID_id_GostR3410_94_a, NID_id_GostR3410_94_aBis, NID_id_GostR3410_94_b, NID_id_GostR3410_94_bBis, NID_id_GostR3410_94_cc, NID_id_GostR3411_2012_256, NID_id_GostR3411_2012_512, NID_id_GostR3411_94, NID_id_GostR3411_94_CryptoProParamSet, NID_id_GostR3411_94_TestParamSet, NID_id_GostR3411_94_prf, NID_id_GostR3411_94_with_GostR3410_2001, NID_id_GostR3411_94_with_GostR3410_2001_cc, NID_id_GostR3411_94_with_GostR3410_94, NID_id_GostR3411_94_with_GostR3410_94_cc, NID_id_HMACGostR3411_94, NID_id_PasswordBasedMAC, NID_id_aca, NID_id_aca_accessIdentity, NID_id_aca_authenticationInfo, NID_id_aca_chargingIdentity, NID_id_aca_encAttrs, NID_id_aca_group, NID_id_aca_role, NID_id_ad, NID_id_aes128_wrap, NID_id_aes128_wrap_pad, NID_id_aes192_wrap, NID_id_aes192_wrap_pad, NID_id_aes256_wrap, NID_id_aes256_wrap_pad, NID_id_alg, NID_id_alg_PWRI_KEK, NID_id_alg_des40, NID_id_alg_dh_pop, NID_id_alg_dh_sig_hmac_sha1, NID_id_alg_noSignature, NID_id_camellia128_wrap, NID_id_camellia192_wrap, NID_id_camellia256_wrap, NID_id_cct, NID_id_cct_PKIData, NID_id_cct_PKIResponse, NID_id_cct_crs, NID_id_ce, NID_id_cmc, NID_id_cmc_addExtensions, NID_id_cmc_confirmCertAcceptance, NID_id_cmc_dataReturn, NID_id_cmc_decryptedPOP, NID_id_cmc_encryptedPOP, NID_id_cmc_getCRL, NID_id_cmc_getCert, NID_id_cmc_identification, NID_id_cmc_identityProof, NID_id_cmc_lraPOPWitness, NID_id_cmc_popLinkRandom, NID_id_cmc_popLinkWitness, NID_id_cmc_queryPending, NID_id_cmc_recipientNonce, NID_id_cmc_regInfo, NID_id_cmc_responseInfo, NID_id_cmc_revokeRequest, NID_id_cmc_senderNonce, NID_id_cmc_statusInfo, NID_id_cmc_transactionId, NID_id_cp, NID_id_ct_asciiTextWithCRLF, NID_id_ct_geofeedCSVwithCRLF, NID_id_ct_resourceTaggedAttest, NID_id_ct_routeOriginAuthz, NID_id_ct_rpkiGhostbusters, NID_id_ct_rpkiManifest, NID_id_ct_signedChecklist, NID_id_ct_xml, NID_id_hex_multipart_message, NID_id_hex_partial_message, NID_id_it, NID_id_it_caCerts, NID_id_it_caKeyUpdateInfo, NID_id_it_caProtEncCert, NID_id_it_certReqTemplate, NID_id_it_confirmWaitTime, NID_id_it_currentCRL, NID_id_it_encKeyPairTypes, NID_id_it_implicitConfirm, NID_id_it_keyPairParamRep, NID_id_it_keyPairParamReq, NID_id_it_origPKIMessage, NID_id_it_preferredSymmAlg, NID_id_it_revPassphrase, NID_id_it_rootCaKeyUpdate, NID_id_it_signKeyPairTypes, NID_id_it_subscriptionRequest, NID_id_it_subscriptionResponse, NID_id_it_suppLangTags, NID_id_it_unsupportedOIDs, NID_id_kp, NID_id_kp_BrandIndicatorforMessageIdentification, NID_id_kp_bgpsec_router, NID_id_mod_attribute_cert, NID_id_mod_cmc, NID_id_mod_cmp, NID_id_mod_cmp2000, NID_id_mod_crmf, NID_id_mod_dvcs, NID_id_mod_kea_profile_88, NID_id_mod_kea_profile_93, NID_id_mod_ocsp, NID_id_mod_qualified_cert_88, NID_id_mod_qualified_cert_93, NID_id_mod_timestamp_protocol, NID_id_on, NID_id_on_SmtpUTF8Mailbox, NID_id_on_permanentIdentifier, NID_id_on_personalData, NID_id_pbkdf2, NID_id_pda, NID_id_pda_countryOfCitizenship, NID_id_pda_countryOfResidence, NID_id_pda_dateOfBirth, NID_id_pda_gender, NID_id_pda_placeOfBirth, NID_id_pe, NID_id_pkinit, NID_id_pkip, NID_id_pkix, NID_id_pkix1_explicit_88, NID_id_pkix1_explicit_93, NID_id_pkix1_implicit_88, NID_id_pkix1_implicit_93, NID_id_pkix_OCSP_CrlID, NID_id_pkix_OCSP_Nonce, NID_id_pkix_OCSP_acceptableResponses, NID_id_pkix_OCSP_archiveCutoff, NID_id_pkix_OCSP_basic, NID_id_pkix_OCSP_extendedStatus, NID_id_pkix_OCSP_noCheck, NID_id_pkix_OCSP_path, NID_id_pkix_OCSP_serviceLocator, NID_id_pkix_OCSP_trustRoot, NID_id_pkix_OCSP_valid, NID_id_pkix_mod, NID_id_ppl, NID_id_ppl_anyLanguage, NID_id_ppl_inheritAll, NID_id_qcs, NID_id_qcs_pkixQCSyntax_v1, NID_id_qt, NID_id_qt_cps, NID_id_qt_unotice, NID_id_regCtrl, NID_id_regCtrl_authenticator, NID_id_regCtrl_oldCertID, NID_id_regCtrl_pkiArchiveOptions, NID_id_regCtrl_pkiPublicationInfo, NID_id_regCtrl_protocolEncrKey, NID_id_regCtrl_regToken, NID_id_regInfo, NID_id_regInfo_certReq, NID_id_regInfo_utf8Pairs, NID_id_scrypt, NID_id_set, NID_id_smime_aa, NID_id_smime_aa_contentHint, NID_id_smime_aa_contentIdentifier, NID_id_smime_aa_contentReference, NID_id_smime_aa_dvcs_dvc, NID_id_smime_aa_encapContentType, NID_id_smime_aa_encrypKeyPref, NID_id_smime_aa_equivalentLabels, NID_id_smime_aa_ets_CertificateRefs, NID_id_smime_aa_ets_RevocationRefs, NID_id_smime_aa_ets_archiveTimeStamp, NID_id_smime_aa_ets_certCRLTimestamp, NID_id_smime_aa_ets_certValues, NID_id_smime_aa_ets_commitmentType, NID_id_smime_aa_ets_contentTimestamp, NID_id_smime_aa_ets_escTimeStamp, NID_id_smime_aa_ets_otherSigCert, NID_id_smime_aa_ets_revocationValues, NID_id_smime_aa_ets_sigPolicyId, NID_id_smime_aa_ets_signerAttr, NID_id_smime_aa_ets_signerLocation, NID_id_smime_aa_macValue, NID_id_smime_aa_mlExpandHistory, NID_id_smime_aa_msgSigDigest, NID_id_smime_aa_receiptRequest, NID_id_smime_aa_securityLabel, NID_id_smime_aa_signatureType, NID_id_smime_aa_signingCertificate, NID_id_smime_aa_signingCertificateV2, NID_id_smime_aa_smimeEncryptCerts, NID_id_smime_aa_timeStampToken, NID_id_smime_alg, NID_id_smime_alg_3DESwrap, NID_id_smime_alg_CMS3DESwrap, NID_id_smime_alg_CMSRC2wrap, NID_id_smime_alg_ESDH, NID_id_smime_alg_ESDHwith3DES, NID_id_smime_alg_ESDHwithRC2, NID_id_smime_alg_RC2wrap, NID_id_smime_cd, NID_id_smime_cd_ldap, NID_id_smime_ct, NID_id_smime_ct_DVCSRequestData, NID_id_smime_ct_DVCSResponseData, NID_id_smime_ct_TDTInfo, NID_id_smime_ct_TSTInfo, NID_id_smime_ct_authData, NID_id_smime_ct_authEnvelopedData, NID_id_smime_ct_compressedData, NID_id_smime_ct_contentCollection, NID_id_smime_ct_contentInfo, NID_id_smime_ct_publishCert, NID_id_smime_ct_receipt, NID_id_smime_cti, NID_id_smime_cti_ets_proofOfApproval, NID_id_smime_cti_ets_proofOfCreation, NID_id_smime_cti_ets_proofOfDelivery, NID_id_smime_cti_ets_proofOfOrigin, NID_id_smime_cti_ets_proofOfReceipt, NID_id_smime_cti_ets_proofOfSender, NID_id_smime_mod, NID_id_smime_mod_cms, NID_id_smime_mod_ess, NID_id_smime_mod_ets_eSigPolicy_88, NID_id_smime_mod_ets_eSigPolicy_97, NID_id_smime_mod_ets_eSignature_88, NID_id_smime_mod_ets_eSignature_97, NID_id_smime_mod_msg_v3, NID_id_smime_mod_oid, NID_id_smime_spq, NID_id_smime_spq_ets_sqt_unotice, NID_id_smime_spq_ets_sqt_uri, NID_id_tc26, NID_id_tc26_agreement, NID_id_tc26_agreement_gost_3410_2012_256, NID_id_tc26_agreement_gost_3410_2012_512, NID_id_tc26_algorithms, NID_id_tc26_cipher, NID_id_tc26_cipher_constants, NID_id_tc26_cipher_gostr3412_2015_kuznyechik, NID_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm, NID_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm_omac, NID_id_tc26_cipher_gostr3412_2015_magma, NID_id_tc26_cipher_gostr3412_2015_magma_ctracpkm, NID_id_tc26_cipher_gostr3412_2015_magma_ctracpkm_omac, NID_id_tc26_constants, NID_id_tc26_digest, NID_id_tc26_digest_constants, NID_id_tc26_gost_28147_constants, NID_id_tc26_gost_28147_param_Z, NID_id_tc26_gost_3410_2012_256_constants, NID_id_tc26_gost_3410_2012_256_paramSetA, NID_id_tc26_gost_3410_2012_256_paramSetB, NID_id_tc26_gost_3410_2012_256_paramSetC, NID_id_tc26_gost_3410_2012_256_paramSetD, NID_id_tc26_gost_3410_2012_512_constants, NID_id_tc26_gost_3410_2012_512_paramSetA, NID_id_tc26_gost_3410_2012_512_paramSetB, NID_id_tc26_gost_3410_2012_512_paramSetC, NID_id_tc26_gost_3410_2012_512_paramSetTest, NID_id_tc26_hmac_gost_3411_2012_256, NID_id_tc26_hmac_gost_3411_2012_512, NID_id_tc26_mac, NID_id_tc26_sign, NID_id_tc26_sign_constants, NID_id_tc26_signwithdigest, NID_id_tc26_signwithdigest_gost3410_2012_256, NID_id_tc26_signwithdigest_gost3410_2012_512, NID_id_tc26_wrap, NID_id_tc26_wrap_gostr3412_2015_kuznyechik, NID_id_tc26_wrap_gostr3412_2015_kuznyechik_kexp15, NID_id_tc26_wrap_gostr3412_2015_magma, NID_id_tc26_wrap_gostr3412_2015_magma_kexp15, NID_idea_cbc, NID_idea_cfb64, NID_idea_ecb, NID_idea_ofb64, NID_identified_organization, NID_ieee, NID_ieee_siswg, NID_info, NID_info_access, NID_inhibit_any_policy, NID_initials, NID_international_organizations, NID_internationaliSDNNumber, NID_invalidity_date, NID_ipAddr_asNumber, NID_ipAddr_asNumberv2, NID_ipsec3, NID_ipsec4, NID_ipsecEndSystem, NID_ipsecTunnel, NID_ipsecUser, NID_ipsec_IKE, NID_iso, NID_issuerSignTool, NID_issuer_alt_name, NID_issuing_distribution_point, NID_itu_t, NID_janetMailbox, NID_joint_iso_ccitt, NID_joint_iso_itu_t, NID_jurisdictionCountryName, NID_jurisdictionLocalityName, NID_jurisdictionStateOrProvinceName, NID_keyBag, NID_key_usage, NID_kisa, NID_kmac128, NID_kmac256, NID_kuznyechik_cbc, NID_kuznyechik_cfb, NID_kuznyechik_ctr, NID_kuznyechik_ctr_acpkm, NID_kuznyechik_ctr_acpkm_omac, NID_kuznyechik_ecb, NID_kuznyechik_kexp15, NID_kuznyechik_mac, NID_kuznyechik_ofb, NID_kx_any, NID_kx_dhe, NID_kx_dhe_psk, NID_kx_ecdhe, NID_kx_ecdhe_psk, NID_kx_gost, NID_kx_gost18, NID_kx_psk, NID_kx_rsa, NID_kx_rsa_psk, NID_kx_srp, NID_lastModifiedBy, NID_lastModifiedTime, NID_localKeyID, NID_localityName, NID_mXRecord, NID_magma_cbc, NID_magma_cfb, NID_magma_ctr, NID_magma_ctr_acpkm, NID_magma_ctr_acpkm_omac, NID_magma_ecb, NID_magma_kexp15, NID_magma_mac, NID_magma_ofb, NID_mailPreferenceOption, NID_manager, NID_md2, NID_md2WithRSAEncryption, NID_md4, NID_md4WithRSAEncryption, NID_md5, NID_md5WithRSA, NID_md5WithRSAEncryption, NID_md5_sha1, NID_mdc2, NID_mdc2WithRSA, NID_member, NID_member_body, NID_mgf1, NID_mime_mhs, NID_mime_mhs_bodies, NID_mime_mhs_headings, NID_mobileTelephoneNumber, NID_modp_1536, NID_modp_2048, NID_modp_3072, NID_modp_4096, NID_modp_6144, NID_modp_8192, NID_ms_code_com, NID_ms_code_ind, NID_ms_csp_name, NID_ms_ctl_sign, NID_ms_efs, NID_ms_ext_req, NID_ms_sgc, NID_ms_smartcard_login, NID_ms_upn, NID_nSRecord, NID_name, NID_name_constraints, NID_netscape, NID_netscape_base_url, NID_netscape_ca_policy_url, NID_netscape_ca_revocation_url, NID_netscape_cert_extension, NID_netscape_cert_sequence, NID_netscape_cert_type, NID_netscape_comment, NID_netscape_data_type, NID_netscape_renewal_url, NID_netscape_revocation_url, NID_netscape_ssl_server_name, NID_no_rev_avail, NID_ns_sgc, NID_org, NID_organizationIdentifier, NID_organizationName, NID_organizationalStatus, NID_organizationalUnitName, NID_oscca, NID_otherMailbox, NID_owner, NID_pSpecified, NID_pagerTelephoneNumber, NID_pbeWithMD2AndDES_CBC, NID_pbeWithMD2AndRC2_CBC, NID_pbeWithMD5AndCast5_CBC, NID_pbeWithMD5AndDES_CBC, NID_pbeWithMD5AndRC2_CBC, NID_pbeWithSHA1AndDES_CBC, NID_pbeWithSHA1AndRC2_CBC, NID_pbe_WithSHA1And128BitRC2_CBC, NID_pbe_WithSHA1And128BitRC4, NID_pbe_WithSHA1And2_Key_TripleDES_CBC, NID_pbe_WithSHA1And3_Key_TripleDES_CBC, NID_pbe_WithSHA1And40BitRC2_CBC, NID_pbe_WithSHA1And40BitRC4, NID_pbes2, NID_pbmac1, NID_personalSignature, NID_personalTitle, NID_photo, NID_physicalDeliveryOfficeName, NID_pilot, NID_pilotAttributeSyntax, NID_pilotAttributeType, NID_pilotAttributeType27, NID_pilotDSA, NID_pilotGroups, NID_pilotObject, NID_pilotObjectClass, NID_pilotOrganization, NID_pilotPerson, NID_pkInitClientAuth, NID_pkInitKDC, NID_pkcs, NID_pkcs1, NID_pkcs3, NID_pkcs5, NID_pkcs7, NID_pkcs7_data, NID_pkcs7_digest, NID_pkcs7_encrypted, NID_pkcs7_enveloped, NID_pkcs7_signed, NID_pkcs7_signedAndEnveloped, NID_pkcs8ShroudedKeyBag, NID_pkcs9, NID_pkcs9_challengePassword, NID_pkcs9_contentType, NID_pkcs9_countersignature, NID_pkcs9_emailAddress, NID_pkcs9_extCertAttributes, NID_pkcs9_messageDigest, NID_pkcs9_signingTime, NID_pkcs9_unstructuredAddress, NID_pkcs9_unstructuredName, NID_policy_constraints, NID_policy_mappings, NID_poly1305, NID_postOfficeBox, NID_postalAddress, NID_postalCode, NID_preferredDeliveryMethod, NID_presentationAddress, NID_private_key_usage_period, NID_protocolInformation, NID_proxyCertInfo, NID_pseudonym, NID_pss, NID_qcStatements, NID_qualityLabelledData, NID_rFC822localPart, NID_rc2_40_cbc, NID_rc2_64_cbc, NID_rc2_cbc, NID_rc2_cfb64, NID_rc2_ecb, NID_rc2_ofb64, NID_rc4, NID_rc4_40, NID_rc4_hmac_md5, NID_rc5_cbc, NID_rc5_cfb64, NID_rc5_ecb, NID_rc5_ofb64, NID_registeredAddress, NID_rfc822Mailbox, NID_ripemd160, NID_ripemd160WithRSA, NID_role, NID_roleOccupant, NID_room, NID_roomNumber, NID_rpkiManifest, NID_rpkiNotify, NID_rsa, NID_rsaEncryption, NID_rsaOAEPEncryptionSET, NID_rsaSignature, NID_rsadsi, NID_rsaesOaep, NID_rsassaPss, NID_sOARecord, NID_safeContentsBag, NID_sbgp_autonomousSysNum, NID_sbgp_autonomousSysNumv2, NID_sbgp_ipAddrBlock, NID_sbgp_ipAddrBlockv2, NID_sbgp_routerIdentifier, NID_sdsiCertificate, NID_searchGuide, NID_secp112r1, NID_secp112r2, NID_secp128r1, NID_secp128r2, NID_secp160k1, NID_secp160r1, NID_secp160r2, NID_secp192k1, NID_secp224k1, NID_secp224r1, NID_secp256k1, NID_secp384r1, NID_secp521r1, NID_secretBag, NID_secretary, NID_sect113r1, NID_sect113r2, NID_sect131r1, NID_sect131r2, NID_sect163k1, NID_sect163r1, NID_sect163r2, NID_sect193r1, NID_sect193r2, NID_sect233k1, NID_sect233r1, NID_sect239k1, NID_sect283k1, NID_sect283r1, NID_sect409k1, NID_sect409r1, NID_sect571k1, NID_sect571r1, NID_seeAlso, NID_seed_cbc, NID_seed_cfb128, NID_seed_ecb, NID_seed_ofb128, NID_selected_attribute_types, NID_sendOwner, NID_sendProxiedOwner, NID_sendProxiedRouter, NID_sendRouter, NID_serialNumber, NID_server_auth, NID_setAttr_Cert, NID_setAttr_GenCryptgrm, NID_setAttr_IssCap, NID_setAttr_IssCap_CVM, NID_setAttr_IssCap_Sig, NID_setAttr_IssCap_T2, NID_setAttr_PGWYcap, NID_setAttr_SecDevSig, NID_setAttr_T2Enc, NID_setAttr_T2cleartxt, NID_setAttr_TokICCsig, NID_setAttr_TokenType, NID_setAttr_Token_B0Prime, NID_setAttr_Token_EMV, NID_setCext_IssuerCapabilities, NID_setCext_PGWYcapabilities, NID_setCext_TokenIdentifier, NID_setCext_TokenType, NID_setCext_Track2Data, NID_setCext_cCertRequired, NID_setCext_certType, NID_setCext_hashedRoot, NID_setCext_merchData, NID_setCext_setExt, NID_setCext_setQualf, NID_setCext_tunneling, NID_set_addPolicy, NID_set_attr, NID_set_brand, NID_set_brand_AmericanExpress, NID_set_brand_Diners, NID_set_brand_IATA_ATA, NID_set_brand_JCB, NID_set_brand_MasterCard, NID_set_brand_Novus, NID_set_brand_Visa, NID_set_certExt, NID_set_ctype, NID_set_msgExt, NID_set_policy, NID_set_policy_root, NID_set_rootKeyThumb, NID_setct_AcqCardCodeMsg, NID_setct_AcqCardCodeMsgTBE, NID_setct_AuthReqTBE, NID_setct_AuthReqTBS, NID_setct_AuthResBaggage, NID_setct_AuthResTBE, NID_setct_AuthResTBEX, NID_setct_AuthResTBS, NID_setct_AuthResTBSX, NID_setct_AuthRevReqBaggage, NID_setct_AuthRevReqTBE, NID_setct_AuthRevReqTBS, NID_setct_AuthRevResBaggage, NID_setct_AuthRevResData, NID_setct_AuthRevResTBE, NID_setct_AuthRevResTBEB, NID_setct_AuthRevResTBS, NID_setct_AuthTokenTBE, NID_setct_AuthTokenTBS, NID_setct_BCIDistributionTBS, NID_setct_BatchAdminReqData, NID_setct_BatchAdminReqTBE, NID_setct_BatchAdminResData, NID_setct_BatchAdminResTBE, NID_setct_CRLNotificationResTBS, NID_setct_CRLNotificationTBS, NID_setct_CapReqTBE, NID_setct_CapReqTBEX, NID_setct_CapReqTBS, NID_setct_CapReqTBSX, NID_setct_CapResData, NID_setct_CapResTBE, NID_setct_CapRevReqTBE, NID_setct_CapRevReqTBEX, NID_setct_CapRevReqTBS, NID_setct_CapRevReqTBSX, NID_setct_CapRevResData, NID_setct_CapRevResTBE, NID_setct_CapTokenData, NID_setct_CapTokenSeq, NID_setct_CapTokenTBE, NID_setct_CapTokenTBEX, NID_setct_CapTokenTBS, NID_setct_CardCInitResTBS, NID_setct_CertInqReqTBS, NID_setct_CertReqData, NID_setct_CertReqTBE, NID_setct_CertReqTBEX, NID_setct_CertReqTBS, NID_setct_CertResData, NID_setct_CertResTBE, NID_setct_CredReqTBE, NID_setct_CredReqTBEX, NID_setct_CredReqTBS, NID_setct_CredReqTBSX, NID_setct_CredResData, NID_setct_CredResTBE, NID_setct_CredRevReqTBE, NID_setct_CredRevReqTBEX, NID_setct_CredRevReqTBS, NID_setct_CredRevReqTBSX, NID_setct_CredRevResData, NID_setct_CredRevResTBE, NID_setct_ErrorTBS, NID_setct_HODInput, NID_setct_MeAqCInitResTBS, NID_setct_OIData, NID_setct_PANData, NID_setct_PANOnly, NID_setct_PANToken, NID_setct_PCertReqData, NID_setct_PCertResTBS, NID_setct_PI, NID_setct_PIData, NID_setct_PIDataUnsigned, NID_setct_PIDualSignedTBE, NID_setct_PIUnsignedTBE, NID_setct_PI_TBS, NID_setct_PInitResData, NID_setct_PResData, NID_setct_RegFormReqTBE, NID_setct_RegFormResTBS, NID_setext_cv, NID_setext_genCrypt, NID_setext_miAuth, NID_setext_pinAny, NID_setext_pinSecure, NID_setext_track2, NID_sha, NID_sha1, NID_sha1WithRSA, NID_sha1WithRSAEncryption, NID_sha224, NID_sha224WithRSAEncryption, NID_sha256, NID_sha256WithRSAEncryption, NID_sha384, NID_sha384WithRSAEncryption, NID_sha3_224, NID_sha3_256, NID_sha3_384, NID_sha3_512, NID_sha512, NID_sha512WithRSAEncryption, NID_sha512_224, NID_sha512_224WithRSAEncryption, NID_sha512_256, NID_sha512_256WithRSAEncryption, NID_shaWithRSAEncryption, NID_shake128, NID_shake256, NID_signedObject, NID_simpleSecurityObject, NID_sinfo_access, NID_singleLevelQuality, NID_siphash, NID_sm2, NID_sm3, NID_sm3WithRSAEncryption, NID_sm4_cbc, NID_sm4_cfb1, NID_sm4_cfb128, NID_sm4_cfb8, NID_sm4_ctr, NID_sm4_ecb, NID_sm4_ofb128, NID_sm_scheme, NID_sshClient, NID_sshServer, NID_sshkdf, NID_sskdf, NID_stateOrProvinceName, NID_streetAddress, NID_subjectSignTool, NID_subject_alt_name, NID_subject_directory_attributes, NID_subject_key_identifier, NID_subtreeMaximumQuality, NID_subtreeMinimumQuality, NID_supportedAlgorithms, NID_supportedApplicationContext, NID_surname, NID_sxnet, NID_target_information, NID_telephoneNumber, NID_teletexTerminalIdentifier, NID_telexNumber, NID_textEncodedORAddress, NID_textNotice, NID_time_stamp, NID_title, NID_tls1_prf, NID_tlsfeature, NID_ua_pki, NID_uacurve0, NID_uacurve1, NID_uacurve2, NID_uacurve3, NID_uacurve4, NID_uacurve5, NID_uacurve6, NID_uacurve7, NID_uacurve8, NID_uacurve9, NID_ucl, NID_undef, NID_uniqueIdentifier, NID_uniqueMember, NID_userCertificate, NID_userClass, NID_userId, NID_userPassword, NID_wap, NID_wap_wsg, NID_wap_wsg_idm_ecid_wtls1, NID_wap_wsg_idm_ecid_wtls10, NID_wap_wsg_idm_ecid_wtls11, NID_wap_wsg_idm_ecid_wtls12, NID_wap_wsg_idm_ecid_wtls3, NID_wap_wsg_idm_ecid_wtls4, NID_wap_wsg_idm_ecid_wtls5, NID_wap_wsg_idm_ecid_wtls6, NID_wap_wsg_idm_ecid_wtls7, NID_wap_wsg_idm_ecid_wtls8, NID_wap_wsg_idm_ecid_wtls9, NID_whirlpool, NID_x121Address, NID_x500UniqueIdentifier, NID_x509Certificate, NID_x509Crl, NID_x509ExtAdmission, NID_x942kdf, NID_x963kdf, NID_zlib_compression, NON_EMPTY_TRANSLATION_UNIT, OBJ_BSEARCH_FIRST_VALUE_ON_MATCH, OBJ_BSEARCH_VALUE_ON_NOMATCH, OBJ_Directory, OBJ_Domain, OBJ_ED25519, OBJ_ED448, OBJ_Enterprises, OBJ_Experimental, OBJ_INN, OBJ_ISO_CN, OBJ_ISO_UA, OBJ_ISO_US, OBJ_Independent, OBJ_LocalKeySet, OBJ_Mail, OBJ_Management, OBJ_NAIRealm, OBJ_NAME_ALIAS, OBJ_NAME_TYPE_CIPHER_METH, OBJ_NAME_TYPE_COMP_METH, OBJ_NAME_TYPE_KDF_METH, OBJ_NAME_TYPE_MAC_METH, OBJ_NAME_TYPE_MD_METH, OBJ_NAME_TYPE_NUM, OBJ_NAME_TYPE_PKEY_METH, OBJ_NAME_TYPE_UNDEF, OBJ_OCSP_sign, OBJ_OGRN, OBJ_OGRNIP, OBJ_Private, OBJ_RSA_SHA3_224, OBJ_RSA_SHA3_256, OBJ_RSA_SHA3_384, OBJ_RSA_SHA3_512, OBJ_R_OID_EXISTS, OBJ_R_UNKNOWN_NID, OBJ_R_UNKNOWN_OBJECT_NAME, OBJ_SM2_with_SM3, OBJ_SMIME, OBJ_SMIMECapabilities, OBJ_SNILS, OBJ_SNMPv2, OBJ_SRVName, OBJ_Security, OBJ_X25519, OBJ_X448, OBJ_X500, OBJ_X500algorithms, OBJ_X509, OBJ_X9_57, OBJ_X9_62_c2onb191v4, OBJ_X9_62_c2onb191v5, OBJ_X9_62_c2onb239v4, OBJ_X9_62_c2onb239v5, OBJ_X9_62_c2pnb163v1, OBJ_X9_62_c2pnb163v2, OBJ_X9_62_c2pnb163v3, OBJ_X9_62_c2pnb176v1, OBJ_X9_62_c2pnb208w1, OBJ_X9_62_c2pnb272w1, OBJ_X9_62_c2pnb304w1, OBJ_X9_62_c2pnb368w1, OBJ_X9_62_c2tnb191v1, OBJ_X9_62_c2tnb191v2, OBJ_X9_62_c2tnb191v3, OBJ_X9_62_c2tnb239v1, OBJ_X9_62_c2tnb239v2, OBJ_X9_62_c2tnb239v3, OBJ_X9_62_c2tnb359v1, OBJ_X9_62_c2tnb431r1, OBJ_X9_62_c_TwoCurve, OBJ_X9_62_characteristic_two_field, OBJ_X9_62_ellipticCurve, OBJ_X9_62_id_characteristic_two_basis, OBJ_X9_62_id_ecPublicKey, OBJ_X9_62_id_ecSigType, OBJ_X9_62_id_fieldType, OBJ_X9_62_id_publicKeyType, OBJ_X9_62_onBasis, OBJ_X9_62_ppBasis, OBJ_X9_62_prime192v1, OBJ_X9_62_prime192v2, OBJ_X9_62_prime192v3, OBJ_X9_62_prime239v1, OBJ_X9_62_prime239v2, OBJ_X9_62_prime239v3, OBJ_X9_62_prime256v1, OBJ_X9_62_primeCurve, OBJ_X9_62_prime_field, OBJ_X9_62_tpBasis, OBJ_X9cm, OBJ_XmppAddr, OBJ_aRecord, OBJ_aaControls, OBJ_ac_auditEntity, OBJ_ac_proxying, OBJ_ac_targeting, OBJ_account, OBJ_ad_OCSP, OBJ_ad_ca_issuers, OBJ_ad_dvcs, OBJ_ad_timeStamping, OBJ_aes, OBJ_aes_128_cbc, OBJ_aes_128_ccm, OBJ_aes_128_cfb128, OBJ_aes_128_ecb, OBJ_aes_128_gcm, OBJ_aes_128_ofb128, OBJ_aes_128_xts, OBJ_aes_192_cbc, OBJ_aes_192_ccm, OBJ_aes_192_cfb128, OBJ_aes_192_ecb, OBJ_aes_192_gcm, OBJ_aes_192_ofb128, OBJ_aes_256_cbc, OBJ_aes_256_ccm, OBJ_aes_256_cfb128, OBJ_aes_256_ecb, OBJ_aes_256_gcm, OBJ_aes_256_ofb128, OBJ_aes_256_xts, OBJ_algorithm, OBJ_ansi_X9_62, OBJ_anyExtendedKeyUsage, OBJ_any_policy, OBJ_aria, OBJ_aria_128_cbc, OBJ_aria_128_ccm, OBJ_aria_128_cfb128, OBJ_aria_128_ctr, OBJ_aria_128_ecb, OBJ_aria_128_gcm, OBJ_aria_128_ofb128, OBJ_aria_192_cbc, OBJ_aria_192_ccm, OBJ_aria_192_cfb128, OBJ_aria_192_ctr, OBJ_aria_192_ecb, OBJ_aria_192_gcm, OBJ_aria_192_ofb128, OBJ_aria_256_cbc, OBJ_aria_256_ccm, OBJ_aria_256_cfb128, OBJ_aria_256_ctr, OBJ_aria_256_ecb, OBJ_aria_256_gcm, OBJ_aria_256_ofb128, OBJ_associatedDomain, OBJ_associatedName, OBJ_audio, OBJ_authorityRevocationList, OBJ_authority_key_identifier, OBJ_basic_constraints, OBJ_bf_cbc, OBJ_biometricInfo, OBJ_blake2b512, OBJ_blake2bmac, OBJ_blake2s256, OBJ_blake2smac, OBJ_brainpoolP160r1, OBJ_brainpoolP160t1, OBJ_brainpoolP192r1, OBJ_brainpoolP192t1, OBJ_brainpoolP224r1, OBJ_brainpoolP224t1, OBJ_brainpoolP256r1, OBJ_brainpoolP256t1, OBJ_brainpoolP320r1, OBJ_brainpoolP320t1, OBJ_brainpoolP384r1, OBJ_brainpoolP384t1, OBJ_brainpoolP512r1, OBJ_brainpoolP512t1, OBJ_buildingName, OBJ_businessCategory, OBJ_cACertificate, OBJ_cNAMERecord, OBJ_caRepository, OBJ_camellia, OBJ_camellia_128_cbc, OBJ_camellia_128_ccm, OBJ_camellia_128_cfb128, OBJ_camellia_128_cmac, OBJ_camellia_128_ctr, OBJ_camellia_128_ecb, OBJ_camellia_128_gcm, OBJ_camellia_128_ofb128, OBJ_camellia_192_cbc, OBJ_camellia_192_ccm, OBJ_camellia_192_cfb128, OBJ_camellia_192_cmac, OBJ_camellia_192_ctr, OBJ_camellia_192_ecb, OBJ_camellia_192_gcm, OBJ_camellia_192_ofb128, OBJ_camellia_256_cbc, OBJ_camellia_256_ccm, OBJ_camellia_256_cfb128, OBJ_camellia_256_cmac, OBJ_camellia_256_ctr, OBJ_camellia_256_ecb, OBJ_camellia_256_gcm, OBJ_camellia_256_ofb128, OBJ_capwapAC, OBJ_capwapWTP, OBJ_caseIgnoreIA5StringSyntax, OBJ_cast5_cbc, OBJ_ccitt, OBJ_certBag, OBJ_certTypes, OBJ_certicom_arc, OBJ_certificateRevocationList, OBJ_certificate_issuer, OBJ_certificate_policies, OBJ_classSignTool, OBJ_classSignToolKA1, OBJ_classSignToolKB1, OBJ_classSignToolKB2, OBJ_classSignToolKC1, OBJ_classSignToolKC2, OBJ_classSignToolKC3, OBJ_clearance, OBJ_client_auth, OBJ_cmKGA, OBJ_cmcArchive, OBJ_cmcCA, OBJ_cmcRA, OBJ_code_sign, OBJ_commonName, OBJ_countryCode3c, OBJ_countryCode3n, OBJ_countryName, OBJ_crlBag, OBJ_crlTypes, OBJ_crl_distribution_points, OBJ_crl_number, OBJ_crl_reason, OBJ_crossCertificatePair, OBJ_cryptocom, OBJ_cryptopro, OBJ_csor, OBJ_ct_cert_scts, OBJ_ct_precert_poison, OBJ_ct_precert_scts, OBJ_ct_precert_signer, OBJ_dITRedirect, OBJ_dNSDomain, OBJ_dSAQuality, OBJ_data, OBJ_dcObject, OBJ_deltaRevocationList, OBJ_delta_crl, OBJ_des_cbc, OBJ_des_cdmf, OBJ_des_cfb64, OBJ_des_ecb, OBJ_des_ede3_cbc, OBJ_des_ede_ecb, OBJ_des_ofb64, OBJ_description, OBJ_destinationIndicator, OBJ_dhKeyAgreement, OBJ_dhSinglePass_cofactorDH_sha1kdf_scheme, OBJ_dhSinglePass_cofactorDH_sha224kdf_scheme, OBJ_dhSinglePass_cofactorDH_sha256kdf_scheme, OBJ_dhSinglePass_cofactorDH_sha384kdf_scheme, OBJ_dhSinglePass_cofactorDH_sha512kdf_scheme, OBJ_dhSinglePass_stdDH_sha1kdf_scheme, OBJ_dhSinglePass_stdDH_sha224kdf_scheme, OBJ_dhSinglePass_stdDH_sha256kdf_scheme, OBJ_dhSinglePass_stdDH_sha384kdf_scheme, OBJ_dhSinglePass_stdDH_sha512kdf_scheme, OBJ_dhpublicnumber, OBJ_distinguishedName, OBJ_dmdName, OBJ_dnQualifier, OBJ_dnsName, OBJ_document, OBJ_documentAuthor, OBJ_documentIdentifier, OBJ_documentLocation, OBJ_documentPublisher, OBJ_documentSeries, OBJ_documentTitle, OBJ_documentVersion, OBJ_dod, OBJ_domainComponent, OBJ_domainRelatedObject, OBJ_dsa, OBJ_dsaWithSHA, OBJ_dsaWithSHA1, OBJ_dsaWithSHA1_2, OBJ_dsa_2, OBJ_dsa_with_SHA224, OBJ_dsa_with_SHA256, OBJ_dsa_with_SHA384, OBJ_dsa_with_SHA3_224, OBJ_dsa_with_SHA3_256, OBJ_dsa_with_SHA3_384, OBJ_dsa_with_SHA3_512, OBJ_dsa_with_SHA512, OBJ_dsa_with_sha2, OBJ_dstu28147, OBJ_dstu28147_cfb, OBJ_dstu28147_ofb, OBJ_dstu28147_wrap, OBJ_dstu34311, OBJ_dstu4145be, OBJ_dstu4145le, OBJ_dvcs, OBJ_ecdsa_with_Recommended, OBJ_ecdsa_with_SHA1, OBJ_ecdsa_with_SHA224, OBJ_ecdsa_with_SHA256, OBJ_ecdsa_with_SHA384, OBJ_ecdsa_with_SHA3_224, OBJ_ecdsa_with_SHA3_256, OBJ_ecdsa_with_SHA3_384, OBJ_ecdsa_with_SHA3_512, OBJ_ecdsa_with_SHA512, OBJ_ecdsa_with_Specified, OBJ_email_protect, OBJ_enhancedSearchGuide, OBJ_ext_key_usage, OBJ_ext_req, OBJ_facsimileTelephoneNumber, OBJ_favouriteDrink, OBJ_freshest_crl, OBJ_friendlyCountry, OBJ_friendlyCountryName, OBJ_friendlyName, OBJ_generationQualifier, OBJ_givenName, OBJ_gmac, OBJ_hmacWithDstu34311, OBJ_hmacWithMD5, OBJ_hmacWithSHA1, OBJ_hmacWithSHA224, OBJ_hmacWithSHA256, OBJ_hmacWithSHA384, OBJ_hmacWithSHA512, OBJ_hmacWithSHA512_224, OBJ_hmacWithSHA512_256, OBJ_hmac_md5, OBJ_hmac_sha1, OBJ_hmac_sha3_224, OBJ_hmac_sha3_256, OBJ_hmac_sha3_384, OBJ_hmac_sha3_512, OBJ_holdInstruction, OBJ_hold_instruction_call_issuer, OBJ_hold_instruction_code, OBJ_hold_instruction_none, OBJ_hold_instruction_reject, OBJ_homePostalAddress, OBJ_homeTelephoneNumber, OBJ_host, OBJ_houseIdentifier, OBJ_iA5StringSyntax, OBJ_iana, OBJ_id_DHBasedMac, OBJ_id_Gost28147_89, OBJ_id_Gost28147_89_CryptoPro_A_ParamSet, OBJ_id_Gost28147_89_CryptoPro_B_ParamSet, OBJ_id_Gost28147_89_CryptoPro_C_ParamSet, OBJ_id_Gost28147_89_CryptoPro_D_ParamSet, OBJ_id_Gost28147_89_CryptoPro_KeyMeshing, OBJ_id_Gost28147_89_CryptoPro_Oscar_1_0_ParamSet, OBJ_id_Gost28147_89_CryptoPro_Oscar_1_1_ParamSet, OBJ_id_Gost28147_89_CryptoPro_RIC_1_ParamSet, OBJ_id_Gost28147_89_MAC, OBJ_id_Gost28147_89_None_KeyMeshing, OBJ_id_Gost28147_89_TestParamSet, OBJ_id_Gost28147_89_cc, OBJ_id_GostR3410_2001, OBJ_id_GostR3410_2001DH, OBJ_id_GostR3410_2001_CryptoPro_A_ParamSet, OBJ_id_GostR3410_2001_CryptoPro_B_ParamSet, OBJ_id_GostR3410_2001_CryptoPro_C_ParamSet, OBJ_id_GostR3410_2001_CryptoPro_XchA_ParamSet, OBJ_id_GostR3410_2001_CryptoPro_XchB_ParamSet, OBJ_id_GostR3410_2001_ParamSet_cc, OBJ_id_GostR3410_2001_TestParamSet, OBJ_id_GostR3410_2001_cc, OBJ_id_GostR3410_2012_256, OBJ_id_GostR3410_2012_512, OBJ_id_GostR3410_94, OBJ_id_GostR3410_94DH, OBJ_id_GostR3410_94_CryptoPro_A_ParamSet, OBJ_id_GostR3410_94_CryptoPro_B_ParamSet, OBJ_id_GostR3410_94_CryptoPro_C_ParamSet, OBJ_id_GostR3410_94_CryptoPro_D_ParamSet, OBJ_id_GostR3410_94_CryptoPro_XchA_ParamSet, OBJ_id_GostR3410_94_CryptoPro_XchB_ParamSet, OBJ_id_GostR3410_94_CryptoPro_XchC_ParamSet, OBJ_id_GostR3410_94_TestParamSet, OBJ_id_GostR3410_94_a, OBJ_id_GostR3410_94_aBis, OBJ_id_GostR3410_94_b, OBJ_id_GostR3410_94_bBis, OBJ_id_GostR3410_94_cc, OBJ_id_GostR3411_2012_256, OBJ_id_GostR3411_2012_512, OBJ_id_GostR3411_94, OBJ_id_GostR3411_94_CryptoProParamSet, OBJ_id_GostR3411_94_TestParamSet, OBJ_id_GostR3411_94_prf, OBJ_id_GostR3411_94_with_GostR3410_2001, OBJ_id_GostR3411_94_with_GostR3410_2001_cc, OBJ_id_GostR3411_94_with_GostR3410_94, OBJ_id_GostR3411_94_with_GostR3410_94_cc, OBJ_id_HMACGostR3411_94, OBJ_id_PasswordBasedMAC, OBJ_id_aca, OBJ_id_aca_accessIdentity, OBJ_id_aca_authenticationInfo, OBJ_id_aca_chargingIdentity, OBJ_id_aca_encAttrs, OBJ_id_aca_group, OBJ_id_aca_role, OBJ_id_ad, OBJ_id_aes128_wrap, OBJ_id_aes128_wrap_pad, OBJ_id_aes192_wrap, OBJ_id_aes192_wrap_pad, OBJ_id_aes256_wrap, OBJ_id_aes256_wrap_pad, OBJ_id_alg, OBJ_id_alg_PWRI_KEK, OBJ_id_alg_des40, OBJ_id_alg_dh_pop, OBJ_id_alg_dh_sig_hmac_sha1, OBJ_id_alg_noSignature, OBJ_id_camellia128_wrap, OBJ_id_camellia192_wrap, OBJ_id_camellia256_wrap, OBJ_id_cct, OBJ_id_cct_PKIData, OBJ_id_cct_PKIResponse, OBJ_id_cct_crs, OBJ_id_ce, OBJ_id_cmc, OBJ_id_cmc_addExtensions, OBJ_id_cmc_confirmCertAcceptance, OBJ_id_cmc_dataReturn, OBJ_id_cmc_decryptedPOP, OBJ_id_cmc_encryptedPOP, OBJ_id_cmc_getCRL, OBJ_id_cmc_getCert, OBJ_id_cmc_identification, OBJ_id_cmc_identityProof, OBJ_id_cmc_lraPOPWitness, OBJ_id_cmc_popLinkRandom, OBJ_id_cmc_popLinkWitness, OBJ_id_cmc_queryPending, OBJ_id_cmc_recipientNonce, OBJ_id_cmc_regInfo, OBJ_id_cmc_responseInfo, OBJ_id_cmc_revokeRequest, OBJ_id_cmc_senderNonce, OBJ_id_cmc_statusInfo, OBJ_id_cmc_transactionId, OBJ_id_cp, OBJ_id_ct_asciiTextWithCRLF, OBJ_id_ct_geofeedCSVwithCRLF, OBJ_id_ct_resourceTaggedAttest, OBJ_id_ct_routeOriginAuthz, OBJ_id_ct_rpkiGhostbusters, OBJ_id_ct_rpkiManifest, OBJ_id_ct_signedChecklist, OBJ_id_ct_xml, OBJ_id_hex_multipart_message, OBJ_id_hex_partial_message, OBJ_id_it, OBJ_id_it_caCerts, OBJ_id_it_caKeyUpdateInfo, OBJ_id_it_caProtEncCert, OBJ_id_it_certReqTemplate, OBJ_id_it_confirmWaitTime, OBJ_id_it_currentCRL, OBJ_id_it_encKeyPairTypes, OBJ_id_it_implicitConfirm, OBJ_id_it_keyPairParamRep, OBJ_id_it_keyPairParamReq, OBJ_id_it_origPKIMessage, OBJ_id_it_preferredSymmAlg, OBJ_id_it_revPassphrase, OBJ_id_it_rootCaKeyUpdate, OBJ_id_it_signKeyPairTypes, OBJ_id_it_subscriptionRequest, OBJ_id_it_subscriptionResponse, OBJ_id_it_suppLangTags, OBJ_id_it_unsupportedOIDs, OBJ_id_kp, OBJ_id_kp_BrandIndicatorforMessageIdentification, OBJ_id_kp_bgpsec_router, OBJ_id_mod_attribute_cert, OBJ_id_mod_cmc, OBJ_id_mod_cmp, OBJ_id_mod_cmp2000, OBJ_id_mod_crmf, OBJ_id_mod_dvcs, OBJ_id_mod_kea_profile_88, OBJ_id_mod_kea_profile_93, OBJ_id_mod_ocsp, OBJ_id_mod_qualified_cert_88, OBJ_id_mod_qualified_cert_93, OBJ_id_mod_timestamp_protocol, OBJ_id_on, OBJ_id_on_SmtpUTF8Mailbox, OBJ_id_on_permanentIdentifier, OBJ_id_on_personalData, OBJ_id_pbkdf2, OBJ_id_pda, OBJ_id_pda_countryOfCitizenship, OBJ_id_pda_countryOfResidence, OBJ_id_pda_dateOfBirth, OBJ_id_pda_gender, OBJ_id_pda_placeOfBirth, OBJ_id_pe, OBJ_id_pkinit, OBJ_id_pkip, OBJ_id_pkix, OBJ_id_pkix1_explicit_88, OBJ_id_pkix1_explicit_93, OBJ_id_pkix1_implicit_88, OBJ_id_pkix1_implicit_93, OBJ_id_pkix_OCSP, OBJ_id_pkix_OCSP_CrlID, OBJ_id_pkix_OCSP_Nonce, OBJ_id_pkix_OCSP_acceptableResponses, OBJ_id_pkix_OCSP_archiveCutoff, OBJ_id_pkix_OCSP_basic, OBJ_id_pkix_OCSP_extendedStatus, OBJ_id_pkix_OCSP_noCheck, OBJ_id_pkix_OCSP_path, OBJ_id_pkix_OCSP_serviceLocator, OBJ_id_pkix_OCSP_trustRoot, OBJ_id_pkix_OCSP_valid, OBJ_id_pkix_mod, OBJ_id_ppl, OBJ_id_ppl_anyLanguage, OBJ_id_ppl_inheritAll, OBJ_id_qcs, OBJ_id_qcs_pkixQCSyntax_v1, OBJ_id_qt, OBJ_id_qt_cps, OBJ_id_qt_unotice, OBJ_id_regCtrl, OBJ_id_regCtrl_authenticator, OBJ_id_regCtrl_oldCertID, OBJ_id_regCtrl_pkiArchiveOptions, OBJ_id_regCtrl_pkiPublicationInfo, OBJ_id_regCtrl_protocolEncrKey, OBJ_id_regCtrl_regToken, OBJ_id_regInfo, OBJ_id_regInfo_certReq, OBJ_id_regInfo_utf8Pairs, OBJ_id_scrypt, OBJ_id_set, OBJ_id_smime_aa, OBJ_id_smime_aa_contentHint, OBJ_id_smime_aa_contentIdentifier, OBJ_id_smime_aa_contentReference, OBJ_id_smime_aa_dvcs_dvc, OBJ_id_smime_aa_encapContentType, OBJ_id_smime_aa_encrypKeyPref, OBJ_id_smime_aa_equivalentLabels, OBJ_id_smime_aa_ets_CertificateRefs, OBJ_id_smime_aa_ets_RevocationRefs, OBJ_id_smime_aa_ets_archiveTimeStamp, OBJ_id_smime_aa_ets_certCRLTimestamp, OBJ_id_smime_aa_ets_certValues, OBJ_id_smime_aa_ets_commitmentType, OBJ_id_smime_aa_ets_contentTimestamp, OBJ_id_smime_aa_ets_escTimeStamp, OBJ_id_smime_aa_ets_otherSigCert, OBJ_id_smime_aa_ets_revocationValues, OBJ_id_smime_aa_ets_sigPolicyId, OBJ_id_smime_aa_ets_signerAttr, OBJ_id_smime_aa_ets_signerLocation, OBJ_id_smime_aa_macValue, OBJ_id_smime_aa_mlExpandHistory, OBJ_id_smime_aa_msgSigDigest, OBJ_id_smime_aa_receiptRequest, OBJ_id_smime_aa_securityLabel, OBJ_id_smime_aa_signatureType, OBJ_id_smime_aa_signingCertificate, OBJ_id_smime_aa_signingCertificateV2, OBJ_id_smime_aa_smimeEncryptCerts, OBJ_id_smime_aa_timeStampToken, OBJ_id_smime_alg, OBJ_id_smime_alg_3DESwrap, OBJ_id_smime_alg_CMS3DESwrap, OBJ_id_smime_alg_CMSRC2wrap, OBJ_id_smime_alg_ESDH, OBJ_id_smime_alg_ESDHwith3DES, OBJ_id_smime_alg_ESDHwithRC2, OBJ_id_smime_alg_RC2wrap, OBJ_id_smime_cd, OBJ_id_smime_cd_ldap, OBJ_id_smime_ct, OBJ_id_smime_ct_DVCSRequestData, OBJ_id_smime_ct_DVCSResponseData, OBJ_id_smime_ct_TDTInfo, OBJ_id_smime_ct_TSTInfo, OBJ_id_smime_ct_authData, OBJ_id_smime_ct_authEnvelopedData, OBJ_id_smime_ct_compressedData, OBJ_id_smime_ct_contentCollection, OBJ_id_smime_ct_contentInfo, OBJ_id_smime_ct_publishCert, OBJ_id_smime_ct_receipt, OBJ_id_smime_cti, OBJ_id_smime_cti_ets_proofOfApproval, OBJ_id_smime_cti_ets_proofOfCreation, OBJ_id_smime_cti_ets_proofOfDelivery, OBJ_id_smime_cti_ets_proofOfOrigin, OBJ_id_smime_cti_ets_proofOfReceipt, OBJ_id_smime_cti_ets_proofOfSender, OBJ_id_smime_mod, OBJ_id_smime_mod_cms, OBJ_id_smime_mod_ess, OBJ_id_smime_mod_ets_eSigPolicy_88, OBJ_id_smime_mod_ets_eSigPolicy_97, OBJ_id_smime_mod_ets_eSignature_88, OBJ_id_smime_mod_ets_eSignature_97, OBJ_id_smime_mod_msg_v3, OBJ_id_smime_mod_oid, OBJ_id_smime_spq, OBJ_id_smime_spq_ets_sqt_unotice, OBJ_id_smime_spq_ets_sqt_uri, OBJ_id_tc26, OBJ_id_tc26_agreement, OBJ_id_tc26_agreement_gost_3410_2012_256, OBJ_id_tc26_agreement_gost_3410_2012_512, OBJ_id_tc26_algorithms, OBJ_id_tc26_cipher, OBJ_id_tc26_cipher_constants, OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik, OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm, OBJ_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm_omac, OBJ_id_tc26_cipher_gostr3412_2015_magma, OBJ_id_tc26_cipher_gostr3412_2015_magma_ctracpkm, OBJ_id_tc26_cipher_gostr3412_2015_magma_ctracpkm_omac, OBJ_id_tc26_constants, OBJ_id_tc26_digest, OBJ_id_tc26_digest_constants, OBJ_id_tc26_gost_28147_constants, OBJ_id_tc26_gost_28147_param_Z, OBJ_id_tc26_gost_3410_2012_256_constants, OBJ_id_tc26_gost_3410_2012_256_paramSetA, OBJ_id_tc26_gost_3410_2012_256_paramSetB, OBJ_id_tc26_gost_3410_2012_256_paramSetC, OBJ_id_tc26_gost_3410_2012_256_paramSetD, OBJ_id_tc26_gost_3410_2012_512_constants, OBJ_id_tc26_gost_3410_2012_512_paramSetA, OBJ_id_tc26_gost_3410_2012_512_paramSetB, OBJ_id_tc26_gost_3410_2012_512_paramSetC, OBJ_id_tc26_gost_3410_2012_512_paramSetTest, OBJ_id_tc26_hmac_gost_3411_2012_256, OBJ_id_tc26_hmac_gost_3411_2012_512, OBJ_id_tc26_mac, OBJ_id_tc26_sign, OBJ_id_tc26_sign_constants, OBJ_id_tc26_signwithdigest, OBJ_id_tc26_signwithdigest_gost3410_2012_256, OBJ_id_tc26_signwithdigest_gost3410_2012_512, OBJ_id_tc26_wrap, OBJ_id_tc26_wrap_gostr3412_2015_kuznyechik, OBJ_id_tc26_wrap_gostr3412_2015_kuznyechik_kexp15, OBJ_id_tc26_wrap_gostr3412_2015_magma, OBJ_id_tc26_wrap_gostr3412_2015_magma_kexp15, OBJ_idea_cbc, OBJ_identified_organization, OBJ_ieee, OBJ_ieee_siswg, OBJ_info, OBJ_info_access, OBJ_inhibit_any_policy, OBJ_initials, OBJ_international_organizations, OBJ_internationaliSDNNumber, OBJ_internet, OBJ_invalidity_date, OBJ_ipAddr_asNumber, OBJ_ipAddr_asNumberv2, OBJ_ipsecEndSystem, OBJ_ipsecTunnel, OBJ_ipsecUser, OBJ_ipsec_IKE, OBJ_iso, OBJ_issuerSignTool, OBJ_issuer_alt_name, OBJ_issuing_distribution_point, OBJ_itu_t, OBJ_janetMailbox, OBJ_joint_iso_ccitt, OBJ_joint_iso_itu_t, OBJ_jurisdictionCountryName, OBJ_jurisdictionLocalityName, OBJ_jurisdictionStateOrProvinceName, OBJ_keyBag, OBJ_key_usage, OBJ_kisa, OBJ_kmac128, OBJ_kmac256, OBJ_kuznyechik_ctr_acpkm, OBJ_kuznyechik_ctr_acpkm_omac, OBJ_kuznyechik_kexp15, OBJ_lastModifiedBy, OBJ_lastModifiedTime, OBJ_localKeyID, OBJ_localityName, OBJ_mXRecord, OBJ_magma_ctr_acpkm, OBJ_magma_ctr_acpkm_omac, OBJ_magma_kexp15, OBJ_mailPreferenceOption, OBJ_manager, OBJ_md2, OBJ_md2WithRSAEncryption, OBJ_md4, OBJ_md4WithRSAEncryption, OBJ_md5, OBJ_md5WithRSA, OBJ_md5WithRSAEncryption, OBJ_mdc2, OBJ_mdc2WithRSA, OBJ_member, OBJ_member_body, OBJ_mgf1, OBJ_mime_mhs, OBJ_mime_mhs_bodies, OBJ_mime_mhs_headings, OBJ_mobileTelephoneNumber, OBJ_ms_code_com, OBJ_ms_code_ind, OBJ_ms_csp_name, OBJ_ms_ctl_sign, OBJ_ms_efs, OBJ_ms_ext_req, OBJ_ms_sgc, OBJ_ms_smartcard_login, OBJ_ms_upn, OBJ_nSRecord, OBJ_name, OBJ_name_constraints, OBJ_netscape, OBJ_netscape_base_url, OBJ_netscape_ca_policy_url, OBJ_netscape_ca_revocation_url, OBJ_netscape_cert_extension, OBJ_netscape_cert_sequence, OBJ_netscape_cert_type, OBJ_netscape_comment, OBJ_netscape_data_type, OBJ_netscape_renewal_url, OBJ_netscape_revocation_url, OBJ_netscape_ssl_server_name, OBJ_nistAlgorithms, OBJ_nist_hashalgs, OBJ_no_rev_avail, OBJ_ns_sgc, OBJ_ntt_ds, OBJ_org, OBJ_organizationIdentifier, OBJ_organizationName, OBJ_organizationalStatus, OBJ_organizationalUnitName, OBJ_oscca, OBJ_otherMailbox, OBJ_owner, OBJ_pSpecified, OBJ_pagerTelephoneNumber, OBJ_pbeWithMD2AndDES_CBC, OBJ_pbeWithMD2AndRC2_CBC, OBJ_pbeWithMD5AndCast5_CBC, OBJ_pbeWithMD5AndDES_CBC, OBJ_pbeWithMD5AndRC2_CBC, OBJ_pbeWithSHA1AndDES_CBC, OBJ_pbeWithSHA1AndRC2_CBC, OBJ_pbe_WithSHA1And128BitRC2_CBC, OBJ_pbe_WithSHA1And128BitRC4, OBJ_pbe_WithSHA1And2_Key_TripleDES_CBC, OBJ_pbe_WithSHA1And3_Key_TripleDES_CBC, OBJ_pbe_WithSHA1And40BitRC2_CBC, OBJ_pbe_WithSHA1And40BitRC4, OBJ_pbes2, OBJ_pbmac1, OBJ_personalSignature, OBJ_personalTitle, OBJ_photo, OBJ_physicalDeliveryOfficeName, OBJ_pilot, OBJ_pilotAttributeSyntax, OBJ_pilotAttributeType, OBJ_pilotAttributeType27, OBJ_pilotDSA, OBJ_pilotGroups, OBJ_pilotObject, OBJ_pilotObjectClass, OBJ_pilotOrganization, OBJ_pilotPerson, OBJ_pkInitClientAuth, OBJ_pkInitKDC, OBJ_pkcs, OBJ_pkcs1, OBJ_pkcs12, OBJ_pkcs12_BagIds, OBJ_pkcs12_Version1, OBJ_pkcs12_pbeids, OBJ_pkcs3, OBJ_pkcs5, OBJ_pkcs7, OBJ_pkcs7_data, OBJ_pkcs7_digest, OBJ_pkcs7_encrypted, OBJ_pkcs7_enveloped, OBJ_pkcs7_signed, OBJ_pkcs7_signedAndEnveloped, OBJ_pkcs8ShroudedKeyBag, OBJ_pkcs9, OBJ_pkcs9_challengePassword, OBJ_pkcs9_contentType, OBJ_pkcs9_countersignature, OBJ_pkcs9_emailAddress, OBJ_pkcs9_extCertAttributes, OBJ_pkcs9_messageDigest, OBJ_pkcs9_signingTime, OBJ_pkcs9_unstructuredAddress, OBJ_pkcs9_unstructuredName, OBJ_policy_constraints, OBJ_policy_mappings, OBJ_postOfficeBox, OBJ_postalAddress, OBJ_postalCode, OBJ_preferredDeliveryMethod, OBJ_presentationAddress, OBJ_private_key_usage_period, OBJ_protocolInformation, OBJ_proxyCertInfo, OBJ_pseudonym, OBJ_pss, OBJ_qcStatements, OBJ_qualityLabelledData, OBJ_rFC822localPart, OBJ_rc2_cbc, OBJ_rc4, OBJ_rc5_cbc, OBJ_registeredAddress, OBJ_rfc822Mailbox, OBJ_ripemd160, OBJ_ripemd160WithRSA, OBJ_role, OBJ_roleOccupant, OBJ_room, OBJ_roomNumber, OBJ_rpkiManifest, OBJ_rpkiNotify, OBJ_rsa, OBJ_rsaEncryption, OBJ_rsaOAEPEncryptionSET, OBJ_rsaSignature, OBJ_rsadsi, OBJ_rsaesOaep, OBJ_rsassaPss, OBJ_sOARecord, OBJ_safeContentsBag, OBJ_sbgp_autonomousSysNum, OBJ_sbgp_autonomousSysNumv2, OBJ_sbgp_ipAddrBlock, OBJ_sbgp_ipAddrBlockv2, OBJ_sbgp_routerIdentifier, OBJ_sdsiCertificate, OBJ_searchGuide, OBJ_secg_ellipticCurve, OBJ_secg_scheme, OBJ_secp112r1, OBJ_secp112r2, OBJ_secp128r1, OBJ_secp128r2, OBJ_secp160k1, OBJ_secp160r1, OBJ_secp160r2, OBJ_secp192k1, OBJ_secp224k1, OBJ_secp224r1, OBJ_secp256k1, OBJ_secp384r1, OBJ_secp521r1, OBJ_secretBag, OBJ_secretary, OBJ_sect113r1, OBJ_sect113r2, OBJ_sect131r1, OBJ_sect131r2, OBJ_sect163k1, OBJ_sect163r1, OBJ_sect163r2, OBJ_sect193r1, OBJ_sect193r2, OBJ_sect233k1, OBJ_sect233r1, OBJ_sect239k1, OBJ_sect283k1, OBJ_sect283r1, OBJ_sect409k1, OBJ_sect409r1, OBJ_sect571k1, OBJ_sect571r1, OBJ_seeAlso, OBJ_seed_cbc, OBJ_seed_cfb128, OBJ_seed_ecb, OBJ_seed_ofb128, OBJ_selected_attribute_types, OBJ_sendOwner, OBJ_sendProxiedOwner, OBJ_sendProxiedRouter, OBJ_sendRouter, OBJ_serialNumber, OBJ_server_auth, OBJ_setAttr_Cert, OBJ_setAttr_GenCryptgrm, OBJ_setAttr_IssCap, OBJ_setAttr_IssCap_CVM, OBJ_setAttr_IssCap_Sig, OBJ_setAttr_IssCap_T2, OBJ_setAttr_PGWYcap, OBJ_setAttr_SecDevSig, OBJ_setAttr_T2Enc, OBJ_setAttr_T2cleartxt, OBJ_setAttr_TokICCsig, OBJ_setAttr_TokenType, OBJ_setAttr_Token_B0Prime, OBJ_setAttr_Token_EMV, OBJ_setCext_IssuerCapabilities, OBJ_setCext_PGWYcapabilities, OBJ_setCext_TokenIdentifier, OBJ_setCext_TokenType, OBJ_setCext_Track2Data, OBJ_setCext_cCertRequired, OBJ_setCext_certType, OBJ_setCext_hashedRoot, OBJ_setCext_merchData, OBJ_setCext_setExt, OBJ_setCext_setQualf, OBJ_setCext_tunneling, OBJ_set_addPolicy, OBJ_set_attr, OBJ_set_brand, OBJ_set_brand_AmericanExpress, OBJ_set_brand_Diners, OBJ_set_brand_IATA_ATA, OBJ_set_brand_JCB, OBJ_set_brand_MasterCard, OBJ_set_brand_Novus, OBJ_set_brand_Visa, OBJ_set_certExt, OBJ_set_ctype, OBJ_set_msgExt, OBJ_set_policy, OBJ_set_policy_root, OBJ_set_rootKeyThumb, OBJ_setct_AcqCardCodeMsg, OBJ_setct_AcqCardCodeMsgTBE, OBJ_setct_AuthReqTBE, OBJ_setct_AuthReqTBS, OBJ_setct_AuthResBaggage, OBJ_setct_AuthResTBE, OBJ_setct_AuthResTBEX, OBJ_setct_AuthResTBS, OBJ_setct_AuthResTBSX, OBJ_setct_AuthRevReqBaggage, OBJ_setct_AuthRevReqTBE, OBJ_setct_AuthRevReqTBS, OBJ_setct_AuthRevResBaggage, OBJ_setct_AuthRevResData, OBJ_setct_AuthRevResTBE, OBJ_setct_AuthRevResTBEB, OBJ_setct_AuthRevResTBS, OBJ_setct_AuthTokenTBE, OBJ_setct_AuthTokenTBS, OBJ_setct_BCIDistributionTBS, OBJ_setct_BatchAdminReqData, OBJ_setct_BatchAdminReqTBE, OBJ_setct_BatchAdminResData, OBJ_setct_BatchAdminResTBE, OBJ_setct_CRLNotificationResTBS, OBJ_setct_CRLNotificationTBS, OBJ_setct_CapReqTBE, OBJ_setct_CapReqTBEX, OBJ_setct_CapReqTBS, OBJ_setct_CapReqTBSX, OBJ_setct_CapResData, OBJ_setct_CapResTBE, OBJ_setct_CapRevReqTBE, OBJ_setct_CapRevReqTBEX, OBJ_setct_CapRevReqTBS, OBJ_setct_CapRevReqTBSX, OBJ_setct_CapRevResData, OBJ_setct_CapRevResTBE, OBJ_setct_CapTokenData, OBJ_setct_CapTokenSeq, OBJ_setct_CapTokenTBE, OBJ_setct_CapTokenTBEX, OBJ_setct_CapTokenTBS, OBJ_setct_CardCInitResTBS, OBJ_setct_CertInqReqTBS, OBJ_setct_CertReqData, OBJ_setct_CertReqTBE, OBJ_setct_CertReqTBEX, OBJ_setct_CertReqTBS, OBJ_setct_CertResData, OBJ_setct_CertResTBE, OBJ_setct_CredReqTBE, OBJ_setct_CredReqTBEX, OBJ_setct_CredReqTBS, OBJ_setct_CredReqTBSX, OBJ_setct_CredResData, OBJ_setct_CredResTBE, OBJ_setct_CredRevReqTBE, OBJ_setct_CredRevReqTBEX, OBJ_setct_CredRevReqTBS, OBJ_setct_CredRevReqTBSX, OBJ_setct_CredRevResData, OBJ_setct_CredRevResTBE, OBJ_setct_ErrorTBS, OBJ_setct_HODInput, OBJ_setct_MeAqCInitResTBS, OBJ_setct_OIData, OBJ_setct_PANData, OBJ_setct_PANOnly, OBJ_setct_PANToken, OBJ_setct_PCertReqData, OBJ_setct_PCertResTBS, OBJ_setct_PI, OBJ_setct_PIData, OBJ_setct_PIDataUnsigned, OBJ_setct_PIDualSignedTBE, OBJ_setct_PIUnsignedTBE, OBJ_setct_PI_TBS, OBJ_setct_PInitResData, OBJ_setct_PResData, OBJ_setct_RegFormReqTBE, OBJ_setct_RegFormResTBS, OBJ_setext_cv, OBJ_setext_genCrypt, OBJ_setext_miAuth, OBJ_setext_pinAny, OBJ_setext_pinSecure, OBJ_setext_track2, OBJ_sha, OBJ_sha1, OBJ_sha1WithRSA, OBJ_sha1WithRSAEncryption, OBJ_sha224, OBJ_sha224WithRSAEncryption, OBJ_sha256, OBJ_sha256WithRSAEncryption, OBJ_sha384, OBJ_sha384WithRSAEncryption, OBJ_sha3_224, OBJ_sha3_256, OBJ_sha3_384, OBJ_sha3_512, OBJ_sha512, OBJ_sha512WithRSAEncryption, OBJ_sha512_224, OBJ_sha512_224WithRSAEncryption, OBJ_sha512_256, OBJ_sha512_256WithRSAEncryption, OBJ_shaWithRSAEncryption, OBJ_shake128, OBJ_shake256, OBJ_sigAlgs, OBJ_signedObject, OBJ_simpleSecurityObject, OBJ_sinfo_access, OBJ_singleLevelQuality, OBJ_sm2, OBJ_sm3, OBJ_sm3WithRSAEncryption, OBJ_sm4_cbc, OBJ_sm4_cfb1, OBJ_sm4_cfb128, OBJ_sm4_cfb8, OBJ_sm4_ctr, OBJ_sm4_ecb, OBJ_sm4_ofb128, OBJ_sm_scheme, OBJ_sshClient, OBJ_sshServer, OBJ_stateOrProvinceName, OBJ_streetAddress, OBJ_subjectSignTool, OBJ_subject_alt_name, OBJ_subject_directory_attributes, OBJ_subject_key_identifier, OBJ_subtreeMaximumQuality, OBJ_subtreeMinimumQuality, OBJ_supportedAlgorithms, OBJ_supportedApplicationContext, OBJ_surname, OBJ_sxnet, OBJ_target_information, OBJ_telephoneNumber, OBJ_teletexTerminalIdentifier, OBJ_telexNumber, OBJ_textEncodedORAddress, OBJ_textNotice, OBJ_time_stamp, OBJ_title, OBJ_tlsfeature, OBJ_ua_pki, OBJ_uacurve0, OBJ_uacurve1, OBJ_uacurve2, OBJ_uacurve3, OBJ_uacurve4, OBJ_uacurve5, OBJ_uacurve6, OBJ_uacurve7, OBJ_uacurve8, OBJ_uacurve9, OBJ_ucl, OBJ_undef, OBJ_uniqueIdentifier, OBJ_uniqueMember, OBJ_userCertificate, OBJ_userClass, OBJ_userId, OBJ_userPassword, OBJ_wap, OBJ_wap_wsg, OBJ_wap_wsg_idm_ecid, OBJ_wap_wsg_idm_ecid_wtls1, OBJ_wap_wsg_idm_ecid_wtls10, OBJ_wap_wsg_idm_ecid_wtls11, OBJ_wap_wsg_idm_ecid_wtls12, OBJ_wap_wsg_idm_ecid_wtls3, OBJ_wap_wsg_idm_ecid_wtls4, OBJ_wap_wsg_idm_ecid_wtls5, OBJ_wap_wsg_idm_ecid_wtls6, OBJ_wap_wsg_idm_ecid_wtls7, OBJ_wap_wsg_idm_ecid_wtls8, OBJ_wap_wsg_idm_ecid_wtls9, OBJ_whirlpool, OBJ_x121Address, OBJ_x500UniqueIdentifier, OBJ_x509Certificate, OBJ_x509Crl, OBJ_x509ExtAdmission, OBJ_x9_63_scheme, OBJ_zlib_compression, OPENSSL_EC_EXPLICIT_CURVE, OPENSSL_EC_NAMED_CURVE, OPENSSL_EXTERN, OPENSSL_HTTPS_PROXY, OPENSSL_HTTP_PROXY, OPENSSL_NO_PROXY, OSSL_ALG_PARAM_CIPHER, OSSL_ALG_PARAM_DIGEST, OSSL_ALG_PARAM_ENGINE, OSSL_ALG_PARAM_MAC, OSSL_ASYM_CIPHER_PARAM_DIGEST, OSSL_ASYM_CIPHER_PARAM_ENGINE, OSSL_ASYM_CIPHER_PARAM_OAEP_DIGEST, OSSL_ASYM_CIPHER_PARAM_OAEP_DIGEST_PROPS, OSSL_ASYM_CIPHER_PARAM_OAEP_LABEL, OSSL_ASYM_CIPHER_PARAM_PAD_MODE, OSSL_ASYM_CIPHER_PARAM_PROPERTIES, OSSL_ASYM_CIPHER_PARAM_TLS_CLIENT_VERSION, OSSL_ASYM_CIPHER_PARAM_TLS_NEGOTIATED_VERSION, OSSL_ASYNC_FD, OSSL_BAD_ASYNC_FD, OSSL_CAPABILITY_TLS_GROUP_ALG, OSSL_CAPABILITY_TLS_GROUP_ID, OSSL_CAPABILITY_TLS_GROUP_IS_KEM, OSSL_CAPABILITY_TLS_GROUP_MAX_DTLS, OSSL_CAPABILITY_TLS_GROUP_MAX_TLS, OSSL_CAPABILITY_TLS_GROUP_MIN_DTLS, OSSL_CAPABILITY_TLS_GROUP_MIN_TLS, OSSL_CAPABILITY_TLS_GROUP_NAME, OSSL_CAPABILITY_TLS_GROUP_NAME_INTERNAL, OSSL_CAPABILITY_TLS_GROUP_SECURITY_BITS, OSSL_CIPHER_CTS_MODE_CS1, OSSL_CIPHER_CTS_MODE_CS2, OSSL_CIPHER_CTS_MODE_CS3, OSSL_CIPHER_PARAM_AEAD, OSSL_CIPHER_PARAM_AEAD_IVLEN, OSSL_CIPHER_PARAM_AEAD_MAC_KEY, OSSL_CIPHER_PARAM_AEAD_TAG, OSSL_CIPHER_PARAM_AEAD_TAGLEN, OSSL_CIPHER_PARAM_AEAD_TLS1_AAD, OSSL_CIPHER_PARAM_AEAD_TLS1_AAD_PAD, OSSL_CIPHER_PARAM_AEAD_TLS1_GET_IV_GEN, OSSL_CIPHER_PARAM_AEAD_TLS1_IV_FIXED, OSSL_CIPHER_PARAM_AEAD_TLS1_SET_IV_INV, OSSL_CIPHER_PARAM_ALGORITHM_ID_PARAMS, OSSL_CIPHER_PARAM_BLOCK_SIZE, OSSL_CIPHER_PARAM_CTS, OSSL_CIPHER_PARAM_CTS_MODE, OSSL_CIPHER_PARAM_CUSTOM_IV, OSSL_CIPHER_PARAM_HAS_RAND_KEY, OSSL_CIPHER_PARAM_IV, OSSL_CIPHER_PARAM_IVLEN, OSSL_CIPHER_PARAM_KEYLEN, OSSL_CIPHER_PARAM_MODE, OSSL_CIPHER_PARAM_NUM, OSSL_CIPHER_PARAM_PADDING, OSSL_CIPHER_PARAM_RANDOM_KEY, OSSL_CIPHER_PARAM_RC2_KEYBITS, OSSL_CIPHER_PARAM_ROUNDS, OSSL_CIPHER_PARAM_SPEED, OSSL_CIPHER_PARAM_TLS1_MULTIBLOCK, OSSL_CIPHER_PARAM_TLS_MAC, OSSL_CIPHER_PARAM_TLS_MAC_SIZE, OSSL_CIPHER_PARAM_TLS_VERSION, OSSL_CIPHER_PARAM_UPDATED_IV, OSSL_CIPHER_PARAM_USE_BITS, OSSL_DECODER_PARAM_PROPERTIES, OSSL_DECODER_R_COULD_NOT_DECODE_OBJECT, OSSL_DECODER_R_DECODER_NOT_FOUND, OSSL_DECODER_R_MISSING_GET_PARAMS, OSSL_DIGEST_NAME_KECCAK_KMAC128, OSSL_DIGEST_NAME_KECCAK_KMAC256, OSSL_DIGEST_NAME_MD2, OSSL_DIGEST_NAME_MD4, OSSL_DIGEST_NAME_MD5, OSSL_DIGEST_NAME_MD5_SHA1, OSSL_DIGEST_NAME_MDC2, OSSL_DIGEST_NAME_RIPEMD160, OSSL_DIGEST_NAME_SHA1, OSSL_DIGEST_NAME_SHA2_224, OSSL_DIGEST_NAME_SHA2_256, OSSL_DIGEST_NAME_SHA2_384, OSSL_DIGEST_NAME_SHA2_512, OSSL_DIGEST_NAME_SHA3_224, OSSL_DIGEST_NAME_SHA3_256, OSSL_DIGEST_NAME_SHA3_384, OSSL_DIGEST_NAME_SHA3_512, OSSL_DIGEST_NAME_SM3, OSSL_DIGEST_PARAM_ALGID_ABSENT, OSSL_DIGEST_PARAM_BLOCK_SIZE, OSSL_DIGEST_PARAM_MICALG, OSSL_DIGEST_PARAM_PAD_TYPE, OSSL_DIGEST_PARAM_SIZE, OSSL_DIGEST_PARAM_SSL3_MS, OSSL_DIGEST_PARAM_XOF, OSSL_DIGEST_PARAM_XOFLEN, OSSL_DRBG_PARAM_CIPHER, OSSL_DRBG_PARAM_DIGEST, OSSL_DRBG_PARAM_ENTROPY_REQUIRED, OSSL_DRBG_PARAM_MAC, OSSL_DRBG_PARAM_MAX_ADINLEN, OSSL_DRBG_PARAM_MAX_ENTROPYLEN, OSSL_DRBG_PARAM_MAX_LENGTH, OSSL_DRBG_PARAM_MAX_NONCELEN, OSSL_DRBG_PARAM_MAX_PERSLEN, OSSL_DRBG_PARAM_MIN_ENTROPYLEN, OSSL_DRBG_PARAM_MIN_LENGTH, OSSL_DRBG_PARAM_MIN_NONCELEN, OSSL_DRBG_PARAM_PREDICTION_RESISTANCE, OSSL_DRBG_PARAM_PROPERTIES, OSSL_DRBG_PARAM_RANDOM_DATA, OSSL_DRBG_PARAM_RESEED_COUNTER, OSSL_DRBG_PARAM_RESEED_REQUESTS, OSSL_DRBG_PARAM_RESEED_TIME, OSSL_DRBG_PARAM_RESEED_TIME_INTERVAL, OSSL_DRBG_PARAM_SIZE, OSSL_DRBG_PARAM_USE_DF, OSSL_ENCODER_PARAM_CIPHER, OSSL_ENCODER_PARAM_ENCRYPT_LEVEL, OSSL_ENCODER_PARAM_PROPERTIES, OSSL_ENCODER_PARAM_SAVE_PARAMETERS, OSSL_ENCODER_R_ENCODER_NOT_FOUND, OSSL_ENCODER_R_INCORRECT_PROPERTY_QUERY, OSSL_ENCODER_R_MISSING_GET_PARAMS, OSSL_EXCHANGE_PARAM_EC_ECDH_COFACTOR_MODE, OSSL_EXCHANGE_PARAM_KDF_DIGEST, OSSL_EXCHANGE_PARAM_KDF_DIGEST_PROPS, OSSL_EXCHANGE_PARAM_KDF_OUTLEN, OSSL_EXCHANGE_PARAM_KDF_TYPE, OSSL_EXCHANGE_PARAM_KDF_UKM, OSSL_EXCHANGE_PARAM_PAD, OSSL_FUNC_ASYM_CIPHER_DECRYPT, OSSL_FUNC_ASYM_CIPHER_DECRYPT_INIT, OSSL_FUNC_ASYM_CIPHER_DUPCTX, OSSL_FUNC_ASYM_CIPHER_ENCRYPT, OSSL_FUNC_ASYM_CIPHER_ENCRYPT_INIT, OSSL_FUNC_ASYM_CIPHER_FREECTX, OSSL_FUNC_ASYM_CIPHER_GETTABLE_CTX_PARAMS, OSSL_FUNC_ASYM_CIPHER_GET_CTX_PARAMS, OSSL_FUNC_ASYM_CIPHER_NEWCTX, OSSL_FUNC_ASYM_CIPHER_SETTABLE_CTX_PARAMS, OSSL_FUNC_ASYM_CIPHER_SET_CTX_PARAMS, OSSL_FUNC_BIO_CTRL, OSSL_FUNC_BIO_FREE, OSSL_FUNC_BIO_GETS, OSSL_FUNC_BIO_NEW_FILE, OSSL_FUNC_BIO_NEW_MEMBUF, OSSL_FUNC_BIO_PUTS, OSSL_FUNC_BIO_READ_EX, OSSL_FUNC_BIO_UP_REF, OSSL_FUNC_BIO_VPRINTF, OSSL_FUNC_BIO_VSNPRINTF, OSSL_FUNC_BIO_WRITE_EX, OSSL_FUNC_CIPHER_CIPHER, OSSL_FUNC_CIPHER_DECRYPT_INIT, OSSL_FUNC_CIPHER_DUPCTX, OSSL_FUNC_CIPHER_ENCRYPT_INIT, OSSL_FUNC_CIPHER_FINAL, OSSL_FUNC_CIPHER_FREECTX, OSSL_FUNC_CIPHER_GETTABLE_CTX_PARAMS, OSSL_FUNC_CIPHER_GETTABLE_PARAMS, OSSL_FUNC_CIPHER_GET_CTX_PARAMS, OSSL_FUNC_CIPHER_GET_PARAMS, OSSL_FUNC_CIPHER_NEWCTX, OSSL_FUNC_CIPHER_SETTABLE_CTX_PARAMS, OSSL_FUNC_CIPHER_SET_CTX_PARAMS, OSSL_FUNC_CIPHER_UPDATE, OSSL_FUNC_CLEANUP_ENTROPY, OSSL_FUNC_CLEANUP_NONCE, OSSL_FUNC_CORE_CLEAR_LAST_ERROR_MARK, OSSL_FUNC_CORE_GETTABLE_PARAMS, OSSL_FUNC_CORE_GET_LIBCTX, OSSL_FUNC_CORE_GET_PARAMS, OSSL_FUNC_CORE_NEW_ERROR, OSSL_FUNC_CORE_OBJ_ADD_SIGID, OSSL_FUNC_CORE_OBJ_CREATE, OSSL_FUNC_CORE_POP_ERROR_TO_MARK, OSSL_FUNC_CORE_SET_ERROR_DEBUG, OSSL_FUNC_CORE_SET_ERROR_MARK, OSSL_FUNC_CORE_THREAD_START, OSSL_FUNC_CORE_VSET_ERROR, OSSL_FUNC_CRYPTO_CLEAR_FREE, OSSL_FUNC_CRYPTO_CLEAR_REALLOC, OSSL_FUNC_CRYPTO_FREE, OSSL_FUNC_CRYPTO_MALLOC, OSSL_FUNC_CRYPTO_REALLOC, OSSL_FUNC_CRYPTO_SECURE_ALLOCATED, OSSL_FUNC_CRYPTO_SECURE_CLEAR_FREE, OSSL_FUNC_CRYPTO_SECURE_FREE, OSSL_FUNC_CRYPTO_SECURE_MALLOC, OSSL_FUNC_CRYPTO_SECURE_ZALLOC, OSSL_FUNC_CRYPTO_ZALLOC, OSSL_FUNC_DECODER_DECODE, OSSL_FUNC_DECODER_DOES_SELECTION, OSSL_FUNC_DECODER_EXPORT_OBJECT, OSSL_FUNC_DECODER_FREECTX, OSSL_FUNC_DECODER_GETTABLE_PARAMS, OSSL_FUNC_DECODER_GET_PARAMS, OSSL_FUNC_DECODER_NEWCTX, OSSL_FUNC_DECODER_SETTABLE_CTX_PARAMS, OSSL_FUNC_DECODER_SET_CTX_PARAMS, OSSL_FUNC_DIGEST_DIGEST, OSSL_FUNC_DIGEST_DUPCTX, OSSL_FUNC_DIGEST_FINAL, OSSL_FUNC_DIGEST_FREECTX, OSSL_FUNC_DIGEST_GETTABLE_CTX_PARAMS, OSSL_FUNC_DIGEST_GETTABLE_PARAMS, OSSL_FUNC_DIGEST_GET_CTX_PARAMS, OSSL_FUNC_DIGEST_GET_PARAMS, OSSL_FUNC_DIGEST_INIT, OSSL_FUNC_DIGEST_NEWCTX, OSSL_FUNC_DIGEST_SETTABLE_CTX_PARAMS, OSSL_FUNC_DIGEST_SET_CTX_PARAMS, OSSL_FUNC_DIGEST_UPDATE, OSSL_FUNC_ENCODER_DOES_SELECTION, OSSL_FUNC_ENCODER_ENCODE, OSSL_FUNC_ENCODER_FREECTX, OSSL_FUNC_ENCODER_FREE_OBJECT, OSSL_FUNC_ENCODER_GETTABLE_PARAMS, OSSL_FUNC_ENCODER_GET_PARAMS, OSSL_FUNC_ENCODER_IMPORT_OBJECT, OSSL_FUNC_ENCODER_NEWCTX, OSSL_FUNC_ENCODER_SETTABLE_CTX_PARAMS, OSSL_FUNC_ENCODER_SET_CTX_PARAMS, OSSL_FUNC_GET_ENTROPY, OSSL_FUNC_GET_NONCE, OSSL_FUNC_KDF_DERIVE, OSSL_FUNC_KDF_DUPCTX, OSSL_FUNC_KDF_FREECTX, OSSL_FUNC_KDF_GETTABLE_CTX_PARAMS, OSSL_FUNC_KDF_GETTABLE_PARAMS, OSSL_FUNC_KDF_GET_CTX_PARAMS, OSSL_FUNC_KDF_GET_PARAMS, OSSL_FUNC_KDF_NEWCTX, OSSL_FUNC_KDF_RESET, OSSL_FUNC_KDF_SETTABLE_CTX_PARAMS, OSSL_FUNC_KDF_SET_CTX_PARAMS, OSSL_FUNC_KEM_DECAPSULATE, OSSL_FUNC_KEM_DECAPSULATE_INIT, OSSL_FUNC_KEM_DUPCTX, OSSL_FUNC_KEM_ENCAPSULATE, OSSL_FUNC_KEM_ENCAPSULATE_INIT, OSSL_FUNC_KEM_FREECTX, OSSL_FUNC_KEM_GETTABLE_CTX_PARAMS, OSSL_FUNC_KEM_GET_CTX_PARAMS, OSSL_FUNC_KEM_NEWCTX, OSSL_FUNC_KEM_SETTABLE_CTX_PARAMS, OSSL_FUNC_KEM_SET_CTX_PARAMS, OSSL_FUNC_KEYEXCH_DERIVE, OSSL_FUNC_KEYEXCH_DUPCTX, OSSL_FUNC_KEYEXCH_FREECTX, OSSL_FUNC_KEYEXCH_GETTABLE_CTX_PARAMS, OSSL_FUNC_KEYEXCH_GET_CTX_PARAMS, OSSL_FUNC_KEYEXCH_INIT, OSSL_FUNC_KEYEXCH_NEWCTX, OSSL_FUNC_KEYEXCH_SETTABLE_CTX_PARAMS, OSSL_FUNC_KEYEXCH_SET_CTX_PARAMS, OSSL_FUNC_KEYEXCH_SET_PEER, OSSL_FUNC_KEYMGMT_DUP, OSSL_FUNC_KEYMGMT_EXPORT, OSSL_FUNC_KEYMGMT_EXPORT_TYPES, OSSL_FUNC_KEYMGMT_FREE, OSSL_FUNC_KEYMGMT_GEN, OSSL_FUNC_KEYMGMT_GEN_CLEANUP, OSSL_FUNC_KEYMGMT_GEN_INIT, OSSL_FUNC_KEYMGMT_GEN_SETTABLE_PARAMS, OSSL_FUNC_KEYMGMT_GEN_SET_PARAMS, OSSL_FUNC_KEYMGMT_GEN_SET_TEMPLATE, OSSL_FUNC_KEYMGMT_GETTABLE_PARAMS, OSSL_FUNC_KEYMGMT_GET_PARAMS, OSSL_FUNC_KEYMGMT_HAS, OSSL_FUNC_KEYMGMT_IMPORT, OSSL_FUNC_KEYMGMT_IMPORT_TYPES, OSSL_FUNC_KEYMGMT_LOAD, OSSL_FUNC_KEYMGMT_MATCH, OSSL_FUNC_KEYMGMT_NEW, OSSL_FUNC_KEYMGMT_QUERY_OPERATION_NAME, OSSL_FUNC_KEYMGMT_SETTABLE_PARAMS, OSSL_FUNC_KEYMGMT_SET_PARAMS, OSSL_FUNC_KEYMGMT_VALIDATE, OSSL_FUNC_MAC_DUPCTX, OSSL_FUNC_MAC_FINAL, OSSL_FUNC_MAC_FREECTX, OSSL_FUNC_MAC_GETTABLE_CTX_PARAMS, OSSL_FUNC_MAC_GETTABLE_PARAMS, OSSL_FUNC_MAC_GET_CTX_PARAMS, OSSL_FUNC_MAC_GET_PARAMS, OSSL_FUNC_MAC_INIT, OSSL_FUNC_MAC_NEWCTX, OSSL_FUNC_MAC_SETTABLE_CTX_PARAMS, OSSL_FUNC_MAC_SET_CTX_PARAMS, OSSL_FUNC_MAC_UPDATE, OSSL_FUNC_OPENSSL_CLEANSE, OSSL_FUNC_PROVIDER_DEREGISTER_CHILD_CB, OSSL_FUNC_PROVIDER_FREE, OSSL_FUNC_PROVIDER_GET0_DISPATCH, OSSL_FUNC_PROVIDER_GET0_PROVIDER_CTX, OSSL_FUNC_PROVIDER_GETTABLE_PARAMS, OSSL_FUNC_PROVIDER_GET_CAPABILITIES, OSSL_FUNC_PROVIDER_GET_PARAMS, OSSL_FUNC_PROVIDER_GET_REASON_STRINGS, OSSL_FUNC_PROVIDER_NAME, OSSL_FUNC_PROVIDER_QUERY_OPERATION, OSSL_FUNC_PROVIDER_REGISTER_CHILD_CB, OSSL_FUNC_PROVIDER_SELF_TEST, OSSL_FUNC_PROVIDER_TEARDOWN, OSSL_FUNC_PROVIDER_UNQUERY_OPERATION, OSSL_FUNC_PROVIDER_UP_REF, OSSL_FUNC_RAND_CLEAR_SEED, OSSL_FUNC_RAND_ENABLE_LOCKING, OSSL_FUNC_RAND_FREECTX, OSSL_FUNC_RAND_GENERATE, OSSL_FUNC_RAND_GETTABLE_CTX_PARAMS, OSSL_FUNC_RAND_GETTABLE_PARAMS, OSSL_FUNC_RAND_GET_CTX_PARAMS, OSSL_FUNC_RAND_GET_PARAMS, OSSL_FUNC_RAND_GET_SEED, OSSL_FUNC_RAND_INSTANTIATE, OSSL_FUNC_RAND_LOCK, OSSL_FUNC_RAND_NEWCTX, OSSL_FUNC_RAND_NONCE, OSSL_FUNC_RAND_RESEED, OSSL_FUNC_RAND_SETTABLE_CTX_PARAMS, OSSL_FUNC_RAND_SET_CTX_PARAMS, OSSL_FUNC_RAND_UNINSTANTIATE, OSSL_FUNC_RAND_UNLOCK, OSSL_FUNC_RAND_VERIFY_ZEROIZATION, OSSL_FUNC_SELF_TEST_CB, OSSL_FUNC_SIGNATURE_DIGEST_SIGN, OSSL_FUNC_SIGNATURE_DIGEST_SIGN_FINAL, OSSL_FUNC_SIGNATURE_DIGEST_SIGN_INIT, OSSL_FUNC_SIGNATURE_DIGEST_SIGN_UPDATE, OSSL_FUNC_SIGNATURE_DIGEST_VERIFY, OSSL_FUNC_SIGNATURE_DIGEST_VERIFY_FINAL, OSSL_FUNC_SIGNATURE_DIGEST_VERIFY_INIT, OSSL_FUNC_SIGNATURE_DIGEST_VERIFY_UPDATE, OSSL_FUNC_SIGNATURE_DUPCTX, OSSL_FUNC_SIGNATURE_FREECTX, OSSL_FUNC_SIGNATURE_GETTABLE_CTX_MD_PARAMS, OSSL_FUNC_SIGNATURE_GETTABLE_CTX_PARAMS, OSSL_FUNC_SIGNATURE_GET_CTX_MD_PARAMS, OSSL_FUNC_SIGNATURE_GET_CTX_PARAMS, OSSL_FUNC_SIGNATURE_NEWCTX, OSSL_FUNC_SIGNATURE_SETTABLE_CTX_MD_PARAMS, OSSL_FUNC_SIGNATURE_SETTABLE_CTX_PARAMS, OSSL_FUNC_SIGNATURE_SET_CTX_MD_PARAMS, OSSL_FUNC_SIGNATURE_SET_CTX_PARAMS, OSSL_FUNC_SIGNATURE_SIGN, OSSL_FUNC_SIGNATURE_SIGN_INIT, OSSL_FUNC_SIGNATURE_VERIFY, OSSL_FUNC_SIGNATURE_VERIFY_INIT, OSSL_FUNC_SIGNATURE_VERIFY_RECOVER, OSSL_FUNC_SIGNATURE_VERIFY_RECOVER_INIT, OSSL_FUNC_STORE_ATTACH, OSSL_FUNC_STORE_CLOSE, OSSL_FUNC_STORE_EOF, OSSL_FUNC_STORE_EXPORT_OBJECT, OSSL_FUNC_STORE_LOAD, OSSL_FUNC_STORE_OPEN, OSSL_FUNC_STORE_SETTABLE_CTX_PARAMS, OSSL_FUNC_STORE_SET_CTX_PARAMS, OSSL_GEN_PARAM_ITERATION, OSSL_GEN_PARAM_POTENTIAL, OSSL_HTTPS_NAME, OSSL_HTTPS_PORT, OSSL_HTTP_NAME, OSSL_HTTP_PORT, OSSL_KDF_NAME_HKDF, OSSL_KDF_NAME_KBKDF, OSSL_KDF_NAME_KRB5KDF, OSSL_KDF_NAME_PBKDF1, OSSL_KDF_NAME_PBKDF2, OSSL_KDF_NAME_SCRYPT, OSSL_KDF_NAME_SSHKDF, OSSL_KDF_NAME_SSKDF, OSSL_KDF_NAME_TLS1_3_KDF, OSSL_KDF_NAME_TLS1_PRF, OSSL_KDF_NAME_X942KDF_ASN1, OSSL_KDF_NAME_X942KDF_CONCAT, OSSL_KDF_NAME_X963KDF, OSSL_KDF_PARAM_CEK_ALG, OSSL_KDF_PARAM_CIPHER, OSSL_KDF_PARAM_CONSTANT, OSSL_KDF_PARAM_DATA, OSSL_KDF_PARAM_DIGEST, OSSL_KDF_PARAM_INFO, OSSL_KDF_PARAM_ITER, OSSL_KDF_PARAM_KBKDF_USE_L, OSSL_KDF_PARAM_KBKDF_USE_SEPARATOR, OSSL_KDF_PARAM_KEY, OSSL_KDF_PARAM_LABEL, OSSL_KDF_PARAM_MAC, OSSL_KDF_PARAM_MAC_SIZE, OSSL_KDF_PARAM_MODE, OSSL_KDF_PARAM_PASSWORD, OSSL_KDF_PARAM_PKCS12_ID, OSSL_KDF_PARAM_PKCS5, OSSL_KDF_PARAM_PREFIX, OSSL_KDF_PARAM_PROPERTIES, OSSL_KDF_PARAM_SALT, OSSL_KDF_PARAM_SCRYPT_MAXMEM, OSSL_KDF_PARAM_SCRYPT_N, OSSL_KDF_PARAM_SCRYPT_P, OSSL_KDF_PARAM_SCRYPT_R, OSSL_KDF_PARAM_SECRET, OSSL_KDF_PARAM_SEED, OSSL_KDF_PARAM_SIZE, OSSL_KDF_PARAM_SSHKDF_SESSION_ID, OSSL_KDF_PARAM_SSHKDF_TYPE, OSSL_KDF_PARAM_SSHKDF_XCGHASH, OSSL_KDF_PARAM_UKM, OSSL_KDF_PARAM_X942_ACVPINFO, OSSL_KDF_PARAM_X942_PARTYUINFO, OSSL_KDF_PARAM_X942_PARTYVINFO, OSSL_KDF_PARAM_X942_SUPP_PRIVINFO, OSSL_KDF_PARAM_X942_SUPP_PUBINFO, OSSL_KDF_PARAM_X942_USE_KEYBITS, OSSL_KEM_PARAM_OPERATION, OSSL_KEM_PARAM_OPERATION_RSASVE, OSSL_KEYMGMT_SELECT_DOMAIN_PARAMETERS, OSSL_KEYMGMT_SELECT_OTHER_PARAMETERS, OSSL_KEYMGMT_SELECT_PRIVATE_KEY, OSSL_KEYMGMT_SELECT_PUBLIC_KEY, OSSL_KEYMGMT_VALIDATE_FULL_CHECK, OSSL_KEYMGMT_VALIDATE_QUICK_CHECK, OSSL_MAC_NAME_BLAKE2BMAC, OSSL_MAC_NAME_BLAKE2SMAC, OSSL_MAC_NAME_CMAC, OSSL_MAC_NAME_GMAC, OSSL_MAC_NAME_HMAC, OSSL_MAC_NAME_KMAC128, OSSL_MAC_NAME_KMAC256, OSSL_MAC_NAME_POLY1305, OSSL_MAC_NAME_SIPHASH, OSSL_MAC_PARAM_BLOCK_SIZE, OSSL_MAC_PARAM_CIPHER, OSSL_MAC_PARAM_CUSTOM, OSSL_MAC_PARAM_C_ROUNDS, OSSL_MAC_PARAM_DIGEST, OSSL_MAC_PARAM_DIGEST_NOINIT, OSSL_MAC_PARAM_DIGEST_ONESHOT, OSSL_MAC_PARAM_D_ROUNDS, OSSL_MAC_PARAM_IV, OSSL_MAC_PARAM_KEY, OSSL_MAC_PARAM_PROPERTIES, OSSL_MAC_PARAM_SALT, OSSL_MAC_PARAM_SIZE, OSSL_MAC_PARAM_TLS_DATA_SIZE, OSSL_MAC_PARAM_XOF, OSSL_OBJECT_CERT, OSSL_OBJECT_CRL, OSSL_OBJECT_NAME, OSSL_OBJECT_PARAM_DATA, OSSL_OBJECT_PARAM_DATA_STRUCTURE, OSSL_OBJECT_PARAM_DATA_TYPE, OSSL_OBJECT_PARAM_DESC, OSSL_OBJECT_PARAM_REFERENCE, OSSL_OBJECT_PARAM_TYPE, OSSL_OBJECT_PKEY, OSSL_OBJECT_UNKNOWN, OSSL_OP_ASYM_CIPHER, OSSL_OP_CIPHER, OSSL_OP_DECODER, OSSL_OP_DIGEST, OSSL_OP_ENCODER, OSSL_OP_KDF, OSSL_OP_KEM, OSSL_OP_KEYEXCH, OSSL_OP_KEYMGMT, OSSL_OP_MAC, OSSL_OP_RAND, OSSL_OP_SIGNATURE, OSSL_OP_STORE, OSSL_OP__HIGHEST, OSSL_PARAM_INTEGER, OSSL_PARAM_OCTET_PTR, OSSL_PARAM_OCTET_STRING, OSSL_PARAM_REAL, OSSL_PARAM_UNSIGNED_INTEGER, OSSL_PARAM_UTF8_PTR, OSSL_PARAM_UTF8_STRING, OSSL_PASSPHRASE_PARAM_INFO, OSSL_PKEY_EC_ENCODING_EXPLICIT, OSSL_PKEY_EC_ENCODING_GROUP, OSSL_PKEY_EC_GROUP_CHECK_DEFAULT, OSSL_PKEY_EC_GROUP_CHECK_NAMED, OSSL_PKEY_EC_GROUP_CHECK_NAMED_NIST, OSSL_PKEY_EC_POINT_CONVERSION_FORMAT_COMPRESSED, OSSL_PKEY_EC_POINT_CONVERSION_FORMAT_HYBRID, OSSL_PKEY_EC_POINT_CONVERSION_FORMAT_UNCOMPRESSED, OSSL_PKEY_PARAM_BITS, OSSL_PKEY_PARAM_CIPHER, OSSL_PKEY_PARAM_DEFAULT_DIGEST, OSSL_PKEY_PARAM_DH_GENERATOR, OSSL_PKEY_PARAM_DH_PRIV_LEN, OSSL_PKEY_PARAM_DIGEST, OSSL_PKEY_PARAM_DIGEST_SIZE, OSSL_PKEY_PARAM_DIST_ID, OSSL_PKEY_PARAM_EC_A, OSSL_PKEY_PARAM_EC_B, OSSL_PKEY_PARAM_EC_CHAR2_M, OSSL_PKEY_PARAM_EC_CHAR2_PP_K1, OSSL_PKEY_PARAM_EC_CHAR2_PP_K2, OSSL_PKEY_PARAM_EC_CHAR2_PP_K3, OSSL_PKEY_PARAM_EC_CHAR2_TP_BASIS, OSSL_PKEY_PARAM_EC_CHAR2_TYPE, OSSL_PKEY_PARAM_EC_COFACTOR, OSSL_PKEY_PARAM_EC_DECODED_FROM_EXPLICIT_PARAMS, OSSL_PKEY_PARAM_EC_ENCODING, OSSL_PKEY_PARAM_EC_FIELD_TYPE, OSSL_PKEY_PARAM_EC_GENERATOR, OSSL_PKEY_PARAM_EC_GROUP_CHECK_TYPE, OSSL_PKEY_PARAM_EC_INCLUDE_PUBLIC, OSSL_PKEY_PARAM_EC_ORDER, OSSL_PKEY_PARAM_EC_P, OSSL_PKEY_PARAM_EC_POINT_CONVERSION_FORMAT, OSSL_PKEY_PARAM_EC_PUB_X, OSSL_PKEY_PARAM_EC_PUB_Y, OSSL_PKEY_PARAM_EC_SEED, OSSL_PKEY_PARAM_ENCODED_PUBLIC_KEY, OSSL_PKEY_PARAM_ENGINE, OSSL_PKEY_PARAM_FFC_COFACTOR, OSSL_PKEY_PARAM_FFC_DIGEST, OSSL_PKEY_PARAM_FFC_DIGEST_PROPS, OSSL_PKEY_PARAM_FFC_G, OSSL_PKEY_PARAM_FFC_GINDEX, OSSL_PKEY_PARAM_FFC_H, OSSL_PKEY_PARAM_FFC_P, OSSL_PKEY_PARAM_FFC_PBITS, OSSL_PKEY_PARAM_FFC_PCOUNTER, OSSL_PKEY_PARAM_FFC_Q, OSSL_PKEY_PARAM_FFC_QBITS, OSSL_PKEY_PARAM_FFC_SEED, OSSL_PKEY_PARAM_FFC_TYPE, OSSL_PKEY_PARAM_FFC_VALIDATE_G, OSSL_PKEY_PARAM_FFC_VALIDATE_LEGACY, OSSL_PKEY_PARAM_FFC_VALIDATE_PQ, OSSL_PKEY_PARAM_GROUP_NAME, OSSL_PKEY_PARAM_MANDATORY_DIGEST, OSSL_PKEY_PARAM_MASKGENFUNC, OSSL_PKEY_PARAM_MAX_SIZE, OSSL_PKEY_PARAM_MGF1_DIGEST, OSSL_PKEY_PARAM_MGF1_PROPERTIES, OSSL_PKEY_PARAM_PAD_MODE, OSSL_PKEY_PARAM_PRIV_KEY, OSSL_PKEY_PARAM_PROPERTIES, OSSL_PKEY_PARAM_PUB_KEY, OSSL_PKEY_PARAM_RSA_BITS, OSSL_PKEY_PARAM_RSA_COEFFICIENT, OSSL_PKEY_PARAM_RSA_COEFFICIENT1, OSSL_PKEY_PARAM_RSA_COEFFICIENT2, OSSL_PKEY_PARAM_RSA_COEFFICIENT3, OSSL_PKEY_PARAM_RSA_COEFFICIENT4, OSSL_PKEY_PARAM_RSA_COEFFICIENT5, OSSL_PKEY_PARAM_RSA_COEFFICIENT6, OSSL_PKEY_PARAM_RSA_COEFFICIENT7, OSSL_PKEY_PARAM_RSA_COEFFICIENT8, OSSL_PKEY_PARAM_RSA_COEFFICIENT9, OSSL_PKEY_PARAM_RSA_D, OSSL_PKEY_PARAM_RSA_DIGEST, OSSL_PKEY_PARAM_RSA_DIGEST_PROPS, OSSL_PKEY_PARAM_RSA_E, OSSL_PKEY_PARAM_RSA_EXPONENT, OSSL_PKEY_PARAM_RSA_EXPONENT1, OSSL_PKEY_PARAM_RSA_EXPONENT10, OSSL_PKEY_PARAM_RSA_EXPONENT2, OSSL_PKEY_PARAM_RSA_EXPONENT3, OSSL_PKEY_PARAM_RSA_EXPONENT4, OSSL_PKEY_PARAM_RSA_EXPONENT5, OSSL_PKEY_PARAM_RSA_EXPONENT6, OSSL_PKEY_PARAM_RSA_EXPONENT7, OSSL_PKEY_PARAM_RSA_EXPONENT8, OSSL_PKEY_PARAM_RSA_EXPONENT9, OSSL_PKEY_PARAM_RSA_FACTOR, OSSL_PKEY_PARAM_RSA_FACTOR1, OSSL_PKEY_PARAM_RSA_FACTOR10, OSSL_PKEY_PARAM_RSA_FACTOR2, OSSL_PKEY_PARAM_RSA_FACTOR3, OSSL_PKEY_PARAM_RSA_FACTOR4, OSSL_PKEY_PARAM_RSA_FACTOR5, OSSL_PKEY_PARAM_RSA_FACTOR6, OSSL_PKEY_PARAM_RSA_FACTOR7, OSSL_PKEY_PARAM_RSA_FACTOR8, OSSL_PKEY_PARAM_RSA_FACTOR9, OSSL_PKEY_PARAM_RSA_MASKGENFUNC, OSSL_PKEY_PARAM_RSA_MGF1_DIGEST, OSSL_PKEY_PARAM_RSA_N, OSSL_PKEY_PARAM_RSA_PRIMES, OSSL_PKEY_PARAM_RSA_PSS_SALTLEN, OSSL_PKEY_PARAM_RSA_TEST_P1, OSSL_PKEY_PARAM_RSA_TEST_P2, OSSL_PKEY_PARAM_RSA_TEST_Q1, OSSL_PKEY_PARAM_RSA_TEST_Q2, OSSL_PKEY_PARAM_RSA_TEST_XP, OSSL_PKEY_PARAM_RSA_TEST_XP1, OSSL_PKEY_PARAM_RSA_TEST_XP2, OSSL_PKEY_PARAM_RSA_TEST_XQ, OSSL_PKEY_PARAM_RSA_TEST_XQ1, OSSL_PKEY_PARAM_RSA_TEST_XQ2, OSSL_PKEY_PARAM_SECURITY_BITS, OSSL_PKEY_PARAM_USE_COFACTOR_FLAG, OSSL_PKEY_RSA_PAD_MODE_NONE, OSSL_PKEY_RSA_PAD_MODE_OAEP, OSSL_PKEY_RSA_PAD_MODE_PKCSV15, OSSL_PKEY_RSA_PAD_MODE_PSS, OSSL_PKEY_RSA_PAD_MODE_X931, OSSL_PKEY_RSA_PSS_SALT_LEN_AUTO, OSSL_PKEY_RSA_PSS_SALT_LEN_DIGEST, OSSL_PKEY_RSA_PSS_SALT_LEN_MAX, OSSL_PROV_FIPS_PARAM_CONDITIONAL_ERRORS, OSSL_PROV_FIPS_PARAM_INSTALL_MAC, OSSL_PROV_FIPS_PARAM_INSTALL_STATUS, OSSL_PROV_FIPS_PARAM_INSTALL_VERSION, OSSL_PROV_FIPS_PARAM_MODULE_MAC, OSSL_PROV_FIPS_PARAM_SECURITY_CHECKS, OSSL_PROV_PARAM_BUILDINFO, OSSL_PROV_PARAM_CORE_MODULE_FILENAME, OSSL_PROV_PARAM_CORE_PROV_NAME, OSSL_PROV_PARAM_CORE_VERSION, OSSL_PROV_PARAM_NAME, OSSL_PROV_PARAM_SECURITY_CHECKS, OSSL_PROV_PARAM_SELF_TEST_DESC, OSSL_PROV_PARAM_SELF_TEST_PHASE, OSSL_PROV_PARAM_SELF_TEST_TYPE, OSSL_PROV_PARAM_STATUS, OSSL_PROV_PARAM_VERSION, OSSL_RAND_PARAM_MAX_REQUEST, OSSL_RAND_PARAM_STATE, OSSL_RAND_PARAM_STRENGTH, OSSL_RAND_PARAM_TEST_ENTROPY, OSSL_RAND_PARAM_TEST_NONCE, OSSL_SELF_TEST_DESC_ASYM_RSA_DEC, OSSL_SELF_TEST_DESC_ASYM_RSA_ENC, OSSL_SELF_TEST_DESC_CIPHER_AES_ECB, OSSL_SELF_TEST_DESC_CIPHER_AES_GCM, OSSL_SELF_TEST_DESC_CIPHER_TDES, OSSL_SELF_TEST_DESC_DRBG_CTR, OSSL_SELF_TEST_DESC_DRBG_HASH, OSSL_SELF_TEST_DESC_DRBG_HMAC, OSSL_SELF_TEST_DESC_INTEGRITY_HMAC, OSSL_SELF_TEST_DESC_KA_DH, OSSL_SELF_TEST_DESC_KA_ECDH, OSSL_SELF_TEST_DESC_KDF_HKDF, OSSL_SELF_TEST_DESC_KDF_KBKDF, OSSL_SELF_TEST_DESC_KDF_PBKDF2, OSSL_SELF_TEST_DESC_KDF_SSHKDF, OSSL_SELF_TEST_DESC_KDF_SSKDF, OSSL_SELF_TEST_DESC_KDF_TLS12_PRF, OSSL_SELF_TEST_DESC_KDF_TLS13_EXPAND, OSSL_SELF_TEST_DESC_KDF_TLS13_EXTRACT, OSSL_SELF_TEST_DESC_KDF_X942KDF, OSSL_SELF_TEST_DESC_KDF_X963KDF, OSSL_SELF_TEST_DESC_MD_SHA1, OSSL_SELF_TEST_DESC_MD_SHA2, OSSL_SELF_TEST_DESC_MD_SHA3, OSSL_SELF_TEST_DESC_NONE, OSSL_SELF_TEST_DESC_PCT_DSA, OSSL_SELF_TEST_DESC_PCT_ECDSA, OSSL_SELF_TEST_DESC_PCT_RSA_PKCS1, OSSL_SELF_TEST_DESC_RNG, OSSL_SELF_TEST_DESC_SIGN_DSA, OSSL_SELF_TEST_DESC_SIGN_ECDSA, OSSL_SELF_TEST_DESC_SIGN_RSA, OSSL_SELF_TEST_PHASE_CORRUPT, OSSL_SELF_TEST_PHASE_FAIL, OSSL_SELF_TEST_PHASE_NONE, OSSL_SELF_TEST_PHASE_PASS, OSSL_SELF_TEST_PHASE_START, OSSL_SELF_TEST_TYPE_CRNG, OSSL_SELF_TEST_TYPE_DRBG, OSSL_SELF_TEST_TYPE_INSTALL_INTEGRITY, OSSL_SELF_TEST_TYPE_KAT_ASYM_CIPHER, OSSL_SELF_TEST_TYPE_KAT_CIPHER, OSSL_SELF_TEST_TYPE_KAT_DIGEST, OSSL_SELF_TEST_TYPE_KAT_KA, OSSL_SELF_TEST_TYPE_KAT_KDF, OSSL_SELF_TEST_TYPE_KAT_SIGNATURE, OSSL_SELF_TEST_TYPE_MODULE_INTEGRITY, OSSL_SELF_TEST_TYPE_NONE, OSSL_SELF_TEST_TYPE_PCT, OSSL_SELF_TEST_TYPE_PCT_SIGNATURE, OSSL_SIGNATURE_PARAM_ALGORITHM_ID, OSSL_SIGNATURE_PARAM_DIGEST, OSSL_SIGNATURE_PARAM_DIGEST_SIZE, OSSL_SIGNATURE_PARAM_KAT, OSSL_SIGNATURE_PARAM_MGF1_DIGEST, OSSL_SIGNATURE_PARAM_PAD_MODE, OSSL_SIGNATURE_PARAM_PROPERTIES, OSSL_SIGNATURE_PARAM_PSS_SALTLEN, OSSL_STORE_C_CUSTOM_START, OSSL_STORE_C_USE_SECMEM, OSSL_STORE_INFO_CERT, OSSL_STORE_INFO_CRL, OSSL_STORE_INFO_NAME, OSSL_STORE_INFO_PARAMS, OSSL_STORE_INFO_PKEY, OSSL_STORE_INFO_PUBKEY, OSSL_STORE_PARAM_ALIAS, OSSL_STORE_PARAM_DIGEST, OSSL_STORE_PARAM_EXPECT, OSSL_STORE_PARAM_FINGERPRINT, OSSL_STORE_PARAM_INPUT_TYPE, OSSL_STORE_PARAM_ISSUER, OSSL_STORE_PARAM_PROPERTIES, OSSL_STORE_PARAM_SERIAL, OSSL_STORE_PARAM_SUBJECT, OSSL_STORE_R_AMBIGUOUS_CONTENT_TYPE, OSSL_STORE_R_BAD_PASSWORD_READ, OSSL_STORE_R_ERROR_VERIFYING_PKCS12_MAC, OSSL_STORE_R_FINGERPRINT_SIZE_DOES_NOT_MATCH_DIGEST, OSSL_STORE_R_INVALID_SCHEME, OSSL_STORE_R_IS_NOT_A, OSSL_STORE_R_LOADER_INCOMPLETE, OSSL_STORE_R_LOADING_STARTED, OSSL_STORE_R_NOT_A_CERTIFICATE, OSSL_STORE_R_NOT_A_CRL, OSSL_STORE_R_NOT_A_NAME, OSSL_STORE_R_NOT_A_PRIVATE_KEY, OSSL_STORE_R_NOT_A_PUBLIC_KEY, OSSL_STORE_R_NOT_PARAMETERS, OSSL_STORE_R_NO_LOADERS_FOUND, OSSL_STORE_R_PASSPHRASE_CALLBACK_ERROR, OSSL_STORE_R_PATH_MUST_BE_ABSOLUTE, OSSL_STORE_R_SEARCH_ONLY_SUPPORTED_FOR_DIRECTORIES, OSSL_STORE_R_UI_PROCESS_INTERRUPTED_OR_CANCELLED, OSSL_STORE_R_UNREGISTERED_SCHEME, OSSL_STORE_R_UNSUPPORTED_CONTENT_TYPE, OSSL_STORE_R_UNSUPPORTED_OPERATION, OSSL_STORE_R_UNSUPPORTED_SEARCH_TYPE, OSSL_STORE_R_URI_AUTHORITY_UNSUPPORTED, OSSL_STORE_SEARCH_BY_ALIAS, OSSL_STORE_SEARCH_BY_ISSUER_SERIAL, OSSL_STORE_SEARCH_BY_KEY_FINGERPRINT, OSSL_STORE_SEARCH_BY_NAME, OSSL_TRACE_CATEGORY_ALL, OSSL_TRACE_CATEGORY_BN_CTX, OSSL_TRACE_CATEGORY_CMP, OSSL_TRACE_CATEGORY_CONF, OSSL_TRACE_CATEGORY_DECODER, OSSL_TRACE_CATEGORY_ENCODER, OSSL_TRACE_CATEGORY_INIT, OSSL_TRACE_CATEGORY_NUM, OSSL_TRACE_CATEGORY_PKCS12_DECRYPT, OSSL_TRACE_CATEGORY_PKCS12_KEYGEN, OSSL_TRACE_CATEGORY_PKCS5V2, OSSL_TRACE_CATEGORY_REF_COUNT, OSSL_TRACE_CATEGORY_STORE, OSSL_TRACE_CATEGORY_TLS, OSSL_TRACE_CATEGORY_TLS_CIPHER, OSSL_TRACE_CATEGORY_TRACE, OSSL_TRACE_CATEGORY_X509V3_POLICY, OSSL_TRACE_CTRL_BEGIN, OSSL_TRACE_CTRL_END, OSSL_TRACE_CTRL_WRITE, PEM_BUFSIZE, PEM_R_BAD_BASE64_DECODE, PEM_R_BAD_DECRYPT, PEM_R_BAD_END_LINE, PEM_R_BAD_IV_CHARS, PEM_R_BAD_MAGIC_NUMBER, PEM_R_BAD_PASSWORD_READ, PEM_R_BAD_VERSION_NUMBER, PEM_R_BIO_WRITE_FAILURE, PEM_R_CIPHER_IS_NULL, PEM_R_ERROR_CONVERTING_PRIVATE_KEY, PEM_R_EXPECTING_DSS_KEY_BLOB, PEM_R_EXPECTING_PRIVATE_KEY_BLOB, PEM_R_EXPECTING_PUBLIC_KEY_BLOB, PEM_R_EXPECTING_RSA_KEY_BLOB, PEM_R_HEADER_TOO_LONG, PEM_R_INCONSISTENT_HEADER, PEM_R_KEYBLOB_HEADER_PARSE_ERROR, PEM_R_KEYBLOB_TOO_SHORT, PEM_R_MISSING_DEK_IV, PEM_R_NOT_DEK_INFO, PEM_R_NOT_ENCRYPTED, PEM_R_NOT_PROC_TYPE, PEM_R_NO_START_LINE, PEM_R_PROBLEMS_GETTING_PASSWORD, PEM_R_PVK_DATA_TOO_SHORT, PEM_R_PVK_TOO_SHORT, PEM_R_READ_KEY, PEM_R_SHORT_HEADER, PEM_R_UNEXPECTED_DEK_IV, PEM_R_UNSUPPORTED_CIPHER, PEM_R_UNSUPPORTED_ENCRYPTION, PEM_R_UNSUPPORTED_KEY_COMPONENTS, PEM_R_UNSUPPORTED_PUBLIC_KEY_TYPE, PEM_STRING_CMS, PEM_STRING_DHPARAMS, PEM_STRING_DHXPARAMS, PEM_STRING_DSA, PEM_STRING_DSAPARAMS, PEM_STRING_DSA_PUBLIC, PEM_STRING_ECDSA_PUBLIC, PEM_STRING_ECPARAMETERS, PEM_STRING_ECPRIVATEKEY, PEM_STRING_EVP_PKEY, PEM_STRING_PARAMETERS, PEM_STRING_PKCS7, PEM_STRING_PKCS7_SIGNED, PEM_STRING_PKCS8, PEM_STRING_PKCS8INF, PEM_STRING_PUBLIC, PEM_STRING_RSA, PEM_STRING_RSA_PUBLIC, PEM_STRING_SSL_SESSION, PEM_STRING_X509, PEM_STRING_X509_CRL, PEM_STRING_X509_OLD, PEM_STRING_X509_REQ, PEM_STRING_X509_REQ_OLD, PEM_STRING_X509_TRUSTED, PEM_TYPE_CLEAR, PEM_TYPE_ENCRYPTED, PEM_TYPE_MIC_CLEAR, PEM_TYPE_MIC_ONLY, PKCS12_R_CANT_PACK_STRUCTURE, PKCS12_R_CONTENT_TYPE_NOT_DATA, PKCS12_R_DECODE_ERROR, PKCS12_R_ENCODE_ERROR, PKCS12_R_ENCRYPT_ERROR, PKCS12_R_ERROR_SETTING_ENCRYPTED_DATA_TYPE, PKCS12_R_INVALID_NULL_ARGUMENT, PKCS12_R_INVALID_NULL_PKCS12_POINTER, PKCS12_R_INVALID_TYPE, PKCS12_R_IV_GEN_ERROR, PKCS12_R_KEY_GEN_ERROR, PKCS12_R_MAC_ABSENT, PKCS12_R_MAC_GENERATION_ERROR, PKCS12_R_MAC_SETUP_ERROR, PKCS12_R_MAC_STRING_SET_ERROR, PKCS12_R_MAC_VERIFY_FAILURE, PKCS12_R_PARSE_ERROR, PKCS12_R_PKCS12_CIPHERFINAL_ERROR, PKCS12_R_UNKNOWN_DIGEST_ALGORITHM, PKCS12_R_UNSUPPORTED_PKCS12_MODE, PKCS5_DEFAULT_ITER, PKCS5_SALT_LEN, PKCS7_R_CERTIFICATE_VERIFY_ERROR, PKCS7_R_CIPHER_HAS_NO_OBJECT_IDENTIFIER, PKCS7_R_CIPHER_NOT_INITIALIZED, PKCS7_R_CONTENT_AND_DATA_PRESENT, PKCS7_R_CTRL_ERROR, PKCS7_R_DECRYPT_ERROR, PKCS7_R_DIGEST_FAILURE, PKCS7_R_ENCRYPTION_CTRL_FAILURE, PKCS7_R_ENCRYPTION_NOT_SUPPORTED_FOR_THIS_KEY_TYPE, PKCS7_R_ERROR_ADDING_RECIPIENT, PKCS7_R_ERROR_SETTING_CIPHER, PKCS7_R_INVALID_NULL_POINTER, PKCS7_R_INVALID_SIGNED_DATA_TYPE, PKCS7_R_NO_CONTENT, PKCS7_R_NO_DEFAULT_DIGEST, PKCS7_R_NO_MATCHING_DIGEST_TYPE_FOUND, PKCS7_R_NO_RECIPIENT_MATCHES_CERTIFICATE, PKCS7_R_NO_SIGNATURES_ON_DATA, PKCS7_R_NO_SIGNERS, PKCS7_R_OPERATION_NOT_SUPPORTED_ON_THIS_TYPE, PKCS7_R_PKCS7_ADD_SIGNATURE_ERROR, PKCS7_R_PKCS7_ADD_SIGNER_ERROR, PKCS7_R_PKCS7_DATASIGN, PKCS7_R_PRIVATE_KEY_DOES_NOT_MATCH_CERTIFICATE, PKCS7_R_SIGNATURE_FAILURE, PKCS7_R_SIGNER_CERTIFICATE_NOT_FOUND, PKCS7_R_SIGNING_CTRL_FAILURE, PKCS7_R_SIGNING_NOT_SUPPORTED_FOR_THIS_KEY_TYPE, PKCS7_R_SMIME_TEXT_ERROR, PKCS7_R_UNABLE_TO_FIND_CERTIFICATE, PKCS7_R_UNABLE_TO_FIND_MEM_BIO, PKCS7_R_UNABLE_TO_FIND_MESSAGE_DIGEST, PKCS7_R_UNKNOWN_DIGEST_TYPE, PKCS7_R_UNKNOWN_OPERATION, PKCS7_R_UNSUPPORTED_CIPHER_TYPE, PKCS7_R_UNSUPPORTED_CONTENT_TYPE, PKCS7_R_WRONG_CONTENT_TYPE, PKCS7_R_WRONG_PKCS7_TYPE, POINT_CONVERSION_COMPRESSED, POINT_CONVERSION_HYBRID, POINT_CONVERSION_UNCOMPRESSED, PROV_R_ADDITIONAL_INPUT_TOO_LONG, PROV_R_ALGORITHM_MISMATCH, PROV_R_ALREADY_INSTANTIATED, PROV_R_BAD_DECRYPT, PROV_R_BAD_ENCODING, PROV_R_BAD_LENGTH, PROV_R_BAD_TLS_CLIENT_VERSION, PROV_R_BN_ERROR, PROV_R_CIPHER_OPERATION_FAILED, PROV_R_DERIVATION_FUNCTION_INIT_FAILED, PROV_R_DIGEST_NOT_ALLOWED, PROV_R_ENTROPY_SOURCE_STRENGTH_TOO_WEAK, PROV_R_ERROR_INSTANTIATING_DRBG, PROV_R_ERROR_RETRIEVING_ENTROPY, PROV_R_ERROR_RETRIEVING_NONCE, PROV_R_FAILED_DURING_DERIVATION, PROV_R_FAILED_TO_CREATE_LOCK, PROV_R_FAILED_TO_DECRYPT, PROV_R_FAILED_TO_GENERATE_KEY, PROV_R_FAILED_TO_GET_PARAMETER, PROV_R_FAILED_TO_SET_PARAMETER, PROV_R_FAILED_TO_SIGN, PROV_R_FIPS_MODULE_CONDITIONAL_ERROR, PROV_R_FIPS_MODULE_ENTERING_ERROR_STATE, PROV_R_FIPS_MODULE_IN_ERROR_STATE, PROV_R_GENERATE_ERROR, PROV_R_ILLEGAL_OR_UNSUPPORTED_PADDING_MODE, PROV_R_INDICATOR_INTEGRITY_FAILURE, PROV_R_INSUFFICIENT_DRBG_STRENGTH, PROV_R_INVALID_AAD, PROV_R_INVALID_CONFIG_DATA, PROV_R_INVALID_CONSTANT_LENGTH, PROV_R_INVALID_CURVE, PROV_R_INVALID_CUSTOM_LENGTH, PROV_R_INVALID_DATA, PROV_R_INVALID_DIGEST, PROV_R_INVALID_DIGEST_LENGTH, PROV_R_INVALID_DIGEST_SIZE, PROV_R_INVALID_INPUT_LENGTH, PROV_R_INVALID_ITERATION_COUNT, PROV_R_INVALID_IV_LENGTH, PROV_R_INVALID_KEY, PROV_R_INVALID_KEY_LENGTH, PROV_R_INVALID_MAC, PROV_R_INVALID_MGF1_MD, PROV_R_INVALID_MODE, PROV_R_INVALID_OUTPUT_LENGTH, PROV_R_INVALID_PADDING_MODE, PROV_R_INVALID_PUBINFO, PROV_R_INVALID_SALT_LENGTH, PROV_R_INVALID_SEED_LENGTH, PROV_R_INVALID_SIGNATURE_SIZE, PROV_R_INVALID_STATE, PROV_R_INVALID_TAG, PROV_R_INVALID_TAG_LENGTH, PROV_R_INVALID_UKM_LENGTH, PROV_R_INVALID_X931_DIGEST, PROV_R_IN_ERROR_STATE, PROV_R_KEY_SETUP_FAILED, PROV_R_KEY_SIZE_TOO_SMALL, PROV_R_LENGTH_TOO_LARGE, PROV_R_MISMATCHING_DOMAIN_PARAMETERS, PROV_R_MISSING_CEK_ALG, PROV_R_MISSING_CIPHER, PROV_R_MISSING_CONFIG_DATA, PROV_R_MISSING_CONSTANT, PROV_R_MISSING_KEY, PROV_R_MISSING_MAC, PROV_R_MISSING_MESSAGE_DIGEST, PROV_R_MISSING_OID, PROV_R_MISSING_PASS, PROV_R_MISSING_SALT, PROV_R_MISSING_SECRET, PROV_R_MISSING_SEED, PROV_R_MISSING_SESSION_ID, PROV_R_MISSING_TYPE, PROV_R_MISSING_XCGHASH, PROV_R_MODULE_INTEGRITY_FAILURE, PROV_R_NOT_A_PRIVATE_KEY, PROV_R_NOT_A_PUBLIC_KEY, PROV_R_NOT_INSTANTIATED, PROV_R_NOT_PARAMETERS, PROV_R_NOT_SUPPORTED, PROV_R_NOT_XOF_OR_INVALID_LENGTH, PROV_R_NO_KEY_SET, PROV_R_NO_PARAMETERS_SET, PROV_R_OPERATION_NOT_SUPPORTED_FOR_THIS_KEYTYPE, PROV_R_OUTPUT_BUFFER_TOO_SMALL, PROV_R_PARENT_CANNOT_GENERATE_RANDOM_NUMBERS, PROV_R_PARENT_CANNOT_SUPPLY_ENTROPY_SEED, PROV_R_PARENT_LOCKING_NOT_ENABLED, PROV_R_PARENT_STRENGTH_TOO_WEAK, PROV_R_PATH_MUST_BE_ABSOLUTE, PROV_R_PERSONALISATION_STRING_TOO_LONG, PROV_R_PSS_SALTLEN_TOO_SMALL, PROV_R_REQUEST_TOO_LARGE_FOR_DRBG, PROV_R_REQUIRE_CTR_MODE_CIPHER, PROV_R_RESEED_ERROR, PROV_R_SEARCH_ONLY_SUPPORTED_FOR_DIRECTORIES, PROV_R_SEED_SOURCES_MUST_NOT_HAVE_A_PARENT, PROV_R_SELF_TEST_KAT_FAILURE, PROV_R_SELF_TEST_POST_FAILURE, PROV_R_TAG_NOT_NEEDED, PROV_R_TAG_NOT_SET, PROV_R_TOO_MANY_RECORDS, PROV_R_UNABLE_TO_FIND_CIPHERS, PROV_R_UNABLE_TO_GET_PARENT_STRENGTH, PROV_R_UNABLE_TO_GET_PASSPHRASE, PROV_R_UNABLE_TO_INITIALISE_CIPHERS, PROV_R_UNABLE_TO_LOAD_SHA256, PROV_R_UNABLE_TO_LOCK_PARENT, PROV_R_UNABLE_TO_RESEED, PROV_R_UNSUPPORTED_CEK_ALG, PROV_R_UNSUPPORTED_KEY_SIZE, PROV_R_UNSUPPORTED_MAC_TYPE, PROV_R_UNSUPPORTED_NUMBER_OF_ROUNDS, PROV_R_URI_AUTHORITY_UNSUPPORTED, PROV_R_VALUE_ERROR, PROV_R_WRONG_FINAL_BLOCK_LENGTH, PROV_R_WRONG_OUTPUT_BUFFER_SIZE, PROV_R_XOF_DIGESTS_NOT_ALLOWED, PROV_R_XTS_DATA_UNIT_IS_TOO_LARGE, PROV_R_XTS_DUPLICATED_KEYS, RAND_DRBG_STRENGTH, RAND_R_ADDITIONAL_INPUT_TOO_LONG, RAND_R_ALREADY_INSTANTIATED, RAND_R_ARGUMENT_OUT_OF_RANGE, RAND_R_CANNOT_OPEN_FILE, RAND_R_DRBG_ALREADY_INITIALIZED, RAND_R_DRBG_NOT_INITIALISED, RAND_R_ENTROPY_INPUT_TOO_LONG, RAND_R_ENTROPY_OUT_OF_RANGE, RAND_R_ERROR_ENTROPY_POOL_WAS_IGNORED, RAND_R_ERROR_INITIALISING_DRBG, RAND_R_ERROR_INSTANTIATING_DRBG, RAND_R_ERROR_RETRIEVING_ADDITIONAL_INPUT, RAND_R_ERROR_RETRIEVING_ENTROPY, RAND_R_ERROR_RETRIEVING_NONCE, RAND_R_FAILED_TO_CREATE_LOCK, RAND_R_FUNC_NOT_IMPLEMENTED, RAND_R_FWRITE_ERROR, RAND_R_GENERATE_ERROR, RAND_R_INSUFFICIENT_DRBG_STRENGTH, RAND_R_INTERNAL_ERROR, RAND_R_IN_ERROR_STATE, RAND_R_NOT_A_REGULAR_FILE, RAND_R_NOT_INSTANTIATED, RAND_R_NO_DRBG_IMPLEMENTATION_SELECTED, RAND_R_PARENT_LOCKING_NOT_ENABLED, RAND_R_PARENT_STRENGTH_TOO_WEAK, RAND_R_PERSONALISATION_STRING_TOO_LONG, RAND_R_PREDICTION_RESISTANCE_NOT_SUPPORTED, RAND_R_PRNG_NOT_SEEDED, RAND_R_RANDOM_POOL_OVERFLOW, RAND_R_RANDOM_POOL_UNDERFLOW, RAND_R_REQUEST_TOO_LARGE_FOR_DRBG, RAND_R_RESEED_ERROR, RAND_R_SELFTEST_FAILURE, RAND_R_TOO_LITTLE_NONCE_REQUESTED, RAND_R_TOO_MUCH_NONCE_REQUESTED, RAND_R_UNABLE_TO_CREATE_DRBG, RAND_R_UNABLE_TO_FETCH_DRBG, RAND_R_UNABLE_TO_GET_PARENT_RESEED_PROP_COUNTER, RAND_R_UNABLE_TO_GET_PARENT_STRENGTH, RAND_R_UNABLE_TO_LOCK_PARENT, RAND_R_UNSUPPORTED_DRBG_FLAGS, RAND_R_UNSUPPORTED_DRBG_TYPE, RSA_3, RSA_F4, RSA_FLAG_TYPE_MASK, RSA_FLAG_TYPE_RSA, RSA_FLAG_TYPE_RSAESOAEP, RSA_FLAG_TYPE_RSASSAPSS, RSA_NO_PADDING, RSA_PKCS1_OAEP_PADDING, RSA_PKCS1_PADDING, RSA_PKCS1_PADDING_SIZE, RSA_PKCS1_PSS_PADDING, RSA_PKCS1_WITH_TLS_PADDING, RSA_PSS_SALTLEN_AUTO, RSA_PSS_SALTLEN_DIGEST, RSA_PSS_SALTLEN_MAX, RSA_PSS_SALTLEN_MAX_SIGN, RSA_R_ALGORITHM_MISMATCH, RSA_R_BAD_E_VALUE, RSA_R_BAD_FIXED_HEADER_DECRYPT, RSA_R_BAD_PAD_BYTE_COUNT, RSA_R_BAD_SIGNATURE, RSA_R_BLOCK_TYPE_IS_NOT_01, RSA_R_BLOCK_TYPE_IS_NOT_02, RSA_R_DATA_GREATER_THAN_MOD_LEN, RSA_R_DATA_TOO_LARGE, RSA_R_DATA_TOO_LARGE_FOR_KEY_SIZE, RSA_R_DATA_TOO_LARGE_FOR_MODULUS, RSA_R_DATA_TOO_SMALL, RSA_R_DATA_TOO_SMALL_FOR_KEY_SIZE, RSA_R_DIGEST_DOES_NOT_MATCH, RSA_R_DIGEST_NOT_ALLOWED, RSA_R_DIGEST_TOO_BIG_FOR_RSA_KEY, RSA_R_DMP1_NOT_CONGRUENT_TO_D, RSA_R_DMQ1_NOT_CONGRUENT_TO_D, RSA_R_D_E_NOT_CONGRUENT_TO_1, RSA_R_FIRST_OCTET_INVALID, RSA_R_ILLEGAL_OR_UNSUPPORTED_PADDING_MODE, RSA_R_INVALID_DIGEST, RSA_R_INVALID_DIGEST_LENGTH, RSA_R_INVALID_HEADER, RSA_R_INVALID_KEYPAIR, RSA_R_INVALID_KEY_LENGTH, RSA_R_INVALID_LABEL, RSA_R_INVALID_LENGTH, RSA_R_INVALID_MESSAGE_LENGTH, RSA_R_INVALID_MGF1_MD, RSA_R_INVALID_MODULUS, RSA_R_INVALID_MULTI_PRIME_KEY, RSA_R_INVALID_OAEP_PARAMETERS, RSA_R_INVALID_PADDING, RSA_R_INVALID_PADDING_MODE, RSA_R_INVALID_PSS_PARAMETERS, RSA_R_INVALID_PSS_SALTLEN, RSA_R_INVALID_REQUEST, RSA_R_INVALID_SALT_LENGTH, RSA_R_INVALID_STRENGTH, RSA_R_INVALID_TRAILER, RSA_R_INVALID_X931_DIGEST, RSA_R_IQMP_NOT_INVERSE_OF_Q, RSA_R_KEY_PRIME_NUM_INVALID, RSA_R_KEY_SIZE_TOO_SMALL, RSA_R_LAST_OCTET_INVALID, RSA_R_MGF1_DIGEST_NOT_ALLOWED, RSA_R_MISSING_PRIVATE_KEY, RSA_R_MODULUS_TOO_LARGE, RSA_R_MP_COEFFICIENT_NOT_INVERSE_OF_R, RSA_R_MP_EXPONENT_NOT_CONGRUENT_TO_D, RSA_R_MP_R_NOT_PRIME, RSA_R_NO_PUBLIC_EXPONENT, RSA_R_NULL_BEFORE_BLOCK_MISSING, RSA_R_N_DOES_NOT_EQUAL_PRODUCT_OF_PRIMES, RSA_R_N_DOES_NOT_EQUAL_P_Q, RSA_R_OAEP_DECODING_ERROR, RSA_R_OPERATION_NOT_SUPPORTED_FOR_THIS_KEYTYPE, RSA_R_PADDING_CHECK_FAILED, RSA_R_PAIRWISE_TEST_FAILURE, RSA_R_PKCS_DECODING_ERROR, RSA_R_PSS_SALTLEN_TOO_SMALL, RSA_R_PUB_EXPONENT_OUT_OF_RANGE, RSA_R_P_NOT_PRIME, RSA_R_Q_NOT_PRIME, RSA_R_RANDOMNESS_SOURCE_STRENGTH_INSUFFICIENT, RSA_R_RSA_OPERATIONS_NOT_SUPPORTED, RSA_R_SLEN_CHECK_FAILED, RSA_R_SLEN_RECOVERY_FAILED, RSA_R_SSLV3_ROLLBACK_ATTACK, RSA_R_THE_ASN1_OBJECT_IDENTIFIER_IS_NOT_KNOWN_FOR_THIS_MD, RSA_R_UNKNOWN_ALGORITHM_TYPE, RSA_R_UNKNOWN_DIGEST, RSA_R_UNKNOWN_MASK_DIGEST, RSA_R_UNKNOWN_PADDING_TYPE, RSA_R_UNSUPPORTED_ENCRYPTION_TYPE, RSA_R_UNSUPPORTED_LABEL_SOURCE, RSA_R_UNSUPPORTED_MASK_ALGORITHM, RSA_R_UNSUPPORTED_MASK_PARAMETER, RSA_R_UNSUPPORTED_SIGNATURE_TYPE, RSA_R_VALUE_MISSING, RSA_R_WRONG_SIGNATURE_LENGTH, RSA_X931_PADDING, SHA224_DIGEST_LENGTH, SHA256_DIGEST_LENGTH, SHA384_DIGEST_LENGTH, SHA512_DIGEST_LENGTH, SHA_DIGEST_LENGTH, SN_Directory, SN_Domain, SN_ED25519, SN_ED448, SN_Enterprises, SN_Experimental, SN_INN, SN_ISO_CN, SN_ISO_UA, SN_ISO_US, SN_Independent, SN_LocalKeySet, SN_Management, SN_NAIRealm, SN_OCSP_sign, SN_OGRN, SN_OGRNIP, SN_Private, SN_RSA_SHA3_224, SN_RSA_SHA3_256, SN_RSA_SHA3_384, SN_RSA_SHA3_512, SN_SM2_with_SM3, SN_SMIME, SN_SMIMECapabilities, SN_SNILS, SN_SNMPv2, SN_SRVName, SN_Security, SN_X25519, SN_X448, SN_X500, SN_X500algorithms, SN_X509, SN_X9_57, SN_X9_62_c2onb191v4, SN_X9_62_c2onb191v5, SN_X9_62_c2onb239v4, SN_X9_62_c2onb239v5, SN_X9_62_c2pnb163v1, SN_X9_62_c2pnb163v2, SN_X9_62_c2pnb163v3, SN_X9_62_c2pnb176v1, SN_X9_62_c2pnb208w1, SN_X9_62_c2pnb272w1, SN_X9_62_c2pnb304w1, SN_X9_62_c2pnb368w1, SN_X9_62_c2tnb191v1, SN_X9_62_c2tnb191v2, SN_X9_62_c2tnb191v3, SN_X9_62_c2tnb239v1, SN_X9_62_c2tnb239v2, SN_X9_62_c2tnb239v3, SN_X9_62_c2tnb359v1, SN_X9_62_c2tnb431r1, SN_X9_62_characteristic_two_field, SN_X9_62_id_characteristic_two_basis, SN_X9_62_id_ecPublicKey, SN_X9_62_onBasis, SN_X9_62_ppBasis, SN_X9_62_prime192v1, SN_X9_62_prime192v2, SN_X9_62_prime192v3, SN_X9_62_prime239v1, SN_X9_62_prime239v2, SN_X9_62_prime239v3, SN_X9_62_prime256v1, SN_X9_62_prime_field, SN_X9_62_tpBasis, SN_X9cm, SN_XmppAddr, SN_aaControls, SN_ac_auditEntity, SN_ac_proxying, SN_ac_targeting, SN_account, SN_ad_OCSP, SN_ad_ca_issuers, SN_ad_dvcs, SN_ad_timeStamping, SN_aes_128_cbc, SN_aes_128_cbc_hmac_sha1, SN_aes_128_cbc_hmac_sha256, SN_aes_128_ccm, SN_aes_128_cfb1, SN_aes_128_cfb128, SN_aes_128_cfb8, SN_aes_128_ctr, SN_aes_128_ecb, SN_aes_128_gcm, SN_aes_128_ocb, SN_aes_128_ofb128, SN_aes_128_siv, SN_aes_128_xts, SN_aes_192_cbc, SN_aes_192_cbc_hmac_sha1, SN_aes_192_cbc_hmac_sha256, SN_aes_192_ccm, SN_aes_192_cfb1, SN_aes_192_cfb128, SN_aes_192_cfb8, SN_aes_192_ctr, SN_aes_192_ecb, SN_aes_192_gcm, SN_aes_192_ocb, SN_aes_192_ofb128, SN_aes_192_siv, SN_aes_256_cbc, SN_aes_256_cbc_hmac_sha1, SN_aes_256_cbc_hmac_sha256, SN_aes_256_ccm, SN_aes_256_cfb1, SN_aes_256_cfb128, SN_aes_256_cfb8, SN_aes_256_ctr, SN_aes_256_ecb, SN_aes_256_gcm, SN_aes_256_ocb, SN_aes_256_ofb128, SN_aes_256_siv, SN_aes_256_xts, SN_algorithm, SN_ansi_X9_62, SN_anyExtendedKeyUsage, SN_any_policy, SN_aria_128_cbc, SN_aria_128_ccm, SN_aria_128_cfb1, SN_aria_128_cfb128, SN_aria_128_cfb8, SN_aria_128_ctr, SN_aria_128_ecb, SN_aria_128_gcm, SN_aria_128_ofb128, SN_aria_192_cbc, SN_aria_192_ccm, SN_aria_192_cfb1, SN_aria_192_cfb128, SN_aria_192_cfb8, SN_aria_192_ctr, SN_aria_192_ecb, SN_aria_192_gcm, SN_aria_192_ofb128, SN_aria_256_cbc, SN_aria_256_ccm, SN_aria_256_cfb1, SN_aria_256_cfb128, SN_aria_256_cfb8, SN_aria_256_ctr, SN_aria_256_ecb, SN_aria_256_gcm, SN_aria_256_ofb128, SN_audio, SN_auth_any, SN_auth_dss, SN_auth_ecdsa, SN_auth_gost01, SN_auth_gost12, SN_auth_null, SN_auth_psk, SN_auth_rsa, SN_auth_srp, SN_authority_key_identifier, SN_basic_constraints, SN_bf_cbc, SN_bf_cfb64, SN_bf_ecb, SN_bf_ofb64, SN_biometricInfo, SN_blake2b512, SN_blake2bmac, SN_blake2s256, SN_blake2smac, SN_brainpoolP160r1, SN_brainpoolP160t1, SN_brainpoolP192r1, SN_brainpoolP192t1, SN_brainpoolP224r1, SN_brainpoolP224t1, SN_brainpoolP256r1, SN_brainpoolP256t1, SN_brainpoolP320r1, SN_brainpoolP320t1, SN_brainpoolP384r1, SN_brainpoolP384t1, SN_brainpoolP512r1, SN_brainpoolP512t1, SN_caRepository, SN_camellia_128_cbc, SN_camellia_128_ccm, SN_camellia_128_cfb1, SN_camellia_128_cfb128, SN_camellia_128_cfb8, SN_camellia_128_cmac, SN_camellia_128_ctr, SN_camellia_128_ecb, SN_camellia_128_gcm, SN_camellia_128_ofb128, SN_camellia_192_cbc, SN_camellia_192_ccm, SN_camellia_192_cfb1, SN_camellia_192_cfb128, SN_camellia_192_cfb8, SN_camellia_192_cmac, SN_camellia_192_ctr, SN_camellia_192_ecb, SN_camellia_192_gcm, SN_camellia_192_ofb128, SN_camellia_256_cbc, SN_camellia_256_ccm, SN_camellia_256_cfb1, SN_camellia_256_cfb128, SN_camellia_256_cfb8, SN_camellia_256_cmac, SN_camellia_256_ctr, SN_camellia_256_ecb, SN_camellia_256_gcm, SN_camellia_256_ofb128, SN_capwapAC, SN_capwapWTP, SN_cast5_cbc, SN_cast5_cfb64, SN_cast5_ecb, SN_cast5_ofb64, SN_certicom_arc, SN_certificate_issuer, SN_certificate_policies, SN_chacha20, SN_chacha20_poly1305, SN_classSignTool, SN_classSignToolKA1, SN_classSignToolKB1, SN_classSignToolKB2, SN_classSignToolKC1, SN_classSignToolKC2, SN_classSignToolKC3, SN_clearance, SN_client_auth, SN_cmKGA, SN_cmac, SN_cmcArchive, SN_cmcCA, SN_cmcRA, SN_code_sign, SN_commonName, SN_countryCode3c, SN_countryCode3n, SN_countryName, SN_crl_distribution_points, SN_crl_number, SN_crl_reason, SN_cryptocom, SN_cryptopro, SN_ct_cert_scts, SN_ct_precert_poison, SN_ct_precert_scts, SN_ct_precert_signer, SN_data, SN_dcObject, SN_delta_crl, SN_des_cbc, SN_des_cdmf, SN_des_cfb1, SN_des_cfb64, SN_des_cfb8, SN_des_ecb, SN_des_ede3_cbc, SN_des_ede3_cfb1, SN_des_ede3_cfb64, SN_des_ede3_cfb8, SN_des_ede3_ecb, SN_des_ede3_ofb64, SN_des_ede_cbc, SN_des_ede_cfb64, SN_des_ede_ecb, SN_des_ede_ofb64, SN_des_ofb64, SN_desx_cbc, SN_dhSinglePass_cofactorDH_sha1kdf_scheme, SN_dhSinglePass_cofactorDH_sha224kdf_scheme, SN_dhSinglePass_cofactorDH_sha256kdf_scheme, SN_dhSinglePass_cofactorDH_sha384kdf_scheme, SN_dhSinglePass_cofactorDH_sha512kdf_scheme, SN_dhSinglePass_stdDH_sha1kdf_scheme, SN_dhSinglePass_stdDH_sha224kdf_scheme, SN_dhSinglePass_stdDH_sha256kdf_scheme, SN_dhSinglePass_stdDH_sha384kdf_scheme, SN_dhSinglePass_stdDH_sha512kdf_scheme, SN_dh_cofactor_kdf, SN_dh_std_kdf, SN_dhpublicnumber, SN_dmdName, SN_dnQualifier, SN_document, SN_dod, SN_domainComponent, SN_dsa, SN_dsaWithSHA, SN_dsaWithSHA1, SN_dsaWithSHA1_2, SN_dsa_2, SN_dsa_with_SHA224, SN_dsa_with_SHA256, SN_dsa_with_SHA384, SN_dsa_with_SHA3_224, SN_dsa_with_SHA3_256, SN_dsa_with_SHA3_384, SN_dsa_with_SHA3_512, SN_dsa_with_SHA512, SN_dstu28147, SN_dstu28147_cfb, SN_dstu28147_ofb, SN_dstu28147_wrap, SN_dstu34311, SN_dstu4145be, SN_dstu4145le, SN_dvcs, SN_ecdsa_with_Recommended, SN_ecdsa_with_SHA1, SN_ecdsa_with_SHA224, SN_ecdsa_with_SHA256, SN_ecdsa_with_SHA384, SN_ecdsa_with_SHA3_224, SN_ecdsa_with_SHA3_256, SN_ecdsa_with_SHA3_384, SN_ecdsa_with_SHA3_512, SN_ecdsa_with_SHA512, SN_ecdsa_with_Specified, SN_email_protect, SN_ext_key_usage, SN_ext_req, SN_ffdhe2048, SN_ffdhe3072, SN_ffdhe4096, SN_ffdhe6144, SN_ffdhe8192, SN_freshest_crl, SN_givenName, SN_gmac, SN_gost89_cbc, SN_gost89_cnt, SN_gost89_cnt_12, SN_gost89_ctr, SN_gost89_ecb, SN_gost_mac_12, SN_grasshopper_cbc, SN_grasshopper_cfb, SN_grasshopper_ctr, SN_grasshopper_ecb, SN_grasshopper_mac, SN_grasshopper_ofb, SN_hkdf, SN_hmac, SN_hmacWithDstu34311, SN_hmac_md5, SN_hmac_sha1, SN_hmac_sha3_224, SN_hmac_sha3_256, SN_hmac_sha3_384, SN_hmac_sha3_512, SN_hold_instruction_call_issuer, SN_hold_instruction_code, SN_hold_instruction_none, SN_hold_instruction_reject, SN_host, SN_iana, SN_id_DHBasedMac, SN_id_Gost28147_89, SN_id_Gost28147_89_CryptoPro_A_ParamSet, SN_id_Gost28147_89_CryptoPro_B_ParamSet, SN_id_Gost28147_89_CryptoPro_C_ParamSet, SN_id_Gost28147_89_CryptoPro_D_ParamSet, SN_id_Gost28147_89_CryptoPro_KeyMeshing, SN_id_Gost28147_89_CryptoPro_Oscar_1_0_ParamSet, SN_id_Gost28147_89_CryptoPro_Oscar_1_1_ParamSet, SN_id_Gost28147_89_CryptoPro_RIC_1_ParamSet, SN_id_Gost28147_89_MAC, SN_id_Gost28147_89_None_KeyMeshing, SN_id_Gost28147_89_TestParamSet, SN_id_Gost28147_89_cc, SN_id_GostR3410_2001, SN_id_GostR3410_2001DH, SN_id_GostR3410_2001_CryptoPro_A_ParamSet, SN_id_GostR3410_2001_CryptoPro_B_ParamSet, SN_id_GostR3410_2001_CryptoPro_C_ParamSet, SN_id_GostR3410_2001_CryptoPro_XchA_ParamSet, SN_id_GostR3410_2001_CryptoPro_XchB_ParamSet, SN_id_GostR3410_2001_ParamSet_cc, SN_id_GostR3410_2001_TestParamSet, SN_id_GostR3410_2001_cc, SN_id_GostR3410_2012_256, SN_id_GostR3410_2012_512, SN_id_GostR3410_94, SN_id_GostR3410_94DH, SN_id_GostR3410_94_CryptoPro_A_ParamSet, SN_id_GostR3410_94_CryptoPro_B_ParamSet, SN_id_GostR3410_94_CryptoPro_C_ParamSet, SN_id_GostR3410_94_CryptoPro_D_ParamSet, SN_id_GostR3410_94_CryptoPro_XchA_ParamSet, SN_id_GostR3410_94_CryptoPro_XchB_ParamSet, SN_id_GostR3410_94_CryptoPro_XchC_ParamSet, SN_id_GostR3410_94_TestParamSet, SN_id_GostR3410_94_a, SN_id_GostR3410_94_aBis, SN_id_GostR3410_94_b, SN_id_GostR3410_94_bBis, SN_id_GostR3410_94_cc, SN_id_GostR3411_2012_256, SN_id_GostR3411_2012_512, SN_id_GostR3411_94, SN_id_GostR3411_94_CryptoProParamSet, SN_id_GostR3411_94_TestParamSet, SN_id_GostR3411_94_prf, SN_id_GostR3411_94_with_GostR3410_2001, SN_id_GostR3411_94_with_GostR3410_2001_cc, SN_id_GostR3411_94_with_GostR3410_94, SN_id_GostR3411_94_with_GostR3410_94_cc, SN_id_HMACGostR3411_94, SN_id_PasswordBasedMAC, SN_id_aca, SN_id_aca_accessIdentity, SN_id_aca_authenticationInfo, SN_id_aca_chargingIdentity, SN_id_aca_encAttrs, SN_id_aca_group, SN_id_aca_role, SN_id_ad, SN_id_aes128_wrap, SN_id_aes128_wrap_pad, SN_id_aes192_wrap, SN_id_aes192_wrap_pad, SN_id_aes256_wrap, SN_id_aes256_wrap_pad, SN_id_alg, SN_id_alg_PWRI_KEK, SN_id_alg_des40, SN_id_alg_dh_pop, SN_id_alg_dh_sig_hmac_sha1, SN_id_alg_noSignature, SN_id_camellia128_wrap, SN_id_camellia192_wrap, SN_id_camellia256_wrap, SN_id_cct, SN_id_cct_PKIData, SN_id_cct_PKIResponse, SN_id_cct_crs, SN_id_ce, SN_id_cmc, SN_id_cmc_addExtensions, SN_id_cmc_confirmCertAcceptance, SN_id_cmc_dataReturn, SN_id_cmc_decryptedPOP, SN_id_cmc_encryptedPOP, SN_id_cmc_getCRL, SN_id_cmc_getCert, SN_id_cmc_identification, SN_id_cmc_identityProof, SN_id_cmc_lraPOPWitness, SN_id_cmc_popLinkRandom, SN_id_cmc_popLinkWitness, SN_id_cmc_queryPending, SN_id_cmc_recipientNonce, SN_id_cmc_regInfo, SN_id_cmc_responseInfo, SN_id_cmc_revokeRequest, SN_id_cmc_senderNonce, SN_id_cmc_statusInfo, SN_id_cmc_transactionId, SN_id_cp, SN_id_ct_asciiTextWithCRLF, SN_id_ct_geofeedCSVwithCRLF, SN_id_ct_resourceTaggedAttest, SN_id_ct_routeOriginAuthz, SN_id_ct_rpkiGhostbusters, SN_id_ct_rpkiManifest, SN_id_ct_signedChecklist, SN_id_ct_xml, SN_id_hex_multipart_message, SN_id_hex_partial_message, SN_id_it, SN_id_it_caCerts, SN_id_it_caKeyUpdateInfo, SN_id_it_caProtEncCert, SN_id_it_certReqTemplate, SN_id_it_confirmWaitTime, SN_id_it_currentCRL, SN_id_it_encKeyPairTypes, SN_id_it_implicitConfirm, SN_id_it_keyPairParamRep, SN_id_it_keyPairParamReq, SN_id_it_origPKIMessage, SN_id_it_preferredSymmAlg, SN_id_it_revPassphrase, SN_id_it_rootCaKeyUpdate, SN_id_it_signKeyPairTypes, SN_id_it_subscriptionRequest, SN_id_it_subscriptionResponse, SN_id_it_suppLangTags, SN_id_it_unsupportedOIDs, SN_id_kp, SN_id_kp_BrandIndicatorforMessageIdentification, SN_id_kp_bgpsec_router, SN_id_mod_attribute_cert, SN_id_mod_cmc, SN_id_mod_cmp, SN_id_mod_cmp2000, SN_id_mod_crmf, SN_id_mod_dvcs, SN_id_mod_kea_profile_88, SN_id_mod_kea_profile_93, SN_id_mod_ocsp, SN_id_mod_qualified_cert_88, SN_id_mod_qualified_cert_93, SN_id_mod_timestamp_protocol, SN_id_on, SN_id_on_SmtpUTF8Mailbox, SN_id_on_permanentIdentifier, SN_id_on_personalData, SN_id_pda, SN_id_pda_countryOfCitizenship, SN_id_pda_countryOfResidence, SN_id_pda_dateOfBirth, SN_id_pda_gender, SN_id_pda_placeOfBirth, SN_id_pe, SN_id_pkinit, SN_id_pkip, SN_id_pkix, SN_id_pkix1_explicit_88, SN_id_pkix1_explicit_93, SN_id_pkix1_implicit_88, SN_id_pkix1_implicit_93, SN_id_pkix_OCSP_CrlID, SN_id_pkix_OCSP_Nonce, SN_id_pkix_OCSP_acceptableResponses, SN_id_pkix_OCSP_archiveCutoff, SN_id_pkix_OCSP_basic, SN_id_pkix_OCSP_extendedStatus, SN_id_pkix_OCSP_noCheck, SN_id_pkix_OCSP_path, SN_id_pkix_OCSP_serviceLocator, SN_id_pkix_OCSP_trustRoot, SN_id_pkix_OCSP_valid, SN_id_pkix_mod, SN_id_ppl, SN_id_ppl_anyLanguage, SN_id_ppl_inheritAll, SN_id_qcs, SN_id_qcs_pkixQCSyntax_v1, SN_id_qt, SN_id_qt_cps, SN_id_qt_unotice, SN_id_regCtrl, SN_id_regCtrl_authenticator, SN_id_regCtrl_oldCertID, SN_id_regCtrl_pkiArchiveOptions, SN_id_regCtrl_pkiPublicationInfo, SN_id_regCtrl_protocolEncrKey, SN_id_regCtrl_regToken, SN_id_regInfo, SN_id_regInfo_certReq, SN_id_regInfo_utf8Pairs, SN_id_scrypt, SN_id_set, SN_id_smime_aa, SN_id_smime_aa_contentHint, SN_id_smime_aa_contentIdentifier, SN_id_smime_aa_contentReference, SN_id_smime_aa_dvcs_dvc, SN_id_smime_aa_encapContentType, SN_id_smime_aa_encrypKeyPref, SN_id_smime_aa_equivalentLabels, SN_id_smime_aa_ets_CertificateRefs, SN_id_smime_aa_ets_RevocationRefs, SN_id_smime_aa_ets_archiveTimeStamp, SN_id_smime_aa_ets_certCRLTimestamp, SN_id_smime_aa_ets_certValues, SN_id_smime_aa_ets_commitmentType, SN_id_smime_aa_ets_contentTimestamp, SN_id_smime_aa_ets_escTimeStamp, SN_id_smime_aa_ets_otherSigCert, SN_id_smime_aa_ets_revocationValues, SN_id_smime_aa_ets_sigPolicyId, SN_id_smime_aa_ets_signerAttr, SN_id_smime_aa_ets_signerLocation, SN_id_smime_aa_macValue, SN_id_smime_aa_mlExpandHistory, SN_id_smime_aa_msgSigDigest, SN_id_smime_aa_receiptRequest, SN_id_smime_aa_securityLabel, SN_id_smime_aa_signatureType, SN_id_smime_aa_signingCertificate, SN_id_smime_aa_signingCertificateV2, SN_id_smime_aa_smimeEncryptCerts, SN_id_smime_aa_timeStampToken, SN_id_smime_alg, SN_id_smime_alg_3DESwrap, SN_id_smime_alg_CMS3DESwrap, SN_id_smime_alg_CMSRC2wrap, SN_id_smime_alg_ESDH, SN_id_smime_alg_ESDHwith3DES, SN_id_smime_alg_ESDHwithRC2, SN_id_smime_alg_RC2wrap, SN_id_smime_cd, SN_id_smime_cd_ldap, SN_id_smime_ct, SN_id_smime_ct_DVCSRequestData, SN_id_smime_ct_DVCSResponseData, SN_id_smime_ct_TDTInfo, SN_id_smime_ct_TSTInfo, SN_id_smime_ct_authData, SN_id_smime_ct_authEnvelopedData, SN_id_smime_ct_compressedData, SN_id_smime_ct_contentCollection, SN_id_smime_ct_contentInfo, SN_id_smime_ct_publishCert, SN_id_smime_ct_receipt, SN_id_smime_cti, SN_id_smime_cti_ets_proofOfApproval, SN_id_smime_cti_ets_proofOfCreation, SN_id_smime_cti_ets_proofOfDelivery, SN_id_smime_cti_ets_proofOfOrigin, SN_id_smime_cti_ets_proofOfReceipt, SN_id_smime_cti_ets_proofOfSender, SN_id_smime_mod, SN_id_smime_mod_cms, SN_id_smime_mod_ess, SN_id_smime_mod_ets_eSigPolicy_88, SN_id_smime_mod_ets_eSigPolicy_97, SN_id_smime_mod_ets_eSignature_88, SN_id_smime_mod_ets_eSignature_97, SN_id_smime_mod_msg_v3, SN_id_smime_mod_oid, SN_id_smime_spq, SN_id_smime_spq_ets_sqt_unotice, SN_id_smime_spq_ets_sqt_uri, SN_id_tc26, SN_id_tc26_agreement, SN_id_tc26_agreement_gost_3410_2012_256, SN_id_tc26_agreement_gost_3410_2012_512, SN_id_tc26_algorithms, SN_id_tc26_cipher, SN_id_tc26_cipher_constants, SN_id_tc26_cipher_gostr3412_2015_kuznyechik, SN_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm, SN_id_tc26_cipher_gostr3412_2015_kuznyechik_ctracpkm_omac, SN_id_tc26_cipher_gostr3412_2015_magma, SN_id_tc26_cipher_gostr3412_2015_magma_ctracpkm, SN_id_tc26_cipher_gostr3412_2015_magma_ctracpkm_omac, SN_id_tc26_constants, SN_id_tc26_digest, SN_id_tc26_digest_constants, SN_id_tc26_gost_28147_constants, SN_id_tc26_gost_28147_param_Z, SN_id_tc26_gost_3410_2012_256_constants, SN_id_tc26_gost_3410_2012_256_paramSetA, SN_id_tc26_gost_3410_2012_256_paramSetB, SN_id_tc26_gost_3410_2012_256_paramSetC, SN_id_tc26_gost_3410_2012_256_paramSetD, SN_id_tc26_gost_3410_2012_512_constants, SN_id_tc26_gost_3410_2012_512_paramSetA, SN_id_tc26_gost_3410_2012_512_paramSetB, SN_id_tc26_gost_3410_2012_512_paramSetC, SN_id_tc26_gost_3410_2012_512_paramSetTest, SN_id_tc26_hmac_gost_3411_2012_256, SN_id_tc26_hmac_gost_3411_2012_512, SN_id_tc26_mac, SN_id_tc26_sign, SN_id_tc26_sign_constants, SN_id_tc26_signwithdigest, SN_id_tc26_signwithdigest_gost3410_2012_256, SN_id_tc26_signwithdigest_gost3410_2012_512, SN_id_tc26_wrap, SN_id_tc26_wrap_gostr3412_2015_kuznyechik, SN_id_tc26_wrap_gostr3412_2015_kuznyechik_kexp15, SN_id_tc26_wrap_gostr3412_2015_magma, SN_id_tc26_wrap_gostr3412_2015_magma_kexp15, SN_idea_cbc, SN_idea_cfb64, SN_idea_ecb, SN_idea_ofb64, SN_identified_organization, SN_ieee, SN_ieee_siswg, SN_info, SN_info_access, SN_inhibit_any_policy, SN_initials, SN_international_organizations, SN_invalidity_date, SN_ipAddr_asNumber, SN_ipAddr_asNumberv2, SN_ipsec3, SN_ipsec4, SN_ipsecEndSystem, SN_ipsecTunnel, SN_ipsecUser, SN_ipsec_IKE, SN_iso, SN_issuerSignTool, SN_issuer_alt_name, SN_issuing_distribution_point, SN_itu_t, SN_joint_iso_itu_t, SN_jurisdictionCountryName, SN_jurisdictionLocalityName, SN_jurisdictionStateOrProvinceName, SN_key_usage, SN_kisa, SN_kmac128, SN_kmac256, SN_kuznyechik_cbc, SN_kuznyechik_cfb, SN_kuznyechik_ctr, SN_kuznyechik_ctr_acpkm, SN_kuznyechik_ctr_acpkm_omac, SN_kuznyechik_ecb, SN_kuznyechik_kexp15, SN_kuznyechik_mac, SN_kuznyechik_ofb, SN_kx_any, SN_kx_dhe, SN_kx_dhe_psk, SN_kx_ecdhe, SN_kx_ecdhe_psk, SN_kx_gost, SN_kx_gost18, SN_kx_psk, SN_kx_rsa, SN_kx_rsa_psk, SN_kx_srp, SN_localityName, SN_magma_cbc, SN_magma_cfb, SN_magma_ctr, SN_magma_ctr_acpkm, SN_magma_ctr_acpkm_omac, SN_magma_ecb, SN_magma_kexp15, SN_magma_mac, SN_magma_ofb, SN_manager, SN_md2, SN_md2WithRSAEncryption, SN_md4, SN_md4WithRSAEncryption, SN_md5, SN_md5WithRSA, SN_md5WithRSAEncryption, SN_md5_sha1, SN_mdc2, SN_mdc2WithRSA, SN_member, SN_member_body, SN_mgf1, SN_mime_mhs, SN_mime_mhs_bodies, SN_mime_mhs_headings, SN_modp_1536, SN_modp_2048, SN_modp_3072, SN_modp_4096, SN_modp_6144, SN_modp_8192, SN_ms_code_com, SN_ms_code_ind, SN_ms_csp_name, SN_ms_ctl_sign, SN_ms_efs, SN_ms_ext_req, SN_ms_sgc, SN_ms_smartcard_login, SN_ms_upn, SN_name, SN_name_constraints, SN_netscape, SN_netscape_base_url, SN_netscape_ca_policy_url, SN_netscape_ca_revocation_url, SN_netscape_cert_extension, SN_netscape_cert_sequence, SN_netscape_cert_type, SN_netscape_comment, SN_netscape_data_type, SN_netscape_renewal_url, SN_netscape_revocation_url, SN_netscape_ssl_server_name, SN_no_rev_avail, SN_ns_sgc, SN_org, SN_organizationName, SN_organizationalUnitName, SN_oscca, SN_owner, SN_pSpecified, SN_pbeWithMD2AndDES_CBC, SN_pbeWithMD2AndRC2_CBC, SN_pbeWithMD5AndDES_CBC, SN_pbeWithMD5AndRC2_CBC, SN_pbeWithSHA1AndDES_CBC, SN_pbeWithSHA1AndRC2_CBC, SN_pbe_WithSHA1And128BitRC2_CBC, SN_pbe_WithSHA1And128BitRC4, SN_pbe_WithSHA1And2_Key_TripleDES_CBC, SN_pbe_WithSHA1And3_Key_TripleDES_CBC, SN_pbe_WithSHA1And40BitRC2_CBC, SN_pbe_WithSHA1And40BitRC4, SN_photo, SN_pilot, SN_pkInitClientAuth, SN_pkInitKDC, SN_pkcs, SN_pkcs1, SN_pkcs3, SN_pkcs5, SN_pkcs7, SN_pkcs9, SN_policy_constraints, SN_policy_mappings, SN_poly1305, SN_private_key_usage_period, SN_proxyCertInfo, SN_pss, SN_qcStatements, SN_rc2_40_cbc, SN_rc2_64_cbc, SN_rc2_cbc, SN_rc2_cfb64, SN_rc2_ecb, SN_rc2_ofb64, SN_rc4, SN_rc4_40, SN_rc4_hmac_md5, SN_rc5_cbc, SN_rc5_cfb64, SN_rc5_ecb, SN_rc5_ofb64, SN_rfc822Mailbox, SN_ripemd160, SN_ripemd160WithRSA, SN_role, SN_room, SN_rpkiManifest, SN_rpkiNotify, SN_rsa, SN_rsaOAEPEncryptionSET, SN_rsaSignature, SN_rsadsi, SN_rsaesOaep, SN_rsassaPss, SN_sbgp_autonomousSysNum, SN_sbgp_autonomousSysNumv2, SN_sbgp_ipAddrBlock, SN_sbgp_ipAddrBlockv2, SN_sbgp_routerIdentifier, SN_secp112r1, SN_secp112r2, SN_secp128r1, SN_secp128r2, SN_secp160k1, SN_secp160r1, SN_secp160r2, SN_secp192k1, SN_secp224k1, SN_secp224r1, SN_secp256k1, SN_secp384r1, SN_secp521r1, SN_secretary, SN_sect113r1, SN_sect113r2, SN_sect131r1, SN_sect131r2, SN_sect163k1, SN_sect163r1, SN_sect163r2, SN_sect193r1, SN_sect193r2, SN_sect233k1, SN_sect233r1, SN_sect239k1, SN_sect283k1, SN_sect283r1, SN_sect409k1, SN_sect409r1, SN_sect571k1, SN_sect571r1, SN_seeAlso, SN_seed_cbc, SN_seed_cfb128, SN_seed_ecb, SN_seed_ofb128, SN_selected_attribute_types, SN_sendOwner, SN_sendProxiedOwner, SN_sendProxiedRouter, SN_sendRouter, SN_server_auth, SN_setAttr_Cert, SN_setAttr_GenCryptgrm, SN_setAttr_IssCap, SN_setAttr_IssCap_CVM, SN_setAttr_IssCap_Sig, SN_setAttr_IssCap_T2, SN_setAttr_PGWYcap, SN_setAttr_SecDevSig, SN_setAttr_T2Enc, SN_setAttr_T2cleartxt, SN_setAttr_TokICCsig, SN_setAttr_TokenType, SN_setAttr_Token_B0Prime, SN_setAttr_Token_EMV, SN_setCext_IssuerCapabilities, SN_setCext_PGWYcapabilities, SN_setCext_TokenIdentifier, SN_setCext_TokenType, SN_setCext_Track2Data, SN_setCext_cCertRequired, SN_setCext_certType, SN_setCext_hashedRoot, SN_setCext_merchData, SN_setCext_setExt, SN_setCext_setQualf, SN_setCext_tunneling, SN_set_addPolicy, SN_set_attr, SN_set_brand, SN_set_brand_AmericanExpress, SN_set_brand_Diners, SN_set_brand_IATA_ATA, SN_set_brand_JCB, SN_set_brand_MasterCard, SN_set_brand_Novus, SN_set_brand_Visa, SN_set_certExt, SN_set_ctype, SN_set_msgExt, SN_set_policy, SN_set_policy_root, SN_set_rootKeyThumb, SN_setct_AcqCardCodeMsg, SN_setct_AcqCardCodeMsgTBE, SN_setct_AuthReqTBE, SN_setct_AuthReqTBS, SN_setct_AuthResBaggage, SN_setct_AuthResTBE, SN_setct_AuthResTBEX, SN_setct_AuthResTBS, SN_setct_AuthResTBSX, SN_setct_AuthRevReqBaggage, SN_setct_AuthRevReqTBE, SN_setct_AuthRevReqTBS, SN_setct_AuthRevResBaggage, SN_setct_AuthRevResData, SN_setct_AuthRevResTBE, SN_setct_AuthRevResTBEB, SN_setct_AuthRevResTBS, SN_setct_AuthTokenTBE, SN_setct_AuthTokenTBS, SN_setct_BCIDistributionTBS, SN_setct_BatchAdminReqData, SN_setct_BatchAdminReqTBE, SN_setct_BatchAdminResData, SN_setct_BatchAdminResTBE, SN_setct_CRLNotificationResTBS, SN_setct_CRLNotificationTBS, SN_setct_CapReqTBE, SN_setct_CapReqTBEX, SN_setct_CapReqTBS, SN_setct_CapReqTBSX, SN_setct_CapResData, SN_setct_CapResTBE, SN_setct_CapRevReqTBE, SN_setct_CapRevReqTBEX, SN_setct_CapRevReqTBS, SN_setct_CapRevReqTBSX, SN_setct_CapRevResData, SN_setct_CapRevResTBE, SN_setct_CapTokenData, SN_setct_CapTokenSeq, SN_setct_CapTokenTBE, SN_setct_CapTokenTBEX, SN_setct_CapTokenTBS, SN_setct_CardCInitResTBS, SN_setct_CertInqReqTBS, SN_setct_CertReqData, SN_setct_CertReqTBE, SN_setct_CertReqTBEX, SN_setct_CertReqTBS, SN_setct_CertResData, SN_setct_CertResTBE, SN_setct_CredReqTBE, SN_setct_CredReqTBEX, SN_setct_CredReqTBS, SN_setct_CredReqTBSX, SN_setct_CredResData, SN_setct_CredResTBE, SN_setct_CredRevReqTBE, SN_setct_CredRevReqTBEX, SN_setct_CredRevReqTBS, SN_setct_CredRevReqTBSX, SN_setct_CredRevResData, SN_setct_CredRevResTBE, SN_setct_ErrorTBS, SN_setct_HODInput, SN_setct_MeAqCInitResTBS, SN_setct_OIData, SN_setct_PANData, SN_setct_PANOnly, SN_setct_PANToken, SN_setct_PCertReqData, SN_setct_PCertResTBS, SN_setct_PI, SN_setct_PIData, SN_setct_PIDataUnsigned, SN_setct_PIDualSignedTBE, SN_setct_PIUnsignedTBE, SN_setct_PI_TBS, SN_setct_PInitResData, SN_setct_PResData, SN_setct_RegFormReqTBE, SN_setct_RegFormResTBS, SN_setext_cv, SN_setext_genCrypt, SN_setext_miAuth, SN_setext_pinAny, SN_setext_pinSecure, SN_setext_track2, SN_sha, SN_sha1, SN_sha1WithRSA, SN_sha1WithRSAEncryption, SN_sha224, SN_sha224WithRSAEncryption, SN_sha256, SN_sha256WithRSAEncryption, SN_sha384, SN_sha384WithRSAEncryption, SN_sha3_224, SN_sha3_256, SN_sha3_384, SN_sha3_512, SN_sha512, SN_sha512WithRSAEncryption, SN_sha512_224, SN_sha512_256, SN_shaWithRSAEncryption, SN_shake128, SN_shake256, SN_signedObject, SN_sinfo_access, SN_siphash, SN_sm2, SN_sm3, SN_sm3WithRSAEncryption, SN_sm4_cbc, SN_sm4_cfb1, SN_sm4_cfb128, SN_sm4_cfb8, SN_sm4_ctr, SN_sm4_ecb, SN_sm4_ofb128, SN_sm_scheme, SN_sshClient, SN_sshServer, SN_sshkdf, SN_sskdf, SN_stateOrProvinceName, SN_streetAddress, SN_subjectSignTool, SN_subject_alt_name, SN_subject_directory_attributes, SN_subject_key_identifier, SN_surname, SN_sxnet, SN_target_information, SN_textNotice, SN_time_stamp, SN_title, SN_tls1_prf, SN_tlsfeature, SN_ua_pki, SN_uacurve0, SN_uacurve1, SN_uacurve2, SN_uacurve3, SN_uacurve4, SN_uacurve5, SN_uacurve6, SN_uacurve7, SN_uacurve8, SN_uacurve9, SN_ucl, SN_undef, SN_uniqueIdentifier, SN_userId, SN_wap, SN_wap_wsg, SN_wap_wsg_idm_ecid_wtls1, SN_wap_wsg_idm_ecid_wtls10, SN_wap_wsg_idm_ecid_wtls11, SN_wap_wsg_idm_ecid_wtls12, SN_wap_wsg_idm_ecid_wtls3, SN_wap_wsg_idm_ecid_wtls4, SN_wap_wsg_idm_ecid_wtls5, SN_wap_wsg_idm_ecid_wtls6, SN_wap_wsg_idm_ecid_wtls7, SN_wap_wsg_idm_ecid_wtls8, SN_wap_wsg_idm_ecid_wtls9, SN_whirlpool, SN_x509ExtAdmission, SN_x942kdf, SN_x963kdf, SN_zlib_compression, SRTP_AEAD_AES_128_GCM, SRTP_AEAD_AES_256_GCM, SRTP_AES128_CM_SHA1_32, SRTP_AES128_CM_SHA1_80, SRTP_AES128_F8_SHA1_32, SRTP_AES128_F8_SHA1_80, SRTP_NULL_SHA1_32, SRTP_NULL_SHA1_80, SSL2_MT_CLIENT_HELLO, SSL2_VERSION, SSL3_AD_BAD_CERTIFICATE, SSL3_AD_CERTIFICATE_EXPIRED, SSL3_AD_CERTIFICATE_REVOKED, SSL3_AD_CERTIFICATE_UNKNOWN, SSL3_AD_CLOSE_NOTIFY, SSL3_AD_NO_CERTIFICATE, SSL3_AD_UNSUPPORTED_CERTIFICATE, SSL3_AL_FATAL, SSL3_AL_WARNING, SSL3_CC_APPLICATION, SSL3_CC_CLIENT, SSL3_CC_EARLY, SSL3_CC_HANDSHAKE, SSL3_CC_READ, SSL3_CC_SERVER, SSL3_CC_WRITE, SSL3_CK_ADH_DES_192_CBC_SHA, SSL3_CK_ADH_DES_40_CBC_SHA, SSL3_CK_ADH_DES_64_CBC_SHA, SSL3_CK_ADH_RC4_128_MD5, SSL3_CK_ADH_RC4_40_MD5, SSL3_CK_DHE_DSS_DES_192_CBC3_SHA, SSL3_CK_DHE_DSS_DES_40_CBC_SHA, SSL3_CK_DHE_DSS_DES_64_CBC_SHA, SSL3_CK_DHE_RSA_DES_192_CBC3_SHA, SSL3_CK_DHE_RSA_DES_40_CBC_SHA, SSL3_CK_DHE_RSA_DES_64_CBC_SHA, SSL3_CK_DH_DSS_DES_192_CBC3_SHA, SSL3_CK_DH_DSS_DES_40_CBC_SHA, SSL3_CK_DH_DSS_DES_64_CBC_SHA, SSL3_CK_DH_RSA_DES_192_CBC3_SHA, SSL3_CK_DH_RSA_DES_40_CBC_SHA, SSL3_CK_DH_RSA_DES_64_CBC_SHA, SSL3_CK_EDH_DSS_DES_192_CBC3_SHA, SSL3_CK_EDH_DSS_DES_40_CBC_SHA, SSL3_CK_EDH_DSS_DES_64_CBC_SHA, SSL3_CK_EDH_RSA_DES_192_CBC3_SHA, SSL3_CK_EDH_RSA_DES_40_CBC_SHA, SSL3_CK_EDH_RSA_DES_64_CBC_SHA, SSL3_CK_FALLBACK_SCSV, SSL3_CK_RSA_DES_192_CBC3_SHA, SSL3_CK_RSA_DES_40_CBC_SHA, SSL3_CK_RSA_DES_64_CBC_SHA, SSL3_CK_RSA_IDEA_128_SHA, SSL3_CK_RSA_NULL_MD5, SSL3_CK_RSA_NULL_SHA, SSL3_CK_RSA_RC2_40_MD5, SSL3_CK_RSA_RC4_128_MD5, SSL3_CK_RSA_RC4_128_SHA, SSL3_CK_RSA_RC4_40_MD5, SSL3_CK_SCSV, SSL3_CT_DSS_EPHEMERAL_DH, SSL3_CT_DSS_FIXED_DH, SSL3_CT_DSS_SIGN, SSL3_CT_FORTEZZA_DMS, SSL3_CT_NUMBER, SSL3_CT_RSA_EPHEMERAL_DH, SSL3_CT_RSA_FIXED_DH, SSL3_CT_RSA_SIGN, SSL3_FLAGS_NO_RENEGOTIATE_CIPHERS, SSL3_HM_HEADER_LENGTH, SSL3_MASTER_SECRET_SIZE, SSL3_MAX_SSL_SESSION_ID_LENGTH, SSL3_MT_CCS, SSL3_MT_CERTIFICATE, SSL3_MT_CERTIFICATE_REQUEST, SSL3_MT_CERTIFICATE_STATUS, SSL3_MT_CERTIFICATE_URL, SSL3_MT_CERTIFICATE_VERIFY, SSL3_MT_CHANGE_CIPHER_SPEC, SSL3_MT_CLIENT_HELLO, SSL3_MT_CLIENT_KEY_EXCHANGE, SSL3_MT_ENCRYPTED_EXTENSIONS, SSL3_MT_END_OF_EARLY_DATA, SSL3_MT_FINISHED, SSL3_MT_HELLO_REQUEST, SSL3_MT_KEY_UPDATE, SSL3_MT_MESSAGE_HASH, SSL3_MT_NEWSESSION_TICKET, SSL3_MT_SERVER_DONE, SSL3_MT_SERVER_HELLO, SSL3_MT_SERVER_KEY_EXCHANGE, SSL3_MT_SUPPLEMENTAL_DATA, SSL3_RANDOM_SIZE, SSL3_RFC_ADH_DES_192_CBC_SHA, SSL3_RFC_ADH_RC4_128_MD5, SSL3_RFC_DHE_DSS_DES_192_CBC3_SHA, SSL3_RFC_DHE_RSA_DES_192_CBC3_SHA, SSL3_RFC_RSA_DES_192_CBC3_SHA, SSL3_RFC_RSA_IDEA_128_SHA, SSL3_RFC_RSA_NULL_MD5, SSL3_RFC_RSA_NULL_SHA, SSL3_RFC_RSA_RC4_128_MD5, SSL3_RFC_RSA_RC4_128_SHA, SSL3_RT_ALERT, SSL3_RT_APPLICATION_DATA, SSL3_RT_CHANGE_CIPHER_SPEC, SSL3_RT_HANDSHAKE, SSL3_RT_HEADER, SSL3_RT_HEADER_LENGTH, SSL3_RT_INNER_CONTENT_TYPE, SSL3_RT_MAX_COMPRESSED_OVERHEAD, SSL3_RT_MAX_MD_SIZE, SSL3_RT_MAX_PLAIN_LENGTH, SSL3_RT_MAX_TLS13_ENCRYPTED_OVERHEAD, SSL3_SESSION_ID_SIZE, SSL3_SSL_SESSION_ID_LENGTH, SSL3_TXT_ADH_DES_192_CBC_SHA, SSL3_TXT_ADH_DES_40_CBC_SHA, SSL3_TXT_ADH_DES_64_CBC_SHA, SSL3_TXT_ADH_RC4_128_MD5, SSL3_TXT_ADH_RC4_40_MD5, SSL3_TXT_DHE_DSS_DES_192_CBC3_SHA, SSL3_TXT_DHE_DSS_DES_40_CBC_SHA, SSL3_TXT_DHE_DSS_DES_64_CBC_SHA, SSL3_TXT_DHE_RSA_DES_192_CBC3_SHA, SSL3_TXT_DHE_RSA_DES_40_CBC_SHA, SSL3_TXT_DHE_RSA_DES_64_CBC_SHA, SSL3_TXT_DH_DSS_DES_192_CBC3_SHA, SSL3_TXT_DH_DSS_DES_40_CBC_SHA, SSL3_TXT_DH_DSS_DES_64_CBC_SHA, SSL3_TXT_DH_RSA_DES_192_CBC3_SHA, SSL3_TXT_DH_RSA_DES_40_CBC_SHA, SSL3_TXT_DH_RSA_DES_64_CBC_SHA, SSL3_TXT_EDH_DSS_DES_192_CBC3_SHA, SSL3_TXT_EDH_DSS_DES_40_CBC_SHA, SSL3_TXT_EDH_DSS_DES_64_CBC_SHA, SSL3_TXT_EDH_RSA_DES_192_CBC3_SHA, SSL3_TXT_EDH_RSA_DES_40_CBC_SHA, SSL3_TXT_EDH_RSA_DES_64_CBC_SHA, SSL3_TXT_RSA_DES_192_CBC3_SHA, SSL3_TXT_RSA_DES_40_CBC_SHA, SSL3_TXT_RSA_DES_64_CBC_SHA, SSL3_TXT_RSA_IDEA_128_SHA, SSL3_TXT_RSA_NULL_MD5, SSL3_TXT_RSA_NULL_SHA, SSL3_TXT_RSA_RC2_40_MD5, SSL3_TXT_RSA_RC4_128_MD5, SSL3_TXT_RSA_RC4_128_SHA, SSL3_TXT_RSA_RC4_40_MD5, SSL3_VERSION, SSL3_VERSION_MAJOR, SSL3_VERSION_MINOR, SSL_MAX_MASTER_KEY_LENGTH, SSL_RT_MAX_CIPHER_BLOCK_SIZE, SSL_R_APPLICATION_DATA_AFTER_CLOSE_NOTIFY, SSL_R_APP_DATA_IN_HANDSHAKE, SSL_R_ATTEMPT_TO_REUSE_SESSION_IN_DIFFERENT_CONTEXT, SSL_R_AT_LEAST_TLS_1_2_NEEDED_IN_SUITEB_MODE, SSL_R_BAD_CHANGE_CIPHER_SPEC, SSL_R_BAD_CIPHER, SSL_R_BAD_DATA, SSL_R_BAD_DATA_RETURNED_BY_CALLBACK, SSL_R_BAD_DECOMPRESSION, SSL_R_BAD_DH_VALUE, SSL_R_BAD_DIGEST_LENGTH, SSL_R_BAD_EARLY_DATA, SSL_R_BAD_ECC_CERT, SSL_R_BAD_ECPOINT, SSL_R_BAD_EXTENSION, SSL_R_BAD_HANDSHAKE_LENGTH, SSL_R_BAD_HANDSHAKE_STATE, SSL_R_BAD_HELLO_REQUEST, SSL_R_BAD_HRR_VERSION, SSL_R_BAD_KEY_SHARE, SSL_R_BAD_KEY_UPDATE, SSL_R_BAD_LEGACY_VERSION, SSL_R_BAD_LENGTH, SSL_R_BAD_PACKET, SSL_R_BAD_PACKET_LENGTH, SSL_R_BAD_PROTOCOL_VERSION_NUMBER, SSL_R_BAD_PSK, SSL_R_BAD_PSK_IDENTITY, SSL_R_BAD_RECORD_TYPE, SSL_R_BAD_RSA_ENCRYPT, SSL_R_BAD_SIGNATURE, SSL_R_BAD_SRP_A_LENGTH, SSL_R_BAD_SRP_PARAMETERS, SSL_R_BAD_SRTP_MKI_VALUE, SSL_R_BAD_SRTP_PROTECTION_PROFILE_LIST, SSL_R_BAD_SSL_FILETYPE, SSL_R_BAD_VALUE, SSL_R_BAD_WRITE_RETRY, SSL_R_BINDER_DOES_NOT_VERIFY, SSL_R_BIO_NOT_SET, SSL_R_BLOCK_CIPHER_PAD_IS_WRONG, SSL_R_BN_LIB, SSL_R_CALLBACK_FAILED, SSL_R_CANNOT_CHANGE_CIPHER, SSL_R_CANNOT_GET_GROUP_NAME, SSL_R_CA_DN_LENGTH_MISMATCH, SSL_R_CA_KEY_TOO_SMALL, SSL_R_CA_MD_TOO_WEAK, SSL_R_CCS_RECEIVED_EARLY, SSL_R_CERTIFICATE_VERIFY_FAILED, SSL_R_CERT_CB_ERROR, SSL_R_CERT_LENGTH_MISMATCH, SSL_R_CIPHERSUITE_DIGEST_HAS_CHANGED, SSL_R_CIPHER_CODE_WRONG_LENGTH, SSL_R_CLIENTHELLO_TLSEXT, SSL_R_COMPRESSED_LENGTH_TOO_LONG, SSL_R_COMPRESSION_DISABLED, SSL_R_COMPRESSION_FAILURE, SSL_R_COMPRESSION_ID_NOT_WITHIN_PRIVATE_RANGE, SSL_R_COMPRESSION_LIBRARY_ERROR, SSL_R_CONNECTION_TYPE_NOT_SET, SSL_R_CONTEXT_NOT_DANE_ENABLED, SSL_R_COOKIE_GEN_CALLBACK_FAILURE, SSL_R_COOKIE_MISMATCH, SSL_R_COPY_PARAMETERS_FAILED, SSL_R_CUSTOM_EXT_HANDLER_ALREADY_INSTALLED, SSL_R_DANE_ALREADY_ENABLED, SSL_R_DANE_CANNOT_OVERRIDE_MTYPE_FULL, SSL_R_DANE_NOT_ENABLED, SSL_R_DANE_TLSA_BAD_CERTIFICATE, SSL_R_DANE_TLSA_BAD_CERTIFICATE_USAGE, SSL_R_DANE_TLSA_BAD_DATA_LENGTH, SSL_R_DANE_TLSA_BAD_DIGEST_LENGTH, SSL_R_DANE_TLSA_BAD_MATCHING_TYPE, SSL_R_DANE_TLSA_BAD_PUBLIC_KEY, SSL_R_DANE_TLSA_BAD_SELECTOR, SSL_R_DANE_TLSA_NULL_DATA, SSL_R_DATA_BETWEEN_CCS_AND_FINISHED, SSL_R_DATA_LENGTH_TOO_LONG, SSL_R_DECRYPTION_FAILED, SSL_R_DECRYPTION_FAILED_OR_BAD_RECORD_MAC, SSL_R_DH_KEY_TOO_SMALL, SSL_R_DH_PUBLIC_VALUE_LENGTH_IS_WRONG, SSL_R_DIGEST_CHECK_FAILED, SSL_R_DTLS_MESSAGE_TOO_BIG, SSL_R_DUPLICATE_COMPRESSION_ID, SSL_R_ECC_CERT_NOT_FOR_SIGNING, SSL_R_ECDH_REQUIRED_FOR_SUITEB_MODE, SSL_R_EE_KEY_TOO_SMALL, SSL_R_EMPTY_SRTP_PROTECTION_PROFILE_LIST, SSL_R_ENCRYPTED_LENGTH_TOO_LONG, SSL_R_ERROR_IN_RECEIVED_CIPHER_LIST, SSL_R_ERROR_SETTING_TLSA_BASE_DOMAIN, SSL_R_EXCEEDS_MAX_FRAGMENT_SIZE, SSL_R_EXCESSIVE_MESSAGE_SIZE, SSL_R_EXTENSION_NOT_RECEIVED, SSL_R_EXTRA_DATA_IN_MESSAGE, SSL_R_EXT_LENGTH_MISMATCH, SSL_R_FAILED_TO_INIT_ASYNC, SSL_R_FRAGMENTED_CLIENT_HELLO, SSL_R_GOT_A_FIN_BEFORE_A_CCS, SSL_R_HTTPS_PROXY_REQUEST, SSL_R_HTTP_REQUEST, SSL_R_ILLEGAL_POINT_COMPRESSION, SSL_R_ILLEGAL_SUITEB_DIGEST, SSL_R_INAPPROPRIATE_FALLBACK, SSL_R_INCONSISTENT_COMPRESSION, SSL_R_INCONSISTENT_EARLY_DATA_ALPN, SSL_R_INCONSISTENT_EARLY_DATA_SNI, SSL_R_INCONSISTENT_EXTMS, SSL_R_INSUFFICIENT_SECURITY, SSL_R_INVALID_ALERT, SSL_R_INVALID_CCS_MESSAGE, SSL_R_INVALID_CERTIFICATE_OR_ALG, SSL_R_INVALID_COMMAND, SSL_R_INVALID_COMPRESSION_ALGORITHM, SSL_R_INVALID_CONFIG, SSL_R_INVALID_CONFIGURATION_NAME, SSL_R_INVALID_CONTEXT, SSL_R_INVALID_CT_VALIDATION_TYPE, SSL_R_INVALID_KEY_UPDATE_TYPE, SSL_R_INVALID_MAX_EARLY_DATA, SSL_R_INVALID_NULL_CMD_NAME, SSL_R_INVALID_SEQUENCE_NUMBER, SSL_R_INVALID_SERVERINFO_DATA, SSL_R_INVALID_SESSION_ID, SSL_R_INVALID_SRP_USERNAME, SSL_R_INVALID_STATUS_RESPONSE, SSL_R_INVALID_TICKET_KEYS_LENGTH, SSL_R_LENGTH_MISMATCH, SSL_R_LENGTH_TOO_LONG, SSL_R_LENGTH_TOO_SHORT, SSL_R_LIBRARY_BUG, SSL_R_LIBRARY_HAS_NO_CIPHERS, SSL_R_MISSING_DSA_SIGNING_CERT, SSL_R_MISSING_ECDSA_SIGNING_CERT, SSL_R_MISSING_FATAL, SSL_R_MISSING_PARAMETERS, SSL_R_MISSING_PSK_KEX_MODES_EXTENSION, SSL_R_MISSING_RSA_CERTIFICATE, SSL_R_MISSING_RSA_ENCRYPTING_CERT, SSL_R_MISSING_RSA_SIGNING_CERT, SSL_R_MISSING_SIGALGS_EXTENSION, SSL_R_MISSING_SIGNING_CERT, SSL_R_MISSING_SRP_PARAM, SSL_R_MISSING_SUPPORTED_GROUPS_EXTENSION, SSL_R_MISSING_TMP_DH_KEY, SSL_R_MISSING_TMP_ECDH_KEY, SSL_R_MIXED_HANDSHAKE_AND_NON_HANDSHAKE_DATA, SSL_R_NOT_ON_RECORD_BOUNDARY, SSL_R_NOT_REPLACING_CERTIFICATE, SSL_R_NOT_SERVER, SSL_R_NO_APPLICATION_PROTOCOL, SSL_R_NO_CERTIFICATES_RETURNED, SSL_R_NO_CERTIFICATE_ASSIGNED, SSL_R_NO_CERTIFICATE_SET, SSL_R_NO_CHANGE_FOLLOWING_HRR, SSL_R_NO_CIPHERS_AVAILABLE, SSL_R_NO_CIPHERS_SPECIFIED, SSL_R_NO_CIPHER_MATCH, SSL_R_NO_CLIENT_CERT_METHOD, SSL_R_NO_COMPRESSION_SPECIFIED, SSL_R_NO_COOKIE_CALLBACK_SET, SSL_R_NO_GOST_CERTIFICATE_SENT_BY_PEER, SSL_R_NO_METHOD_SPECIFIED, SSL_R_NO_PEM_EXTENSIONS, SSL_R_NO_PRIVATE_KEY_ASSIGNED, SSL_R_NO_PROTOCOLS_AVAILABLE, SSL_R_NO_RENEGOTIATION, SSL_R_NO_REQUIRED_DIGEST, SSL_R_NO_SHARED_CIPHER, SSL_R_NO_SHARED_GROUPS, SSL_R_NO_SHARED_SIGNATURE_ALGORITHMS, SSL_R_NO_SRTP_PROFILES, SSL_R_NO_SUITABLE_DIGEST_ALGORITHM, SSL_R_NO_SUITABLE_GROUPS, SSL_R_NO_SUITABLE_KEY_SHARE, SSL_R_NO_SUITABLE_SIGNATURE_ALGORITHM, SSL_R_NO_VALID_SCTS, SSL_R_NO_VERIFY_COOKIE_CALLBACK, SSL_R_NULL_SSL_CTX, SSL_R_NULL_SSL_METHOD_PASSED, SSL_R_OCSP_CALLBACK_FAILURE, SSL_R_OLD_SESSION_CIPHER_NOT_RETURNED, SSL_R_OLD_SESSION_COMPRESSION_ALGORITHM_NOT_RETURNED, SSL_R_OVERFLOW_ERROR, SSL_R_PACKET_LENGTH_TOO_LONG, SSL_R_PARSE_TLSEXT, SSL_R_PATH_TOO_LONG, SSL_R_PEER_DID_NOT_RETURN_A_CERTIFICATE, SSL_R_PEM_NAME_BAD_PREFIX, SSL_R_PEM_NAME_TOO_SHORT, SSL_R_PIPELINE_FAILURE, SSL_R_POST_HANDSHAKE_AUTH_ENCODING_ERR, SSL_R_PRIVATE_KEY_MISMATCH, SSL_R_PROTOCOL_IS_SHUTDOWN, SSL_R_PSK_IDENTITY_NOT_FOUND, SSL_R_PSK_NO_CLIENT_CB, SSL_R_PSK_NO_SERVER_CB, SSL_R_READ_BIO_NOT_SET, SSL_R_READ_TIMEOUT_EXPIRED, SSL_R_RECORD_LENGTH_MISMATCH, SSL_R_RECORD_TOO_SMALL, SSL_R_RENEGOTIATE_EXT_TOO_LONG, SSL_R_RENEGOTIATION_ENCODING_ERR, SSL_R_RENEGOTIATION_MISMATCH, SSL_R_REQUEST_PENDING, SSL_R_REQUEST_SENT, SSL_R_REQUIRED_CIPHER_MISSING, SSL_R_REQUIRED_COMPRESSION_ALGORITHM_MISSING, SSL_R_SCSV_RECEIVED_WHEN_RENEGOTIATING, SSL_R_SCT_VERIFICATION_FAILED, SSL_R_SERVERHELLO_TLSEXT, SSL_R_SESSION_ID_CONTEXT_UNINITIALIZED, SSL_R_SHUTDOWN_WHILE_IN_INIT, SSL_R_SIGNATURE_ALGORITHMS_ERROR, SSL_R_SIGNATURE_FOR_NON_SIGNING_CERTIFICATE, SSL_R_SRP_A_CALC, SSL_R_SRTP_COULD_NOT_ALLOCATE_PROFILES, SSL_R_SRTP_PROTECTION_PROFILE_LIST_TOO_LONG, SSL_R_SRTP_UNKNOWN_PROTECTION_PROFILE, SSL_R_SSL3_EXT_INVALID_MAX_FRAGMENT_LENGTH, SSL_R_SSL3_EXT_INVALID_SERVERNAME, SSL_R_SSL3_EXT_INVALID_SERVERNAME_TYPE, SSL_R_SSL3_SESSION_ID_TOO_LONG, SSL_R_SSLV3_ALERT_BAD_CERTIFICATE, SSL_R_SSLV3_ALERT_BAD_RECORD_MAC, SSL_R_SSLV3_ALERT_CERTIFICATE_EXPIRED, SSL_R_SSLV3_ALERT_CERTIFICATE_REVOKED, SSL_R_SSLV3_ALERT_CERTIFICATE_UNKNOWN, SSL_R_SSLV3_ALERT_DECOMPRESSION_FAILURE, SSL_R_SSLV3_ALERT_HANDSHAKE_FAILURE, SSL_R_SSLV3_ALERT_ILLEGAL_PARAMETER, SSL_R_SSLV3_ALERT_NO_CERTIFICATE, SSL_R_SSLV3_ALERT_UNEXPECTED_MESSAGE, SSL_R_SSLV3_ALERT_UNSUPPORTED_CERTIFICATE, SSL_R_SSL_COMMAND_SECTION_EMPTY, SSL_R_SSL_COMMAND_SECTION_NOT_FOUND, SSL_R_SSL_CTX_HAS_NO_DEFAULT_SSL_VERSION, SSL_R_SSL_HANDSHAKE_FAILURE, SSL_R_SSL_LIBRARY_HAS_NO_CIPHERS, SSL_R_SSL_NEGATIVE_LENGTH, SSL_R_SSL_SECTION_EMPTY, SSL_R_SSL_SECTION_NOT_FOUND, SSL_R_SSL_SESSION_ID_CALLBACK_FAILED, SSL_R_SSL_SESSION_ID_CONFLICT, SSL_R_SSL_SESSION_ID_CONTEXT_TOO_LONG, SSL_R_SSL_SESSION_ID_HAS_BAD_LENGTH, SSL_R_SSL_SESSION_ID_TOO_LONG, SSL_R_SSL_SESSION_VERSION_MISMATCH, SSL_R_STILL_IN_INIT, SSL_R_TLSV13_ALERT_CERTIFICATE_REQUIRED, SSL_R_TLSV13_ALERT_MISSING_EXTENSION, SSL_R_TLSV1_ALERT_ACCESS_DENIED, SSL_R_TLSV1_ALERT_DECODE_ERROR, SSL_R_TLSV1_ALERT_DECRYPTION_FAILED, SSL_R_TLSV1_ALERT_DECRYPT_ERROR, SSL_R_TLSV1_ALERT_EXPORT_RESTRICTION, SSL_R_TLSV1_ALERT_INAPPROPRIATE_FALLBACK, SSL_R_TLSV1_ALERT_INSUFFICIENT_SECURITY, SSL_R_TLSV1_ALERT_INTERNAL_ERROR, SSL_R_TLSV1_ALERT_NO_RENEGOTIATION, SSL_R_TLSV1_ALERT_PROTOCOL_VERSION, SSL_R_TLSV1_ALERT_RECORD_OVERFLOW, SSL_R_TLSV1_ALERT_UNKNOWN_CA, SSL_R_TLSV1_ALERT_USER_CANCELLED, SSL_R_TLSV1_BAD_CERTIFICATE_HASH_VALUE, SSL_R_TLSV1_BAD_CERTIFICATE_STATUS_RESPONSE, SSL_R_TLSV1_CERTIFICATE_UNOBTAINABLE, SSL_R_TLSV1_UNRECOGNIZED_NAME, SSL_R_TLSV1_UNSUPPORTED_EXTENSION, SSL_R_TLS_ILLEGAL_EXPORTER_LABEL, SSL_R_TLS_INVALID_ECPOINTFORMAT_LIST, SSL_R_TOO_MANY_KEY_UPDATES, SSL_R_TOO_MANY_WARN_ALERTS, SSL_R_TOO_MUCH_EARLY_DATA, SSL_R_UNABLE_TO_FIND_ECDH_PARAMETERS, SSL_R_UNABLE_TO_FIND_PUBLIC_KEY_PARAMETERS, SSL_R_UNABLE_TO_LOAD_SSL3_MD5_ROUTINES, SSL_R_UNABLE_TO_LOAD_SSL3_SHA1_ROUTINES, SSL_R_UNEXPECTED_CCS_MESSAGE, SSL_R_UNEXPECTED_END_OF_EARLY_DATA, SSL_R_UNEXPECTED_EOF_WHILE_READING, SSL_R_UNEXPECTED_MESSAGE, SSL_R_UNEXPECTED_RECORD, SSL_R_UNINITIALIZED, SSL_R_UNKNOWN_ALERT_TYPE, SSL_R_UNKNOWN_CERTIFICATE_TYPE, SSL_R_UNKNOWN_CIPHER_RETURNED, SSL_R_UNKNOWN_CIPHER_TYPE, SSL_R_UNKNOWN_CMD_NAME, SSL_R_UNKNOWN_COMMAND, SSL_R_UNKNOWN_DIGEST, SSL_R_UNKNOWN_KEY_EXCHANGE_TYPE, SSL_R_UNKNOWN_PKEY_TYPE, SSL_R_UNKNOWN_PROTOCOL, SSL_R_UNKNOWN_SSL_VERSION, SSL_R_UNKNOWN_STATE, SSL_R_UNSAFE_LEGACY_RENEGOTIATION_DISABLED, SSL_R_UNSOLICITED_EXTENSION, SSL_R_UNSUPPORTED_COMPRESSION_ALGORITHM, SSL_R_UNSUPPORTED_ELLIPTIC_CURVE, SSL_R_UNSUPPORTED_PROTOCOL, SSL_R_UNSUPPORTED_SSL_VERSION, SSL_R_UNSUPPORTED_STATUS_TYPE, SSL_R_USE_SRTP_NOT_NEGOTIATED, SSL_R_VERSION_TOO_HIGH, SSL_R_VERSION_TOO_LOW, SSL_R_WRONG_CERTIFICATE_TYPE, SSL_R_WRONG_CIPHER_RETURNED, SSL_R_WRONG_CURVE, SSL_R_WRONG_SIGNATURE_LENGTH, SSL_R_WRONG_SIGNATURE_SIZE, SSL_R_WRONG_SIGNATURE_TYPE, SSL_R_WRONG_SSL_VERSION, SSL_R_WRONG_VERSION_NUMBER, SSL_R_X509_LIB, SSL_R_X509_VERIFICATION_SETUP_PROBLEMS, SSL_TLSEXT_ERR_ALERT_FATAL, SSL_TLSEXT_ERR_ALERT_WARNING, SSL_TLSEXT_ERR_NOACK, SSL_TLSEXT_ERR_OK, TLS13_AD_CERTIFICATE_REQUIRED, TLS13_AD_MISSING_EXTENSION, TLS1_1_VERSION, TLS1_1_VERSION_MAJOR, TLS1_1_VERSION_MINOR, TLS1_2_VERSION, TLS1_2_VERSION_MAJOR, TLS1_2_VERSION_MINOR, TLS1_3_CK_AES_128_CCM_8_SHA256, TLS1_3_CK_AES_128_CCM_SHA256, TLS1_3_CK_AES_128_GCM_SHA256, TLS1_3_CK_AES_256_GCM_SHA384, TLS1_3_CK_CHACHA20_POLY1305_SHA256, TLS1_3_RFC_AES_128_CCM_8_SHA256, TLS1_3_RFC_AES_128_CCM_SHA256, TLS1_3_RFC_AES_128_GCM_SHA256, TLS1_3_RFC_AES_256_GCM_SHA384, TLS1_3_RFC_CHACHA20_POLY1305_SHA256, TLS1_3_VERSION, TLS1_AD_BAD_CERTIFICATE_HASH_VALUE, TLS1_AD_BAD_CERTIFICATE_STATUS_RESPONSE, TLS1_AD_CERTIFICATE_UNOBTAINABLE, TLS1_AD_DECRYPTION_FAILED, TLS1_AD_DECRYPT_ERROR, TLS1_AD_NO_APPLICATION_PROTOCOL, TLS1_AD_NO_RENEGOTIATION, TLS1_AD_RECORD_OVERFLOW, TLS1_AD_UNRECOGNIZED_NAME, TLS1_AD_UNSUPPORTED_EXTENSION, TLS1_AD_USER_CANCELLED, TLS1_CK_ADH_WITH_AES_128_GCM_SHA256, TLS1_CK_ADH_WITH_AES_128_SHA, TLS1_CK_ADH_WITH_AES_128_SHA256, TLS1_CK_ADH_WITH_AES_256_GCM_SHA384, TLS1_CK_ADH_WITH_AES_256_SHA, TLS1_CK_ADH_WITH_AES_256_SHA256, TLS1_CK_ADH_WITH_CAMELLIA_128_CBC_SHA, TLS1_CK_ADH_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_ADH_WITH_CAMELLIA_256_CBC_SHA, TLS1_CK_ADH_WITH_CAMELLIA_256_CBC_SHA256, TLS1_CK_ADH_WITH_SEED_SHA, TLS1_CK_DHE_DSS_WITH_AES_128_GCM_SHA256, TLS1_CK_DHE_DSS_WITH_AES_128_SHA, TLS1_CK_DHE_DSS_WITH_AES_128_SHA256, TLS1_CK_DHE_DSS_WITH_AES_256_GCM_SHA384, TLS1_CK_DHE_DSS_WITH_AES_256_SHA, TLS1_CK_DHE_DSS_WITH_AES_256_SHA256, TLS1_CK_DHE_DSS_WITH_ARIA_128_GCM_SHA256, TLS1_CK_DHE_DSS_WITH_ARIA_256_GCM_SHA384, TLS1_CK_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA, TLS1_CK_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA, TLS1_CK_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA256, TLS1_CK_DHE_DSS_WITH_SEED_SHA, TLS1_CK_DHE_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_CK_DHE_PSK_WITH_AES_128_CBC_SHA, TLS1_CK_DHE_PSK_WITH_AES_128_CBC_SHA256, TLS1_CK_DHE_PSK_WITH_AES_128_CCM, TLS1_CK_DHE_PSK_WITH_AES_128_CCM_8, TLS1_CK_DHE_PSK_WITH_AES_128_GCM_SHA256, TLS1_CK_DHE_PSK_WITH_AES_256_CBC_SHA, TLS1_CK_DHE_PSK_WITH_AES_256_CBC_SHA384, TLS1_CK_DHE_PSK_WITH_AES_256_CCM, TLS1_CK_DHE_PSK_WITH_AES_256_CCM_8, TLS1_CK_DHE_PSK_WITH_AES_256_GCM_SHA384, TLS1_CK_DHE_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_CK_DHE_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_CK_DHE_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_DHE_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_DHE_PSK_WITH_CHACHA20_POLY1305, TLS1_CK_DHE_PSK_WITH_NULL_SHA, TLS1_CK_DHE_PSK_WITH_NULL_SHA256, TLS1_CK_DHE_PSK_WITH_NULL_SHA384, TLS1_CK_DHE_PSK_WITH_RC4_128_SHA, TLS1_CK_DHE_RSA_WITH_AES_128_CCM, TLS1_CK_DHE_RSA_WITH_AES_128_CCM_8, TLS1_CK_DHE_RSA_WITH_AES_128_GCM_SHA256, TLS1_CK_DHE_RSA_WITH_AES_128_SHA, TLS1_CK_DHE_RSA_WITH_AES_128_SHA256, TLS1_CK_DHE_RSA_WITH_AES_256_CCM, TLS1_CK_DHE_RSA_WITH_AES_256_CCM_8, TLS1_CK_DHE_RSA_WITH_AES_256_GCM_SHA384, TLS1_CK_DHE_RSA_WITH_AES_256_SHA, TLS1_CK_DHE_RSA_WITH_AES_256_SHA256, TLS1_CK_DHE_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_CK_DHE_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_CK_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_CK_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_CK_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_CK_DHE_RSA_WITH_CHACHA20_POLY1305, TLS1_CK_DHE_RSA_WITH_SEED_SHA, TLS1_CK_DH_DSS_WITH_AES_128_GCM_SHA256, TLS1_CK_DH_DSS_WITH_AES_128_SHA, TLS1_CK_DH_DSS_WITH_AES_128_SHA256, TLS1_CK_DH_DSS_WITH_AES_256_GCM_SHA384, TLS1_CK_DH_DSS_WITH_AES_256_SHA, TLS1_CK_DH_DSS_WITH_AES_256_SHA256, TLS1_CK_DH_DSS_WITH_ARIA_128_GCM_SHA256, TLS1_CK_DH_DSS_WITH_ARIA_256_GCM_SHA384, TLS1_CK_DH_DSS_WITH_CAMELLIA_128_CBC_SHA, TLS1_CK_DH_DSS_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_DH_DSS_WITH_CAMELLIA_256_CBC_SHA, TLS1_CK_DH_DSS_WITH_CAMELLIA_256_CBC_SHA256, TLS1_CK_DH_DSS_WITH_SEED_SHA, TLS1_CK_DH_RSA_WITH_AES_128_GCM_SHA256, TLS1_CK_DH_RSA_WITH_AES_128_SHA, TLS1_CK_DH_RSA_WITH_AES_128_SHA256, TLS1_CK_DH_RSA_WITH_AES_256_GCM_SHA384, TLS1_CK_DH_RSA_WITH_AES_256_SHA, TLS1_CK_DH_RSA_WITH_AES_256_SHA256, TLS1_CK_DH_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_CK_DH_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_CK_DH_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_CK_DH_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_DH_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_CK_DH_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_CK_DH_RSA_WITH_SEED_SHA, TLS1_CK_DH_anon_WITH_ARIA_128_GCM_SHA256, TLS1_CK_DH_anon_WITH_ARIA_256_GCM_SHA384, TLS1_CK_ECDHE_ECDSA_WITH_AES_128_CBC_SHA, TLS1_CK_ECDHE_ECDSA_WITH_AES_128_CCM, TLS1_CK_ECDHE_ECDSA_WITH_AES_128_CCM_8, TLS1_CK_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256, TLS1_CK_ECDHE_ECDSA_WITH_AES_128_SHA256, TLS1_CK_ECDHE_ECDSA_WITH_AES_256_CBC_SHA, TLS1_CK_ECDHE_ECDSA_WITH_AES_256_CCM, TLS1_CK_ECDHE_ECDSA_WITH_AES_256_CCM_8, TLS1_CK_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384, TLS1_CK_ECDHE_ECDSA_WITH_AES_256_SHA384, TLS1_CK_ECDHE_ECDSA_WITH_ARIA_128_GCM_SHA256, TLS1_CK_ECDHE_ECDSA_WITH_ARIA_256_GCM_SHA384, TLS1_CK_ECDHE_ECDSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_ECDHE_ECDSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_ECDHE_ECDSA_WITH_CHACHA20_POLY1305, TLS1_CK_ECDHE_ECDSA_WITH_DES_192_CBC3_SHA, TLS1_CK_ECDHE_ECDSA_WITH_NULL_SHA, TLS1_CK_ECDHE_ECDSA_WITH_RC4_128_SHA, TLS1_CK_ECDHE_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_CK_ECDHE_PSK_WITH_AES_128_CBC_SHA, TLS1_CK_ECDHE_PSK_WITH_AES_128_CBC_SHA256, TLS1_CK_ECDHE_PSK_WITH_AES_256_CBC_SHA, TLS1_CK_ECDHE_PSK_WITH_AES_256_CBC_SHA384, TLS1_CK_ECDHE_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_ECDHE_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_ECDHE_PSK_WITH_CHACHA20_POLY1305, TLS1_CK_ECDHE_PSK_WITH_NULL_SHA, TLS1_CK_ECDHE_PSK_WITH_NULL_SHA256, TLS1_CK_ECDHE_PSK_WITH_NULL_SHA384, TLS1_CK_ECDHE_PSK_WITH_RC4_128_SHA, TLS1_CK_ECDHE_RSA_WITH_AES_128_CBC_SHA, TLS1_CK_ECDHE_RSA_WITH_AES_128_GCM_SHA256, TLS1_CK_ECDHE_RSA_WITH_AES_128_SHA256, TLS1_CK_ECDHE_RSA_WITH_AES_256_CBC_SHA, TLS1_CK_ECDHE_RSA_WITH_AES_256_GCM_SHA384, TLS1_CK_ECDHE_RSA_WITH_AES_256_SHA384, TLS1_CK_ECDHE_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_CK_ECDHE_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_CK_ECDHE_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_ECDHE_RSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_ECDHE_RSA_WITH_CHACHA20_POLY1305, TLS1_CK_ECDHE_RSA_WITH_DES_192_CBC3_SHA, TLS1_CK_ECDHE_RSA_WITH_NULL_SHA, TLS1_CK_ECDHE_RSA_WITH_RC4_128_SHA, TLS1_CK_ECDH_ECDSA_WITH_AES_128_CBC_SHA, TLS1_CK_ECDH_ECDSA_WITH_AES_128_GCM_SHA256, TLS1_CK_ECDH_ECDSA_WITH_AES_128_SHA256, TLS1_CK_ECDH_ECDSA_WITH_AES_256_CBC_SHA, TLS1_CK_ECDH_ECDSA_WITH_AES_256_GCM_SHA384, TLS1_CK_ECDH_ECDSA_WITH_AES_256_SHA384, TLS1_CK_ECDH_ECDSA_WITH_ARIA_128_GCM_SHA256, TLS1_CK_ECDH_ECDSA_WITH_ARIA_256_GCM_SHA384, TLS1_CK_ECDH_ECDSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_ECDH_ECDSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_ECDH_ECDSA_WITH_DES_192_CBC3_SHA, TLS1_CK_ECDH_ECDSA_WITH_NULL_SHA, TLS1_CK_ECDH_ECDSA_WITH_RC4_128_SHA, TLS1_CK_ECDH_RSA_WITH_AES_128_CBC_SHA, TLS1_CK_ECDH_RSA_WITH_AES_128_GCM_SHA256, TLS1_CK_ECDH_RSA_WITH_AES_128_SHA256, TLS1_CK_ECDH_RSA_WITH_AES_256_CBC_SHA, TLS1_CK_ECDH_RSA_WITH_AES_256_GCM_SHA384, TLS1_CK_ECDH_RSA_WITH_AES_256_SHA384, TLS1_CK_ECDH_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_CK_ECDH_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_CK_ECDH_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_ECDH_RSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_ECDH_RSA_WITH_DES_192_CBC3_SHA, TLS1_CK_ECDH_RSA_WITH_NULL_SHA, TLS1_CK_ECDH_RSA_WITH_RC4_128_SHA, TLS1_CK_ECDH_anon_WITH_AES_128_CBC_SHA, TLS1_CK_ECDH_anon_WITH_AES_256_CBC_SHA, TLS1_CK_ECDH_anon_WITH_DES_192_CBC3_SHA, TLS1_CK_ECDH_anon_WITH_NULL_SHA, TLS1_CK_ECDH_anon_WITH_RC4_128_SHA, TLS1_CK_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_CK_PSK_WITH_AES_128_CBC_SHA, TLS1_CK_PSK_WITH_AES_128_CBC_SHA256, TLS1_CK_PSK_WITH_AES_128_CCM, TLS1_CK_PSK_WITH_AES_128_CCM_8, TLS1_CK_PSK_WITH_AES_128_GCM_SHA256, TLS1_CK_PSK_WITH_AES_256_CBC_SHA, TLS1_CK_PSK_WITH_AES_256_CBC_SHA384, TLS1_CK_PSK_WITH_AES_256_CCM, TLS1_CK_PSK_WITH_AES_256_CCM_8, TLS1_CK_PSK_WITH_AES_256_GCM_SHA384, TLS1_CK_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_CK_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_CK_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_PSK_WITH_CHACHA20_POLY1305, TLS1_CK_PSK_WITH_NULL_SHA, TLS1_CK_PSK_WITH_NULL_SHA256, TLS1_CK_PSK_WITH_NULL_SHA384, TLS1_CK_PSK_WITH_RC4_128_SHA, TLS1_CK_RSA_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_CK_RSA_PSK_WITH_AES_128_CBC_SHA, TLS1_CK_RSA_PSK_WITH_AES_128_CBC_SHA256, TLS1_CK_RSA_PSK_WITH_AES_128_GCM_SHA256, TLS1_CK_RSA_PSK_WITH_AES_256_CBC_SHA, TLS1_CK_RSA_PSK_WITH_AES_256_CBC_SHA384, TLS1_CK_RSA_PSK_WITH_AES_256_GCM_SHA384, TLS1_CK_RSA_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_CK_RSA_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_CK_RSA_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_RSA_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_CK_RSA_PSK_WITH_CHACHA20_POLY1305, TLS1_CK_RSA_PSK_WITH_NULL_SHA, TLS1_CK_RSA_PSK_WITH_NULL_SHA256, TLS1_CK_RSA_PSK_WITH_NULL_SHA384, TLS1_CK_RSA_PSK_WITH_RC4_128_SHA, TLS1_CK_RSA_WITH_AES_128_CCM, TLS1_CK_RSA_WITH_AES_128_CCM_8, TLS1_CK_RSA_WITH_AES_128_GCM_SHA256, TLS1_CK_RSA_WITH_AES_128_SHA, TLS1_CK_RSA_WITH_AES_128_SHA256, TLS1_CK_RSA_WITH_AES_256_CCM, TLS1_CK_RSA_WITH_AES_256_CCM_8, TLS1_CK_RSA_WITH_AES_256_GCM_SHA384, TLS1_CK_RSA_WITH_AES_256_SHA, TLS1_CK_RSA_WITH_AES_256_SHA256, TLS1_CK_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_CK_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_CK_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_CK_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_CK_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_CK_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_CK_RSA_WITH_NULL_SHA256, TLS1_CK_RSA_WITH_SEED_SHA, TLS1_CK_SRP_SHA_DSS_WITH_3DES_EDE_CBC_SHA, TLS1_CK_SRP_SHA_DSS_WITH_AES_128_CBC_SHA, TLS1_CK_SRP_SHA_DSS_WITH_AES_256_CBC_SHA, TLS1_CK_SRP_SHA_RSA_WITH_3DES_EDE_CBC_SHA, TLS1_CK_SRP_SHA_RSA_WITH_AES_128_CBC_SHA, TLS1_CK_SRP_SHA_RSA_WITH_AES_256_CBC_SHA, TLS1_CK_SRP_SHA_WITH_3DES_EDE_CBC_SHA, TLS1_CK_SRP_SHA_WITH_AES_128_CBC_SHA, TLS1_CK_SRP_SHA_WITH_AES_256_CBC_SHA, TLS1_FINISH_MAC_LENGTH, TLS1_FLAGS_ENCRYPT_THEN_MAC, TLS1_FLAGS_ENCRYPT_THEN_MAC_READ, TLS1_FLAGS_ENCRYPT_THEN_MAC_WRITE, TLS1_FLAGS_RECEIVED_EXTMS, TLS1_FLAGS_REQUIRED_EXTMS, TLS1_FLAGS_SKIP_CERT_VERIFY, TLS1_FLAGS_STATELESS, TLS1_FLAGS_TLS_PADDING_BUG, TLS1_HB_REQUEST, TLS1_HB_RESPONSE, TLS1_RFC_ADH_WITH_AES_128_GCM_SHA256, TLS1_RFC_ADH_WITH_AES_128_SHA, TLS1_RFC_ADH_WITH_AES_128_SHA256, TLS1_RFC_ADH_WITH_AES_256_GCM_SHA384, TLS1_RFC_ADH_WITH_AES_256_SHA, TLS1_RFC_ADH_WITH_AES_256_SHA256, TLS1_RFC_ADH_WITH_CAMELLIA_128_CBC_SHA, TLS1_RFC_ADH_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_ADH_WITH_CAMELLIA_256_CBC_SHA, TLS1_RFC_ADH_WITH_CAMELLIA_256_CBC_SHA256, TLS1_RFC_ADH_WITH_SEED_SHA, TLS1_RFC_DHE_DSS_WITH_AES_128_GCM_SHA256, TLS1_RFC_DHE_DSS_WITH_AES_128_SHA, TLS1_RFC_DHE_DSS_WITH_AES_128_SHA256, TLS1_RFC_DHE_DSS_WITH_AES_256_GCM_SHA384, TLS1_RFC_DHE_DSS_WITH_AES_256_SHA, TLS1_RFC_DHE_DSS_WITH_AES_256_SHA256, TLS1_RFC_DHE_DSS_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_DHE_DSS_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA, TLS1_RFC_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA, TLS1_RFC_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA256, TLS1_RFC_DHE_DSS_WITH_SEED_SHA, TLS1_RFC_DHE_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_RFC_DHE_PSK_WITH_AES_128_CBC_SHA, TLS1_RFC_DHE_PSK_WITH_AES_128_CBC_SHA256, TLS1_RFC_DHE_PSK_WITH_AES_128_CCM, TLS1_RFC_DHE_PSK_WITH_AES_128_CCM_8, TLS1_RFC_DHE_PSK_WITH_AES_128_GCM_SHA256, TLS1_RFC_DHE_PSK_WITH_AES_256_CBC_SHA, TLS1_RFC_DHE_PSK_WITH_AES_256_CBC_SHA384, TLS1_RFC_DHE_PSK_WITH_AES_256_CCM, TLS1_RFC_DHE_PSK_WITH_AES_256_CCM_8, TLS1_RFC_DHE_PSK_WITH_AES_256_GCM_SHA384, TLS1_RFC_DHE_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_DHE_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_DHE_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_DHE_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_RFC_DHE_PSK_WITH_CHACHA20_POLY1305, TLS1_RFC_DHE_PSK_WITH_NULL_SHA, TLS1_RFC_DHE_PSK_WITH_NULL_SHA256, TLS1_RFC_DHE_PSK_WITH_NULL_SHA384, TLS1_RFC_DHE_PSK_WITH_RC4_128_SHA, TLS1_RFC_DHE_RSA_WITH_AES_128_CCM, TLS1_RFC_DHE_RSA_WITH_AES_128_CCM_8, TLS1_RFC_DHE_RSA_WITH_AES_128_GCM_SHA256, TLS1_RFC_DHE_RSA_WITH_AES_128_SHA, TLS1_RFC_DHE_RSA_WITH_AES_128_SHA256, TLS1_RFC_DHE_RSA_WITH_AES_256_CCM, TLS1_RFC_DHE_RSA_WITH_AES_256_CCM_8, TLS1_RFC_DHE_RSA_WITH_AES_256_GCM_SHA384, TLS1_RFC_DHE_RSA_WITH_AES_256_SHA, TLS1_RFC_DHE_RSA_WITH_AES_256_SHA256, TLS1_RFC_DHE_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_DHE_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_RFC_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_RFC_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_RFC_DHE_RSA_WITH_CHACHA20_POLY1305, TLS1_RFC_DHE_RSA_WITH_SEED_SHA, TLS1_RFC_DH_DSS_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_DH_DSS_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_DH_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_DH_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_DH_anon_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_DH_anon_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_CBC_SHA, TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_CCM, TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_CCM_8, TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256, TLS1_RFC_ECDHE_ECDSA_WITH_AES_128_SHA256, TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_CBC_SHA, TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_CCM, TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_CCM_8, TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384, TLS1_RFC_ECDHE_ECDSA_WITH_AES_256_SHA384, TLS1_RFC_ECDHE_ECDSA_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_ECDHE_ECDSA_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_ECDHE_ECDSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_ECDHE_ECDSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_RFC_ECDHE_ECDSA_WITH_CHACHA20_POLY1305, TLS1_RFC_ECDHE_ECDSA_WITH_DES_192_CBC3_SHA, TLS1_RFC_ECDHE_ECDSA_WITH_NULL_SHA, TLS1_RFC_ECDHE_ECDSA_WITH_RC4_128_SHA, TLS1_RFC_ECDHE_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_RFC_ECDHE_PSK_WITH_AES_128_CBC_SHA, TLS1_RFC_ECDHE_PSK_WITH_AES_128_CBC_SHA256, TLS1_RFC_ECDHE_PSK_WITH_AES_256_CBC_SHA, TLS1_RFC_ECDHE_PSK_WITH_AES_256_CBC_SHA384, TLS1_RFC_ECDHE_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_ECDHE_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_RFC_ECDHE_PSK_WITH_CHACHA20_POLY1305, TLS1_RFC_ECDHE_PSK_WITH_NULL_SHA, TLS1_RFC_ECDHE_PSK_WITH_NULL_SHA256, TLS1_RFC_ECDHE_PSK_WITH_NULL_SHA384, TLS1_RFC_ECDHE_PSK_WITH_RC4_128_SHA, TLS1_RFC_ECDHE_RSA_WITH_AES_128_CBC_SHA, TLS1_RFC_ECDHE_RSA_WITH_AES_128_GCM_SHA256, TLS1_RFC_ECDHE_RSA_WITH_AES_128_SHA256, TLS1_RFC_ECDHE_RSA_WITH_AES_256_CBC_SHA, TLS1_RFC_ECDHE_RSA_WITH_AES_256_GCM_SHA384, TLS1_RFC_ECDHE_RSA_WITH_AES_256_SHA384, TLS1_RFC_ECDHE_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_ECDHE_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_ECDHE_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_ECDHE_RSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_RFC_ECDHE_RSA_WITH_CHACHA20_POLY1305, TLS1_RFC_ECDHE_RSA_WITH_DES_192_CBC3_SHA, TLS1_RFC_ECDHE_RSA_WITH_NULL_SHA, TLS1_RFC_ECDHE_RSA_WITH_RC4_128_SHA, TLS1_RFC_ECDH_ECDSA_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_ECDH_ECDSA_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_ECDH_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_ECDH_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_ECDH_anon_WITH_AES_128_CBC_SHA, TLS1_RFC_ECDH_anon_WITH_AES_256_CBC_SHA, TLS1_RFC_ECDH_anon_WITH_DES_192_CBC3_SHA, TLS1_RFC_ECDH_anon_WITH_NULL_SHA, TLS1_RFC_ECDH_anon_WITH_RC4_128_SHA, TLS1_RFC_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_RFC_PSK_WITH_AES_128_CBC_SHA, TLS1_RFC_PSK_WITH_AES_128_CBC_SHA256, TLS1_RFC_PSK_WITH_AES_128_CCM, TLS1_RFC_PSK_WITH_AES_128_CCM_8, TLS1_RFC_PSK_WITH_AES_128_GCM_SHA256, TLS1_RFC_PSK_WITH_AES_256_CBC_SHA, TLS1_RFC_PSK_WITH_AES_256_CBC_SHA384, TLS1_RFC_PSK_WITH_AES_256_CCM, TLS1_RFC_PSK_WITH_AES_256_CCM_8, TLS1_RFC_PSK_WITH_AES_256_GCM_SHA384, TLS1_RFC_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_RFC_PSK_WITH_CHACHA20_POLY1305, TLS1_RFC_PSK_WITH_NULL_SHA, TLS1_RFC_PSK_WITH_NULL_SHA256, TLS1_RFC_PSK_WITH_NULL_SHA384, TLS1_RFC_PSK_WITH_RC4_128_SHA, TLS1_RFC_RSA_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_RFC_RSA_PSK_WITH_AES_128_CBC_SHA, TLS1_RFC_RSA_PSK_WITH_AES_128_CBC_SHA256, TLS1_RFC_RSA_PSK_WITH_AES_128_GCM_SHA256, TLS1_RFC_RSA_PSK_WITH_AES_256_CBC_SHA, TLS1_RFC_RSA_PSK_WITH_AES_256_CBC_SHA384, TLS1_RFC_RSA_PSK_WITH_AES_256_GCM_SHA384, TLS1_RFC_RSA_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_RSA_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_RSA_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_RSA_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_RFC_RSA_PSK_WITH_CHACHA20_POLY1305, TLS1_RFC_RSA_PSK_WITH_NULL_SHA, TLS1_RFC_RSA_PSK_WITH_NULL_SHA256, TLS1_RFC_RSA_PSK_WITH_NULL_SHA384, TLS1_RFC_RSA_PSK_WITH_RC4_128_SHA, TLS1_RFC_RSA_WITH_AES_128_CCM, TLS1_RFC_RSA_WITH_AES_128_CCM_8, TLS1_RFC_RSA_WITH_AES_128_GCM_SHA256, TLS1_RFC_RSA_WITH_AES_128_SHA, TLS1_RFC_RSA_WITH_AES_128_SHA256, TLS1_RFC_RSA_WITH_AES_256_CCM, TLS1_RFC_RSA_WITH_AES_256_CCM_8, TLS1_RFC_RSA_WITH_AES_256_GCM_SHA384, TLS1_RFC_RSA_WITH_AES_256_SHA, TLS1_RFC_RSA_WITH_AES_256_SHA256, TLS1_RFC_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_RFC_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_RFC_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_RFC_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_RFC_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_RFC_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_RFC_RSA_WITH_NULL_SHA256, TLS1_RFC_RSA_WITH_SEED_SHA, TLS1_RFC_SRP_SHA_DSS_WITH_3DES_EDE_CBC_SHA, TLS1_RFC_SRP_SHA_DSS_WITH_AES_128_CBC_SHA, TLS1_RFC_SRP_SHA_DSS_WITH_AES_256_CBC_SHA, TLS1_RFC_SRP_SHA_RSA_WITH_3DES_EDE_CBC_SHA, TLS1_RFC_SRP_SHA_RSA_WITH_AES_128_CBC_SHA, TLS1_RFC_SRP_SHA_RSA_WITH_AES_256_CBC_SHA, TLS1_RFC_SRP_SHA_WITH_3DES_EDE_CBC_SHA, TLS1_RFC_SRP_SHA_WITH_AES_128_CBC_SHA, TLS1_RFC_SRP_SHA_WITH_AES_256_CBC_SHA, TLS1_RT_CRYPTO, TLS1_RT_CRYPTO_READ, TLS1_RT_CRYPTO_WRITE, TLS1_TXT_ADH_WITH_AES_128_GCM_SHA256, TLS1_TXT_ADH_WITH_AES_128_SHA, TLS1_TXT_ADH_WITH_AES_128_SHA256, TLS1_TXT_ADH_WITH_AES_256_GCM_SHA384, TLS1_TXT_ADH_WITH_AES_256_SHA, TLS1_TXT_ADH_WITH_AES_256_SHA256, TLS1_TXT_ADH_WITH_CAMELLIA_128_CBC_SHA, TLS1_TXT_ADH_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_ADH_WITH_CAMELLIA_256_CBC_SHA, TLS1_TXT_ADH_WITH_CAMELLIA_256_CBC_SHA256, TLS1_TXT_ADH_WITH_SEED_SHA, TLS1_TXT_DHE_DSS_WITH_AES_128_GCM_SHA256, TLS1_TXT_DHE_DSS_WITH_AES_128_SHA, TLS1_TXT_DHE_DSS_WITH_AES_128_SHA256, TLS1_TXT_DHE_DSS_WITH_AES_256_GCM_SHA384, TLS1_TXT_DHE_DSS_WITH_AES_256_SHA, TLS1_TXT_DHE_DSS_WITH_AES_256_SHA256, TLS1_TXT_DHE_DSS_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_DHE_DSS_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA, TLS1_TXT_DHE_DSS_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA, TLS1_TXT_DHE_DSS_WITH_CAMELLIA_256_CBC_SHA256, TLS1_TXT_DHE_DSS_WITH_RC4_128_SHA, TLS1_TXT_DHE_DSS_WITH_SEED_SHA, TLS1_TXT_DHE_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_TXT_DHE_PSK_WITH_AES_128_CBC_SHA, TLS1_TXT_DHE_PSK_WITH_AES_128_CBC_SHA256, TLS1_TXT_DHE_PSK_WITH_AES_128_CCM, TLS1_TXT_DHE_PSK_WITH_AES_128_CCM_8, TLS1_TXT_DHE_PSK_WITH_AES_128_GCM_SHA256, TLS1_TXT_DHE_PSK_WITH_AES_256_CBC_SHA, TLS1_TXT_DHE_PSK_WITH_AES_256_CBC_SHA384, TLS1_TXT_DHE_PSK_WITH_AES_256_CCM, TLS1_TXT_DHE_PSK_WITH_AES_256_CCM_8, TLS1_TXT_DHE_PSK_WITH_AES_256_GCM_SHA384, TLS1_TXT_DHE_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_DHE_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_DHE_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_DHE_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_DHE_PSK_WITH_CHACHA20_POLY1305, TLS1_TXT_DHE_PSK_WITH_NULL_SHA, TLS1_TXT_DHE_PSK_WITH_NULL_SHA256, TLS1_TXT_DHE_PSK_WITH_NULL_SHA384, TLS1_TXT_DHE_PSK_WITH_RC4_128_SHA, TLS1_TXT_DHE_RSA_WITH_AES_128_CCM, TLS1_TXT_DHE_RSA_WITH_AES_128_CCM_8, TLS1_TXT_DHE_RSA_WITH_AES_128_GCM_SHA256, TLS1_TXT_DHE_RSA_WITH_AES_128_SHA, TLS1_TXT_DHE_RSA_WITH_AES_128_SHA256, TLS1_TXT_DHE_RSA_WITH_AES_256_CCM, TLS1_TXT_DHE_RSA_WITH_AES_256_CCM_8, TLS1_TXT_DHE_RSA_WITH_AES_256_GCM_SHA384, TLS1_TXT_DHE_RSA_WITH_AES_256_SHA, TLS1_TXT_DHE_RSA_WITH_AES_256_SHA256, TLS1_TXT_DHE_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_DHE_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_TXT_DHE_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_TXT_DHE_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_TXT_DHE_RSA_WITH_CHACHA20_POLY1305, TLS1_TXT_DHE_RSA_WITH_SEED_SHA, TLS1_TXT_DH_DSS_WITH_AES_128_GCM_SHA256, TLS1_TXT_DH_DSS_WITH_AES_128_SHA, TLS1_TXT_DH_DSS_WITH_AES_128_SHA256, TLS1_TXT_DH_DSS_WITH_AES_256_GCM_SHA384, TLS1_TXT_DH_DSS_WITH_AES_256_SHA, TLS1_TXT_DH_DSS_WITH_AES_256_SHA256, TLS1_TXT_DH_DSS_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_DH_DSS_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_DH_DSS_WITH_CAMELLIA_128_CBC_SHA, TLS1_TXT_DH_DSS_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_DH_DSS_WITH_CAMELLIA_256_CBC_SHA, TLS1_TXT_DH_DSS_WITH_CAMELLIA_256_CBC_SHA256, TLS1_TXT_DH_DSS_WITH_SEED_SHA, TLS1_TXT_DH_RSA_WITH_AES_128_GCM_SHA256, TLS1_TXT_DH_RSA_WITH_AES_128_SHA, TLS1_TXT_DH_RSA_WITH_AES_128_SHA256, TLS1_TXT_DH_RSA_WITH_AES_256_GCM_SHA384, TLS1_TXT_DH_RSA_WITH_AES_256_SHA, TLS1_TXT_DH_RSA_WITH_AES_256_SHA256, TLS1_TXT_DH_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_DH_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_DH_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_TXT_DH_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_DH_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_TXT_DH_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_TXT_DH_RSA_WITH_SEED_SHA, TLS1_TXT_DH_anon_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_DH_anon_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_CBC_SHA, TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_CCM, TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_CCM_8, TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256, TLS1_TXT_ECDHE_ECDSA_WITH_AES_128_SHA256, TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_CBC_SHA, TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_CCM, TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_CCM_8, TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384, TLS1_TXT_ECDHE_ECDSA_WITH_AES_256_SHA384, TLS1_TXT_ECDHE_ECDSA_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_ECDHE_ECDSA_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_ECDHE_ECDSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_ECDHE_ECDSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_ECDHE_ECDSA_WITH_CHACHA20_POLY1305, TLS1_TXT_ECDHE_ECDSA_WITH_DES_192_CBC3_SHA, TLS1_TXT_ECDHE_ECDSA_WITH_NULL_SHA, TLS1_TXT_ECDHE_ECDSA_WITH_RC4_128_SHA, TLS1_TXT_ECDHE_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_TXT_ECDHE_PSK_WITH_AES_128_CBC_SHA, TLS1_TXT_ECDHE_PSK_WITH_AES_128_CBC_SHA256, TLS1_TXT_ECDHE_PSK_WITH_AES_256_CBC_SHA, TLS1_TXT_ECDHE_PSK_WITH_AES_256_CBC_SHA384, TLS1_TXT_ECDHE_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_ECDHE_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_ECDHE_PSK_WITH_CHACHA20_POLY1305, TLS1_TXT_ECDHE_PSK_WITH_NULL_SHA, TLS1_TXT_ECDHE_PSK_WITH_NULL_SHA256, TLS1_TXT_ECDHE_PSK_WITH_NULL_SHA384, TLS1_TXT_ECDHE_PSK_WITH_RC4_128_SHA, TLS1_TXT_ECDHE_RSA_WITH_AES_128_CBC_SHA, TLS1_TXT_ECDHE_RSA_WITH_AES_128_GCM_SHA256, TLS1_TXT_ECDHE_RSA_WITH_AES_128_SHA256, TLS1_TXT_ECDHE_RSA_WITH_AES_256_CBC_SHA, TLS1_TXT_ECDHE_RSA_WITH_AES_256_GCM_SHA384, TLS1_TXT_ECDHE_RSA_WITH_AES_256_SHA384, TLS1_TXT_ECDHE_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_ECDHE_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_ECDHE_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_ECDHE_RSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_ECDHE_RSA_WITH_CHACHA20_POLY1305, TLS1_TXT_ECDHE_RSA_WITH_DES_192_CBC3_SHA, TLS1_TXT_ECDHE_RSA_WITH_NULL_SHA, TLS1_TXT_ECDHE_RSA_WITH_RC4_128_SHA, TLS1_TXT_ECDH_ECDSA_WITH_AES_128_CBC_SHA, TLS1_TXT_ECDH_ECDSA_WITH_AES_128_GCM_SHA256, TLS1_TXT_ECDH_ECDSA_WITH_AES_128_SHA256, TLS1_TXT_ECDH_ECDSA_WITH_AES_256_CBC_SHA, TLS1_TXT_ECDH_ECDSA_WITH_AES_256_GCM_SHA384, TLS1_TXT_ECDH_ECDSA_WITH_AES_256_SHA384, TLS1_TXT_ECDH_ECDSA_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_ECDH_ECDSA_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_ECDH_ECDSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_ECDH_ECDSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_ECDH_ECDSA_WITH_DES_192_CBC3_SHA, TLS1_TXT_ECDH_ECDSA_WITH_NULL_SHA, TLS1_TXT_ECDH_ECDSA_WITH_RC4_128_SHA, TLS1_TXT_ECDH_RSA_WITH_AES_128_CBC_SHA, TLS1_TXT_ECDH_RSA_WITH_AES_128_GCM_SHA256, TLS1_TXT_ECDH_RSA_WITH_AES_128_SHA256, TLS1_TXT_ECDH_RSA_WITH_AES_256_CBC_SHA, TLS1_TXT_ECDH_RSA_WITH_AES_256_GCM_SHA384, TLS1_TXT_ECDH_RSA_WITH_AES_256_SHA384, TLS1_TXT_ECDH_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_ECDH_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_ECDH_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_ECDH_RSA_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_ECDH_RSA_WITH_DES_192_CBC3_SHA, TLS1_TXT_ECDH_RSA_WITH_NULL_SHA, TLS1_TXT_ECDH_RSA_WITH_RC4_128_SHA, TLS1_TXT_ECDH_anon_WITH_AES_128_CBC_SHA, TLS1_TXT_ECDH_anon_WITH_AES_256_CBC_SHA, TLS1_TXT_ECDH_anon_WITH_DES_192_CBC3_SHA, TLS1_TXT_ECDH_anon_WITH_NULL_SHA, TLS1_TXT_ECDH_anon_WITH_RC4_128_SHA, TLS1_TXT_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_TXT_PSK_WITH_AES_128_CBC_SHA, TLS1_TXT_PSK_WITH_AES_128_CBC_SHA256, TLS1_TXT_PSK_WITH_AES_128_CCM, TLS1_TXT_PSK_WITH_AES_128_CCM_8, TLS1_TXT_PSK_WITH_AES_128_GCM_SHA256, TLS1_TXT_PSK_WITH_AES_256_CBC_SHA, TLS1_TXT_PSK_WITH_AES_256_CBC_SHA384, TLS1_TXT_PSK_WITH_AES_256_CCM, TLS1_TXT_PSK_WITH_AES_256_CCM_8, TLS1_TXT_PSK_WITH_AES_256_GCM_SHA384, TLS1_TXT_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_PSK_WITH_CHACHA20_POLY1305, TLS1_TXT_PSK_WITH_NULL_SHA, TLS1_TXT_PSK_WITH_NULL_SHA256, TLS1_TXT_PSK_WITH_NULL_SHA384, TLS1_TXT_PSK_WITH_RC4_128_SHA, TLS1_TXT_RSA_PSK_WITH_3DES_EDE_CBC_SHA, TLS1_TXT_RSA_PSK_WITH_AES_128_CBC_SHA, TLS1_TXT_RSA_PSK_WITH_AES_128_CBC_SHA256, TLS1_TXT_RSA_PSK_WITH_AES_128_GCM_SHA256, TLS1_TXT_RSA_PSK_WITH_AES_256_CBC_SHA, TLS1_TXT_RSA_PSK_WITH_AES_256_CBC_SHA384, TLS1_TXT_RSA_PSK_WITH_AES_256_GCM_SHA384, TLS1_TXT_RSA_PSK_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_RSA_PSK_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_RSA_PSK_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_RSA_PSK_WITH_CAMELLIA_256_CBC_SHA384, TLS1_TXT_RSA_PSK_WITH_CHACHA20_POLY1305, TLS1_TXT_RSA_PSK_WITH_NULL_SHA, TLS1_TXT_RSA_PSK_WITH_NULL_SHA256, TLS1_TXT_RSA_PSK_WITH_NULL_SHA384, TLS1_TXT_RSA_PSK_WITH_RC4_128_SHA, TLS1_TXT_RSA_WITH_AES_128_CCM, TLS1_TXT_RSA_WITH_AES_128_CCM_8, TLS1_TXT_RSA_WITH_AES_128_GCM_SHA256, TLS1_TXT_RSA_WITH_AES_128_SHA, TLS1_TXT_RSA_WITH_AES_128_SHA256, TLS1_TXT_RSA_WITH_AES_256_CCM, TLS1_TXT_RSA_WITH_AES_256_CCM_8, TLS1_TXT_RSA_WITH_AES_256_GCM_SHA384, TLS1_TXT_RSA_WITH_AES_256_SHA, TLS1_TXT_RSA_WITH_AES_256_SHA256, TLS1_TXT_RSA_WITH_ARIA_128_GCM_SHA256, TLS1_TXT_RSA_WITH_ARIA_256_GCM_SHA384, TLS1_TXT_RSA_WITH_CAMELLIA_128_CBC_SHA, TLS1_TXT_RSA_WITH_CAMELLIA_128_CBC_SHA256, TLS1_TXT_RSA_WITH_CAMELLIA_256_CBC_SHA, TLS1_TXT_RSA_WITH_CAMELLIA_256_CBC_SHA256, TLS1_TXT_RSA_WITH_NULL_SHA256, TLS1_TXT_RSA_WITH_SEED_SHA, TLS1_TXT_SRP_SHA_DSS_WITH_3DES_EDE_CBC_SHA, TLS1_TXT_SRP_SHA_DSS_WITH_AES_128_CBC_SHA, TLS1_TXT_SRP_SHA_DSS_WITH_AES_256_CBC_SHA, TLS1_TXT_SRP_SHA_RSA_WITH_3DES_EDE_CBC_SHA, TLS1_TXT_SRP_SHA_RSA_WITH_AES_128_CBC_SHA, TLS1_TXT_SRP_SHA_RSA_WITH_AES_256_CBC_SHA, TLS1_TXT_SRP_SHA_WITH_3DES_EDE_CBC_SHA, TLS1_TXT_SRP_SHA_WITH_AES_128_CBC_SHA, TLS1_TXT_SRP_SHA_WITH_AES_256_CBC_SHA, TLS1_VERSION, TLS1_VERSION_MAJOR, TLS1_VERSION_MINOR, TLSEXT_ECPOINTFORMAT_ansiX962_compressed_char2, TLSEXT_ECPOINTFORMAT_ansiX962_compressed_prime, TLSEXT_ECPOINTFORMAT_first, TLSEXT_ECPOINTFORMAT_last, TLSEXT_ECPOINTFORMAT_uncompressed, TLSEXT_MAXLEN_host_name, TLSEXT_NAMETYPE_host_name, TLSEXT_STATUSTYPE_ocsp, TLSEXT_TYPE_application_layer_protocol_negotiation, TLSEXT_TYPE_cert_type, TLSEXT_TYPE_certificate_authorities, TLSEXT_TYPE_client_authz, TLSEXT_TYPE_client_certificate_url, TLSEXT_TYPE_cookie, TLSEXT_TYPE_early_data, TLSEXT_TYPE_ec_point_formats, TLSEXT_TYPE_elliptic_curves, TLSEXT_TYPE_encrypt_then_mac, TLSEXT_TYPE_extended_master_secret, TLSEXT_TYPE_key_share, TLSEXT_TYPE_max_fragment_length, TLSEXT_TYPE_padding, TLSEXT_TYPE_post_handshake_auth, TLSEXT_TYPE_psk, TLSEXT_TYPE_psk_kex_modes, TLSEXT_TYPE_renegotiate, TLSEXT_TYPE_server_authz, TLSEXT_TYPE_server_name, TLSEXT_TYPE_session_ticket, TLSEXT_TYPE_signature_algorithms, TLSEXT_TYPE_signature_algorithms_cert, TLSEXT_TYPE_signed_certificate_timestamp, TLSEXT_TYPE_srp, TLSEXT_TYPE_status_request, TLSEXT_TYPE_supported_groups, TLSEXT_TYPE_supported_versions, TLSEXT_TYPE_truncated_hmac, TLSEXT_TYPE_trusted_ca_keys, TLSEXT_TYPE_use_srtp, TLSEXT_TYPE_user_mapping, TLSEXT_curve_P_256, TLSEXT_curve_P_384, TLSEXT_hash_gostr3411, TLSEXT_hash_gostr34112012_256, TLSEXT_hash_gostr34112012_512, TLSEXT_hash_md5, TLSEXT_hash_none, TLSEXT_hash_num, TLSEXT_hash_sha1, TLSEXT_hash_sha224, TLSEXT_hash_sha256, TLSEXT_hash_sha384, TLSEXT_hash_sha512, TLSEXT_max_fragment_length_1024, TLSEXT_max_fragment_length_2048, TLSEXT_max_fragment_length_4096, TLSEXT_max_fragment_length_512, TLSEXT_max_fragment_length_DISABLED, TLSEXT_nid_unknown, TLSEXT_signature_anonymous, TLSEXT_signature_dsa, TLSEXT_signature_ecdsa, TLSEXT_signature_gostr34102001, TLSEXT_signature_gostr34102012_256, TLSEXT_signature_gostr34102012_512, TLSEXT_signature_num, TLSEXT_signature_rsa, TLS_ANY_VERSION, TLS_CT_DSS_FIXED_DH, TLS_CT_DSS_SIGN, TLS_CT_ECDSA_FIXED_ECDH, TLS_CT_ECDSA_SIGN, TLS_CT_GOST01_SIGN, TLS_CT_GOST12_IANA_512_SIGN, TLS_CT_GOST12_IANA_SIGN, TLS_CT_GOST12_LEGACY_512_SIGN, TLS_CT_GOST12_LEGACY_SIGN, TLS_CT_NUMBER, TLS_CT_RSA_FIXED_DH, TLS_CT_RSA_FIXED_ECDH, TLS_CT_RSA_SIGN, TLS_MD_CLIENT_FINISH_CONST, TLS_MD_CLIENT_FINISH_CONST_SIZE, TLS_MD_CLIENT_WRITE_KEY_CONST, TLS_MD_CLIENT_WRITE_KEY_CONST_SIZE, TLS_MD_EXTENDED_MASTER_SECRET_CONST, TLS_MD_EXTENDED_MASTER_SECRET_CONST_SIZE, TLS_MD_IV_BLOCK_CONST, TLS_MD_IV_BLOCK_CONST_SIZE, TLS_MD_KEY_EXPANSION_CONST, TLS_MD_KEY_EXPANSION_CONST_SIZE, TLS_MD_MASTER_SECRET_CONST, TLS_MD_MASTER_SECRET_CONST_SIZE, TLS_MD_MAX_CONST_SIZE, TLS_MD_SERVER_FINISH_CONST, TLS_MD_SERVER_FINISH_CONST_SIZE, TLS_MD_SERVER_WRITE_KEY_CONST, TLS_MD_SERVER_WRITE_KEY_CONST_SIZE, TS_ESS_CERT_ID_CHAIN, TS_INFO_ADD_INFO_NOT_AVAILABLE, TS_INFO_BAD_ALG, TS_INFO_BAD_DATA_FORMAT, TS_INFO_BAD_REQUEST, TS_INFO_SYSTEM_FAILURE, TS_INFO_TIME_NOT_AVAILABLE, TS_INFO_UNACCEPTED_EXTENSION, TS_INFO_UNACCEPTED_POLICY, TS_MAX_CLOCK_PRECISION_DIGITS, TS_ORDERING, TS_STATUS_GRANTED, TS_STATUS_GRANTED_WITH_MODS, TS_STATUS_REJECTION, TS_STATUS_REVOCATION_NOTIFICATION, TS_STATUS_REVOCATION_WARNING, TS_STATUS_WAITING, TS_TSA_NAME, UI_R_COMMON_OK_AND_CANCEL_CHARACTERS, UI_R_INDEX_TOO_LARGE, UI_R_INDEX_TOO_SMALL, UI_R_NO_RESULT_BUFFER, UI_R_PROCESSING_ERROR, UI_R_RESULT_TOO_LARGE, UI_R_RESULT_TOO_SMALL, UI_R_SYSASSIGN_ERROR, UI_R_SYSDASSGN_ERROR, UI_R_SYSQIOW_ERROR, UI_R_UNKNOWN_CONTROL_COMMAND, UI_R_UNKNOWN_TTYGET_ERRNO_VALUE, UI_R_USER_DATA_DUPLICATION_UNSUPPORTED, X509V3_R_BAD_IP_ADDRESS, X509V3_R_BAD_OBJECT, X509V3_R_BN_DEC2BN_ERROR, X509V3_R_BN_TO_ASN1_INTEGER_ERROR, X509V3_R_DIRNAME_ERROR, X509V3_R_DISTPOINT_ALREADY_SET, X509V3_R_DUPLICATE_ZONE_ID, X509V3_R_EMPTY_KEY_USAGE, X509V3_R_ERROR_CONVERTING_ZONE, X509V3_R_ERROR_CREATING_EXTENSION, X509V3_R_ERROR_IN_EXTENSION, X509V3_R_EXPECTED_A_SECTION_NAME, X509V3_R_EXTENSION_EXISTS, X509V3_R_EXTENSION_NAME_ERROR, X509V3_R_EXTENSION_NOT_FOUND, X509V3_R_EXTENSION_SETTING_NOT_SUPPORTED, X509V3_R_EXTENSION_VALUE_ERROR, X509V3_R_ILLEGAL_EMPTY_EXTENSION, X509V3_R_INCORRECT_POLICY_SYNTAX_TAG, X509V3_R_INVALID_ASNUMBER, X509V3_R_INVALID_ASRANGE, X509V3_R_INVALID_BOOLEAN_STRING, X509V3_R_INVALID_CERTIFICATE, X509V3_R_INVALID_EMPTY_NAME, X509V3_R_INVALID_EXTENSION_STRING, X509V3_R_INVALID_INHERITANCE, X509V3_R_INVALID_IPADDRESS, X509V3_R_INVALID_MULTIPLE_RDNS, X509V3_R_INVALID_NAME, X509V3_R_INVALID_NULL_ARGUMENT, X509V3_R_INVALID_NULL_VALUE, X509V3_R_INVALID_NUMBER, X509V3_R_INVALID_NUMBERS, X509V3_R_INVALID_OBJECT_IDENTIFIER, X509V3_R_INVALID_OPTION, X509V3_R_INVALID_POLICY_IDENTIFIER, X509V3_R_INVALID_PROXY_POLICY_SETTING, X509V3_R_INVALID_PURPOSE, X509V3_R_INVALID_SAFI, X509V3_R_INVALID_SECTION, X509V3_R_INVALID_SYNTAX, X509V3_R_ISSUER_DECODE_ERROR, X509V3_R_MISSING_VALUE, X509V3_R_NEED_ORGANIZATION_AND_NUMBERS, X509V3_R_NEGATIVE_PATHLEN, X509V3_R_NO_CONFIG_DATABASE, X509V3_R_NO_ISSUER_CERTIFICATE, X509V3_R_NO_ISSUER_DETAILS, X509V3_R_NO_POLICY_IDENTIFIER, X509V3_R_NO_PROXY_CERT_POLICY_LANGUAGE_DEFINED, X509V3_R_NO_PUBLIC_KEY, X509V3_R_NO_SUBJECT_DETAILS, X509V3_R_OPERATION_NOT_DEFINED, X509V3_R_OTHERNAME_ERROR, X509V3_R_POLICY_LANGUAGE_ALREADY_DEFINED, X509V3_R_POLICY_PATH_LENGTH, X509V3_R_POLICY_PATH_LENGTH_ALREADY_DEFINED, X509V3_R_POLICY_WHEN_PROXY_LANGUAGE_REQUIRES_NO_POLICY, X509V3_R_SECTION_NOT_FOUND, X509V3_R_UNABLE_TO_GET_ISSUER_DETAILS, X509V3_R_UNABLE_TO_GET_ISSUER_KEYID, X509V3_R_UNKNOWN_BIT_STRING_ARGUMENT, X509V3_R_UNKNOWN_EXTENSION, X509V3_R_UNKNOWN_EXTENSION_NAME, X509V3_R_UNKNOWN_OPTION, X509V3_R_UNSUPPORTED_OPTION, X509V3_R_UNSUPPORTED_TYPE, X509V3_R_USER_TOO_LONG, X509_R_AKID_MISMATCH, X509_R_BAD_SELECTOR, X509_R_BAD_X509_FILETYPE, X509_R_BASE64_DECODE_ERROR, X509_R_CANT_CHECK_DH_KEY, X509_R_CERTIFICATE_VERIFICATION_FAILED, X509_R_CERT_ALREADY_IN_HASH_TABLE, X509_R_CRL_ALREADY_DELTA, X509_R_CRL_VERIFY_FAILURE, X509_R_ERROR_GETTING_MD_BY_NID, X509_R_ERROR_USING_SIGINF_SET, X509_R_IDP_MISMATCH, X509_R_INVALID_ATTRIBUTES, X509_R_INVALID_DIRECTORY, X509_R_INVALID_DISTPOINT, X509_R_INVALID_FIELD_NAME, X509_R_INVALID_TRUST, X509_R_ISSUER_MISMATCH, X509_R_KEY_TYPE_MISMATCH, X509_R_KEY_VALUES_MISMATCH, X509_R_LOADING_CERT_DIR, X509_R_LOADING_DEFAULTS, X509_R_METHOD_NOT_SUPPORTED, X509_R_NAME_TOO_LONG, X509_R_NEWER_CRL_NOT_NEWER, X509_R_NO_CERTIFICATE_FOUND, X509_R_NO_CERTIFICATE_OR_CRL_FOUND, X509_R_NO_CERT_SET_FOR_US_TO_VERIFY, X509_R_NO_CRL_FOUND, X509_R_NO_CRL_NUMBER, X509_R_PUBLIC_KEY_DECODE_ERROR, X509_R_PUBLIC_KEY_ENCODE_ERROR, X509_R_SHOULD_RETRY, X509_R_UNABLE_TO_FIND_PARAMETERS_IN_CHAIN, X509_R_UNABLE_TO_GET_CERTS_PUBLIC_KEY, X509_R_UNKNOWN_KEY_TYPE, X509_R_UNKNOWN_NID, X509_R_UNKNOWN_PURPOSE_ID, X509_R_UNKNOWN_SIGID_ALGS, X509_R_UNKNOWN_TRUST_ID, X509_R_UNSUPPORTED_ALGORITHM, X509_R_WRONG_LOOKUP_TYPE, X509_R_WRONG_TYPE, ascii2ebcdic, ebcdic2ascii, os_toascii, os_toebcdic };
